export const OrangeData =
[
    {
        "id": 1,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE",
        "trade_name": "ABACAVIR SULFATE",
        "forms": [
            {
                "orange_id": "77950-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            },
            {
                "orange_id": "77844-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE",
        "trade_name": "ZIAGEN",
        "forms": [
            {
                "orange_id": "20978-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            },
            {
                "orange_id": "20977-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE, DOLUTEGRAVIR SODIUM AND LAMIVUDINE",
        "trade_name": "TRIUMEQ",
        "forms": [
            {
                "orange_id": "205551-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE-EQ 50MG BASE-300MG"
                ]
            }
        ]
    },
    {
        "id": 4,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE AND LAMIVUDINE",
        "trade_name": "ABACAVIR SULFATE AND LAMIVUDINE",
        "forms": [
            {
                "orange_id": "90159-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE-300MG"
                ]
            }
        ]
    },
    {
        "id": 5,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE AND LAMIVUDINE",
        "trade_name": "EPZICOM",
        "forms": [
            {
                "orange_id": "21652-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE-300MG"
                ]
            }
        ]
    },
    {
        "id": 6,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE, LAMIVUDINE AND ZIDOVUDINE",
        "trade_name": "ABACAVIR SULFATE, LAMIVUDINE AND ZIDOVUDINE",
        "forms": [
            {
                "orange_id": "202912-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE-150MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 7,
        "type": "RX",
        "ingredient": "ABACAVIR SULFATE, LAMIVUDINE AND ZIDOVUDINE",
        "trade_name": "TRIZIVIR",
        "forms": [
            {
                "orange_id": "21205-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE-150MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 8,
        "type": "RX",
        "ingredient": "ABALOPARATIDE",
        "trade_name": "TYMLOS",
        "forms": [
            {
                "orange_id": "208743-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "3.12MG/1.56ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 9,
        "type": "RX",
        "ingredient": "ABEMACICLIB",
        "trade_name": "VERZENIO",
        "forms": [
            {
                "orange_id": "208716-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 10,
        "type": "RX",
        "ingredient": "ABIRATERONE ACETATE",
        "trade_name": "ABIRATERONE ACETATE",
        "forms": [
            {
                "orange_id": "208327-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 11,
        "type": "RX",
        "ingredient": "ABIRATERONE ACETATE",
        "trade_name": "YONSA",
        "forms": [
            {
                "orange_id": "210308-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 12,
        "type": "RX",
        "ingredient": "ABIRATERONE ACETATE",
        "trade_name": "ZYTIGA",
        "forms": [
            {
                "orange_id": "202379-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 13,
        "type": "RX",
        "ingredient": "ABROCITINIB",
        "trade_name": "CIBINQO",
        "forms": [
            {
                "orange_id": "213871-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 14,
        "type": "RX",
        "ingredient": "ACALABRUTINIB",
        "trade_name": "CALQUENCE",
        "forms": [
            {
                "orange_id": "210259-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 15,
        "type": "RX",
        "ingredient": "ACAMPROSATE CALCIUM",
        "trade_name": "ACAMPROSATE CALCIUM",
        "forms": [
            {
                "orange_id": "202229-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "333MG"
                ]
            }
        ]
    },
    {
        "id": 16,
        "type": "RX",
        "ingredient": "ACARBOSE",
        "trade_name": "ACARBOSE",
        "forms": [
            {
                "orange_id": "202271-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 17,
        "type": "RX",
        "ingredient": "ACEBUTOLOL HYDROCHLORIDE",
        "trade_name": "ACEBUTOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75047-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 18,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN",
        "trade_name": "ACEPHEN",
        "forms": [
            {
                "orange_id": "18060-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "120MG",
                    "325MG",
                    "650MG"
                ]
            }
        ]
    },
    {
        "id": 19,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN",
        "trade_name": "ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "204957-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/100ML (10MG/ML)",
                    "500MG/50ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "70607-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "120MG",
                    "650MG",
                    "325MG"
                ]
            },
            {
                "orange_id": "207229-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "650MG"
                ]
            }
        ]
    },
    {
        "id": 20,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN",
        "trade_name": "INFANTS' FEVERALL",
        "forms": [
            {
                "orange_id": "18337-4",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 21,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN",
        "trade_name": "OFIRMEV",
        "forms": [
            {
                "orange_id": "22450-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/100ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 22,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN",
        "trade_name": "TYLENOL",
        "forms": [
            {
                "orange_id": "19872-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "650MG"
                ]
            }
        ]
    },
    {
        "id": 23,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN, ASPIRIN AND CAFFEINE",
        "trade_name": "ACETAMINOPHEN, ASPIRIN AND CAFFEINE",
        "forms": [
            {
                "orange_id": "211695-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG-250MG-65MG"
                ]
            }
        ]
    },
    {
        "id": 24,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN, ASPIRIN AND CAFFEINE",
        "trade_name": "EXCEDRIN (MIGRAINE)",
        "forms": [
            {
                "orange_id": "20802-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG-250MG-65MG"
                ]
            }
        ]
    },
    {
        "id": 25,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND BENZHYDROCODONE HYDROCHLORIDE",
        "trade_name": "APADAZ",
        "forms": [
            {
                "orange_id": "208653-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-EQ 4.08MG BASE",
                    "325MG-EQ 6.12MG BASE",
                    "325MG-EQ 8.16MG BASE"
                ]
            }
        ]
    },
    {
        "id": 26,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND BUTALBITAL",
        "trade_name": "ALLZITAL",
        "forms": [
            {
                "orange_id": "203484-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 27,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND BUTALBITAL",
        "trade_name": "BUTALBITAL AND ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "213115-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG-50MG"
                ]
            },
            {
                "orange_id": "207635-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG-50MG",
                    "325MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 28,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND BUTALBITAL",
        "trade_name": "BUTAPAP",
        "forms": [
            {
                "orange_id": "89987-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 29,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN, BUTALBITAL AND CAFFEINE",
        "trade_name": "BUTALBITAL, ACETAMINOPHEN AND CAFFEINE",
        "forms": [
            {
                "orange_id": "204733-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG",
                    "300MG-50MG-40MG"
                ]
            },
            {
                "orange_id": "40387-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "325MG/15ML-50MG/15ML-40MG/15ML"
                ]
            },
            {
                "orange_id": "211106-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 30,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN, BUTALBITAL, CAFFEINE AND CODEINE PHOSPHATE",
        "trade_name": "BUTALBITAL, ACETAMINOPHEN, CAFFEINE AND CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "215138-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG-50MG-40MG-30MG",
                    "325MG-50MG-40MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 31,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN, BUTALBITAL, CAFFEINE AND CODEINE PHOSPHATE",
        "trade_name": "FIORICET W/ CODEINE",
        "forms": [
            {
                "orange_id": "20232-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 32,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN, CAFFEINE AND DIHYDROCODEINE BITARTRATE",
        "trade_name": "ACETAMINOPHEN, CAFFEINE AND DIHYDROCODEINE BITARTRATE",
        "forms": [
            {
                "orange_id": "204209-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-30MG-16MG"
                ]
            }
        ]
    },
    {
        "id": 33,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN, CAFFEINE AND DIHYDROCODEINE BITARTRATE",
        "trade_name": "TREZIX",
        "forms": [
            {
                "orange_id": "204785-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "320.5MG-30MG-16MG"
                ]
            }
        ]
    },
    {
        "id": 34,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND CODEINE PHOSPHATE",
        "trade_name": "ACETAMINOPHEN AND CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "40119-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "120MG/5ML-12MG/5ML"
                ]
            },
            {
                "orange_id": "40779-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG-30MG",
                    "300MG-15MG",
                    "300MG-60MG"
                ]
            }
        ]
    },
    {
        "id": 35,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND HYDROCODONE BITARTRATE",
        "trade_name": "ANEXSIA 5/325",
        "forms": [
            {
                "orange_id": "40409-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 36,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND HYDROCODONE BITARTRATE",
        "trade_name": "ANEXSIA 7. 5/325",
        "forms": [
            {
                "orange_id": "40405-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-7.5MG"
                ]
            }
        ]
    },
    {
        "id": 37,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND HYDROCODONE BITARTRATE",
        "trade_name": "HYDROCODONE BITARTRATE AND ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "40482-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "325MG/15ML-7.5MG/15ML",
                    "300MG/15ML-10MG/15ML",
                    "325MG/15ML-10MG/15ML"
                ]
            },
            {
                "orange_id": "209036-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG-5MG",
                    "300MG-7.5MG",
                    "300MG-10MG",
                    "325MG-5MG",
                    "325MG-7.5MG",
                    "325MG-10MG",
                    "325MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 38,
        "type": "OTC",
        "ingredient": "ACETAMINOPHEN AND IBUPROFEN",
        "trade_name": "ADVIL DUAL ACTION WITH ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "211733-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG-125MG"
                ]
            }
        ]
    },
    {
        "id": 39,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXYCET",
        "forms": [
            {
                "orange_id": "87463-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 40,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXYCODONE AND ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "211499-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "325MG/5ML-5MG/5ML",
                    "300MG/5ML-10MG/5ML"
                ]
            },
            {
                "orange_id": "210644-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-2.5MG",
                    "325MG-5MG",
                    "325MG-7.5MG",
                    "325MG-10MG",
                    "300MG-2.5MG",
                    "300MG-5MG",
                    "300MG-7.5MG",
                    "300MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 41,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND OXYCODONE HYDROCHLORIDE",
        "trade_name": "PERCOCET",
        "forms": [
            {
                "orange_id": "40330-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-2.5MG",
                    "325MG-5MG",
                    "325MG-7.5MG",
                    "325MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 42,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND TRAMADOL HYDROCHLORIDE",
        "trade_name": "TRAMADOL HYDROCHLORIDE AND ACETAMINOPHEN",
        "forms": [
            {
                "orange_id": "202076-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-37.5MG"
                ]
            }
        ]
    },
    {
        "id": 43,
        "type": "RX",
        "ingredient": "ACETAMINOPHEN AND TRAMADOL HYDROCHLORIDE",
        "trade_name": "ULTRACET",
        "forms": [
            {
                "orange_id": "21123-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-37.5MG"
                ]
            }
        ]
    },
    {
        "id": 44,
        "type": "RX",
        "ingredient": "ACETAZOLAMIDE",
        "trade_name": "ACETAZOLAMIDE",
        "forms": [
            {
                "orange_id": "207659-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            },
            {
                "orange_id": "211372-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 45,
        "type": "RX",
        "ingredient": "ACETAZOLAMIDE SODIUM",
        "trade_name": "ACETAZOLAMIDE SODIUM",
        "forms": [
            {
                "orange_id": "202693-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 46,
        "type": "RX",
        "ingredient": "ACETIC ACID, GLACIAL",
        "trade_name": "ACETIC ACID",
        "forms": [
            {
                "orange_id": "207280-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 47,
        "type": "RX",
        "ingredient": "ACETIC ACID, GLACIAL",
        "trade_name": "ACETIC ACID 0. 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18161-1",
                "form": "SOLUTION",
                "route": "IRRIGATION, URETHRAL",
                "dosage": [
                    "250MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 48,
        "type": "RX",
        "ingredient": "ACETIC ACID, GLACIAL",
        "trade_name": "VOSOL",
        "forms": [
            {
                "orange_id": "12179-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 49,
        "type": "RX",
        "ingredient": "ACETIC ACID, GLACIAL AND HYDROCORTISONE",
        "trade_name": "HYDROCORTISONE AND ACETIC ACID",
        "forms": [
            {
                "orange_id": "40609-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "2%-1%"
                ]
            }
        ]
    },
    {
        "id": 50,
        "type": "RX",
        "ingredient": "ACETIC ACID, GLACIAL AND HYDROCORTISONE",
        "trade_name": "VOSOL HC",
        "forms": [
            {
                "orange_id": "12770-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "2%-1%"
                ]
            }
        ]
    },
    {
        "id": 51,
        "type": "RX",
        "ingredient": "ACETOHYDROXAMIC ACID",
        "trade_name": "LITHOSTAT",
        "forms": [
            {
                "orange_id": "18749-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 52,
        "type": "RX",
        "ingredient": "ACETYLCHOLINE CHLORIDE",
        "trade_name": "MIOCHOL-E",
        "forms": [
            {
                "orange_id": "20213-1",
                "form": "FOR SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "20MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 53,
        "type": "RX",
        "ingredient": "ACETYLCYSTEINE",
        "trade_name": "ACETADOTE",
        "forms": [
            {
                "orange_id": "21539-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6GM/30ML (200MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 54,
        "type": "RX",
        "ingredient": "ACETYLCYSTEINE",
        "trade_name": "ACETYLCYSTEINE",
        "forms": [
            {
                "orange_id": "203173-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6GM/30ML (200MG/ML)"
                ]
            },
            {
                "orange_id": "204674-1",
                "form": "SOLUTION",
                "route": "INHALATION, ORAL",
                "dosage": [
                    "10%",
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 55,
        "type": "RX",
        "ingredient": "ACITRETIN",
        "trade_name": "ACITRETIN",
        "forms": [
            {
                "orange_id": "91455-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "17.5MG",
                    "22.5MG"
                ]
            }
        ]
    },
    {
        "id": 56,
        "type": "RX",
        "ingredient": "ACLIDINIUM BROMIDE",
        "trade_name": "TUDORZA PRESSAIR",
        "forms": [
            {
                "orange_id": "202450-1",
                "form": "POWDER, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.4MG/INH"
                ]
            }
        ]
    },
    {
        "id": 57,
        "type": "RX",
        "ingredient": "ACLIDINIUM BROMIDE AND FORMOTEROL FUMARATE",
        "trade_name": "DUAKLIR PRESSAIR",
        "forms": [
            {
                "orange_id": "210595-1",
                "form": "POWDER, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.4MG/INH-0.012MG/INH"
                ]
            }
        ]
    },
    {
        "id": 58,
        "type": "RX",
        "ingredient": "ACYCLOVIR",
        "trade_name": "ACYCLOVIR",
        "forms": [
            {
                "orange_id": "75677-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            },
            {
                "orange_id": "208766-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "209000-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "74738-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "77309-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 59,
        "type": "RX",
        "ingredient": "ACYCLOVIR",
        "trade_name": "SITAVIG",
        "forms": [
            {
                "orange_id": "203791-1",
                "form": "TABLET",
                "route": "BUCCAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 60,
        "type": "RX",
        "ingredient": "ACYCLOVIR",
        "trade_name": "ZOVIRAX",
        "forms": [
            {
                "orange_id": "21478-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "18604-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "19909-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 61,
        "type": "RX",
        "ingredient": "ACYCLOVIR SODIUM",
        "trade_name": "ACYCLOVIR SODIUM",
        "forms": [
            {
                "orange_id": "203701-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 62,
        "type": "RX",
        "ingredient": "ACYCLOVIR AND HYDROCORTISONE",
        "trade_name": "XERESE",
        "forms": [
            {
                "orange_id": "22436-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%-1%"
                ]
            }
        ]
    },
    {
        "id": 63,
        "type": "RX",
        "ingredient": "ADAPALENE",
        "trade_name": "ADAPALENE",
        "forms": [
            {
                "orange_id": "90824-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "201000-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.3%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "203981-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 64,
        "type": "RX",
        "ingredient": "ADAPALENE",
        "trade_name": "DIFFERIN",
        "forms": [
            {
                "orange_id": "20748-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "20380-2",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%",
                    "0.3%"
                ]
            },
            {
                "orange_id": "22502-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 65,
        "type": "RX",
        "ingredient": "ADAPALENE AND BENZOYL PEROXIDE",
        "trade_name": "ADAPALENE AND BENZOYL PEROXIDE",
        "forms": [
            {
                "orange_id": "203790-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%-2.5%",
                    "0.3%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 66,
        "type": "RX",
        "ingredient": "ADAPALENE AND BENZOYL PEROXIDE",
        "trade_name": "EPIDUO",
        "forms": [
            {
                "orange_id": "22320-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 67,
        "type": "RX",
        "ingredient": "ADAPALENE AND BENZOYL PEROXIDE",
        "trade_name": "EPIDUO FORTE",
        "forms": [
            {
                "orange_id": "207917-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.3%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 68,
        "type": "RX",
        "ingredient": "ADEFOVIR DIPIVOXIL",
        "trade_name": "ADEFOVIR DIPIVOXIL",
        "forms": [
            {
                "orange_id": "205459-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 69,
        "type": "RX",
        "ingredient": "ADEFOVIR DIPIVOXIL",
        "trade_name": "HEPSERA",
        "forms": [
            {
                "orange_id": "21449-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 70,
        "type": "RX",
        "ingredient": "ADENOSINE",
        "trade_name": "ADENOSINE",
        "forms": [
            {
                "orange_id": "78076-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3MG/ML"
                ]
            },
            {
                "orange_id": "90450-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60MG/20ML (3MG/ML)",
                    "90MG/30ML (3MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 71,
        "type": "RX",
        "ingredient": "AFAMELANOTIDE",
        "trade_name": "SCENESSE",
        "forms": [
            {
                "orange_id": "210797-1",
                "form": "IMPLANT",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "16MG"
                ]
            }
        ]
    },
    {
        "id": 72,
        "type": "RX",
        "ingredient": "AFATINIB DIMALEATE",
        "trade_name": "GILOTRIF",
        "forms": [
            {
                "orange_id": "201292-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 73,
        "type": "RX",
        "ingredient": "AIR POLYMER-TYPE A",
        "trade_name": "EXEM FOAM KIT",
        "forms": [
            {
                "orange_id": "212279-1",
                "form": "FOAM",
                "route": "INTRAUTERINE",
                "dosage": [
                    "10ML"
                ]
            }
        ]
    },
    {
        "id": 74,
        "type": "RX",
        "ingredient": "ALBENDAZOLE",
        "trade_name": "ALBENDAZOLE",
        "forms": [
            {
                "orange_id": "208094-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 75,
        "type": "RX",
        "ingredient": "ALBENDAZOLE",
        "trade_name": "ALBENZA",
        "forms": [
            {
                "orange_id": "20666-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 76,
        "type": "RX",
        "ingredient": "ALBUMIN HUMAN",
        "trade_name": "OPTISON",
        "forms": [
            {
                "orange_id": "20899-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 77,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "ACCUNEB",
        "forms": [
            {
                "orange_id": "20949-2",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.021% BASE",
                    "EQ 0.042% BASE"
                ]
            }
        ]
    },
    {
        "id": 78,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "ALBUTEROL SULFATE",
        "forms": [
            {
                "orange_id": "209959-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            },
            {
                "orange_id": "74543-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.5% BASE",
                    "EQ 0.083% BASE",
                    "EQ 0.021% BASE",
                    "EQ 0.042% BASE"
                ]
            },
            {
                "orange_id": "74749-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE/5ML"
                ]
            },
            {
                "orange_id": "208804-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 79,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "PROAIR DIGIHALER",
        "forms": [
            {
                "orange_id": "205636-2",
                "form": "POWDER, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 80,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "PROAIR HFA",
        "forms": [
            {
                "orange_id": "21457-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 81,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "PROAIR RESPICLICK",
        "forms": [
            {
                "orange_id": "205636-1",
                "form": "POWDER, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 82,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "PROVENTIL-HFA",
        "forms": [
            {
                "orange_id": "20503-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 83,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "VENTOLIN HFA",
        "forms": [
            {
                "orange_id": "20983-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.09MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 84,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE",
        "trade_name": "VOSPIRE ER",
        "forms": [
            {
                "orange_id": "76130-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 85,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE AND IPRATROPIUM BROMIDE",
        "trade_name": "ALBUTEROL SULFATE AND IPRATROPIUM BROMIDE",
        "forms": [
            {
                "orange_id": "77559-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.083% BASE-0.017%"
                ]
            }
        ]
    },
    {
        "id": 86,
        "type": "RX",
        "ingredient": "ALBUTEROL SULFATE AND IPRATROPIUM BROMIDE",
        "trade_name": "COMBIVENT RESPIMAT",
        "forms": [
            {
                "orange_id": "21747-1",
                "form": "SPRAY, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.1MG BASE/INH-0.02MG/INH"
                ]
            }
        ]
    },
    {
        "id": 87,
        "type": "OTC",
        "ingredient": "ALCAFTADINE",
        "trade_name": "LASTACAFT",
        "forms": [
            {
                "orange_id": "22134-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.25%"
                ]
            }
        ]
    },
    {
        "id": 88,
        "type": "RX",
        "ingredient": "ALCLOMETASONE DIPROPIONATE",
        "trade_name": "ALCLOMETASONE DIPROPIONATE",
        "forms": [
            {
                "orange_id": "76973-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "76884-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 89,
        "type": "RX",
        "ingredient": "ALCOHOL",
        "trade_name": "ABLYSINOL",
        "forms": [
            {
                "orange_id": "207987-1",
                "form": "SOLUTION",
                "route": "INTRA-ARTERIAL",
                "dosage": [
                    "99% (1ML)",
                    "99% (5ML)"
                ]
            }
        ]
    },
    {
        "id": 90,
        "type": "OTC",
        "ingredient": "ALCOHOL AND CHLORHEXIDINE GLUCONATE",
        "trade_name": "AVAGARD",
        "forms": [
            {
                "orange_id": "21074-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "61%-1%"
                ]
            }
        ]
    },
    {
        "id": 91,
        "type": "RX",
        "ingredient": "ALECTINIB HYDROCHLORIDE",
        "trade_name": "ALECENSA",
        "forms": [
            {
                "orange_id": "208434-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 92,
        "type": "RX",
        "ingredient": "ALENDRONATE SODIUM",
        "trade_name": "ALENDRONATE SODIUM",
        "forms": [
            {
                "orange_id": "90520-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 70MG BASE/75ML"
                ]
            },
            {
                "orange_id": "77982-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 35MG BASE",
                    "EQ 70MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 93,
        "type": "RX",
        "ingredient": "ALENDRONATE SODIUM",
        "trade_name": "BINOSTO",
        "forms": [
            {
                "orange_id": "202344-1",
                "form": "TABLET, EFFERVESCENT",
                "route": "ORAL",
                "dosage": [
                    "EQ 70MG BASE"
                ]
            }
        ]
    },
    {
        "id": 94,
        "type": "RX",
        "ingredient": "ALENDRONATE SODIUM",
        "trade_name": "FOSAMAX",
        "forms": [
            {
                "orange_id": "20560-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 70MG BASE"
                ]
            }
        ]
    },
    {
        "id": 95,
        "type": "RX",
        "ingredient": "ALENDRONATE SODIUM AND CHOLECALCIFEROL",
        "trade_name": "FOSAMAX PLUS D",
        "forms": [
            {
                "orange_id": "21762-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 70MG BASE-2,800 IU",
                    "EQ 70MG BASE-5,600 IU"
                ]
            }
        ]
    },
    {
        "id": 96,
        "type": "RX",
        "ingredient": "ALFENTANIL HYDROCHLORIDE",
        "trade_name": "ALFENTA",
        "forms": [
            {
                "orange_id": "19353-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 97,
        "type": "RX",
        "ingredient": "ALFENTANIL HYDROCHLORIDE",
        "trade_name": "ALFENTANIL",
        "forms": [
            {
                "orange_id": "75221-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 98,
        "type": "RX",
        "ingredient": "ALFUZOSIN HYDROCHLORIDE",
        "trade_name": "ALFUZOSIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79013-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 99,
        "type": "RX",
        "ingredient": "ALFUZOSIN HYDROCHLORIDE",
        "trade_name": "UROXATRAL",
        "forms": [
            {
                "orange_id": "21287-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 100,
        "type": "RX",
        "ingredient": "ALISKIREN HEMIFUMARATE",
        "trade_name": "ALISKIREN HEMIFUMARATE",
        "forms": [
            {
                "orange_id": "206665-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 101,
        "type": "RX",
        "ingredient": "ALISKIREN HEMIFUMARATE",
        "trade_name": "TEKTURNA",
        "forms": [
            {
                "orange_id": "21985-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 102,
        "type": "RX",
        "ingredient": "ALISKIREN HEMIFUMARATE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "TEKTURNA HCT",
        "forms": [
            {
                "orange_id": "22107-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE-12.5MG",
                    "EQ 300MG BASE-25MG"
                ]
            }
        ]
    },
    {
        "id": 103,
        "type": "RX",
        "ingredient": "ALITRETINOIN",
        "trade_name": "PANRETIN",
        "forms": [
            {
                "orange_id": "20886-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 104,
        "type": "RX",
        "ingredient": "ALLOPURINOL",
        "trade_name": "ALLOPURINOL",
        "forms": [
            {
                "orange_id": "212363-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "203154-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 105,
        "type": "RX",
        "ingredient": "ALLOPURINOL",
        "trade_name": "LOPURIN",
        "forms": [
            {
                "orange_id": "71586-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 106,
        "type": "RX",
        "ingredient": "ALLOPURINOL",
        "trade_name": "ZYLOPRIM",
        "forms": [
            {
                "orange_id": "16084-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 107,
        "type": "RX",
        "ingredient": "ALLOPURINOL SODIUM",
        "trade_name": "ALLOPURINOL SODIUM",
        "forms": [
            {
                "orange_id": "76870-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 108,
        "type": "RX",
        "ingredient": "ALLOPURINOL SODIUM",
        "trade_name": "ALOPRIM",
        "forms": [
            {
                "orange_id": "20298-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 109,
        "type": "RX",
        "ingredient": "ALMOTRIPTAN MALATE",
        "trade_name": "ALMOTRIPTAN MALATE",
        "forms": [
            {
                "orange_id": "205523-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 6.25MG BASE",
                    "EQ 12.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 110,
        "type": "RX",
        "ingredient": "ALOGLIPTIN BENZOATE",
        "trade_name": "NESINA",
        "forms": [
            {
                "orange_id": "22271-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 6.25MG BASE",
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 111,
        "type": "RX",
        "ingredient": "ALOGLIPTIN BENZOATE AND METFORMIN HYDROCHLORIDE",
        "trade_name": "KAZANO",
        "forms": [
            {
                "orange_id": "203414-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE-1GM",
                    "EQ 12.5MG BASE-500MG"
                ]
            }
        ]
    },
    {
        "id": 112,
        "type": "RX",
        "ingredient": "ALOGLIPTIN BENZOATE AND PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "OSENI",
        "forms": [
            {
                "orange_id": "22426-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE-EQ 15MG BASE",
                    "EQ 12.5MG BASE-EQ 30MG BASE",
                    "EQ 12.5MG BASE-EQ 45MG BASE",
                    "EQ 25MG BASE-EQ 15MG BASE",
                    "EQ 25MG BASE-EQ 30MG BASE",
                    "EQ 25MG BASE-EQ 45MG BASE"
                ]
            }
        ]
    },
    {
        "id": 113,
        "type": "RX",
        "ingredient": "ALOSETRON HYDROCHLORIDE",
        "trade_name": "ALOSETRON HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206647-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 114,
        "type": "RX",
        "ingredient": "ALOSETRON HYDROCHLORIDE",
        "trade_name": "LOTRONEX",
        "forms": [
            {
                "orange_id": "21107-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 115,
        "type": "RX",
        "ingredient": "ALPELISIB",
        "trade_name": "PIQRAY",
        "forms": [
            {
                "orange_id": "212526-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 116,
        "type": "RX",
        "ingredient": "ALPHA-TOCOPHEROL ACETATE, ASCORBIC ACID, BIOTIN, CHOLECALCIFEROL, CYANOCOBALAMIN, DEXPANTHENOL, FOLIC ACID, NIACINAMIDE, PYRIDOXINE HYDROCHLORIDE, RIBOFLAVIN 5'-PHOSPHATE SODIUM, THIAMINE HYDROCHLORIDE, VITAMIN A PALMITATE AND VITAMIN K",
        "trade_name": "INFUVITE ADULT",
        "forms": [
            {
                "orange_id": "21163-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2 IU/ML-40MG/ML-12MCG/ML-40 IU/ML-1MCG/ML-3MG/ML-120MCG/ML-8MG/ML-1.2MG/ML-0.72MG/ML-1.2MG/ML-660 IU/ML-0.03MG/ML",
                    "2 IU/ML-40MG/ML-12MCG/ML-40 IU/ML-1MCG/ML-3MG/ML-120MCG/ML-8MG/ML-1.2MG/ML-0.72MG/ML-1.2MG/ML-660 IU/ML-30MCG/ML"
                ]
            }
        ]
    },
    {
        "id": 117,
        "type": "RX",
        "ingredient": "ALPRAZOLAM",
        "trade_name": "ALPRAZOLAM",
        "forms": [
            {
                "orange_id": "74312-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "78056-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            },
            {
                "orange_id": "78561-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            },
            {
                "orange_id": "74342-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 118,
        "type": "RX",
        "ingredient": "ALPRAZOLAM",
        "trade_name": "XANAX",
        "forms": [
            {
                "orange_id": "18276-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 119,
        "type": "RX",
        "ingredient": "ALPRAZOLAM",
        "trade_name": "XANAX XR",
        "forms": [
            {
                "orange_id": "21434-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 120,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "ALPROSTADIL",
        "forms": [
            {
                "orange_id": "74815-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 121,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "CAVERJECT",
        "forms": [
            {
                "orange_id": "20379-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.01MG/VIAL",
                    "0.02MG/VIAL",
                    "0.04MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 122,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "CAVERJECT IMPULSE",
        "forms": [
            {
                "orange_id": "21212-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.01MG/VIAL",
                    "0.02MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 123,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "EDEX",
        "forms": [
            {
                "orange_id": "20649-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.01MG/VIAL",
                    "0.02MG/VIAL",
                    "0.04MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 124,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "MUSE",
        "forms": [
            {
                "orange_id": "20700-1",
                "form": "SUPPOSITORY",
                "route": "URETHRAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG",
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 125,
        "type": "RX",
        "ingredient": "ALPROSTADIL",
        "trade_name": "PROSTIN VR PEDIATRIC",
        "forms": [
            {
                "orange_id": "18484-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 126,
        "type": "OTC",
        "ingredient": "ALUMINUM HYDROXIDE AND MAGNESIUM TRISILICATE",
        "trade_name": "GAVISCON",
        "forms": [
            {
                "orange_id": "18685-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "80MG-20MG"
                ]
            }
        ]
    },
    {
        "id": 127,
        "type": "RX",
        "ingredient": "ALVIMOPAN",
        "trade_name": "ALVIMOPAN",
        "forms": [
            {
                "orange_id": "208295-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 128,
        "type": "RX",
        "ingredient": "ALVIMOPAN",
        "trade_name": "ENTEREG",
        "forms": [
            {
                "orange_id": "21775-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 129,
        "type": "RX",
        "ingredient": "AMANTADINE HYDROCHLORIDE",
        "trade_name": "AMANTADINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208966-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "74170-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "214284-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 130,
        "type": "RX",
        "ingredient": "AMANTADINE HYDROCHLORIDE",
        "trade_name": "GOCOVRI",
        "forms": [
            {
                "orange_id": "208944-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 68.5MG BASE",
                    "EQ 137MG BASE"
                ]
            }
        ]
    },
    {
        "id": 131,
        "type": "RX",
        "ingredient": "AMANTADINE HYDROCHLORIDE",
        "trade_name": "OSMOLEX ER",
        "forms": [
            {
                "orange_id": "209410-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 129MG BASE",
                    "EQ 193MG BASE"
                ]
            }
        ]
    },
    {
        "id": 132,
        "type": "RX",
        "ingredient": "AMBRISENTAN",
        "trade_name": "AMBRISENTAN",
        "forms": [
            {
                "orange_id": "210715-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 133,
        "type": "RX",
        "ingredient": "AMBRISENTAN",
        "trade_name": "LETAIRIS",
        "forms": [
            {
                "orange_id": "22081-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 134,
        "type": "RX",
        "ingredient": "AMCINONIDE",
        "trade_name": "AMCINONIDE",
        "forms": [
            {
                "orange_id": "76065-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "76329-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "76096-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 135,
        "type": "RX",
        "ingredient": "AMIFAMPRIDINE PHOSPHATE",
        "trade_name": "FIRDAPSE",
        "forms": [
            {
                "orange_id": "208078-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 136,
        "type": "RX",
        "ingredient": "AMIFOSTINE",
        "trade_name": "AMIFOSTINE",
        "forms": [
            {
                "orange_id": "77126-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 137,
        "type": "RX",
        "ingredient": "AMIFOSTINE",
        "trade_name": "ETHYOL",
        "forms": [
            {
                "orange_id": "20221-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 138,
        "type": "RX",
        "ingredient": "AMIKACIN SULFATE",
        "trade_name": "AMIKACIN SULFATE",
        "forms": [
            {
                "orange_id": "204040-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 250MG BASE/ML",
                    "EQ 50MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 139,
        "type": "RX",
        "ingredient": "AMIKACIN SULFATE",
        "trade_name": "ARIKAYCE KIT",
        "forms": [
            {
                "orange_id": "207356-1",
                "form": "SUSPENSION, LIPOSOMAL",
                "route": "INHALATION",
                "dosage": [
                    "EQ 590MG BASE/8.4ML"
                ]
            }
        ]
    },
    {
        "id": 140,
        "type": "RX",
        "ingredient": "AMILORIDE HYDROCHLORIDE",
        "trade_name": "AMILORIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "70346-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 141,
        "type": "RX",
        "ingredient": "AMILORIDE HYDROCHLORIDE",
        "trade_name": "MIDAMOR",
        "forms": [
            {
                "orange_id": "18200-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 142,
        "type": "RX",
        "ingredient": "AMILORIDE HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "AMILORIDE HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "71111-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG ANHYDROUS-50MG"
                ]
            }
        ]
    },
    {
        "id": 143,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "AMINO ACIDS",
        "forms": [
            {
                "orange_id": "91112-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15%(150GM/1000ML)",
                    "15%(300GM/2000ML)"
                ]
            }
        ]
    },
    {
        "id": 144,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "AMINOSYN II 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20015-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 145,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "AMINOSYN II 15% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20041-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15% (15GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 146,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "AMINOSYN-PF 10%",
        "forms": [
            {
                "orange_id": "19492-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 147,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "AMINOSYN-PF 7%",
        "forms": [
            {
                "orange_id": "19398-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "7% (7GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 148,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "CLINISOL 15% SULFITE FREE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20512-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15% (15GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 149,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "FREAMINE HBC 6. 9%",
        "forms": [
            {
                "orange_id": "16822-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6.9% (6.9GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 150,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "FREAMINE III 10%",
        "forms": [
            {
                "orange_id": "16822-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 151,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "FREAMINE III 8. 5%",
        "forms": [
            {
                "orange_id": "16822-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "8.5% (8.5GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 152,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "HEPATAMINE 8%",
        "forms": [
            {
                "orange_id": "18676-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "8% (8GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 153,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "NEPHRAMINE 5. 4%",
        "forms": [
            {
                "orange_id": "17766-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5.4% (5.4GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 154,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "PREMASOL 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "75880-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 155,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "PREMASOL 6% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "75880-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6% (6GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 156,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "PROSOL 20% SULFITE FREE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20849-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20% (20GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 157,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "TRAVASOL 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18931-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10MG/100ML)"
                ]
            }
        ]
    },
    {
        "id": 158,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "TRAVASOL 5. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18931-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5.5% (5.5GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 159,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "TRAVASOL 8. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18931-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "8.5% (8.5GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 160,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "TROPHAMINE",
        "forms": [
            {
                "orange_id": "19018-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6% (6GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 161,
        "type": "RX",
        "ingredient": "AMINO ACIDS",
        "trade_name": "TROPHAMINE 10%",
        "forms": [
            {
                "orange_id": "19018-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10% (10GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 162,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM ACETATE, GLYCERIN, MAGNESIUM ACETATE, PHOSPHORIC ACID, POTASSIUM CHLORIDE, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "PROCALAMINE",
        "forms": [
            {
                "orange_id": "18582-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3%-26MG/100ML-3GM/100ML-54MG/100ML-41MG/100ML-150MG/100ML-200MG/100ML-120MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 163,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 2. 75/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-33MG/100ML-10GM/100ML-51MG/100ML-261MG/100ML-217MG/100ML-112MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 164,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 2. 75/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-33MG/100ML-25GM/100ML-51MG/100ML-261MG/100ML-217MG/100ML-112MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 165,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 2. 75/5 SULFITE FREE W/ ELECT IN DEXTROSE 5% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-33MG/100ML-5GM/100ML-51MG/100ML-261MG/100ML-217MG/100ML-112MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 166,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 4. 25/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-9",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-33MG/100ML-10GM/100ML-51MG/100ML-261MG/100ML-297MG/100ML-77MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 167,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 4. 25/20 SULFITE FREE W/ ELECT IN DEXTROSE 20% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-11",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-33MG/100ML-20GM/100ML-51MG/100ML-261MG/100ML-297MG/100ML-77MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 168,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 4. 25/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-12",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-33MG/100ML-25GM/100ML-51MG/100ML-261MG/100ML-297MG/100ML-77MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 169,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 4. 25/5 SULFITE FREE W/ ELECT IN DEXTROSE 5% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-33MG/100ML-5GM/100ML-51MG/100ML-261MG/100ML-297MG/100ML-77MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 170,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 5/10 SULFITE FREE W/ ELECT IN DEXTROSE 10% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-16",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-33MG/100ML-10GM/100ML-51MG/100ML-261MG/100ML-340MG/100ML-59MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 171,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 5/15 SULFITE FREE W/ ELECT IN DEXTROSE 15% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-17",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-33MG/100ML-15GM/100ML-51MG/100ML-261MG/100ML-340MG/100ML-59MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 172,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 5/20 SULFITE FREE W/ ELECT IN 20% DEXTROSE W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-18",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-33MG/100ML-20GM/100ML-51MG/100ML-261MG/100ML-340MG/100ML-59MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 173,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 5/25 SULFITE FREE W/ ELECT IN DEXTROSE 25% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-19",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-33MG/100ML-25GM/100ML-51MG/100ML-261MG/100ML-340MG/100ML-59MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 174,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "CLINIMIX E 5/35 SULFITE FREE W/ ELECT IN DEXTROSE 35% W/ CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20678-21",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-33MG/100ML-35GM/100ML-51MG/100ML-261MG/100ML-340MG/100ML-59MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 175,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM SULFATE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM GLYCEROPHOSPHATE AND SOYBEAN OIL",
        "trade_name": "KABIVEN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "200656-4",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "3.3%-29MG/100ML-9.8GM/100ML-96MG/100ML-174MG/100ML-239MG/100ML -147MG/100ML-3.9GM/100ML (1026ML)",
                    "3.3%-29MG/100ML-9.8GM/100ML-96MG/100ML-174MG/100ML-239MG/100ML-147MG/100ML-3.9GM/100ML (1540ML)",
                    "3.3%-29MG/100ML-9.8GM/100ML-96MG/100ML-174MG/100ML-239MG/100ML-147MG/100ML-3.9GM/100ML (2053ML)",
                    "3.3%-29MG/100ML-9.8GM/100ML-96MG/100ML-174MG/100ML-239MG/100ML-147MG/100ML-3.9GM/100ML (2566ML)"
                ]
            }
        ]
    },
    {
        "id": 176,
        "type": "RX",
        "ingredient": "AMINO ACIDS, CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM SULFATE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM GLYCEROPHOSPHATE AND SOYBEAN OIL",
        "trade_name": "PERIKABIVEN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "200656-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2.4%-20MG/100ML-6.8GM/100ML-68MG/100ML-124MG/100ML-170MG/100ML-105MG/100ML-3.5GM/100ML (1440ML)",
                    "2.4%-20MG/100ML-6.8GM/100ML-68MG/100ML-124MG/100ML-170MG/100ML-105MG/100ML-3.5GM/100ML (1920ML)",
                    "2.4%-20MG/100ML-6.8GM/100ML-68MG/100ML-124MG/100ML-170MG/100ML -105MG/100ML-3.5GM/100ML (2400ML)"
                ]
            }
        ]
    },
    {
        "id": 177,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 2. 75/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 178,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 2. 75/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-25GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 179,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 2. 75/5 SULFITE FREE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.75%-5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 180,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 4. 25/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 181,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 4. 25/20 SULFITE FREE IN DEXTROSE 20% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-10",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 182,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 4. 25/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-11",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-25GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 183,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 4. 25/5 SULFITE FREE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4.25%-5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 184,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 5/10 SULFITE FREE IN DEXTROSE 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-14",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 185,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 5/15 SULFITE FREE IN DEXTROSE 15% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-15",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-15GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 186,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 5/20 SULFITE FREE IN DEXTROSE 20% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-16",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 187,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 5/25 SULFITE FREE IN DEXTROSE 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-17",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-25GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 188,
        "type": "RX",
        "ingredient": "AMINO ACIDS AND DEXTROSE",
        "trade_name": "CLINIMIX 5/35 SULFITE FREE IN DEXTROSE 35% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20734-18",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5%-35GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 189,
        "type": "RX",
        "ingredient": "AMINO ACIDS, MAGNESIUM ACETATE, PHOSPHORIC ACID, POTASSIUM ACETATE, POTASSIUM CHLORIDE AND SODIUM ACETATE",
        "trade_name": "FREAMINE III 8. 5% W/ ELECTROLYTES",
        "forms": [
            {
                "orange_id": "16822-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "8.5%-110MG/100ML-230MG/100ML-10MG/100ML-440MG/100ML-690MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 190,
        "type": "RX",
        "ingredient": "AMINO ACIDS, MAGNESIUM ACETATE, PHOSPHORIC ACID, POTASSIUM CHLORIDE, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "FREAMINE III 3% W/ ELECTROLYTES",
        "forms": [
            {
                "orange_id": "16822-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3%-54MG/100ML-40MG/100ML-150MG/100ML-200MG/100ML-120MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 191,
        "type": "RX",
        "ingredient": "AMINOCAPROIC ACID",
        "trade_name": "AMICAR",
        "forms": [
            {
                "orange_id": "15230-2",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.25GM/ML"
                ]
            },
            {
                "orange_id": "15197-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 192,
        "type": "RX",
        "ingredient": "AMINOCAPROIC ACID",
        "trade_name": "AMINOCAPROIC ACID",
        "forms": [
            {
                "orange_id": "71192-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250MG/ML"
                ]
            },
            {
                "orange_id": "212780-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.25GM/ML"
                ]
            },
            {
                "orange_id": "212492-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 193,
        "type": "RX",
        "ingredient": "AMINOCAPROIC ACID",
        "trade_name": "AMINOCAPROIC ACID IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "70010-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250MG/ML"
                ]
            }
        ]
    },
    {
        "id": 194,
        "type": "RX",
        "ingredient": "AMINOLEVULINIC ACID HYDROCHLORIDE",
        "trade_name": "AMELUZ",
        "forms": [
            {
                "orange_id": "208081-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 195,
        "type": "RX",
        "ingredient": "AMINOLEVULINIC ACID HYDROCHLORIDE",
        "trade_name": "GLEOLAN",
        "forms": [
            {
                "orange_id": "208630-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1.5GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 196,
        "type": "RX",
        "ingredient": "AMINOLEVULINIC ACID HYDROCHLORIDE",
        "trade_name": "LEVULAN",
        "forms": [
            {
                "orange_id": "20965-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 197,
        "type": "RX",
        "ingredient": "AMINOPHYLLINE",
        "trade_name": "AMINOPHYLLINE",
        "forms": [
            {
                "orange_id": "87242-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 198,
        "type": "RX",
        "ingredient": "AMINOSALICYLIC ACID",
        "trade_name": "PASER",
        "forms": [
            {
                "orange_id": "74346-1",
                "form": "GRANULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 199,
        "type": "RX",
        "ingredient": "AMIODARONE HYDROCHLORIDE",
        "trade_name": "AMIODARONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77610-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "204742-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "100MG",
                    "400MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 200,
        "type": "RX",
        "ingredient": "AMIODARONE HYDROCHLORIDE",
        "trade_name": "NEXTERONE",
        "forms": [
            {
                "orange_id": "22325-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/100ML (1.5MG/ML)",
                    "360MG/200ML (1.8MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 201,
        "type": "RX",
        "ingredient": "AMIODARONE HYDROCHLORIDE",
        "trade_name": "PACERONE",
        "forms": [
            {
                "orange_id": "75135-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 202,
        "type": "RX",
        "ingredient": "AMISULPRIDE",
        "trade_name": "BARHEMSYS",
        "forms": [
            {
                "orange_id": "209510-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5MG/2ML (2.5MG/ML)",
                    "10MG/4ML (2.5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 203,
        "type": "RX",
        "ingredient": "AMITRIPTYLINE HYDROCHLORIDE",
        "trade_name": "AMITRIPTYLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202446-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 204,
        "type": "RX",
        "ingredient": "AMITRIPTYLINE HYDROCHLORIDE AND CHLORDIAZEPOXIDE",
        "trade_name": "CHLORDIAZEPOXIDE AND AMITRIPTYLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "211925-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE-5MG",
                    "EQ 25MG BASE-10MG"
                ]
            }
        ]
    },
    {
        "id": 205,
        "type": "RX",
        "ingredient": "AMITRIPTYLINE HYDROCHLORIDE AND PERPHENAZINE",
        "trade_name": "PERPHENAZINE AND AMITRIPTYLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "71443-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-2MG",
                    "10MG-4MG",
                    "25MG-2MG",
                    "25MG-4MG",
                    "50MG-4MG"
                ]
            }
        ]
    },
    {
        "id": 206,
        "type": "RX",
        "ingredient": "AMLODIPINE BENZOATE",
        "trade_name": "KATERZIA",
        "forms": [
            {
                "orange_id": "211340-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 207,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE",
        "trade_name": "AMLODIPINE BESYLATE",
        "forms": [
            {
                "orange_id": "202553-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 5MG BASE "
                ]
            }
        ]
    },
    {
        "id": 208,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE",
        "trade_name": "NORVASC",
        "forms": [
            {
                "orange_id": "19787-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 209,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND ATORVASTATIN CALCIUM",
        "trade_name": "AMLODIPINE BESYLATE AND ATORVASTATIN CALCIUM",
        "forms": [
            {
                "orange_id": "205199-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-EQ 10MG BASE",
                    "EQ 5MG BASE-EQ 20MG BASE",
                    "EQ 5MG BASE-EQ 40MG BASE",
                    "EQ 5MG BASE-EQ 80MG BASE",
                    "EQ 10MG BASE-EQ 10MG BASE",
                    "EQ 10MG BASE-EQ 20MG BASE",
                    "EQ 10MG BASE-EQ 40MG BASE",
                    "EQ 10MG BASE-EQ 80MG BASE",
                    "EQ 2.5MG BASE-EQ 10MG BASE",
                    "EQ 2.5MG BASE-EQ 20MG BASE",
                    "EQ 2.5MG BASE-EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 210,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND ATORVASTATIN CALCIUM",
        "trade_name": "CADUET",
        "forms": [
            {
                "orange_id": "21540-9",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE-EQ 10MG BASE",
                    "EQ 2.5MG BASE-EQ 20MG BASE",
                    "EQ 2.5MG BASE-EQ 40MG BASE",
                    "EQ 5MG BASE-EQ 10MG BASE",
                    "EQ 5MG BASE-EQ 20MG BASE",
                    "EQ 5MG BASE-EQ 40MG BASE",
                    "EQ 5MG BASE-EQ 80MG BASE",
                    "EQ 10MG BASE-EQ 10MG BASE",
                    "EQ 10MG BASE-EQ 20MG BASE",
                    "EQ 10MG BASE-EQ 40MG BASE",
                    "EQ 10MG BASE-EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 211,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND BENAZEPRIL HYDROCHLORIDE",
        "trade_name": "AMLODIPINE BESYLATE AND BENAZEPRIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91431-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE-10MG",
                    "EQ 5MG BASE-10MG",
                    "EQ 5MG BASE-20MG",
                    "EQ 5MG BASE-40MG",
                    "EQ 10MG BASE-20MG",
                    "EQ 10MG BASE-40MG"
                ]
            }
        ]
    },
    {
        "id": 212,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND BENAZEPRIL HYDROCHLORIDE",
        "trade_name": "LOTREL",
        "forms": [
            {
                "orange_id": "20364-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE-10MG",
                    "EQ 5MG BASE-10MG",
                    "EQ 5MG BASE-20MG",
                    "EQ 5MG BASE-40MG",
                    "EQ 10MG BASE-20MG",
                    "EQ 10MG BASE-40MG"
                ]
            }
        ]
    },
    {
        "id": 213,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE, HYDROCHLOROTHIAZIDE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "OLMESARTAN MEDOXOMIL, AMLODIPINE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "206137-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-12.5MG-20MG",
                    "EQ 5MG BASE-12.5MG-40MG",
                    "EQ 5MG BASE-25MG-40MG",
                    "EQ 10MG BASE-12.5MG-40MG",
                    "EQ 10MG BASE-25MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 214,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE, HYDROCHLOROTHIAZIDE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "TRIBENZOR",
        "forms": [
            {
                "orange_id": "200175-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-12.5MG-20MG",
                    "EQ 5MG BASE-12.5MG-40MG",
                    "EQ 5MG BASE-25MG-40MG",
                    "EQ 10MG BASE-12.5MG-40MG",
                    "EQ 10MG BASE-25MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 215,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE, HYDROCHLOROTHIAZIDE AND VALSARTAN",
        "trade_name": "AMLODIPINE BESYLATE, VALSARTAN AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "206180-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-12.5MG-160MG",
                    "EQ 5MG BASE-25MG-160MG",
                    "EQ 10MG BASE-12.5MG-160MG",
                    "EQ 10MG BASE-25MG-160MG",
                    "EQ 10MG BASE-25MG-320MG"
                ]
            }
        ]
    },
    {
        "id": 216,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE, HYDROCHLOROTHIAZIDE AND VALSARTAN",
        "trade_name": "EXFORGE HCT",
        "forms": [
            {
                "orange_id": "22314-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-12.5MG-160MG",
                    "EQ 5MG BASE-25MG-160MG",
                    "EQ 10MG BASE-12.5MG-160MG",
                    "EQ 10MG BASE-25MG-160MG",
                    "EQ 10MG BASE-25MG-320MG"
                ]
            }
        ]
    },
    {
        "id": 217,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "AMLODIPINE AND OLMESARTAN MEDOXOMIL",
        "forms": [
            {
                "orange_id": "207216-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-20MG",
                    "EQ 5MG BASE-40MG",
                    "EQ 10MG BASE-20MG",
                    "EQ 10MG BASE-40MG"
                ]
            }
        ]
    },
    {
        "id": 218,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "AZOR",
        "forms": [
            {
                "orange_id": "22100-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-20MG",
                    "EQ 5MG BASE-40MG",
                    "EQ 10MG BASE-20MG",
                    "EQ 10MG BASE-40MG"
                ]
            }
        ]
    },
    {
        "id": 219,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND PERINDOPRIL ARGININE",
        "trade_name": "PRESTALIA",
        "forms": [
            {
                "orange_id": "205003-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE-3.5MG ",
                    "EQ 5MG BASE-7MG",
                    "EQ 10MG BASE-14MG"
                ]
            }
        ]
    },
    {
        "id": 220,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND TELMISARTAN",
        "trade_name": "TELMISARTAN AND AMLODIPINE",
        "forms": [
            {
                "orange_id": "201586-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-40MG",
                    "EQ 5MG BASE-80MG",
                    "EQ 10MG BASE-40MG",
                    "EQ 10MG BASE-80MG"
                ]
            }
        ]
    },
    {
        "id": 221,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND VALSARTAN",
        "trade_name": "AMLODIPINE BESYLATE AND VALSARTAN",
        "forms": [
            {
                "orange_id": "202713-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-160MG",
                    "EQ 5MG BASE-320MG",
                    "EQ 10MG BASE-160MG",
                    "EQ 10MG BASE-320MG"
                ]
            }
        ]
    },
    {
        "id": 222,
        "type": "RX",
        "ingredient": "AMLODIPINE BESYLATE AND VALSARTAN",
        "trade_name": "EXFORGE",
        "forms": [
            {
                "orange_id": "21990-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE-160MG",
                    "EQ 5MG BASE-320MG",
                    "EQ 10MG BASE-160MG",
                    "EQ 10MG BASE-320MG"
                ]
            }
        ]
    },
    {
        "id": 223,
        "type": "RX",
        "ingredient": "AMMONIA N-13",
        "trade_name": "AMMONIA N 13",
        "forms": [
            {
                "orange_id": "203779-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30mCi-300mCi/8ML (3.75-37.5mCi/ML)",
                    "48.75mCi-487.5mCi/13ML (3.75-37.5mCi/ML)",
                    "3.75mCi-260mCi/ML",
                    "22.5mCi-225mCi/6ML (3.75-37.5mCi/ML)",
                    "30mCi-300mCi (3.75-37.5mCi/ML)",
                    "18.8mCi-188mCi/5ML (3.75-37.5mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 224,
        "type": "RX",
        "ingredient": "AMMONIUM CHLORIDE",
        "trade_name": "AMMONIUM CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "88366-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MEQ/ML"
                ]
            }
        ]
    },
    {
        "id": 225,
        "type": "RX",
        "ingredient": "AMMONIUM LACTATE",
        "trade_name": "AMMONIUM LACTATE",
        "forms": [
            {
                "orange_id": "75774-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 12% BASE"
                ]
            },
            {
                "orange_id": "75570-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 12% BASE"
                ]
            }
        ]
    },
    {
        "id": 226,
        "type": "RX",
        "ingredient": "AMOXAPINE",
        "trade_name": "AMOXAPINE",
        "forms": [
            {
                "orange_id": "72691-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 227,
        "type": "RX",
        "ingredient": "AMOXICILLIN",
        "trade_name": "AMOXICILLIN",
        "forms": [
            {
                "orange_id": "65271-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "65334-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML",
                    "400MG/5ML",
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            },
            {
                "orange_id": "64013-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG"
                ]
            },
            {
                "orange_id": "65256-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "875MG"
                ]
            }
        ]
    },
    {
        "id": 228,
        "type": "RX",
        "ingredient": "AMOXICILLIN",
        "trade_name": "AMOXICILLIN PEDIATRIC",
        "forms": [
            {
                "orange_id": "61931-3",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 229,
        "type": "RX",
        "ingredient": "AMOXICILLIN",
        "trade_name": "AMOXIL",
        "forms": [
            {
                "orange_id": "62216-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "62226-5",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML",
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 230,
        "type": "RX",
        "ingredient": "AMOXICILLIN",
        "trade_name": "LAROTID",
        "forms": [
            {
                "orange_id": "62226-3",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 231,
        "type": "RX",
        "ingredient": "AMOXICILLIN, CLARITHROMYCIN AND LANSOPRAZOLE",
        "trade_name": "LANSOPRAZOLE, AMOXICILLIN AND CLARITHROMYCIN (COPACKAGED)",
        "forms": [
            {
                "orange_id": "206006-1",
                "form": "CAPSULE, TABLET, CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "500MG-500MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 232,
        "type": "RX",
        "ingredient": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "trade_name": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "forms": [
            {
                "orange_id": "209371-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML-EQ 31.25MG BASE/5ML",
                    "200MG/5ML-EQ 28.5MG BASE/5ML",
                    "250MG/5ML-EQ 62.5MG BASE/5ML",
                    "400MG/5ML-EQ 57MG BASE/5ML",
                    "600MG/5ML-EQ 42.9MG BASE/5ML"
                ]
            },
            {
                "orange_id": "65205-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "200MG-EQ 28.5MG BASE",
                    "400MG-EQ 57MG BASE"
                ]
            },
            {
                "orange_id": "90227-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM-EQ 62.5MG BASE"
                ]
            },
            {
                "orange_id": "91569-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG-EQ 125MG BASE",
                    "500MG-EQ 125MG BASE",
                    "875MG-EQ 125MG BASE"
                ]
            }
        ]
    },
    {
        "id": 233,
        "type": "RX",
        "ingredient": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "trade_name": "AUGMENTIN '125'",
        "forms": [
            {
                "orange_id": "50575-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML-EQ 31.25MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 234,
        "type": "RX",
        "ingredient": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "trade_name": "AUGMENTIN '250'",
        "forms": [
            {
                "orange_id": "50575-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML-EQ 62.5MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 235,
        "type": "RX",
        "ingredient": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "trade_name": "AUGMENTIN '875'",
        "forms": [
            {
                "orange_id": "50720-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "875MG-EQ 125MG BASE"
                ]
            }
        ]
    },
    {
        "id": 236,
        "type": "RX",
        "ingredient": "AMOXICILLIN AND CLAVULANATE POTASSIUM",
        "trade_name": "AUGMENTIN ES-600",
        "forms": [
            {
                "orange_id": "50755-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "600MG/5ML-EQ 42.9MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 237,
        "type": "RX",
        "ingredient": "AMOXICILLIN, OMEPRAZOLE MAGNESIUM AND RIFABUTIN",
        "trade_name": "TALICIA",
        "forms": [
            {
                "orange_id": "213004-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "250MG-EQ 10MG BASE-12.5MG"
                ]
            }
        ]
    },
    {
        "id": 238,
        "type": "RX",
        "ingredient": "AMPHETAMINE",
        "trade_name": "ADZENYS XR-ODT",
        "forms": [
            {
                "orange_id": "204326-1",
                "form": "TABLET, ORALLY DISINTEGRATING, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 3.1MG BASE",
                    "EQ 6.3MG BASE",
                    "EQ 9.4MG BASE",
                    "EQ 12.5MG BASE",
                    "EQ 15.7MG BASE",
                    "EQ 18.8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 239,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE , AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DEXTROAMP SACCHARATE, AMP ASPARTATE, DEXTROAMP SULFATE AND AMP SULFATE",
        "forms": [
            {
                "orange_id": "213111-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-2.5MG-2.5MG-2.5MG",
                    "3.75MG-3.75MG-3.75MG-3.75MG",
                    "5MG-5MG-5MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 240,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 10",
        "forms": [
            {
                "orange_id": "21303-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-2.5MG-2.5MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 241,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 15",
        "forms": [
            {
                "orange_id": "21303-6",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "3.75MG-3.75MG-3.75MG-3.75MG"
                ]
            }
        ]
    },
    {
        "id": 242,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 20",
        "forms": [
            {
                "orange_id": "21303-2",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-5MG-5MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 243,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 25",
        "forms": [
            {
                "orange_id": "21303-4",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "6.25MG-6.25MG-6.25MG-6.25MG"
                ]
            }
        ]
    },
    {
        "id": 244,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 30",
        "forms": [
            {
                "orange_id": "21303-3",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "7.5MG-7.5MG-7.5MG-7.5MG"
                ]
            }
        ]
    },
    {
        "id": 245,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "ADDERALL XR 5",
        "forms": [
            {
                "orange_id": "21303-5",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.25MG-1.25MG-1.25MG-1.25MG"
                ]
            }
        ]
    },
    {
        "id": 246,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DETROAMP SACCHARATE, AMP ASPARTATE, DEXTROAMP SULFATE AND AMP SULFATE",
        "forms": [
            {
                "orange_id": "214959-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.25MG-1.25MG-1.25MG-1.25MG",
                    "2.5MG-2.5MG-2.5MG-2.5MG",
                    "3.75MG-3.75MG-3.75MG-3.75MG",
                    "5MG-5MG-5MG-5MG",
                    "6.25MG-6.25MG-6.25MG-6.25MG",
                    "7.5MG-7.5MG-7.5MG-7.5MG"
                ]
            }
        ]
    },
    {
        "id": 247,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DEXTROAMP SACCHARATE, AMP ASPARTATE, DEXTROAMP SULFATE AND AMP SULFATE",
        "forms": [
            {
                "orange_id": "77302-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.25MG-1.25MG-1.25MG-1.25MG",
                    "2.5MG-2.5MG-2.5MG-2.5MG",
                    "3.75MG-3.75MG-3.75MG-3.75MG",
                    "5MG-5MG-5MG-5MG",
                    "6.25MG-6.25MG-6.25MG-6.25MG",
                    "7.5MG-7.5MG-7.5MG-7.5MG",
                    "3.125MG-3.125MG-3.125MG-3.125MG",
                    "9.375MG-9.375MG-9.375MG-9.375MG",
                    "12.5MG-12.5MG-12.5MG-12.5MG"
                ]
            },
            {
                "orange_id": "214347-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.25MG-1.25MG-1.25MG-1.25MG",
                    "1.875MG-1.875MG-1.875MG-1.875MG",
                    "2.5MG-2.5MG-2.5MG-2.5MG",
                    "3.125MG-3.125MG-3.125MG-3.125MG",
                    "3.75MG-3.75MG-3.75MG-3.75MG",
                    "5MG-5MG-5MG-5MG",
                    "7.5MG-7.5MG-7.5MG-7.5MG"
                ]
            }
        ]
    },
    {
        "id": 248,
        "type": "RX",
        "ingredient": "AMPHETAMINE ASPARTATE, AMPHETAMINE SULFATE, DEXTROAMPHETAMINE SACCHARATE AND DEXTROAMPHETAMINE SULFATE",
        "trade_name": "MYDAYIS",
        "forms": [
            {
                "orange_id": "22063-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "3.125MG-3.125MG-3.125MG-3.125MG",
                    "6.25MG-6.25MG-6.25MG-6.25MG",
                    "9.375MG-9.375MG-9.375MG-9.375MG",
                    "12.5MG-12.5MG-12.5MG-12.5MG"
                ]
            }
        ]
    },
    {
        "id": 249,
        "type": "RX",
        "ingredient": "AMPHETAMINE SULFATE",
        "trade_name": "AMPHETAMINE SULFATE",
        "forms": [
            {
                "orange_id": "213720-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 250,
        "type": "RX",
        "ingredient": "AMPHETAMINE SULFATE",
        "trade_name": "EVEKEO",
        "forms": [
            {
                "orange_id": "200166-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 251,
        "type": "RX",
        "ingredient": "AMPHETAMINE SULFATE",
        "trade_name": "EVEKEO ODT",
        "forms": [
            {
                "orange_id": "209905-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 252,
        "type": "RX",
        "ingredient": "AMPHETAMINE AND AMPHETAMINE ASPARTATE/DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DYANAVEL XR",
        "forms": [
            {
                "orange_id": "208147-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2MG/ML-EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 253,
        "type": "RX",
        "ingredient": "AMPHETAMINE AND AMPHETAMINE ASPARTATE/DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DYANAVEL XR 10",
        "forms": [
            {
                "orange_id": "210526-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MG-EQ 2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 254,
        "type": "RX",
        "ingredient": "AMPHETAMINE AND AMPHETAMINE ASPARTATE/DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DYANAVEL XR 15",
        "forms": [
            {
                "orange_id": "210526-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "12MG-EQ 3MG BASE"
                ]
            }
        ]
    },
    {
        "id": 255,
        "type": "RX",
        "ingredient": "AMPHETAMINE AND AMPHETAMINE ASPARTATE/DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DYANAVEL XR 20",
        "forms": [
            {
                "orange_id": "210526-4",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "16MG-EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 256,
        "type": "RX",
        "ingredient": "AMPHETAMINE AND AMPHETAMINE ASPARTATE/DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DYANAVEL XR 5",
        "forms": [
            {
                "orange_id": "210526-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4MG-EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 257,
        "type": "RX",
        "ingredient": "AMPHOTERICIN B",
        "trade_name": "ABELCET",
        "forms": [
            {
                "orange_id": "50724-1",
                "form": "INJECTABLE, LIPID COMPLEX",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 258,
        "type": "RX",
        "ingredient": "AMPHOTERICIN B",
        "trade_name": "AMBISOME",
        "forms": [
            {
                "orange_id": "50740-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 259,
        "type": "RX",
        "ingredient": "AMPHOTERICIN B",
        "trade_name": "AMPHOTERICIN B",
        "forms": [
            {
                "orange_id": "212514-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "50MG/VIAL"
                ]
            },
            {
                "orange_id": "63206-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 260,
        "type": "RX",
        "ingredient": "AMPICILLIN SODIUM",
        "trade_name": "AMPICILLIN SODIUM",
        "forms": [
            {
                "orange_id": "90889-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10GM BASE/VIAL",
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 250MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 125MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "62738-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 261,
        "type": "RX",
        "ingredient": "AMPICILLIN SODIUM AND SULBACTAM SODIUM",
        "trade_name": "AMPICILLIN AND SULBACTAM",
        "forms": [
            {
                "orange_id": "65406-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL-EQ 500MG BASE/VIAL",
                    "EQ 2GM BASE/VIAL-EQ 1GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL-EQ 5GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 262,
        "type": "RX",
        "ingredient": "AMPICILLIN SODIUM AND SULBACTAM SODIUM",
        "trade_name": "UNASYN",
        "forms": [
            {
                "orange_id": "62901-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2GM BASE/VIAL-EQ 1GM BASE/VIAL",
                    "EQ 1GM BASE/VIAL-EQ 500MG BASE/VIAL",
                    "EQ 10GM BASE/VIAL-EQ 5GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 263,
        "type": "RX",
        "ingredient": "AMPICILLIN/AMPICILLIN TRIHYDRATE",
        "trade_name": "AMPICILLIN TRIHYDRATE",
        "forms": [
            {
                "orange_id": "64082-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 264,
        "type": "RX",
        "ingredient": "ANAGRELIDE HYDROCHLORIDE",
        "trade_name": "AGRYLIN",
        "forms": [
            {
                "orange_id": "20333-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 265,
        "type": "RX",
        "ingredient": "ANAGRELIDE HYDROCHLORIDE",
        "trade_name": "ANAGRELIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76910-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 266,
        "type": "RX",
        "ingredient": "ANASTROZOLE",
        "trade_name": "ANASTROZOLE",
        "forms": [
            {
                "orange_id": "90568-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 267,
        "type": "RX",
        "ingredient": "ANASTROZOLE",
        "trade_name": "ARIMIDEX",
        "forms": [
            {
                "orange_id": "20541-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 268,
        "type": "RX",
        "ingredient": "ANGIOTENSIN II ACETATE",
        "trade_name": "GIAPREZA",
        "forms": [
            {
                "orange_id": "209360-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.5MG BASE/ML (EQ 0.5MG BASE/ML)",
                    "EQ 2.5MG BASE/ML (EQ 2.5MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 269,
        "type": "RX",
        "ingredient": "ANIDULAFUNGIN",
        "trade_name": "ERAXIS",
        "forms": [
            {
                "orange_id": "21632-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL",
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 270,
        "type": "RX",
        "ingredient": "APALUTAMIDE",
        "trade_name": "ERLEADA",
        "forms": [
            {
                "orange_id": "210951-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 271,
        "type": "RX",
        "ingredient": "APIXABAN",
        "trade_name": "APIXABAN",
        "forms": [
            {
                "orange_id": "210180-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 272,
        "type": "RX",
        "ingredient": "APIXABAN",
        "trade_name": "ELIQUIS",
        "forms": [
            {
                "orange_id": "202155-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 273,
        "type": "RX",
        "ingredient": "APOMORPHINE HYDROCHLORIDE",
        "trade_name": "APOKYN",
        "forms": [
            {
                "orange_id": "21264-2",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "30MG/3ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 274,
        "type": "RX",
        "ingredient": "APOMORPHINE HYDROCHLORIDE",
        "trade_name": "KYNMOBI",
        "forms": [
            {
                "orange_id": "210875-1",
                "form": "FILM",
                "route": "SUBLINGUAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "25MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 275,
        "type": "RX",
        "ingredient": "APRACLONIDINE HYDROCHLORIDE",
        "trade_name": "APRACLONIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77764-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 276,
        "type": "RX",
        "ingredient": "APRACLONIDINE HYDROCHLORIDE",
        "trade_name": "IOPIDINE",
        "forms": [
            {
                "orange_id": "20258-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE",
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 277,
        "type": "RX",
        "ingredient": "APREMILAST",
        "trade_name": "APREMILAST",
        "forms": [
            {
                "orange_id": "211761-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 278,
        "type": "RX",
        "ingredient": "APREMILAST",
        "trade_name": "OTEZLA",
        "forms": [
            {
                "orange_id": "205437-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 279,
        "type": "RX",
        "ingredient": "APREPITANT",
        "trade_name": "APREPITANT",
        "forms": [
            {
                "orange_id": "207777-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG",
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 280,
        "type": "RX",
        "ingredient": "APREPITANT",
        "trade_name": "CINVANTI",
        "forms": [
            {
                "orange_id": "209296-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "130MG/18ML (7.2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 281,
        "type": "RX",
        "ingredient": "APREPITANT",
        "trade_name": "EMEND",
        "forms": [
            {
                "orange_id": "21549-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "125MG"
                ]
            },
            {
                "orange_id": "207865-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/KIT"
                ]
            }
        ]
    },
    {
        "id": 282,
        "type": "RX",
        "ingredient": "ARFORMOTEROL TARTRATE",
        "trade_name": "ARFORMOTEROL TARTRATE",
        "forms": [
            {
                "orange_id": "213762-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.015MG BASE/2ML"
                ]
            }
        ]
    },
    {
        "id": 283,
        "type": "RX",
        "ingredient": "ARFORMOTEROL TARTRATE",
        "trade_name": "BROVANA",
        "forms": [
            {
                "orange_id": "21912-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.015MG BASE/2ML"
                ]
            }
        ]
    },
    {
        "id": 284,
        "type": "RX",
        "ingredient": "ARGATROBAN",
        "trade_name": "ARGATROBAN",
        "forms": [
            {
                "orange_id": "206698-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250MG/2.5ML (100MG/ML)",
                    "50MG/50ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 285,
        "type": "RX",
        "ingredient": "ARGATROBAN",
        "trade_name": "ARGATROBAN IN SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "205570-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "125MG/125ML (1MG/ML)"
                ]
            },
            {
                "orange_id": "212035-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/50ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 286,
        "type": "RX",
        "ingredient": "ARGININE HYDROCHLORIDE",
        "trade_name": "R-GENE 10",
        "forms": [
            {
                "orange_id": "16931-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 287,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE",
        "trade_name": "ABILIFY",
        "forms": [
            {
                "orange_id": "21436-6",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 288,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE",
        "trade_name": "ABILIFY MAINTENA KIT",
        "forms": [
            {
                "orange_id": "202971-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "300MG/VIAL",
                    "300MG",
                    "400MG/VIAL",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 289,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE",
        "trade_name": "ABILIFY MYCITE KIT",
        "forms": [
            {
                "orange_id": "207202-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 290,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE",
        "trade_name": "ARIPIPRAZOLE",
        "forms": [
            {
                "orange_id": "203906-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "202102-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG"
                ]
            },
            {
                "orange_id": "206251-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 291,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE LAUROXIL",
        "trade_name": "ARISTADA",
        "forms": [
            {
                "orange_id": "207533-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "441MG/1.6ML (275.63MG/ML)",
                    "662MG/2.4ML (275.83MG/ML)",
                    "882MG/3.2ML (275.63MG/ML)",
                    "1064MG/3.9ML (272.82MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 292,
        "type": "RX",
        "ingredient": "ARIPIPRAZOLE LAUROXIL",
        "trade_name": "ARISTADA INITIO KIT",
        "forms": [
            {
                "orange_id": "209830-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "675MG/2.4ML"
                ]
            }
        ]
    },
    {
        "id": 293,
        "type": "RX",
        "ingredient": "ARMODAFINIL",
        "trade_name": "ARMODAFINIL",
        "forms": [
            {
                "orange_id": "206069-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "150MG",
                    "200MG",
                    "250MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 294,
        "type": "RX",
        "ingredient": "ARMODAFINIL",
        "trade_name": "NUVIGIL",
        "forms": [
            {
                "orange_id": "21875-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "150MG",
                    "200MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 295,
        "type": "RX",
        "ingredient": "ARSENIC TRIOXIDE",
        "trade_name": "ARSENIC TRIOXIDE",
        "forms": [
            {
                "orange_id": "210739-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 296,
        "type": "RX",
        "ingredient": "ARSENIC TRIOXIDE",
        "trade_name": "TRISENOX",
        "forms": [
            {
                "orange_id": "21248-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 297,
        "type": "RX",
        "ingredient": "ARTEMETHER AND LUMEFANTRINE",
        "trade_name": "COARTEM",
        "forms": [
            {
                "orange_id": "22268-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 298,
        "type": "RX",
        "ingredient": "ARTESUNATE",
        "trade_name": "ARTESUNATE",
        "forms": [
            {
                "orange_id": "213036-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "110MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 299,
        "type": "RX",
        "ingredient": "ARTICAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "ORABLOC",
        "forms": [
            {
                "orange_id": "22466-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4%-EQ 0.009MG BASE/1.8ML (EQ 0.005MG BASE/ML)",
                    "4%-EQ 0.018MG BASE/1.8ML (EQ 0.01MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 300,
        "type": "RX",
        "ingredient": "ARTICAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "SEPTOCAINE",
        "forms": [
            {
                "orange_id": "20971-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4%- EQ 0.0085MG BASE/1.7ML (4%- EQ 0.005MG BASE/ML)",
                    "4%-EQ 0.017MG BASE/1.7ML (4%-EQ 0.01MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 301,
        "type": "RX",
        "ingredient": "ASCIMINIB HYDROCHLORIDE",
        "trade_name": "SCEMBLIX",
        "forms": [
            {
                "orange_id": "215358-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 302,
        "type": "RX",
        "ingredient": "ASCORBIC ACID",
        "trade_name": "ASCOR",
        "forms": [
            {
                "orange_id": "209112-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "25,000MG/50ML (500MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 303,
        "type": "RX",
        "ingredient": "ASCORBIC ACID, BIOTIN, CHOLECALCIFEROL, CYANOCOBALAMIN, DEXPANTHENOL, FOLIC ACID, NIACINAMIDE, PYRIDOXINE, RIBOFLAVIN, THIAMINE, TOCOPHEROL ACETATE, VITAMIN A AND VITAMIN K",
        "trade_name": "INFUVITE PEDIATRIC",
        "forms": [
            {
                "orange_id": "21265-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "80MG/VIAL-0.02MG/VIAL-400 IU/VIAL-0.001MG/VIAL-5MG/VIAL-0.14MG/VIAL-17MG/VIAL-1MG/VIAL-1.4MG/VIAL-1.2MG/VIAL-7 IU/VIAL-2,300 IU/VIAL-0.2MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 304,
        "type": "RX",
        "ingredient": "ASCORBIC ACID, BIOTIN, CHOLECALCIFEROL, CYANOCOBALAMIN, DEXPANTHENOL, FOLIC ACID, NIACINAMIDE, PYRIDOXINE, RIBOFLAVIN, THIAMINE, TOCOPHEROL ACETATE, VITAMIN A AND VITAMIN K",
        "trade_name": "INFUVITE PEDIATRIC (PHARMACY BULK PACKAGE)",
        "forms": [
            {
                "orange_id": "21265-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "80MG/VIAL-0.02MG/VIAL-400 IU/VIAL-0.001MG/VIAL-5MG/VIAL-0.14MG/VIAL-17MG/VIAL-1MG/VIAL-1.4MG/VIAL-1.2MG/VIAL-7 IU/VIAL-2,300 IU/VIAL-0.2MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 305,
        "type": "RX",
        "ingredient": "ASCORBIC ACID, POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM ASCORBATE, SODIUM CHLORIDE AND SODIUM SULFATE",
        "trade_name": "MOVIPREP",
        "forms": [
            {
                "orange_id": "21881-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4.7GM-100GM-1.015GM-5.9GM-2.691GM-7.5GM"
                ]
            }
        ]
    },
    {
        "id": 306,
        "type": "RX",
        "ingredient": "ASCORBIC ACID, POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM ASCORBATE, SODIUM CHLORIDE AND SODIUM SULFATE",
        "trade_name": "PEG-3350, SODIUM SULFATE, SODIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ASCORBATE AND ASCORBIC ACID",
        "forms": [
            {
                "orange_id": "90145-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4.7GM-100GM-1.015GM-5.9GM-2.691GM-7.5GM"
                ]
            }
        ]
    },
    {
        "id": 307,
        "type": "RX",
        "ingredient": "ASCORBIC ACID, POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM ASCORBATE, SODIUM CHLORIDE AND SODIUM SULFATE",
        "trade_name": "PLENVU",
        "forms": [
            {
                "orange_id": "209381-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "7.54GM-140GM-2.2GM-48.11GM-5.2GM-9GM"
                ]
            }
        ]
    },
    {
        "id": 308,
        "type": "RX",
        "ingredient": "ASENAPINE",
        "trade_name": "SECUADO",
        "forms": [
            {
                "orange_id": "212268-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "3.8MG/24HR",
                    "5.7MG/24HR",
                    "7.6MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 309,
        "type": "RX",
        "ingredient": "ASENAPINE MALEATE",
        "trade_name": "ASENAPINE MALEATE",
        "forms": [
            {
                "orange_id": "206098-3",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 310,
        "type": "RX",
        "ingredient": "ASENAPINE MALEATE",
        "trade_name": "SAPHRIS",
        "forms": [
            {
                "orange_id": "22117-3",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 311,
        "type": "RX",
        "ingredient": "ASPIRIN",
        "trade_name": "DURLAZA",
        "forms": [
            {
                "orange_id": "200671-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "162.5MG"
                ]
            }
        ]
    },
    {
        "id": 312,
        "type": "OTC",
        "ingredient": "ASPIRIN",
        "trade_name": "VAZALORE",
        "forms": [
            {
                "orange_id": "203697-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "81MG",
                    "325MG"
                ]
            }
        ]
    },
    {
        "id": 313,
        "type": "RX",
        "ingredient": "ASPIRIN, BUTALBITAL AND CAFFEINE",
        "trade_name": "BUTALBITAL, ASPIRIN AND CAFFEINE",
        "forms": [
            {
                "orange_id": "205230-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "500MG-50MG-40MG"
                ]
            },
            {
                "orange_id": "204195-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 314,
        "type": "RX",
        "ingredient": "ASPIRIN, BUTALBITAL AND CAFFEINE",
        "trade_name": "FIORINAL",
        "forms": [
            {
                "orange_id": "17534-5",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 315,
        "type": "RX",
        "ingredient": "ASPIRIN, BUTALBITAL AND CAFFEINE",
        "trade_name": "LANORINAL",
        "forms": [
            {
                "orange_id": "86996-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 316,
        "type": "RX",
        "ingredient": "ASPIRIN, BUTALBITAL, CAFFEINE AND CODEINE PHOSPHATE",
        "trade_name": "BUTALBITAL, ASPIRIN, CAFFEINE, AND CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "75231-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 317,
        "type": "RX",
        "ingredient": "ASPIRIN, BUTALBITAL, CAFFEINE AND CODEINE PHOSPHATE",
        "trade_name": "FIORINAL W/CODEINE",
        "forms": [
            {
                "orange_id": "19429-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "325MG-50MG-40MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 318,
        "type": "RX",
        "ingredient": "ASPIRIN, CAFFEINE AND ORPHENADRINE CITRATE",
        "trade_name": "ORPHENGESIC FORTE",
        "forms": [
            {
                "orange_id": "75141-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "770MG-60MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 319,
        "type": "RX",
        "ingredient": "ASPIRIN, CARISOPRODOL AND CODEINE PHOSPHATE",
        "trade_name": "CARISOPRODOL, ASPIRIN AND CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "40860-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-200MG-16MG"
                ]
            }
        ]
    },
    {
        "id": 320,
        "type": "RX",
        "ingredient": "ASPIRIN AND DIPYRIDAMOLE",
        "trade_name": "AGGRENOX",
        "forms": [
            {
                "orange_id": "20884-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 321,
        "type": "RX",
        "ingredient": "ASPIRIN AND DIPYRIDAMOLE",
        "trade_name": "ASPIRIN AND DIPYRIDAMOLE",
        "forms": [
            {
                "orange_id": "206392-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 322,
        "type": "RX",
        "ingredient": "ASPIRIN AND OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXYCODONE AND ASPIRIN",
        "forms": [
            {
                "orange_id": "40910-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-4.8355MG"
                ]
            }
        ]
    },
    {
        "id": 323,
        "type": "RX",
        "ingredient": "ASPIRIN AND OXYCODONE HYDROCHLORIDE",
        "trade_name": "PERCODAN",
        "forms": [
            {
                "orange_id": "7337-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "325MG-4.8355MG"
                ]
            }
        ]
    },
    {
        "id": 324,
        "type": "RX",
        "ingredient": "ATAZANAVIR SULFATE",
        "trade_name": "ATAZANAVIR SULFATE",
        "forms": [
            {
                "orange_id": "209717-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 325,
        "type": "RX",
        "ingredient": "ATAZANAVIR SULFATE",
        "trade_name": "REYATAZ",
        "forms": [
            {
                "orange_id": "21567-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE"
                ]
            },
            {
                "orange_id": "206352-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 326,
        "type": "RX",
        "ingredient": "ATAZANAVIR SULFATE AND COBICISTAT",
        "trade_name": "EVOTAZ",
        "forms": [
            {
                "orange_id": "206353-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE-150MG"
                ]
            }
        ]
    },
    {
        "id": 327,
        "type": "RX",
        "ingredient": "ATENOLOL",
        "trade_name": "ATENOLOL",
        "forms": [
            {
                "orange_id": "72304-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 328,
        "type": "RX",
        "ingredient": "ATENOLOL",
        "trade_name": "TENORMIN",
        "forms": [
            {
                "orange_id": "18240-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 329,
        "type": "RX",
        "ingredient": "ATENOLOL AND CHLORTHALIDONE",
        "trade_name": "ATENOLOL AND CHLORTHALIDONE",
        "forms": [
            {
                "orange_id": "72302-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-25MG",
                    "100MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 330,
        "type": "RX",
        "ingredient": "ATENOLOL AND CHLORTHALIDONE",
        "trade_name": "TENORETIC 100",
        "forms": [
            {
                "orange_id": "18760-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 331,
        "type": "RX",
        "ingredient": "ATENOLOL AND CHLORTHALIDONE",
        "trade_name": "TENORETIC 50",
        "forms": [
            {
                "orange_id": "18760-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 332,
        "type": "RX",
        "ingredient": "ATOGEPANT",
        "trade_name": "QULIPTA",
        "forms": [
            {
                "orange_id": "215206-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "30MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 333,
        "type": "RX",
        "ingredient": "ATOMOXETINE HYDROCHLORIDE",
        "trade_name": "ATOMOXETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78983-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "18MG",
                    "25MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 334,
        "type": "RX",
        "ingredient": "ATOMOXETINE HYDROCHLORIDE",
        "trade_name": "STRATTERA",
        "forms": [
            {
                "orange_id": "21411-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "18MG",
                    "25MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 335,
        "type": "RX",
        "ingredient": "ATORVASTATIN CALCIUM",
        "trade_name": "ATORVASTATIN CALCIUM",
        "forms": [
            {
                "orange_id": "207687-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 80MG BASE ",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 336,
        "type": "RX",
        "ingredient": "ATORVASTATIN CALCIUM",
        "trade_name": "LIPITOR",
        "forms": [
            {
                "orange_id": "20702-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 337,
        "type": "RX",
        "ingredient": "ATOVAQUONE",
        "trade_name": "ATOVAQUONE",
        "forms": [
            {
                "orange_id": "210510-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "750MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 338,
        "type": "RX",
        "ingredient": "ATOVAQUONE",
        "trade_name": "MEPRON",
        "forms": [
            {
                "orange_id": "20500-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "750MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 339,
        "type": "RX",
        "ingredient": "ATOVAQUONE AND PROGUANIL HYDROCHLORIDE",
        "trade_name": "ATOVAQUONE AND PROGUANIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91211-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "62.5MG-25MG",
                    "250MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 340,
        "type": "RX",
        "ingredient": "ATOVAQUONE AND PROGUANIL HYDROCHLORIDE",
        "trade_name": "MALARONE",
        "forms": [
            {
                "orange_id": "21078-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 341,
        "type": "RX",
        "ingredient": "ATOVAQUONE AND PROGUANIL HYDROCHLORIDE",
        "trade_name": "MALARONE PEDIATRIC",
        "forms": [
            {
                "orange_id": "21078-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "62.5MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 342,
        "type": "RX",
        "ingredient": "ATRACURIUM BESYLATE",
        "trade_name": "ATRACURIUM BESYLATE",
        "forms": [
            {
                "orange_id": "206011-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 343,
        "type": "RX",
        "ingredient": "ATRACURIUM BESYLATE",
        "trade_name": "ATRACURIUM BESYLATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "206010-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 344,
        "type": "RX",
        "ingredient": "ATROPINE",
        "trade_name": "ATROPEN",
        "forms": [
            {
                "orange_id": "17106-4",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 0.25MG SULFATE/0.3ML",
                    "EQ 0.5MG SULFATE/0.7ML",
                    "EQ 1MG SULFATE/0.7ML",
                    "EQ 2MG SULFATE/0.7ML"
                ]
            }
        ]
    },
    {
        "id": 345,
        "type": "RX",
        "ingredient": "ATROPINE SULFATE",
        "trade_name": "ATROPINE SULFATE",
        "forms": [
            {
                "orange_id": "206289-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "212868-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.25MG/5ML (0.05MG/ML)",
                    "0.4MG/ML (0.4MG/ML)",
                    "0.5MG/5ML (0.1MG/ML)",
                    "1MG/10ML (0.1MG/ML)",
                    "1MG/ML (1MG/ML)"
                ]
            },
            {
                "orange_id": "213424-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS, INTRAMUSCULAR, SUBCUTANEOUS, INTRAOSSEOUS, ENDOTRACHEAL",
                "dosage": [
                    "8MG/20ML (0.4MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 346,
        "type": "RX",
        "ingredient": "ATROPINE SULFATE",
        "trade_name": "ISOPTO ATROPINE",
        "forms": [
            {
                "orange_id": "208151-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 347,
        "type": "RX",
        "ingredient": "ATROPINE SULFATE AND DIFENOXIN HYDROCHLORIDE",
        "trade_name": "MOTOFEN",
        "forms": [
            {
                "orange_id": "17744-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 348,
        "type": "RX",
        "ingredient": "ATROPINE SULFATE AND DIPHENOXYLATE HYDROCHLORIDE",
        "trade_name": "DIPHENOXYLATE HYDROCHLORIDE AND ATROPINE SULFATE",
        "forms": [
            {
                "orange_id": "87708-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.025MG/5ML-2.5MG/5ML"
                ]
            },
            {
                "orange_id": "86727-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 349,
        "type": "RX",
        "ingredient": "ATROPINE SULFATE AND DIPHENOXYLATE HYDROCHLORIDE",
        "trade_name": "LOMOTIL",
        "forms": [
            {
                "orange_id": "12462-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 350,
        "type": "RX",
        "ingredient": "ATROPINE AND PRALIDOXIME CHLORIDE",
        "trade_name": "DUODOTE",
        "forms": [
            {
                "orange_id": "21983-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "2.1MG/0.7ML-600MG/2ML"
                ]
            }
        ]
    },
    {
        "id": 351,
        "type": "RX",
        "ingredient": "AURANOFIN",
        "trade_name": "RIDAURA",
        "forms": [
            {
                "orange_id": "18689-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 352,
        "type": "RX",
        "ingredient": "AVACOPAN",
        "trade_name": "TAVNEOS",
        "forms": [
            {
                "orange_id": "214487-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 353,
        "type": "RX",
        "ingredient": "AVANAFIL",
        "trade_name": "STENDRA",
        "forms": [
            {
                "orange_id": "202276-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 354,
        "type": "RX",
        "ingredient": "AVAPRITINIB",
        "trade_name": "AYVAKIT",
        "forms": [
            {
                "orange_id": "212608-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 355,
        "type": "RX",
        "ingredient": "AVATROMBOPAG MALEATE",
        "trade_name": "DOPTELET",
        "forms": [
            {
                "orange_id": "210238-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 356,
        "type": "RX",
        "ingredient": "AVIBACTAM SODIUM AND CEFTAZIDIME",
        "trade_name": "AVYCAZ",
        "forms": [
            {
                "orange_id": "206494-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.5GM BASE-2GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 357,
        "type": "OTC",
        "ingredient": "AVOBENZONE, ECAMSULE AND OCTOCRYLENE",
        "trade_name": "ANTHELIOS SX",
        "forms": [
            {
                "orange_id": "21502-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%-2%-10%"
                ]
            }
        ]
    },
    {
        "id": 358,
        "type": "OTC",
        "ingredient": "AVOBENZONE, ECAMSULE AND OCTOCRYLENE",
        "trade_name": "CAPITAL SOLEIL 15",
        "forms": [
            {
                "orange_id": "21501-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%-3%-10%"
                ]
            }
        ]
    },
    {
        "id": 359,
        "type": "OTC",
        "ingredient": "AVOBENZONE, ECAMSULE, OCTOCRYLENE AND TITANIUM DIOXIDE",
        "trade_name": "ANTHELIOS 20",
        "forms": [
            {
                "orange_id": "21471-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%-2%-10%-2%"
                ]
            }
        ]
    },
    {
        "id": 360,
        "type": "OTC",
        "ingredient": "AVOBENZONE, ECAMSULE, OCTOCRYLENE AND TITANIUM DIOXIDE",
        "trade_name": "ANTHELIOS 40",
        "forms": [
            {
                "orange_id": "22009-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%-3%-10%-5%"
                ]
            }
        ]
    },
    {
        "id": 361,
        "type": "RX",
        "ingredient": "AXITINIB",
        "trade_name": "INLYTA",
        "forms": [
            {
                "orange_id": "202324-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 362,
        "type": "RX",
        "ingredient": "AZACITIDINE",
        "trade_name": "AZACITIDINE",
        "forms": [
            {
                "orange_id": "207475-1",
                "form": "POWDER",
                "route": "INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 363,
        "type": "RX",
        "ingredient": "AZACITIDINE",
        "trade_name": "ONUREG",
        "forms": [
            {
                "orange_id": "214120-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 364,
        "type": "RX",
        "ingredient": "AZACITIDINE",
        "trade_name": "VIDAZA",
        "forms": [
            {
                "orange_id": "50794-1",
                "form": "POWDER",
                "route": "INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 365,
        "type": "RX",
        "ingredient": "AZATHIOPRINE",
        "trade_name": "AZASAN",
        "forms": [
            {
                "orange_id": "75252-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 366,
        "type": "RX",
        "ingredient": "AZATHIOPRINE",
        "trade_name": "AZATHIOPRINE",
        "forms": [
            {
                "orange_id": "208687-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 367,
        "type": "RX",
        "ingredient": "AZATHIOPRINE",
        "trade_name": "IMURAN",
        "forms": [
            {
                "orange_id": "16324-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 368,
        "type": "RX",
        "ingredient": "AZATHIOPRINE SODIUM",
        "trade_name": "AZATHIOPRINE SODIUM",
        "forms": [
            {
                "orange_id": "74419-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 369,
        "type": "RX",
        "ingredient": "AZELAIC ACID",
        "trade_name": "AZELAIC ACID",
        "forms": [
            {
                "orange_id": "208011-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "15%"
                ]
            }
        ]
    },
    {
        "id": 370,
        "type": "RX",
        "ingredient": "AZELAIC ACID",
        "trade_name": "AZELEX",
        "forms": [
            {
                "orange_id": "20428-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 371,
        "type": "RX",
        "ingredient": "AZELAIC ACID",
        "trade_name": "FINACEA",
        "forms": [
            {
                "orange_id": "207071-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "15%"
                ]
            },
            {
                "orange_id": "21470-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "15%"
                ]
            }
        ]
    },
    {
        "id": 372,
        "type": "OTC",
        "ingredient": "AZELASTINE HYDROCHLORIDE",
        "trade_name": "ASTEPRO ALLERGY",
        "forms": [
            {
                "orange_id": "213872-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.2055MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 373,
        "type": "RX",
        "ingredient": "AZELASTINE HYDROCHLORIDE",
        "trade_name": "AZELASTINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "203660-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "207610-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.137MG/SPRAY",
                    "0.2055MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 374,
        "type": "OTC",
        "ingredient": "AZELASTINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ASTEPRO ALLERGY",
        "forms": [
            {
                "orange_id": "213872-2",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.2055MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 375,
        "type": "RX",
        "ingredient": "AZELASTINE HYDROCHLORIDE AND FLUTICASONE PROPIONATE",
        "trade_name": "AZELASTINE HYDROCHLORIDE AND FLUTICASONE PROPIONATE",
        "forms": [
            {
                "orange_id": "207712-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.137MG/SPRAY-0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 376,
        "type": "RX",
        "ingredient": "AZELASTINE HYDROCHLORIDE AND FLUTICASONE PROPIONATE",
        "trade_name": "DYMISTA",
        "forms": [
            {
                "orange_id": "202236-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.137MG/SPRAY-0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 377,
        "type": "RX",
        "ingredient": "AZILSARTAN KAMEDOXOMIL",
        "trade_name": "EDARBI",
        "forms": [
            {
                "orange_id": "200796-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG MEDOXOMIL",
                    "EQ 80MG MEDOXOMIL"
                ]
            }
        ]
    },
    {
        "id": 378,
        "type": "RX",
        "ingredient": "AZILSARTAN KAMEDOXOMIL AND CHLORTHALIDONE",
        "trade_name": "EDARBYCLOR",
        "forms": [
            {
                "orange_id": "202331-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG MEDOXOMIL-12.5MG",
                    "EQ 40MG MEDOXOMIL-25MG"
                ]
            }
        ]
    },
    {
        "id": 379,
        "type": "RX",
        "ingredient": "AZITHROMYCIN",
        "trade_name": "AZASITE",
        "forms": [
            {
                "orange_id": "50810-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 380,
        "type": "RX",
        "ingredient": "AZITHROMYCIN",
        "trade_name": "AZITHROMYCIN",
        "forms": [
            {
                "orange_id": "205666-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE/5ML",
                    "EQ 200MG BASE/5ML"
                ]
            },
            {
                "orange_id": "203294-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "211791-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE",
                    "EQ 600MG BASE"
                ]
            }
        ]
    },
    {
        "id": 381,
        "type": "RX",
        "ingredient": "AZITHROMYCIN",
        "trade_name": "ZITHROMAX",
        "forms": [
            {
                "orange_id": "50693-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE/PACKET",
                    "EQ 100MG BASE/5ML",
                    "EQ 200MG BASE/5ML"
                ]
            },
            {
                "orange_id": "50733-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "50711-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 382,
        "type": "RX",
        "ingredient": "AZTREONAM",
        "trade_name": "AZACTAM",
        "forms": [
            {
                "orange_id": "50580-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 383,
        "type": "RX",
        "ingredient": "AZTREONAM",
        "trade_name": "AZTREONAM",
        "forms": [
            {
                "orange_id": "65439-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 384,
        "type": "RX",
        "ingredient": "AZTREONAM",
        "trade_name": "CAYSTON",
        "forms": [
            {
                "orange_id": "50814-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "75MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 385,
        "type": "RX",
        "ingredient": "BACITRACIN",
        "trade_name": "BACITRACIN",
        "forms": [
            {
                "orange_id": "61212-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "500 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 386,
        "type": "RX",
        "ingredient": "BACITRACIN ZINC, HYDROCORTISONE ACETATE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "BACITRACIN-NEOMYCIN-POLYMYXIN W/ HYDROCORTISONE ACETATE",
        "forms": [
            {
                "orange_id": "62166-2",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "400 UNITS/GM-1%-EQ 3.5MG BASE/GM-10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 387,
        "type": "RX",
        "ingredient": "BACITRACIN ZINC, HYDROCORTISONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATES, BACITRACIN ZINC AND HYDROCORTISONE",
        "forms": [
            {
                "orange_id": "65213-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "400 UNITS/GM-1%-EQ 3.5MG BASE/GM-10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 388,
        "type": "RX",
        "ingredient": "BACITRACIN ZINC, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "LUMI-SPORYN",
        "forms": [
            {
                "orange_id": "50417-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 400 UNITS/GM-EQ 3.5MG BASE/GM-EQ 10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 389,
        "type": "RX",
        "ingredient": "BACITRACIN ZINC, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATES AND BACITRACIN ZINC",
        "forms": [
            {
                "orange_id": "65088-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "400 UNITS/GM-EQ 3.5MG BASE/GM-10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 390,
        "type": "RX",
        "ingredient": "BACITRACIN ZINC AND POLYMYXIN B SULFATE",
        "trade_name": "BACITRACIN ZINC AND POLYMYXIN B SULFATE",
        "forms": [
            {
                "orange_id": "64028-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "500 UNITS/GM-10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 391,
        "type": "RX",
        "ingredient": "BACLOFEN",
        "trade_name": "BACLOFEN",
        "forms": [
            {
                "orange_id": "91193-1",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "0.05MG/ML",
                    "0.5MG/ML",
                    "2MG/ML",
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "214099-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 392,
        "type": "RX",
        "ingredient": "BACLOFEN",
        "trade_name": "GABLOFEN",
        "forms": [
            {
                "orange_id": "22462-1",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "0.05MG/ML",
                    "0.5MG/ML",
                    "1MG/ML",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 393,
        "type": "RX",
        "ingredient": "BACLOFEN",
        "trade_name": "LIORESAL",
        "forms": [
            {
                "orange_id": "20075-3",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "0.05MG/ML",
                    "0.5MG/ML",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 394,
        "type": "RX",
        "ingredient": "BACLOFEN",
        "trade_name": "LYVISPAH",
        "forms": [
            {
                "orange_id": "215422-1",
                "form": "GRANULES",
                "route": "ORAL",
                "dosage": [
                    "5MG/PACKET",
                    "10MG/PACKET",
                    "20MG/PACKET"
                ]
            }
        ]
    },
    {
        "id": 395,
        "type": "RX",
        "ingredient": "BACLOFEN",
        "trade_name": "OZOBAX",
        "forms": [
            {
                "orange_id": "208193-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 396,
        "type": "RX",
        "ingredient": "BALOXAVIR MARBOXIL",
        "trade_name": "XOFLUZA",
        "forms": [
            {
                "orange_id": "214410-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2MG/ML"
                ]
            },
            {
                "orange_id": "210854-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 397,
        "type": "RX",
        "ingredient": "BALSALAZIDE DISODIUM",
        "trade_name": "BALSALAZIDE DISODIUM",
        "forms": [
            {
                "orange_id": "77883-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 398,
        "type": "RX",
        "ingredient": "BALSALAZIDE DISODIUM",
        "trade_name": "COLAZAL",
        "forms": [
            {
                "orange_id": "20610-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 399,
        "type": "RX",
        "ingredient": "BARICITINIB",
        "trade_name": "OLUMIANT",
        "forms": [
            {
                "orange_id": "207924-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 400,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "ENTERO VU 24%",
        "forms": [
            {
                "orange_id": "208143-8",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "24% (144GM/600ML)"
                ]
            }
        ]
    },
    {
        "id": 401,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "E-Z-HD",
        "forms": [
            {
                "orange_id": "208036-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "98% (334GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 402,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "E-Z-PAQUE",
        "forms": [
            {
                "orange_id": "208036-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "96% (169GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 403,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "LIQUID E-Z-PAQUE",
        "forms": [
            {
                "orange_id": "208143-3",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "60% (213GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 404,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "READI-CAT 2",
        "forms": [
            {
                "orange_id": "208143-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2% (9GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 405,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "READI-CAT 2 SMOOTHIE",
        "forms": [
            {
                "orange_id": "208143-2",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2% (9GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 406,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "TAGITOL V",
        "forms": [
            {
                "orange_id": "208143-5",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40% (8GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 407,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "VARIBAR HONEY",
        "forms": [
            {
                "orange_id": "208143-7",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40% (100GM/250ML)"
                ]
            }
        ]
    },
    {
        "id": 408,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "VARIBAR NECTAR",
        "forms": [
            {
                "orange_id": "208143-4",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40% (96GM/240ML)"
                ]
            }
        ]
    },
    {
        "id": 409,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "VARIBAR PUDDING",
        "forms": [
            {
                "orange_id": "208844-1",
                "form": "PASTE",
                "route": "ORAL",
                "dosage": [
                    "40%"
                ]
            }
        ]
    },
    {
        "id": 410,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "VARIBAR THIN HONEY",
        "forms": [
            {
                "orange_id": "208143-6",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40% (100GM/250ML)"
                ]
            }
        ]
    },
    {
        "id": 411,
        "type": "RX",
        "ingredient": "BARIUM SULFATE",
        "trade_name": "VARIBAR THIN LIQUID",
        "forms": [
            {
                "orange_id": "208036-4",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "81% (120GM/BOT)"
                ]
            }
        ]
    },
    {
        "id": 412,
        "type": "RX",
        "ingredient": "BAZEDOXIFENE ACETATE AND ESTROGENS, CONJUGATED",
        "trade_name": "DUAVEE",
        "forms": [
            {
                "orange_id": "22247-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE-0.45MG"
                ]
            }
        ]
    },
    {
        "id": 413,
        "type": "RX",
        "ingredient": "BECLOMETHASONE DIPROPIONATE",
        "trade_name": "QNASL",
        "forms": [
            {
                "orange_id": "202813-2",
                "form": "AEROSOL, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.04MG/ACTUATION",
                    "0.08MG/ACTUATION"
                ]
            }
        ]
    },
    {
        "id": 414,
        "type": "RX",
        "ingredient": "BECLOMETHASONE DIPROPIONATE",
        "trade_name": "QVAR REDIHALER",
        "forms": [
            {
                "orange_id": "207921-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.04MG/INH",
                    "0.08MG/INH"
                ]
            }
        ]
    },
    {
        "id": 415,
        "type": "RX",
        "ingredient": "BECLOMETHASONE DIPROPIONATE MONOHYDRATE",
        "trade_name": "BECONASE AQ",
        "forms": [
            {
                "orange_id": "19389-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "EQ 0.042MG DIPROP/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 416,
        "type": "RX",
        "ingredient": "BEDAQUILINE FUMARATE",
        "trade_name": "SIRTURO",
        "forms": [
            {
                "orange_id": "204384-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 417,
        "type": "RX",
        "ingredient": "BELINOSTAT",
        "trade_name": "BELEODAQ",
        "forms": [
            {
                "orange_id": "206256-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 418,
        "type": "RX",
        "ingredient": "BELUMOSUDIL MESYLATE",
        "trade_name": "REZUROCK",
        "forms": [
            {
                "orange_id": "214783-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 419,
        "type": "RX",
        "ingredient": "BELZUTIFAN",
        "trade_name": "WELIREG",
        "forms": [
            {
                "orange_id": "215383-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 420,
        "type": "RX",
        "ingredient": "BEMPEDOIC ACID",
        "trade_name": "NEXLETOL",
        "forms": [
            {
                "orange_id": "211616-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 421,
        "type": "RX",
        "ingredient": "BEMPEDOIC ACID AND EZETIMIBE",
        "trade_name": "NEXLIZET",
        "forms": [
            {
                "orange_id": "211617-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "180MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 422,
        "type": "RX",
        "ingredient": "BENAZEPRIL HYDROCHLORIDE",
        "trade_name": "BENAZEPRIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76820-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 423,
        "type": "RX",
        "ingredient": "BENAZEPRIL HYDROCHLORIDE",
        "trade_name": "LOTENSIN",
        "forms": [
            {
                "orange_id": "19851-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 424,
        "type": "RX",
        "ingredient": "BENAZEPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "BENAZEPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "76631-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-6.25MG",
                    "10MG-12.5MG",
                    "20MG-12.5MG",
                    "20MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 425,
        "type": "RX",
        "ingredient": "BENAZEPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "LOTENSIN HCT",
        "forms": [
            {
                "orange_id": "20033-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-12.5MG",
                    "20MG-12.5MG",
                    "20MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 426,
        "type": "RX",
        "ingredient": "BENDAMUSTINE HYDROCHLORIDE",
        "trade_name": "BELRAPZO",
        "forms": [
            {
                "orange_id": "205580-1",
                "form": "SOLUTION",
                "route": "IV (INFUSION)",
                "dosage": [
                    "100MG/4ML (25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 427,
        "type": "RX",
        "ingredient": "BENDAMUSTINE HYDROCHLORIDE",
        "trade_name": "BENDEKA",
        "forms": [
            {
                "orange_id": "208194-1",
                "form": "SOLUTION",
                "route": "IV (INFUSION)",
                "dosage": [
                    "100MG/4ML (25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 428,
        "type": "RX",
        "ingredient": "BENDAMUSTINE HYDROCHLORIDE",
        "trade_name": "TREANDA",
        "forms": [
            {
                "orange_id": "22249-2",
                "form": "POWDER",
                "route": "IV (INFUSION)",
                "dosage": [
                    "25MG/VIAL",
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 429,
        "type": "RX",
        "ingredient": "BENOXINATE HYDROCHLORIDE AND FLUORESCEIN SODIUM",
        "trade_name": "ALTAFLUOR BENOX",
        "forms": [
            {
                "orange_id": "208582-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.4%-0.25%"
                ]
            }
        ]
    },
    {
        "id": 430,
        "type": "RX",
        "ingredient": "BENOXINATE HYDROCHLORIDE AND FLUORESCEIN SODIUM",
        "trade_name": "FLUORESCEIN SODIUM AND BENOXINATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "211039-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.4%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 431,
        "type": "OTC",
        "ingredient": "BENTOQUATAM",
        "trade_name": "IVY BLOCK",
        "forms": [
            {
                "orange_id": "20532-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 432,
        "type": "RX",
        "ingredient": "BENZNIDAZOLE",
        "trade_name": "BENZNIDAZOLE",
        "forms": [
            {
                "orange_id": "209570-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 433,
        "type": "RX",
        "ingredient": "BENZONATATE",
        "trade_name": "BENZONATATE",
        "forms": [
            {
                "orange_id": "91310-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 434,
        "type": "RX",
        "ingredient": "BENZONATATE",
        "trade_name": "TESSALON",
        "forms": [
            {
                "orange_id": "11210-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 435,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
        "trade_name": "ACANYA",
        "forms": [
            {
                "orange_id": "50819-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%-EQ 1.2% BASE"
                ]
            }
        ]
    },
    {
        "id": 436,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
        "trade_name": "BENZACLIN",
        "forms": [
            {
                "orange_id": "50756-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "5%-EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 437,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAMYCIN PHOSPHATE AND BENZOYL PEROXIDE",
        "forms": [
            {
                "orange_id": "205128-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%-EQ 1.2% BASE",
                    "5%-1.2%",
                    "5%-EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 438,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
        "trade_name": "DUAC",
        "forms": [
            {
                "orange_id": "50741-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "5%-1.2%"
                ]
            }
        ]
    },
    {
        "id": 439,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND CLINDAMYCIN PHOSPHATE",
        "trade_name": "ONEXTON",
        "forms": [
            {
                "orange_id": "50819-2",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "3.75%-EQ 1.2% BASE"
                ]
            }
        ]
    },
    {
        "id": 440,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND ERYTHROMYCIN",
        "trade_name": "BENZAMYCIN",
        "forms": [
            {
                "orange_id": "50557-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "5%-3%"
                ]
            }
        ]
    },
    {
        "id": 441,
        "type": "RX",
        "ingredient": "BENZOYL PEROXIDE AND ERYTHROMYCIN",
        "trade_name": "ERYTHROMYCIN AND BENZOYL PEROXIDE",
        "forms": [
            {
                "orange_id": "65385-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "5%-3%"
                ]
            }
        ]
    },
    {
        "id": 442,
        "type": "RX",
        "ingredient": "BENZPHETAMINE HYDROCHLORIDE",
        "trade_name": "BENZPHETAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90473-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 443,
        "type": "RX",
        "ingredient": "BENZTROPINE MESYLATE",
        "trade_name": "BENZTROPINE MESYLATE",
        "forms": [
            {
                "orange_id": "90233-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "204713-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 444,
        "type": "RX",
        "ingredient": "BENZTROPINE MESYLATE",
        "trade_name": "COGENTIN",
        "forms": [
            {
                "orange_id": "12015-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 445,
        "type": "RX",
        "ingredient": "BEPOTASTINE BESILATE",
        "trade_name": "BEPOTASTINE BESILATE",
        "forms": [
            {
                "orange_id": "206066-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1.5%"
                ]
            }
        ]
    },
    {
        "id": 446,
        "type": "RX",
        "ingredient": "BEPOTASTINE BESILATE",
        "trade_name": "BEPREVE",
        "forms": [
            {
                "orange_id": "22288-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1.5%"
                ]
            }
        ]
    },
    {
        "id": 447,
        "type": "RX",
        "ingredient": "BEROTRALSTAT HYDROCHLORIDE",
        "trade_name": "ORLADEYO",
        "forms": [
            {
                "orange_id": "214094-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 110MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 448,
        "type": "RX",
        "ingredient": "BESIFLOXACIN HYDROCHLORIDE",
        "trade_name": "BESIVANCE",
        "forms": [
            {
                "orange_id": "22308-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.6% BASE"
                ]
            }
        ]
    },
    {
        "id": 449,
        "type": "RX",
        "ingredient": "BETAINE",
        "trade_name": "BETAINE",
        "forms": [
            {
                "orange_id": "210508-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 450,
        "type": "RX",
        "ingredient": "BETAINE",
        "trade_name": "CYSTADANE",
        "forms": [
            {
                "orange_id": "20576-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 451,
        "type": "RX",
        "ingredient": "BETAMETHASONE ACETATE AND BETAMETHASONE SODIUM PHOSPHATE",
        "trade_name": "BETAMETHASONE ACETATE AND BETAMETHASONE SODIUM PHOSPHATE",
        "forms": [
            {
                "orange_id": "90747-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3MG/ML-EQ 3MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 452,
        "type": "RX",
        "ingredient": "BETAMETHASONE ACETATE AND BETAMETHASONE SODIUM PHOSPHATE",
        "trade_name": "CELESTONE SOLUSPAN",
        "forms": [
            {
                "orange_id": "14602-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3MG/ML-EQ 3MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 453,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE",
        "trade_name": "BETAMETHASONE DIPROPIONATE",
        "forms": [
            {
                "orange_id": "76215-1",
                "form": "CREAM, AUGMENTED",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "70885-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "75276-1",
                "form": "GEL, AUGMENTED",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "208849-1",
                "form": "LOTION, AUGMENTED",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "209896-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "74304-1",
                "form": "OINTMENT, AUGMENTED",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            },
            {
                "orange_id": "71012-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            }
        ]
    },
    {
        "id": 454,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE",
        "trade_name": "DIPROLENE",
        "forms": [
            {
                "orange_id": "18741-1",
                "form": "OINTMENT, AUGMENTED",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE"
                ]
            }
        ]
    },
    {
        "id": 455,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE",
        "trade_name": "SERNIVO",
        "forms": [
            {
                "orange_id": "208079-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 456,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CALCIPOTRIENE",
        "trade_name": "CALCIPOTRIENE AND BETAMETHASONE DIPROPIONATE",
        "forms": [
            {
                "orange_id": "200174-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            },
            {
                "orange_id": "213269-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            }
        ]
    },
    {
        "id": 457,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CALCIPOTRIENE",
        "trade_name": "CALCIPOTRIENE AND BETHAMETHASONE DIPROPIONATE",
        "forms": [
            {
                "orange_id": "212367-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            }
        ]
    },
    {
        "id": 458,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CALCIPOTRIENE",
        "trade_name": "ENSTILAR",
        "forms": [
            {
                "orange_id": "207589-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            }
        ]
    },
    {
        "id": 459,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CALCIPOTRIENE",
        "trade_name": "TACLONEX",
        "forms": [
            {
                "orange_id": "21852-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            },
            {
                "orange_id": "22185-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            }
        ]
    },
    {
        "id": 460,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CALCIPOTRIENE",
        "trade_name": "WYNZORA",
        "forms": [
            {
                "orange_id": "213422-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.064%-0.005%"
                ]
            }
        ]
    },
    {
        "id": 461,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CLOTRIMAZOLE",
        "trade_name": "CLOTRIMAZOLE AND BETAMETHASONE DIPROPIONATE",
        "forms": [
            {
                "orange_id": "76002-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE-1%"
                ]
            },
            {
                "orange_id": "76516-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE-1%"
                ]
            }
        ]
    },
    {
        "id": 462,
        "type": "RX",
        "ingredient": "BETAMETHASONE DIPROPIONATE AND CLOTRIMAZOLE",
        "trade_name": "LOTRISONE",
        "forms": [
            {
                "orange_id": "18827-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.05% BASE-1%"
                ]
            }
        ]
    },
    {
        "id": 463,
        "type": "RX",
        "ingredient": "BETAMETHASONE VALERATE",
        "trade_name": "BETAMETHASONE VALERATE",
        "forms": [
            {
                "orange_id": "78337-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.12%"
                ]
            },
            {
                "orange_id": "18861-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            },
            {
                "orange_id": "70052-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            },
            {
                "orange_id": "70051-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 464,
        "type": "RX",
        "ingredient": "BETAMETHASONE VALERATE",
        "trade_name": "BETA-VAL",
        "forms": [
            {
                "orange_id": "18642-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            },
            {
                "orange_id": "70069-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 465,
        "type": "RX",
        "ingredient": "BETAMETHASONE VALERATE",
        "trade_name": "DERMABET",
        "forms": [
            {
                "orange_id": "72041-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 466,
        "type": "RX",
        "ingredient": "BETAMETHASONE VALERATE",
        "trade_name": "LUXIQ",
        "forms": [
            {
                "orange_id": "20934-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.12%"
                ]
            }
        ]
    },
    {
        "id": 467,
        "type": "RX",
        "ingredient": "BETAMETHASONE VALERATE",
        "trade_name": "VALNAC",
        "forms": [
            {
                "orange_id": "70050-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 468,
        "type": "RX",
        "ingredient": "BETAXOLOL HYDROCHLORIDE",
        "trade_name": "BETAXOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78694-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            },
            {
                "orange_id": "75541-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 469,
        "type": "RX",
        "ingredient": "BETAXOLOL HYDROCHLORIDE",
        "trade_name": "BETOPTIC",
        "forms": [
            {
                "orange_id": "19270-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 470,
        "type": "RX",
        "ingredient": "BETAXOLOL HYDROCHLORIDE",
        "trade_name": "BETOPTIC S",
        "forms": [
            {
                "orange_id": "19845-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE"
                ]
            }
        ]
    },
    {
        "id": 471,
        "type": "RX",
        "ingredient": "BETHANECHOL CHLORIDE",
        "trade_name": "BETHANECHOL CHLORIDE",
        "forms": [
            {
                "orange_id": "40855-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 472,
        "type": "RX",
        "ingredient": "BETHANECHOL CHLORIDE",
        "trade_name": "DUVOID",
        "forms": [
            {
                "orange_id": "86262-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 473,
        "type": "RX",
        "ingredient": "BEXAROTENE",
        "trade_name": "BEXAROTENE",
        "forms": [
            {
                "orange_id": "210105-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 474,
        "type": "RX",
        "ingredient": "BEXAROTENE",
        "trade_name": "TARGRETIN",
        "forms": [
            {
                "orange_id": "21055-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            },
            {
                "orange_id": "21056-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 475,
        "type": "RX",
        "ingredient": "BICALUTAMIDE",
        "trade_name": "BICALUTAMIDE",
        "forms": [
            {
                "orange_id": "78917-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 476,
        "type": "RX",
        "ingredient": "BICALUTAMIDE",
        "trade_name": "CASODEX",
        "forms": [
            {
                "orange_id": "20498-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 477,
        "type": "RX",
        "ingredient": "BICTEGRAVIR SODIUM, EMTRICITABINE AND TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "BIKTARVY",
        "forms": [
            {
                "orange_id": "210251-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE-120MG-EQ 15MG BASE",
                    "EQ 50MG BASE-200MG-EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 478,
        "type": "RX",
        "ingredient": "BIMATOPROST",
        "trade_name": "BIMATOPROST",
        "forms": [
            {
                "orange_id": "210263-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.03%"
                ]
            },
            {
                "orange_id": "203051-1",
                "form": "SOLUTION/DROPS",
                "route": "TOPICAL",
                "dosage": [
                    "0.03%"
                ]
            }
        ]
    },
    {
        "id": 479,
        "type": "RX",
        "ingredient": "BIMATOPROST",
        "trade_name": "DURYSTA",
        "forms": [
            {
                "orange_id": "211911-1",
                "form": "IMPLANT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10MCG"
                ]
            }
        ]
    },
    {
        "id": 480,
        "type": "RX",
        "ingredient": "BIMATOPROST",
        "trade_name": "LATISSE",
        "forms": [
            {
                "orange_id": "22369-1",
                "form": "SOLUTION/DROPS",
                "route": "TOPICAL",
                "dosage": [
                    "0.03%"
                ]
            }
        ]
    },
    {
        "id": 481,
        "type": "RX",
        "ingredient": "BIMATOPROST",
        "trade_name": "LUMIGAN",
        "forms": [
            {
                "orange_id": "22184-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 482,
        "type": "RX",
        "ingredient": "BINIMETINIB",
        "trade_name": "MEKTOVI",
        "forms": [
            {
                "orange_id": "210498-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 483,
        "type": "RX",
        "ingredient": "BISMUTH SUBCITRATE POTASSIUM, METRONIDAZOLE AND TETRACYCLINE HYDROCHLORIDE",
        "trade_name": "PYLERA",
        "forms": [
            {
                "orange_id": "50786-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "140MG-125MG-125MG"
                ]
            }
        ]
    },
    {
        "id": 484,
        "type": "RX",
        "ingredient": "BISMUTH SUBSALICYLATE, METRONIDAZOLE AND TETRACYCLINE HYDROCHLORIDE",
        "trade_name": "BISMUTH SUBSALICYLATE, METRONIDAZOLE AND TETRACYCLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202584-1",
                "form": "TABLET, CHEWABLE, TABLET, CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "262.4MG, N/A, N/A-N/A, 250MG, N/A-N/A, N/A, 500MG"
                ]
            }
        ]
    },
    {
        "id": 485,
        "type": "RX",
        "ingredient": "BISOPROLOL FUMARATE",
        "trade_name": "BISOPROLOL FUMARATE",
        "forms": [
            {
                "orange_id": "204891-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 486,
        "type": "RX",
        "ingredient": "BISOPROLOL FUMARATE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "BISOPROLOL FUMARATE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "212678-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-6.25MG",
                    "5MG-6.25MG",
                    "10MG-6.25MG"
                ]
            }
        ]
    },
    {
        "id": 487,
        "type": "RX",
        "ingredient": "BISOPROLOL FUMARATE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "ZIAC",
        "forms": [
            {
                "orange_id": "20186-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-6.25MG",
                    "5MG-6.25MG",
                    "10MG-6.25MG"
                ]
            }
        ]
    },
    {
        "id": 488,
        "type": "RX",
        "ingredient": "BIVALIRUDIN",
        "trade_name": "ANGIOMAX",
        "forms": [
            {
                "orange_id": "20873-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 489,
        "type": "RX",
        "ingredient": "BIVALIRUDIN",
        "trade_name": "ANGIOMAX RTU",
        "forms": [
            {
                "orange_id": "211215-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/50ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 490,
        "type": "RX",
        "ingredient": "BIVALIRUDIN",
        "trade_name": "BIVALIRUDIN",
        "forms": [
            {
                "orange_id": "206551-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 491,
        "type": "RX",
        "ingredient": "BIVALIRUDIN",
        "trade_name": "BIVALIRUDIN IN 0. 9% SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "208374-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/50ML (5MG/ML)",
                    "500MG/100ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 492,
        "type": "RX",
        "ingredient": "BLEOMYCIN SULFATE",
        "trade_name": "BLEOMYCIN SULFATE",
        "forms": [
            {
                "orange_id": "65185-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 15 UNITS BASE/VIAL",
                    "EQ 30 UNITS BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 493,
        "type": "RX",
        "ingredient": "BORTEZOMIB",
        "trade_name": "BORTEZOMIB",
        "forms": [
            {
                "orange_id": "206927-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "3.5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 494,
        "type": "RX",
        "ingredient": "BORTEZOMIB",
        "trade_name": "VELCADE",
        "forms": [
            {
                "orange_id": "21602-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "3.5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 495,
        "type": "RX",
        "ingredient": "BOSENTAN",
        "trade_name": "BOSENTAN",
        "forms": [
            {
                "orange_id": "208695-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "62.5MG",
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 496,
        "type": "RX",
        "ingredient": "BOSENTAN",
        "trade_name": "TRACLEER",
        "forms": [
            {
                "orange_id": "209279-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "32MG"
                ]
            },
            {
                "orange_id": "21290-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "62.5MG",
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 497,
        "type": "RX",
        "ingredient": "BOSUTINIB MONOHYDRATE",
        "trade_name": "BOSULIF",
        "forms": [
            {
                "orange_id": "203341-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 400MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 498,
        "type": "RX",
        "ingredient": "BREMELANOTIDE ACETATE",
        "trade_name": "VYLEESI (AUTOINJECTOR)",
        "forms": [
            {
                "orange_id": "210557-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 1.75MG BASE/0.3ML (EQ 1.75MG BASE/0.3 ML)"
                ]
            }
        ]
    },
    {
        "id": 499,
        "type": "RX",
        "ingredient": "BRETYLIUM TOSYLATE",
        "trade_name": "BRETYLIUM TOSYLATE",
        "forms": [
            {
                "orange_id": "204386-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 500,
        "type": "RX",
        "ingredient": "BREXANOLONE",
        "trade_name": "ZULRESSO",
        "forms": [
            {
                "orange_id": "211371-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/20ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 501,
        "type": "RX",
        "ingredient": "BREXPIPRAZOLE",
        "trade_name": "REXULTI",
        "forms": [
            {
                "orange_id": "205422-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 502,
        "type": "RX",
        "ingredient": "BRIGATINIB",
        "trade_name": "ALUNBRIG",
        "forms": [
            {
                "orange_id": "208772-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "90MG",
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 503,
        "type": "RX",
        "ingredient": "BRILLIANT BLUE G",
        "trade_name": "TISSUEBLUE",
        "forms": [
            {
                "orange_id": "209569-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 504,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE",
        "trade_name": "ALPHAGAN P",
        "forms": [
            {
                "orange_id": "21770-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%",
                    "0.15%"
                ]
            }
        ]
    },
    {
        "id": 505,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE",
        "trade_name": "BRIMONIDINE TARTRATE",
        "forms": [
            {
                "orange_id": "209158-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.33% BASE"
                ]
            },
            {
                "orange_id": "76439-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%",
                    "0.15%"
                ]
            }
        ]
    },
    {
        "id": 506,
        "type": "OTC",
        "ingredient": "BRIMONIDINE TARTRATE",
        "trade_name": "LUMIFY",
        "forms": [
            {
                "orange_id": "208144-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 507,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE",
        "trade_name": "MIRVASO",
        "forms": [
            {
                "orange_id": "204708-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.33% BASE"
                ]
            }
        ]
    },
    {
        "id": 508,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE",
        "trade_name": "QOLIANA",
        "forms": [
            {
                "orange_id": "21764-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.15%"
                ]
            }
        ]
    },
    {
        "id": 509,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE AND BRINZOLAMIDE",
        "trade_name": "SIMBRINZA",
        "forms": [
            {
                "orange_id": "204251-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%-1%"
                ]
            }
        ]
    },
    {
        "id": 510,
        "type": "RX",
        "ingredient": "BRIMONIDINE TARTRATE AND TIMOLOL MALEATE",
        "trade_name": "COMBIGAN",
        "forms": [
            {
                "orange_id": "21398-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%-EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 511,
        "type": "RX",
        "ingredient": "BRINCIDOFOVIR",
        "trade_name": "TEMBEXA",
        "forms": [
            {
                "orange_id": "214460-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "214461-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 512,
        "type": "RX",
        "ingredient": "BRINZOLAMIDE",
        "trade_name": "AZOPT",
        "forms": [
            {
                "orange_id": "20816-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 513,
        "type": "RX",
        "ingredient": "BRINZOLAMIDE",
        "trade_name": "BRINZOLAMIDE",
        "forms": [
            {
                "orange_id": "204884-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 514,
        "type": "RX",
        "ingredient": "BRIVARACETAM",
        "trade_name": "BRIVIACT",
        "forms": [
            {
                "orange_id": "205837-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/5ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "205838-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "205836-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 515,
        "type": "RX",
        "ingredient": "BROMFENAC SODIUM",
        "trade_name": "BROMFENAC SODIUM",
        "forms": [
            {
                "orange_id": "203395-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.09% ACID"
                ]
            }
        ]
    },
    {
        "id": 516,
        "type": "RX",
        "ingredient": "BROMFENAC SODIUM",
        "trade_name": "BROMSITE",
        "forms": [
            {
                "orange_id": "206911-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.075% ACID"
                ]
            }
        ]
    },
    {
        "id": 517,
        "type": "RX",
        "ingredient": "BROMFENAC SODIUM",
        "trade_name": "PROLENSA",
        "forms": [
            {
                "orange_id": "203168-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.07% ACID"
                ]
            }
        ]
    },
    {
        "id": 518,
        "type": "RX",
        "ingredient": "BROMOCRIPTINE MESYLATE",
        "trade_name": "BROMOCRIPTINE MESYLATE",
        "forms": [
            {
                "orange_id": "77226-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "77646-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 519,
        "type": "RX",
        "ingredient": "BROMOCRIPTINE MESYLATE",
        "trade_name": "CYCLOSET",
        "forms": [
            {
                "orange_id": "20866-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 520,
        "type": "RX",
        "ingredient": "BROMOCRIPTINE MESYLATE",
        "trade_name": "PARLODEL",
        "forms": [
            {
                "orange_id": "17962-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "17962-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 521,
        "type": "RX",
        "ingredient": "BROMPHENIRAMINE MALEATE, DEXTROMETHORPHAN HYDROBROMIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "BROMFED-DM",
        "forms": [
            {
                "orange_id": "88811-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML-10MG/5ML-30MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 522,
        "type": "RX",
        "ingredient": "BROMPHENIRAMINE MALEATE, DEXTROMETHORPHAN HYDROBROMIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "BROMPHENIRAMINE MALEATE, PSEUDOEPHEDRINE HYDROCHLORIDE AND DEXTROMETHORPHAN HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "203375-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML-10MG/5ML-30MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 523,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "BUDESONIDE",
        "forms": [
            {
                "orange_id": "206200-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            },
            {
                "orange_id": "78949-2",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.032MG/SPRAY"
                ]
            },
            {
                "orange_id": "205710-1",
                "form": "SUSPENSION",
                "route": "INHALATION",
                "dosage": [
                    "0.25MG/2ML",
                    "0.5MG/2ML",
                    "1MG/2ML"
                ]
            },
            {
                "orange_id": "205457-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "9MG"
                ]
            }
        ]
    },
    {
        "id": 524,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "ENTOCORT EC",
        "forms": [
            {
                "orange_id": "21324-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 525,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "ORTIKOS",
        "forms": [
            {
                "orange_id": "211929-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "6MG",
                    "9MG"
                ]
            }
        ]
    },
    {
        "id": 526,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "PULMICORT FLEXHALER",
        "forms": [
            {
                "orange_id": "21949-1",
                "form": "POWDER, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.08MG/INH",
                    "0.16MG/INH"
                ]
            }
        ]
    },
    {
        "id": 527,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "PULMICORT RESPULES",
        "forms": [
            {
                "orange_id": "20929-1",
                "form": "SUSPENSION",
                "route": "INHALATION",
                "dosage": [
                    "0.25MG/2ML",
                    "0.5MG/2ML",
                    "1MG/2ML"
                ]
            }
        ]
    },
    {
        "id": 528,
        "type": "OTC",
        "ingredient": "BUDESONIDE",
        "trade_name": "RHINOCORT ALLERGY",
        "forms": [
            {
                "orange_id": "20746-3",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.032MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 529,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "TARPEYO",
        "forms": [
            {
                "orange_id": "215935-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 530,
        "type": "RX",
        "ingredient": "BUDESONIDE",
        "trade_name": "UCERIS",
        "forms": [
            {
                "orange_id": "205613-1",
                "form": "AEROSOL, FOAM",
                "route": "RECTAL",
                "dosage": [
                    "2MG/ACTUATION"
                ]
            },
            {
                "orange_id": "203634-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "9MG"
                ]
            }
        ]
    },
    {
        "id": 531,
        "type": "RX",
        "ingredient": "BUDESONIDE AND FORMOTEROL FUMARATE DIHYDRATE",
        "trade_name": "SYMBICORT",
        "forms": [
            {
                "orange_id": "21929-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.08MG/INH-0.0045MG/INH",
                    "0.16MG/INH-0.0045MG/INH"
                ]
            }
        ]
    },
    {
        "id": 532,
        "type": "RX",
        "ingredient": "BUDESONIDE, FORMOTEROL FUMARATE AND GLYCOPYRROLATE",
        "trade_name": "BREZTRI AEROSPHERE",
        "forms": [
            {
                "orange_id": "212122-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.16MG/INH-0.0048MG/INH-0.009MG/INH"
                ]
            }
        ]
    },
    {
        "id": 533,
        "type": "RX",
        "ingredient": "BUMETANIDE",
        "trade_name": "BUMETANIDE",
        "forms": [
            {
                "orange_id": "74332-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25MG/ML"
                ]
            },
            {
                "orange_id": "209724-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 534,
        "type": "RX",
        "ingredient": "BUMETANIDE",
        "trade_name": "BUMEX",
        "forms": [
            {
                "orange_id": "18225-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 535,
        "type": "RX",
        "ingredient": "BUPIVACAINE",
        "trade_name": "EXPAREL",
        "forms": [
            {
                "orange_id": "22496-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "133MG/10ML (13.3MG/ML)",
                    "266MG/20ML (13.3MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 536,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "BUPIVACAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207183-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%",
                    "0.5%",
                    "0.75%"
                ]
            },
            {
                "orange_id": "209087-1",
                "form": "INJECTABLE",
                "route": "SPINAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 537,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "BUPIVACAINE HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "203895-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%",
                    "0.5%",
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 538,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "MARCAINE",
        "forms": [
            {
                "orange_id": "18692-1",
                "form": "INJECTABLE",
                "route": "SPINAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 539,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "MARCAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "16964-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%",
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 540,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "MARCAINE HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "16964-12",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%",
                    "0.5%",
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 541,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "SENSORCAINE",
        "forms": [
            {
                "orange_id": "70552-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%",
                    "0.5%",
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 542,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE",
        "trade_name": "XARACOLL",
        "forms": [
            {
                "orange_id": "209511-1",
                "form": "IMPLANT",
                "route": "IMPLANTATION",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 543,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE",
        "trade_name": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE",
        "forms": [
            {
                "orange_id": "71165-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%-0.005MG/ML",
                    "0.5%-0.005MG/ML"
                ]
            }
        ]
    },
    {
        "id": 544,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE",
        "forms": [
            {
                "orange_id": "77250-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5%-0.0091MG/ML"
                ]
            }
        ]
    },
    {
        "id": 545,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "MARCAINE HYDROCHLORIDE W/ EPINEPHRINE",
        "forms": [
            {
                "orange_id": "16964-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%-0.0091MG/ML",
                    "0.5%-0.0091MG/ML"
                ]
            }
        ]
    },
    {
        "id": 546,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "MARCAINE HYDROCHLORIDE W/ EPINEPHRINE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "16964-13",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%-0.0091MG/ML",
                    "0.5%-0.0091MG/ML",
                    "0.75%-0.0091MG/ML"
                ]
            }
        ]
    },
    {
        "id": 547,
        "type": "RX",
        "ingredient": "BUPIVACAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "trade_name": "SENSORCAINE",
        "forms": [
            {
                "orange_id": "70966-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25%-0.0091MG/ML",
                    "0.5%-0.0091MG/ML",
                    "0.75%-0.0091MG/ML"
                ]
            }
        ]
    },
    {
        "id": 548,
        "type": "RX",
        "ingredient": "BUPIVACAINE AND MELOXICAM",
        "trade_name": "ZYNRELEF KIT",
        "forms": [
            {
                "orange_id": "211988-1",
                "form": "SOLUTION, EXTENDED RELEASE",
                "route": "PERIARTICULAR",
                "dosage": [
                    "60MG/2.3ML (29.25MG/ML)-1.8MG/2.3ML (0.88MG/ML)",
                    "200MG/7ML (29.25MG/ML)-6MG/7ML (0.88MG/ML)",
                    "300MG/10.5ML (29.25MG/ML)-9MG/10.5ML (0.88MG/ML)",
                    "400MG/14ML (29.25MG/ML)-12MG/14ML (0.88MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 549,
        "type": "RX",
        "ingredient": "BUPRENORPHINE",
        "trade_name": "BUPRENORPHINE",
        "forms": [
            {
                "orange_id": "211586-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "5MCG/HR",
                    "7.5MCG/HR",
                    "10MCG/HR",
                    "15MCG/HR",
                    "20MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 550,
        "type": "RX",
        "ingredient": "BUPRENORPHINE",
        "trade_name": "BUTRANS",
        "forms": [
            {
                "orange_id": "21306-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "5MCG/HR",
                    "7.5MCG/HR",
                    "10MCG/HR",
                    "15MCG/HR",
                    "20MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 551,
        "type": "RX",
        "ingredient": "BUPRENORPHINE",
        "trade_name": "SUBLOCADE",
        "forms": [
            {
                "orange_id": "209819-1",
                "form": "SOLUTION, EXTENDED RELEASE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "100MG/0.5ML (100MG/0.5ML)",
                    "300MG/1.5ML (200MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 552,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE",
        "trade_name": "BELBUCA",
        "forms": [
            {
                "orange_id": "207932-1",
                "form": "FILM",
                "route": "BUCCAL",
                "dosage": [
                    "EQ 0.075MG BASE",
                    "EQ 0.15MG BASE",
                    "EQ 0.3MG BASE",
                    "EQ 0.45MG BASE",
                    "EQ 0.6MG BASE",
                    "EQ 0.75MG BASE",
                    "EQ 0.9MG BASE"
                ]
            }
        ]
    },
    {
        "id": 553,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE",
        "trade_name": "BUPRENEX",
        "forms": [
            {
                "orange_id": "18401-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.3MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 554,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE",
        "trade_name": "BUPRENORPHINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78331-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.3MG BASE/ML"
                ]
            },
            {
                "orange_id": "90819-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 555,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE",
        "trade_name": "BUPRENORPHINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205954-1",
                "form": "FILM",
                "route": "BUCCAL, SUBLINGUAL",
                "dosage": [
                    "EQ 2MG BASE-EQ 0.5MG BASE",
                    "EQ 4MG BASE-EQ 1MG BASE",
                    "EQ 8MG BASE-EQ 2MG BASE",
                    "EQ 12MG BASE-EQ 3MG BASE"
                ]
            },
            {
                "orange_id": "91422-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 2MG BASE-EQ 0.5MG BASE",
                    "EQ 8MG BASE-EQ 2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 556,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE",
        "trade_name": "SUBOXONE",
        "forms": [
            {
                "orange_id": "22410-1",
                "form": "FILM",
                "route": "BUCCAL, SUBLINGUAL",
                "dosage": [
                    "EQ 2MG BASE-EQ 0.5MG BASE",
                    "EQ 4MG BASE-EQ 1MG BASE",
                    "EQ 8MG BASE-EQ 2MG BASE",
                    "EQ 12MG BASE-EQ 3MG BASE"
                ]
            }
        ]
    },
    {
        "id": 557,
        "type": "RX",
        "ingredient": "BUPRENORPHINE HYDROCHLORIDE AND NALOXONE HYDROCHLORIDE",
        "trade_name": "ZUBSOLV",
        "forms": [
            {
                "orange_id": "204242-6",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 0.7MG BASE-EQ 0.18MG BASE",
                    "EQ 1.4MG BASE-EQ 0.36MG BASE",
                    "EQ 2.9MG BASE-EQ 0.71MG BASE",
                    "EQ 5.7MG BASE-EQ 1.4MG BASE",
                    "EQ 8.6MG BASE-EQ 2.1MG BASE",
                    "EQ 11.4MG BASE-EQ 2.9MG BASE"
                ]
            }
        ]
    },
    {
        "id": 558,
        "type": "RX",
        "ingredient": "BUPROPION HYDROBROMIDE",
        "trade_name": "APLENZIN",
        "forms": [
            {
                "orange_id": "22108-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "174MG",
                    "348MG",
                    "522MG"
                ]
            }
        ]
    },
    {
        "id": 559,
        "type": "RX",
        "ingredient": "BUPROPION HYDROCHLORIDE",
        "trade_name": "BUPROPION HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210497-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG",
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "203013-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 560,
        "type": "RX",
        "ingredient": "BUPROPION HYDROCHLORIDE",
        "trade_name": "FORFIVO XL",
        "forms": [
            {
                "orange_id": "22497-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "450MG"
                ]
            }
        ]
    },
    {
        "id": 561,
        "type": "RX",
        "ingredient": "BUPROPION HYDROCHLORIDE",
        "trade_name": "WELLBUTRIN SR",
        "forms": [
            {
                "orange_id": "20358-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 562,
        "type": "RX",
        "ingredient": "BUPROPION HYDROCHLORIDE",
        "trade_name": "WELLBUTRIN XL",
        "forms": [
            {
                "orange_id": "21515-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 563,
        "type": "RX",
        "ingredient": "BUPROPION HYDROCHLORIDE AND NALTREXONE HYDROCHLORIDE",
        "trade_name": "CONTRAVE",
        "forms": [
            {
                "orange_id": "200063-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "90MG-8MG"
                ]
            }
        ]
    },
    {
        "id": 564,
        "type": "RX",
        "ingredient": "BUSPIRONE HYDROCHLORIDE",
        "trade_name": "BUSPIRONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202557-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG",
                    "10MG",
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 565,
        "type": "RX",
        "ingredient": "BUSULFAN",
        "trade_name": "BUSULFAN",
        "forms": [
            {
                "orange_id": "210148-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 566,
        "type": "RX",
        "ingredient": "BUSULFAN",
        "trade_name": "BUSULFEX",
        "forms": [
            {
                "orange_id": "20954-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 567,
        "type": "RX",
        "ingredient": "BUSULFAN",
        "trade_name": "MYLERAN",
        "forms": [
            {
                "orange_id": "9386-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 568,
        "type": "OTC",
        "ingredient": "BUTENAFINE HYDROCHLORIDE",
        "trade_name": "BUTENAFINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205181-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 569,
        "type": "OTC",
        "ingredient": "BUTENAFINE HYDROCHLORIDE",
        "trade_name": "LOTRIMIN ULTRA",
        "forms": [
            {
                "orange_id": "21307-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 570,
        "type": "RX",
        "ingredient": "BUTENAFINE HYDROCHLORIDE",
        "trade_name": "MENTAX",
        "forms": [
            {
                "orange_id": "20524-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 571,
        "type": "RX",
        "ingredient": "BUTOCONAZOLE NITRATE",
        "trade_name": "GYNAZOLE-1",
        "forms": [
            {
                "orange_id": "200923-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 572,
        "type": "RX",
        "ingredient": "BUTORPHANOL TARTRATE",
        "trade_name": "BUTORPHANOL TARTRATE",
        "forms": [
            {
                "orange_id": "75046-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML",
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "75499-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "1MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 573,
        "type": "RX",
        "ingredient": "BUTORPHANOL TARTRATE",
        "trade_name": "BUTORPHANOL TARTRATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "75045-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 574,
        "type": "RX",
        "ingredient": "CABAZITAXEL",
        "trade_name": "CABAZITAXEL",
        "forms": [
            {
                "orange_id": "207949-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60MG/3ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 575,
        "type": "RX",
        "ingredient": "CABAZITAXEL",
        "trade_name": "JEVTANA KIT",
        "forms": [
            {
                "orange_id": "201023-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60MG/1.5ML (40MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 576,
        "type": "RX",
        "ingredient": "CABERGOLINE",
        "trade_name": "CABERGOLINE",
        "forms": [
            {
                "orange_id": "204735-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 577,
        "type": "RX",
        "ingredient": "CABOTEGRAVIR",
        "trade_name": "APRETUDE",
        "forms": [
            {
                "orange_id": "215499-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "600MG/3ML (200MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 578,
        "type": "RX",
        "ingredient": "CABOTEGRAVIR SODIUM",
        "trade_name": "VOCABRIA",
        "forms": [
            {
                "orange_id": "212887-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE"
                ]
            }
        ]
    },
    {
        "id": 579,
        "type": "RX",
        "ingredient": "CABOTEGRAVIR AND RILPIVIRINE",
        "trade_name": "CABENUVA KIT",
        "forms": [
            {
                "orange_id": "212888-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "400MG/2ML (200MG/ML)-600MG/2ML (300MG/ML)",
                    "600MG/3ML (200MG/ML)-900MG/3ML (300MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 580,
        "type": "RX",
        "ingredient": "CABOZANTINIB S-MALATE",
        "trade_name": "CABOMETYX",
        "forms": [
            {
                "orange_id": "208692-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 581,
        "type": "RX",
        "ingredient": "CABOZANTINIB S-MALATE",
        "trade_name": "COMETRIQ",
        "forms": [
            {
                "orange_id": "203756-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 582,
        "type": "RX",
        "ingredient": "CAFFEINE CITRATE",
        "trade_name": "CAFCIT",
        "forms": [
            {
                "orange_id": "20793-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 30MG BASE/3ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 583,
        "type": "RX",
        "ingredient": "CAFFEINE CITRATE",
        "trade_name": "CAFFEINE CITRATE",
        "forms": [
            {
                "orange_id": "77906-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 30MG BASE/3ML (EQ 10MG BASE/ML)"
                ]
            },
            {
                "orange_id": "77304-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE/3ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 584,
        "type": "RX",
        "ingredient": "CAFFEINE AND ERGOTAMINE TARTRATE",
        "trade_name": "ERGOTAMINE TARTRATE AND CAFFEINE",
        "forms": [
            {
                "orange_id": "40590-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 585,
        "type": "RX",
        "ingredient": "CAFFEINE AND ERGOTAMINE TARTRATE",
        "trade_name": "MIGERGOT",
        "forms": [
            {
                "orange_id": "86557-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "100MG-2MG"
                ]
            }
        ]
    },
    {
        "id": 586,
        "type": "RX",
        "ingredient": "CALCIFEDIOL",
        "trade_name": "RAYALDEE",
        "forms": [
            {
                "orange_id": "208010-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.03MG"
                ]
            }
        ]
    },
    {
        "id": 587,
        "type": "RX",
        "ingredient": "CALCIPOTRIENE",
        "trade_name": "CALCIPOTRIENE",
        "forms": [
            {
                "orange_id": "205772-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            },
            {
                "orange_id": "90633-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            },
            {
                "orange_id": "77579-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 588,
        "type": "RX",
        "ingredient": "CALCIPOTRIENE",
        "trade_name": "DOVONEX",
        "forms": [
            {
                "orange_id": "20554-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 589,
        "type": "RX",
        "ingredient": "CALCIPOTRIENE",
        "trade_name": "SORILUX",
        "forms": [
            {
                "orange_id": "22563-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 590,
        "type": "RX",
        "ingredient": "CALCITONIN SALMON",
        "trade_name": "CALCITONIN-SALMON",
        "forms": [
            {
                "orange_id": "212416-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 IU/ML"
                ]
            },
            {
                "orange_id": "76396-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "200 IU/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 591,
        "type": "RX",
        "ingredient": "CALCITONIN SALMON",
        "trade_name": "MIACALCIN",
        "forms": [
            {
                "orange_id": "17808-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 IU/ML"
                ]
            }
        ]
    },
    {
        "id": 592,
        "type": "RX",
        "ingredient": "CALCITRIOL",
        "trade_name": "CALCITRIOL",
        "forms": [
            {
                "orange_id": "203289-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.25MCG",
                    "0.5MCG"
                ]
            },
            {
                "orange_id": "78066-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.001MG/ML"
                ]
            },
            {
                "orange_id": "209798-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MCG/ML"
                ]
            }
        ]
    },
    {
        "id": 593,
        "type": "RX",
        "ingredient": "CALCITRIOL",
        "trade_name": "ROCALTROL",
        "forms": [
            {
                "orange_id": "18044-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.25MCG",
                    "0.5MCG"
                ]
            },
            {
                "orange_id": "21068-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MCG/ML"
                ]
            }
        ]
    },
    {
        "id": 594,
        "type": "RX",
        "ingredient": "CALCITRIOL",
        "trade_name": "VECTICAL",
        "forms": [
            {
                "orange_id": "22087-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "3MCG/GM"
                ]
            }
        ]
    },
    {
        "id": 595,
        "type": "RX",
        "ingredient": "CALCIUM ACETATE",
        "trade_name": "CALCIUM ACETATE",
        "forms": [
            {
                "orange_id": "91312-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "667MG"
                ]
            },
            {
                "orange_id": "202420-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "667MG"
                ]
            }
        ]
    },
    {
        "id": 596,
        "type": "RX",
        "ingredient": "CALCIUM ACETATE",
        "trade_name": "PHOSLO GELCAPS",
        "forms": [
            {
                "orange_id": "21160-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "667MG"
                ]
            }
        ]
    },
    {
        "id": 597,
        "type": "RX",
        "ingredient": "CALCIUM ACETATE",
        "trade_name": "PHOSLYRA",
        "forms": [
            {
                "orange_id": "22581-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "667MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 598,
        "type": "OTC",
        "ingredient": "CALCIUM CARBONATE, FAMOTIDINE AND MAGNESIUM HYDROXIDE",
        "trade_name": "FAMOTIDINE, CALCIUM CARBONATE, AND MAGNESIUM HYDROXIDE",
        "forms": [
            {
                "orange_id": "77355-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "800MG-10MG-165MG"
                ]
            }
        ]
    },
    {
        "id": 599,
        "type": "OTC",
        "ingredient": "CALCIUM CARBONATE, FAMOTIDINE AND MAGNESIUM HYDROXIDE",
        "trade_name": "PEPCID COMPLETE",
        "forms": [
            {
                "orange_id": "20958-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "800MG-10MG-165MG"
                ]
            }
        ]
    },
    {
        "id": 600,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE",
        "trade_name": "CALCIUM CHLORIDE 10%",
        "forms": [
            {
                "orange_id": "209088-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 601,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE",
        "trade_name": "CALCIUM CHLORIDE 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21117-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 602,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, GLUTATHIONE DISULFIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM PHOSPHATE",
        "trade_name": "BSS PLUS",
        "forms": [
            {
                "orange_id": "18469-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "0.154MG/ML-0.92MG/ML-0.184MG/ML-0.2MG/ML-0.38MG/ML-2.1MG/ML-7.14MG/ML-0.42MG/ML"
                ]
            }
        ]
    },
    {
        "id": 603,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL B22GK 4/0 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-11",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A/1000ML-20GM/1000ML-5.4GM/1000ML-3.05GM/1000ML-0.314GM/1000ML-2.21GM/1000ML-7.07GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 604,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BGK 0/2. 5 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.68GM/1000ML-20GM/1000ML-5.4GM/1000ML-3.05GM/1000ML-N/A/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 605,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BGK 2/0 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A/1000ML-20GM/1000ML-5.4GM/1000ML-2.03GM/1000ML-0.157GM/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 606,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BGK 2/3. 5 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5.15GM/1000ML-20GM/1000ML-5.4GM/1000ML-2.03GM/1000ML-0.157GM/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 607,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BGK 4/0/1. 2 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-15",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A/1000ML-20GM/1000ML-5.4GM/1000ML-2.44GM/1000ML-0.314GM/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 608,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BGK 4/2. 5 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.68GM/1000ML-20GM/1000ML-5.4GM/1000ML-3.05GM/1000ML-0.314GM/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 609,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, LACTIC ACID, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PRISMASOL BK 0/0/1. 2 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21703-14",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A/1000ML-N/A/1000ML-5.4GM/1000ML-2.44GM/1000ML-N/A/1000ML-3.09GM/1000ML-6.46GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 610,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-1",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-1.5GM/100ML-15.2MG/100ML-567MG/100ML-392MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 611,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 1. 5% LOW MAGNESIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-4",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-1.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 612,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 1. 5% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20171-1",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.4MG/100ML-1.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 613,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 2. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-2",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-2.5GM/100ML-15.2MG/100ML-567MG/100ML-392MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 614,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 2. 5% LOW MAGNESIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-5",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-2.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 615,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 2. 5% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20171-2",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.4MG/100ML-2.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 616,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 4. 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-3",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-4.25GM/100ML-15.2MG/100ML-567MG/100ML-392MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 617,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 4. 25% LOW MAGNESIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18883-6",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-4.25GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 618,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DELFLEX W/ DEXTROSE 4. 25% LOW MAGNESIUM LOW CALCIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20171-3",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.4MG/100ML-4.25GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 619,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/ DEXTROSE 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20183-1",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-1.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 620,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/ DEXTROSE 2. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20183-2",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-2.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 621,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/ DEXTROSE 4. 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20183-4",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-4.25GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 622,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/DEXTROSE 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-12",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-1.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 623,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/DEXTROSE 2. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-13",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-2.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 624,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/DEXTROSE 3. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-14",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-3.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 625,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL LOW CALCIUM W/DEXTROSE 4. 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-15",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "18.3MG/100ML-4.25GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 626,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL PD-2 W/ DEXTROSE 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-4",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-1.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 627,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL PD-2 W/ DEXTROSE 2. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-5",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-2.5GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 628,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DIANEAL PD-2 W/ DEXTROSE 4. 25% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17512-6",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "25.7MG/100ML-4.25GM/100ML-5.08MG/100ML-538MG/100ML-448MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 629,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, MAGNESIUM SULFATE, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM PHOSPHATE, DIBASIC, HEPTAHYDRATE",
        "trade_name": "ELLIOTTS B SOLUTION",
        "forms": [
            {
                "orange_id": "20577-1",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "0.2MG/ML-0.8MG/ML-0.3MG/ML-0.3MG/ML-1.9MG/ML-7.3MG/ML-0.2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 630,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DEXTROSE 2. 5% IN HALF-STRENGTH LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19634-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/100ML-2.5GM/100ML-15MG/100ML-300MG/100ML-160MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 631,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17608-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-30MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 632,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DEXTROSE 5% IN LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19634-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-30MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 633,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "LACTATED RINGER'S AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16679-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-30MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 634,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-105MG/100ML-600MG/100ML-310MG/100ML",
                    "20MG/100ML-5GM/100ML-179MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 635,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 15MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-254MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 636,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-179MG/100ML-600MG/100ML-310MG/100ML",
                    "20MG/100ML-5GM/100ML-328MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 637,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-254MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 638,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-328MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 639,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, DEXTROSE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19367-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-5GM/100ML-105MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 640,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "TPN ELECTROLYTES IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18895-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "16.5MG/ML-25.4MG/ML-74.6MG/ML-121MG/ML-16.1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 641,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM CITRATE",
        "trade_name": "BALANCED SALT",
        "forms": [
            {
                "orange_id": "75503-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "0.48MG/ML-0.3MG/ML-0.75MG/ML-3.9MG/ML-6.4MG/ML-1.7MG/ML"
                ]
            }
        ]
    },
    {
        "id": 642,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM CITRATE",
        "trade_name": "BSS",
        "forms": [
            {
                "orange_id": "20742-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "0.48MG/ML-0.3MG/ML-0.75MG/ML-3.9MG/ML-6.4MG/ML-1.7MG/ML"
                ]
            }
        ]
    },
    {
        "id": 643,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM PHOSPHATE",
        "trade_name": "PHOXILLUM B22K 4/0 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "207026-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A/1000ML-3.05GM/1000ML-0.314GM/1000ML-2.21GM/1000ML-6.95GM/1000ML-0.187GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 644,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM PHOSPHATE",
        "trade_name": "PHOXILLUM BK 4/2. 5 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "207026-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.68GM/1000ML-3.05GM/1000ML-0.314GM/1000ML -3.09GM/1000ML-6.34GM/1000ML-0.187GM/1000ML (5000ML)"
                ]
            }
        ]
    },
    {
        "id": 645,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "CARDIOPLEGIC IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "75323-1",
                "form": "SOLUTION",
                "route": "PERFUSION, CARDIAC",
                "dosage": [
                    "17.6MG/100ML-325.3MG/100ML-119.3MG/100ML-643MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 646,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "PLEGISOL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18608-1",
                "form": "SOLUTION",
                "route": "PERFUSION, CARDIAC",
                "dosage": [
                    "17.6MG/100ML-325.3MG/100ML-119.3MG/100ML-643MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 647,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20002-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "33MG/100ML-30MG/100ML-860MG/100ML"
                ]
            },
            {
                "orange_id": "18156-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "33MG/100ML-30MG/100ML-860MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 648,
        "type": "RX",
        "ingredient": "CALCIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "LACTATED RINGER'S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19632-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/100ML-30MG/100ML-600MG/100ML-310MG/100ML"
                ]
            },
            {
                "orange_id": "18681-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "20MG/100ML-30MG/100ML-600MG/100ML-310MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 649,
        "type": "RX",
        "ingredient": "CALCIUM GLUCONATE",
        "trade_name": "CALCIUM GLUCONATE",
        "forms": [
            {
                "orange_id": "208418-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/10ML (100MG/ML)",
                    "5GM/50ML (100MG/ML)",
                    "10GM/100ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 650,
        "type": "RX",
        "ingredient": "CALCIUM GLUCONATE",
        "trade_name": "CALCIUM GLUCONATE IN SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "208418-4",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/50ML (20MG/ML)",
                    "2GM/100ML (20MG/ML)",
                    "1GM/100ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 651,
        "type": "RX",
        "ingredient": "CALCIUM OXYBATE, MAGNESIUM OXYBATE, POTASSIUM OXYBATE AND SODIUM OXYBATE",
        "trade_name": "XYWAV",
        "forms": [
            {
                "orange_id": "212690-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.234GM/ML-0.096GM/ML-0.13GM/ML-0.04GM/ML"
                ]
            }
        ]
    },
    {
        "id": 652,
        "type": "RX",
        "ingredient": "CANAGLIFLOZIN",
        "trade_name": "INVOKANA",
        "forms": [
            {
                "orange_id": "204042-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 653,
        "type": "RX",
        "ingredient": "CANAGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "INVOKAMET",
        "forms": [
            {
                "orange_id": "204353-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-500MG",
                    "50MG-1GM",
                    "150MG-500MG",
                    "150MG-1GM"
                ]
            }
        ]
    },
    {
        "id": 654,
        "type": "RX",
        "ingredient": "CANAGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "INVOKAMET XR",
        "forms": [
            {
                "orange_id": "205879-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "50MG-1GM",
                    "50MG-500MG",
                    "150MG-1GM",
                    "150MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 655,
        "type": "RX",
        "ingredient": "CANDESARTAN CILEXETIL",
        "trade_name": "ATACAND",
        "forms": [
            {
                "orange_id": "20838-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG",
                    "16MG",
                    "32MG"
                ]
            }
        ]
    },
    {
        "id": 656,
        "type": "RX",
        "ingredient": "CANDESARTAN CILEXETIL",
        "trade_name": "CANDESARTAN CILEXETIL",
        "forms": [
            {
                "orange_id": "210302-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG",
                    "16MG",
                    "32MG"
                ]
            }
        ]
    },
    {
        "id": 657,
        "type": "RX",
        "ingredient": "CANDESARTAN CILEXETIL AND HYDROCHLOROTHIAZIDE",
        "trade_name": "ATACAND HCT",
        "forms": [
            {
                "orange_id": "21093-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "16MG-12.5MG",
                    "32MG-12.5MG",
                    "32MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 658,
        "type": "RX",
        "ingredient": "CANDESARTAN CILEXETIL AND HYDROCHLOROTHIAZIDE",
        "trade_name": "CANDESARTAN CILEXETIL AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "202965-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "16MG-12.5MG",
                    "32MG-12.5MG",
                    "32MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 659,
        "type": "RX",
        "ingredient": "CANGRELOR",
        "trade_name": "KENGREAL",
        "forms": [
            {
                "orange_id": "204958-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 660,
        "type": "RX",
        "ingredient": "CANNABIDIOL",
        "trade_name": "EPIDIOLEX",
        "forms": [
            {
                "orange_id": "210365-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 661,
        "type": "RX",
        "ingredient": "CAPECITABINE",
        "trade_name": "CAPECITABINE",
        "forms": [
            {
                "orange_id": "202593-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 662,
        "type": "RX",
        "ingredient": "CAPECITABINE",
        "trade_name": "XELODA",
        "forms": [
            {
                "orange_id": "20896-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 663,
        "type": "RX",
        "ingredient": "CAPMATINIB HYDROCHLORIDE",
        "trade_name": "TABRECTA",
        "forms": [
            {
                "orange_id": "213591-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 664,
        "type": "RX",
        "ingredient": "CAPSAICIN",
        "trade_name": "QUTENZA",
        "forms": [
            {
                "orange_id": "22395-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "8%"
                ]
            }
        ]
    },
    {
        "id": 665,
        "type": "RX",
        "ingredient": "CAPTOPRIL",
        "trade_name": "CAPTOPRIL",
        "forms": [
            {
                "orange_id": "212809-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 666,
        "type": "RX",
        "ingredient": "CARBACHOL",
        "trade_name": "MIOSTAT",
        "forms": [
            {
                "orange_id": "16968-1",
                "form": "SOLUTION",
                "route": "INTRAOCULAR",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 667,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "CARBAMAZEPINE",
        "forms": [
            {
                "orange_id": "78986-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "75714-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "75687-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "212948-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "400MG"
                ]
            },
            {
                "orange_id": "75948-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "100MG",
                    "300MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 668,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "CARBATROL",
        "forms": [
            {
                "orange_id": "20712-3",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 669,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "EPITOL",
        "forms": [
            {
                "orange_id": "73524-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "70541-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 670,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "EQUETRO",
        "forms": [
            {
                "orange_id": "21710-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 671,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "TEGRETOL",
        "forms": [
            {
                "orange_id": "18927-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "16608-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 672,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "TEGRETOL-XR",
        "forms": [
            {
                "orange_id": "20234-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 673,
        "type": "RX",
        "ingredient": "CARBAMAZEPINE",
        "trade_name": "TERIL",
        "forms": [
            {
                "orange_id": "76729-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 674,
        "type": "RX",
        "ingredient": "CARBIDOPA",
        "trade_name": "CARBIDOPA",
        "forms": [
            {
                "orange_id": "204291-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 675,
        "type": "RX",
        "ingredient": "CARBIDOPA",
        "trade_name": "LODOSYN",
        "forms": [
            {
                "orange_id": "17830-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 676,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "CARBIDOPA, LEVODOPA AND ENTACAPONE",
        "forms": [
            {
                "orange_id": "213212-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-200MG-50MG",
                    "18.75MG-200MG-75MG",
                    "25MG-200MG-100MG",
                    "31.25MG-200MG-125MG",
                    "37.5MG-200MG-150MG",
                    "50MG-200MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 677,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 100",
        "forms": [
            {
                "orange_id": "21485-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-200MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 678,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 125",
        "forms": [
            {
                "orange_id": "21485-6",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "31.25MG-200MG-125MG"
                ]
            }
        ]
    },
    {
        "id": 679,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 150",
        "forms": [
            {
                "orange_id": "21485-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "37.5MG-200MG-150MG"
                ]
            }
        ]
    },
    {
        "id": 680,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 200",
        "forms": [
            {
                "orange_id": "21485-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-200MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 681,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 50",
        "forms": [
            {
                "orange_id": "21485-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-200MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 682,
        "type": "RX",
        "ingredient": "CARBIDOPA, ENTACAPONE AND LEVODOPA",
        "trade_name": "STALEVO 75",
        "forms": [
            {
                "orange_id": "21485-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "18.75MG-200MG-75MG"
                ]
            }
        ]
    },
    {
        "id": 683,
        "type": "RX",
        "ingredient": "CARBIDOPA AND LEVODOPA",
        "trade_name": "CARBIDOPA AND LEVODOPA",
        "forms": [
            {
                "orange_id": "202323-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG-100MG",
                    "50MG-200MG"
                ]
            },
            {
                "orange_id": "78690-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG-100MG",
                    "25MG-100MG",
                    "25MG-250MG"
                ]
            },
            {
                "orange_id": "74260-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-100MG",
                    "25MG-100MG",
                    "25MG-250MG"
                ]
            }
        ]
    },
    {
        "id": 684,
        "type": "RX",
        "ingredient": "CARBIDOPA AND LEVODOPA",
        "trade_name": "DHIVY",
        "forms": [
            {
                "orange_id": "214869-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 685,
        "type": "RX",
        "ingredient": "CARBIDOPA AND LEVODOPA",
        "trade_name": "DUOPA",
        "forms": [
            {
                "orange_id": "203952-1",
                "form": "SUSPENSION",
                "route": "ENTERAL",
                "dosage": [
                    "4.63MG/ML-20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 686,
        "type": "RX",
        "ingredient": "CARBIDOPA AND LEVODOPA",
        "trade_name": "RYTARY",
        "forms": [
            {
                "orange_id": "203312-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "23.75MG-95MG",
                    "36.25MG-145MG",
                    "48.75MG-195MG",
                    "61.25MG-245MG"
                ]
            }
        ]
    },
    {
        "id": 687,
        "type": "RX",
        "ingredient": "CARBIDOPA AND LEVODOPA",
        "trade_name": "SINEMET",
        "forms": [
            {
                "orange_id": "17555-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-100MG",
                    "25MG-100MG",
                    "25MG-250MG"
                ]
            }
        ]
    },
    {
        "id": 688,
        "type": "RX",
        "ingredient": "CARBINOXAMINE MALEATE",
        "trade_name": "CARBINOXAMINE MALEATE",
        "forms": [
            {
                "orange_id": "40458-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4MG/5ML"
                ]
            },
            {
                "orange_id": "90435-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "6MG"
                ]
            }
        ]
    },
    {
        "id": 689,
        "type": "RX",
        "ingredient": "CARBINOXAMINE MALEATE",
        "trade_name": "KARBINAL ER",
        "forms": [
            {
                "orange_id": "22556-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 690,
        "type": "RX",
        "ingredient": "CARBOPLATIN",
        "trade_name": "CARBOPLATIN",
        "forms": [
            {
                "orange_id": "206775-5",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/100ML (10MG/ML)",
                    "50MG/5ML (10MG/ML)",
                    "150MG/15ML (10MG/ML)",
                    "450MG/45ML (10MG/ML)",
                    "600MG/60ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 691,
        "type": "RX",
        "ingredient": "CARBOPROST TROMETHAMINE",
        "trade_name": "CARBOPROST TROMETHAMINE",
        "forms": [
            {
                "orange_id": "215337-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.25MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 692,
        "type": "RX",
        "ingredient": "CARBOPROST TROMETHAMINE",
        "trade_name": "HEMABATE",
        "forms": [
            {
                "orange_id": "17989-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.25MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 693,
        "type": "RX",
        "ingredient": "CARFILZOMIB",
        "trade_name": "CARFILZOMIB",
        "forms": [
            {
                "orange_id": "209422-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 694,
        "type": "RX",
        "ingredient": "CARFILZOMIB",
        "trade_name": "KYPROLIS",
        "forms": [
            {
                "orange_id": "202714-3",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/VIAL",
                    "30MG/VIAL",
                    "60MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 695,
        "type": "RX",
        "ingredient": "CARGLUMIC ACID",
        "trade_name": "CARBAGLU",
        "forms": [
            {
                "orange_id": "22562-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 696,
        "type": "RX",
        "ingredient": "CARGLUMIC ACID",
        "trade_name": "CARGLUMIC ACID",
        "forms": [
            {
                "orange_id": "213729-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 697,
        "type": "RX",
        "ingredient": "CARIPRAZINE HYDROCHLORIDE",
        "trade_name": "VRAYLAR",
        "forms": [
            {
                "orange_id": "204370-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1.5MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4.5MG BASE",
                    "EQ 6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 698,
        "type": "RX",
        "ingredient": "CARISOPRODOL",
        "trade_name": "CARISOPRODOL",
        "forms": [
            {
                "orange_id": "40576-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "350MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 699,
        "type": "RX",
        "ingredient": "CARISOPRODOL",
        "trade_name": "SOMA",
        "forms": [
            {
                "orange_id": "11792-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "350MG"
                ]
            }
        ]
    },
    {
        "id": 700,
        "type": "RX",
        "ingredient": "CARMUSTINE",
        "trade_name": "BICNU",
        "forms": [
            {
                "orange_id": "17422-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 701,
        "type": "RX",
        "ingredient": "CARMUSTINE",
        "trade_name": "CARMUSTINE",
        "forms": [
            {
                "orange_id": "211229-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 702,
        "type": "RX",
        "ingredient": "CARMUSTINE",
        "trade_name": "GLIADEL",
        "forms": [
            {
                "orange_id": "20637-1",
                "form": "IMPLANT",
                "route": "INTRACRANIAL",
                "dosage": [
                    "7.7MG"
                ]
            }
        ]
    },
    {
        "id": 703,
        "type": "RX",
        "ingredient": "CARTEOLOL HYDROCHLORIDE",
        "trade_name": "CARTEOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75476-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 704,
        "type": "RX",
        "ingredient": "CARVEDILOL",
        "trade_name": "CARVEDILOL",
        "forms": [
            {
                "orange_id": "78332-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3.125MG",
                    "6.25MG",
                    "12.5MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 705,
        "type": "RX",
        "ingredient": "CARVEDILOL",
        "trade_name": "COREG",
        "forms": [
            {
                "orange_id": "20297-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3.125MG",
                    "6.25MG",
                    "12.5MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 706,
        "type": "RX",
        "ingredient": "CARVEDILOL PHOSPHATE",
        "trade_name": "CARVEDILOL PHOSPHATE",
        "forms": [
            {
                "orange_id": "204717-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 707,
        "type": "RX",
        "ingredient": "CARVEDILOL PHOSPHATE",
        "trade_name": "COREG CR",
        "forms": [
            {
                "orange_id": "22012-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 708,
        "type": "RX",
        "ingredient": "CASIMERSEN",
        "trade_name": "AMONDYS 45",
        "forms": [
            {
                "orange_id": "213026-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/2ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 709,
        "type": "RX",
        "ingredient": "CASPOFUNGIN ACETATE",
        "trade_name": "CANCIDAS",
        "forms": [
            {
                "orange_id": "21227-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL",
                    "70MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 710,
        "type": "RX",
        "ingredient": "CASPOFUNGIN ACETATE",
        "trade_name": "CASPOFUNGIN ACETATE",
        "forms": [
            {
                "orange_id": "206110-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL",
                    "70MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 711,
        "type": "RX",
        "ingredient": "CEDAZURIDINE AND DECITABINE",
        "trade_name": "INQOVI",
        "forms": [
            {
                "orange_id": "212576-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-35MG"
                ]
            }
        ]
    },
    {
        "id": 712,
        "type": "RX",
        "ingredient": "CEFACLOR",
        "trade_name": "CEFACLOR",
        "forms": [
            {
                "orange_id": "65350-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            },
            {
                "orange_id": "65412-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG BASE/5ML",
                    "EQ 187MG BASE/5ML",
                    "EQ 250MG BASE/5ML",
                    "EQ 375MG BASE/5ML"
                ]
            },
            {
                "orange_id": "65058-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 375MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 713,
        "type": "RX",
        "ingredient": "CEFADROXIL/CEFADROXIL HEMIHYDRATE",
        "trade_name": "CEFADROXIL",
        "forms": [
            {
                "orange_id": "65352-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 500MG BASE"
                ]
            },
            {
                "orange_id": "65349-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE/5ML",
                    "EQ 500MG BASE/5ML"
                ]
            },
            {
                "orange_id": "65260-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE"
                ]
            }
        ]
    },
    {
        "id": 714,
        "type": "RX",
        "ingredient": "CEFAZOLIN SODIUM",
        "trade_name": "ANCEF IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "63002-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 715,
        "type": "RX",
        "ingredient": "CEFAZOLIN SODIUM",
        "trade_name": "CEFAZOLIN AND DEXTROSE",
        "forms": [
            {
                "orange_id": "50779-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 716,
        "type": "RX",
        "ingredient": "CEFAZOLIN SODIUM",
        "trade_name": "CEFAZOLIN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "207131-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/50ML (EQ 20MG BASE/ML)",
                    "EQ 2GM BASE/100ML (EQ 20MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 717,
        "type": "RX",
        "ingredient": "CEFAZOLIN SODIUM",
        "trade_name": "CEFAZOLIN SODIUM",
        "forms": [
            {
                "orange_id": "65303-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL",
                    "EQ 20GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 100GM BASE/VIAL",
                    "EQ 300GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 718,
        "type": "RX",
        "ingredient": "CEFDINIR",
        "trade_name": "CEFDINIR",
        "forms": [
            {
                "orange_id": "210220-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            },
            {
                "orange_id": "210534-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 719,
        "type": "RX",
        "ingredient": "CEFEPIME HYDROCHLORIDE",
        "trade_name": "CEFEPIME AND DEXTROSE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "50821-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 720,
        "type": "RX",
        "ingredient": "CEFEPIME HYDROCHLORIDE",
        "trade_name": "CEFEPIME HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65441-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 721,
        "type": "RX",
        "ingredient": "CEFEPIME HYDROCHLORIDE",
        "trade_name": "CEFEPIME HYDROCHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "209408-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 100GM BASE"
                ]
            }
        ]
    },
    {
        "id": 722,
        "type": "RX",
        "ingredient": "CEFEPIME HYDROCHLORIDE",
        "trade_name": "CEFEPIME IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50817-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/50ML (EQ 20MG BASE/ML)",
                    "EQ 2GM BASE/100ML (EQ 20MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 723,
        "type": "RX",
        "ingredient": "CEFEPIME HYDROCHLORIDE",
        "trade_name": "MAXIPIME",
        "forms": [
            {
                "orange_id": "50679-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 724,
        "type": "RX",
        "ingredient": "CEFIDEROCOL SULFATE TOSYLATE",
        "trade_name": "FETROJA",
        "forms": [
            {
                "orange_id": "209445-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 725,
        "type": "RX",
        "ingredient": "CEFIXIME",
        "trade_name": "CEFIXIME",
        "forms": [
            {
                "orange_id": "210574-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            },
            {
                "orange_id": "211775-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML ",
                    "200MG/5ML ",
                    "100MG/5ML",
                    "200MG/5ML",
                    "500MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 726,
        "type": "RX",
        "ingredient": "CEFIXIME",
        "trade_name": "SUPRAX",
        "forms": [
            {
                "orange_id": "202091-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "500MG/5ML",
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "65380-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 727,
        "type": "RX",
        "ingredient": "CEFOTAXIME SODIUM",
        "trade_name": "CEFOTAXIME",
        "forms": [
            {
                "orange_id": "65072-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 728,
        "type": "RX",
        "ingredient": "CEFOTETAN DISODIUM",
        "trade_name": "CEFOTAN",
        "forms": [
            {
                "orange_id": "50588-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 729,
        "type": "RX",
        "ingredient": "CEFOTETAN DISODIUM",
        "trade_name": "CEFOTETAN",
        "forms": [
            {
                "orange_id": "65374-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 730,
        "type": "RX",
        "ingredient": "CEFOTETAN DISODIUM",
        "trade_name": "CEFOTETAN AND DEXTROSE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "65430-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 731,
        "type": "RX",
        "ingredient": "CEFOXITIN SODIUM",
        "trade_name": "CEFOXITIN",
        "forms": [
            {
                "orange_id": "65414-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 732,
        "type": "RX",
        "ingredient": "CEFOXITIN SODIUM",
        "trade_name": "CEFOXITIN AND DEXTROSE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "65214-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 733,
        "type": "RX",
        "ingredient": "CEFOXITIN SODIUM",
        "trade_name": "CEFOXITIN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "200938-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 100GM BASE"
                ]
            }
        ]
    },
    {
        "id": 734,
        "type": "RX",
        "ingredient": "CEFPODOXIME PROXETIL",
        "trade_name": "CEFPODOXIME PROXETIL",
        "forms": [
            {
                "orange_id": "65409-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE/5ML",
                    "EQ 100MG BASE/5ML"
                ]
            },
            {
                "orange_id": "65370-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 735,
        "type": "RX",
        "ingredient": "CEFPROZIL",
        "trade_name": "CEFPROZIL",
        "forms": [
            {
                "orange_id": "65351-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            },
            {
                "orange_id": "65327-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 736,
        "type": "RX",
        "ingredient": "CEFTAROLINE FOSAMIL",
        "trade_name": "CEFTAROLINE FOSAMIL",
        "forms": [
            {
                "orange_id": "208075-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "400MG/VIAL",
                    "600MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 737,
        "type": "RX",
        "ingredient": "CEFTAROLINE FOSAMIL",
        "trade_name": "TEFLARO",
        "forms": [
            {
                "orange_id": "200327-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "400MG/VIAL",
                    "600MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 738,
        "type": "RX",
        "ingredient": "CEFTAZIDIME",
        "trade_name": "CEFTAZIDIME",
        "forms": [
            {
                "orange_id": "62640-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL",
                    "6GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 739,
        "type": "RX",
        "ingredient": "CEFTAZIDIME",
        "trade_name": "CEFTAZIDIME IN DEXTROSE CONTAINER",
        "forms": [
            {
                "orange_id": "50823-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 2GM BASE"
                ]
            }
        ]
    },
    {
        "id": 740,
        "type": "RX",
        "ingredient": "CEFTAZIDIME",
        "trade_name": "FORTAZ",
        "forms": [
            {
                "orange_id": "50578-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL",
                    "6GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 741,
        "type": "RX",
        "ingredient": "CEFTAZIDIME",
        "trade_name": "TAZICEF",
        "forms": [
            {
                "orange_id": "62662-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL",
                    "6GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 742,
        "type": "RX",
        "ingredient": "CEFTOLOZANE SULFATE AND TAZOBACTAM SODIUM",
        "trade_name": "ZERBAXA",
        "forms": [
            {
                "orange_id": "206829-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL-EQ 0.5GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 743,
        "type": "RX",
        "ingredient": "CEFTRIAXONE SODIUM",
        "trade_name": "CEFTRIAXONE",
        "forms": [
            {
                "orange_id": "65329-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 100GM BASE/VIAL"
                ]
            },
            {
                "orange_id": "65305-3",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 250MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 744,
        "type": "RX",
        "ingredient": "CEFTRIAXONE SODIUM",
        "trade_name": "CEFTRIAXONE AND DEXTROSE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "50796-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 745,
        "type": "RX",
        "ingredient": "CEFTRIAXONE SODIUM",
        "trade_name": "CEFTRIAXONE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "65224-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/ML",
                    "EQ 40MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 746,
        "type": "RX",
        "ingredient": "CEFTRIAXONE SODIUM",
        "trade_name": "CEFTRIAXONE SODIUM",
        "forms": [
            {
                "orange_id": "91117-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 747,
        "type": "RX",
        "ingredient": "CEFUROXIME AXETIL",
        "trade_name": "CEFUROXIME AXETIL",
        "forms": [
            {
                "orange_id": "65496-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE",
                    "EQ 125MG BASE"
                ]
            }
        ]
    },
    {
        "id": 748,
        "type": "RX",
        "ingredient": "CEFUROXIME SODIUM",
        "trade_name": "CEFUROXIME AND DEXTROSE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "50780-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1.5GM BASE/VIAL",
                    "EQ 750MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 749,
        "type": "RX",
        "ingredient": "CEFUROXIME SODIUM",
        "trade_name": "CEFUROXIME SODIUM",
        "forms": [
            {
                "orange_id": "64125-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1.5GM BASE/VIAL",
                    "EQ 7.5GM BASE/VIAL"
                ]
            },
            {
                "orange_id": "64125-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 750MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 750,
        "type": "RX",
        "ingredient": "CEFUROXIME SODIUM",
        "trade_name": "ZINACEF",
        "forms": [
            {
                "orange_id": "50558-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1.5GM BASE/VIAL",
                    "EQ 7.5GM BASE/VIAL"
                ]
            },
            {
                "orange_id": "50558-2",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 750MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 751,
        "type": "RX",
        "ingredient": "CELECOXIB",
        "trade_name": "CELEBREX",
        "forms": [
            {
                "orange_id": "20998-4",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 752,
        "type": "RX",
        "ingredient": "CELECOXIB",
        "trade_name": "CELECOXIB",
        "forms": [
            {
                "orange_id": "204519-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 753,
        "type": "RX",
        "ingredient": "CELECOXIB",
        "trade_name": "ELYXYB",
        "forms": [
            {
                "orange_id": "212157-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 754,
        "type": "RX",
        "ingredient": "CELECOXIB AND TRAMADOL HYDROCHLORIDE",
        "trade_name": "SEGLENTIS",
        "forms": [
            {
                "orange_id": "213426-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "56MG-44MG"
                ]
            }
        ]
    },
    {
        "id": 755,
        "type": "RX",
        "ingredient": "CENOBAMATE",
        "trade_name": "XCOPRI",
        "forms": [
            {
                "orange_id": "212839-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 756,
        "type": "RX",
        "ingredient": "CEPHALEXIN",
        "trade_name": "CEPHALEXIN",
        "forms": [
            {
                "orange_id": "90836-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 333MG BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE"
                ]
            },
            {
                "orange_id": "210221-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG BASE/5ML",
                    "EQ 250MG BASE/5ML"
                ]
            },
            {
                "orange_id": "63023-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 757,
        "type": "RX",
        "ingredient": "CERITINIB",
        "trade_name": "ZYKADIA",
        "forms": [
            {
                "orange_id": "211225-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 758,
        "type": "RX",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CETIRIZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90766-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "213557-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 759,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CETIRIZINE HYDROCHLORIDE ALLERGY",
        "forms": [
            {
                "orange_id": "207235-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "205490-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "78780-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 760,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CETIRIZINE HYDROCHLORIDE HIVES",
        "forms": [
            {
                "orange_id": "78343-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 761,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CETIRIZINE HYDROCHLORIDE HIVES RELIEF",
        "forms": [
            {
                "orange_id": "209107-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "78780-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 762,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S CETIRIZINE HYDROCHLORIDE ALLERGY",
        "forms": [
            {
                "orange_id": "90765-2",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "91116-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 763,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S CETIRIZINE HYDROCHLORIDE HIVES RELIEF",
        "forms": [
            {
                "orange_id": "90765-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "91116-3",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 764,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ZYRTEC ALLERGY",
        "forms": [
            {
                "orange_id": "22155-2",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 765,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ZYRTEC HIVES RELIEF",
        "forms": [
            {
                "orange_id": "22155-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 766,
        "type": "RX",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "QUZYTTIR",
        "forms": [
            {
                "orange_id": "211415-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 767,
        "type": "RX",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "ZERVIATE",
        "forms": [
            {
                "orange_id": "208694-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.24% BASE"
                ]
            }
        ]
    },
    {
        "id": 768,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE",
        "trade_name": "ZYRTEC ALLERGY",
        "forms": [
            {
                "orange_id": "22578-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "19835-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 769,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "CETIRIZINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77170-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 770,
        "type": "OTC",
        "ingredient": "CETIRIZINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "ZYRTEC-D 12 HOUR",
        "forms": [
            {
                "orange_id": "21150-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 771,
        "type": "RX",
        "ingredient": "CETRORELIX",
        "trade_name": "CETROTIDE",
        "forms": [
            {
                "orange_id": "21197-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.25MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 772,
        "type": "RX",
        "ingredient": "CEVIMELINE HYDROCHLORIDE",
        "trade_name": "CEVIMELINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91591-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 773,
        "type": "RX",
        "ingredient": "CEVIMELINE HYDROCHLORIDE",
        "trade_name": "EVOXAC",
        "forms": [
            {
                "orange_id": "20989-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 774,
        "type": "RX",
        "ingredient": "CHENODIOL",
        "trade_name": "CHENODIOL",
        "forms": [
            {
                "orange_id": "91019-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 775,
        "type": "RX",
        "ingredient": "CHLORAMBUCIL",
        "trade_name": "LEUKERAN",
        "forms": [
            {
                "orange_id": "10669-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 776,
        "type": "RX",
        "ingredient": "CHLORAMPHENICOL SODIUM SUCCINATE",
        "trade_name": "CHLORAMPHENICOL SODIUM SUCCINATE",
        "forms": [
            {
                "orange_id": "62365-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 777,
        "type": "RX",
        "ingredient": "CHLORDIAZEPOXIDE HYDROCHLORIDE",
        "trade_name": "CHLORDIAZEPOXIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "84768-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 778,
        "type": "RX",
        "ingredient": "CHLORDIAZEPOXIDE HYDROCHLORIDE",
        "trade_name": "LIBRIUM",
        "forms": [
            {
                "orange_id": "85461-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 779,
        "type": "RX",
        "ingredient": "CHLORDIAZEPOXIDE HYDROCHLORIDE AND CLIDINIUM BROMIDE",
        "trade_name": "CHLORDIAZEPOXIDE HYDROCHLORIDE AND CLIDINIUM BROMIDE",
        "forms": [
            {
                "orange_id": "214065-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 780,
        "type": "RX",
        "ingredient": "CHLORDIAZEPOXIDE HYDROCHLORIDE AND CLIDINIUM BROMIDE",
        "trade_name": "LIBRAX",
        "forms": [
            {
                "orange_id": "12750-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG-2.5MG"
                ]
            }
        ]
    },
    {
        "id": 781,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "BIOSCRUB",
        "forms": [
            {
                "orange_id": "19822-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 782,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "CHG SCRUB",
        "forms": [
            {
                "orange_id": "19258-2",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 783,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "CHLORHEXIDINE GLUCONATE",
        "forms": [
            {
                "orange_id": "21669-1",
                "form": "CLOTH",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "74356-1",
                "form": "SOLUTION",
                "route": "DENTAL",
                "dosage": [
                    "0.12%"
                ]
            },
            {
                "orange_id": "20111-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%"
                ]
            },
            {
                "orange_id": "72525-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 784,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "CIDA-STAT",
        "forms": [
            {
                "orange_id": "19258-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 785,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "EXIDINE",
        "forms": [
            {
                "orange_id": "19127-1",
                "form": "AEROSOL, METERED",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            },
            {
                "orange_id": "19422-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%",
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 786,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "HIBICLENS",
        "forms": [
            {
                "orange_id": "17768-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 787,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "HIBISTAT",
        "forms": [
            {
                "orange_id": "18300-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 788,
        "type": "RX",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "PAROEX",
        "forms": [
            {
                "orange_id": "76434-1",
                "form": "SOLUTION",
                "route": "DENTAL",
                "dosage": [
                    "0.12%"
                ]
            }
        ]
    },
    {
        "id": 789,
        "type": "RX",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "PERIDEX",
        "forms": [
            {
                "orange_id": "19028-1",
                "form": "SOLUTION",
                "route": "DENTAL",
                "dosage": [
                    "0.12%"
                ]
            }
        ]
    },
    {
        "id": 790,
        "type": "RX",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "PERIOCHIP",
        "forms": [
            {
                "orange_id": "20774-1",
                "form": "TABLET",
                "route": "DENTAL",
                "dosage": [
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 791,
        "type": "RX",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "PERIOGARD",
        "forms": [
            {
                "orange_id": "73695-1",
                "form": "SOLUTION",
                "route": "DENTAL",
                "dosage": [
                    "0.12%"
                ]
            }
        ]
    },
    {
        "id": 792,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE",
        "trade_name": "READYPREP CHG",
        "forms": [
            {
                "orange_id": "207964-1",
                "form": "CLOTH",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 793,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP ONE-STEP",
        "forms": [
            {
                "orange_id": "20832-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (3ML)",
                    "2%-70% (10.5ML)",
                    "2%-70% (26ML)",
                    "2%-70% (1ML)"
                ]
            }
        ]
    },
    {
        "id": 794,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP ONE-STEP FREPP",
        "forms": [
            {
                "orange_id": "20832-3",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (1.5ML)"
                ]
            }
        ]
    },
    {
        "id": 795,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP ONE-STEP SEPP",
        "forms": [
            {
                "orange_id": "21555-1",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (0.67ML)"
                ]
            }
        ]
    },
    {
        "id": 796,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP SINGLE SWABSTICK",
        "forms": [
            {
                "orange_id": "21555-2",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (1.75ML)"
                ]
            }
        ]
    },
    {
        "id": 797,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP TRIPLE SWABSTICK",
        "forms": [
            {
                "orange_id": "21555-3",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (5.25ML)"
                ]
            }
        ]
    },
    {
        "id": 798,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "CHLORAPREP WITH TINT",
        "forms": [
            {
                "orange_id": "20832-2",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70% (26ML)",
                    "2%-70% (10.5ML)",
                    "2%-70% (3ML)"
                ]
            }
        ]
    },
    {
        "id": 799,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "PREVANTICS MAXI SWABSTICK",
        "forms": [
            {
                "orange_id": "21524-3",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "3.15%-70% (5.1ML)"
                ]
            }
        ]
    },
    {
        "id": 800,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "PREVANTICS SWAB",
        "forms": [
            {
                "orange_id": "21524-1",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "3.15%-70% (1ML)"
                ]
            }
        ]
    },
    {
        "id": 801,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "PREVANTICS SWABSTICK",
        "forms": [
            {
                "orange_id": "21524-2",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "3.15%-70% (1.6ML)"
                ]
            }
        ]
    },
    {
        "id": 802,
        "type": "OTC",
        "ingredient": "CHLORHEXIDINE GLUCONATE AND ISOPROPYL ALCOHOL",
        "trade_name": "SOLUPREP",
        "forms": [
            {
                "orange_id": "208288-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%-70%"
                ]
            }
        ]
    },
    {
        "id": 803,
        "type": "RX",
        "ingredient": "CHLOROPROCAINE HYDROCHLORIDE",
        "trade_name": "CHLOROPROCAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40273-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2%",
                    "3%"
                ]
            }
        ]
    },
    {
        "id": 804,
        "type": "RX",
        "ingredient": "CHLOROPROCAINE HYDROCHLORIDE",
        "trade_name": "CLOROTEKAL",
        "forms": [
            {
                "orange_id": "208791-1",
                "form": "SOLUTION",
                "route": "INTRATHECAL",
                "dosage": [
                    "50MG/5ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 805,
        "type": "RX",
        "ingredient": "CHLOROPROCAINE HYDROCHLORIDE",
        "trade_name": "NESACAINE",
        "forms": [
            {
                "orange_id": "9435-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 806,
        "type": "RX",
        "ingredient": "CHLOROPROCAINE HYDROCHLORIDE",
        "trade_name": "NESACAINE-MPF",
        "forms": [
            {
                "orange_id": "9435-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2%",
                    "3%"
                ]
            }
        ]
    },
    {
        "id": 807,
        "type": "RX",
        "ingredient": "CHLOROQUINE PHOSPHATE",
        "trade_name": "CHLOROQUINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "90610-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 808,
        "type": "RX",
        "ingredient": "CHLOROTHIAZIDE",
        "trade_name": "DIURIL",
        "forms": [
            {
                "orange_id": "11870-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 809,
        "type": "RX",
        "ingredient": "CHLOROTHIAZIDE SODIUM",
        "trade_name": "CHLOROTHIAZIDE SODIUM",
        "forms": [
            {
                "orange_id": "202561-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 810,
        "type": "RX",
        "ingredient": "CHLOROTHIAZIDE SODIUM",
        "trade_name": "DIURIL",
        "forms": [
            {
                "orange_id": "11145-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 811,
        "type": "OTC",
        "ingredient": "CHLORPHENIRAMINE MALEATE",
        "trade_name": "CHLORPHENIRAMINE MALEATE",
        "forms": [
            {
                "orange_id": "40829-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 812,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE MALEATE AND CODEINE PHOSPHATE",
        "trade_name": "TUXARIN ER",
        "forms": [
            {
                "orange_id": "206323-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MG-54.3MG"
                ]
            }
        ]
    },
    {
        "id": 813,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE MALEATE, HYDROCODONE BITARTRATE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "HYDROCODONE BITARTRATE, CHLORPHENIRAMINE MALEATE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204627-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4MG/5ML-5MG/5ML-60MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 814,
        "type": "OTC",
        "ingredient": "CHLORPHENIRAMINE MALEATE, IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "ADVIL ALLERGY AND CONGESTION RELIEF",
        "forms": [
            {
                "orange_id": "22113-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG-200MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 815,
        "type": "OTC",
        "ingredient": "CHLORPHENIRAMINE MALEATE, IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "ADVIL MULTI-SYMPTOM COLD & FLU",
        "forms": [
            {
                "orange_id": "22113-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG-200MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 816,
        "type": "OTC",
        "ingredient": "CHLORPHENIRAMINE MALEATE, IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "ADVIL ALLERGY SINUS",
        "forms": [
            {
                "orange_id": "21441-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG-200MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 817,
        "type": "OTC",
        "ingredient": "CHLORPHENIRAMINE MALEATE, IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ADVIL ALLERGY SINUS",
        "forms": [
            {
                "orange_id": "21587-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/5ML-100MG/5ML-15MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 818,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE POLISTIREX AND CODEINE POLISTIREX",
        "trade_name": "TUZISTRA XR",
        "forms": [
            {
                "orange_id": "207768-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.8MG BASE/5ML-EQ 14.7MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 819,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE POLISTIREX AND HYDROCODONE POLISTIREX",
        "trade_name": "HYDROCODONE POLISTIREX AND CHLORPHENIRAMINE POLISTIREX",
        "forms": [
            {
                "orange_id": "91632-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 8MG MALEATE/5ML-EQ 10MG BITARTRATE/5ML"
                ]
            }
        ]
    },
    {
        "id": 820,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE POLISTIREX AND HYDROCODONE POLISTIREX",
        "trade_name": "HYDROCODONE POLISTIREX AND CHLORPHENIRAMNE POLISTIREX",
        "forms": [
            {
                "orange_id": "91671-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 8MG MALEATE/5ML-EQ 10MG BITARTRATE/5ML"
                ]
            }
        ]
    },
    {
        "id": 821,
        "type": "RX",
        "ingredient": "CHLORPHENIRAMINE POLISTIREX AND HYDROCODONE POLISTIREX",
        "trade_name": "TUSSICAPS",
        "forms": [
            {
                "orange_id": "77273-2",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG MALEATE-EQ 5MG BITARTRATE",
                    "EQ 8MG MALEATE-EQ 10MG BITARTRATE"
                ]
            }
        ]
    },
    {
        "id": 822,
        "type": "RX",
        "ingredient": "CHLORPROMAZINE HYDROCHLORIDE",
        "trade_name": "CHLORPROMAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "214542-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "30MG/ML",
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "211816-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML"
                ]
            },
            {
                "orange_id": "209755-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 823,
        "type": "RX",
        "ingredient": "CHLORTHALIDONE",
        "trade_name": "CHLORTHALIDONE",
        "forms": [
            {
                "orange_id": "214129-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 824,
        "type": "RX",
        "ingredient": "CHLORTHALIDONE",
        "trade_name": "THALITONE",
        "forms": [
            {
                "orange_id": "19574-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 825,
        "type": "RX",
        "ingredient": "CHLORZOXAZONE",
        "trade_name": "CHLORZOXAZONE",
        "forms": [
            {
                "orange_id": "89853-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "375MG",
                    "750MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 826,
        "type": "RX",
        "ingredient": "CHOLESTYRAMINE",
        "trade_name": "CHOLESTYRAMINE",
        "forms": [
            {
                "orange_id": "211119-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 4GM RESIN/PACKET",
                    "EQ 4GM RESIN/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 827,
        "type": "RX",
        "ingredient": "CHOLESTYRAMINE",
        "trade_name": "CHOLESTYRAMINE LIGHT",
        "forms": [
            {
                "orange_id": "211799-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 4GM RESIN/PACKET",
                    "EQ 4GM RESIN/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 828,
        "type": "RX",
        "ingredient": "CHOLESTYRAMINE",
        "trade_name": "PREVALITE",
        "forms": [
            {
                "orange_id": "73263-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 4GM RESIN/PACKET",
                    "EQ 4GM RESIN/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 829,
        "type": "RX",
        "ingredient": "CHOLIC ACID",
        "trade_name": "CHOLBAM",
        "forms": [
            {
                "orange_id": "205750-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 830,
        "type": "RX",
        "ingredient": "CHOLINE C-11",
        "trade_name": "CHOLINE C-11",
        "forms": [
            {
                "orange_id": "206319-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "4-33.1mCi/ML",
                    "4-100mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 831,
        "type": "RX",
        "ingredient": "CHOLINE FENOFIBRATE",
        "trade_name": "FENOFIBRIC ACID",
        "forms": [
            {
                "orange_id": "200920-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 45MG FENOFIBRIC ACID",
                    "EQ 135MG FENOFIBRIC ACID"
                ]
            }
        ]
    },
    {
        "id": 832,
        "type": "RX",
        "ingredient": "CHOLINE FENOFIBRATE",
        "trade_name": "TRILIPIX",
        "forms": [
            {
                "orange_id": "22224-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 45MG FENOFIBRIC ACID",
                    "EQ 135MG FENOFIBRIC ACID"
                ]
            }
        ]
    },
    {
        "id": 833,
        "type": "RX",
        "ingredient": "CHROMIC CHLORIDE",
        "trade_name": "CHROMIC CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18961-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.004MG CHROMIUM/ML"
                ]
            }
        ]
    },
    {
        "id": 834,
        "type": "RX",
        "ingredient": "CICLESONIDE",
        "trade_name": "ALVESCO",
        "forms": [
            {
                "orange_id": "21658-2",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.08MG/INH",
                    "0.16MG/INH"
                ]
            }
        ]
    },
    {
        "id": 835,
        "type": "RX",
        "ingredient": "CICLESONIDE",
        "trade_name": "OMNARIS",
        "forms": [
            {
                "orange_id": "22004-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 836,
        "type": "RX",
        "ingredient": "CICLESONIDE",
        "trade_name": "ZETONNA",
        "forms": [
            {
                "orange_id": "202129-1",
                "form": "AEROSOL, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.037MG/INH"
                ]
            }
        ]
    },
    {
        "id": 837,
        "type": "RX",
        "ingredient": "CICLOPIROX",
        "trade_name": "CICLOPIROX",
        "forms": [
            {
                "orange_id": "78463-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.77%"
                ]
            },
            {
                "orange_id": "20519-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.77%"
                ]
            },
            {
                "orange_id": "90490-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "78172-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "8%"
                ]
            },
            {
                "orange_id": "76422-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.77%"
                ]
            }
        ]
    },
    {
        "id": 838,
        "type": "RX",
        "ingredient": "CICLOPIROX",
        "trade_name": "LOPROX",
        "forms": [
            {
                "orange_id": "18748-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.77%"
                ]
            },
            {
                "orange_id": "21159-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "19824-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.77%"
                ]
            }
        ]
    },
    {
        "id": 839,
        "type": "RX",
        "ingredient": "CICLOPIROX",
        "trade_name": "PENLAC",
        "forms": [
            {
                "orange_id": "21022-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "8%"
                ]
            }
        ]
    },
    {
        "id": 840,
        "type": "RX",
        "ingredient": "CIDOFOVIR",
        "trade_name": "CIDOFOVIR",
        "forms": [
            {
                "orange_id": "202501-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 75MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 841,
        "type": "RX",
        "ingredient": "CILASTATIN SODIUM AND IMIPENEM",
        "trade_name": "IMIPENEM AND CILASTATIN",
        "forms": [
            {
                "orange_id": "90577-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 250MG BASE/VIAL-250MG/VIAL",
                    "EQ 500MG BASE/VIAL-500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 842,
        "type": "RX",
        "ingredient": "CILASTATIN SODIUM AND IMIPENEM",
        "trade_name": "PRIMAXIN",
        "forms": [
            {
                "orange_id": "50587-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/VIAL-500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 843,
        "type": "RX",
        "ingredient": "CILASTATIN SODIUM, IMIPENEM AND RELEBACTAM",
        "trade_name": "RECARBRIO",
        "forms": [
            {
                "orange_id": "212819-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/VIAL-500MG/VIAL-250MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 844,
        "type": "RX",
        "ingredient": "CILOSTAZOL",
        "trade_name": "CILOSTAZOL",
        "forms": [
            {
                "orange_id": "77030-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 845,
        "type": "OTC",
        "ingredient": "CIMETIDINE",
        "trade_name": "CIMETIDINE",
        "forms": [
            {
                "orange_id": "74948-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG",
                    "400MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 846,
        "type": "OTC",
        "ingredient": "CIMETIDINE",
        "trade_name": "TAGAMET HB",
        "forms": [
            {
                "orange_id": "20238-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 847,
        "type": "RX",
        "ingredient": "CIMETIDINE HYDROCHLORIDE",
        "trade_name": "CIMETIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74664-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 848,
        "type": "RX",
        "ingredient": "CINACALCET HYDROCHLORIDE",
        "trade_name": "CINACALCET HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "211892-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE",
                    "EQ 60MG BASE",
                    "EQ 90MG BASE",
                    "30MG",
                    "60MG",
                    "90MG"
                ]
            }
        ]
    },
    {
        "id": 849,
        "type": "RX",
        "ingredient": "CINACALCET HYDROCHLORIDE",
        "trade_name": "SENSIPAR",
        "forms": [
            {
                "orange_id": "21688-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE",
                    "EQ 60MG BASE",
                    "EQ 90MG BASE"
                ]
            }
        ]
    },
    {
        "id": 850,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN",
        "trade_name": "CIPRO",
        "forms": [
            {
                "orange_id": "20780-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML",
                    "500MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 851,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN",
        "trade_name": "CIPROFLOXACIN",
        "forms": [
            {
                "orange_id": "78062-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/20ML (10MG/ML)",
                    "400MG/40ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 852,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN",
        "trade_name": "CIPROFLOXACIN IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "78024-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML",
                    "400MG/200ML"
                ]
            }
        ]
    },
    {
        "id": 853,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN",
        "trade_name": "OTIPRIO",
        "forms": [
            {
                "orange_id": "207986-1",
                "form": "INJECTABLE, SUSPENSION",
                "route": "OTIC",
                "dosage": [
                    "6% (60MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 854,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE",
        "trade_name": "CETRAXAL",
        "forms": [
            {
                "orange_id": "21918-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "EQ 0.2% BASE"
                ]
            }
        ]
    },
    {
        "id": 855,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE",
        "trade_name": "CILOXAN",
        "forms": [
            {
                "orange_id": "20369-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            },
            {
                "orange_id": "19992-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            }
        ]
    },
    {
        "id": 856,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE",
        "trade_name": "CIPRO",
        "forms": [
            {
                "orange_id": "19537-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 857,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE",
        "trade_name": "CIPROFLOXACIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76555-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            },
            {
                "orange_id": "77859-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 858,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE AND FLUOCINOLONE ACETONIDE",
        "trade_name": "OTOVEL",
        "forms": [
            {
                "orange_id": "208251-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "EQ 0.3% BASE-0.025%"
                ]
            }
        ]
    },
    {
        "id": 859,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN HYDROCHLORIDE AND HYDROCORTISONE",
        "trade_name": "CIPRO HC",
        "forms": [
            {
                "orange_id": "20805-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "EQ 0.2% BASE-1%"
                ]
            }
        ]
    },
    {
        "id": 860,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN AND CIPROFLOXACIN HYDROCHLORIDE",
        "trade_name": "CIPROFLOXACIN EXTENDED RELEASE",
        "forms": [
            {
                "orange_id": "78166-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "212.6MG-EQ 287.5MG BASE",
                    "425.2MG-EQ 574.9MG BASE"
                ]
            }
        ]
    },
    {
        "id": 861,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN AND DEXAMETHASONE",
        "trade_name": "CIPRODEX",
        "forms": [
            {
                "orange_id": "21537-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.3%-0.1%"
                ]
            }
        ]
    },
    {
        "id": 862,
        "type": "RX",
        "ingredient": "CIPROFLOXACIN AND DEXAMETHASONE",
        "trade_name": "CIPROFLOXACIN AND DEXAMETHASONE",
        "forms": [
            {
                "orange_id": "205548-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.3%-0.1%"
                ]
            }
        ]
    },
    {
        "id": 863,
        "type": "RX",
        "ingredient": "CISATRACURIUM BESYLATE",
        "trade_name": "CISATRACURIUM BESYLATE",
        "forms": [
            {
                "orange_id": "209144-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML",
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 864,
        "type": "RX",
        "ingredient": "CISATRACURIUM BESYLATE",
        "trade_name": "CISATRACURIUM BESYLATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "209665-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML",
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 865,
        "type": "RX",
        "ingredient": "CISATRACURIUM BESYLATE",
        "trade_name": "NIMBEX",
        "forms": [
            {
                "orange_id": "20551-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 866,
        "type": "RX",
        "ingredient": "CISATRACURIUM BESYLATE",
        "trade_name": "NIMBEX PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "20551-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML",
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 867,
        "type": "RX",
        "ingredient": "CISPLATIN",
        "trade_name": "CISPLATIN",
        "forms": [
            {
                "orange_id": "206774-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 868,
        "type": "RX",
        "ingredient": "CITALOPRAM HYDROBROMIDE",
        "trade_name": "CELEXA",
        "forms": [
            {
                "orange_id": "20822-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 869,
        "type": "RX",
        "ingredient": "CITALOPRAM HYDROBROMIDE",
        "trade_name": "CITALOPRAM HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "215428-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE"
                ]
            },
            {
                "orange_id": "77812-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/5ML"
                ]
            },
            {
                "orange_id": "77289-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 870,
        "type": "RX",
        "ingredient": "CITRIC ACID, GLUCONOLACTONE AND MAGNESIUM CARBONATE",
        "trade_name": "RENACIDIN",
        "forms": [
            {
                "orange_id": "19481-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "6.602GM/100ML-198MG/100ML-3.177GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 871,
        "type": "RX",
        "ingredient": "CITRIC ACID, LACTIC ACID AND POTASSIUM BITARTRATE",
        "trade_name": "PHEXXI",
        "forms": [
            {
                "orange_id": "208352-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "1%-1.8%-0.4%"
                ]
            }
        ]
    },
    {
        "id": 872,
        "type": "RX",
        "ingredient": "CITRIC ACID, MAGNESIUM OXIDE AND SODIUM PICOSULFATE",
        "trade_name": "CLENPIQ",
        "forms": [
            {
                "orange_id": "209589-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "12GM/BOT-3.5GM/BOT-10MG/BOT"
                ]
            }
        ]
    },
    {
        "id": 873,
        "type": "RX",
        "ingredient": "CITRIC ACID AND UREA C-13",
        "trade_name": "IDKIT:HP",
        "forms": [
            {
                "orange_id": "21314-1",
                "form": "FOR SOLUTION, TABLET, FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4GM-75MG"
                ]
            }
        ]
    },
    {
        "id": 874,
        "type": "RX",
        "ingredient": "CLADRIBINE",
        "trade_name": "CLADRIBINE",
        "forms": [
            {
                "orange_id": "76571-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 875,
        "type": "RX",
        "ingredient": "CLADRIBINE",
        "trade_name": "MAVENCLAD",
        "forms": [
            {
                "orange_id": "22561-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 876,
        "type": "RX",
        "ingredient": "CLARITHROMYCIN",
        "trade_name": "CLARITHROMYCIN",
        "forms": [
            {
                "orange_id": "65283-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML",
                    "250MG/5ML"
                ]
            },
            {
                "orange_id": "65145-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            },
            {
                "orange_id": "210459-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 877,
        "type": "RX",
        "ingredient": "CLASCOTERONE",
        "trade_name": "WINLEVI",
        "forms": [
            {
                "orange_id": "213433-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 878,
        "type": "RX",
        "ingredient": "CLEMASTINE FUMARATE",
        "trade_name": "CLEMASTINE FUMARATE",
        "forms": [
            {
                "orange_id": "73399-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE/5ML"
                ]
            },
            {
                "orange_id": "74512-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.34MG",
                    "2.68MG"
                ]
            }
        ]
    },
    {
        "id": 879,
        "type": "RX",
        "ingredient": "CLEVIDIPINE",
        "trade_name": "CLEVIPREX",
        "forms": [
            {
                "orange_id": "22156-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "25MG/50ML (0.5MG/ML)",
                    "50MG/100ML (0.5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 880,
        "type": "RX",
        "ingredient": "CLINDAMYCIN HYDROCHLORIDE",
        "trade_name": "CLEOCIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "50162-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 150MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 881,
        "type": "RX",
        "ingredient": "CLINDAMYCIN HYDROCHLORIDE",
        "trade_name": "CLINDAMYCIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65442-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 300MG BASE",
                    "EQ 75MG BASE"
                ]
            }
        ]
    },
    {
        "id": 882,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PALMITATE HYDROCHLORIDE",
        "trade_name": "CLEOCIN",
        "forms": [
            {
                "orange_id": "62644-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 883,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PALMITATE HYDROCHLORIDE",
        "trade_name": "CLINDAMYCIN PALMITATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206958-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 884,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLEOCIN",
        "forms": [
            {
                "orange_id": "50680-2",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "EQ 2% BASE"
                ]
            },
            {
                "orange_id": "50767-1",
                "form": "SUPPOSITORY",
                "route": "VAGINAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 885,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLEOCIN PHOSPHATE",
        "forms": [
            {
                "orange_id": "62803-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 150MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 886,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLEOCIN T",
        "forms": [
            {
                "orange_id": "50615-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            },
            {
                "orange_id": "50600-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 887,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDA-DERM",
        "forms": [
            {
                "orange_id": "63329-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 888,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAGEL",
        "forms": [
            {
                "orange_id": "50782-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 889,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAMYCIN PHOSPHATE",
        "forms": [
            {
                "orange_id": "210778-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "65139-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "EQ 2% BASE"
                ]
            },
            {
                "orange_id": "212438-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            },
            {
                "orange_id": "62800-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 150MG BASE/ML"
                ]
            },
            {
                "orange_id": "215607-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            },
            {
                "orange_id": "208767-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            },
            {
                "orange_id": "65513-1",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 890,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAMYCIN PHOSPHATE IN 0. 9% SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "208083-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 300MG BASE/50ML (EQ 6MG BASE/ML)",
                    "EQ 600MG BASE/50ML (EQ 12MG BASE/ML)",
                    "EQ 900MG BASE/50ML (EQ 18MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 891,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAMYCIN PHOSPHATE IN 5% DEXTROSE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "203048-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 6MG BASE/ML",
                    "EQ 12MG BASE/ML",
                    "EQ 18MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 892,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDAMYCIN PHOSPHATE IN DEXTROSE 5%",
        "forms": [
            {
                "orange_id": "50635-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 900MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 893,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDESSE",
        "forms": [
            {
                "orange_id": "50793-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "EQ 2% BASE"
                ]
            }
        ]
    },
    {
        "id": 894,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "CLINDETS",
        "forms": [
            {
                "orange_id": "64136-1",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 895,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "EVOCLIN",
        "forms": [
            {
                "orange_id": "50801-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 896,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE",
        "trade_name": "XACIATO",
        "forms": [
            {
                "orange_id": "215650-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "EQ 2% BASE"
                ]
            }
        ]
    },
    {
        "id": 897,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE AND TRETINOIN",
        "trade_name": "CLINDAMYCIN PHOSPHATE AND TRETINOIN",
        "forms": [
            {
                "orange_id": "202564-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1.2%-0.025%"
                ]
            }
        ]
    },
    {
        "id": 898,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE AND TRETINOIN",
        "trade_name": "VELTIN",
        "forms": [
            {
                "orange_id": "50803-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1.2%-0.025%"
                ]
            }
        ]
    },
    {
        "id": 899,
        "type": "RX",
        "ingredient": "CLINDAMYCIN PHOSPHATE AND TRETINOIN",
        "trade_name": "ZIANA",
        "forms": [
            {
                "orange_id": "50802-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1.2%-0.025%"
                ]
            }
        ]
    },
    {
        "id": 900,
        "type": "RX",
        "ingredient": "CLOBAZAM",
        "trade_name": "CLOBAZAM",
        "forms": [
            {
                "orange_id": "213039-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/ML"
                ]
            },
            {
                "orange_id": "212714-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 901,
        "type": "RX",
        "ingredient": "CLOBAZAM",
        "trade_name": "ONFI",
        "forms": [
            {
                "orange_id": "203993-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/ML"
                ]
            },
            {
                "orange_id": "202067-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 902,
        "type": "RX",
        "ingredient": "CLOBAZAM",
        "trade_name": "SYMPAZAN",
        "forms": [
            {
                "orange_id": "210833-1",
                "form": "FILM",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 903,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "CLOBETASOL PROPIONATE",
        "forms": [
            {
                "orange_id": "210809-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "213291-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "75368-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "78223-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "211800-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "78854-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "212881-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "211191-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 904,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "CLOBETASOL PROPIONATE (EMOLLIENT)",
        "forms": [
            {
                "orange_id": "75733-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 905,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "CLOBEX",
        "forms": [
            {
                "orange_id": "21535-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "21644-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "21835-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 906,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "CORMAX",
        "forms": [
            {
                "orange_id": "74220-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 907,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "EMBELINE",
        "forms": [
            {
                "orange_id": "76141-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "74221-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "74222-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 908,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "EMBELINE E",
        "forms": [
            {
                "orange_id": "75325-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 909,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "IMPEKLO",
        "forms": [
            {
                "orange_id": "213691-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 910,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "IMPOYZ",
        "forms": [
            {
                "orange_id": "209483-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 911,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "OLUX",
        "forms": [
            {
                "orange_id": "21142-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 912,
        "type": "RX",
        "ingredient": "CLOBETASOL PROPIONATE",
        "trade_name": "OLUX E",
        "forms": [
            {
                "orange_id": "22013-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 913,
        "type": "RX",
        "ingredient": "CLOCORTOLONE PIVALATE",
        "trade_name": "CLOCORTOLONE PIVALATE",
        "forms": [
            {
                "orange_id": "206370-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 914,
        "type": "RX",
        "ingredient": "CLOCORTOLONE PIVALATE",
        "trade_name": "CLODERM",
        "forms": [
            {
                "orange_id": "17765-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 915,
        "type": "RX",
        "ingredient": "CLOFARABINE",
        "trade_name": "CLOFARABINE",
        "forms": [
            {
                "orange_id": "204029-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/20ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 916,
        "type": "RX",
        "ingredient": "CLOFARABINE",
        "trade_name": "CLOLAR",
        "forms": [
            {
                "orange_id": "21673-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/20ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 917,
        "type": "RX",
        "ingredient": "CLOMIPHENE CITRATE",
        "trade_name": "CLOMIPHENE CITRATE",
        "forms": [
            {
                "orange_id": "75528-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 918,
        "type": "RX",
        "ingredient": "CLOMIPRAMINE HYDROCHLORIDE",
        "trade_name": "ANAFRANIL",
        "forms": [
            {
                "orange_id": "19906-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 919,
        "type": "RX",
        "ingredient": "CLOMIPRAMINE HYDROCHLORIDE",
        "trade_name": "CLOMIPRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "213897-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 920,
        "type": "RX",
        "ingredient": "CLONAZEPAM",
        "trade_name": "CLONAZEPAM",
        "forms": [
            {
                "orange_id": "211033-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            },
            {
                "orange_id": "77147-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 921,
        "type": "RX",
        "ingredient": "CLONAZEPAM",
        "trade_name": "KLONOPIN",
        "forms": [
            {
                "orange_id": "17533-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 922,
        "type": "RX",
        "ingredient": "CLONIDINE",
        "trade_name": "CATAPRES-TTS-1",
        "forms": [
            {
                "orange_id": "18891-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.1MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 923,
        "type": "RX",
        "ingredient": "CLONIDINE",
        "trade_name": "CATAPRES-TTS-2",
        "forms": [
            {
                "orange_id": "18891-2",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.2MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 924,
        "type": "RX",
        "ingredient": "CLONIDINE",
        "trade_name": "CATAPRES-TTS-3",
        "forms": [
            {
                "orange_id": "18891-3",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.3MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 925,
        "type": "RX",
        "ingredient": "CLONIDINE",
        "trade_name": "CLONIDINE",
        "forms": [
            {
                "orange_id": "90873-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.1MG/24HR",
                    "0.2MG/24HR",
                    "0.3MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 926,
        "type": "RX",
        "ingredient": "CLONIDINE HYDROCHLORIDE",
        "trade_name": "CLONIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "200673-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/10ML (0.1MG/ML)",
                    "5MG/10ML (0.5MG/ML)"
                ]
            },
            {
                "orange_id": "202792-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.1MG"
                ]
            },
            {
                "orange_id": "70974-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 927,
        "type": "RX",
        "ingredient": "CLONIDINE HYDROCHLORIDE",
        "trade_name": "DURACLON",
        "forms": [
            {
                "orange_id": "20615-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/10ML (0.1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 928,
        "type": "RX",
        "ingredient": "CLONIDINE HYDROCHLORIDE",
        "trade_name": "KAPVAY",
        "forms": [
            {
                "orange_id": "22331-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.1MG"
                ]
            }
        ]
    },
    {
        "id": 929,
        "type": "RX",
        "ingredient": "CLOPIDOGREL BISULFATE",
        "trade_name": "CLOPIDOGREL BISULFATE",
        "forms": [
            {
                "orange_id": "202925-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 930,
        "type": "RX",
        "ingredient": "CLOPIDOGREL BISULFATE",
        "trade_name": "PLAVIX",
        "forms": [
            {
                "orange_id": "20839-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 931,
        "type": "RX",
        "ingredient": "CLORAZEPATE DIPOTASSIUM",
        "trade_name": "CLORAZEPATE DIPOTASSIUM",
        "forms": [
            {
                "orange_id": "71858-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3.75MG",
                    "7.5MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 932,
        "type": "RX",
        "ingredient": "CLORAZEPATE DIPOTASSIUM",
        "trade_name": "TRANXENE",
        "forms": [
            {
                "orange_id": "17105-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7.5MG"
                ]
            }
        ]
    },
    {
        "id": 933,
        "type": "RX",
        "ingredient": "CLOTRIMAZOLE",
        "trade_name": "CLOTRIMAZOLE",
        "forms": [
            {
                "orange_id": "78338-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "74165-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "209815-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "76387-1",
                "form": "TROCHE/LOZENGE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 934,
        "type": "OTC",
        "ingredient": "CLOTRIMAZOLE",
        "trade_name": "TRIVAGIZOLE 3",
        "forms": [
            {
                "orange_id": "21143-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 935,
        "type": "RX",
        "ingredient": "CLOZAPINE",
        "trade_name": "CLOZAPINE",
        "forms": [
            {
                "orange_id": "90308-3",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "202873-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG",
                    "50MG",
                    "200MG",
                    "12.5MG"
                ]
            }
        ]
    },
    {
        "id": 936,
        "type": "RX",
        "ingredient": "CLOZAPINE",
        "trade_name": "CLOZARIL",
        "forms": [
            {
                "orange_id": "19758-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 937,
        "type": "RX",
        "ingredient": "CLOZAPINE",
        "trade_name": "VERSACLOZ",
        "forms": [
            {
                "orange_id": "203479-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 938,
        "type": "RX",
        "ingredient": "COBICISTAT",
        "trade_name": "TYBOST",
        "forms": [
            {
                "orange_id": "203094-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 939,
        "type": "RX",
        "ingredient": "COBICISTAT AND DARUNAVIR",
        "trade_name": "PREZCOBIX",
        "forms": [
            {
                "orange_id": "205395-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-800MG"
                ]
            }
        ]
    },
    {
        "id": 940,
        "type": "RX",
        "ingredient": "COBICISTAT, DARUNAVIR, EMTRICITABINE AND TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "SYMTUZA",
        "forms": [
            {
                "orange_id": "210455-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-800MG-200MG-EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 941,
        "type": "RX",
        "ingredient": "COBICISTAT, ELVITEGRAVIR, EMTRICITABINE AND TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "GENVOYA",
        "forms": [
            {
                "orange_id": "207561-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-150MG-200MG-EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 942,
        "type": "RX",
        "ingredient": "COBICISTAT, ELVITEGRAVIR, EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "STRIBILD",
        "forms": [
            {
                "orange_id": "203100-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-150MG-200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 943,
        "type": "RX",
        "ingredient": "COBIMETINIB FUMARATE",
        "trade_name": "COTELLIC",
        "forms": [
            {
                "orange_id": "206192-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 944,
        "type": "RX",
        "ingredient": "COCAINE HYDROCHLORIDE",
        "trade_name": "GOPRELTO",
        "forms": [
            {
                "orange_id": "209963-1",
                "form": "SOLUTION",
                "route": "NASAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 945,
        "type": "RX",
        "ingredient": "COCAINE HYDROCHLORIDE",
        "trade_name": "NUMBRINO",
        "forms": [
            {
                "orange_id": "209575-1",
                "form": "SOLUTION",
                "route": "NASAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 946,
        "type": "RX",
        "ingredient": "CODEINE PHOSPHATE, PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETH HYDROCHLORIDE, PHENYLEPHRINE HYDROCHLORIDE W/CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "40660-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML-5MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 947,
        "type": "RX",
        "ingredient": "CODEINE PHOSPHATE, PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE HYDROCHLORIDE, PHENYLEPHRINE HYDROCHLORIDE W/CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "40674-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML-5MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 948,
        "type": "RX",
        "ingredient": "CODEINE PHOSPHATE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE HYDROCHLORIDE AND CODEINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "88763-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 949,
        "type": "RX",
        "ingredient": "CODEINE PHOSPHATE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE WITH CODEINE",
        "forms": [
            {
                "orange_id": "40650-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 950,
        "type": "RX",
        "ingredient": "CODEINE PHOSPHATE, PSEUDOEPHEDRINE HYDROCHLORIDE AND TRIPROLIDINE HYDROCHLORIDE",
        "trade_name": "TRIACIN-C",
        "forms": [
            {
                "orange_id": "88704-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML-30MG/5ML-1.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 951,
        "type": "RX",
        "ingredient": "CODEINE SULFATE",
        "trade_name": "CODEINE SULFATE",
        "forms": [
            {
                "orange_id": "22402-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 952,
        "type": "RX",
        "ingredient": "COLCHICINE",
        "trade_name": "COLCHICINE",
        "forms": [
            {
                "orange_id": "211250-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.6MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 953,
        "type": "RX",
        "ingredient": "COLCHICINE",
        "trade_name": "COLCRYS",
        "forms": [
            {
                "orange_id": "22352-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.6MG"
                ]
            }
        ]
    },
    {
        "id": 954,
        "type": "RX",
        "ingredient": "COLCHICINE",
        "trade_name": "GLOPERBA",
        "forms": [
            {
                "orange_id": "210942-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.6MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 955,
        "type": "RX",
        "ingredient": "COLCHICINE",
        "trade_name": "MITIGARE",
        "forms": [
            {
                "orange_id": "204820-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.6MG"
                ]
            }
        ]
    },
    {
        "id": 956,
        "type": "RX",
        "ingredient": "COLCHICINE AND PROBENECID",
        "trade_name": "COL-PROBENECID",
        "forms": [
            {
                "orange_id": "84279-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 957,
        "type": "RX",
        "ingredient": "COLCHICINE AND PROBENECID",
        "trade_name": "PROBENECID AND COLCHICINE",
        "forms": [
            {
                "orange_id": "40618-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 958,
        "type": "RX",
        "ingredient": "COLESEVELAM HYDROCHLORIDE",
        "trade_name": "COLESEVELAM HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210316-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "3.75GM/PACKET",
                    "1.875GM/PACKET"
                ]
            },
            {
                "orange_id": "209038-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "625MG"
                ]
            }
        ]
    },
    {
        "id": 959,
        "type": "RX",
        "ingredient": "COLESEVELAM HYDROCHLORIDE",
        "trade_name": "WELCHOL",
        "forms": [
            {
                "orange_id": "22362-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "3.75GM/PACKET"
                ]
            },
            {
                "orange_id": "21176-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "625MG"
                ]
            }
        ]
    },
    {
        "id": 960,
        "type": "RX",
        "ingredient": "COLESTIPOL HYDROCHLORIDE",
        "trade_name": "COLESTID",
        "forms": [
            {
                "orange_id": "17563-3",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "5GM/SCOOPFUL",
                    "5GM/PACKET"
                ]
            },
            {
                "orange_id": "20222-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 961,
        "type": "RX",
        "ingredient": "COLESTIPOL HYDROCHLORIDE",
        "trade_name": "COLESTIPOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77277-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "5GM/SCOOPFUL",
                    "5GM/PACKET"
                ]
            },
            {
                "orange_id": "77510-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 962,
        "type": "RX",
        "ingredient": "COLESTIPOL HYDROCHLORIDE",
        "trade_name": "FLAVORED COLESTID",
        "forms": [
            {
                "orange_id": "17563-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "5GM/PACKET",
                    "5GM/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 963,
        "type": "RX",
        "ingredient": "COLISTIMETHATE SODIUM",
        "trade_name": "COLISTIMETHATE SODIUM",
        "forms": [
            {
                "orange_id": "202359-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 150MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 964,
        "type": "RX",
        "ingredient": "COLISTIMETHATE SODIUM",
        "trade_name": "COLY-MYCIN M",
        "forms": [
            {
                "orange_id": "50108-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 150MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 965,
        "type": "RX",
        "ingredient": "COLISTIN SULFATE, HYDROCORTISONE ACETATE, NEOMYCIN SULFATE AND THONZONIUM BROMIDE",
        "trade_name": "COLY-MYCIN S",
        "forms": [
            {
                "orange_id": "50356-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "EQ 3MG BASE/ML-10MG/ML-EQ 3.3MG BASE/ML-0.5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 966,
        "type": "RX",
        "ingredient": "CONIVAPTAN HYDROCHLORIDE",
        "trade_name": "VAPRISOL IN 5% DEXTROSE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "21697-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/100ML (0.2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 967,
        "type": "RX",
        "ingredient": "COPANLISIB DIHYDROCHLORIDE",
        "trade_name": "ALIQOPA",
        "forms": [
            {
                "orange_id": "209936-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 968,
        "type": "RX",
        "ingredient": "COPPER",
        "trade_name": "PARAGARD T 380A",
        "forms": [
            {
                "orange_id": "18680-1",
                "form": "INTRAUTERINE DEVICE",
                "route": "INTRAUTERINE",
                "dosage": [
                    "309MG/COPPER"
                ]
            }
        ]
    },
    {
        "id": 969,
        "type": "RX",
        "ingredient": "COPPER DOTATATE CU-64",
        "trade_name": "DETECTNET",
        "forms": [
            {
                "orange_id": "213227-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "4mL (1mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 970,
        "type": "RX",
        "ingredient": "CORTICOTROPIN",
        "trade_name": "ACTHAR GEL",
        "forms": [
            {
                "orange_id": "8372-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 971,
        "type": "RX",
        "ingredient": "CORTICOTROPIN",
        "trade_name": "PURIFIED CORTROPHIN GEL",
        "forms": [
            {
                "orange_id": "8975-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 972,
        "type": "RX",
        "ingredient": "CORTISONE ACETATE",
        "trade_name": "CORTISONE ACETATE",
        "forms": [
            {
                "orange_id": "80776-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 973,
        "type": "RX",
        "ingredient": "COSYNTROPIN",
        "trade_name": "CORTROSYN",
        "forms": [
            {
                "orange_id": "16750-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 974,
        "type": "RX",
        "ingredient": "COSYNTROPIN",
        "trade_name": "COSYNTROPIN",
        "forms": [
            {
                "orange_id": "90574-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 975,
        "type": "RX",
        "ingredient": "CRISABOROLE",
        "trade_name": "EUCRISA",
        "forms": [
            {
                "orange_id": "207695-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 976,
        "type": "RX",
        "ingredient": "CRIZOTINIB",
        "trade_name": "XALKORI",
        "forms": [
            {
                "orange_id": "202570-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 977,
        "type": "RX",
        "ingredient": "CROFELEMER",
        "trade_name": "MYTESI",
        "forms": [
            {
                "orange_id": "202292-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 978,
        "type": "RX",
        "ingredient": "CROMOLYN SODIUM",
        "trade_name": "CROMOLYN SODIUM",
        "forms": [
            {
                "orange_id": "209264-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "74706-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "4%"
                ]
            },
            {
                "orange_id": "209453-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "75702-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "5.2MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 979,
        "type": "RX",
        "ingredient": "CROMOLYN SODIUM",
        "trade_name": "GASTROCROM",
        "forms": [
            {
                "orange_id": "20479-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 980,
        "type": "RX",
        "ingredient": "CROTAMITON",
        "trade_name": "CROTAN",
        "forms": [
            {
                "orange_id": "87204-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 981,
        "type": "RX",
        "ingredient": "CROTAMITON",
        "trade_name": "EURAX",
        "forms": [
            {
                "orange_id": "9112-3",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 982,
        "type": "RX",
        "ingredient": "CUPRIC CHLORIDE",
        "trade_name": "CUPRIC CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18960-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.4MG COPPER/ML"
                ]
            }
        ]
    },
    {
        "id": 983,
        "type": "RX",
        "ingredient": "CUPRIC SULFATE, MANGANESE SULFATE, SELENIOUS ACID AND ZINC SULFATE",
        "trade_name": "MULTRYS",
        "forms": [
            {
                "orange_id": "209376-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 60MCG COPPER/ML-EQ 3MCG BASE/ML-EQ 6MCG SELENIUM/ML-EQ 1000MCG BASE/ML (1ML)"
                ]
            }
        ]
    },
    {
        "id": 984,
        "type": "RX",
        "ingredient": "CUPRIC SULFATE, MANGANESE SULFATE, SELENIOUS ACID AND ZINC SULFATE",
        "trade_name": "TRALEMENT",
        "forms": [
            {
                "orange_id": "209376-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.3MG COPPER/ML-EQ 55MCG BASE/ML-EQ 60MCG SELENIUM/ML-EQ 3MG BASE/ML (1ML)",
                    "EQ 0.3MG COPPER/ML-EQ 55MCG BASE/ML-EQ 60MCG SELENIUM/ML-EQ 3MG BASE/ML (5ML)"
                ]
            }
        ]
    },
    {
        "id": 985,
        "type": "RX",
        "ingredient": "CYANOCOBALAMIN",
        "trade_name": "CYANOCOBALAMIN",
        "forms": [
            {
                "orange_id": "80737-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 986,
        "type": "RX",
        "ingredient": "CYANOCOBALAMIN",
        "trade_name": "NASCOBAL",
        "forms": [
            {
                "orange_id": "21642-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 987,
        "type": "RX",
        "ingredient": "CYANOCOBALAMIN",
        "trade_name": "VIBISONE",
        "forms": [
            {
                "orange_id": "80557-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 988,
        "type": "RX",
        "ingredient": "CYCLOBENZAPRINE HYDROCHLORIDE",
        "trade_name": "AMRIX",
        "forms": [
            {
                "orange_id": "21777-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 989,
        "type": "RX",
        "ingredient": "CYCLOBENZAPRINE HYDROCHLORIDE",
        "trade_name": "CYCLOBENZAPRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206703-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            },
            {
                "orange_id": "71611-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 990,
        "type": "RX",
        "ingredient": "CYCLOPENTOLATE HYDROCHLORIDE",
        "trade_name": "AKPENTOLATE",
        "forms": [
            {
                "orange_id": "40164-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 991,
        "type": "RX",
        "ingredient": "CYCLOPENTOLATE HYDROCHLORIDE",
        "trade_name": "CYCLOGYL",
        "forms": [
            {
                "orange_id": "84109-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%",
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 992,
        "type": "RX",
        "ingredient": "CYCLOPENTOLATE HYDROCHLORIDE",
        "trade_name": "CYCLOPENTOLATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205937-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 993,
        "type": "RX",
        "ingredient": "CYCLOPENTOLATE HYDROCHLORIDE",
        "trade_name": "PENTOLAIR",
        "forms": [
            {
                "orange_id": "40075-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 994,
        "type": "RX",
        "ingredient": "CYCLOPENTOLATE HYDROCHLORIDE AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "CYCLOMYDRIL",
        "forms": [
            {
                "orange_id": "84300-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%-1%"
                ]
            }
        ]
    },
    {
        "id": 995,
        "type": "RX",
        "ingredient": "CYCLOPHOSPHAMIDE",
        "trade_name": "CYCLOPHOSPHAMIDE",
        "forms": [
            {
                "orange_id": "207014-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            },
            {
                "orange_id": "210046-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "2GM/VIAL",
                    "500MG/VIAL"
                ]
            },
            {
                "orange_id": "210735-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/5ML (200MG/ML)",
                    "500MG/2.5ML (200MG/ML)",
                    "2GM/10ML (200MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 996,
        "type": "RX",
        "ingredient": "CYCLOPHOSPHAMIDE",
        "trade_name": "CYTOXAN",
        "forms": [
            {
                "orange_id": "12141-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 997,
        "type": "RX",
        "ingredient": "CYCLOSERINE",
        "trade_name": "SEROMYCIN",
        "forms": [
            {
                "orange_id": "60593-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 998,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "CEQUA",
        "forms": [
            {
                "orange_id": "210913-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.09%"
                ]
            }
        ]
    },
    {
        "id": 999,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "CYCLOSPORINE",
        "forms": [
            {
                "orange_id": "65040-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            },
            {
                "orange_id": "205894-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "65004-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "65025-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1000,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "GENGRAF",
        "forms": [
            {
                "orange_id": "65003-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1001,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "NEORAL",
        "forms": [
            {
                "orange_id": "50715-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            },
            {
                "orange_id": "50716-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1002,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "RESTASIS",
        "forms": [
            {
                "orange_id": "50790-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1003,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "RESTASIS MULTIDOSE",
        "forms": [
            {
                "orange_id": "50790-2",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1004,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "SANDIMMUNE",
        "forms": [
            {
                "orange_id": "50625-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            },
            {
                "orange_id": "50573-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "50574-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1005,
        "type": "RX",
        "ingredient": "CYCLOSPORINE",
        "trade_name": "VERKAZIA",
        "forms": [
            {
                "orange_id": "214965-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1006,
        "type": "RX",
        "ingredient": "CYPROHEPTADINE HYDROCHLORIDE",
        "trade_name": "CYPROHEPTADINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204823-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML"
                ]
            },
            {
                "orange_id": "206553-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 1007,
        "type": "RX",
        "ingredient": "CYSTEAMINE BITARTRATE",
        "trade_name": "CYSTAGON",
        "forms": [
            {
                "orange_id": "20392-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1008,
        "type": "RX",
        "ingredient": "CYSTEAMINE BITARTRATE",
        "trade_name": "PROCYSBI",
        "forms": [
            {
                "orange_id": "203389-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 75MG BASE"
                ]
            },
            {
                "orange_id": "213491-1",
                "form": "GRANULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE/PACKET",
                    "EQ 300MG BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1009,
        "type": "RX",
        "ingredient": "CYSTEAMINE HYDROCHLORIDE",
        "trade_name": "CYSTADROPS",
        "forms": [
            {
                "orange_id": "211302-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.37% BASE"
                ]
            }
        ]
    },
    {
        "id": 1010,
        "type": "RX",
        "ingredient": "CYSTEAMINE HYDROCHLORIDE",
        "trade_name": "CYSTARAN",
        "forms": [
            {
                "orange_id": "200740-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.44% BASE"
                ]
            }
        ]
    },
    {
        "id": 1011,
        "type": "RX",
        "ingredient": "CYSTEINE HYDROCHLORIDE",
        "trade_name": "ELCYS",
        "forms": [
            {
                "orange_id": "210660-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/10ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1012,
        "type": "RX",
        "ingredient": "CYTARABINE",
        "trade_name": "CYTARABINE",
        "forms": [
            {
                "orange_id": "76512-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML",
                    "2GM/VIAL",
                    "100MG/VIAL",
                    "500MG/VIAL",
                    "20MG/ML",
                    "1GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1013,
        "type": "RX",
        "ingredient": "CYTARABINE AND DAUNORUBICIN",
        "trade_name": "VYXEOS",
        "forms": [
            {
                "orange_id": "209401-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG-44MG"
                ]
            }
        ]
    },
    {
        "id": 1014,
        "type": "RX",
        "ingredient": "DABIGATRAN ETEXILATE MESYLATE",
        "trade_name": "DABIGATRAN ETEXILATE MESYLATE",
        "forms": [
            {
                "orange_id": "208040-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1015,
        "type": "RX",
        "ingredient": "DABIGATRAN ETEXILATE MESYLATE",
        "trade_name": "PRADAXA",
        "forms": [
            {
                "orange_id": "22512-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 110MG BASE",
                    "EQ 150MG BASE"
                ]
            },
            {
                "orange_id": "214358-1",
                "form": "PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/PACKET",
                    "EQ 30MG BASE/PACKET",
                    "EQ 40MG BASE/PACKET",
                    "EQ 50MG BASE/PACKET",
                    "EQ 110MG BASE/PACKET",
                    "EQ 150MG BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1016,
        "type": "RX",
        "ingredient": "DABRAFENIB MESYLATE",
        "trade_name": "TAFINLAR",
        "forms": [
            {
                "orange_id": "202806-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1017,
        "type": "RX",
        "ingredient": "DACARBAZINE",
        "trade_name": "DACARBAZINE",
        "forms": [
            {
                "orange_id": "75371-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/VIAL",
                    "200MG/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1018,
        "type": "RX",
        "ingredient": "DACOMITINIB",
        "trade_name": "VIZIMPRO",
        "forms": [
            {
                "orange_id": "211288-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "45MG"
                ]
            }
        ]
    },
    {
        "id": 1019,
        "type": "RX",
        "ingredient": "DACTINOMYCIN",
        "trade_name": "COSMEGEN",
        "forms": [
            {
                "orange_id": "50682-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1020,
        "type": "RX",
        "ingredient": "DACTINOMYCIN",
        "trade_name": "DACTINOMYCIN",
        "forms": [
            {
                "orange_id": "203385-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1021,
        "type": "RX",
        "ingredient": "DALBAVANCIN HYDROCHLORIDE",
        "trade_name": "DALVANCE",
        "forms": [
            {
                "orange_id": "21883-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1022,
        "type": "RX",
        "ingredient": "DALFAMPRIDINE",
        "trade_name": "AMPYRA",
        "forms": [
            {
                "orange_id": "22250-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1023,
        "type": "RX",
        "ingredient": "DALFAMPRIDINE",
        "trade_name": "DALFAMPRIDINE",
        "forms": [
            {
                "orange_id": "206863-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1024,
        "type": "RX",
        "ingredient": "DALFOPRISTIN AND QUINUPRISTIN",
        "trade_name": "SYNERCID",
        "forms": [
            {
                "orange_id": "50748-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "350MG/VIAL-150MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1025,
        "type": "RX",
        "ingredient": "DALTEPARIN SODIUM",
        "trade_name": "FRAGMIN",
        "forms": [
            {
                "orange_id": "20287-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "2,500IU/0.2ML (12,500IU/ML)",
                    "5,000IU/0.2ML (25,000IU/ML)",
                    "7,500IU/0.3ML (25,000IU/ML)",
                    "10,000IU/ML (10,000IU/ML)",
                    "12,500IU/0.5ML (25,000IU/ML)",
                    "15,000IU/0.6ML (25,000IU/ML)",
                    "18,000IU/0.72ML (25,000IU/ML)",
                    "95,000IU/3.8ML (25,000IU/ML)"
                ]
            }
        ]
    },
    {
        "id": 1026,
        "type": "RX",
        "ingredient": "DANAZOL",
        "trade_name": "DANAZOL",
        "forms": [
            {
                "orange_id": "74582-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1027,
        "type": "RX",
        "ingredient": "DANTROLENE SODIUM",
        "trade_name": "DANTRIUM",
        "forms": [
            {
                "orange_id": "17443-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            },
            {
                "orange_id": "18264-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1028,
        "type": "RX",
        "ingredient": "DANTROLENE SODIUM",
        "trade_name": "DANTROLENE SODIUM",
        "forms": [
            {
                "orange_id": "76686-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            },
            {
                "orange_id": "204762-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1029,
        "type": "RX",
        "ingredient": "DANTROLENE SODIUM",
        "trade_name": "REVONTO",
        "forms": [
            {
                "orange_id": "78378-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1030,
        "type": "RX",
        "ingredient": "DANTROLENE SODIUM",
        "trade_name": "RYANODEX",
        "forms": [
            {
                "orange_id": "205579-1",
                "form": "FOR SUSPENSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1031,
        "type": "RX",
        "ingredient": "DAPAGLIFLOZIN",
        "trade_name": "FARXIGA",
        "forms": [
            {
                "orange_id": "202293-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1032,
        "type": "RX",
        "ingredient": "DAPAGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "XIGDUO XR",
        "forms": [
            {
                "orange_id": "205649-5",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-1GM",
                    "5MG-1GM",
                    "5MG-500MG",
                    "10MG-1GM",
                    "10MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 1033,
        "type": "RX",
        "ingredient": "DAPAGLIFLOZIN AND SAXAGLIPTIN HYDROCHLORIDE",
        "trade_name": "QTERN",
        "forms": [
            {
                "orange_id": "209091-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-EQ 5MG BASE",
                    "10MG-EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1034,
        "type": "RX",
        "ingredient": "DAPSONE",
        "trade_name": "ACZONE",
        "forms": [
            {
                "orange_id": "21794-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "5%",
                    "7.5%"
                ]
            }
        ]
    },
    {
        "id": 1035,
        "type": "RX",
        "ingredient": "DAPSONE",
        "trade_name": "DAPSONE",
        "forms": [
            {
                "orange_id": "213847-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "7.5%",
                    "5%"
                ]
            },
            {
                "orange_id": "204380-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1036,
        "type": "RX",
        "ingredient": "DAPTOMYCIN",
        "trade_name": "CUBICIN",
        "forms": [
            {
                "orange_id": "21572-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1037,
        "type": "RX",
        "ingredient": "DAPTOMYCIN",
        "trade_name": "CUBICIN RF",
        "forms": [
            {
                "orange_id": "21572-3",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1038,
        "type": "RX",
        "ingredient": "DAPTOMYCIN",
        "trade_name": "DAPTOMYCIN",
        "forms": [
            {
                "orange_id": "212667-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "350MG/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1039,
        "type": "RX",
        "ingredient": "DAPTOMYCIN",
        "trade_name": "DAPZURA RT",
        "forms": [
            {
                "orange_id": "213645-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1040,
        "type": "RX",
        "ingredient": "DARIFENACIN HYDROBROMIDE",
        "trade_name": "DARIFENACIN",
        "forms": [
            {
                "orange_id": "207302-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 7.5MG BASE",
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1041,
        "type": "RX",
        "ingredient": "DARIFENACIN HYDROBROMIDE",
        "trade_name": "DARIFENACIN HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "207681-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 7.5MG BASE",
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1042,
        "type": "RX",
        "ingredient": "DAROLUTAMIDE",
        "trade_name": "NUBEQA",
        "forms": [
            {
                "orange_id": "212099-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 1043,
        "type": "RX",
        "ingredient": "DARUNAVIR",
        "trade_name": "DARUNAVIR",
        "forms": [
            {
                "orange_id": "202118-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1044,
        "type": "RX",
        "ingredient": "DARUNAVIR",
        "trade_name": "PREZISTA",
        "forms": [
            {
                "orange_id": "202895-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "21976-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "150MG",
                    "600MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 1045,
        "type": "RX",
        "ingredient": "DASATINIB",
        "trade_name": "DASATINIB",
        "forms": [
            {
                "orange_id": "203180-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "140MG"
                ]
            }
        ]
    },
    {
        "id": 1046,
        "type": "RX",
        "ingredient": "DASATINIB",
        "trade_name": "SPRYCEL",
        "forms": [
            {
                "orange_id": "21986-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "50MG",
                    "70MG",
                    "80MG",
                    "100MG",
                    "140MG"
                ]
            }
        ]
    },
    {
        "id": 1047,
        "type": "RX",
        "ingredient": "DASIGLUCAGON HYDROCHLORIDE",
        "trade_name": "ZEGALOGUE",
        "forms": [
            {
                "orange_id": "214231-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 0.6MG BASE/0.6ML (EQ 0.6MG BASE/0.6ML)"
                ]
            }
        ]
    },
    {
        "id": 1048,
        "type": "RX",
        "ingredient": "DASIGLUCAGON HYDROCHLORIDE",
        "trade_name": "ZEGALOGUE (AUTOINJECTOR)",
        "forms": [
            {
                "orange_id": "214231-2",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 0.6MG BASE/0.6ML (EQ 0.6MG BASE/0.6ML)"
                ]
            }
        ]
    },
    {
        "id": 1049,
        "type": "RX",
        "ingredient": "DAUNORUBICIN HYDROCHLORIDE",
        "trade_name": "CERUBIDINE",
        "forms": [
            {
                "orange_id": "64103-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1050,
        "type": "RX",
        "ingredient": "DAUNORUBICIN HYDROCHLORIDE",
        "trade_name": "DAUNORUBICIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65034-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/VIAL",
                    "EQ 20MG BASE/VIAL",
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1051,
        "type": "RX",
        "ingredient": "DECITABINE",
        "trade_name": "DACOGEN",
        "forms": [
            {
                "orange_id": "21790-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1052,
        "type": "RX",
        "ingredient": "DECITABINE",
        "trade_name": "DECITABINE",
        "forms": [
            {
                "orange_id": "203475-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            },
            {
                "orange_id": "205582-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1053,
        "type": "RX",
        "ingredient": "DEFERASIROX",
        "trade_name": "DEFERASIROX",
        "forms": [
            {
                "orange_id": "213374-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "90MG",
                    "180MG",
                    "360MG"
                ]
            },
            {
                "orange_id": "203560-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "208697-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "90MG",
                    "180MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 1054,
        "type": "RX",
        "ingredient": "DEFERASIROX",
        "trade_name": "EXJADE",
        "forms": [
            {
                "orange_id": "21882-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1055,
        "type": "RX",
        "ingredient": "DEFERASIROX",
        "trade_name": "JADENU",
        "forms": [
            {
                "orange_id": "206910-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "90MG",
                    "180MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 1056,
        "type": "RX",
        "ingredient": "DEFERASIROX",
        "trade_name": "JADENU SPRINKLE",
        "forms": [
            {
                "orange_id": "207968-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "90MG",
                    "180MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 1057,
        "type": "RX",
        "ingredient": "DEFERIPRONE",
        "trade_name": "DEFERIPRONE",
        "forms": [
            {
                "orange_id": "213239-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1058,
        "type": "RX",
        "ingredient": "DEFERIPRONE",
        "trade_name": "FERRIPROX",
        "forms": [
            {
                "orange_id": "208030-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "21825-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1059,
        "type": "RX",
        "ingredient": "DEFEROXAMINE MESYLATE",
        "trade_name": "DEFEROXAMINE MESYLATE",
        "forms": [
            {
                "orange_id": "78718-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1060,
        "type": "RX",
        "ingredient": "DEFEROXAMINE MESYLATE",
        "trade_name": "DESFERAL",
        "forms": [
            {
                "orange_id": "16267-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1061,
        "type": "RX",
        "ingredient": "DEFIBROTIDE SODIUM",
        "trade_name": "DEFITELIO",
        "forms": [
            {
                "orange_id": "208114-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/2.5ML (80MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1062,
        "type": "RX",
        "ingredient": "DEFLAZACORT",
        "trade_name": "EMFLAZA",
        "forms": [
            {
                "orange_id": "208685-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "22.75MG/ML"
                ]
            },
            {
                "orange_id": "208684-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "6MG",
                    "18MG",
                    "30MG",
                    "36MG"
                ]
            }
        ]
    },
    {
        "id": 1063,
        "type": "RX",
        "ingredient": "DEGARELIX ACETATE",
        "trade_name": "FIRMAGON",
        "forms": [
            {
                "orange_id": "22201-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 80MG BASE/VIAL",
                    "EQ 120MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1064,
        "type": "RX",
        "ingredient": "DELAFLOXACIN MEGLUMINE",
        "trade_name": "BAXDELA",
        "forms": [
            {
                "orange_id": "208611-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 300MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "208610-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 450MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1065,
        "type": "RX",
        "ingredient": "DEMECLOCYCLINE HYDROCHLORIDE",
        "trade_name": "DEMECLOCYCLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65389-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 1066,
        "type": "RX",
        "ingredient": "DEOXYCHOLIC ACID",
        "trade_name": "DEOXYCHOLIC ACID",
        "forms": [
            {
                "orange_id": "212296-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "20MG/2ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1067,
        "type": "RX",
        "ingredient": "DEOXYCHOLIC ACID",
        "trade_name": "KYBELLA",
        "forms": [
            {
                "orange_id": "206333-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "20MG/2ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1068,
        "type": "RX",
        "ingredient": "DESFLURANE",
        "trade_name": "DESFLURANE",
        "forms": [
            {
                "orange_id": "208234-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 1069,
        "type": "RX",
        "ingredient": "DESFLURANE",
        "trade_name": "SUPRANE",
        "forms": [
            {
                "orange_id": "20118-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 1070,
        "type": "RX",
        "ingredient": "DESIPRAMINE HYDROCHLORIDE",
        "trade_name": "DESIPRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74430-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 1071,
        "type": "RX",
        "ingredient": "DESIPRAMINE HYDROCHLORIDE",
        "trade_name": "NORPRAMIN",
        "forms": [
            {
                "orange_id": "14399-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 1072,
        "type": "RX",
        "ingredient": "DESLORATADINE",
        "trade_name": "CLARINEX",
        "forms": [
            {
                "orange_id": "21165-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1073,
        "type": "RX",
        "ingredient": "DESLORATADINE",
        "trade_name": "DESLORATADINE",
        "forms": [
            {
                "orange_id": "78367-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "78355-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1074,
        "type": "RX",
        "ingredient": "DESLORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "trade_name": "CLARINEX-D 12 HOUR",
        "forms": [
            {
                "orange_id": "21313-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 1075,
        "type": "RX",
        "ingredient": "DESLORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "trade_name": "DESLORATADINE AND PSEUDOEPHEDRINE SULFATE 24 HOUR",
        "forms": [
            {
                "orange_id": "78366-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-240MG"
                ]
            }
        ]
    },
    {
        "id": 1076,
        "type": "RX",
        "ingredient": "DESMOPRESSIN ACETATE",
        "trade_name": "DDAVP",
        "forms": [
            {
                "orange_id": "18938-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.004MG/ML"
                ]
            },
            {
                "orange_id": "19955-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 1077,
        "type": "RX",
        "ingredient": "DESMOPRESSIN ACETATE",
        "trade_name": "DESMOPRESSIN ACETATE",
        "forms": [
            {
                "orange_id": "91374-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.004MG/ML"
                ]
            },
            {
                "orange_id": "74830-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.01MG/SPRAY"
                ]
            },
            {
                "orange_id": "210371-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 1078,
        "type": "RX",
        "ingredient": "DESMOPRESSIN ACETATE",
        "trade_name": "DESMOPRESSIN ACETATE (NEEDS NO REFRIGERATION)",
        "forms": [
            {
                "orange_id": "76703-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.01MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1079,
        "type": "RX",
        "ingredient": "DESMOPRESSIN ACETATE",
        "trade_name": "NOCDURNA",
        "forms": [
            {
                "orange_id": "22517-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.0277MG",
                    "0.0553MG"
                ]
            }
        ]
    },
    {
        "id": 1080,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "BEKYREE",
        "forms": [
            {
                "orange_id": "202226-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1081,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "CYCLESSA",
        "forms": [
            {
                "orange_id": "21090-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.1MG,0.125MG,0.15MG-0.025MG,0.025MG,0.025MG"
                ]
            }
        ]
    },
    {
        "id": 1082,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "75256-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG-0.03MG",
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1083,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "ENSKYCE",
        "forms": [
            {
                "orange_id": "201887-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1084,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "ISIBLOOM",
        "forms": [
            {
                "orange_id": "202789-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1085,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "KALLIGA",
        "forms": [
            {
                "orange_id": "207081-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1086,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "KARIVA",
        "forms": [
            {
                "orange_id": "75863-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1087,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "KIMIDESS",
        "forms": [
            {
                "orange_id": "76681-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1088,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "PIMTREA",
        "forms": [
            {
                "orange_id": "91247-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1089,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "SIMLIYA",
        "forms": [
            {
                "orange_id": "206853-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1090,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "VELIVET",
        "forms": [
            {
                "orange_id": "76455-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.1MG,0.125MG,0.15MG-0.025MG,0.025MG,0.025MG"
                ]
            }
        ]
    },
    {
        "id": 1091,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "VIORELE",
        "forms": [
            {
                "orange_id": "91346-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1092,
        "type": "RX",
        "ingredient": "DESOGESTREL AND ETHINYL ESTRADIOL",
        "trade_name": "VOLNEA",
        "forms": [
            {
                "orange_id": "202689-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.15MG,N/A-0.02MG,0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1093,
        "type": "RX",
        "ingredient": "DESONIDE",
        "trade_name": "DESONIDE",
        "forms": [
            {
                "orange_id": "210198-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "202470-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "213632-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "208836-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1094,
        "type": "RX",
        "ingredient": "DESONIDE",
        "trade_name": "DESOWEN",
        "forms": [
            {
                "orange_id": "19048-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "72354-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "71425-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1095,
        "type": "RX",
        "ingredient": "DESONIDE",
        "trade_name": "VERDESO",
        "forms": [
            {
                "orange_id": "21978-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1096,
        "type": "RX",
        "ingredient": "DESOXIMETASONE",
        "trade_name": "DESOXIMETASONE",
        "forms": [
            {
                "orange_id": "205082-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.25%",
                    "0.05%"
                ]
            },
            {
                "orange_id": "90727-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "204965-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.25%",
                    "0.05%"
                ]
            },
            {
                "orange_id": "208124-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.25%"
                ]
            }
        ]
    },
    {
        "id": 1097,
        "type": "RX",
        "ingredient": "DESOXIMETASONE",
        "trade_name": "TOPICORT",
        "forms": [
            {
                "orange_id": "73210-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.25%"
                ]
            },
            {
                "orange_id": "74904-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "18594-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "204141-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.25%"
                ]
            }
        ]
    },
    {
        "id": 1098,
        "type": "RX",
        "ingredient": "DESVENLAFAXINE",
        "trade_name": "DESVENLAFAXINE",
        "forms": [
            {
                "orange_id": "204150-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1099,
        "type": "RX",
        "ingredient": "DESVENLAFAXINE SUCCINATE",
        "trade_name": "DESVENLAFAXINE SUCCINATE",
        "forms": [
            {
                "orange_id": "204065-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1100,
        "type": "RX",
        "ingredient": "DESVENLAFAXINE SUCCINATE",
        "trade_name": "PRISTIQ",
        "forms": [
            {
                "orange_id": "21992-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1101,
        "type": "RX",
        "ingredient": "DEUTETRABENAZINE",
        "trade_name": "AUSTEDO",
        "forms": [
            {
                "orange_id": "208082-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "6MG",
                    "9MG",
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 1102,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "DEXAMETHASONE",
        "forms": [
            {
                "orange_id": "84754-1",
                "form": "ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "0.5MG/5ML"
                ]
            },
            {
                "orange_id": "88248-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.5MG/5ML"
                ]
            },
            {
                "orange_id": "88481-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "0.75MG",
                    "4MG",
                    "6MG",
                    "1MG",
                    "1.5MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 1103,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "DEXAMETHASONE INTENSOL",
        "forms": [
            {
                "orange_id": "88252-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1104,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "DEXTENZA",
        "forms": [
            {
                "orange_id": "208742-1",
                "form": "INSERT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1105,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "DEXYCU KIT",
        "forms": [
            {
                "orange_id": "208912-1",
                "form": "SUSPENSION",
                "route": "INTRAOCULAR",
                "dosage": [
                    "9%"
                ]
            }
        ]
    },
    {
        "id": 1106,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "HEMADY",
        "forms": [
            {
                "orange_id": "211379-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1107,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "MAXIDEX",
        "forms": [
            {
                "orange_id": "13422-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1108,
        "type": "RX",
        "ingredient": "DEXAMETHASONE",
        "trade_name": "OZURDEX",
        "forms": [
            {
                "orange_id": "22315-1",
                "form": "IMPLANT",
                "route": "INTRAVITREAL",
                "dosage": [
                    "0.7MG"
                ]
            }
        ]
    },
    {
        "id": 1109,
        "type": "RX",
        "ingredient": "DEXAMETHASONE SODIUM PHOSPHATE",
        "trade_name": "DEXAMETHASONE SODIUM PHOSPHATE",
        "forms": [
            {
                "orange_id": "208689-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 4MG PHOSPHATE/ML",
                    "EQ 10MG PHOSPHATE/ML"
                ]
            },
            {
                "orange_id": "40069-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC, OTIC",
                "dosage": [
                    "EQ 0.1% PHOSPHATE"
                ]
            }
        ]
    },
    {
        "id": 1110,
        "type": "RX",
        "ingredient": "DEXAMETHASONE SODIUM PHOSPHATE",
        "trade_name": "DEXAMETHASONE SODIUM PHOSPHATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "208690-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG PHOSPHATE/ML"
                ]
            }
        ]
    },
    {
        "id": 1111,
        "type": "RX",
        "ingredient": "DEXAMETHASONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "DEXASPORIN",
        "forms": [
            {
                "orange_id": "64135-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 1112,
        "type": "RX",
        "ingredient": "DEXAMETHASONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "MAXITROL",
        "forms": [
            {
                "orange_id": "50065-2",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-EQ 3.5MG BASE/GM-10,000 UNITS/GM"
                ]
            },
            {
                "orange_id": "50023-2",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 1113,
        "type": "RX",
        "ingredient": "DEXAMETHASONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATES AND DEXAMETHASONE",
        "forms": [
            {
                "orange_id": "64063-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-EQ 3.5MG BASE/GM-10,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 1114,
        "type": "RX",
        "ingredient": "DEXAMETHASONE AND TOBRAMYCIN",
        "trade_name": "TOBRADEX",
        "forms": [
            {
                "orange_id": "50616-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-0.3%"
                ]
            },
            {
                "orange_id": "50592-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 1115,
        "type": "RX",
        "ingredient": "DEXAMETHASONE AND TOBRAMYCIN",
        "trade_name": "TOBRADEX ST",
        "forms": [
            {
                "orange_id": "50818-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 1116,
        "type": "RX",
        "ingredient": "DEXAMETHASONE AND TOBRAMYCIN",
        "trade_name": "TOBRAMYCIN AND DEXAMETHASONE",
        "forms": [
            {
                "orange_id": "212991-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 1117,
        "type": "RX",
        "ingredient": "DEXCHLORPHENIRAMINE MALEATE",
        "trade_name": "DEXCHLORPHENIRAMINE MALEATE",
        "forms": [
            {
                "orange_id": "88251-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1118,
        "type": "RX",
        "ingredient": "DEXCHLORPHENIRAMINE MALEATE",
        "trade_name": "POLMON",
        "forms": [
            {
                "orange_id": "202520-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1119,
        "type": "RX",
        "ingredient": "DEXLANSOPRAZOLE",
        "trade_name": "DEXILANT",
        "forms": [
            {
                "orange_id": "22287-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 1120,
        "type": "RX",
        "ingredient": "DEXLANSOPRAZOLE",
        "trade_name": "DEXLANSOPRAZOLE",
        "forms": [
            {
                "orange_id": "202294-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 1121,
        "type": "RX",
        "ingredient": "DEXMEDETOMIDINE HYDROCHLORIDE",
        "trade_name": "DEXMEDETOMIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204023-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 200MCG BASE/2ML (EQ 100MCG BASE/ML)",
                    "EQ 200MCG BASE/50ML (EQ 4MCG BASE/ML)",
                    "EQ 400MCG BASE/100ML (EQ 4MCG BASE/ML)",
                    "EQ 80MCG BASE/20ML (EQ 4MCG BASE/ML)"
                ]
            },
            {
                "orange_id": "206628-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1MG BASE/10ML (EQ 100MCG BASE/ML)",
                    "EQ 200MCG BASE/50ML (EQ 4MCG BASE/ML)",
                    "EQ 400MCG BASE/4ML (EQ 100MCG BASE/ML)",
                    "EQ 400MCG BASE/100ML (EQ 4MCG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1122,
        "type": "RX",
        "ingredient": "DEXMEDETOMIDINE HYDROCHLORIDE",
        "trade_name": "PRECEDEX",
        "forms": [
            {
                "orange_id": "21038-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/250ML (EQ 4MCG BASE/ML)",
                    "EQ 80MCG BASE/20ML (EQ 4MCG BASE/ML)",
                    "EQ 200MCG BASE/2ML (EQ 100MCG BASE/ML)",
                    "EQ 200MCG BASE/50ML (EQ 4MCG BASE/ML)",
                    "EQ 400MCG BASE/100ML (EQ 4MCG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1123,
        "type": "RX",
        "ingredient": "DEXMETHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "DEXMETHYLPHENIDATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210279-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "25MG",
                    "30MG",
                    "35MG",
                    "40MG"
                ]
            },
            {
                "orange_id": "206931-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1124,
        "type": "RX",
        "ingredient": "DEXMETHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "FOCALIN",
        "forms": [
            {
                "orange_id": "21278-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1125,
        "type": "RX",
        "ingredient": "DEXMETHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "FOCALIN XR",
        "forms": [
            {
                "orange_id": "21802-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "25MG",
                    "30MG",
                    "35MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 1126,
        "type": "RX",
        "ingredient": "DEXMETHYLPHENIDATE HYDROCHLORIDE AND SERDEXMETHYLPHENIDATE CHLORIDE",
        "trade_name": "AZSTARYS",
        "forms": [
            {
                "orange_id": "212994-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5.2MG BASE-EQ 26.1MG BASE",
                    "EQ 7.8MG BASE-EQ 39.2MG BASE",
                    "EQ 10.4MG BASE-EQ 52.3MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1127,
        "type": "RX",
        "ingredient": "DEXRAZOXANE HYDROCHLORIDE",
        "trade_name": "DEXRAZOXANE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "200752-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 250MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1128,
        "type": "RX",
        "ingredient": "DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DEXEDRINE",
        "forms": [
            {
                "orange_id": "17078-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 1129,
        "type": "RX",
        "ingredient": "DEXTROAMPHETAMINE SULFATE",
        "trade_name": "DEXTROAMPHETAMINE SULFATE",
        "forms": [
            {
                "orange_id": "203901-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG"
                ]
            },
            {
                "orange_id": "40776-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "90533-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "7.5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 1130,
        "type": "OTC",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND GUAIFENESIN",
        "trade_name": "GUAIFENESIN AND DEXTROMETHORPHAN HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "91070-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG-600MG",
                    "60MG-1.2GM"
                ]
            }
        ]
    },
    {
        "id": 1131,
        "type": "OTC",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND GUAIFENESIN",
        "trade_name": "MUCINEX DM",
        "forms": [
            {
                "orange_id": "21620-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG-600MG",
                    "60MG-1.2GM"
                ]
            }
        ]
    },
    {
        "id": 1132,
        "type": "RX",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE DM",
        "forms": [
            {
                "orange_id": "40649-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "15MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1133,
        "type": "RX",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE HYDROCHLORIDE AND DEXTROMETHORPHAN HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "90575-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "15MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1134,
        "type": "RX",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE W/ DEXTROMETHORPHAN",
        "forms": [
            {
                "orange_id": "88864-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "15MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1135,
        "type": "RX",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND QUINIDINE SULFATE",
        "trade_name": "DEXTROMETHORPHAN HYDROBROMIDE AND QUINIDINE SULFATE",
        "forms": [
            {
                "orange_id": "202934-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 1136,
        "type": "RX",
        "ingredient": "DEXTROMETHORPHAN HYDROBROMIDE AND QUINIDINE SULFATE",
        "trade_name": "NUEDEXTA",
        "forms": [
            {
                "orange_id": "21879-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 1137,
        "type": "OTC",
        "ingredient": "DEXTROMETHORPHAN POLISTIREX",
        "trade_name": "DELSYM",
        "forms": [
            {
                "orange_id": "18658-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG HYDROBROMIDE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1138,
        "type": "OTC",
        "ingredient": "DEXTROMETHORPHAN POLISTIREX",
        "trade_name": "DEXTROMETHORPHAN POLISTIREX",
        "forms": [
            {
                "orange_id": "203133-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG HYDROBROMIDE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1139,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19626-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1140,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 20% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18564-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1141,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 25%",
        "forms": [
            {
                "orange_id": "19445-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1142,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 30% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19345-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1143,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 40% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18562-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1144,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16730-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML",
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1145,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 50%",
        "forms": [
            {
                "orange_id": "19445-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1146,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 50% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20047-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1147,
        "type": "RX",
        "ingredient": "DEXTROSE",
        "trade_name": "DEXTROSE 70% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19626-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "70GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1148,
        "type": "RX",
        "ingredient": "DEXTROSE, MAGNESIUM ACETATE, POTASSIUM ACETATE AND SODIUM CHLORIDE",
        "trade_name": "NORMOSOL-M AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17610-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-21MG/100ML-128MG/100ML-234MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1149,
        "type": "RX",
        "ingredient": "DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, DIBASIC AND SODIUM ACETATE",
        "trade_name": "ISOLYTE P IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19873-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-31MG/100ML-130MG/100ML-26MG/100ML-320MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1150,
        "type": "RX",
        "ingredient": "DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, MONOBASIC, SODIUM CHLORIDE AND SODIUM LACTATE",
        "trade_name": "DEXTROSE 5% AND ELECTROLYTE NO. 48 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17484-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-31MG/100ML-141MG/100ML-20MG/100ML-12MG/100ML-260MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1151,
        "type": "RX",
        "ingredient": "DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, MONOBASIC, SODIUM LACTATE AND SODIUM PHOSPHATE, MONOBASIC ANHYDROUS",
        "trade_name": "IONOSOL MB AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19513-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-30MG/100ML-141MG/100ML-15MG/100ML-260MG/100ML-25MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1152,
        "type": "RX",
        "ingredient": "DEXTROSE, MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "NORMOSOL-R AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17609-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-30MG/100ML-37MG/100ML-222MG/100ML-526MG/100ML-502MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1153,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND POTASSIUM CHLORIDE 0. 075% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17634-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1154,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND POTASSIUM CHLORIDE 0. 15% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17634-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1155,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND POTASSIUM CHLORIDE 0. 224% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17634-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1156,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND POTASSIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17634-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1157,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19699-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1158,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19699-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1159,
        "type": "RX",
        "ingredient": "DEXTROSE AND POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18371-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-149MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1160,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 10MEQ",
        "forms": [
            {
                "orange_id": "18037-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-200MG/100ML",
                    "5GM/100ML-150MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1161,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 15MEQ (K)",
        "forms": [
            {
                "orange_id": "18037-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1162,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 20MEQ",
        "forms": [
            {
                "orange_id": "18037-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1163,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 20MEQ (K)",
        "forms": [
            {
                "orange_id": "18037-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1164,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 30MEQ",
        "forms": [
            {
                "orange_id": "18037-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1165,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 40MEQ",
        "forms": [
            {
                "orange_id": "18037-9",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1166,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 5MEQ",
        "forms": [
            {
                "orange_id": "18037-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1167,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 2% AND POTASSIUM CHLORIDE 5MEQ (K)",
        "forms": [
            {
                "orange_id": "18037-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1168,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 10MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-330MG/100ML",
                    "5GM/100ML-150MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1169,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 15MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1170,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 20MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-330MG/100ML",
                    "5GM/100ML-300MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1171,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 30MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1172,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 40MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1173,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 33% AND POTASSIUM CHLORIDE 5MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18629-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1174,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5%, SODIUM CHLORIDE 0. 45% AND POTASSIUM CHLORIDE 20MEQ (K) IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-10",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1175,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-31",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-37MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1176,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-37",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-37MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1177,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-43",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-37MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1178,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-37MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1179,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-37MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1180,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-13",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-37MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1181,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-19",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-37MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1182,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 037% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-25",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-37MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1183,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-32",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-75MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1184,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-38",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-75MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1185,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-44",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-75MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1186,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-49",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-75MG/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1187,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1188,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1189,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-14",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1190,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-20",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1191,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 075% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-26",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1192,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-33",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-110MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1193,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-39",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-110MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1194,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-45",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-110MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1195,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-50",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-110MG/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1196,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1197,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-9",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1198,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-15",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1199,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-21",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1200,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 11% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-27",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1201,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-34",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-150MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1202,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-40",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-150MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1203,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-46",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1204,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-51",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-150MG/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1205,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1206,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-10",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1207,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-16",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1208,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-22",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1209,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-28",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1210,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-35",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-220MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1211,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-41",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-220MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1212,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-47",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-220MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1213,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-52",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-220MG/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1214,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-220MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1215,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-11",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-220MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1216,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-17",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-220MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1217,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-23",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-220MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1218,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 22% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-29",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-220MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1219,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-36",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-300MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1220,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-42",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-300MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1221,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-48",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-300MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1222,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-53",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-300MG/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1223,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1224,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-12",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1225,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-18",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1226,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-24",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1227,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19630-30",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1228,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-450MG/100ML",
                    "5GM/100ML-150MG/100ML-450MG/100ML",
                    "5GM/100ML-74.5MG/100ML-450MG/100ML",
                    "5GM/100ML-149MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1229,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 10MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19308-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-75MG/100ML-900MG/100ML",
                    "5GM/100ML-150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1230,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 225% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18365-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-149MG/100ML-225MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1231,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-450MG/100ML",
                    "5GM/100ML-149MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1232,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19308-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-900MG/100ML",
                    "5GM/100ML-300MG/100ML-900MG/100ML",
                    "5GM/100ML-149MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1233,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1234,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 30MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19308-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-224MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1235,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-9",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-450MG/100ML",
                    "5GM/100ML-298MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1236,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19308-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML-900MG/100ML",
                    "5GM/100ML-298MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1237,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18008-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1238,
        "type": "RX",
        "ingredient": "DEXTROSE, POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 5MEQ IN DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19308-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1239,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 10% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-11",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1240,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 10% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-12",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1241,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 10% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-13",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1242,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 10% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-14",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1243,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 10% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-15",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1244,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 2. 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5GM/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1245,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 2. 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5GM/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1246,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 2. 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5GM/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1247,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 2. 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5GM/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1248,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 2. 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5GM/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1249,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 3. 3% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-16",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.3GM/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1250,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 11% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-110MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1251,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1252,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 225%",
        "forms": [
            {
                "orange_id": "211221-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-225MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1253,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 225% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17606-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-225MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1254,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "211194-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-300MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1255,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1256,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 45%",
        "forms": [
            {
                "orange_id": "211276-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1257,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-9",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1258,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "211211-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1259,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19631-10",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1260,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% IN SODIUM CHLORIDE 0. 2% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16689-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1261,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% IN SODIUM CHLORIDE 0. 33% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16687-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-330MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1262,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% IN SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16683-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1263,
        "type": "RX",
        "ingredient": "DEXTROSE AND SODIUM CHLORIDE",
        "trade_name": "DEXTROSE 5% IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16678-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1264,
        "type": "RX",
        "ingredient": "DIATRIZOATE MEGLUMINE",
        "trade_name": "CYSTOGRAFIN",
        "forms": [
            {
                "orange_id": "10040-18",
                "form": "SOLUTION",
                "route": "URETHRAL",
                "dosage": [
                    "30%"
                ]
            }
        ]
    },
    {
        "id": 1265,
        "type": "RX",
        "ingredient": "DIATRIZOATE MEGLUMINE",
        "trade_name": "CYSTOGRAFIN DILUTE",
        "forms": [
            {
                "orange_id": "10040-22",
                "form": "SOLUTION",
                "route": "URETHRAL",
                "dosage": [
                    "18%"
                ]
            }
        ]
    },
    {
        "id": 1266,
        "type": "RX",
        "ingredient": "DIATRIZOATE MEGLUMINE AND DIATRIZOATE SODIUM",
        "trade_name": "GASTROGRAFIN",
        "forms": [
            {
                "orange_id": "11245-3",
                "form": "SOLUTION",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "66%-10%"
                ]
            }
        ]
    },
    {
        "id": 1267,
        "type": "RX",
        "ingredient": "DIATRIZOATE MEGLUMINE AND DIATRIZOATE SODIUM",
        "trade_name": "MD-GASTROVIEW",
        "forms": [
            {
                "orange_id": "87388-1",
                "form": "SOLUTION",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "66%-10%"
                ]
            }
        ]
    },
    {
        "id": 1268,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "DIASTAT",
        "forms": [
            {
                "orange_id": "20648-1",
                "form": "GEL",
                "route": "RECTAL",
                "dosage": [
                    "2.5MG/0.5ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1269,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "DIASTAT ACUDIAL",
        "forms": [
            {
                "orange_id": "20648-7",
                "form": "GEL",
                "route": "RECTAL",
                "dosage": [
                    "10MG/2ML (5MG/ML)",
                    "20MG/4ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1270,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "DIAZEPAM",
        "forms": [
            {
                "orange_id": "210363-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/2ML (5MG/ML)",
                    "50MG/10ML (5MG/ML)"
                ]
            },
            {
                "orange_id": "70928-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "71307-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1271,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "DIAZEPAM INTENSOL",
        "forms": [
            {
                "orange_id": "71415-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1272,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "VALIUM",
        "forms": [
            {
                "orange_id": "13263-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1273,
        "type": "RX",
        "ingredient": "DIAZEPAM",
        "trade_name": "VALTOCO",
        "forms": [
            {
                "orange_id": "211635-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "5MG/SPRAY",
                    "7.5MG/SPRAY",
                    "10MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1274,
        "type": "RX",
        "ingredient": "DIAZOXIDE",
        "trade_name": "DIAZOXIDE",
        "forms": [
            {
                "orange_id": "211050-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1275,
        "type": "RX",
        "ingredient": "DIAZOXIDE",
        "trade_name": "PROGLYCEM",
        "forms": [
            {
                "orange_id": "17453-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1276,
        "type": "RX",
        "ingredient": "DICHLORPHENAMIDE",
        "trade_name": "KEVEYIS",
        "forms": [
            {
                "orange_id": "11366-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1277,
        "type": "RX",
        "ingredient": "DICLOFENAC",
        "trade_name": "ZORVOLEX",
        "forms": [
            {
                "orange_id": "204592-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "35MG"
                ]
            }
        ]
    },
    {
        "id": 1278,
        "type": "RX",
        "ingredient": "DICLOFENAC EPOLAMINE",
        "trade_name": "FLECTOR",
        "forms": [
            {
                "orange_id": "21234-1",
                "form": "SYSTEM",
                "route": "TOPICAL",
                "dosage": [
                    "1.3%"
                ]
            }
        ]
    },
    {
        "id": 1279,
        "type": "RX",
        "ingredient": "DICLOFENAC EPOLAMINE",
        "trade_name": "LICART",
        "forms": [
            {
                "orange_id": "206976-1",
                "form": "SYSTEM",
                "route": "TOPICAL",
                "dosage": [
                    "1.3%"
                ]
            }
        ]
    },
    {
        "id": 1280,
        "type": "RX",
        "ingredient": "DICLOFENAC POTASSIUM",
        "trade_name": "CAMBIA",
        "forms": [
            {
                "orange_id": "22165-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1281,
        "type": "RX",
        "ingredient": "DICLOFENAC POTASSIUM",
        "trade_name": "CATAFLAM",
        "forms": [
            {
                "orange_id": "76561-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1282,
        "type": "RX",
        "ingredient": "DICLOFENAC POTASSIUM",
        "trade_name": "DICLOFENAC POTASSIUM",
        "forms": [
            {
                "orange_id": "213875-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            },
            {
                "orange_id": "202964-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            },
            {
                "orange_id": "215585-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1283,
        "type": "RX",
        "ingredient": "DICLOFENAC POTASSIUM",
        "trade_name": "ZIPSOR",
        "forms": [
            {
                "orange_id": "22202-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1284,
        "type": "RX",
        "ingredient": "DICLOFENAC SODIUM",
        "trade_name": "DICLOFENAC SODIUM",
        "forms": [
            {
                "orange_id": "206493-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "3%",
                    "1%"
                ]
            },
            {
                "orange_id": "77845-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "206655-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "1.5%"
                ]
            },
            {
                "orange_id": "74514-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "75MG",
                    "25MG"
                ]
            },
            {
                "orange_id": "76201-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1285,
        "type": "RX",
        "ingredient": "DICLOFENAC SODIUM",
        "trade_name": "PENNSAID",
        "forms": [
            {
                "orange_id": "204623-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 1286,
        "type": "OTC",
        "ingredient": "DICLOFENAC SODIUM",
        "trade_name": "VOLTAREN ARTHRITIS PAIN",
        "forms": [
            {
                "orange_id": "22122-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 1287,
        "type": "RX",
        "ingredient": "DICLOFENAC SODIUM AND MISOPROSTOL",
        "trade_name": "ARTHROTEC",
        "forms": [
            {
                "orange_id": "20607-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "50MG-0.2MG",
                    "75MG-0.2MG"
                ]
            }
        ]
    },
    {
        "id": 1288,
        "type": "RX",
        "ingredient": "DICLOFENAC SODIUM AND MISOPROSTOL",
        "trade_name": "DICLOFENAC SODIUM AND MISOPROSTOL",
        "forms": [
            {
                "orange_id": "201089-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "50MG-0.2MG",
                    "75MG-0.2MG"
                ]
            }
        ]
    },
    {
        "id": 1289,
        "type": "RX",
        "ingredient": "DICLOXACILLIN SODIUM",
        "trade_name": "DICLOXACILLIN SODIUM",
        "forms": [
            {
                "orange_id": "62286-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1290,
        "type": "RX",
        "ingredient": "DICYCLOMINE HYDROCHLORIDE",
        "trade_name": "BENTYL",
        "forms": [
            {
                "orange_id": "8370-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1291,
        "type": "RX",
        "ingredient": "DICYCLOMINE HYDROCHLORIDE",
        "trade_name": "BENTYL PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "8370-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1292,
        "type": "RX",
        "ingredient": "DICYCLOMINE HYDROCHLORIDE",
        "trade_name": "DICYCLOMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "84285-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "207084-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "40169-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML"
                ]
            },
            {
                "orange_id": "40161-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1293,
        "type": "RX",
        "ingredient": "DICYCLOMINE HYDROCHLORIDE",
        "trade_name": "DICYCLOMINE HYDROCHLORIDE (PRESERVATIVE FREE)",
        "forms": [
            {
                "orange_id": "40465-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1294,
        "type": "RX",
        "ingredient": "DIENOGEST AND ESTRADIOL VALERATE",
        "trade_name": "NATAZIA",
        "forms": [
            {
                "orange_id": "22252-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "N/A,2MG,3MG,N/A,N/A-3MG,2MG,2MG,1MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1295,
        "type": "RX",
        "ingredient": "DIETHYLPROPION HYDROCHLORIDE",
        "trade_name": "DIETHYLPROPION HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91680-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            },
            {
                "orange_id": "201212-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1296,
        "type": "RX",
        "ingredient": "DIFELIKEFALIN ACETATE",
        "trade_name": "KORSUVA",
        "forms": [
            {
                "orange_id": "214916-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.065MG BASE/1.3ML (EQ 0.05MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1297,
        "type": "RX",
        "ingredient": "DIFLORASONE DIACETATE",
        "trade_name": "DIFLORASONE DIACETATE",
        "forms": [
            {
                "orange_id": "76263-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "75374-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1298,
        "type": "RX",
        "ingredient": "DIFLUNISAL",
        "trade_name": "DIFLUNISAL",
        "forms": [
            {
                "orange_id": "202845-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1299,
        "type": "RX",
        "ingredient": "DIFLUPREDNATE",
        "trade_name": "DIFLUPREDNATE",
        "forms": [
            {
                "orange_id": "211526-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1300,
        "type": "RX",
        "ingredient": "DIFLUPREDNATE",
        "trade_name": "DUREZOL",
        "forms": [
            {
                "orange_id": "22212-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1301,
        "type": "RX",
        "ingredient": "DIGOXIN",
        "trade_name": "DIGOXIN",
        "forms": [
            {
                "orange_id": "21648-1",
                "form": "ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "0.05MG/ML"
                ]
            },
            {
                "orange_id": "40481-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25MG/ML"
                ]
            },
            {
                "orange_id": "214982-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.0625MG",
                    "0.125MG",
                    "0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1302,
        "type": "RX",
        "ingredient": "DIGOXIN",
        "trade_name": "LANOXIN",
        "forms": [
            {
                "orange_id": "9330-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.25MG/ML"
                ]
            },
            {
                "orange_id": "20405-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.0625MG",
                    "0.125MG",
                    "0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1303,
        "type": "RX",
        "ingredient": "DIGOXIN",
        "trade_name": "LANOXIN PEDIATRIC",
        "forms": [
            {
                "orange_id": "9330-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1304,
        "type": "RX",
        "ingredient": "DIHYDROERGOTAMINE MESYLATE",
        "trade_name": "D. H. E. 45",
        "forms": [
            {
                "orange_id": "5929-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1305,
        "type": "RX",
        "ingredient": "DIHYDROERGOTAMINE MESYLATE",
        "trade_name": "DIHYDROERGOTAMINE MESYLATE",
        "forms": [
            {
                "orange_id": "40453-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "214105-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1306,
        "type": "RX",
        "ingredient": "DIHYDROERGOTAMINE MESYLATE",
        "trade_name": "MIGRANAL",
        "forms": [
            {
                "orange_id": "20148-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1307,
        "type": "RX",
        "ingredient": "DIHYDROERGOTAMINE MESYLATE",
        "trade_name": "TRUDHESA",
        "forms": [
            {
                "orange_id": "213436-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.725MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1308,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "CARDIZEM",
        "forms": [
            {
                "orange_id": "18602-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "90MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 1309,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "CARDIZEM CD",
        "forms": [
            {
                "orange_id": "20062-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 1310,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "CARDIZEM LA",
        "forms": [
            {
                "orange_id": "21392-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG",
                    "360MG",
                    "420MG"
                ]
            }
        ]
    },
    {
        "id": 1311,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "CARTIA XT",
        "forms": [
            {
                "orange_id": "74752-2",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 1312,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "DILTIAZEM HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206997-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "360MG",
                    "60MG",
                    "90MG",
                    "300MG",
                    "420MG"
                ]
            },
            {
                "orange_id": "75086-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML",
                    "100MG/VIAL"
                ]
            },
            {
                "orange_id": "77686-6",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG",
                    "360MG",
                    "420MG"
                ]
            },
            {
                "orange_id": "211596-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "90MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 1313,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "DILTIAZEM HYDROCHLORIDE IN DEXTROSE 5%",
        "forms": [
            {
                "orange_id": "215252-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "125MG/125ML (1MG/ML)",
                    "250MG/250ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1314,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "TAZTIA XT",
        "forms": [
            {
                "orange_id": "75401-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 1315,
        "type": "RX",
        "ingredient": "DILTIAZEM HYDROCHLORIDE",
        "trade_name": "TIAZAC",
        "forms": [
            {
                "orange_id": "20401-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "300MG",
                    "360MG",
                    "420MG"
                ]
            }
        ]
    },
    {
        "id": 1316,
        "type": "RX",
        "ingredient": "DIMENHYDRINATE",
        "trade_name": "DIMENHYDRINATE",
        "forms": [
            {
                "orange_id": "40519-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1317,
        "type": "RX",
        "ingredient": "DIMERCAPROL",
        "trade_name": "BAL",
        "forms": [
            {
                "orange_id": "5939-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 1318,
        "type": "RX",
        "ingredient": "DIMETHYL FUMARATE",
        "trade_name": "DIMETHYL FUMARATE",
        "forms": [
            {
                "orange_id": "210499-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 1319,
        "type": "RX",
        "ingredient": "DIMETHYL FUMARATE",
        "trade_name": "TECFIDERA",
        "forms": [
            {
                "orange_id": "204063-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 1320,
        "type": "RX",
        "ingredient": "DIMETHYL SULFOXIDE",
        "trade_name": "RIMSO-50",
        "forms": [
            {
                "orange_id": "17788-1",
                "form": "SOLUTION",
                "route": "INTRAVESICAL",
                "dosage": [
                    "50%"
                ]
            }
        ]
    },
    {
        "id": 1321,
        "type": "RX",
        "ingredient": "DINOPROSTONE",
        "trade_name": "CERVIDIL",
        "forms": [
            {
                "orange_id": "20411-1",
                "form": "INSERT, EXTENDED RELEASE",
                "route": "VAGINAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1322,
        "type": "RX",
        "ingredient": "DINOPROSTONE",
        "trade_name": "PREPIDIL",
        "forms": [
            {
                "orange_id": "19617-1",
                "form": "GEL",
                "route": "ENDOCERVICAL",
                "dosage": [
                    "0.5MG/3GM"
                ]
            }
        ]
    },
    {
        "id": 1323,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE CITRATE AND IBUPROFEN",
        "trade_name": "ADVIL PM",
        "forms": [
            {
                "orange_id": "21394-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "38MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 1324,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE CITRATE AND IBUPROFEN",
        "trade_name": "IBUPROFEN AND DIPHENHYDRAMINE CITRATE",
        "forms": [
            {
                "orange_id": "90619-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "38MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 1325,
        "type": "RX",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE",
        "trade_name": "DIPHENHYDRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "87513-1",
                "form": "ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "12.5MG/5ML"
                ]
            },
            {
                "orange_id": "40466-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1326,
        "type": "RX",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE",
        "trade_name": "DIPHENHYDRAMINE HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "91526-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1327,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE AND IBUPROFEN",
        "trade_name": "ADVIL PM",
        "forms": [
            {
                "orange_id": "21393-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG-EQ 200MG FREE ACID AND POTASSIUM SALT"
                ]
            }
        ]
    },
    {
        "id": 1328,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE AND IBUPROFEN",
        "trade_name": "IBUPROFEN AND DIPHENHYDRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210676-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG-EQ 200MG FREE ACID AND POTASSIUM SALT"
                ]
            }
        ]
    },
    {
        "id": 1329,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE AND NAPROXEN SODIUM",
        "trade_name": "ALEVE PM",
        "forms": [
            {
                "orange_id": "205352-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-220MG"
                ]
            }
        ]
    },
    {
        "id": 1330,
        "type": "OTC",
        "ingredient": "DIPHENHYDRAMINE HYDROCHLORIDE AND NAPROXEN SODIUM",
        "trade_name": "NAPROXEN SODIUM AND DIPHENHYDRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "209726-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-220MG"
                ]
            }
        ]
    },
    {
        "id": 1331,
        "type": "RX",
        "ingredient": "DIPYRIDAMOLE",
        "trade_name": "DIPYRIDAMOLE",
        "forms": [
            {
                "orange_id": "74939-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "86944-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 1332,
        "type": "RX",
        "ingredient": "DIPYRIDAMOLE",
        "trade_name": "PERSANTINE",
        "forms": [
            {
                "orange_id": "12836-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 1333,
        "type": "RX",
        "ingredient": "DIROXIMEL FUMARATE",
        "trade_name": "VUMERITY",
        "forms": [
            {
                "orange_id": "211855-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "231MG"
                ]
            }
        ]
    },
    {
        "id": 1334,
        "type": "RX",
        "ingredient": "DISOPYRAMIDE PHOSPHATE",
        "trade_name": "DISOPYRAMIDE PHOSPHATE",
        "forms": [
            {
                "orange_id": "70101-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1335,
        "type": "RX",
        "ingredient": "DISOPYRAMIDE PHOSPHATE",
        "trade_name": "NORPACE",
        "forms": [
            {
                "orange_id": "17447-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1336,
        "type": "RX",
        "ingredient": "DISOPYRAMIDE PHOSPHATE",
        "trade_name": "NORPACE CR",
        "forms": [
            {
                "orange_id": "18655-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1337,
        "type": "RX",
        "ingredient": "DISULFIRAM",
        "trade_name": "DISULFIRAM",
        "forms": [
            {
                "orange_id": "91681-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1338,
        "type": "RX",
        "ingredient": "DIVALPROEX SODIUM",
        "trade_name": "DEPAKOTE",
        "forms": [
            {
                "orange_id": "19680-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG VALPROIC ACID"
                ]
            },
            {
                "orange_id": "18723-3",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG VALPROIC ACID",
                    "EQ 250MG VALPROIC ACID",
                    "EQ 500MG VALPROIC ACID"
                ]
            }
        ]
    },
    {
        "id": 1339,
        "type": "RX",
        "ingredient": "DIVALPROEX SODIUM",
        "trade_name": "DEPAKOTE ER",
        "forms": [
            {
                "orange_id": "21168-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG VALPROIC ACID",
                    "EQ 500MG VALPROIC ACID"
                ]
            }
        ]
    },
    {
        "id": 1340,
        "type": "RX",
        "ingredient": "DIVALPROEX SODIUM",
        "trade_name": "DIVALPROEX SODIUM",
        "forms": [
            {
                "orange_id": "213181-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG VALPROIC ACID"
                ]
            },
            {
                "orange_id": "79080-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 500MG VALPROIC ACID",
                    "EQ 125MG VALPROIC ACID",
                    "EQ 250MG VALPROIC ACID"
                ]
            },
            {
                "orange_id": "203730-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG VALPROIC ACID",
                    "EQ 500MG VALPROIC ACID"
                ]
            }
        ]
    },
    {
        "id": 1341,
        "type": "RX",
        "ingredient": "DOBUTAMINE HYDROCHLORIDE",
        "trade_name": "DOBUTAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74277-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 12.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1342,
        "type": "RX",
        "ingredient": "DOBUTAMINE HYDROCHLORIDE",
        "trade_name": "DOBUTAMINE HYDROCHLORIDE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20255-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/100ML",
                    "EQ 100MG BASE/100ML",
                    "EQ 200MG BASE/100ML",
                    "EQ 400MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 1343,
        "type": "RX",
        "ingredient": "DOCETAXEL",
        "trade_name": "DOCETAXEL",
        "forms": [
            {
                "orange_id": "201195-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML (20MG/ML)",
                    "80MG/4ML (20MG/ML)",
                    "160MG/8ML (20MG/ML)",
                    "140MG/7ML (20MG/ML)",
                    "20MG/2ML (10MG/ML)",
                    "80MG/8ML (10MG/ML)",
                    "160MG/16ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "22534-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/ML (20MG/ML)",
                    "80MG/4ML (20MG/ML)",
                    "160MG/8ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1344,
        "type": "RX",
        "ingredient": "DOCETAXEL",
        "trade_name": "TAXOTERE",
        "forms": [
            {
                "orange_id": "20449-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML (20MG/ML)",
                    "80MG/4ML (20MG/ML)",
                    "160MG/8ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1345,
        "type": "OTC",
        "ingredient": "DOCOSANOL",
        "trade_name": "ABREVA",
        "forms": [
            {
                "orange_id": "20941-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 1346,
        "type": "OTC",
        "ingredient": "DOCOSANOL",
        "trade_name": "DOCOSANOL",
        "forms": [
            {
                "orange_id": "208754-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 1347,
        "type": "RX",
        "ingredient": "DOFETILIDE",
        "trade_name": "DOFETILDE",
        "forms": [
            {
                "orange_id": "210740-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1348,
        "type": "RX",
        "ingredient": "DOFETILIDE",
        "trade_name": "DOFETILIDE",
        "forms": [
            {
                "orange_id": "213338-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1349,
        "type": "RX",
        "ingredient": "DOFETILIDE",
        "trade_name": "TIKOSYN",
        "forms": [
            {
                "orange_id": "20931-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1350,
        "type": "RX",
        "ingredient": "DOLASETRON MESYLATE",
        "trade_name": "ANZEMET",
        "forms": [
            {
                "orange_id": "20623-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1351,
        "type": "RX",
        "ingredient": "DOLUTEGRAVIR SODIUM",
        "trade_name": "TIVICAY",
        "forms": [
            {
                "orange_id": "204790-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1352,
        "type": "RX",
        "ingredient": "DOLUTEGRAVIR SODIUM",
        "trade_name": "TIVICAY PD",
        "forms": [
            {
                "orange_id": "213983-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1353,
        "type": "RX",
        "ingredient": "DOLUTEGRAVIR SODIUM AND LAMIVUDINE",
        "trade_name": "DOVATO",
        "forms": [
            {
                "orange_id": "211994-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE-300MG"
                ]
            }
        ]
    },
    {
        "id": 1354,
        "type": "RX",
        "ingredient": "DOLUTEGRAVIR SODIUM AND RILPIVIRINE HYDROCHLORIDE",
        "trade_name": "JULUCA",
        "forms": [
            {
                "orange_id": "210192-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE-EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1355,
        "type": "RX",
        "ingredient": "DONEPEZIL HYDROCHLORIDE",
        "trade_name": "ARICEPT",
        "forms": [
            {
                "orange_id": "20690-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "23MG"
                ]
            }
        ]
    },
    {
        "id": 1356,
        "type": "RX",
        "ingredient": "DONEPEZIL HYDROCHLORIDE",
        "trade_name": "DONEPEZIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205269-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "78662-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "23MG"
                ]
            }
        ]
    },
    {
        "id": 1357,
        "type": "RX",
        "ingredient": "DONEPEZIL HYDROCHLORIDE AND MEMANTINE HYDROCHLORIDE",
        "trade_name": "NAMZARIC",
        "forms": [
            {
                "orange_id": "206439-3",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG-7MG",
                    "10MG-14MG",
                    "10MG-21MG",
                    "10MG-28MG"
                ]
            }
        ]
    },
    {
        "id": 1358,
        "type": "RX",
        "ingredient": "DOPAMINE HYDROCHLORIDE",
        "trade_name": "DOPAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207707-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/ML",
                    "80MG/ML",
                    "80MG/100ML",
                    "160MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1359,
        "type": "RX",
        "ingredient": "DOPAMINE HYDROCHLORIDE",
        "trade_name": "DOPAMINE HYDROCHLORIDE AND DEXTROSE 5%",
        "forms": [
            {
                "orange_id": "19099-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80MG/100ML",
                    "320MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1360,
        "type": "RX",
        "ingredient": "DOPAMINE HYDROCHLORIDE",
        "trade_name": "DOPAMINE HYDROCHLORIDE AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19099-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/100ML",
                    "160MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1361,
        "type": "RX",
        "ingredient": "DOPAMINE HYDROCHLORIDE",
        "trade_name": "DOPAMINE HYDROCHLORIDE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19615-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80MG/100ML",
                    "160MG/100ML",
                    "320MG/100ML",
                    "640MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1362,
        "type": "RX",
        "ingredient": "DORAVIRINE",
        "trade_name": "PIFELTRO",
        "forms": [
            {
                "orange_id": "210806-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1363,
        "type": "RX",
        "ingredient": "DORAVIRINE, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "DELSTRIGO",
        "forms": [
            {
                "orange_id": "210807-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-300MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1364,
        "type": "RX",
        "ingredient": "DORZOLAMIDE HYDROCHLORIDE",
        "trade_name": "DORZOLAMIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77846-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 2% BASE"
                ]
            }
        ]
    },
    {
        "id": 1365,
        "type": "RX",
        "ingredient": "DORZOLAMIDE HYDROCHLORIDE",
        "trade_name": "TRUSOPT",
        "forms": [
            {
                "orange_id": "20408-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 2% BASE"
                ]
            }
        ]
    },
    {
        "id": 1366,
        "type": "RX",
        "ingredient": "DORZOLAMIDE HYDROCHLORIDE AND TIMOLOL MALEATE",
        "trade_name": "COSOPT",
        "forms": [
            {
                "orange_id": "20869-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 2% BASE-EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 1367,
        "type": "RX",
        "ingredient": "DORZOLAMIDE HYDROCHLORIDE AND TIMOLOL MALEATE",
        "trade_name": "COSOPT PF",
        "forms": [
            {
                "orange_id": "202667-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 2% BASE-EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 1368,
        "type": "RX",
        "ingredient": "DORZOLAMIDE HYDROCHLORIDE AND TIMOLOL MALEATE",
        "trade_name": "DORZOLAMIDE HYDROCHLORIDE AND TIMOLOL MALEATE",
        "forms": [
            {
                "orange_id": "77847-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 2% BASE-EQ 0.5% BASE",
                    "EQ 2.0% BASE-EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 1369,
        "type": "RX",
        "ingredient": "DOXAPRAM HYDROCHLORIDE",
        "trade_name": "DOPRAM",
        "forms": [
            {
                "orange_id": "14879-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1370,
        "type": "RX",
        "ingredient": "DOXAPRAM HYDROCHLORIDE",
        "trade_name": "DOXAPRAM HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76266-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1371,
        "type": "RX",
        "ingredient": "DOXAZOSIN MESYLATE",
        "trade_name": "CARDURA",
        "forms": [
            {
                "orange_id": "19668-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 4MG BASE",
                    "EQ 8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1372,
        "type": "RX",
        "ingredient": "DOXAZOSIN MESYLATE",
        "trade_name": "CARDURA XL",
        "forms": [
            {
                "orange_id": "21269-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1373,
        "type": "RX",
        "ingredient": "DOXAZOSIN MESYLATE",
        "trade_name": "DOXAZOSIN MESYLATE",
        "forms": [
            {
                "orange_id": "202824-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 4MG BASE",
                    "EQ 8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1374,
        "type": "RX",
        "ingredient": "DOXEPIN HYDROCHLORIDE",
        "trade_name": "DOXEPIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "212624-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            },
            {
                "orange_id": "74721-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            },
            {
                "orange_id": "201951-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 3MG BASE",
                    "EQ 6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1375,
        "type": "RX",
        "ingredient": "DOXEPIN HYDROCHLORIDE",
        "trade_name": "SILENOR",
        "forms": [
            {
                "orange_id": "22036-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 3MG BASE",
                    "EQ 6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1376,
        "type": "RX",
        "ingredient": "DOXEPIN HYDROCHLORIDE",
        "trade_name": "ZONALON",
        "forms": [
            {
                "orange_id": "20126-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 1377,
        "type": "RX",
        "ingredient": "DOXERCALCIFEROL",
        "trade_name": "DOXERCALCIFEROL",
        "forms": [
            {
                "orange_id": "205360-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MCG",
                    "1MCG",
                    "2.5MCG"
                ]
            },
            {
                "orange_id": "203929-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MCG/ML (2MCG/ML)",
                    "4MCG/2ML (2MCG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1378,
        "type": "RX",
        "ingredient": "DOXERCALCIFEROL",
        "trade_name": "HECTOROL",
        "forms": [
            {
                "orange_id": "20862-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MCG",
                    "1MCG",
                    "2.5MCG"
                ]
            },
            {
                "orange_id": "21027-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MCG/ML (2MCG/ML)",
                    "4MCG/2ML (2MCG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1379,
        "type": "RX",
        "ingredient": "DOXORUBICIN HYDROCHLORIDE",
        "trade_name": "DOXIL (LIPOSOMAL)",
        "forms": [
            {
                "orange_id": "50718-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "20MG/10ML (2MG/ML)",
                    "50MG/25ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1380,
        "type": "RX",
        "ingredient": "DOXORUBICIN HYDROCHLORIDE",
        "trade_name": "DOXORUBICIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207228-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "20MG/10ML (2MG/ML)",
                    "50MG/25ML (2MG/ML)"
                ]
            },
            {
                "orange_id": "203622-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML",
                    "200MG/100ML",
                    "20MG/VIAL",
                    "50MG/VIAL",
                    "10MG/VIAL",
                    "150MG/75ML"
                ]
            }
        ]
    },
    {
        "id": 1381,
        "type": "RX",
        "ingredient": "DOXORUBICIN HYDROCHLORIDE",
        "trade_name": "DOXORUBICIN HYDROCHLORIDE (LIPOSOMAL)",
        "forms": [
            {
                "orange_id": "208657-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INJECTION",
                "dosage": [
                    "20MG/10ML (2MG/ML)",
                    "50MG/25ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1382,
        "type": "RX",
        "ingredient": "DOXYCYCLINE",
        "trade_name": "DOXYCYCLINE",
        "forms": [
            {
                "orange_id": "209165-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 100MG BASE",
                    "EQ 50MG BASE",
                    "EQ 150MG BASE"
                ]
            },
            {
                "orange_id": "65454-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE/5ML"
                ]
            },
            {
                "orange_id": "91605-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1383,
        "type": "RX",
        "ingredient": "DOXYCYCLINE",
        "trade_name": "MONODOX",
        "forms": [
            {
                "orange_id": "50641-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1384,
        "type": "RX",
        "ingredient": "DOXYCYCLINE",
        "trade_name": "ORACEA",
        "forms": [
            {
                "orange_id": "50805-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 1385,
        "type": "RX",
        "ingredient": "DOXYCYCLINE",
        "trade_name": "VIBRAMYCIN",
        "forms": [
            {
                "orange_id": "50006-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1386,
        "type": "RX",
        "ingredient": "DOXYCYCLINE CALCIUM",
        "trade_name": "VIBRAMYCIN",
        "forms": [
            {
                "orange_id": "50480-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1387,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "ACTICLATE",
        "forms": [
            {
                "orange_id": "205931-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1388,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DORYX",
        "forms": [
            {
                "orange_id": "50795-6",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 80MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1389,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DORYX MPC",
        "forms": [
            {
                "orange_id": "50795-8",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 120MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1390,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DOXY 100",
        "forms": [
            {
                "orange_id": "62475-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1391,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DOXY 200",
        "forms": [
            {
                "orange_id": "62475-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 200MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1392,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DOXYCYCLINE",
        "forms": [
            {
                "orange_id": "62569-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL",
                    "EQ 200MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1393,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "DOXYCYCLINE HYCLATE",
        "forms": [
            {
                "orange_id": "62031-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            },
            {
                "orange_id": "62992-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL",
                    "EQ 200MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "90134-3",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE",
                    "EQ 200MG BASE",
                    "EQ 150MG BASE"
                ]
            },
            {
                "orange_id": "210664-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 75MG BASE",
                    "EQ 150MG BASE",
                    "EQ 20MG BASE",
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1394,
        "type": "RX",
        "ingredient": "DOXYCYCLINE HYCLATE",
        "trade_name": "VIBRAMYCIN",
        "forms": [
            {
                "orange_id": "50007-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1395,
        "type": "OTC",
        "ingredient": "DOXYLAMINE SUCCINATE",
        "trade_name": "DOXYLAMINE SUCCINATE",
        "forms": [
            {
                "orange_id": "40564-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1396,
        "type": "OTC",
        "ingredient": "DOXYLAMINE SUCCINATE",
        "trade_name": "UNISOM",
        "forms": [
            {
                "orange_id": "18066-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1397,
        "type": "RX",
        "ingredient": "DOXYLAMINE SUCCINATE AND PYRIDOXINE HYDROCHLORIDE",
        "trade_name": "BONJESTA",
        "forms": [
            {
                "orange_id": "209661-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG-20MG"
                ]
            }
        ]
    },
    {
        "id": 1398,
        "type": "RX",
        "ingredient": "DOXYLAMINE SUCCINATE AND PYRIDOXINE HYDROCHLORIDE",
        "trade_name": "DICLEGIS",
        "forms": [
            {
                "orange_id": "21876-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 1399,
        "type": "RX",
        "ingredient": "DOXYLAMINE SUCCINATE AND PYRIDOXINE HYDROCHLORIDE",
        "trade_name": "DOXYLAMINE SUCCINATE AND PYRIDOXINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205811-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 1400,
        "type": "RX",
        "ingredient": "DRONABINOL",
        "trade_name": "DRONABINOL",
        "forms": [
            {
                "orange_id": "79217-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1401,
        "type": "RX",
        "ingredient": "DRONABINOL",
        "trade_name": "MARINOL",
        "forms": [
            {
                "orange_id": "18651-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1402,
        "type": "RX",
        "ingredient": "DRONABINOL",
        "trade_name": "SYNDROS",
        "forms": [
            {
                "orange_id": "205525-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1403,
        "type": "RX",
        "ingredient": "DRONEDARONE HYDROCHLORIDE",
        "trade_name": "MULTAQ",
        "forms": [
            {
                "orange_id": "22425-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1404,
        "type": "RX",
        "ingredient": "DROPERIDOL",
        "trade_name": "DROPERIDOL",
        "forms": [
            {
                "orange_id": "72123-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1405,
        "type": "RX",
        "ingredient": "DROPERIDOL",
        "trade_name": "INAPSINE",
        "forms": [
            {
                "orange_id": "16796-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1406,
        "type": "RX",
        "ingredient": "DROSPIRENONE",
        "trade_name": "SLYND",
        "forms": [
            {
                "orange_id": "211367-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 1407,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ESTETROL",
        "trade_name": "NEXTSTELLIS",
        "forms": [
            {
                "orange_id": "214154-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-14.2MG"
                ]
            }
        ]
    },
    {
        "id": 1408,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ESTRADIOL",
        "trade_name": "ANGELIQ",
        "forms": [
            {
                "orange_id": "21355-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG-0.5MG",
                    "0.5MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1409,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "78515-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            },
            {
                "orange_id": "77527-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "3MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1410,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "LORYNA",
        "forms": [
            {
                "orange_id": "79221-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            }
        ]
    },
    {
        "id": 1411,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "LO-ZUMANDIMINE",
        "forms": [
            {
                "orange_id": "209632-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            }
        ]
    },
    {
        "id": 1412,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "MELAMISA",
        "forms": [
            {
                "orange_id": "202016-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            }
        ]
    },
    {
        "id": 1413,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "NIKKI",
        "forms": [
            {
                "orange_id": "201661-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            }
        ]
    },
    {
        "id": 1414,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "SYEDA",
        "forms": [
            {
                "orange_id": "90114-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "3MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1415,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "YAELA",
        "forms": [
            {
                "orange_id": "202015-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "3MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1416,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "YASMIN",
        "forms": [
            {
                "orange_id": "21098-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "3MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1417,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "YAZ",
        "forms": [
            {
                "orange_id": "21676-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG-0.02MG"
                ]
            }
        ]
    },
    {
        "id": 1418,
        "type": "RX",
        "ingredient": "DROSPIRENONE AND ETHINYL ESTRADIOL",
        "trade_name": "ZUMANDIMINE",
        "forms": [
            {
                "orange_id": "209407-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "3MG-0.03MG"
                ]
            }
        ]
    },
    {
        "id": 1419,
        "type": "RX",
        "ingredient": "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
        "trade_name": "BEYAZ",
        "forms": [
            {
                "orange_id": "22532-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG,N/A-0.02MG,N/A-0.451MG,0.451MG"
                ]
            }
        ]
    },
    {
        "id": 1420,
        "type": "RX",
        "ingredient": "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
        "trade_name": "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
        "forms": [
            {
                "orange_id": "205947-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG,N/A-0.02MG,N/A-0.451MG,0.451MG",
                    "3MG,N/A-0.03MG,N/A-0.451MG,0.451MG"
                ]
            }
        ]
    },
    {
        "id": 1421,
        "type": "RX",
        "ingredient": "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
        "trade_name": "SAFYRAL",
        "forms": [
            {
                "orange_id": "22574-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG,N/A-0.03MG,N/A-0.451MG,0.451MG"
                ]
            }
        ]
    },
    {
        "id": 1422,
        "type": "RX",
        "ingredient": "DROSPIRENONE, ETHINYL ESTRADIOL AND LEVOMEFOLATE CALCIUM",
        "trade_name": "TYDEMY",
        "forms": [
            {
                "orange_id": "205948-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG,N/A-0.03MG,N/A-0.451MG,0.451MG"
                ]
            }
        ]
    },
    {
        "id": 1423,
        "type": "RX",
        "ingredient": "DROXIDOPA",
        "trade_name": "DROXIDOPA",
        "forms": [
            {
                "orange_id": "214391-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 1424,
        "type": "RX",
        "ingredient": "DROXIDOPA",
        "trade_name": "NORTHERA",
        "forms": [
            {
                "orange_id": "203202-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 1425,
        "type": "RX",
        "ingredient": "DULOXETINE HYDROCHLORIDE",
        "trade_name": "CYMBALTA",
        "forms": [
            {
                "orange_id": "21427-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1426,
        "type": "RX",
        "ingredient": "DULOXETINE HYDROCHLORIDE",
        "trade_name": "DRIZALMA SPRINKLE",
        "forms": [
            {
                "orange_id": "212516-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE",
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1427,
        "type": "RX",
        "ingredient": "DULOXETINE HYDROCHLORIDE",
        "trade_name": "DULOXETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90776-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 60MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1428,
        "type": "RX",
        "ingredient": "DUTASTERIDE",
        "trade_name": "AVODART",
        "forms": [
            {
                "orange_id": "21319-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1429,
        "type": "RX",
        "ingredient": "DUTASTERIDE",
        "trade_name": "DUTASTERIDE",
        "forms": [
            {
                "orange_id": "206373-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1430,
        "type": "RX",
        "ingredient": "DUTASTERIDE AND TAMSULOSIN HYDROCHLORIDE",
        "trade_name": "DUTASTERIDE AND TAMSULOSIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202509-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1431,
        "type": "RX",
        "ingredient": "DUTASTERIDE AND TAMSULOSIN HYDROCHLORIDE",
        "trade_name": "JALYN",
        "forms": [
            {
                "orange_id": "22460-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1432,
        "type": "RX",
        "ingredient": "DUVELISIB",
        "trade_name": "COPIKTRA",
        "forms": [
            {
                "orange_id": "211155-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1433,
        "type": "RX",
        "ingredient": "DYCLONINE HYDROCHLORIDE",
        "trade_name": "DYCLOPRO",
        "forms": [
            {
                "orange_id": "200480-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%",
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 1434,
        "type": "RX",
        "ingredient": "ECHOTHIOPHATE IODIDE",
        "trade_name": "PHOSPHOLINE IODIDE",
        "forms": [
            {
                "orange_id": "11963-1",
                "form": "FOR SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.125%"
                ]
            }
        ]
    },
    {
        "id": 1435,
        "type": "RX",
        "ingredient": "ECONAZOLE NITRATE",
        "trade_name": "ECONAZOLE NITRATE",
        "forms": [
            {
                "orange_id": "76479-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 1436,
        "type": "RX",
        "ingredient": "ECONAZOLE NITRATE",
        "trade_name": "ECOZA",
        "forms": [
            {
                "orange_id": "205175-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 1437,
        "type": "RX",
        "ingredient": "ECONAZOLE NITRATE",
        "trade_name": "SPECTAZOLE",
        "forms": [
            {
                "orange_id": "18751-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 1438,
        "type": "RX",
        "ingredient": "EDARAVONE",
        "trade_name": "RADICAVA",
        "forms": [
            {
                "orange_id": "209176-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30MG/100ML (0.3MG/ML)",
                    "60MG/100ML (0.6MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1439,
        "type": "RX",
        "ingredient": "EDETATE CALCIUM DISODIUM",
        "trade_name": "CALCIUM DISODIUM VERSENATE",
        "forms": [
            {
                "orange_id": "8922-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1440,
        "type": "RX",
        "ingredient": "EDOXABAN TOSYLATE",
        "trade_name": "SAVAYSA",
        "forms": [
            {
                "orange_id": "206316-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE",
                    "EQ 30MG BASE",
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1441,
        "type": "RX",
        "ingredient": "EFAVIRENZ",
        "trade_name": "EFAVIRENZ",
        "forms": [
            {
                "orange_id": "78064-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "77673-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1442,
        "type": "RX",
        "ingredient": "EFAVIRENZ",
        "trade_name": "SUSTIVA",
        "forms": [
            {
                "orange_id": "20972-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "21360-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1443,
        "type": "RX",
        "ingredient": "EFAVIRENZ, EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "ATRIPLA",
        "forms": [
            {
                "orange_id": "21937-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG-200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1444,
        "type": "RX",
        "ingredient": "EFAVIRENZ, EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "EFAVIRENZ, EMTRICITABINE, AND TENOFOVIR DISOPROXIL FUMARATE",
        "forms": [
            {
                "orange_id": "203041-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG-200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1445,
        "type": "RX",
        "ingredient": "EFAVIRENZ, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "EFAVIRENZ, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "forms": [
            {
                "orange_id": "213038-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-300MG-300MG",
                    "600MG-300MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1446,
        "type": "RX",
        "ingredient": "EFAVIRENZ, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "SYMFI",
        "forms": [
            {
                "orange_id": "22142-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG-300MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1447,
        "type": "RX",
        "ingredient": "EFAVIRENZ, LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "SYMFI LO",
        "forms": [
            {
                "orange_id": "208255-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-300MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1448,
        "type": "RX",
        "ingredient": "EFINACONAZOLE",
        "trade_name": "EFINACONAZOLE",
        "forms": [
            {
                "orange_id": "211969-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 1449,
        "type": "RX",
        "ingredient": "EFINACONAZOLE",
        "trade_name": "JUBLIA",
        "forms": [
            {
                "orange_id": "203567-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 1450,
        "type": "RX",
        "ingredient": "EFLORNITHINE HYDROCHLORIDE",
        "trade_name": "VANIQA",
        "forms": [
            {
                "orange_id": "21145-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "13.9%"
                ]
            }
        ]
    },
    {
        "id": 1451,
        "type": "RX",
        "ingredient": "ELAGOLIX SODIUM",
        "trade_name": "ORILISSA",
        "forms": [
            {
                "orange_id": "210450-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1452,
        "type": "RX",
        "ingredient": "ELAGOLIX SODIUM,ESTRADIOL,NORETHINDRONE ACETATE AND ELAGOLIX SODIUM",
        "trade_name": "ORIAHNN (COPACKAGED)",
        "forms": [
            {
                "orange_id": "213388-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG BASE,1MG,0.5MG- EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1453,
        "type": "RX",
        "ingredient": "ELBASVIR AND GRAZOPREVIR",
        "trade_name": "ZEPATIER",
        "forms": [
            {
                "orange_id": "208261-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 1454,
        "type": "RX",
        "ingredient": "ELETRIPTAN HYDROBROMIDE",
        "trade_name": "ELETRIPTAN HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "205186-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1455,
        "type": "RX",
        "ingredient": "ELETRIPTAN HYDROBROMIDE",
        "trade_name": "RELPAX",
        "forms": [
            {
                "orange_id": "21016-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1456,
        "type": "RX",
        "ingredient": "ELEXACAFTOR, IVACAFTOR, TEZACAFTOR AND IVACAFTOR",
        "trade_name": "TRIKAFTA (COPACKAGED)",
        "forms": [
            {
                "orange_id": "212273-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG,37.5MG,25MG- 75MG",
                    "100MG,75MG,50MG- 150MG"
                ]
            }
        ]
    },
    {
        "id": 1457,
        "type": "RX",
        "ingredient": "ELIGLUSTAT TARTRATE",
        "trade_name": "CERDELGA",
        "forms": [
            {
                "orange_id": "205494-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 84MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1458,
        "type": "RX",
        "ingredient": "ELIGLUSTAT TARTRATE",
        "trade_name": "ELIGLUSTAT TARTRATE",
        "forms": [
            {
                "orange_id": "212463-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 84MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1459,
        "type": "RX",
        "ingredient": "ELTROMBOPAG OLAMINE",
        "trade_name": "PROMACTA",
        "forms": [
            {
                "orange_id": "22291-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG ACID",
                    "EQ 25MG ACID",
                    "EQ 50MG ACID",
                    "EQ 75MG ACID"
                ]
            }
        ]
    },
    {
        "id": 1460,
        "type": "RX",
        "ingredient": "ELTROMBOPAG OLAMINE",
        "trade_name": "PROMACTA KIT",
        "forms": [
            {
                "orange_id": "207027-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG ACID/PACKET",
                    "EQ 25MG ACID/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1461,
        "type": "RX",
        "ingredient": "ELUXADOLINE",
        "trade_name": "VIBERZI",
        "forms": [
            {
                "orange_id": "206940-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1462,
        "type": "RX",
        "ingredient": "EMPAGLIFLOZIN",
        "trade_name": "JARDIANCE",
        "forms": [
            {
                "orange_id": "204629-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1463,
        "type": "RX",
        "ingredient": "EMPAGLIFLOZIN AND LINAGLIPTIN",
        "trade_name": "GLYXAMBI",
        "forms": [
            {
                "orange_id": "206073-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-5MG",
                    "25MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 1464,
        "type": "RX",
        "ingredient": "EMPAGLIFLOZIN, LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "TRIJARDY XR",
        "forms": [
            {
                "orange_id": "212614-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-2.5MG-1GM",
                    "10MG-5MG-1GM",
                    "12.5MG-2.5MG-1GM",
                    "25MG-5MG-1GM"
                ]
            }
        ]
    },
    {
        "id": 1465,
        "type": "RX",
        "ingredient": "EMPAGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "SYNJARDY",
        "forms": [
            {
                "orange_id": "206111-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-1GM",
                    "5MG-500MG",
                    "12.5MG-1GM",
                    "12.5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 1466,
        "type": "RX",
        "ingredient": "EMPAGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "SYNJARDY XR",
        "forms": [
            {
                "orange_id": "208658-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-1GM",
                    "10MG-1GM",
                    "12.5MG-1GM",
                    "25MG-1GM"
                ]
            }
        ]
    },
    {
        "id": 1467,
        "type": "RX",
        "ingredient": "EMTRICITABINE",
        "trade_name": "EMTRICITABINE",
        "forms": [
            {
                "orange_id": "91168-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1468,
        "type": "RX",
        "ingredient": "EMTRICITABINE",
        "trade_name": "EMTRIVA",
        "forms": [
            {
                "orange_id": "21500-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            },
            {
                "orange_id": "21896-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1469,
        "type": "RX",
        "ingredient": "EMTRICITABINE, RILPIVIRINE HYDROCHLORIDE AND TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "ODEFSEY",
        "forms": [
            {
                "orange_id": "208351-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-EQ 25MG BASE-EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1470,
        "type": "RX",
        "ingredient": "EMTRICITABINE, RILPIVIRINE HYDROCHLORIDE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "COMPLERA",
        "forms": [
            {
                "orange_id": "202123-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-EQ 25MG BASE-300MG"
                ]
            }
        ]
    },
    {
        "id": 1471,
        "type": "RX",
        "ingredient": "EMTRICITABINE AND TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "DESCOVY",
        "forms": [
            {
                "orange_id": "208215-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "120MG-EQ 15MG BASE",
                    "200MG-EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1472,
        "type": "RX",
        "ingredient": "EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "EMTRICITABINE AND  TENOFOVIR DISOPROXIL FUMARATE",
        "forms": [
            {
                "orange_id": "201806-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1473,
        "type": "RX",
        "ingredient": "EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "forms": [
            {
                "orange_id": "209721-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-150MG",
                    "133MG-200MG",
                    "167MG-250MG",
                    "200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1474,
        "type": "RX",
        "ingredient": "EMTRICITABINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "TRUVADA",
        "forms": [
            {
                "orange_id": "21752-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-150MG",
                    "133MG-200MG",
                    "167MG-250MG",
                    "200MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 1475,
        "type": "RX",
        "ingredient": "ENALAPRIL MALEATE",
        "trade_name": "ENALAPRIL MALEATE",
        "forms": [
            {
                "orange_id": "212408-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "75479-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1476,
        "type": "RX",
        "ingredient": "ENALAPRIL MALEATE",
        "trade_name": "EPANED",
        "forms": [
            {
                "orange_id": "208686-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1477,
        "type": "RX",
        "ingredient": "ENALAPRIL MALEATE",
        "trade_name": "VASOTEC",
        "forms": [
            {
                "orange_id": "18998-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1478,
        "type": "RX",
        "ingredient": "ENALAPRIL MALEATE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "ENALAPRIL MALEATE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "75727-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-12.5MG",
                    "10MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 1479,
        "type": "RX",
        "ingredient": "ENALAPRIL MALEATE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "VASERETIC",
        "forms": [
            {
                "orange_id": "19221-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-12.5MG",
                    "10MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 1480,
        "type": "RX",
        "ingredient": "ENALAPRILAT",
        "trade_name": "ENALAPRILAT",
        "forms": [
            {
                "orange_id": "75634-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1.25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1481,
        "type": "RX",
        "ingredient": "ENASIDENIB MESYLATE",
        "trade_name": "IDHIFA",
        "forms": [
            {
                "orange_id": "209606-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1482,
        "type": "RX",
        "ingredient": "ENCORAFENIB",
        "trade_name": "BRAFTOVI",
        "forms": [
            {
                "orange_id": "210496-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 1483,
        "type": "RX",
        "ingredient": "ENFUVIRTIDE",
        "trade_name": "FUZEON",
        "forms": [
            {
                "orange_id": "21481-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "90MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1484,
        "type": "RX",
        "ingredient": "ENOXAPARIN SODIUM",
        "trade_name": "ENOXAPARIN SODIUM",
        "forms": [
            {
                "orange_id": "208600-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "300MG/3ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1485,
        "type": "RX",
        "ingredient": "ENOXAPARIN SODIUM",
        "trade_name": "ENOXAPARIN SODIUM (PRESERVATIVE FREE)",
        "forms": [
            {
                "orange_id": "76684-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "30MG/0.3ML (100MG/ML)",
                    "40MG/0.4ML (100MG/ML)",
                    "60MG/0.6ML (100MG/ML)",
                    "80MG/0.8ML (100MG/ML)",
                    "100MG/ML (100MG/ML)",
                    "120MG/0.8ML (150MG/ML)",
                    "150MG/ML (150MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1486,
        "type": "RX",
        "ingredient": "ENOXAPARIN SODIUM",
        "trade_name": "LOVENOX",
        "forms": [
            {
                "orange_id": "20164-9",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "300MG/3ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1487,
        "type": "RX",
        "ingredient": "ENOXAPARIN SODIUM",
        "trade_name": "LOVENOX (PRESERVATIVE FREE)",
        "forms": [
            {
                "orange_id": "20164-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "30MG/0.3ML (100MG/ML)",
                    "40MG/0.4ML (100MG/ML)",
                    "60MG/0.6ML (100MG/ML)",
                    "80MG/0.8ML (100MG/ML)",
                    "100MG/ML (100MG/ML)",
                    "120MG/0.8ML (150MG/ML)",
                    "150MG/ML (150MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1488,
        "type": "RX",
        "ingredient": "ENTACAPONE",
        "trade_name": "COMTAN",
        "forms": [
            {
                "orange_id": "20796-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1489,
        "type": "RX",
        "ingredient": "ENTACAPONE",
        "trade_name": "ENTACAPONE",
        "forms": [
            {
                "orange_id": "205792-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1490,
        "type": "RX",
        "ingredient": "ENTECAVIR",
        "trade_name": "BARACLUDE",
        "forms": [
            {
                "orange_id": "21798-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.05MG/ML"
                ]
            },
            {
                "orange_id": "21797-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1491,
        "type": "RX",
        "ingredient": "ENTECAVIR",
        "trade_name": "ENTECAVIR",
        "forms": [
            {
                "orange_id": "205824-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1492,
        "type": "RX",
        "ingredient": "ENTRECTINIB",
        "trade_name": "ROZLYTREK",
        "forms": [
            {
                "orange_id": "212725-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1493,
        "type": "RX",
        "ingredient": "ENZALUTAMIDE",
        "trade_name": "ENZALUTAMIDE",
        "forms": [
            {
                "orange_id": "209614-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 1494,
        "type": "RX",
        "ingredient": "ENZALUTAMIDE",
        "trade_name": "XTANDI",
        "forms": [
            {
                "orange_id": "203415-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            },
            {
                "orange_id": "213674-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 1495,
        "type": "RX",
        "ingredient": "EPHEDRINE HYDROCHLORIDE",
        "trade_name": "REZIPRES",
        "forms": [
            {
                "orange_id": "213536-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "23.5MG/5ML (4.7MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1496,
        "type": "RX",
        "ingredient": "EPHEDRINE SULFATE",
        "trade_name": "AKOVAZ",
        "forms": [
            {
                "orange_id": "208289-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "25MG/5ML (5MG/ML)",
                    "50MG/ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1497,
        "type": "RX",
        "ingredient": "EPHEDRINE SULFATE",
        "trade_name": "CORPHEDRA",
        "forms": [
            {
                "orange_id": "208943-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1498,
        "type": "RX",
        "ingredient": "EPHEDRINE SULFATE",
        "trade_name": "EMERPHED",
        "forms": [
            {
                "orange_id": "213407-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/10ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1499,
        "type": "RX",
        "ingredient": "EPHEDRINE SULFATE",
        "trade_name": "EPHEDRINE SULFATE",
        "forms": [
            {
                "orange_id": "208609-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1500,
        "type": "RX",
        "ingredient": "EPINASTINE HYDROCHLORIDE",
        "trade_name": "ELESTAT",
        "forms": [
            {
                "orange_id": "21565-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1501,
        "type": "RX",
        "ingredient": "EPINASTINE HYDROCHLORIDE",
        "trade_name": "EPINASTINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204055-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1502,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "ADRENACLICK",
        "forms": [
            {
                "orange_id": "20800-3",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "EQ 0.15MG/DELIVERY",
                    "EQ 0.3MG/DELIVERY"
                ]
            }
        ]
    },
    {
        "id": 1503,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "ADRENALIN",
        "forms": [
            {
                "orange_id": "204200-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "EQ 1MG BASE/ML (EQ 1MG BASE/ML)",
                    "EQ 30MG BASE/30ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1504,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "AUVI-Q",
        "forms": [
            {
                "orange_id": "201739-3",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "EQ 0.1MG/DELIVERY",
                    "EQ 0.15MG/DELIVERY",
                    "EQ 0.3MG/DELIVERY"
                ]
            }
        ]
    },
    {
        "id": 1505,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "EPINEPHRINE",
        "forms": [
            {
                "orange_id": "211880-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "EQ 30MG BASE/30ML (EQ 1MG BASE/ML)"
                ]
            },
            {
                "orange_id": "209359-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1MG/10ML (0.1MG/ML)"
                ]
            },
            {
                "orange_id": "205029-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS, INTRAOCULAR, INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "EQ 1MG BASE/ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1506,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "EPINEPHRINE (AUTOINJECTOR)",
        "forms": [
            {
                "orange_id": "90589-2",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "0.15MG/DELIVERY",
                    "0.3MG/DELIVERY"
                ]
            }
        ]
    },
    {
        "id": 1507,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "EPIPEN",
        "forms": [
            {
                "orange_id": "19430-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "0.3MG/DELIVERY"
                ]
            }
        ]
    },
    {
        "id": 1508,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "EPIPEN JR.",
        "forms": [
            {
                "orange_id": "19430-2",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "0.15MG/DELIVERY"
                ]
            }
        ]
    },
    {
        "id": 1509,
        "type": "OTC",
        "ingredient": "EPINEPHRINE",
        "trade_name": "PRIMATENE MIST",
        "forms": [
            {
                "orange_id": "205920-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.125MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1510,
        "type": "RX",
        "ingredient": "EPINEPHRINE",
        "trade_name": "SYMJEPI",
        "forms": [
            {
                "orange_id": "207534-2",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "0.15MG/0.3ML (0.15MG/0.3ML)",
                    "0.3MG/0.3ML (0.3MG/0.3ML)"
                ]
            }
        ]
    },
    {
        "id": 1511,
        "type": "RX",
        "ingredient": "EPINEPHRINE BITARTRATE AND LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIGNOSPAN FORTE",
        "forms": [
            {
                "orange_id": "88389-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.02MG BASE/ML-2%"
                ]
            }
        ]
    },
    {
        "id": 1512,
        "type": "RX",
        "ingredient": "EPINEPHRINE BITARTRATE AND LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIGNOSPAN STANDARD",
        "forms": [
            {
                "orange_id": "88390-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.01MG BASE/ML-2%"
                ]
            }
        ]
    },
    {
        "id": 1513,
        "type": "RX",
        "ingredient": "EPINEPHRINE BITARTRATE AND PRILOCAINE HYDROCHLORIDE",
        "trade_name": "CITANEST FORTE DENTAL",
        "forms": [
            {
                "orange_id": "21383-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.005MG/ML-4%"
                ]
            }
        ]
    },
    {
        "id": 1514,
        "type": "RX",
        "ingredient": "EPINEPHRINE BITARTRATE AND PRILOCAINE HYDROCHLORIDE",
        "trade_name": "PRILOCAINE HYDROCHLORIDE AND EPINEPHRINE BITARTRATE",
        "forms": [
            {
                "orange_id": "78959-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.005MG/ML-4%"
                ]
            }
        ]
    },
    {
        "id": 1515,
        "type": "RX",
        "ingredient": "EPINEPHRINE AND LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE AND EPINEPHRINE",
        "forms": [
            {
                "orange_id": "208475-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.005MG/ML-1.5%",
                    "0.005MG/ML-0.5%",
                    "0.005MG/ML-2%",
                    "0.01MG/ML-1%",
                    "0.01MG/ML-2%"
                ]
            }
        ]
    },
    {
        "id": 1516,
        "type": "RX",
        "ingredient": "EPINEPHRINE AND LIDOCAINE HYDROCHLORIDE",
        "trade_name": "XYLOCAINE W/ EPINEPHRINE",
        "forms": [
            {
                "orange_id": "6488-12",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.005MG/ML-0.5%",
                    "0.005MG/ML-1%",
                    "0.005MG/ML-1.5%",
                    "0.005MG/ML-2%",
                    "0.01MG/ML-1%",
                    "0.02MG/ML-2%"
                ]
            }
        ]
    },
    {
        "id": 1517,
        "type": "RX",
        "ingredient": "EPIRUBICIN HYDROCHLORIDE",
        "trade_name": "ELLENCE",
        "forms": [
            {
                "orange_id": "50778-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML (2MG/ML)",
                    "50MG/25ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1518,
        "type": "RX",
        "ingredient": "EPIRUBICIN HYDROCHLORIDE",
        "trade_name": "EPIRUBICIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65445-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/25ML (2MG/ML)",
                    "200MG/100ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1519,
        "type": "RX",
        "ingredient": "EPLERENONE",
        "trade_name": "EPLERENONE",
        "forms": [
            {
                "orange_id": "206922-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1520,
        "type": "RX",
        "ingredient": "EPLERENONE",
        "trade_name": "INSPRA",
        "forms": [
            {
                "orange_id": "21437-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 1521,
        "type": "RX",
        "ingredient": "EPOPROSTENOL SODIUM",
        "trade_name": "EPOPROSTENOL SODIUM",
        "forms": [
            {
                "orange_id": "210473-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.5MG BASE/VIAL",
                    "EQ 1.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1522,
        "type": "RX",
        "ingredient": "EPOPROSTENOL SODIUM",
        "trade_name": "FLOLAN",
        "forms": [
            {
                "orange_id": "20444-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.5MG BASE/VIAL",
                    "EQ 1.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1523,
        "type": "RX",
        "ingredient": "EPOPROSTENOL SODIUM",
        "trade_name": "VELETRI",
        "forms": [
            {
                "orange_id": "22260-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.5MG BASE/VIAL",
                    "EQ 1.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1524,
        "type": "RX",
        "ingredient": "EPTIFIBATIDE",
        "trade_name": "EPTIFIBATIDE",
        "forms": [
            {
                "orange_id": "205557-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML",
                    "75MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 1525,
        "type": "RX",
        "ingredient": "ERAVACYCLINE DIHYDROCHLORIDE",
        "trade_name": "XERAVA",
        "forms": [
            {
                "orange_id": "211109-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1526,
        "type": "RX",
        "ingredient": "ERDAFITINIB",
        "trade_name": "BALVERSA",
        "forms": [
            {
                "orange_id": "212018-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG",
                    "4MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1527,
        "type": "RX",
        "ingredient": "ERGOCALCIFEROL",
        "trade_name": "DRISDOL",
        "forms": [
            {
                "orange_id": "3444-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50,000 IU"
                ]
            }
        ]
    },
    {
        "id": 1528,
        "type": "RX",
        "ingredient": "ERGOCALCIFEROL",
        "trade_name": "ERGOCALCIFEROL",
        "forms": [
            {
                "orange_id": "40833-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50,000 IU"
                ]
            }
        ]
    },
    {
        "id": 1529,
        "type": "RX",
        "ingredient": "ERGOCALCIFEROL",
        "trade_name": "VITAMIN D",
        "forms": [
            {
                "orange_id": "80704-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50,000 IU"
                ]
            }
        ]
    },
    {
        "id": 1530,
        "type": "RX",
        "ingredient": "ERGOLOID MESYLATES",
        "trade_name": "ERGOLOID MESYLATES",
        "forms": [
            {
                "orange_id": "81113-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1531,
        "type": "RX",
        "ingredient": "ERGOTAMINE TARTRATE",
        "trade_name": "ERGOMAR",
        "forms": [
            {
                "orange_id": "87693-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 1532,
        "type": "RX",
        "ingredient": "ERIBULIN MESYLATE",
        "trade_name": "HALAVEN",
        "forms": [
            {
                "orange_id": "201532-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1MG/2ML (0.5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1533,
        "type": "RX",
        "ingredient": "ERLOTINIB HYDROCHLORIDE",
        "trade_name": "ERLOTINIB HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "214719-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1534,
        "type": "RX",
        "ingredient": "ERLOTINIB HYDROCHLORIDE",
        "trade_name": "TARCEVA",
        "forms": [
            {
                "orange_id": "21743-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1535,
        "type": "RX",
        "ingredient": "ERTAPENEM SODIUM",
        "trade_name": "ERTAPENEM SODIUM",
        "forms": [
            {
                "orange_id": "208790-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1536,
        "type": "RX",
        "ingredient": "ERTAPENEM SODIUM",
        "trade_name": "INVANZ",
        "forms": [
            {
                "orange_id": "21337-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1537,
        "type": "RX",
        "ingredient": "ERTUGLIFLOZIN",
        "trade_name": "STEGLATRO",
        "forms": [
            {
                "orange_id": "209803-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 1538,
        "type": "RX",
        "ingredient": "ERTUGLIFLOZIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "SEGLUROMET",
        "forms": [
            {
                "orange_id": "209806-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-1GM",
                    "2.5MG-500MG",
                    "7.5MG-1GM",
                    "7.5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 1539,
        "type": "RX",
        "ingredient": "ERTUGLIFLOZIN AND SITAGLIPTIN PHOSPHATE",
        "trade_name": "STEGLUJAN",
        "forms": [
            {
                "orange_id": "209805-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-EQ 100MG BASE",
                    "15MG-EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1540,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN",
        "trade_name": "ERYC",
        "forms": [
            {
                "orange_id": "50536-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 1541,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN",
        "trade_name": "ERYGEL",
        "forms": [
            {
                "orange_id": "50617-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 1542,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN",
        "trade_name": "ERY-TAB",
        "forms": [
            {
                "orange_id": "62298-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "333MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1543,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN",
        "trade_name": "ERYTHRA-DERM",
        "forms": [
            {
                "orange_id": "62687-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 1544,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN",
        "trade_name": "ERYTHROMYCIN",
        "forms": [
            {
                "orange_id": "62746-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "64184-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "64030-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "63038-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "90215-1",
                "form": "SWAB",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "210954-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "333MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "209720-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1545,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN ETHYLSUCCINATE",
        "trade_name": "E. E. S.",
        "forms": [
            {
                "orange_id": "50207-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1546,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN ETHYLSUCCINATE",
        "trade_name": "E. E. S. 400",
        "forms": [
            {
                "orange_id": "61905-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1547,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN ETHYLSUCCINATE",
        "trade_name": "ERYPED",
        "forms": [
            {
                "orange_id": "50207-3",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE/5ML",
                    "EQ 400MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 1548,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN ETHYLSUCCINATE",
        "trade_name": "ERYTHROMYCIN ETHYLSUCCINATE",
        "forms": [
            {
                "orange_id": "211204-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE/5ML",
                    "EQ 400MG BASE/5ML"
                ]
            },
            {
                "orange_id": "61904-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1549,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN LACTOBIONATE",
        "trade_name": "ERYTHROCIN",
        "forms": [
            {
                "orange_id": "62638-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1550,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN LACTOBIONATE",
        "trade_name": "ERYTHROMYCIN LACTOBIONATE",
        "forms": [
            {
                "orange_id": "211086-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1551,
        "type": "RX",
        "ingredient": "ERYTHROMYCIN STEARATE",
        "trade_name": "ERYTHROCIN STEARATE",
        "forms": [
            {
                "orange_id": "60359-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1552,
        "type": "RX",
        "ingredient": "ESCITALOPRAM OXALATE",
        "trade_name": "ESCITALOPRAM OXALATE",
        "forms": [
            {
                "orange_id": "202227-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE/5ML"
                ]
            },
            {
                "orange_id": "202389-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1553,
        "type": "RX",
        "ingredient": "ESCITALOPRAM OXALATE",
        "trade_name": "LEXAPRO",
        "forms": [
            {
                "orange_id": "21323-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1554,
        "type": "RX",
        "ingredient": "ESKETAMINE HYDROCHLORIDE",
        "trade_name": "SPRAVATO",
        "forms": [
            {
                "orange_id": "211243-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "EQ 28MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1555,
        "type": "RX",
        "ingredient": "ESLICARBAZEPINE ACETATE",
        "trade_name": "APTIOM",
        "forms": [
            {
                "orange_id": "22416-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG",
                    "600MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 1556,
        "type": "RX",
        "ingredient": "ESLICARBAZEPINE ACETATE",
        "trade_name": "ESLICARBAZEPINE ACETATE",
        "forms": [
            {
                "orange_id": "211238-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG",
                    "600MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 1557,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "BREVIBLOC",
        "forms": [
            {
                "orange_id": "19386-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1558,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "BREVIBLOC DOUBLE STRENGTH IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19386-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1559,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "BREVIBLOC IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19386-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1560,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "ESMOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205520-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1561,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "ESMOLOL HYDROCHLORIDE DOUBLE STRENGTH IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "205703-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2GM/100ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1562,
        "type": "RX",
        "ingredient": "ESMOLOL HYDROCHLORIDE",
        "trade_name": "ESMOLOL HYDROCHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "205703-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2.5GM/250ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1563,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE MAGNESIUM",
        "trade_name": "ESOMEPRAZOLE MAGNESIUM",
        "forms": [
            {
                "orange_id": "208333-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "209716-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            },
            {
                "orange_id": "211752-1",
                "form": "FOR SUSPENSION, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/PACKET",
                    "EQ 20MG BASE/PACKET",
                    "EQ 40MG BASE/PACKET"
                ]
            },
            {
                "orange_id": "211571-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1564,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE MAGNESIUM",
        "trade_name": "NEXIUM",
        "forms": [
            {
                "orange_id": "21153-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "21957-3",
                "form": "FOR SUSPENSION, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE/PACKET",
                    "EQ 5MG BASE/PACKET",
                    "EQ 10MG BASE/PACKET",
                    "EQ 20MG BASE/PACKET",
                    "EQ 40MG BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1565,
        "type": "OTC",
        "ingredient": "ESOMEPRAZOLE MAGNESIUM",
        "trade_name": "NEXIUM 24HR",
        "forms": [
            {
                "orange_id": "204655-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            },
            {
                "orange_id": "207920-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1566,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE MAGNESIUM AND NAPROXEN",
        "trade_name": "NAPROXEN AND ESOMEPRAZOLE MAGNESIUM",
        "forms": [
            {
                "orange_id": "204206-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE-375MG",
                    "EQ 20MG BASE-500MG"
                ]
            }
        ]
    },
    {
        "id": 1567,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE MAGNESIUM AND NAPROXEN",
        "trade_name": "VIMOVO",
        "forms": [
            {
                "orange_id": "22511-2",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE-375MG",
                    "EQ 20MG BASE-500MG"
                ]
            }
        ]
    },
    {
        "id": 1568,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE SODIUM",
        "trade_name": "ESOMEPRAZOLE SODIUM",
        "forms": [
            {
                "orange_id": "205379-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 40MG BASE/VIAL",
                    "EQ 20MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1569,
        "type": "RX",
        "ingredient": "ESOMEPRAZOLE SODIUM",
        "trade_name": "NEXIUM IV",
        "forms": [
            {
                "orange_id": "21689-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 40MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1570,
        "type": "RX",
        "ingredient": "ESTAZOLAM",
        "trade_name": "ESTAZOLAM",
        "forms": [
            {
                "orange_id": "74921-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 1571,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "CLIMARA",
        "forms": [
            {
                "orange_id": "20375-4",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.025MG/24HR",
                    "0.0375MG/24HR",
                    "0.05MG/24HR",
                    "0.06MG/24HR",
                    "0.075MG/24HR",
                    "0.1MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1572,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "DIVIGEL",
        "forms": [
            {
                "orange_id": "22038-1",
                "form": "GEL",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1573,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "ELESTRIN",
        "forms": [
            {
                "orange_id": "21813-1",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.06% (0.87GM/ACTIVATION)"
                ]
            }
        ]
    },
    {
        "id": 1574,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "ESTRACE",
        "forms": [
            {
                "orange_id": "86069-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1575,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "ESTRADIOL",
        "forms": [
            {
                "orange_id": "209767-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "0.01%"
                ]
            },
            {
                "orange_id": "211396-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.025MG/24HR",
                    "0.0375MG/24HR",
                    "0.05MG/24HR",
                    "0.075MG/24HR",
                    "0.1MG/24HR",
                    "0.06MG/24HR"
                ]
            },
            {
                "orange_id": "211293-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.025MG/24HR",
                    "0.0375MG/24HR",
                    "0.05MG/24HR",
                    "0.075MG/24HR",
                    "0.1MG/24HR"
                ]
            },
            {
                "orange_id": "40197-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            },
            {
                "orange_id": "205256-1",
                "form": "TABLET",
                "route": "VAGINAL",
                "dosage": [
                    "10MCG"
                ]
            }
        ]
    },
    {
        "id": 1576,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "ESTRING",
        "forms": [
            {
                "orange_id": "20472-1",
                "form": "INSERT, EXTENDED RELEASE",
                "route": "VAGINAL",
                "dosage": [
                    "0.0075MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1577,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "ESTROGEL",
        "forms": [
            {
                "orange_id": "21166-2",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.06% (1.25GM/ACTIVATION)"
                ]
            }
        ]
    },
    {
        "id": 1578,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "EVAMIST",
        "forms": [
            {
                "orange_id": "22014-1",
                "form": "SPRAY",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1.53MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1579,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "IMVEXXY",
        "forms": [
            {
                "orange_id": "208564-1",
                "form": "INSERT",
                "route": "VAGINAL",
                "dosage": [
                    "0.004MG",
                    "0.01MG"
                ]
            }
        ]
    },
    {
        "id": 1580,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "MENOSTAR",
        "forms": [
            {
                "orange_id": "21674-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.014MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1581,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "MINIVELLE",
        "forms": [
            {
                "orange_id": "203752-5",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.025MG/24HR",
                    "0.0375MG/24HR",
                    "0.05MG/24HR",
                    "0.075MG/24HR",
                    "0.1MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1582,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "VAGIFEM",
        "forms": [
            {
                "orange_id": "20908-2",
                "form": "TABLET",
                "route": "VAGINAL",
                "dosage": [
                    "10MCG"
                ]
            }
        ]
    },
    {
        "id": 1583,
        "type": "RX",
        "ingredient": "ESTRADIOL",
        "trade_name": "VIVELLE-DOT",
        "forms": [
            {
                "orange_id": "20538-9",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.025MG/24HR",
                    "0.0375MG/24HR",
                    "0.05MG/24HR",
                    "0.075MG/24HR",
                    "0.1MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1584,
        "type": "RX",
        "ingredient": "ESTRADIOL ACETATE",
        "trade_name": "FEMRING",
        "forms": [
            {
                "orange_id": "21367-1",
                "form": "INSERT, EXTENDED RELEASE",
                "route": "VAGINAL",
                "dosage": [
                    "EQ 0.05MG BASE/24HR",
                    "EQ 0.1MG BASE/24HR"
                ]
            }
        ]
    },
    {
        "id": 1585,
        "type": "RX",
        "ingredient": "ESTRADIOL CYPIONATE",
        "trade_name": "DEPO-ESTRADIOL",
        "forms": [
            {
                "orange_id": "85470-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1586,
        "type": "RX",
        "ingredient": "ESTRADIOL VALERATE",
        "trade_name": "DELESTROGEN",
        "forms": [
            {
                "orange_id": "9402-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "20MG/ML",
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1587,
        "type": "RX",
        "ingredient": "ESTRADIOL VALERATE",
        "trade_name": "ESTRADIOL VALERATE",
        "forms": [
            {
                "orange_id": "90920-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML",
                    "40MG/ML",
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1588,
        "type": "RX",
        "ingredient": "ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "CLIMARA PRO",
        "forms": [
            {
                "orange_id": "21258-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.045MG/24HR-0.015MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1589,
        "type": "RX",
        "ingredient": "ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "ACTIVELLA",
        "forms": [
            {
                "orange_id": "20907-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1590,
        "type": "RX",
        "ingredient": "ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AMABELZ",
        "forms": [
            {
                "orange_id": "203339-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-0.1MG",
                    "1MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1591,
        "type": "RX",
        "ingredient": "ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "COMBIPATCH",
        "forms": [
            {
                "orange_id": "20870-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.05MG/24HR-0.14MG/24HR",
                    "0.05MG/24HR-0.25MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1592,
        "type": "RX",
        "ingredient": "ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "ESTRADIOL AND NORETHINDRONE ACETATE",
        "forms": [
            {
                "orange_id": "79193-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG-0.5MG",
                    "0.5MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1593,
        "type": "RX",
        "ingredient": "ESTRADIOL, NORETHINDRONE ACETATE AND RELUGOLIX",
        "trade_name": "MYFEMBREE",
        "forms": [
            {
                "orange_id": "214846-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG-0.5MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 1594,
        "type": "RX",
        "ingredient": "ESTRADIOL AND NORGESTIMATE",
        "trade_name": "ESTRADIOL AND NORGESTIMATE",
        "forms": [
            {
                "orange_id": "76812-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG,1MG-N/A,0.09MG"
                ]
            }
        ]
    },
    {
        "id": 1595,
        "type": "RX",
        "ingredient": "ESTRADIOL AND PROGESTERONE",
        "trade_name": "BIJUVA",
        "forms": [
            {
                "orange_id": "210132-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG-100MG",
                    "1MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 1596,
        "type": "RX",
        "ingredient": "ESTRAMUSTINE PHOSPHATE SODIUM",
        "trade_name": "EMCYT",
        "forms": [
            {
                "orange_id": "18045-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 140MG PHOSPHATE"
                ]
            }
        ]
    },
    {
        "id": 1597,
        "type": "RX",
        "ingredient": "ESTROGENS, CONJUGATED",
        "trade_name": "PREMARIN",
        "forms": [
            {
                "orange_id": "20216-1",
                "form": "CREAM",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "0.625MG/GM"
                ]
            },
            {
                "orange_id": "10402-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/VIAL"
                ]
            },
            {
                "orange_id": "4782-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.3MG",
                    "0.45MG",
                    "0.625MG",
                    "0.9MG",
                    "1.25MG"
                ]
            }
        ]
    },
    {
        "id": 1598,
        "type": "RX",
        "ingredient": "ESTROGENS, CONJUGATED AND MEDROXYPROGESTERONE ACETATE",
        "trade_name": "PREMPHASE 14/14",
        "forms": [
            {
                "orange_id": "20527-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.625MG,0.625MG-N/A,5MG"
                ]
            }
        ]
    },
    {
        "id": 1599,
        "type": "RX",
        "ingredient": "ESTROGENS, CONJUGATED AND MEDROXYPROGESTERONE ACETATE",
        "trade_name": "PREMPRO",
        "forms": [
            {
                "orange_id": "20527-5",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.3MG-1.5MG",
                    "0.45MG-1.5MG",
                    "0.625MG-2.5MG",
                    "0.625MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 1600,
        "type": "RX",
        "ingredient": "ESTROGENS, ESTERIFIED",
        "trade_name": "MENEST",
        "forms": [
            {
                "orange_id": "84951-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.3MG",
                    "0.625MG",
                    "1.25MG",
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 1601,
        "type": "RX",
        "ingredient": "ESTROPIPATE",
        "trade_name": "OGEN 5",
        "forms": [
            {
                "orange_id": "83220-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "6MG"
                ]
            }
        ]
    },
    {
        "id": 1602,
        "type": "RX",
        "ingredient": "ESZOPICLONE",
        "trade_name": "ESZOPICLONE",
        "forms": [
            {
                "orange_id": "208451-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 1603,
        "type": "RX",
        "ingredient": "ESZOPICLONE",
        "trade_name": "LUNESTA",
        "forms": [
            {
                "orange_id": "21476-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 1604,
        "type": "RX",
        "ingredient": "ETELCALCETIDE",
        "trade_name": "PARSABIV",
        "forms": [
            {
                "orange_id": "208325-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2.5MG/0.5ML (2.5MG/0.5ML)",
                    "5MG/ML (5MG/ML)",
                    "10MG/2ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1605,
        "type": "RX",
        "ingredient": "ETEPLIRSEN",
        "trade_name": "EXONDYS 51",
        "forms": [
            {
                "orange_id": "206488-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/2ML (50MG/ML)",
                    "500MG/10ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1606,
        "type": "RX",
        "ingredient": "ETHACRYNATE SODIUM",
        "trade_name": "EDECRIN",
        "forms": [
            {
                "orange_id": "16093-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1607,
        "type": "RX",
        "ingredient": "ETHACRYNATE SODIUM",
        "trade_name": "ETHACRYNATE SODIUM",
        "forms": [
            {
                "orange_id": "204634-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1608,
        "type": "RX",
        "ingredient": "ETHACRYNIC ACID",
        "trade_name": "EDECRIN",
        "forms": [
            {
                "orange_id": "16092-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1609,
        "type": "RX",
        "ingredient": "ETHACRYNIC ACID",
        "trade_name": "ETHACRYNIC ACID",
        "forms": [
            {
                "orange_id": "211809-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1610,
        "type": "RX",
        "ingredient": "ETHAMBUTOL HYDROCHLORIDE",
        "trade_name": "ETHAMBUTOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75095-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 1611,
        "type": "RX",
        "ingredient": "ETHAMBUTOL HYDROCHLORIDE",
        "trade_name": "MYAMBUTOL",
        "forms": [
            {
                "orange_id": "16320-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 1612,
        "type": "RX",
        "ingredient": "ETHANOLAMINE OLEATE",
        "trade_name": "ETHAMOLIN",
        "forms": [
            {
                "orange_id": "19357-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1613,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETHYNODIOL DIACETATE",
        "trade_name": "ETHYNODIOL DIACETATE AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "204703-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG",
                    "0.05MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1614,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETHYNODIOL DIACETATE",
        "trade_name": "KELNOR",
        "forms": [
            {
                "orange_id": "76785-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1615,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETHYNODIOL DIACETATE",
        "trade_name": "LO-MALMOREDE",
        "forms": [
            {
                "orange_id": "209548-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1616,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETHYNODIOL DIACETATE",
        "trade_name": "MALMOREDE",
        "forms": [
            {
                "orange_id": "209547-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.05MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1617,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETHYNODIOL DIACETATE",
        "trade_name": "ZOVIA 1/50E-28",
        "forms": [
            {
                "orange_id": "72723-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.05MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1618,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETONOGESTREL",
        "trade_name": "ELURYNG",
        "forms": [
            {
                "orange_id": "210830-1",
                "form": "RING",
                "route": "VAGINAL",
                "dosage": [
                    "0.015MG/24HR-0.12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1619,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETONOGESTREL",
        "trade_name": "ETHINYL ESTRADIOL; ETONOGESTREL",
        "forms": [
            {
                "orange_id": "204305-1",
                "form": "RING",
                "route": "VAGINAL",
                "dosage": [
                    "0.015MG/24HR-0.12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1620,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETONOGESTREL",
        "trade_name": "NUVARING",
        "forms": [
            {
                "orange_id": "21187-1",
                "form": "RING",
                "route": "VAGINAL",
                "dosage": [
                    "0.015MG/24HR-0.12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1621,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND ETONOGESTREL",
        "trade_name": "VERARING",
        "forms": [
            {
                "orange_id": "207577-1",
                "form": "RING",
                "route": "VAGINAL",
                "dosage": [
                    "0.015MG/24HR-0.12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1622,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "AFIRMELLE",
        "forms": [
            {
                "orange_id": "206886-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1623,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "ALTAVERA",
        "forms": [
            {
                "orange_id": "79102-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1624,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "ASHLYNA",
        "forms": [
            {
                "orange_id": "203163-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG,0.01MG-0.15MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1625,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "AVIANE-28",
        "forms": [
            {
                "orange_id": "75796-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1626,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "AYUNA",
        "forms": [
            {
                "orange_id": "206866-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1627,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "BALCOLTRA",
        "forms": [
            {
                "orange_id": "208612-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1628,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "DAYSEE",
        "forms": [
            {
                "orange_id": "91467-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG,0.01MG-0.15MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1629,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "DOLISHALE",
        "forms": [
            {
                "orange_id": "91692-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-0.09MG"
                ]
            }
        ]
    },
    {
        "id": 1630,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "ENPRESSE-28",
        "forms": [
            {
                "orange_id": "75809-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG,0.04MG,0.03MG-0.05MG,0.075MG,0.125MG"
                ]
            }
        ]
    },
    {
        "id": 1631,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "FALMINA",
        "forms": [
            {
                "orange_id": "90721-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1632,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "ICLEVIA",
        "forms": [
            {
                "orange_id": "206850-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1633,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "INTROVALE",
        "forms": [
            {
                "orange_id": "79064-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1634,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "JAIMIESS",
        "forms": [
            {
                "orange_id": "203770-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG,0.01MG-0.15MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1635,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "KURVELO",
        "forms": [
            {
                "orange_id": "91408-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1636,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LESSINA-28",
        "forms": [
            {
                "orange_id": "75803-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1637,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LEVONEST",
        "forms": [
            {
                "orange_id": "90719-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG,0.04MG,0.03MG-0.05MG,0.075MG,0.125MG"
                ]
            }
        ]
    },
    {
        "id": 1638,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LEVONORGESTREL AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "203871-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG",
                    "0.03MG,0.01MG-0.15MG,N/A",
                    "0.02MG-0.09MG"
                ]
            },
            {
                "orange_id": "201108-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG",
                    "0.03MG-0.15MG",
                    "0.03MG,0.04MG,0.03MG-0.05MG,0.075MG,0.125MG"
                ]
            }
        ]
    },
    {
        "id": 1639,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LEVONORGESTREL AND ETHINYL ESTRADIOL AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "91674-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG,0.1MG-0.01MG,N/A",
                    "0.03MG,0.01MG-0.15MG,N/A",
                    "0.02MG,0.15MG- 0.025MG,0.15MG-0.03MG,0.15MG- 0.01MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1640,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LEVORA 0. 15/30-28",
        "forms": [
            {
                "orange_id": "73594-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1641,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LO SIMPESSE",
        "forms": [
            {
                "orange_id": "206852-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG,0.1MG-0.01MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1642,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "LOSEASONIQUE",
        "forms": [
            {
                "orange_id": "22262-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG,0.1MG-0.01MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1643,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "MARLISSA",
        "forms": [
            {
                "orange_id": "91452-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1644,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "MYZILRA",
        "forms": [
            {
                "orange_id": "77502-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG,0.04MG,0.03MG-0.05MG,0.075MG,0.125MG"
                ]
            }
        ]
    },
    {
        "id": 1645,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "PORTIA-28",
        "forms": [
            {
                "orange_id": "75866-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1646,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "QUARTETTE",
        "forms": [
            {
                "orange_id": "204061-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG,0.15MG-0.025MG,0.15MG-0.03MG,0.15MG-0.01MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1647,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "QUASENSE",
        "forms": [
            {
                "orange_id": "77101-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1648,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "SEASONALE",
        "forms": [
            {
                "orange_id": "21544-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1649,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "SEASONIQUE",
        "forms": [
            {
                "orange_id": "21840-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG,0.01MG-0.15MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1650,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "SETLAKIN",
        "forms": [
            {
                "orange_id": "90716-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG-0.15MG"
                ]
            }
        ]
    },
    {
        "id": 1651,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "SIMPESSE",
        "forms": [
            {
                "orange_id": "206851-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.03MG,0.01MG-0.15MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1652,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "TRIVORA-28",
        "forms": [
            {
                "orange_id": "74538-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG,0.04MG,0.03MG-0.05MG,0.075MG,0.125MG"
                ]
            }
        ]
    },
    {
        "id": 1653,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "TWIRLA",
        "forms": [
            {
                "orange_id": "204017-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.03MG/24HR-0.12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1654,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "TYBLUME",
        "forms": [
            {
                "orange_id": "209405-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1655,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND LEVONORGESTREL",
        "trade_name": "VIENVA",
        "forms": [
            {
                "orange_id": "201088-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1656,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORELGESTROMIN",
        "trade_name": "ETHINYL ESTRADIOL AND NORELGESTROMIN",
        "forms": [
            {
                "orange_id": "213950-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.035MG/24HR-0.15MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1657,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORELGESTROMIN",
        "trade_name": "ONSURA",
        "forms": [
            {
                "orange_id": "213977-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.035MG/24HR-0.15MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1658,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORELGESTROMIN",
        "trade_name": "XULANE",
        "forms": [
            {
                "orange_id": "200910-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.035MG/24HR-0.15MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1659,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "ALYACEN 1/35",
        "forms": [
            {
                "orange_id": "91634-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1660,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "ALYACEN 7/7/7",
        "forms": [
            {
                "orange_id": "91636-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1661,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "ARANELLE",
        "forms": [
            {
                "orange_id": "76783-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,1MG,0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1662,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "BALZIVA-28",
        "forms": [
            {
                "orange_id": "76238-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1663,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "BRIELLYN",
        "forms": [
            {
                "orange_id": "90538-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1664,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "CYONANZ",
        "forms": [
            {
                "orange_id": "207055-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1665,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "DASETTA 1/35",
        "forms": [
            {
                "orange_id": "90948-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1666,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "DASETTA 7/7/7",
        "forms": [
            {
                "orange_id": "90946-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1667,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "GILDAGIA",
        "forms": [
            {
                "orange_id": "78376-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1668,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "KAITLIB FE",
        "forms": [
            {
                "orange_id": "203448-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.025MG-0.8MG"
                ]
            }
        ]
    },
    {
        "id": 1669,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NEXESTA FE",
        "forms": [
            {
                "orange_id": "207535-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1670,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORETHINDRONE AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "206864-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG",
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1671,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORETHINDRONE AND ETHINYL ESTRADIOL (10/11)",
        "forms": [
            {
                "orange_id": "71044-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG-0.5MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1672,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORETHINDRONE AND ETHINYL ESTRADIOL AND FERROUS FUMARATE",
        "forms": [
            {
                "orange_id": "78892-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.035MG-0.4MG",
                    "0.025MG-0.8MG"
                ]
            }
        ]
    },
    {
        "id": 1673,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORTREL 0. 5/35-28",
        "forms": [
            {
                "orange_id": "72695-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1674,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORTREL 1/35-21",
        "forms": [
            {
                "orange_id": "72693-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1675,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORTREL 1/35-28",
        "forms": [
            {
                "orange_id": "72696-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1676,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NORTREL 7/7/7",
        "forms": [
            {
                "orange_id": "75478-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            },
            {
                "orange_id": "75478-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1677,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NYLIA 1/35",
        "forms": [
            {
                "orange_id": "207056-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1678,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "NYLIA 7/7/7",
        "forms": [
            {
                "orange_id": "207054-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1679,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "PHILITH",
        "forms": [
            {
                "orange_id": "90947-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1680,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "PIRMELLA 1/35",
        "forms": [
            {
                "orange_id": "201512-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1681,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "PIRMELLA 7/7/7",
        "forms": [
            {
                "orange_id": "201510-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,0.75MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1682,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "TRI-NORINYL 28-DAY",
        "forms": [
            {
                "orange_id": "18977-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.5MG,1MG,0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1683,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "VYFEMLA",
        "forms": [
            {
                "orange_id": "201886-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.4MG"
                ]
            }
        ]
    },
    {
        "id": 1684,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE",
        "trade_name": "WERA",
        "forms": [
            {
                "orange_id": "91204-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1685,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AUROVELA 1. 5/30",
        "forms": [
            {
                "orange_id": "207581-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1686,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AUROVELA 1/20",
        "forms": [
            {
                "orange_id": "207506-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1687,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AUROVELA 24 FE",
        "forms": [
            {
                "orange_id": "207504-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1688,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AUROVELA FE 1. 5/30",
        "forms": [
            {
                "orange_id": "207580-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1689,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "AUROVELA FE 1/20",
        "forms": [
            {
                "orange_id": "207505-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1690,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "BLISOVI 24 FE",
        "forms": [
            {
                "orange_id": "91398-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1691,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "BLISOVI FE 1. 5/30",
        "forms": [
            {
                "orange_id": "201585-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1692,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "BLISOVI FE 1/20",
        "forms": [
            {
                "orange_id": "201584-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1693,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "CHABELINA FE",
        "forms": [
            {
                "orange_id": "202962-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG,0.03MG,0.035MG-1MG,1MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1694,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "FINZALA",
        "forms": [
            {
                "orange_id": "210087-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1695,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "FYAVOLV",
        "forms": [
            {
                "orange_id": "204213-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.005MG-1MG",
                    "0.0025MG-0.5MG"
                ]
            }
        ]
    },
    {
        "id": 1696,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "GEMMILY",
        "forms": [
            {
                "orange_id": "213317-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1697,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "GILDESS 24 FE",
        "forms": [
            {
                "orange_id": "90293-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1698,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "HAILEY 1. 5/30",
        "forms": [
            {
                "orange_id": "209297-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1699,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "HAILEY FE 1. 5/30",
        "forms": [
            {
                "orange_id": "209031-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1700,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "HAILEY FE 1/20",
        "forms": [
            {
                "orange_id": "206597-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1701,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "JUNEL 1. 5/30",
        "forms": [
            {
                "orange_id": "76381-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1702,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "JUNEL 1/20",
        "forms": [
            {
                "orange_id": "76380-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1703,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "JUNEL FE 1. 5/30",
        "forms": [
            {
                "orange_id": "76064-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1704,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "JUNEL FE 1/20",
        "forms": [
            {
                "orange_id": "76081-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1705,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LARIN 1. 5/30",
        "forms": [
            {
                "orange_id": "202996-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1706,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LARIN 1/20",
        "forms": [
            {
                "orange_id": "202995-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1707,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LARIN 24 FE",
        "forms": [
            {
                "orange_id": "202994-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1708,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LARIN FE 1. 5/30",
        "forms": [
            {
                "orange_id": "91453-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1709,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LARIN FE 1/20",
        "forms": [
            {
                "orange_id": "91454-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1710,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LERIBANE",
        "forms": [
            {
                "orange_id": "203435-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.0025MG-0.5MG",
                    "0.005MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1711,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LO LOESTRIN FE",
        "forms": [
            {
                "orange_id": "22501-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.01MG,0.01MG-1MG,N/A"
                ]
            }
        ]
    },
    {
        "id": 1712,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LOESTRIN 21 1. 5/30",
        "forms": [
            {
                "orange_id": "17875-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1713,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LOESTRIN 21 1/20",
        "forms": [
            {
                "orange_id": "17876-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1714,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LOESTRIN FE 1. 5/30",
        "forms": [
            {
                "orange_id": "17355-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1715,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "LOESTRIN FE 1/20",
        "forms": [
            {
                "orange_id": "17354-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1716,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "MERZEE",
        "forms": [
            {
                "orange_id": "212706-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1717,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "MIBELAS 24 FE",
        "forms": [
            {
                "orange_id": "206287-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1718,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "MINASTRIN 24 FE",
        "forms": [
            {
                "orange_id": "203667-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1719,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "NORETHINDRONE ACETATE AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "76221-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.005MG-1MG",
                    "0.0025MG-0.5MG"
                ]
            },
            {
                "orange_id": "206969-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG-1MG",
                    "0.03MG-1.5MG"
                ]
            },
            {
                "orange_id": "202772-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG-1MG",
                    "0.03MG-1.5MG"
                ]
            }
        ]
    },
    {
        "id": 1720,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "NORETHINDRONE ACETATE AND ETHINYL ESTRADIOL AND FERROUS FUMARATE",
        "forms": [
            {
                "orange_id": "214292-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            },
            {
                "orange_id": "210369-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            },
            {
                "orange_id": "78267-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1721,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "TAYTULLA",
        "forms": [
            {
                "orange_id": "204426-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.02MG-1MG"
                ]
            }
        ]
    },
    {
        "id": 1722,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "TRI-LEGEST 21",
        "forms": [
            {
                "orange_id": "76405-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.02MG,0.03MG,0.035MG-1MG,1MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1723,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORETHINDRONE ACETATE",
        "trade_name": "TRI-LEGEST FE",
        "forms": [
            {
                "orange_id": "76105-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.02MG,0.03MG,0.035MG-1MG,1MG,1MG"
                ]
            }
        ]
    },
    {
        "id": 1724,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "ESTARYLLA",
        "forms": [
            {
                "orange_id": "90794-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1725,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "MILI",
        "forms": [
            {
                "orange_id": "205449-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1726,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "MONO-LINYAH",
        "forms": [
            {
                "orange_id": "90523-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1727,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "NORGESTIMATE AND ETHINYL ESTRADIOL",
        "forms": [
            {
                "orange_id": "203870-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.18MG,0.215MG,0.25MG",
                    "0.035MG-0.25MG",
                    "0.025MG,0.025MG,0.025MG-0.18MG,0.215MG,0.25MG",
                    "0.035MG-0.035MG-0.035MG-0.18MG-0.215MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1728,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "PREVIFEM",
        "forms": [
            {
                "orange_id": "76334-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1729,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "SPRINTEC",
        "forms": [
            {
                "orange_id": "75804-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG-0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1730,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI LO SPRINTEC",
        "forms": [
            {
                "orange_id": "76784-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.025MG,0.025MG,0.025MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1731,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-ESTARYLLA",
        "forms": [
            {
                "orange_id": "90793-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1732,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-LINYAH",
        "forms": [
            {
                "orange_id": "90524-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1733,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-LO-ESTARYLLA",
        "forms": [
            {
                "orange_id": "91232-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.025MG,0.025MG,0.025MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1734,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-LO-MILI",
        "forms": [
            {
                "orange_id": "205762-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.025MG,0.025MG,0.025MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1735,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-MILI",
        "forms": [
            {
                "orange_id": "205441-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1736,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTIMATE",
        "trade_name": "TRI-SPRINTEC",
        "forms": [
            {
                "orange_id": "75808-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.035MG,0.035MG,0.035MG-0.18MG,0.215MG,0.25MG"
                ]
            }
        ]
    },
    {
        "id": 1737,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTREL",
        "trade_name": "CRYSELLE",
        "forms": [
            {
                "orange_id": "75840-1",
                "form": "TABLET",
                "route": "ORAL-21",
                "dosage": [
                    "0.03MG-0.3MG"
                ]
            },
            {
                "orange_id": "75840-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.3MG"
                ]
            }
        ]
    },
    {
        "id": 1738,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTREL",
        "trade_name": "ELINEST",
        "forms": [
            {
                "orange_id": "91105-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.3MG"
                ]
            }
        ]
    },
    {
        "id": 1739,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND NORGESTREL",
        "trade_name": "LOW-OGESTREL-28",
        "forms": [
            {
                "orange_id": "75288-2",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.03MG-0.3MG"
                ]
            }
        ]
    },
    {
        "id": 1740,
        "type": "RX",
        "ingredient": "ETHINYL ESTRADIOL AND SEGESTERONE ACETATE",
        "trade_name": "ANNOVERA",
        "forms": [
            {
                "orange_id": "209627-1",
                "form": "RING",
                "route": "VAGINAL",
                "dosage": [
                    "0.013MG/24HR-0.15MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 1741,
        "type": "RX",
        "ingredient": "ETHIODIZED OIL",
        "trade_name": "LIPIODOL",
        "forms": [
            {
                "orange_id": "9190-1",
                "form": "OIL",
                "route": "INTRALYMPHATIC, INTRAUTERINE",
                "dosage": [
                    "EQ 4.8GM IODINE/10ML (EQ 480MG IODINE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1742,
        "type": "RX",
        "ingredient": "ETHIONAMIDE",
        "trade_name": "TRECATOR",
        "forms": [
            {
                "orange_id": "13026-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 1743,
        "type": "RX",
        "ingredient": "ETHOSUXIMIDE",
        "trade_name": "ETHOSUXIMIDE",
        "forms": [
            {
                "orange_id": "40686-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "40506-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1744,
        "type": "RX",
        "ingredient": "ETHOSUXIMIDE",
        "trade_name": "ZARONTIN",
        "forms": [
            {
                "orange_id": "12380-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "80258-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1745,
        "type": "RX",
        "ingredient": "ETODOLAC",
        "trade_name": "ETODOLAC",
        "forms": [
            {
                "orange_id": "75126-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "212263-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "500MG",
                    "600MG"
                ]
            },
            {
                "orange_id": "208834-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1746,
        "type": "RX",
        "ingredient": "ETOMIDATE",
        "trade_name": "AMIDATE",
        "forms": [
            {
                "orange_id": "18227-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1747,
        "type": "RX",
        "ingredient": "ETOMIDATE",
        "trade_name": "ETOMIDATE",
        "forms": [
            {
                "orange_id": "215028-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML ",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1748,
        "type": "RX",
        "ingredient": "ETONOGESTREL",
        "trade_name": "NEXPLANON",
        "forms": [
            {
                "orange_id": "21529-2",
                "form": "IMPLANT",
                "route": "IMPLANTATION",
                "dosage": [
                    "68MG/IMPLANT"
                ]
            }
        ]
    },
    {
        "id": 1749,
        "type": "RX",
        "ingredient": "ETOPOSIDE",
        "trade_name": "ETOPOSIDE",
        "forms": [
            {
                "orange_id": "75635-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            },
            {
                "orange_id": "74513-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1750,
        "type": "RX",
        "ingredient": "ETOPOSIDE PHOSPHATE",
        "trade_name": "ETOPOPHOS PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "20457-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1751,
        "type": "RX",
        "ingredient": "ETRAVIRINE",
        "trade_name": "ETRAVIRINE",
        "forms": [
            {
                "orange_id": "214196-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1752,
        "type": "RX",
        "ingredient": "ETRAVIRINE",
        "trade_name": "INTELENCE",
        "forms": [
            {
                "orange_id": "22187-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1753,
        "type": "RX",
        "ingredient": "EVEROLIMUS",
        "trade_name": "AFINITOR",
        "forms": [
            {
                "orange_id": "22334-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "7.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1754,
        "type": "RX",
        "ingredient": "EVEROLIMUS",
        "trade_name": "AFINITOR DISPERZ",
        "forms": [
            {
                "orange_id": "203985-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "3MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1755,
        "type": "RX",
        "ingredient": "EVEROLIMUS",
        "trade_name": "EVEROLIMUS",
        "forms": [
            {
                "orange_id": "210130-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "3MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "214138-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "0.75MG",
                    "1MG",
                    "2.5MG",
                    "5MG",
                    "7.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1756,
        "type": "RX",
        "ingredient": "EVEROLIMUS",
        "trade_name": "ZORTRESS",
        "forms": [
            {
                "orange_id": "21560-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "0.75MG",
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1757,
        "type": "RX",
        "ingredient": "EXEMESTANE",
        "trade_name": "AROMASIN",
        "forms": [
            {
                "orange_id": "20753-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1758,
        "type": "RX",
        "ingredient": "EXEMESTANE",
        "trade_name": "EXEMESTANE",
        "forms": [
            {
                "orange_id": "200898-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 1759,
        "type": "RX",
        "ingredient": "EXENATIDE SYNTHETIC",
        "trade_name": "BYDUREON BCISE",
        "forms": [
            {
                "orange_id": "209210-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "2MG/0.85ML (2MG/0.85ML)"
                ]
            }
        ]
    },
    {
        "id": 1760,
        "type": "RX",
        "ingredient": "EXENATIDE SYNTHETIC",
        "trade_name": "BYETTA",
        "forms": [
            {
                "orange_id": "21773-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "300MCG/1.2ML (250MCG/ML)",
                    "600MCG/2.4ML (250MCG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1761,
        "type": "RX",
        "ingredient": "EZETIMIBE",
        "trade_name": "EZETIMIBE",
        "forms": [
            {
                "orange_id": "211550-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1762,
        "type": "RX",
        "ingredient": "EZETIMIBE",
        "trade_name": "ZETIA",
        "forms": [
            {
                "orange_id": "21445-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1763,
        "type": "RX",
        "ingredient": "EZETIMIBE AND ROSUVASTATIN CALCIUM",
        "trade_name": "ROSZET",
        "forms": [
            {
                "orange_id": "213072-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-EQ 5MG BASE",
                    "10MG-EQ 10MG BASE",
                    "10MG-EQ 20MG BASE",
                    "10MG-EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1764,
        "type": "RX",
        "ingredient": "EZETIMIBE AND SIMVASTATIN",
        "trade_name": "EZETIMIBE AND SIMVASTATIN",
        "forms": [
            {
                "orange_id": "209222-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-10MG",
                    "10MG-20MG",
                    "10MG-40MG",
                    "10MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 1765,
        "type": "RX",
        "ingredient": "EZETIMIBE AND SIMVASTATIN",
        "trade_name": "VYTORIN",
        "forms": [
            {
                "orange_id": "21687-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-10MG",
                    "10MG-20MG",
                    "10MG-40MG",
                    "10MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 1766,
        "type": "RX",
        "ingredient": "FAMCICLOVIR",
        "trade_name": "FAMCICLOVIR",
        "forms": [
            {
                "orange_id": "91480-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1767,
        "type": "RX",
        "ingredient": "FAMOTIDINE",
        "trade_name": "FAMOTIDINE",
        "forms": [
            {
                "orange_id": "201995-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/5ML"
                ]
            },
            {
                "orange_id": "75651-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "75715-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "78916-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1768,
        "type": "RX",
        "ingredient": "FAMOTIDINE",
        "trade_name": "FAMOTIDINE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "75622-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1769,
        "type": "RX",
        "ingredient": "FAMOTIDINE",
        "trade_name": "FAMOTIDINE PRESERVATIVE FREE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "75591-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.4MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1770,
        "type": "OTC",
        "ingredient": "FAMOTIDINE",
        "trade_name": "PEPCID AC",
        "forms": [
            {
                "orange_id": "20801-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            },
            {
                "orange_id": "20325-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1771,
        "type": "RX",
        "ingredient": "FAMOTIDINE AND IBUPROFEN",
        "trade_name": "DUEXIS",
        "forms": [
            {
                "orange_id": "22519-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "26.6MG-800MG"
                ]
            }
        ]
    },
    {
        "id": 1772,
        "type": "RX",
        "ingredient": "FAMOTIDINE AND IBUPROFEN",
        "trade_name": "IBUPROFEN AND FAMOTIDINE",
        "forms": [
            {
                "orange_id": "211890-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "26.6MG-800MG"
                ]
            }
        ]
    },
    {
        "id": 1773,
        "type": "RX",
        "ingredient": "FEBUXOSTAT",
        "trade_name": "FEBUXOSTAT",
        "forms": [
            {
                "orange_id": "205421-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 1774,
        "type": "RX",
        "ingredient": "FEBUXOSTAT",
        "trade_name": "ULORIC",
        "forms": [
            {
                "orange_id": "21856-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 1775,
        "type": "RX",
        "ingredient": "FEDRATINIB HYDROCHLORIDE",
        "trade_name": "INREBIC",
        "forms": [
            {
                "orange_id": "212327-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1776,
        "type": "RX",
        "ingredient": "FELBAMATE",
        "trade_name": "FELBAMATE",
        "forms": [
            {
                "orange_id": "202385-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "600MG/5ML"
                ]
            },
            {
                "orange_id": "204595-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1777,
        "type": "RX",
        "ingredient": "FELBAMATE",
        "trade_name": "FELBATOL",
        "forms": [
            {
                "orange_id": "20189-3",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "600MG/5ML"
                ]
            },
            {
                "orange_id": "20189-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1778,
        "type": "RX",
        "ingredient": "FELODIPINE",
        "trade_name": "FELODIPINE",
        "forms": [
            {
                "orange_id": "203417-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1779,
        "type": "RX",
        "ingredient": "FENFLURAMINE HYDROCHLORIDE",
        "trade_name": "FINTEPLA",
        "forms": [
            {
                "orange_id": "212102-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.2MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1780,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "ANTARA (MICRONIZED)",
        "forms": [
            {
                "orange_id": "21695-4",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "43MG",
                    "90MG",
                    "130MG"
                ]
            }
        ]
    },
    {
        "id": 1781,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "FENOFIBRATE",
        "forms": [
            {
                "orange_id": "201748-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "43MG",
                    "130MG"
                ]
            },
            {
                "orange_id": "210606-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "54MG",
                    "160MG",
                    "48MG",
                    "145MG",
                    "40MG",
                    "120MG",
                    "107MG"
                ]
            }
        ]
    },
    {
        "id": 1782,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "FENOFIBRATE (MICRONIZED)",
        "forms": [
            {
                "orange_id": "210705-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "67MG",
                    "134MG",
                    "200MG",
                    "43MG",
                    "130MG"
                ]
            }
        ]
    },
    {
        "id": 1783,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "FENOGLIDE",
        "forms": [
            {
                "orange_id": "22118-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 1784,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "LIPOFEN",
        "forms": [
            {
                "orange_id": "21612-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 1785,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "TRICOR",
        "forms": [
            {
                "orange_id": "21656-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "48MG",
                    "145MG"
                ]
            }
        ]
    },
    {
        "id": 1786,
        "type": "RX",
        "ingredient": "FENOFIBRATE",
        "trade_name": "TRIGLIDE",
        "forms": [
            {
                "orange_id": "21350-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "160MG"
                ]
            }
        ]
    },
    {
        "id": 1787,
        "type": "RX",
        "ingredient": "FENOFIBRIC ACID",
        "trade_name": "FIBRICOR",
        "forms": [
            {
                "orange_id": "22418-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "105MG"
                ]
            }
        ]
    },
    {
        "id": 1788,
        "type": "RX",
        "ingredient": "FENOLDOPAM MESYLATE",
        "trade_name": "CORLOPAM",
        "forms": [
            {
                "orange_id": "19922-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1789,
        "type": "RX",
        "ingredient": "FENOLDOPAM MESYLATE",
        "trade_name": "FENOLDOPAM MESYLATE",
        "forms": [
            {
                "orange_id": "76582-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1790,
        "type": "RX",
        "ingredient": "FENOPROFEN CALCIUM",
        "trade_name": "FENOPROFEN CALCIUM",
        "forms": [
            {
                "orange_id": "72267-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1791,
        "type": "RX",
        "ingredient": "FENOPROFEN CALCIUM",
        "trade_name": "NALFON",
        "forms": [
            {
                "orange_id": "17604-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1792,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-100",
        "forms": [
            {
                "orange_id": "77449-4",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "100MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1793,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-12",
        "forms": [
            {
                "orange_id": "77449-5",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "12.5MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1794,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-25",
        "forms": [
            {
                "orange_id": "77449-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "25MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1795,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-37",
        "forms": [
            {
                "orange_id": "77449-6",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "37.5MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1796,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-50",
        "forms": [
            {
                "orange_id": "77449-2",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "50MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1797,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-62",
        "forms": [
            {
                "orange_id": "77449-7",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "62.5MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1798,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-75",
        "forms": [
            {
                "orange_id": "77449-3",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "75MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1799,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "FENTANYL-87",
        "forms": [
            {
                "orange_id": "77449-8",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "87.5MCG/HR"
                ]
            }
        ]
    },
    {
        "id": 1800,
        "type": "RX",
        "ingredient": "FENTANYL",
        "trade_name": "SUBSYS",
        "forms": [
            {
                "orange_id": "202788-1",
                "form": "SPRAY",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG",
                    "0.4MG",
                    "0.6MG",
                    "0.8MG",
                    "1.2MG",
                    "1.6MG"
                ]
            }
        ]
    },
    {
        "id": 1801,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "ACTIQ",
        "forms": [
            {
                "orange_id": "20747-1",
                "form": "TROCHE/LOZENGE",
                "route": "TRANSMUCOSAL",
                "dosage": [
                    "EQ 0.2MG BASE",
                    "EQ 0.4MG BASE",
                    "EQ 0.6MG BASE",
                    "EQ 0.8MG BASE",
                    "EQ 1.2MG BASE",
                    "EQ 1.6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1802,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "FENTANYL CITRATE",
        "forms": [
            {
                "orange_id": "212086-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML"
                ]
            },
            {
                "orange_id": "78907-1",
                "form": "TROCHE/LOZENGE",
                "route": "TRANSMUCOSAL",
                "dosage": [
                    "EQ 0.2MG BASE",
                    "EQ 0.4MG BASE",
                    "EQ 0.6MG BASE",
                    "EQ 0.8MG BASE",
                    "EQ 1.2MG BASE",
                    "EQ 1.6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1803,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "FENTANYL CITRATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "210762-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1804,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "FENTORA",
        "forms": [
            {
                "orange_id": "21947-1",
                "form": "TABLET",
                "route": "BUCCAL, SUBLINGUAL",
                "dosage": [
                    "EQ 0.1MG BASE",
                    "EQ 0.2MG BASE",
                    "EQ 0.4MG BASE",
                    "EQ 0.6MG BASE",
                    "EQ 0.8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1805,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "LAZANDA",
        "forms": [
            {
                "orange_id": "22569-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "EQ 0.1MG BASE",
                    "EQ 0.4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1806,
        "type": "RX",
        "ingredient": "FENTANYL CITRATE",
        "trade_name": "SUBLIMAZE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "16619-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 1807,
        "type": "RX",
        "ingredient": "FERRIC CARBOXYMALTOSE",
        "trade_name": "INJECTAFER",
        "forms": [
            {
                "orange_id": "203565-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM IRON/20ML (50MG IRON/ML)",
                    "750MG IRON/15ML (50MG IRON/ML)",
                    "500MG IRON/10ML (50MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1808,
        "type": "RX",
        "ingredient": "FERRIC CITRATE",
        "trade_name": "AURYXIA",
        "forms": [
            {
                "orange_id": "205874-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 210MG IRON"
                ]
            }
        ]
    },
    {
        "id": 1809,
        "type": "RX",
        "ingredient": "FERRIC DERISOMALTOSE",
        "trade_name": "MONOFERRIC",
        "forms": [
            {
                "orange_id": "208171-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/10ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1810,
        "type": "RX",
        "ingredient": "FERRIC HEXACYANOFERRATE(II)",
        "trade_name": "RADIOGARDASE (PRUSSIAN BLUE)",
        "forms": [
            {
                "orange_id": "21626-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1811,
        "type": "RX",
        "ingredient": "FERRIC MALTOL",
        "trade_name": "ACCRUFER",
        "forms": [
            {
                "orange_id": "212320-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG IRON"
                ]
            }
        ]
    },
    {
        "id": 1812,
        "type": "RX",
        "ingredient": "FERRIC OXYHYDROXIDE",
        "trade_name": "FERRLECIT",
        "forms": [
            {
                "orange_id": "20955-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 62.5MG IRON/5ML (EQ 12.5MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1813,
        "type": "RX",
        "ingredient": "FERRIC OXYHYDROXIDE",
        "trade_name": "INFED",
        "forms": [
            {
                "orange_id": "17441-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG IRON/2ML (EQ 50MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1814,
        "type": "RX",
        "ingredient": "FERRIC OXYHYDROXIDE",
        "trade_name": "SODIUM FERRIC GLUCONATE COMPLEX IN SUCROSE",
        "forms": [
            {
                "orange_id": "78215-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 62.5MG IRON/5ML (EQ 12.5MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1815,
        "type": "RX",
        "ingredient": "FERRIC OXYHYDROXIDE",
        "trade_name": "VELPHORO",
        "forms": [
            {
                "orange_id": "205109-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 500MG IRON"
                ]
            }
        ]
    },
    {
        "id": 1816,
        "type": "RX",
        "ingredient": "FERRIC OXYHYDROXIDE",
        "trade_name": "VENOFER",
        "forms": [
            {
                "orange_id": "21135-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG IRON/2.5ML (EQ 20MG IRON/ML)",
                    "EQ 100MG IRON/5ML (EQ 20MG IRON/ML)",
                    "EQ 200MG IRON/10ML (EQ 20MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1817,
        "type": "RX",
        "ingredient": "FERRIC PYROPHOSPHATE CITRATE",
        "trade_name": "TRIFERIC",
        "forms": [
            {
                "orange_id": "208551-1",
                "form": "FOR SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "272MG IRON/PACKET"
                ]
            },
            {
                "orange_id": "206317-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "27.2MG IRON/5ML (5.44MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1818,
        "type": "RX",
        "ingredient": "FERRIC PYROPHOSPHATE CITRATE",
        "trade_name": "TRIFERIC AVNU",
        "forms": [
            {
                "orange_id": "212860-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6.75MG IRON/4.5ML (1.5MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1819,
        "type": "RX",
        "ingredient": "FERUMOXYTOL",
        "trade_name": "FERAHEME",
        "forms": [
            {
                "orange_id": "22180-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 510MG IRON/17ML (EQ 30MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1820,
        "type": "RX",
        "ingredient": "FERUMOXYTOL",
        "trade_name": "FERUMOXYTOL",
        "forms": [
            {
                "orange_id": "206604-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 510MG IRON/17ML (EQ 30MG IRON/ML)"
                ]
            }
        ]
    },
    {
        "id": 1821,
        "type": "RX",
        "ingredient": "FESOTERODINE FUMARATE",
        "trade_name": "FESOTERODINE FUMARATE",
        "forms": [
            {
                "orange_id": "205007-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 1822,
        "type": "RX",
        "ingredient": "FESOTERODINE FUMARATE",
        "trade_name": "TOVIAZ",
        "forms": [
            {
                "orange_id": "22030-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 1823,
        "type": "RX",
        "ingredient": "FEXINIDAZOLE",
        "trade_name": "FEXINIDAZOLE",
        "forms": [
            {
                "orange_id": "214429-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1824,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "ALLEGRA ALLERGY",
        "forms": [
            {
                "orange_id": "20872-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 1825,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ALLEGRA ALLERGY",
        "forms": [
            {
                "orange_id": "201373-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "30MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 1826,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S FEXOFENADINE HYDROCHLORIDE ALLERGY",
        "forms": [
            {
                "orange_id": "203330-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "30MG/5ML"
                ]
            },
            {
                "orange_id": "202039-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 1827,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S FEXOFENADINE HYDROCHLORIDE HIVES",
        "forms": [
            {
                "orange_id": "203330-2",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "30MG/5ML"
                ]
            },
            {
                "orange_id": "76502-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 1828,
        "type": "RX",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "FEXOFENADINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76502-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 1829,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "FEXOFENADINE HYDROCHLORIDE ALLERGY",
        "forms": [
            {
                "orange_id": "202039-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 1830,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE",
        "trade_name": "FEXOFENADINE HYDROCHLORIDE HIVES",
        "forms": [
            {
                "orange_id": "76502-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "180MG"
                ]
            }
        ]
    },
    {
        "id": 1831,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "ALLEGRA-D 12 HOUR ALLERGY AND CONGESTION",
        "forms": [
            {
                "orange_id": "20786-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 1832,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "ALLEGRA-D 24 HOUR ALLERGY AND CONGESTION",
        "forms": [
            {
                "orange_id": "21704-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "180MG-240MG"
                ]
            }
        ]
    },
    {
        "id": 1833,
        "type": "OTC",
        "ingredient": "FEXOFENADINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "FEXOFENADINE HYDROCHLORIDE AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "209116-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG-120MG",
                    "180MG-240MG"
                ]
            }
        ]
    },
    {
        "id": 1834,
        "type": "RX",
        "ingredient": "FIDAXOMICIN",
        "trade_name": "DIFICID",
        "forms": [
            {
                "orange_id": "213138-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "201699-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1835,
        "type": "RX",
        "ingredient": "FINASTERIDE",
        "trade_name": "FINASTERIDE",
        "forms": [
            {
                "orange_id": "91643-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1836,
        "type": "RX",
        "ingredient": "FINASTERIDE",
        "trade_name": "PROPECIA",
        "forms": [
            {
                "orange_id": "20788-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1837,
        "type": "RX",
        "ingredient": "FINASTERIDE",
        "trade_name": "PROSCAR",
        "forms": [
            {
                "orange_id": "20180-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 1838,
        "type": "RX",
        "ingredient": "FINASTERIDE AND TADALAFIL",
        "trade_name": "ENTADFI",
        "forms": [
            {
                "orange_id": "215423-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 1839,
        "type": "RX",
        "ingredient": "FINERENONE",
        "trade_name": "KERENDIA",
        "forms": [
            {
                "orange_id": "215341-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 1840,
        "type": "RX",
        "ingredient": "FINGOLIMOD HYDROCHLORIDE",
        "trade_name": "FINGOLIMOD HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207991-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 0.25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1841,
        "type": "RX",
        "ingredient": "FINGOLIMOD HYDROCHLORIDE",
        "trade_name": "GILENYA",
        "forms": [
            {
                "orange_id": "22527-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE",
                    "EQ 0.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1842,
        "type": "RX",
        "ingredient": "FINGOLIMOD LAURYL SULFATE",
        "trade_name": "TASCENSO ODT",
        "forms": [
            {
                "orange_id": "214962-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1843,
        "type": "RX",
        "ingredient": "FISH OIL TRIGLYCERIDES",
        "trade_name": "OMEGAVEN",
        "forms": [
            {
                "orange_id": "210589-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5GM/50ML (0.1GM/ML)",
                    "10GM/100ML (0.1GM/ML)"
                ]
            }
        ]
    },
    {
        "id": 1844,
        "type": "RX",
        "ingredient": "FISH OIL, MEDIUM CHAIN TRIGLYCERIDES, OLIVE OIL AND SOYBEAN OIL",
        "trade_name": "SMOFLIPID 20%",
        "forms": [
            {
                "orange_id": "207648-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "3GM/100ML-6GM/100ML-5GM/100ML-6GM/100ML (100ML)",
                    "3GM/100ML-6GM/100ML-5GM/100ML-6GM/100ML (250ML)",
                    "3GM/100ML-6GM/100ML-5GM/100ML-6GM/100ML (500ML)",
                    "3GM/100ML-6GM/100ML-5GM/100ML-6GM/100ML (1000ML)"
                ]
            }
        ]
    },
    {
        "id": 1845,
        "type": "RX",
        "ingredient": "FLAVOXATE HYDROCHLORIDE",
        "trade_name": "FLAVOXATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76835-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1846,
        "type": "RX",
        "ingredient": "FLECAINIDE ACETATE",
        "trade_name": "FLECAINIDE ACETATE",
        "forms": [
            {
                "orange_id": "75442-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 1847,
        "type": "RX",
        "ingredient": "FLIBANSERIN",
        "trade_name": "ADDYI",
        "forms": [
            {
                "orange_id": "22526-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1848,
        "type": "RX",
        "ingredient": "FLORBETABEN F-18",
        "trade_name": "NEURACEQ",
        "forms": [
            {
                "orange_id": "204677-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30ML (1.4-135mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 1849,
        "type": "RX",
        "ingredient": "FLORBETAPIR F-18",
        "trade_name": "AMYVID",
        "forms": [
            {
                "orange_id": "202008-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10-30ML (13.5-51mCi/ML)",
                    "10-50ML (13.5-51mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 1850,
        "type": "RX",
        "ingredient": "FLORTAUCIPIR F-18",
        "trade_name": "TAUVID",
        "forms": [
            {
                "orange_id": "212123-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30ML (8.1-51mCi/ML)",
                    "50ML (8.1-51mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 1851,
        "type": "RX",
        "ingredient": "FLOXURIDINE",
        "trade_name": "FLOXURIDINE",
        "forms": [
            {
                "orange_id": "75837-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1852,
        "type": "RX",
        "ingredient": "FLUCICLOVINE F-18",
        "trade_name": "AXUMIN",
        "forms": [
            {
                "orange_id": "208054-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "9-221mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1853,
        "type": "RX",
        "ingredient": "FLUCONAZOLE",
        "trade_name": "DIFLUCAN",
        "forms": [
            {
                "orange_id": "20090-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML",
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "19949-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1854,
        "type": "RX",
        "ingredient": "FLUCONAZOLE",
        "trade_name": "FLUCONAZOLE",
        "forms": [
            {
                "orange_id": "79150-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML",
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "78423-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 1855,
        "type": "RX",
        "ingredient": "FLUCONAZOLE",
        "trade_name": "FLUCONAZOLE IN SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "77947-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML (2MG/ML)",
                    "400MG/200ML (2MG/ML)",
                    "100MG/50ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1856,
        "type": "RX",
        "ingredient": "FLUCONAZOLE",
        "trade_name": "FLUCONAZOLE IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "76766-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML (2MG/ML)",
                    "400MG/200ML (2MG/ML)",
                    "100MG/50ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1857,
        "type": "RX",
        "ingredient": "FLUCYTOSINE",
        "trade_name": "ANCOBON",
        "forms": [
            {
                "orange_id": "17001-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1858,
        "type": "RX",
        "ingredient": "FLUCYTOSINE",
        "trade_name": "FLUCYTOSINE",
        "forms": [
            {
                "orange_id": "213665-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 1859,
        "type": "RX",
        "ingredient": "FLUDARABINE PHOSPHATE",
        "trade_name": "FLUDARABINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "203738-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/2ML (25MG/ML)",
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1860,
        "type": "RX",
        "ingredient": "FLUDEOXYGLUCOSE F-18",
        "trade_name": "FLUDEOXYGLUCOSE F18",
        "forms": [
            {
                "orange_id": "203778-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20-300mCi/ML",
                    "20-500mCi/ML",
                    "20-400mCi/ML",
                    "4-500mCi/ML",
                    "4-40mCi/ML",
                    "10-100mCi/ML",
                    "20-240mCi/ML",
                    "20-200mCi/ML",
                    "20-150mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1861,
        "type": "RX",
        "ingredient": "FLUDROCORTISONE ACETATE",
        "trade_name": "FLUDROCORTISONE ACETATE",
        "forms": [
            {
                "orange_id": "40425-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG"
                ]
            }
        ]
    },
    {
        "id": 1862,
        "type": "RX",
        "ingredient": "FLUMAZENIL",
        "trade_name": "FLUMAZENIL",
        "forms": [
            {
                "orange_id": "76755-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/5ML (0.1MG/ML)",
                    "1MG/10ML (0.1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1863,
        "type": "RX",
        "ingredient": "FLUNISOLIDE",
        "trade_name": "FLUNISOLIDE",
        "forms": [
            {
                "orange_id": "77436-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.029MG/SPRAY",
                    "0.025MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1864,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "CAPEX",
        "forms": [
            {
                "orange_id": "20001-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1865,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "DERMA-SMOOTHE/FS",
        "forms": [
            {
                "orange_id": "19452-1",
                "form": "OIL",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1866,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "DERMOTIC",
        "forms": [
            {
                "orange_id": "19452-3",
                "form": "OIL/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1867,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "FLAC",
        "forms": [
            {
                "orange_id": "210736-1",
                "form": "OIL/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1868,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "FLUCINOLONE ACETONIDE",
        "forms": [
            {
                "orange_id": "210556-1",
                "form": "OIL",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1869,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "FLUOCINOLONE ACETONIDE",
        "forms": [
            {
                "orange_id": "89526-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%",
                    "0.025%"
                ]
            },
            {
                "orange_id": "91306-1",
                "form": "OIL/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.01%"
                ]
            },
            {
                "orange_id": "201759-1",
                "form": "OIL",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            },
            {
                "orange_id": "89524-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%"
                ]
            },
            {
                "orange_id": "209913-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1870,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "FLUOCINONIDE ACETONIDE",
        "forms": [
            {
                "orange_id": "211815-1",
                "form": "OIL/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.01%"
                ]
            },
            {
                "orange_id": "210539-1",
                "form": "OIL",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1871,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "ILUVIEN",
        "forms": [
            {
                "orange_id": "201923-1",
                "form": "IMPLANT",
                "route": "INTRAVITREAL",
                "dosage": [
                    "0.19MG"
                ]
            }
        ]
    },
    {
        "id": 1872,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "RETISERT",
        "forms": [
            {
                "orange_id": "21737-1",
                "form": "IMPLANT",
                "route": "INTRAVITREAL",
                "dosage": [
                    "0.59MG"
                ]
            }
        ]
    },
    {
        "id": 1873,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "SYNALAR",
        "forms": [
            {
                "orange_id": "12787-4",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%",
                    "0.025%"
                ]
            },
            {
                "orange_id": "13960-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%"
                ]
            },
            {
                "orange_id": "15296-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 1874,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE",
        "trade_name": "YUTIQ",
        "forms": [
            {
                "orange_id": "210331-1",
                "form": "IMPLANT",
                "route": "INTRAVITREAL",
                "dosage": [
                    "0.18MG"
                ]
            }
        ]
    },
    {
        "id": 1875,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE, HYDROQUINONE AND TRETINOIN",
        "trade_name": "TRI-LUMA",
        "forms": [
            {
                "orange_id": "21112-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%-4%-0.05%"
                ]
            }
        ]
    },
    {
        "id": 1876,
        "type": "RX",
        "ingredient": "FLUOCINOLONE ACETONIDE AND NEOMYCIN SULFATE",
        "trade_name": "NEO-SYNALAR",
        "forms": [
            {
                "orange_id": "60700-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%-EQ 3.5MG BASE/GM"
                ]
            }
        ]
    },
    {
        "id": 1877,
        "type": "RX",
        "ingredient": "FLUOCINONIDE",
        "trade_name": "FLUOCINONIDE",
        "forms": [
            {
                "orange_id": "210554-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "17373-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "74905-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "71535-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1878,
        "type": "RX",
        "ingredient": "FLUOCINONIDE",
        "trade_name": "FLUOCINONIDE EMULSIFIED BASE",
        "forms": [
            {
                "orange_id": "74204-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1879,
        "type": "RX",
        "ingredient": "FLUOCINONIDE",
        "trade_name": "LIDEX",
        "forms": [
            {
                "orange_id": "16909-2",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "18849-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1880,
        "type": "RX",
        "ingredient": "FLUOCINONIDE",
        "trade_name": "LIDEX-E",
        "forms": [
            {
                "orange_id": "16908-3",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1881,
        "type": "RX",
        "ingredient": "FLUOCINONIDE",
        "trade_name": "VANOS",
        "forms": [
            {
                "orange_id": "21758-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1882,
        "type": "RX",
        "ingredient": "FLUORESCEIN SODIUM",
        "trade_name": "AK-FLUOR 10%",
        "forms": [
            {
                "orange_id": "22186-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/5ML (EQ 100MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1883,
        "type": "RX",
        "ingredient": "FLUORESCEIN SODIUM",
        "trade_name": "AK-FLUOR 25%",
        "forms": [
            {
                "orange_id": "22186-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/2ML (EQ 250MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1884,
        "type": "RX",
        "ingredient": "FLUORESCEIN SODIUM",
        "trade_name": "FLUORESCITE",
        "forms": [
            {
                "orange_id": "21980-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/5ML (EQ 100MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1885,
        "type": "RX",
        "ingredient": "FLUORODOPA F-18",
        "trade_name": "FLUORODOPA F18",
        "forms": [
            {
                "orange_id": "200655-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.42-8.33mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1886,
        "type": "RX",
        "ingredient": "FLUOROESTRADIOL F-18",
        "trade_name": "CERIANNA",
        "forms": [
            {
                "orange_id": "212155-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50ML (4-100mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 1887,
        "type": "RX",
        "ingredient": "FLUOROMETHOLONE",
        "trade_name": "FML",
        "forms": [
            {
                "orange_id": "17760-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "16851-2",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1888,
        "type": "RX",
        "ingredient": "FLUOROMETHOLONE",
        "trade_name": "FML FORTE",
        "forms": [
            {
                "orange_id": "19216-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.25%"
                ]
            }
        ]
    },
    {
        "id": 1889,
        "type": "RX",
        "ingredient": "FLUOROMETHOLONE ACETATE",
        "trade_name": "FLAREX",
        "forms": [
            {
                "orange_id": "19079-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 1890,
        "type": "RX",
        "ingredient": "FLUOROURACIL",
        "trade_name": "CARAC",
        "forms": [
            {
                "orange_id": "20985-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 1891,
        "type": "RX",
        "ingredient": "FLUOROURACIL",
        "trade_name": "EFUDEX",
        "forms": [
            {
                "orange_id": "16831-3",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "16831-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 1892,
        "type": "RX",
        "ingredient": "FLUOROURACIL",
        "trade_name": "FLUOROURACIL",
        "forms": [
            {
                "orange_id": "214845-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "40743-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/20ML (50MG/ML)",
                    "2.5GM/50ML (50MG/ML)",
                    "5GM/100ML (50MG/ML)",
                    "500MG/10ML (50MG/ML)"
                ]
            },
            {
                "orange_id": "76526-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%",
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 1893,
        "type": "RX",
        "ingredient": "FLUOROURACIL",
        "trade_name": "TOLAK",
        "forms": [
            {
                "orange_id": "22259-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 1894,
        "type": "RX",
        "ingredient": "FLUOXETINE HYDROCHLORIDE",
        "trade_name": "FLUOXETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78572-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "EQ 90MG BASE"
                ]
            },
            {
                "orange_id": "90223-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "79209-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/5ML"
                ]
            },
            {
                "orange_id": "208698-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1895,
        "type": "RX",
        "ingredient": "FLUOXETINE HYDROCHLORIDE",
        "trade_name": "PROZAC",
        "forms": [
            {
                "orange_id": "18936-6",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1896,
        "type": "RX",
        "ingredient": "FLUOXETINE HYDROCHLORIDE AND OLANZAPINE",
        "trade_name": "OLANZAPINE AND FLUOXETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77742-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE-EQ 3MG BASE",
                    "EQ 25MG BASE-EQ 6MG BASE",
                    "EQ 25MG BASE-EQ 12MG BASE",
                    "EQ 50MG BASE-EQ 6MG BASE",
                    "EQ 50MG BASE-EQ 12MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1897,
        "type": "RX",
        "ingredient": "FLUOXETINE HYDROCHLORIDE AND OLANZAPINE",
        "trade_name": "SYMBYAX",
        "forms": [
            {
                "orange_id": "21520-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE-EQ 3MG BASE",
                    "EQ 25MG BASE-EQ 6MG BASE",
                    "EQ 25MG BASE-EQ 12MG BASE",
                    "EQ 50MG BASE-EQ 6MG BASE",
                    "EQ 50MG BASE-EQ 12MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1898,
        "type": "RX",
        "ingredient": "FLUPHENAZINE DECANOATE",
        "trade_name": "FLUPHENAZINE DECANOATE",
        "forms": [
            {
                "orange_id": "207739-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1899,
        "type": "RX",
        "ingredient": "FLUPHENAZINE HYDROCHLORIDE",
        "trade_name": "FLUPHENAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74725-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "40146-1",
                "form": "ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/5ML"
                ]
            },
            {
                "orange_id": "89556-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5MG/ML"
                ]
            },
            {
                "orange_id": "213647-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 1900,
        "type": "RX",
        "ingredient": "FLURANDRENOLIDE",
        "trade_name": "CORDRAN",
        "forms": [
            {
                "orange_id": "13790-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "12806-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "16455-1",
                "form": "TAPE",
                "route": "TOPICAL",
                "dosage": [
                    "0.004MG/SQ CM"
                ]
            }
        ]
    },
    {
        "id": 1901,
        "type": "RX",
        "ingredient": "FLURANDRENOLIDE",
        "trade_name": "CORDRAN SP",
        "forms": [
            {
                "orange_id": "12806-2",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1902,
        "type": "RX",
        "ingredient": "FLURANDRENOLIDE",
        "trade_name": "FLURANDRENOLIDE",
        "forms": [
            {
                "orange_id": "205342-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "205343-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "207851-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1903,
        "type": "RX",
        "ingredient": "FLURAZEPAM HYDROCHLORIDE",
        "trade_name": "FLURAZEPAM HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "70345-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 1904,
        "type": "RX",
        "ingredient": "FLURBIPROFEN",
        "trade_name": "FLURBIPROFEN",
        "forms": [
            {
                "orange_id": "74431-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1905,
        "type": "RX",
        "ingredient": "FLURBIPROFEN SODIUM",
        "trade_name": "FLURBIPROFEN SODIUM",
        "forms": [
            {
                "orange_id": "74447-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.03%"
                ]
            }
        ]
    },
    {
        "id": 1906,
        "type": "RX",
        "ingredient": "FLUTAMIDE",
        "trade_name": "FLUTAMIDE",
        "forms": [
            {
                "orange_id": "75298-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 1907,
        "type": "RX",
        "ingredient": "FLUTEMETAMOL F-18",
        "trade_name": "VIZAMYL",
        "forms": [
            {
                "orange_id": "203137-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "121.5mCi/30ML (4.05mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 1908,
        "type": "RX",
        "ingredient": "FLUTICASONE FUROATE",
        "trade_name": "ARNUITY ELLIPTA",
        "forms": [
            {
                "orange_id": "205625-3",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.05MG/INH",
                    "0.1MG/INH",
                    "0.2MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1909,
        "type": "OTC",
        "ingredient": "FLUTICASONE FUROATE",
        "trade_name": "FLONASE SENSIMIST ALLERGY RELIEF",
        "forms": [
            {
                "orange_id": "22051-2",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.0275MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1910,
        "type": "RX",
        "ingredient": "FLUTICASONE FUROATE, UMECLIDINIUM BROMIDE AND VILANTEROL TRIFENATATE",
        "trade_name": "TRELEGY ELLIPTA",
        "forms": [
            {
                "orange_id": "209482-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH-EQ 0.0625MG BASE/INH-EQ 0.025MG BASE/INH",
                    "0.2MG/INH-EQ 0.0625MG BASE/INH-EQ 0.025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1911,
        "type": "RX",
        "ingredient": "FLUTICASONE FUROATE AND VILANTEROL TRIFENATATE",
        "trade_name": "BREO ELLIPTA",
        "forms": [
            {
                "orange_id": "204275-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH-EQ 0.025MG BASE/INH",
                    "0.2MG/INH-EQ 0.025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1912,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "ARMONAIR DIGIHALER",
        "forms": [
            {
                "orange_id": "208798-4",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.055MG/INH",
                    "0.113MG/INH",
                    "0.232MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1913,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "CUTIVATE",
        "forms": [
            {
                "orange_id": "21152-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 1914,
        "type": "OTC",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLONASE ALLERGY RELIEF",
        "forms": [
            {
                "orange_id": "205434-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1915,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLOVENT DISKUS 100",
        "forms": [
            {
                "orange_id": "20833-2",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1916,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLOVENT DISKUS 250",
        "forms": [
            {
                "orange_id": "20833-3",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.25MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1917,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLOVENT DISKUS 50",
        "forms": [
            {
                "orange_id": "20833-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.05MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1918,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLOVENT HFA",
        "forms": [
            {
                "orange_id": "21433-3",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.044MG/INH",
                    "0.11MG/INH",
                    "0.22MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1919,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "FLUTICASONE PROPIONATE",
        "forms": [
            {
                "orange_id": "77055-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "90759-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "77168-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            },
            {
                "orange_id": "77570-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 1920,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE",
        "trade_name": "XHANCE",
        "forms": [
            {
                "orange_id": "209022-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.093MG"
                ]
            }
        ]
    },
    {
        "id": 1921,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "ADVAIR DISKUS 100/50",
        "forms": [
            {
                "orange_id": "21077-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH-EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1922,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "ADVAIR DISKUS 250/50",
        "forms": [
            {
                "orange_id": "21077-2",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.25MG/INH-EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1923,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "ADVAIR DISKUS 500/50",
        "forms": [
            {
                "orange_id": "21077-3",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.5MG/INH-EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1924,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "ADVAIR HFA",
        "forms": [
            {
                "orange_id": "21254-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.045MG/INH-EQ 0.021MG BASE/INH",
                    "0.115MG/INH-EQ 0.021MG BASE/INH",
                    "0.23MG/INH-EQ 0.021MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1925,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "AIRDUO DIGIHALER",
        "forms": [
            {
                "orange_id": "208799-4",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.055MG/INH-EQ 0.014MG BASE/INH",
                    "0.113MG/INH-EQ 0.014MG BASE/INH",
                    "0.232MG/INH-EQ 0.014MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1926,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "AIRDUO RESPICLICK",
        "forms": [
            {
                "orange_id": "208799-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.055MG/INH-EQ 0.014MG BASE/INH",
                    "0.113MG/INH-EQ 0.014MG BASE/INH",
                    "0.232MG/INH-EQ 0.014MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1927,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "forms": [
            {
                "orange_id": "203433-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH-EQ 0.05MG BASE/INH",
                    "0.25MG/INH-EQ 0.05MG BASE/INH",
                    "0.5MG/INH-EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1928,
        "type": "RX",
        "ingredient": "FLUTICASONE PROPIONATE AND SALMETEROL XINAFOATE",
        "trade_name": "WIXELA INHUB",
        "forms": [
            {
                "orange_id": "208891-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.1MG/INH-EQ 0.05MG BASE/INH",
                    "0.25MG/INH-EQ 0.05MG BASE/INH",
                    "0.5MG/INH-EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 1929,
        "type": "RX",
        "ingredient": "FLUVASTATIN SODIUM",
        "trade_name": "FLUVASTATIN SODIUM",
        "forms": [
            {
                "orange_id": "90595-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "209397-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1930,
        "type": "RX",
        "ingredient": "FLUVASTATIN SODIUM",
        "trade_name": "LESCOL XL",
        "forms": [
            {
                "orange_id": "21192-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1931,
        "type": "RX",
        "ingredient": "FLUVOXAMINE MALEATE",
        "trade_name": "FLUVOXAMINE MALEATE",
        "forms": [
            {
                "orange_id": "91482-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG"
                ]
            },
            {
                "orange_id": "75902-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1932,
        "type": "RX",
        "ingredient": "FLUVOXAMINE MALEATE",
        "trade_name": "LUVOX",
        "forms": [
            {
                "orange_id": "21519-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 1933,
        "type": "RX",
        "ingredient": "FOLIC ACID",
        "trade_name": "FOLIC ACID",
        "forms": [
            {
                "orange_id": "89202-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "40625-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 1934,
        "type": "RX",
        "ingredient": "FOMEPIZOLE",
        "trade_name": "FOMEPIZOLE",
        "forms": [
            {
                "orange_id": "78368-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1.5GM/1.5ML (1GM/ML)"
                ]
            }
        ]
    },
    {
        "id": 1935,
        "type": "RX",
        "ingredient": "FONDAPARINUX SODIUM",
        "trade_name": "ARIXTRA",
        "forms": [
            {
                "orange_id": "21345-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "2.5MG/0.5ML",
                    "5MG/0.4ML",
                    "7.5MG/0.6ML",
                    "10MG/0.8ML"
                ]
            }
        ]
    },
    {
        "id": 1936,
        "type": "RX",
        "ingredient": "FONDAPARINUX SODIUM",
        "trade_name": "FONDAPARINUX SODIUM",
        "forms": [
            {
                "orange_id": "91316-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "2.5MG/0.5ML",
                    "5MG/0.4ML",
                    "7.5MG/0.6ML",
                    "10MG/0.8ML"
                ]
            }
        ]
    },
    {
        "id": 1937,
        "type": "RX",
        "ingredient": "FORMOTEROL FUMARATE",
        "trade_name": "FORMOTEROL FUMARATE",
        "forms": [
            {
                "orange_id": "215078-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "0.02MG/2ML"
                ]
            }
        ]
    },
    {
        "id": 1938,
        "type": "RX",
        "ingredient": "FORMOTEROL FUMARATE",
        "trade_name": "PERFOROMIST",
        "forms": [
            {
                "orange_id": "22007-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "0.02MG/2ML"
                ]
            }
        ]
    },
    {
        "id": 1939,
        "type": "RX",
        "ingredient": "FORMOTEROL FUMARATE AND GLYCOPYRROLATE",
        "trade_name": "BEVESPI AEROSPHERE",
        "forms": [
            {
                "orange_id": "208294-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.0048MG/INH-0.0090MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1940,
        "type": "RX",
        "ingredient": "FORMOTEROL FUMARATE AND MOMETASONE FUROATE",
        "trade_name": "DULERA",
        "forms": [
            {
                "orange_id": "22518-3",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.005MG/INH-0.05MG/INH",
                    "0.005MG/INH-0.1MG/INH",
                    "0.005MG/INH-0.2MG/INH"
                ]
            }
        ]
    },
    {
        "id": 1941,
        "type": "RX",
        "ingredient": "FOSAMPRENAVIR CALCIUM",
        "trade_name": "FOSAMPRENAVIR CALCIUM",
        "forms": [
            {
                "orange_id": "204060-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 700MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1942,
        "type": "RX",
        "ingredient": "FOSAMPRENAVIR CALCIUM",
        "trade_name": "LEXIVA",
        "forms": [
            {
                "orange_id": "22116-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE/ML"
                ]
            },
            {
                "orange_id": "21548-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 700MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1943,
        "type": "RX",
        "ingredient": "FOSAPREPITANT DIMEGLUMINE",
        "trade_name": "EMEND",
        "forms": [
            {
                "orange_id": "22023-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 150MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1944,
        "type": "RX",
        "ingredient": "FOSAPREPITANT DIMEGLUMINE",
        "trade_name": "FOSAPREPITANT DIMEGLUMINE",
        "forms": [
            {
                "orange_id": "204025-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 150MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1945,
        "type": "RX",
        "ingredient": "FOSCARNET SODIUM",
        "trade_name": "FOSCARNET SODIUM",
        "forms": [
            {
                "orange_id": "212483-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.4GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1946,
        "type": "RX",
        "ingredient": "FOSCARNET SODIUM",
        "trade_name": "FOSCAVIR",
        "forms": [
            {
                "orange_id": "20068-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.4GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 1947,
        "type": "RX",
        "ingredient": "FOSDENOPTERIN HYDROBROMIDE",
        "trade_name": "NULIBRY",
        "forms": [
            {
                "orange_id": "214018-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 9.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1948,
        "type": "RX",
        "ingredient": "FOSFOMYCIN TROMETHAMINE",
        "trade_name": "FOSFOMYCIN TROMETHAMINE",
        "forms": [
            {
                "orange_id": "214554-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 3GM BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1949,
        "type": "RX",
        "ingredient": "FOSFOMYCIN TROMETHAMINE",
        "trade_name": "MONUROL",
        "forms": [
            {
                "orange_id": "50717-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 3GM BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 1950,
        "type": "RX",
        "ingredient": "FOSINOPRIL SODIUM",
        "trade_name": "FOSINOPRIL SODIUM",
        "forms": [
            {
                "orange_id": "76906-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 1951,
        "type": "RX",
        "ingredient": "FOSINOPRIL SODIUM AND HYDROCHLOROTHIAZIDE",
        "trade_name": "FOSINOPRIL SODIUM AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "79245-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG-12.5MG",
                    "20MG-12.5MG"
                ]
            }
        ]
    },
    {
        "id": 1952,
        "type": "RX",
        "ingredient": "FOSNETUPITANT CHLORIDE HYDROCHLORIDE AND PALONOSETRON HYDROCHLORIDE",
        "trade_name": "AKYNZEO",
        "forms": [
            {
                "orange_id": "210493-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 235MG BASE/VIAL-EQ 0.25MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "210493-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 235MG BASE/20ML (EQ 11.75MG BASE/ML)-EQ 0.25MG BASE/20ML (EQ 0.0125MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1953,
        "type": "RX",
        "ingredient": "FOSPHENYTOIN SODIUM",
        "trade_name": "CEREBYX",
        "forms": [
            {
                "orange_id": "20450-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG PHENYTOIN NA/ML"
                ]
            }
        ]
    },
    {
        "id": 1954,
        "type": "RX",
        "ingredient": "FOSPHENYTOIN SODIUM",
        "trade_name": "FOSPHENYTOIN SODIUM",
        "forms": [
            {
                "orange_id": "78052-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG PHENYTOIN NA/ML"
                ]
            }
        ]
    },
    {
        "id": 1955,
        "type": "RX",
        "ingredient": "FOSTAMATINIB DISODIUM",
        "trade_name": "TAVALISSE",
        "forms": [
            {
                "orange_id": "209299-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1956,
        "type": "RX",
        "ingredient": "FOSTEMSAVIR TROMETHAMINE",
        "trade_name": "RUKOBIA",
        "forms": [
            {
                "orange_id": "212950-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1957,
        "type": "RX",
        "ingredient": "FROVATRIPTAN SUCCINATE",
        "trade_name": "FROVA",
        "forms": [
            {
                "orange_id": "21006-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1958,
        "type": "RX",
        "ingredient": "FROVATRIPTAN SUCCINATE",
        "trade_name": "FROVATRIPTAN SUCCINATE",
        "forms": [
            {
                "orange_id": "211292-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1959,
        "type": "RX",
        "ingredient": "FULVESTRANT",
        "trade_name": "FASLODEX",
        "forms": [
            {
                "orange_id": "21344-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1960,
        "type": "RX",
        "ingredient": "FULVESTRANT",
        "trade_name": "FULVESTRANT",
        "forms": [
            {
                "orange_id": "211689-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "210326-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "250MG/5ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1961,
        "type": "RX",
        "ingredient": "FUROSEMIDE",
        "trade_name": "FUROSEMIDE",
        "forms": [
            {
                "orange_id": "70017-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "70434-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML",
                    "40MG/5ML"
                ]
            },
            {
                "orange_id": "18569-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 1962,
        "type": "RX",
        "ingredient": "FUROSEMIDE",
        "trade_name": "LASIX",
        "forms": [
            {
                "orange_id": "16273-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 1963,
        "type": "RX",
        "ingredient": "GABAPENTIN",
        "trade_name": "GABAPENTIN",
        "forms": [
            {
                "orange_id": "206943-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG",
                    "400MG"
                ]
            },
            {
                "orange_id": "76403-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            },
            {
                "orange_id": "203244-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG",
                    "800MG",
                    "100MG",
                    "300MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 1964,
        "type": "RX",
        "ingredient": "GABAPENTIN",
        "trade_name": "GRALISE",
        "forms": [
            {
                "orange_id": "22544-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1965,
        "type": "RX",
        "ingredient": "GABAPENTIN",
        "trade_name": "NEURONTIN",
        "forms": [
            {
                "orange_id": "20235-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG",
                    "400MG"
                ]
            },
            {
                "orange_id": "21129-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            },
            {
                "orange_id": "20882-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 1966,
        "type": "RX",
        "ingredient": "GABAPENTIN ENACARBIL",
        "trade_name": "HORIZANT",
        "forms": [
            {
                "orange_id": "22399-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "300MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1967,
        "type": "RX",
        "ingredient": "GADOBENATE DIMEGLUMINE",
        "trade_name": "MULTIHANCE",
        "forms": [
            {
                "orange_id": "21357-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2.645GM/5ML (529MG/ML)",
                    "5.29GM/10ML (529MG/ML)",
                    "7.935GM/15ML (529MG/ML)",
                    "10.58GM/20ML (529MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1968,
        "type": "RX",
        "ingredient": "GADOBENATE DIMEGLUMINE",
        "trade_name": "MULTIHANCE MULTIPACK",
        "forms": [
            {
                "orange_id": "21358-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "26.45GM/50ML (529MG/ML)",
                    "52.9GM/100ML (529MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1969,
        "type": "RX",
        "ingredient": "GADOBUTROL",
        "trade_name": "GADAVIST",
        "forms": [
            {
                "orange_id": "201277-6",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1.20944GM/2ML (604.72MG/ML)",
                    "4.5354GM/7.5ML (604.72MG/ML)",
                    "6.0472GM/10ML (604.72MG/ML)",
                    "9.0708GM/15ML (604.72MG/ML)",
                    "18.1416GM/30ML (604.72MG/ML)",
                    "39.3068GM/65ML (604.72MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1970,
        "type": "RX",
        "ingredient": "GADODIAMIDE",
        "trade_name": "OMNISCAN",
        "forms": [
            {
                "orange_id": "22066-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "28.7GM/100ML (287MG/ML)",
                    "287MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1971,
        "type": "RX",
        "ingredient": "GADOTERATE MEGLUMINE",
        "trade_name": "CLARISCAN",
        "forms": [
            {
                "orange_id": "210016-5",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1.8845GM/5ML (376.9MG/ML)",
                    "3.769GM/10ML (376.9MG/ML)",
                    "5.6535GM/15ML (376.9MG/ML)",
                    "7.538GM/20ML (376.9MG/ML)",
                    "37.69GM/100ML (376.9MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1972,
        "type": "RX",
        "ingredient": "GADOTERATE MEGLUMINE",
        "trade_name": "DOTAREM",
        "forms": [
            {
                "orange_id": "204781-5",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1.8845GM/5ML (376.9MG/ML)",
                    "3.769GM/10ML (376.9MG/ML)",
                    "5.6535GM/15ML (376.9MG/ML)",
                    "7.538GM/20ML (376.9MG/ML)",
                    "37.69GM/100ML (376.9MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1973,
        "type": "RX",
        "ingredient": "GADOTERIDOL",
        "trade_name": "PROHANCE",
        "forms": [
            {
                "orange_id": "20131-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "279.3MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1974,
        "type": "RX",
        "ingredient": "GADOTERIDOL",
        "trade_name": "PROHANCE MULTIPACK",
        "forms": [
            {
                "orange_id": "21489-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "279.3MG/ML"
                ]
            }
        ]
    },
    {
        "id": 1975,
        "type": "RX",
        "ingredient": "GADOXETATE DISODIUM",
        "trade_name": "EOVIST",
        "forms": [
            {
                "orange_id": "22090-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1.8143GM/10ML (181.43MG/ML)",
                    "2.72145GM/15ML (181.43MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1976,
        "type": "RX",
        "ingredient": "GALANTAMINE HYDROBROMIDE",
        "trade_name": "GALANTAMINE HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "204895-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 8MG BASE",
                    "EQ 16MG BASE",
                    "EQ 24MG BASE"
                ]
            },
            {
                "orange_id": "78185-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4MG/ML"
                ]
            },
            {
                "orange_id": "90957-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 8MG BASE",
                    "EQ 12MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1977,
        "type": "RX",
        "ingredient": "GALANTAMINE HYDROBROMIDE",
        "trade_name": "RAZADYNE ER",
        "forms": [
            {
                "orange_id": "21615-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 8MG BASE",
                    "EQ 16MG BASE",
                    "EQ 24MG BASE"
                ]
            }
        ]
    },
    {
        "id": 1978,
        "type": "RX",
        "ingredient": "GALLIUM CITRATE GA-67",
        "trade_name": "GALLIUM CITRATE GA 67",
        "forms": [
            {
                "orange_id": "18058-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1979,
        "type": "RX",
        "ingredient": "GALLIUM DOTATATE GA-68",
        "trade_name": "NETSPOT",
        "forms": [
            {
                "orange_id": "208547-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "2.1-5.5mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1980,
        "type": "RX",
        "ingredient": "GALLIUM DOTATOC GA-68",
        "trade_name": "GALLIUM DOTATOC GA 68",
        "forms": [
            {
                "orange_id": "210828-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.5-4mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1981,
        "type": "RX",
        "ingredient": "GALLIUM GA-68 GOZETOTIDE",
        "trade_name": "ILLUCCIX",
        "forms": [
            {
                "orange_id": "214032-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6.7mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 1982,
        "type": "RX",
        "ingredient": "GALLIUM GA-68 PSMA-11",
        "trade_name": "GALLIUM GA 68 PSMA-11",
        "forms": [
            {
                "orange_id": "212642-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30ML (0.5-5mCi/mL)",
                    "20ML (0.5-5mCi/mL)"
                ]
            }
        ]
    },
    {
        "id": 1983,
        "type": "RX",
        "ingredient": "GANCICLOVIR",
        "trade_name": "GANZYK-RTU",
        "forms": [
            {
                "orange_id": "209347-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/250ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1984,
        "type": "RX",
        "ingredient": "GANCICLOVIR",
        "trade_name": "ZIRGAN",
        "forms": [
            {
                "orange_id": "22211-1",
                "form": "GEL",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.15%"
                ]
            }
        ]
    },
    {
        "id": 1985,
        "type": "RX",
        "ingredient": "GANCICLOVIR SODIUM",
        "trade_name": "GANCICLOVIR SODIUM",
        "forms": [
            {
                "orange_id": "90658-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 1986,
        "type": "RX",
        "ingredient": "GANIRELIX ACETATE",
        "trade_name": "GANIRELIX ACETATE",
        "forms": [
            {
                "orange_id": "21057-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250MCG/0.5ML"
                ]
            }
        ]
    },
    {
        "id": 1987,
        "type": "RX",
        "ingredient": "GATIFLOXACIN",
        "trade_name": "GATIFLOXACIN",
        "forms": [
            {
                "orange_id": "203189-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 1988,
        "type": "RX",
        "ingredient": "GATIFLOXACIN",
        "trade_name": "ZYMAR",
        "forms": [
            {
                "orange_id": "21493-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            }
        ]
    },
    {
        "id": 1989,
        "type": "RX",
        "ingredient": "GATIFLOXACIN",
        "trade_name": "ZYMAXID",
        "forms": [
            {
                "orange_id": "22548-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 1990,
        "type": "RX",
        "ingredient": "GEFITINIB",
        "trade_name": "IRESSA",
        "forms": [
            {
                "orange_id": "206995-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 1991,
        "type": "RX",
        "ingredient": "GEMCITABINE HYDROCHLORIDE",
        "trade_name": "GEMCITABINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91594-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 200MG BASE/VIAL",
                    "1GM/26.3ML (38MG/ML)",
                    "2GM/52.6ML (38MG/ML)",
                    "200MG/5.26ML (38MG/ML)"
                ]
            },
            {
                "orange_id": "209604-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/10ML (100MG/ML)",
                    "1.5GM/15ML (100MG/ML)",
                    "2GM/20ML (100MG/ML)",
                    "200MG/2ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 1992,
        "type": "RX",
        "ingredient": "GEMCITABINE HYDROCHLORIDE",
        "trade_name": "INFUGEM",
        "forms": [
            {
                "orange_id": "208313-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1200MG BASE/120ML (EQ 10MG BASE/ML)",
                    "EQ 1300MG BASE/130ML (EQ 10MG BASE/ML)",
                    "EQ 1400MG BASE/140ML (EQ 10MG BASE/ML)",
                    "EQ 1500MG BASE/150ML (EQ 10MG BASE/ML)",
                    "EQ 1600MG BASE/160ML (EQ 10MG BASE/ML)",
                    "EQ 1700MG BASE/170ML (EQ 10MG BASE/ML)",
                    "EQ 1800MG BASE/180ML (EQ 10MG BASE/ML)",
                    "EQ 1900MG BASE/190ML (EQ 10MG BASE/ML)",
                    "EQ 2000MG BASE/200ML (EQ 10MG BASE/ML)",
                    "EQ 2200MG BASE/220ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 1993,
        "type": "RX",
        "ingredient": "GEMFIBROZIL",
        "trade_name": "GEMFIBROZIL",
        "forms": [
            {
                "orange_id": "75034-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1994,
        "type": "RX",
        "ingredient": "GEMFIBROZIL",
        "trade_name": "LOPID",
        "forms": [
            {
                "orange_id": "18422-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 1995,
        "type": "RX",
        "ingredient": "GENTAMICIN SULFATE",
        "trade_name": "GENOPTIC",
        "forms": [
            {
                "orange_id": "62452-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            }
        ]
    },
    {
        "id": 1996,
        "type": "RX",
        "ingredient": "GENTAMICIN SULFATE",
        "trade_name": "GENTAK",
        "forms": [
            {
                "orange_id": "64163-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            }
        ]
    },
    {
        "id": 1997,
        "type": "RX",
        "ingredient": "GENTAMICIN SULFATE",
        "trade_name": "GENTAMICIN SULFATE",
        "forms": [
            {
                "orange_id": "64056-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            },
            {
                "orange_id": "62366-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML",
                    "EQ 40MG BASE/ML"
                ]
            },
            {
                "orange_id": "64093-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            },
            {
                "orange_id": "64054-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            },
            {
                "orange_id": "62635-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE"
                ]
            }
        ]
    },
    {
        "id": 1998,
        "type": "RX",
        "ingredient": "GENTAMICIN SULFATE",
        "trade_name": "GENTAMICIN SULFATE IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "62373-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1.2MG BASE/ML",
                    "EQ 1.6MG BASE/ML",
                    "EQ 2MG BASE/ML",
                    "EQ 80MG BASE/100ML",
                    "EQ 100MG BASE/100ML",
                    "EQ 120MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 1999,
        "type": "RX",
        "ingredient": "GENTAMICIN SULFATE AND PREDNISOLONE ACETATE",
        "trade_name": "PRED-G",
        "forms": [
            {
                "orange_id": "50612-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE-0.6%"
                ]
            },
            {
                "orange_id": "50586-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.3% BASE-1%"
                ]
            }
        ]
    },
    {
        "id": 2000,
        "type": "RX",
        "ingredient": "GILTERITINIB FUMARATE",
        "trade_name": "XOSPATA",
        "forms": [
            {
                "orange_id": "211349-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2001,
        "type": "RX",
        "ingredient": "GIVOSIRAN SODIUM",
        "trade_name": "GIVLAARI",
        "forms": [
            {
                "orange_id": "212194-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 189MG BASE/ML (EQ 189MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2002,
        "type": "RX",
        "ingredient": "GLASDEGIB MALEATE",
        "trade_name": "DAURISMO",
        "forms": [
            {
                "orange_id": "210656-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2003,
        "type": "RX",
        "ingredient": "GLATIRAMER ACETATE",
        "trade_name": "COPAXONE",
        "forms": [
            {
                "orange_id": "20622-2",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "20MG/ML",
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2004,
        "type": "RX",
        "ingredient": "GLATIRAMER ACETATE",
        "trade_name": "GLATIRAMER ACETATE",
        "forms": [
            {
                "orange_id": "91646-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "20MG/ML",
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2005,
        "type": "RX",
        "ingredient": "GLATIRAMER ACETATE",
        "trade_name": "GLATOPA",
        "forms": [
            {
                "orange_id": "90218-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "20MG/ML",
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2006,
        "type": "RX",
        "ingredient": "GLECAPREVIR AND PIBRENTASVIR",
        "trade_name": "MAVYRET",
        "forms": [
            {
                "orange_id": "215110-1",
                "form": "PELLETS",
                "route": "ORAL",
                "dosage": [
                    "50MG-20MG/PACKET"
                ]
            },
            {
                "orange_id": "209394-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 2007,
        "type": "RX",
        "ingredient": "GLIMEPIRIDE",
        "trade_name": "AMARYL",
        "forms": [
            {
                "orange_id": "20496-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 2008,
        "type": "RX",
        "ingredient": "GLIMEPIRIDE",
        "trade_name": "GLIMEPIRIDE",
        "forms": [
            {
                "orange_id": "78181-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "4MG",
                    "3MG",
                    "6MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 2009,
        "type": "RX",
        "ingredient": "GLIMEPIRIDE AND PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "DUETACT",
        "forms": [
            {
                "orange_id": "21925-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG-30MG",
                    "4MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2010,
        "type": "RX",
        "ingredient": "GLIMEPIRIDE AND PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "PIOGLITAZONE HYDROCHLORIDE AND GLIMEPIRIDE",
        "forms": [
            {
                "orange_id": "201049-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG-30MG",
                    "4MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2011,
        "type": "RX",
        "ingredient": "GLIPIZIDE",
        "trade_name": "GLIPIZIDE",
        "forms": [
            {
                "orange_id": "206928-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "74550-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2012,
        "type": "RX",
        "ingredient": "GLIPIZIDE",
        "trade_name": "GLUCOTROL",
        "forms": [
            {
                "orange_id": "17783-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2013,
        "type": "RX",
        "ingredient": "GLIPIZIDE",
        "trade_name": "GLUCOTROL XL",
        "forms": [
            {
                "orange_id": "20329-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2014,
        "type": "RX",
        "ingredient": "GLIPIZIDE AND METFORMIN HYDROCHLORIDE",
        "trade_name": "GLIPIZIDE AND METFORMIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77507-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-250MG",
                    "2.5MG-500MG",
                    "5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 2015,
        "type": "RX",
        "ingredient": "GLUCAGON",
        "trade_name": "BAQSIMI",
        "forms": [
            {
                "orange_id": "210134-1",
                "form": "POWDER",
                "route": "NASAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2016,
        "type": "RX",
        "ingredient": "GLUCAGON",
        "trade_name": "GLUCAGON",
        "forms": [
            {
                "orange_id": "208086-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2017,
        "type": "RX",
        "ingredient": "GLUCAGON",
        "trade_name": "GVOKE HYPOPEN",
        "forms": [
            {
                "orange_id": "212097-3",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.5MG/0.1ML (0.5MG/0.1ML)",
                    "1MG/0.2ML (1MG/0.2ML)"
                ]
            }
        ]
    },
    {
        "id": 2018,
        "type": "RX",
        "ingredient": "GLUCAGON",
        "trade_name": "GVOKE PFS",
        "forms": [
            {
                "orange_id": "212097-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.5MG/0.1ML (0.5MG/0.1ML)",
                    "1MG/0.2ML (1MG/0.2ML)"
                ]
            }
        ]
    },
    {
        "id": 2019,
        "type": "RX",
        "ingredient": "GLUCAGON HYDROCHLORIDE",
        "trade_name": "GLUCAGEN",
        "forms": [
            {
                "orange_id": "20918-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2020,
        "type": "RX",
        "ingredient": "GLUCAGON HYDROCHLORIDE",
        "trade_name": "GLUCAGON",
        "forms": [
            {
                "orange_id": "201849-1",
                "form": "POWDER",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "EQ 1MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2021,
        "type": "RX",
        "ingredient": "GLYBURIDE",
        "trade_name": "DIABETA",
        "forms": [
            {
                "orange_id": "17532-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.25MG",
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2022,
        "type": "RX",
        "ingredient": "GLYBURIDE",
        "trade_name": "GLYBURIDE",
        "forms": [
            {
                "orange_id": "203379-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.25MG",
                    "2.5MG",
                    "5MG",
                    "1.25mg",
                    "2.5mg"
                ]
            }
        ]
    },
    {
        "id": 2023,
        "type": "RX",
        "ingredient": "GLYBURIDE",
        "trade_name": "GLYBURIDE (MICRONIZED)",
        "forms": [
            {
                "orange_id": "75890-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG",
                    "3MG",
                    "6MG",
                    "4.5MG"
                ]
            }
        ]
    },
    {
        "id": 2024,
        "type": "RX",
        "ingredient": "GLYBURIDE",
        "trade_name": "GLYNASE",
        "forms": [
            {
                "orange_id": "20051-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG",
                    "3MG",
                    "6MG"
                ]
            }
        ]
    },
    {
        "id": 2025,
        "type": "RX",
        "ingredient": "GLYBURIDE AND METFORMIN HYDROCHLORIDE",
        "trade_name": "GLYBURIDE AND METFORMIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76716-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.25MG-250MG",
                    "2.5MG-500MG",
                    "5MG-500MG"
                ]
            }
        ]
    },
    {
        "id": 2026,
        "type": "RX",
        "ingredient": "GLYCEROL PHENYLBUTYRATE",
        "trade_name": "RAVICTI",
        "forms": [
            {
                "orange_id": "203284-1",
                "form": "LIQUID",
                "route": "ORAL",
                "dosage": [
                    "1.1GM/ML"
                ]
            }
        ]
    },
    {
        "id": 2027,
        "type": "RX",
        "ingredient": "GLYCINE",
        "trade_name": "AMINOACETIC ACID 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17865-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "1.5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2028,
        "type": "RX",
        "ingredient": "GLYCINE",
        "trade_name": "GLYCINE 1. 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16784-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "1.5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2029,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "CUVPOSA",
        "forms": [
            {
                "orange_id": "22571-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2030,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "DARTISLA ODT",
        "forms": [
            {
                "orange_id": "215019-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "1.7MG"
                ]
            }
        ]
    },
    {
        "id": 2031,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "GLYCOPYRROLATE",
        "forms": [
            {
                "orange_id": "213238-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML"
                ]
            },
            {
                "orange_id": "204438-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/5ML"
                ]
            },
            {
                "orange_id": "203657-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2032,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "GLYRX-PF",
        "forms": [
            {
                "orange_id": "210997-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "0.2MG/ML (0.2MG/ML)",
                    "0.4MG/2ML (0.2MG/ML)",
                    "0.6MG/3ML (0.2MG/ML)",
                    "1MG/5ML (0.2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2033,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "LONHALA MAGNAIR KIT",
        "forms": [
            {
                "orange_id": "208437-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "25MCG/ML"
                ]
            }
        ]
    },
    {
        "id": 2034,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "ROBINUL",
        "forms": [
            {
                "orange_id": "12827-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 2035,
        "type": "RX",
        "ingredient": "GLYCOPYRROLATE",
        "trade_name": "ROBINUL FORTE",
        "forms": [
            {
                "orange_id": "12827-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2036,
        "type": "RX",
        "ingredient": "GLYCOPYRRONIUM TOSYLATE",
        "trade_name": "QBREXZA",
        "forms": [
            {
                "orange_id": "210361-1",
                "form": "CLOTH",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 2.4% BASE"
                ]
            }
        ]
    },
    {
        "id": 2037,
        "type": "RX",
        "ingredient": "GOLODIRSEN",
        "trade_name": "VYONDYS 53",
        "forms": [
            {
                "orange_id": "211970-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/2ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2038,
        "type": "RX",
        "ingredient": "GOSERELIN ACETATE",
        "trade_name": "ZOLADEX",
        "forms": [
            {
                "orange_id": "19726-1",
                "form": "IMPLANT",
                "route": "IMPLANTATION",
                "dosage": [
                    "EQ 3.6MG BASE",
                    "EQ 10.8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2039,
        "type": "RX",
        "ingredient": "GRAMICIDIN, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATES AND GRAMICIDIN",
        "forms": [
            {
                "orange_id": "65187-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025MG/ML-EQ 1.75MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2040,
        "type": "RX",
        "ingredient": "GRAMICIDIN, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOSPORIN",
        "forms": [
            {
                "orange_id": "60582-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025MG/ML-EQ 1.75MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2041,
        "type": "RX",
        "ingredient": "GRANISETRON",
        "trade_name": "SANCUSO",
        "forms": [
            {
                "orange_id": "22198-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "3.1MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 2042,
        "type": "RX",
        "ingredient": "GRANISETRON",
        "trade_name": "SUSTOL",
        "forms": [
            {
                "orange_id": "22445-1",
                "form": "INJECTION, EXTENDED RELEASE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "10MG/0.4ML (10MG/0.4ML)"
                ]
            }
        ]
    },
    {
        "id": 2043,
        "type": "RX",
        "ingredient": "GRANISETRON HYDROCHLORIDE",
        "trade_name": "GRANISETRON HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79119-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.1MG BASE/ML (EQ 0.1MG BASE/ML)",
                    "EQ 1MG BASE/ML (EQ 1MG BASE/ML)",
                    "EQ 4MG BASE/4ML (EQ 1MG BASE/ML)"
                ]
            },
            {
                "orange_id": "78843-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2044,
        "type": "RX",
        "ingredient": "GRANISETRON HYDROCHLORIDE",
        "trade_name": "GRANISETRON HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "78863-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2045,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, MICROCRYSTALLINE",
        "trade_name": "FULVICIN-U/F",
        "forms": [
            {
                "orange_id": "60569-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2046,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, MICROSIZE",
        "trade_name": "GRISEOFULVIN",
        "forms": [
            {
                "orange_id": "65394-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML"
                ]
            },
            {
                "orange_id": "91592-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2047,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, ULTRAMICROCRYSTALLINE",
        "trade_name": "FULVICIN P/G",
        "forms": [
            {
                "orange_id": "61996-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2048,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, ULTRAMICROCRYSTALLINE",
        "trade_name": "FULVICIN P/G 165",
        "forms": [
            {
                "orange_id": "61996-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "165MG"
                ]
            }
        ]
    },
    {
        "id": 2049,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, ULTRAMICROCRYSTALLINE",
        "trade_name": "FULVICIN P/G 330",
        "forms": [
            {
                "orange_id": "61996-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "330MG"
                ]
            }
        ]
    },
    {
        "id": 2050,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, ULTRAMICROSIZE",
        "trade_name": "GRISEOFULVIN, ULTRAMICROSIZE",
        "forms": [
            {
                "orange_id": "204371-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2051,
        "type": "RX",
        "ingredient": "GRISEOFULVIN, ULTRAMICROSIZE",
        "trade_name": "GRIS-PEG",
        "forms": [
            {
                "orange_id": "50475-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2052,
        "type": "OTC",
        "ingredient": "GUAIFENESIN",
        "trade_name": "GUAIFENESIN",
        "forms": [
            {
                "orange_id": "91009-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.2GM",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 2053,
        "type": "OTC",
        "ingredient": "GUAIFENESIN",
        "trade_name": "MUCINEX",
        "forms": [
            {
                "orange_id": "21282-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.2GM",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 2054,
        "type": "OTC",
        "ingredient": "GUAIFENESIN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "GUAIFENESIN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91071-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "600MG-60MG",
                    "1.2GM-120MG"
                ]
            }
        ]
    },
    {
        "id": 2055,
        "type": "OTC",
        "ingredient": "GUAIFENESIN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "MUCINEX D",
        "forms": [
            {
                "orange_id": "21585-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.2GM-120MG",
                    "600MG-60MG"
                ]
            }
        ]
    },
    {
        "id": 2056,
        "type": "RX",
        "ingredient": "GUANFACINE HYDROCHLORIDE",
        "trade_name": "GUANFACINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "200881-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4MG BASE"
                ]
            },
            {
                "orange_id": "75109-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2057,
        "type": "RX",
        "ingredient": "GUANFACINE HYDROCHLORIDE",
        "trade_name": "INTUNIV",
        "forms": [
            {
                "orange_id": "22037-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2058,
        "type": "RX",
        "ingredient": "HALCINONIDE",
        "trade_name": "HALCINONIDE",
        "forms": [
            {
                "orange_id": "214723-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2059,
        "type": "RX",
        "ingredient": "HALCINONIDE",
        "trade_name": "HALOG",
        "forms": [
            {
                "orange_id": "17556-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "17824-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "17823-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2060,
        "type": "RX",
        "ingredient": "HALOBETASOL PROPIONATE",
        "trade_name": "BRYHALI",
        "forms": [
            {
                "orange_id": "209355-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%"
                ]
            }
        ]
    },
    {
        "id": 2061,
        "type": "RX",
        "ingredient": "HALOBETASOL PROPIONATE",
        "trade_name": "HALOBETASOL PROPIONATE",
        "forms": [
            {
                "orange_id": "78162-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            },
            {
                "orange_id": "77109-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 2062,
        "type": "RX",
        "ingredient": "HALOBETASOL PROPIONATE",
        "trade_name": "LEXETTE",
        "forms": [
            {
                "orange_id": "210566-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 2063,
        "type": "RX",
        "ingredient": "HALOBETASOL PROPIONATE",
        "trade_name": "ULTRAVATE",
        "forms": [
            {
                "orange_id": "208183-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 2064,
        "type": "RX",
        "ingredient": "HALOBETASOL PROPIONATE AND TAZAROTENE",
        "trade_name": "DUOBRII",
        "forms": [
            {
                "orange_id": "209354-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%-0.045%"
                ]
            }
        ]
    },
    {
        "id": 2065,
        "type": "RX",
        "ingredient": "HALOPERIDOL",
        "trade_name": "HALOPERIDOL",
        "forms": [
            {
                "orange_id": "71130-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG",
                    "0.5MG",
                    "1MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2066,
        "type": "RX",
        "ingredient": "HALOPERIDOL DECANOATE",
        "trade_name": "HALDOL",
        "forms": [
            {
                "orange_id": "18701-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/ML",
                    "EQ 100MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2067,
        "type": "RX",
        "ingredient": "HALOPERIDOL DECANOATE",
        "trade_name": "HALOPERIDOL DECANOATE",
        "forms": [
            {
                "orange_id": "74893-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/ML",
                    "EQ 100MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2068,
        "type": "RX",
        "ingredient": "HALOPERIDOL LACTATE",
        "trade_name": "HALOPERIDOL",
        "forms": [
            {
                "orange_id": "73364-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE/ML"
                ]
            },
            {
                "orange_id": "204849-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2069,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM",
        "forms": [
            {
                "orange_id": "208827-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000 UNITS/0.5ML",
                    "1,000 UNITS/ML",
                    "10,000 UNITS/ML",
                    "5,000 UNITS/ML",
                    "20,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2070,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 1, 000 UNITS AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18609-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2071,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 1, 000 UNITS IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19953-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2072,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 10, 000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19339-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2073,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 12, 500 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19339-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2074,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 12, 500 UNITS IN SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18916-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2075,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 2, 000 UNITS AND SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18609-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 UNITS/100ML",
                    "2,000 UNITS/1000ML"
                ]
            }
        ]
    },
    {
        "id": 2076,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 2, 000 UNITS IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "212441-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2077,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 20, 000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19952-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2078,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 25, 000 UNITS IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19952-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000 UNITS/100ML",
                    "10,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2079,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM 25, 000 UNITS IN SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18916-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000 UNITS/100ML",
                    "10,000 UNITS/100ML"
                ]
            }
        ]
    },
    {
        "id": 2080,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17029-13",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1,000 UNITS/ML",
                    "5,000 UNITS/ML",
                    "10,000 UNITS/ML",
                    "20,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2081,
        "type": "RX",
        "ingredient": "HEPARIN SODIUM",
        "trade_name": "HEPARIN SODIUM PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "17029-10",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1,000 UNITS/ML",
                    "10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2082,
        "type": "RX",
        "ingredient": "HEXACHLOROPHENE",
        "trade_name": "PRE-OP",
        "forms": [
            {
                "orange_id": "17433-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "480MG"
                ]
            }
        ]
    },
    {
        "id": 2083,
        "type": "RX",
        "ingredient": "HEXACHLOROPHENE",
        "trade_name": "PRE-OP II",
        "forms": [
            {
                "orange_id": "17433-2",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "480MG"
                ]
            }
        ]
    },
    {
        "id": 2084,
        "type": "RX",
        "ingredient": "HEXAMINOLEVULINATE HYDROCHLORIDE",
        "trade_name": "CYSVIEW KIT",
        "forms": [
            {
                "orange_id": "22555-1",
                "form": "FOR SOLUTION",
                "route": "INTRAVESICAL",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2085,
        "type": "RX",
        "ingredient": "HISTRELIN ACETATE",
        "trade_name": "SUPPRELIN LA",
        "forms": [
            {
                "orange_id": "22058-1",
                "form": "IMPLANT",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2086,
        "type": "RX",
        "ingredient": "HOMATROPINE METHYLBROMIDE AND HYDROCODONE BITARTRATE",
        "trade_name": "HOMATROPINE METHYLBROMIDE AND HYDROCODONE BITARTRATE",
        "forms": [
            {
                "orange_id": "207176-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 2087,
        "type": "RX",
        "ingredient": "HOMATROPINE METHYLBROMIDE AND HYDROCODONE BITARTRATE",
        "trade_name": "HYCODAN",
        "forms": [
            {
                "orange_id": "5213-2",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "1.5MG/5ML-5MG/5ML"
                ]
            },
            {
                "orange_id": "5213-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG-5MG"
                ]
            }
        ]
    },
    {
        "id": 2088,
        "type": "RX",
        "ingredient": "HOMATROPINE METHYLBROMIDE AND HYDROCODONE BITARTRATE",
        "trade_name": "HYDROCODONE BITARTRATE AND HOMATROPINE METHYLBROMIDE",
        "forms": [
            {
                "orange_id": "207487-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "1.5MG/5ML-5MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2089,
        "type": "RX",
        "ingredient": "HYDRALAZINE HYDROCHLORIDE",
        "trade_name": "HYDRALAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40730-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            },
            {
                "orange_id": "200737-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2090,
        "type": "RX",
        "ingredient": "HYDRALAZINE HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "trade_name": "HYDRA-ZIDE",
        "forms": [
            {
                "orange_id": "88957-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG-25MG",
                    "50MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 2091,
        "type": "RX",
        "ingredient": "HYDRALAZINE HYDROCHLORIDE AND ISOSORBIDE DINITRATE",
        "trade_name": "BIDIL",
        "forms": [
            {
                "orange_id": "20727-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "37.5MG-20MG"
                ]
            }
        ]
    },
    {
        "id": 2092,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE",
        "trade_name": "HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "78164-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "12.5MG"
                ]
            },
            {
                "orange_id": "202556-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2093,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE",
        "trade_name": "MICROZIDE",
        "forms": [
            {
                "orange_id": "20504-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "12.5MG"
                ]
            }
        ]
    },
    {
        "id": 2094,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND IRBESARTAN",
        "trade_name": "AVALIDE",
        "forms": [
            {
                "orange_id": "20758-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-150MG",
                    "12.5MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 2095,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND IRBESARTAN",
        "trade_name": "IRBESARTAN AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "91370-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-150MG",
                    "12.5MG-300MG",
                    "25MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 2096,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND LISINOPRIL",
        "trade_name": "LISINOPRIL AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "77606-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-10MG",
                    "12.5MG-20MG",
                    "25MG-20MG"
                ]
            }
        ]
    },
    {
        "id": 2097,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND LISINOPRIL",
        "trade_name": "ZESTORETIC",
        "forms": [
            {
                "orange_id": "19888-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-10MG",
                    "12.5MG-20MG",
                    "25MG-20MG"
                ]
            }
        ]
    },
    {
        "id": 2098,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND LOSARTAN POTASSIUM",
        "trade_name": "HYZAAR",
        "forms": [
            {
                "orange_id": "20387-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-50MG",
                    "12.5MG-100MG",
                    "25MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 2099,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND LOSARTAN POTASSIUM",
        "trade_name": "LOSARTAN POTASSIUM AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "91617-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-50MG",
                    "12.5MG-100MG",
                    "25MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 2100,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND METOPROLOL TARTRATE",
        "trade_name": "LOPRESSOR HCT",
        "forms": [
            {
                "orange_id": "18303-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 2101,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND METOPROLOL TARTRATE",
        "trade_name": "METOPROLOL TARTRATE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "202870-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-50MG",
                    "25MG-100MG",
                    "50MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 2102,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND MOEXIPRIL HYDROCHLORIDE",
        "trade_name": "MOEXIPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "90718-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-7.5MG",
                    "12.5MG-15MG",
                    "25MG-15MG"
                ]
            }
        ]
    },
    {
        "id": 2103,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "BENICAR HCT",
        "forms": [
            {
                "orange_id": "21532-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-20MG",
                    "12.5MG-40MG",
                    "25MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 2104,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND OLMESARTAN MEDOXOMIL",
        "trade_name": "OLMESARTAN MEDOXOMIL AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "209281-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-20MG",
                    "12.5MG-40MG",
                    "25MG-40MG"
                ]
            }
        ]
    },
    {
        "id": 2105,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND QUINAPRIL HYDROCHLORIDE",
        "trade_name": "ACCURETIC",
        "forms": [
            {
                "orange_id": "20125-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-EQ 10MG BASE",
                    "12.5MG-EQ 20MG BASE",
                    "25MG-EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2106,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND QUINAPRIL HYDROCHLORIDE",
        "trade_name": "QUINAPRIL HYDROCHLORIDE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "91524-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-EQ 10MG BASE",
                    "12.5MG-EQ 20MG BASE",
                    "25MG-EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2107,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND QUINAPRIL HYDROCHLORIDE",
        "trade_name": "QUINARETIC",
        "forms": [
            {
                "orange_id": "76374-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-EQ 10MG BASE",
                    "12.5MG-EQ 20MG BASE",
                    "25MG-EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2108,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND SPIRONOLACTONE",
        "trade_name": "ALDACTAZIDE",
        "forms": [
            {
                "orange_id": "12616-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-25MG",
                    "50MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 2109,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND SPIRONOLACTONE",
        "trade_name": "SPIRONOLACTONE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "86513-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 2110,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND TELMISARTAN",
        "trade_name": "MICARDIS HCT",
        "forms": [
            {
                "orange_id": "21162-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-40MG",
                    "12.5MG-80MG",
                    "25MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 2111,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND TELMISARTAN",
        "trade_name": "TELMISARTAN AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "203010-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-40MG",
                    "12.5MG-80MG",
                    "25MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 2112,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND TRIAMTERENE",
        "trade_name": "MAXZIDE",
        "forms": [
            {
                "orange_id": "19129-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG-75MG"
                ]
            }
        ]
    },
    {
        "id": 2113,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND TRIAMTERENE",
        "trade_name": "MAXZIDE-25",
        "forms": [
            {
                "orange_id": "19129-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-37.5MG"
                ]
            }
        ]
    },
    {
        "id": 2114,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND TRIAMTERENE",
        "trade_name": "TRIAMTERENE AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "208358-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG-37.5MG"
                ]
            },
            {
                "orange_id": "71251-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG-37.5MG",
                    "50MG-75MG"
                ]
            }
        ]
    },
    {
        "id": 2115,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND VALSARTAN",
        "trade_name": "DIOVAN HCT",
        "forms": [
            {
                "orange_id": "20818-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-80MG",
                    "12.5MG-160MG",
                    "12.5MG-320MG",
                    "25MG-160MG",
                    "25MG-320MG"
                ]
            }
        ]
    },
    {
        "id": 2116,
        "type": "RX",
        "ingredient": "HYDROCHLOROTHIAZIDE AND VALSARTAN",
        "trade_name": "VALSARTAN AND HYDROCHLOROTHIAZIDE",
        "forms": [
            {
                "orange_id": "201662-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG-80MG",
                    "12.5MG-160MG",
                    "12.5MG-320MG",
                    "25MG-160MG",
                    "25MG-320MG"
                ]
            }
        ]
    },
    {
        "id": 2117,
        "type": "RX",
        "ingredient": "HYDROCODONE BITARTRATE",
        "trade_name": "HYDROCODONE BITARTRATE",
        "forms": [
            {
                "orange_id": "206986-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG"
                ]
            },
            {
                "orange_id": "208269-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "30MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "100MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2118,
        "type": "RX",
        "ingredient": "HYDROCODONE BITARTRATE",
        "trade_name": "HYSINGLA ER",
        "forms": [
            {
                "orange_id": "206627-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "30MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "100MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2119,
        "type": "RX",
        "ingredient": "HYDROCODONE BITARTRATE AND IBUPROFEN",
        "trade_name": "HYDROCODONE",
        "forms": [
            {
                "orange_id": "77723-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 2120,
        "type": "RX",
        "ingredient": "HYDROCODONE BITARTRATE AND IBUPROFEN",
        "trade_name": "HYDROCODONE BITARTRATE AND IBUPROFEN",
        "forms": [
            {
                "orange_id": "76604-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7.5MG-200MG",
                    "5MG-200MG",
                    "10MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 2121,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "ALA-CORT",
        "forms": [
            {
                "orange_id": "80706-7",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%",
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2122,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "ALA-SCALP",
        "forms": [
            {
                "orange_id": "83231-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2123,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "ALKINDI SPRINKLE",
        "forms": [
            {
                "orange_id": "213876-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2124,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "ANUSOL HC",
        "forms": [
            {
                "orange_id": "88250-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            }
        ]
    },
    {
        "id": 2125,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "COLOCORT",
        "forms": [
            {
                "orange_id": "75172-1",
                "form": "ENEMA",
                "route": "RECTAL",
                "dosage": [
                    "100MG/60ML"
                ]
            }
        ]
    },
    {
        "id": 2126,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "CORTEF",
        "forms": [
            {
                "orange_id": "8697-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2127,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "CORTENEMA",
        "forms": [
            {
                "orange_id": "16199-1",
                "form": "ENEMA",
                "route": "RECTAL",
                "dosage": [
                    "100MG/60ML"
                ]
            }
        ]
    },
    {
        "id": 2128,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "HYDROCORTISONE",
        "forms": [
            {
                "orange_id": "87795-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%",
                    "2.5%"
                ]
            },
            {
                "orange_id": "40417-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            },
            {
                "orange_id": "80692-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "1%",
                    "2.5%"
                ]
            },
            {
                "orange_id": "40646-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2129,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "HYDROCORTISONE IN ABSORBASE",
        "forms": [
            {
                "orange_id": "88138-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2130,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "STIE-CORT",
        "forms": [
            {
                "orange_id": "89074-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            }
        ]
    },
    {
        "id": 2131,
        "type": "RX",
        "ingredient": "HYDROCORTISONE",
        "trade_name": "TEXACORT",
        "forms": [
            {
                "orange_id": "81271-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            }
        ]
    },
    {
        "id": 2132,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE",
        "trade_name": "CORTIFOAM",
        "forms": [
            {
                "orange_id": "17351-1",
                "form": "AEROSOL, METERED",
                "route": "RECTAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 2133,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE",
        "trade_name": "MICORT-HC",
        "forms": [
            {
                "orange_id": "40396-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            }
        ]
    },
    {
        "id": 2134,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE",
        "trade_name": "U-CORT",
        "forms": [
            {
                "orange_id": "89472-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2135,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE AND PRAMOXINE HYDROCHLORIDE",
        "trade_name": "EPIFOAM",
        "forms": [
            {
                "orange_id": "86457-1",
                "form": "AEROSOL, METERED",
                "route": "TOPICAL",
                "dosage": [
                    "1%-1%"
                ]
            }
        ]
    },
    {
        "id": 2136,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE AND PRAMOXINE HYDROCHLORIDE",
        "trade_name": "PRAMOSONE",
        "forms": [
            {
                "orange_id": "83778-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%-1%",
                    "1%-1%"
                ]
            },
            {
                "orange_id": "85980-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%-1%",
                    "2.5%-1%"
                ]
            }
        ]
    },
    {
        "id": 2137,
        "type": "RX",
        "ingredient": "HYDROCORTISONE ACETATE AND PRAMOXINE HYDROCHLORIDE",
        "trade_name": "PROCTOFOAM HC",
        "forms": [
            {
                "orange_id": "86195-1",
                "form": "AEROSOL, METERED",
                "route": "TOPICAL",
                "dosage": [
                    "1%-1%"
                ]
            }
        ]
    },
    {
        "id": 2138,
        "type": "RX",
        "ingredient": "HYDROCORTISONE BUTYRATE",
        "trade_name": "HYDROCORTISONE BUTYRATE",
        "forms": [
            {
                "orange_id": "205134-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "210209-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "76842-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "76364-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2139,
        "type": "RX",
        "ingredient": "HYDROCORTISONE BUTYRATE",
        "trade_name": "LOCOID",
        "forms": [
            {
                "orange_id": "18514-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "22076-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "18652-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "19116-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2140,
        "type": "RX",
        "ingredient": "HYDROCORTISONE BUTYRATE",
        "trade_name": "LOCOID LIPOCREAM",
        "forms": [
            {
                "orange_id": "20769-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2141,
        "type": "RX",
        "ingredient": "HYDROCORTISONE PROBUTATE",
        "trade_name": "PANDEL",
        "forms": [
            {
                "orange_id": "20453-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2142,
        "type": "RX",
        "ingredient": "HYDROCORTISONE SODIUM SUCCINATE",
        "trade_name": "SOLU-CORTEF",
        "forms": [
            {
                "orange_id": "9866-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 100MG BASE/VIAL",
                    "EQ 250MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2143,
        "type": "RX",
        "ingredient": "HYDROCORTISONE VALERATE",
        "trade_name": "HYDROCORTISONE VALERATE",
        "forms": [
            {
                "orange_id": "213724-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.2%"
                ]
            },
            {
                "orange_id": "211764-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.2%"
                ]
            }
        ]
    },
    {
        "id": 2144,
        "type": "RX",
        "ingredient": "HYDROCORTISONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "CASPORYN HC",
        "forms": [
            {
                "orange_id": "60613-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2145,
        "type": "RX",
        "ingredient": "HYDROCORTISONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATES AND HYDROCORTISONE",
        "forms": [
            {
                "orange_id": "64053-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            },
            {
                "orange_id": "62874-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            },
            {
                "orange_id": "65219-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2146,
        "type": "RX",
        "ingredient": "HYDROCORTISONE, NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "OTICAIR",
        "forms": [
            {
                "orange_id": "64065-1",
                "form": "SUSPENSION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "1%-EQ 3.5MG BASE/ML-10,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2147,
        "type": "RX",
        "ingredient": "HYDROMORPHONE HYDROCHLORIDE",
        "trade_name": "DILAUDID",
        "forms": [
            {
                "orange_id": "19034-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML",
                    "1MG/ML",
                    "2MG/ML"
                ]
            },
            {
                "orange_id": "19891-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "19892-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 2148,
        "type": "RX",
        "ingredient": "HYDROMORPHONE HYDROCHLORIDE",
        "trade_name": "HYDROMORPHONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78228-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "2MG/ML",
                    "1MG/ML",
                    "4MG/ML"
                ]
            },
            {
                "orange_id": "210176-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "212133-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MG",
                    "12MG",
                    "16MG",
                    "32MG"
                ]
            },
            {
                "orange_id": "210506-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 2149,
        "type": "RX",
        "ingredient": "HYDROXOCOBALAMIN",
        "trade_name": "CYANOKIT",
        "forms": [
            {
                "orange_id": "22041-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/VIAL (5GM/KIT)"
                ]
            }
        ]
    },
    {
        "id": 2150,
        "type": "RX",
        "ingredient": "HYDROXOCOBALAMIN",
        "trade_name": "HYDROXOCOBALAMIN",
        "forms": [
            {
                "orange_id": "85998-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2151,
        "type": "RX",
        "ingredient": "HYDROXYAMPHETAMINE HYDROBROMIDE AND TROPICAMIDE",
        "trade_name": "PAREMYD",
        "forms": [
            {
                "orange_id": "19261-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%-0.25%"
                ]
            }
        ]
    },
    {
        "id": 2152,
        "type": "RX",
        "ingredient": "HYDROXYCHLOROQUINE SULFATE",
        "trade_name": "HYDROXYCHLOROQUINE SULFATE",
        "forms": [
            {
                "orange_id": "213342-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2153,
        "type": "RX",
        "ingredient": "HYDROXYCHLOROQUINE SULFATE",
        "trade_name": "PLAQUENIL",
        "forms": [
            {
                "orange_id": "9768-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2154,
        "type": "RX",
        "ingredient": "HYDROXYPROGESTERONE CAPROATE",
        "trade_name": "HYDROXYPROGESTERONE CAPROATE",
        "forms": [
            {
                "orange_id": "210723-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "250MG/ML (250MG/ML)",
                    "1250MG/5ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2155,
        "type": "RX",
        "ingredient": "HYDROXYPROGESTERONE CAPROATE",
        "trade_name": "MAKENA",
        "forms": [
            {
                "orange_id": "21945-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "1250MG/5ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2156,
        "type": "RX",
        "ingredient": "HYDROXYPROGESTERONE CAPROATE",
        "trade_name": "MAKENA (AUTOINJECTOR)",
        "forms": [
            {
                "orange_id": "21945-4",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "275MG/1.1ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2157,
        "type": "RX",
        "ingredient": "HYDROXYPROGESTERONE CAPROATE",
        "trade_name": "MAKENA PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "21945-2",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "250MG/ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2158,
        "type": "RX",
        "ingredient": "HYDROXYPROPYL CELLULOSE",
        "trade_name": "LACRISERT",
        "forms": [
            {
                "orange_id": "18771-1",
                "form": "INSERT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2159,
        "type": "RX",
        "ingredient": "HYDROXYUREA",
        "trade_name": "DROXIA",
        "forms": [
            {
                "orange_id": "16295-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2160,
        "type": "RX",
        "ingredient": "HYDROXYUREA",
        "trade_name": "HYDREA",
        "forms": [
            {
                "orange_id": "16295-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2161,
        "type": "RX",
        "ingredient": "HYDROXYUREA",
        "trade_name": "HYDROXYUREA",
        "forms": [
            {
                "orange_id": "75143-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2162,
        "type": "RX",
        "ingredient": "HYDROXYUREA",
        "trade_name": "SIKLOS",
        "forms": [
            {
                "orange_id": "208843-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2163,
        "type": "RX",
        "ingredient": "HYDROXYZINE HYDROCHLORIDE",
        "trade_name": "HYDROXYZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "87408-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML",
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "40010-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML"
                ]
            },
            {
                "orange_id": "40808-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2164,
        "type": "RX",
        "ingredient": "HYDROXYZINE PAMOATE",
        "trade_name": "HYDROXYZINE PAMOATE",
        "forms": [
            {
                "orange_id": "88496-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG HYDROCHLORIDE",
                    "EQ 50MG HYDROCHLORIDE",
                    "EQ 100MG HYDROCHLORIDE"
                ]
            }
        ]
    },
    {
        "id": 2165,
        "type": "RX",
        "ingredient": "HYDROXYZINE PAMOATE",
        "trade_name": "VISTARIL",
        "forms": [
            {
                "orange_id": "11459-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG HYDROCHLORIDE",
                    "EQ 50MG HYDROCHLORIDE"
                ]
            }
        ]
    },
    {
        "id": 2166,
        "type": "RX",
        "ingredient": "IBANDRONATE SODIUM",
        "trade_name": "IBANDRONATE SODIUM",
        "forms": [
            {
                "orange_id": "206058-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 3MG BASE/3ML"
                ]
            },
            {
                "orange_id": "78948-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2167,
        "type": "RX",
        "ingredient": "IBREXAFUNGERP CITRATE",
        "trade_name": "BREXAFEMME",
        "forms": [
            {
                "orange_id": "214900-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2168,
        "type": "RX",
        "ingredient": "IBRUTINIB",
        "trade_name": "IMBRUVICA",
        "forms": [
            {
                "orange_id": "205552-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "70MG",
                    "140MG"
                ]
            },
            {
                "orange_id": "210563-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "140MG",
                    "280MG",
                    "420MG",
                    "560MG"
                ]
            }
        ]
    },
    {
        "id": 2169,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "ADVIL",
        "forms": [
            {
                "orange_id": "18989-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2170,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "ADVIL LIQUI-GELS",
        "forms": [
            {
                "orange_id": "20402-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG FREE ACID AND POTASSIUM SALT"
                ]
            }
        ]
    },
    {
        "id": 2171,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "ADVIL MIGRAINE LIQUI-GELS",
        "forms": [
            {
                "orange_id": "20402-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG FREE ACID AND POTASSIUM SALT"
                ]
            }
        ]
    },
    {
        "id": 2172,
        "type": "RX",
        "ingredient": "IBUPROFEN",
        "trade_name": "CALDOLOR",
        "forms": [
            {
                "orange_id": "22348-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "800MG/8ML (100MG/ML)",
                    "800MG/200ML (4MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2173,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "CHILDREN'S ADVIL",
        "forms": [
            {
                "orange_id": "20589-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "20944-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2174,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "CHILDREN'S ADVIL-FLAVORED",
        "forms": [
            {
                "orange_id": "20589-2",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2175,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "CHILDREN'S IBUPROFEN",
        "forms": [
            {
                "orange_id": "74937-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2176,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "CHILDREN'S MOTRIN",
        "forms": [
            {
                "orange_id": "20603-1",
                "form": "SUSPENSION/DROPS",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "20516-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2177,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "IBUPROFEN",
        "forms": [
            {
                "orange_id": "202300-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG FREE ACID AND POTASSIUM SALT"
                ]
            },
            {
                "orange_id": "210755-1",
                "form": "SUSPENSION/DROPS",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "74978-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "76359-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "214699-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "600MG",
                    "800MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2178,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "INFANT'S ADVIL",
        "forms": [
            {
                "orange_id": "20812-2",
                "form": "SUSPENSION/DROPS",
                "route": "ORAL",
                "dosage": [
                    "50MG/1.25ML"
                ]
            }
        ]
    },
    {
        "id": 2179,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "JUNIOR STRENGTH ADVIL",
        "forms": [
            {
                "orange_id": "20944-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "20267-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2180,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "JUNIOR STRENGTH IBUPROFEN",
        "forms": [
            {
                "orange_id": "75367-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2181,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "JUNIOR STRENGTH MOTRIN",
        "forms": [
            {
                "orange_id": "20602-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2182,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "MIDOL LIQUID GELS",
        "forms": [
            {
                "orange_id": "21472-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2183,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "MOTRIN IB",
        "forms": [
            {
                "orange_id": "19012-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2184,
        "type": "OTC",
        "ingredient": "IBUPROFEN",
        "trade_name": "TAB-PROFEN",
        "forms": [
            {
                "orange_id": "72095-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2185,
        "type": "RX",
        "ingredient": "IBUPROFEN LYSINE",
        "trade_name": "IBUPROFEN LYSINE",
        "forms": [
            {
                "orange_id": "202402-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 20MG BASE/2ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2186,
        "type": "RX",
        "ingredient": "IBUPROFEN LYSINE",
        "trade_name": "NEOPROFEN",
        "forms": [
            {
                "orange_id": "21903-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 20MG BASE/2ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2187,
        "type": "OTC",
        "ingredient": "IBUPROFEN SODIUM",
        "trade_name": "ADVIL",
        "forms": [
            {
                "orange_id": "201803-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2188,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "ADVIL CONGESTION RELIEF",
        "forms": [
            {
                "orange_id": "22565-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 2189,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "IBUPROFEN AND PHENYLEPHRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "203200-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-10MG"
                ]
            }
        ]
    },
    {
        "id": 2190,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "ADVIL COLD AND SINUS",
        "forms": [
            {
                "orange_id": "21374-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG FREE ACID AND POTASSIUM SALT-30MG"
                ]
            },
            {
                "orange_id": "19771-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2191,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S ADVIL COLD",
        "forms": [
            {
                "orange_id": "21373-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML-15MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2192,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "CHILDREN'S MOTRIN COLD",
        "forms": [
            {
                "orange_id": "21128-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML-15MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2193,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "209235-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG FREE ACID AND POTASSIUM SALT-30MG"
                ]
            },
            {
                "orange_id": "76478-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML-15MG/5ML"
                ]
            },
            {
                "orange_id": "77628-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2194,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "IBUPROHM COLD AND SINUS",
        "forms": [
            {
                "orange_id": "74567-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2195,
        "type": "OTC",
        "ingredient": "IBUPROFEN AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "SINE-AID IB",
        "forms": [
            {
                "orange_id": "19899-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-30MG"
                ]
            }
        ]
    },
    {
        "id": 2196,
        "type": "RX",
        "ingredient": "IBUTILIDE FUMARATE",
        "trade_name": "CORVERT",
        "forms": [
            {
                "orange_id": "20491-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2197,
        "type": "RX",
        "ingredient": "IBUTILIDE FUMARATE",
        "trade_name": "IBUTILIDE FUMARATE",
        "forms": [
            {
                "orange_id": "90643-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2198,
        "type": "RX",
        "ingredient": "ICATIBANT ACETATE",
        "trade_name": "FIRAZYR",
        "forms": [
            {
                "orange_id": "22150-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 30MG BASE/3ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2199,
        "type": "RX",
        "ingredient": "ICATIBANT ACETATE",
        "trade_name": "ICATIBANT ACETATE",
        "forms": [
            {
                "orange_id": "212446-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 30MG BASE/3ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2200,
        "type": "RX",
        "ingredient": "ICODEXTRIN",
        "trade_name": "EXTRANEAL",
        "forms": [
            {
                "orange_id": "21321-1",
                "form": "SOLUTION",
                "route": "INTRAPERITONEAL",
                "dosage": [
                    "7.5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2201,
        "type": "RX",
        "ingredient": "ICOSAPENT ETHYL",
        "trade_name": "ICOSAPENT ETHYL",
        "forms": [
            {
                "orange_id": "209437-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2202,
        "type": "RX",
        "ingredient": "ICOSAPENT ETHYL",
        "trade_name": "VASCEPA",
        "forms": [
            {
                "orange_id": "202057-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2203,
        "type": "RX",
        "ingredient": "IDARUBICIN HYDROCHLORIDE",
        "trade_name": "IDAMYCIN PFS",
        "forms": [
            {
                "orange_id": "50734-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2204,
        "type": "RX",
        "ingredient": "IDARUBICIN HYDROCHLORIDE",
        "trade_name": "IDARUBICIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65275-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2205,
        "type": "RX",
        "ingredient": "IDARUBICIN HYDROCHLORIDE",
        "trade_name": "IDARUBICIN HYDROCHLORIDE PFS",
        "forms": [
            {
                "orange_id": "65036-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2206,
        "type": "RX",
        "ingredient": "IDELALISIB",
        "trade_name": "ZYDELIG",
        "forms": [
            {
                "orange_id": "205858-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2207,
        "type": "RX",
        "ingredient": "IFOSFAMIDE",
        "trade_name": "IFEX",
        "forms": [
            {
                "orange_id": "19763-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "3GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2208,
        "type": "RX",
        "ingredient": "IFOSFAMIDE",
        "trade_name": "IFOSFAMIDE",
        "forms": [
            {
                "orange_id": "76078-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "3GM/VIAL",
                    "1GM/20ML (50MG/ML)",
                    "3GM/60ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2209,
        "type": "RX",
        "ingredient": "ILOPERIDONE",
        "trade_name": "FANAPT",
        "forms": [
            {
                "orange_id": "22192-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "4MG",
                    "6MG",
                    "8MG",
                    "10MG",
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 2210,
        "type": "RX",
        "ingredient": "ILOPROST",
        "trade_name": "VENTAVIS",
        "forms": [
            {
                "orange_id": "21779-2",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "10MCG/ML (10MCG/ML)",
                    "20MCG/ML (20MCG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2211,
        "type": "RX",
        "ingredient": "IMATINIB MESYLATE",
        "trade_name": "GLEEVEC",
        "forms": [
            {
                "orange_id": "21588-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2212,
        "type": "RX",
        "ingredient": "IMATINIB MESYLATE",
        "trade_name": "IMATINIB MESYLATE",
        "forms": [
            {
                "orange_id": "79179-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2213,
        "type": "RX",
        "ingredient": "IMIPRAMINE HYDROCHLORIDE",
        "trade_name": "IMIPRAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40903-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2214,
        "type": "RX",
        "ingredient": "IMIPRAMINE HYDROCHLORIDE",
        "trade_name": "TOFRANIL",
        "forms": [
            {
                "orange_id": "87846-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2215,
        "type": "RX",
        "ingredient": "IMIPRAMINE PAMOATE",
        "trade_name": "IMIPRAMINE PAMOATE",
        "forms": [
            {
                "orange_id": "91099-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG HYDROCHLORIDE",
                    "EQ 100MG HYDROCHLORIDE",
                    "EQ 125MG HYDROCHLORIDE",
                    "EQ 150MG HYDROCHLORIDE"
                ]
            }
        ]
    },
    {
        "id": 2216,
        "type": "RX",
        "ingredient": "IMIQUIMOD",
        "trade_name": "ALDARA",
        "forms": [
            {
                "orange_id": "20723-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2217,
        "type": "RX",
        "ingredient": "IMIQUIMOD",
        "trade_name": "IMIQUIMOD",
        "forms": [
            {
                "orange_id": "91308-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%",
                    "3.75%"
                ]
            }
        ]
    },
    {
        "id": 2218,
        "type": "RX",
        "ingredient": "IMIQUIMOD",
        "trade_name": "ZYCLARA",
        "forms": [
            {
                "orange_id": "22483-2",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%",
                    "3.75%"
                ]
            }
        ]
    },
    {
        "id": 2219,
        "type": "RX",
        "ingredient": "INAMRINONE LACTATE",
        "trade_name": "AMRINONE LACTATE",
        "forms": [
            {
                "orange_id": "75513-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2220,
        "type": "RX",
        "ingredient": "INCLISIRAN SODIUM",
        "trade_name": "LEQVIO",
        "forms": [
            {
                "orange_id": "214012-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 284MG BASE/1.5ML (EQ 189MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2221,
        "type": "RX",
        "ingredient": "INDAPAMIDE",
        "trade_name": "INDAPAMIDE",
        "forms": [
            {
                "orange_id": "74722-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.25MG",
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 2222,
        "type": "RX",
        "ingredient": "INDIUM IN-111 CHLORIDE",
        "trade_name": "INDIUM IN 111 CHLORIDE",
        "forms": [
            {
                "orange_id": "19841-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5mCi/0.5ML"
                ]
            }
        ]
    },
    {
        "id": 2223,
        "type": "RX",
        "ingredient": "INDIUM IN-111 OXYQUINOLINE",
        "trade_name": "INDIUM IN 111 OXYQUINOLINE",
        "forms": [
            {
                "orange_id": "202586-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2224,
        "type": "RX",
        "ingredient": "INDIUM IN-111 PENTETATE DISODIUM",
        "trade_name": "MPI INDIUM DTPA IN 111",
        "forms": [
            {
                "orange_id": "17707-1",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "1mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2225,
        "type": "RX",
        "ingredient": "INDIUM IN-111 PENTETREOTIDE KIT",
        "trade_name": "OCTREOSCAN",
        "forms": [
            {
                "orange_id": "20314-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2226,
        "type": "RX",
        "ingredient": "INDOCYANINE GREEN",
        "trade_name": "IC-GREEN",
        "forms": [
            {
                "orange_id": "11525-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2227,
        "type": "RX",
        "ingredient": "INDOCYANINE GREEN",
        "trade_name": "INDOCYANINE GREEN",
        "forms": [
            {
                "orange_id": "40811-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2228,
        "type": "RX",
        "ingredient": "INDOCYANINE GREEN",
        "trade_name": "SPY AGENT GREEN KIT",
        "forms": [
            {
                "orange_id": "211580-1",
                "form": "POWDER",
                "route": "INTRAVENOUS, INTERSTITIAL",
                "dosage": [
                    "25MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2229,
        "type": "RX",
        "ingredient": "INDOMETHACIN",
        "trade_name": "INDOCIN",
        "forms": [
            {
                "orange_id": "18332-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2230,
        "type": "RX",
        "ingredient": "INDOMETHACIN",
        "trade_name": "INDOMETHACIN",
        "forms": [
            {
                "orange_id": "91549-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            },
            {
                "orange_id": "90403-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            },
            {
                "orange_id": "22536-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "73314-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2231,
        "type": "RX",
        "ingredient": "INDOMETHACIN SODIUM",
        "trade_name": "INDOMETHACIN SODIUM",
        "forms": [
            {
                "orange_id": "204118-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2232,
        "type": "RX",
        "ingredient": "INFIGRATINIB PHOSPHATE",
        "trade_name": "TRUSELTIQ",
        "forms": [
            {
                "orange_id": "214622-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2233,
        "type": "RX",
        "ingredient": "INOTERSEN SODIUM",
        "trade_name": "TEGSEDI",
        "forms": [
            {
                "orange_id": "211172-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 284MG BASE/1.5ML (EQ 189.3MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2234,
        "type": "RX",
        "ingredient": "IOBENGUANE I-131",
        "trade_name": "AZEDRA",
        "forms": [
            {
                "orange_id": "209607-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "15mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2235,
        "type": "RX",
        "ingredient": "IOBENGUANE SULFATE I-123",
        "trade_name": "ADREVIEW",
        "forms": [
            {
                "orange_id": "22290-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10mCi/5ML (2mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 2236,
        "type": "OTC",
        "ingredient": "IODINE POVACRYLEX AND ISOPROPYL ALCOHOL",
        "trade_name": "DURAPREP",
        "forms": [
            {
                "orange_id": "21586-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.7% IODINE-74% (6ML)",
                    "EQ 0.7% IODINE-74% (26ML)"
                ]
            }
        ]
    },
    {
        "id": 2237,
        "type": "RX",
        "ingredient": "IODIXANOL",
        "trade_name": "VISIPAQUE 270",
        "forms": [
            {
                "orange_id": "20351-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "55%"
                ]
            }
        ]
    },
    {
        "id": 2238,
        "type": "RX",
        "ingredient": "IODIXANOL",
        "trade_name": "VISIPAQUE 320",
        "forms": [
            {
                "orange_id": "20351-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "65.2%"
                ]
            }
        ]
    },
    {
        "id": 2239,
        "type": "RX",
        "ingredient": "IOFLUPANE I-123",
        "trade_name": "DATSCAN",
        "forms": [
            {
                "orange_id": "22454-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5mCi/2.5ML (2mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 2240,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 12",
        "forms": [
            {
                "orange_id": "18956-9",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2.6%"
                ]
            }
        ]
    },
    {
        "id": 2241,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 140",
        "forms": [
            {
                "orange_id": "18956-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30.2%"
                ]
            }
        ]
    },
    {
        "id": 2242,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 180",
        "forms": [
            {
                "orange_id": "18956-1",
                "form": "SOLUTION",
                "route": "INJECTION, ORAL, RECTAL",
                "dosage": [
                    "38.8%"
                ]
            }
        ]
    },
    {
        "id": 2243,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 240",
        "forms": [
            {
                "orange_id": "18956-2",
                "form": "SOLUTION",
                "route": "INJECTION, ORAL, RECTAL",
                "dosage": [
                    "51.8%"
                ]
            }
        ]
    },
    {
        "id": 2244,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 300",
        "forms": [
            {
                "orange_id": "18956-3",
                "form": "SOLUTION",
                "route": "INJECTION, ORAL, RECTAL",
                "dosage": [
                    "64.7%"
                ]
            }
        ]
    },
    {
        "id": 2245,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 350",
        "forms": [
            {
                "orange_id": "18956-4",
                "form": "SOLUTION",
                "route": "INJECTION, ORAL",
                "dosage": [
                    "75.5%"
                ]
            }
        ]
    },
    {
        "id": 2246,
        "type": "RX",
        "ingredient": "IOHEXOL",
        "trade_name": "OMNIPAQUE 9",
        "forms": [
            {
                "orange_id": "18956-8",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1.9%"
                ]
            }
        ]
    },
    {
        "id": 2247,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-200",
        "forms": [
            {
                "orange_id": "18735-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "41%"
                ]
            }
        ]
    },
    {
        "id": 2248,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-250",
        "forms": [
            {
                "orange_id": "18735-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "51%"
                ]
            }
        ]
    },
    {
        "id": 2249,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-300",
        "forms": [
            {
                "orange_id": "18735-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "61%"
                ]
            }
        ]
    },
    {
        "id": 2250,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-370",
        "forms": [
            {
                "orange_id": "18735-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "76%"
                ]
            }
        ]
    },
    {
        "id": 2251,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-M 200",
        "forms": [
            {
                "orange_id": "18735-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "41%"
                ]
            }
        ]
    },
    {
        "id": 2252,
        "type": "RX",
        "ingredient": "IOPAMIDOL",
        "trade_name": "ISOVUE-M 300",
        "forms": [
            {
                "orange_id": "18735-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "61%"
                ]
            }
        ]
    },
    {
        "id": 2253,
        "type": "RX",
        "ingredient": "IOPROMIDE",
        "trade_name": "ULTRAVIST (PHARMACY BULK)",
        "forms": [
            {
                "orange_id": "21425-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "62.3%",
                    "76.9%"
                ]
            }
        ]
    },
    {
        "id": 2254,
        "type": "RX",
        "ingredient": "IOPROMIDE",
        "trade_name": "ULTRAVIST 300",
        "forms": [
            {
                "orange_id": "20220-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "62.3%"
                ]
            }
        ]
    },
    {
        "id": 2255,
        "type": "RX",
        "ingredient": "IOPROMIDE",
        "trade_name": "ULTRAVIST 370",
        "forms": [
            {
                "orange_id": "20220-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "76.9%"
                ]
            }
        ]
    },
    {
        "id": 2256,
        "type": "RX",
        "ingredient": "IOTHALAMATE MEGLUMINE",
        "trade_name": "CONRAY",
        "forms": [
            {
                "orange_id": "13295-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "60%"
                ]
            }
        ]
    },
    {
        "id": 2257,
        "type": "RX",
        "ingredient": "IOTHALAMATE MEGLUMINE",
        "trade_name": "CYSTO-CONRAY II",
        "forms": [
            {
                "orange_id": "17057-2",
                "form": "SOLUTION",
                "route": "INTRAVESICAL",
                "dosage": [
                    "17.2%"
                ]
            }
        ]
    },
    {
        "id": 2258,
        "type": "RX",
        "ingredient": "IOTHALAMATE SODIUM I-125",
        "trade_name": "GLOFIL-125",
        "forms": [
            {
                "orange_id": "17279-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "250-300uCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2259,
        "type": "RX",
        "ingredient": "IOVERSOL",
        "trade_name": "OPTIRAY 300",
        "forms": [
            {
                "orange_id": "19710-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "64%"
                ]
            }
        ]
    },
    {
        "id": 2260,
        "type": "RX",
        "ingredient": "IOVERSOL",
        "trade_name": "OPTIRAY 320",
        "forms": [
            {
                "orange_id": "19710-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "68%"
                ]
            }
        ]
    },
    {
        "id": 2261,
        "type": "RX",
        "ingredient": "IOVERSOL",
        "trade_name": "OPTIRAY 350",
        "forms": [
            {
                "orange_id": "19710-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "74%"
                ]
            }
        ]
    },
    {
        "id": 2262,
        "type": "RX",
        "ingredient": "IPRATROPIUM BROMIDE",
        "trade_name": "ATROVENT HFA",
        "forms": [
            {
                "orange_id": "21527-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.021MG/INH"
                ]
            }
        ]
    },
    {
        "id": 2263,
        "type": "RX",
        "ingredient": "IPRATROPIUM BROMIDE",
        "trade_name": "IPRATROPIUM BROMIDE",
        "forms": [
            {
                "orange_id": "206543-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "0.02%"
                ]
            },
            {
                "orange_id": "76156-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.021MG/SPRAY",
                    "0.042MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2264,
        "type": "RX",
        "ingredient": "IRBESARTAN",
        "trade_name": "AVAPRO",
        "forms": [
            {
                "orange_id": "20757-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2265,
        "type": "RX",
        "ingredient": "IRBESARTAN",
        "trade_name": "IRBESARTAN",
        "forms": [
            {
                "orange_id": "91236-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2266,
        "type": "RX",
        "ingredient": "IRINOTECAN HYDROCHLORIDE",
        "trade_name": "CAMPTOSAR",
        "forms": [
            {
                "orange_id": "20571-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/2ML (20MG/ML)",
                    "100MG/5ML (20MG/ML)",
                    "300MG/15ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2267,
        "type": "RX",
        "ingredient": "IRINOTECAN HYDROCHLORIDE",
        "trade_name": "IRINOTECAN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79068-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/2ML (20MG/ML)",
                    "100MG/5ML (20MG/ML)",
                    "500MG/25ML (20MG/ML)",
                    "300MG/15ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2268,
        "type": "RX",
        "ingredient": "IRINOTECAN HYDROCHLORIDE",
        "trade_name": "ONIVYDE",
        "forms": [
            {
                "orange_id": "207793-1",
                "form": "INJECTABLE, LIPOSOMAL",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 43MG BASE/10ML (EQ 4.3MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2269,
        "type": "RX",
        "ingredient": "ISAVUCONAZONIUM SULFATE",
        "trade_name": "CRESEMBA",
        "forms": [
            {
                "orange_id": "207500-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "186MG"
                ]
            },
            {
                "orange_id": "207501-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "372MG"
                ]
            }
        ]
    },
    {
        "id": 2270,
        "type": "RX",
        "ingredient": "ISOCARBOXAZID",
        "trade_name": "MARPLAN",
        "forms": [
            {
                "orange_id": "11961-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2271,
        "type": "RX",
        "ingredient": "ISOFLURANE",
        "trade_name": "FORANE",
        "forms": [
            {
                "orange_id": "17624-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "99.9%"
                ]
            }
        ]
    },
    {
        "id": 2272,
        "type": "RX",
        "ingredient": "ISOFLURANE",
        "trade_name": "ISOFLURANE",
        "forms": [
            {
                "orange_id": "75225-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "99.9%"
                ]
            }
        ]
    },
    {
        "id": 2273,
        "type": "RX",
        "ingredient": "ISONIAZID",
        "trade_name": "ISONIAZID",
        "forms": [
            {
                "orange_id": "40648-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "88235-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "40090-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2274,
        "type": "RX",
        "ingredient": "ISOPROTERENOL HYDROCHLORIDE",
        "trade_name": "ISOPROTERENOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210576-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2275,
        "type": "RX",
        "ingredient": "ISOPROTERENOL HYDROCHLORIDE",
        "trade_name": "ISUPREL",
        "forms": [
            {
                "orange_id": "10515-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2276,
        "type": "RX",
        "ingredient": "ISOSORBIDE DINITRATE",
        "trade_name": "ISORDIL",
        "forms": [
            {
                "orange_id": "12093-7",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2277,
        "type": "RX",
        "ingredient": "ISOSORBIDE DINITRATE",
        "trade_name": "ISOSORBIDE DINITRATE",
        "forms": [
            {
                "orange_id": "40009-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            },
            {
                "orange_id": "86067-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2278,
        "type": "RX",
        "ingredient": "ISOSORBIDE MONONITRATE",
        "trade_name": "ISOSORBIDE MONONITRATE",
        "forms": [
            {
                "orange_id": "75522-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "120MG"
                ]
            },
            {
                "orange_id": "75037-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2279,
        "type": "RX",
        "ingredient": "ISOSORBIDE MONONITRATE",
        "trade_name": "MONOKET",
        "forms": [
            {
                "orange_id": "20215-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2280,
        "type": "RX",
        "ingredient": "ISOSULFAN BLUE",
        "trade_name": "ISOSULFAN BLUE",
        "forms": [
            {
                "orange_id": "206831-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2281,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "ABSORICA",
        "forms": [
            {
                "orange_id": "21951-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "25MG",
                    "30MG",
                    "35MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2282,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "ABSORICA LD",
        "forms": [
            {
                "orange_id": "211913-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "8MG",
                    "16MG",
                    "24MG",
                    "32MG"
                ]
            }
        ]
    },
    {
        "id": 2283,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "AMNESTEEM",
        "forms": [
            {
                "orange_id": "75945-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2284,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "CLARAVIS",
        "forms": [
            {
                "orange_id": "76356-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2285,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "ISOTRETINOIN",
        "forms": [
            {
                "orange_id": "205063-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "25MG",
                    "30MG",
                    "35MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2286,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "MYORISAN",
        "forms": [
            {
                "orange_id": "76485-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2287,
        "type": "RX",
        "ingredient": "ISOTRETINOIN",
        "trade_name": "ZENATANE",
        "forms": [
            {
                "orange_id": "202099-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2288,
        "type": "RX",
        "ingredient": "ISRADIPINE",
        "trade_name": "ISRADIPINE",
        "forms": [
            {
                "orange_id": "77169-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2289,
        "type": "RX",
        "ingredient": "ISTRADEFYLLINE",
        "trade_name": "NOURIANZ",
        "forms": [
            {
                "orange_id": "22075-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2290,
        "type": "RX",
        "ingredient": "ITRACONAZOLE",
        "trade_name": "ITRACONAZOLE",
        "forms": [
            {
                "orange_id": "205991-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "205573-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2291,
        "type": "RX",
        "ingredient": "ITRACONAZOLE",
        "trade_name": "SPORANOX",
        "forms": [
            {
                "orange_id": "20083-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "20657-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2292,
        "type": "RX",
        "ingredient": "ITRACONAZOLE",
        "trade_name": "TOLSURA",
        "forms": [
            {
                "orange_id": "208901-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "65MG"
                ]
            }
        ]
    },
    {
        "id": 2293,
        "type": "RX",
        "ingredient": "IVABRADINE",
        "trade_name": "CORLANOR",
        "forms": [
            {
                "orange_id": "209964-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2294,
        "type": "RX",
        "ingredient": "IVABRADINE HYDROCHLORIDE",
        "trade_name": "CORLANOR",
        "forms": [
            {
                "orange_id": "206143-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 7.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2295,
        "type": "RX",
        "ingredient": "IVACAFTOR",
        "trade_name": "KALYDECO",
        "forms": [
            {
                "orange_id": "207925-3",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "25MG/PACKET",
                    "50MG/PACKET",
                    "75MG/PACKET"
                ]
            },
            {
                "orange_id": "203188-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2296,
        "type": "RX",
        "ingredient": "IVACAFTOR AND IVACAFTOR, TEZACAFTOR",
        "trade_name": "SYMDEKO (COPACKAGED)",
        "forms": [
            {
                "orange_id": "210491-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG-75MG, 50MG",
                    "150MG-150MG, 100MG"
                ]
            }
        ]
    },
    {
        "id": 2297,
        "type": "RX",
        "ingredient": "IVACAFTOR AND LUMACAFTOR",
        "trade_name": "ORKAMBI",
        "forms": [
            {
                "orange_id": "211358-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "125MG/PACKET-100MG/PACKET",
                    "188MG/PACKET-150MG/PACKET"
                ]
            },
            {
                "orange_id": "206038-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "125MG-100MG",
                    "125MG-200MG"
                ]
            }
        ]
    },
    {
        "id": 2298,
        "type": "RX",
        "ingredient": "IVERMECTIN",
        "trade_name": "IVERMECTIN",
        "forms": [
            {
                "orange_id": "210019-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "210720-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "204154-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2299,
        "type": "OTC",
        "ingredient": "IVERMECTIN",
        "trade_name": "SKLICE",
        "forms": [
            {
                "orange_id": "202736-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2300,
        "type": "RX",
        "ingredient": "IVERMECTIN",
        "trade_name": "SOOLANTRA",
        "forms": [
            {
                "orange_id": "206255-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2301,
        "type": "RX",
        "ingredient": "IVERMECTIN",
        "trade_name": "STROMECTOL",
        "forms": [
            {
                "orange_id": "50742-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2302,
        "type": "RX",
        "ingredient": "IVOSIDENIB",
        "trade_name": "TIBSOVO",
        "forms": [
            {
                "orange_id": "211192-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2303,
        "type": "RX",
        "ingredient": "IXABEPILONE",
        "trade_name": "IXEMPRA KIT",
        "forms": [
            {
                "orange_id": "22065-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "15MG/VIAL",
                    "45MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2304,
        "type": "RX",
        "ingredient": "IXAZOMIB CITRATE",
        "trade_name": "NINLARO",
        "forms": [
            {
                "orange_id": "208462-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.3MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2305,
        "type": "RX",
        "ingredient": "KETAMINE HYDROCHLORIDE",
        "trade_name": "KETALAR",
        "forms": [
            {
                "orange_id": "16812-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML",
                    "EQ 50MG BASE/ML",
                    "EQ 100MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2306,
        "type": "RX",
        "ingredient": "KETAMINE HYDROCHLORIDE",
        "trade_name": "KETAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76092-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML",
                    "EQ 50MG BASE/ML",
                    "EQ 100MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2307,
        "type": "RX",
        "ingredient": "KETOCONAZOLE",
        "trade_name": "EXTINA",
        "forms": [
            {
                "orange_id": "21738-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2308,
        "type": "RX",
        "ingredient": "KETOCONAZOLE",
        "trade_name": "KETOCONAZOLE",
        "forms": [
            {
                "orange_id": "91550-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "212443-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "76419-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "75912-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2309,
        "type": "RX",
        "ingredient": "KETOCONAZOLE",
        "trade_name": "KETOZOLE",
        "forms": [
            {
                "orange_id": "75638-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2310,
        "type": "OTC",
        "ingredient": "KETOCONAZOLE",
        "trade_name": "NIZORAL ANTI-DANDRUFF",
        "forms": [
            {
                "orange_id": "20310-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2311,
        "type": "RX",
        "ingredient": "KETOCONAZOLE",
        "trade_name": "XOLEGEL",
        "forms": [
            {
                "orange_id": "21946-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2312,
        "type": "RX",
        "ingredient": "KETOPROFEN",
        "trade_name": "KETOPROFEN",
        "forms": [
            {
                "orange_id": "75679-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            },
            {
                "orange_id": "74014-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 2313,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE",
        "trade_name": "ACULAR",
        "forms": [
            {
                "orange_id": "19700-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2314,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE",
        "trade_name": "ACULAR LS",
        "forms": [
            {
                "orange_id": "21528-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.4%"
                ]
            }
        ]
    },
    {
        "id": 2315,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE",
        "trade_name": "ACUVAIL",
        "forms": [
            {
                "orange_id": "22427-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.45%"
                ]
            }
        ]
    },
    {
        "id": 2316,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE",
        "trade_name": "KETOROLAC TROMETHAMINE",
        "forms": [
            {
                "orange_id": "209900-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15MG/ML",
                    "30MG/ML"
                ]
            },
            {
                "orange_id": "78399-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.4%",
                    "0.5%"
                ]
            },
            {
                "orange_id": "210616-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2317,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE",
        "trade_name": "SPRIX",
        "forms": [
            {
                "orange_id": "22382-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "15.75MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2318,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "KETOROLAC TROMETHAMINE AND PHENYLEPHRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210183-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "EQ 0.3% BASE-EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 2319,
        "type": "RX",
        "ingredient": "KETOROLAC TROMETHAMINE AND PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "OMIDRIA",
        "forms": [
            {
                "orange_id": "205388-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "EQ 0.3% BASE-EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 2320,
        "type": "OTC",
        "ingredient": "KETOTIFEN FUMARATE",
        "trade_name": "ALAWAY",
        "forms": [
            {
                "orange_id": "208158-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.035% BASE",
                    "EQ 0.025% BASE"
                ]
            }
        ]
    },
    {
        "id": 2321,
        "type": "OTC",
        "ingredient": "KETOTIFEN FUMARATE",
        "trade_name": "KETOTIFEN FUMARATE",
        "forms": [
            {
                "orange_id": "77958-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.025% BASE"
                ]
            }
        ]
    },
    {
        "id": 2322,
        "type": "OTC",
        "ingredient": "KETOTIFEN FUMARATE",
        "trade_name": "ZADITOR",
        "forms": [
            {
                "orange_id": "77200-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.025% BASE"
                ]
            }
        ]
    },
    {
        "id": 2323,
        "type": "RX",
        "ingredient": "LABETALOL HYDROCHLORIDE",
        "trade_name": "LABETALOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75431-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "209603-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2324,
        "type": "RX",
        "ingredient": "LABETALOL HYDROCHLORIDE",
        "trade_name": "LABETALOL HYDROCHLORIDE IN DEXTROSE",
        "forms": [
            {
                "orange_id": "213330-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/200ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2325,
        "type": "RX",
        "ingredient": "LABETALOL HYDROCHLORIDE",
        "trade_name": "LABETALOL HYDROCHLORIDE IN SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "213330-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/100ML (1MG/ML)",
                    "200MG/200ML (1MG/ML)",
                    "300MG/300ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2326,
        "type": "RX",
        "ingredient": "LABETALOL HYDROCHLORIDE",
        "trade_name": "TRANDATE",
        "forms": [
            {
                "orange_id": "18716-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2327,
        "type": "RX",
        "ingredient": "LACOSAMIDE",
        "trade_name": "VIMPAT",
        "forms": [
            {
                "orange_id": "22254-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/20ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "22255-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "22253-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2328,
        "type": "RX",
        "ingredient": "LACTULOSE",
        "trade_name": "GENERLAC",
        "forms": [
            {
                "orange_id": "74603-1",
                "form": "SOLUTION",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "10GM/15ML"
                ]
            }
        ]
    },
    {
        "id": 2329,
        "type": "RX",
        "ingredient": "LACTULOSE",
        "trade_name": "LACTULOSE",
        "forms": [
            {
                "orange_id": "74712-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10GM/PACKET",
                    "20GM/PACKET"
                ]
            },
            {
                "orange_id": "74076-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10GM/15ML"
                ]
            },
            {
                "orange_id": "74077-1",
                "form": "SOLUTION",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "10GM/15ML"
                ]
            }
        ]
    },
    {
        "id": 2330,
        "type": "RX",
        "ingredient": "LAMIVUDINE",
        "trade_name": "EPIVIR",
        "forms": [
            {
                "orange_id": "20596-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "20564-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2331,
        "type": "RX",
        "ingredient": "LAMIVUDINE",
        "trade_name": "EPIVIR-HBV",
        "forms": [
            {
                "orange_id": "21004-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "21003-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2332,
        "type": "RX",
        "ingredient": "LAMIVUDINE",
        "trade_name": "LAMIVUDINE",
        "forms": [
            {
                "orange_id": "77695-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "211306-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2333,
        "type": "RX",
        "ingredient": "LAMIVUDINE AND TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "CIMDUO",
        "forms": [
            {
                "orange_id": "22141-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 2334,
        "type": "RX",
        "ingredient": "LAMIVUDINE AND ZIDOVUDINE",
        "trade_name": "COMBIVIR",
        "forms": [
            {
                "orange_id": "20857-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 2335,
        "type": "RX",
        "ingredient": "LAMIVUDINE AND ZIDOVUDINE",
        "trade_name": "LAMIVUDINE AND ZIDOVUDINE",
        "forms": [
            {
                "orange_id": "206375-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG-300MG"
                ]
            }
        ]
    },
    {
        "id": 2336,
        "type": "RX",
        "ingredient": "LAMOTRIGINE",
        "trade_name": "LAMICTAL",
        "forms": [
            {
                "orange_id": "20241-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2337,
        "type": "RX",
        "ingredient": "LAMOTRIGINE",
        "trade_name": "LAMICTAL CD",
        "forms": [
            {
                "orange_id": "20764-4",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 2338,
        "type": "RX",
        "ingredient": "LAMOTRIGINE",
        "trade_name": "LAMICTAL ODT",
        "forms": [
            {
                "orange_id": "22251-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2339,
        "type": "RX",
        "ingredient": "LAMOTRIGINE",
        "trade_name": "LAMICTAL XR",
        "forms": [
            {
                "orange_id": "22115-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG",
                    "250MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2340,
        "type": "RX",
        "ingredient": "LAMOTRIGINE",
        "trade_name": "LAMOTRIGINE",
        "forms": [
            {
                "orange_id": "200672-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "25MG",
                    "50MG",
                    "250MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "201168-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "25MG",
                    "2MG"
                ]
            },
            {
                "orange_id": "213271-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "90607-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG",
                    "150MG",
                    "200MG",
                    "50MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2341,
        "type": "RX",
        "ingredient": "LANREOTIDE ACETATE",
        "trade_name": "LANREOTIDE ACETATE",
        "forms": [
            {
                "orange_id": "215395-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 60MG BASE/0.2ML (EQ 60MG BASE/0.2ML)",
                    "EQ 90MG BASE/0.3ML (EQ 90MG BASE/0.3ML)",
                    "EQ 120MG BASE/0.5ML (EQ 120MG BASE/0.5ML)"
                ]
            }
        ]
    },
    {
        "id": 2342,
        "type": "RX",
        "ingredient": "LANREOTIDE ACETATE",
        "trade_name": "SOMATULINE DEPOT",
        "forms": [
            {
                "orange_id": "22074-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 60MG BASE/0.2ML (EQ 60MG BASE/0.2ML)",
                    "EQ 90MG BASE/0.3ML (EQ 90MG BASE/0.3ML)",
                    "EQ 120MG BASE/0.5ML (EQ 120MG BASE/0.5ML)"
                ]
            }
        ]
    },
    {
        "id": 2343,
        "type": "RX",
        "ingredient": "LANSOPRAZOLE",
        "trade_name": "LANSOPRAZOLE",
        "forms": [
            {
                "orange_id": "207394-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            },
            {
                "orange_id": "208025-1",
                "form": "TABLET, ORALLY DISINTEGRATING, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2344,
        "type": "RX",
        "ingredient": "LANSOPRAZOLE",
        "trade_name": "PREVACID",
        "forms": [
            {
                "orange_id": "20406-2",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            },
            {
                "orange_id": "21428-1",
                "form": "TABLET, ORALLY DISINTEGRATING, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2345,
        "type": "OTC",
        "ingredient": "LANSOPRAZOLE",
        "trade_name": "PREVACID 24 HR",
        "forms": [
            {
                "orange_id": "22327-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 2346,
        "type": "RX",
        "ingredient": "LANTHANUM CARBONATE",
        "trade_name": "FOSRENOL",
        "forms": [
            {
                "orange_id": "204734-2",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 750MG BASE"
                ]
            },
            {
                "orange_id": "21468-4",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2347,
        "type": "RX",
        "ingredient": "LANTHANUM CARBONATE",
        "trade_name": "LANTHANUM CARBONATE",
        "forms": [
            {
                "orange_id": "90977-3",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2348,
        "type": "RX",
        "ingredient": "LAPATINIB DITOSYLATE",
        "trade_name": "LAPATINIB DITOSYLATE",
        "forms": [
            {
                "orange_id": "203007-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2349,
        "type": "RX",
        "ingredient": "LAPATINIB DITOSYLATE",
        "trade_name": "TYKERB",
        "forms": [
            {
                "orange_id": "22059-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2350,
        "type": "RX",
        "ingredient": "LAROTRECTINIB SULFATE",
        "trade_name": "VITRAKVI",
        "forms": [
            {
                "orange_id": "210861-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 100MG BASE"
                ]
            },
            {
                "orange_id": "211710-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2351,
        "type": "RX",
        "ingredient": "LASMIDITAN SUCCINATE",
        "trade_name": "REYVOW",
        "forms": [
            {
                "orange_id": "211280-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2352,
        "type": "RX",
        "ingredient": "LATANOPROST",
        "trade_name": "LATANOPROST",
        "forms": [
            {
                "orange_id": "90887-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 2353,
        "type": "RX",
        "ingredient": "LATANOPROST",
        "trade_name": "XALATAN",
        "forms": [
            {
                "orange_id": "20597-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 2354,
        "type": "RX",
        "ingredient": "LATANOPROST",
        "trade_name": "XELPROS",
        "forms": [
            {
                "orange_id": "206185-1",
                "form": "EMULSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 2355,
        "type": "RX",
        "ingredient": "LATANOPROST AND NETARSUDIL DIMESYLATE",
        "trade_name": "ROCKLATAN",
        "forms": [
            {
                "orange_id": "208259-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.005%-EQ 0.02% BASE"
                ]
            }
        ]
    },
    {
        "id": 2356,
        "type": "RX",
        "ingredient": "LATANOPROSTENE BUNOD",
        "trade_name": "VYZULTA",
        "forms": [
            {
                "orange_id": "207795-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.024%"
                ]
            }
        ]
    },
    {
        "id": 2357,
        "type": "RX",
        "ingredient": "LEDIPASVIR AND SOFOSBUVIR",
        "trade_name": "HARVONI",
        "forms": [
            {
                "orange_id": "212477-1",
                "form": "PELLETS",
                "route": "ORAL",
                "dosage": [
                    "33.75MG-150MG/PACKET",
                    "45MG-200MG/PACKET"
                ]
            },
            {
                "orange_id": "205834-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "45MG-200MG",
                    "90MG-400MG"
                ]
            }
        ]
    },
    {
        "id": 2358,
        "type": "RX",
        "ingredient": "LEFAMULIN ACETATE",
        "trade_name": "XENLETA",
        "forms": [
            {
                "orange_id": "211673-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 150MG BASE/15ML (EQ 10MG BASE/ML)"
                ]
            },
            {
                "orange_id": "211672-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2359,
        "type": "RX",
        "ingredient": "LEFLUNOMIDE",
        "trade_name": "ARAVA",
        "forms": [
            {
                "orange_id": "20905-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2360,
        "type": "RX",
        "ingredient": "LEFLUNOMIDE",
        "trade_name": "LEFLUNOMIDE",
        "forms": [
            {
                "orange_id": "212453-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2361,
        "type": "RX",
        "ingredient": "LEMBOREXANT",
        "trade_name": "DAYVIGO",
        "forms": [
            {
                "orange_id": "212028-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2362,
        "type": "RX",
        "ingredient": "LENALIDOMIDE",
        "trade_name": "LENALIDOMIDE",
        "forms": [
            {
                "orange_id": "201452-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "25MG",
                    "2.5MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2363,
        "type": "RX",
        "ingredient": "LENALIDOMIDE",
        "trade_name": "REVLIMID",
        "forms": [
            {
                "orange_id": "21880-5",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 2364,
        "type": "RX",
        "ingredient": "LENVATINIB MESYLATE",
        "trade_name": "LENVIMA",
        "forms": [
            {
                "orange_id": "206947-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2365,
        "type": "RX",
        "ingredient": "LETERMOVIR",
        "trade_name": "PREVYMIS",
        "forms": [
            {
                "orange_id": "209940-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "240MG/12ML (20MG/ML)",
                    "480MG/24ML (20MG/ML)"
                ]
            },
            {
                "orange_id": "209939-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "240MG",
                    "480MG"
                ]
            }
        ]
    },
    {
        "id": 2366,
        "type": "RX",
        "ingredient": "LETROZOLE",
        "trade_name": "FEMARA",
        "forms": [
            {
                "orange_id": "20726-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 2367,
        "type": "RX",
        "ingredient": "LETROZOLE",
        "trade_name": "LETROZOLE",
        "forms": [
            {
                "orange_id": "90934-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 2368,
        "type": "RX",
        "ingredient": "LETROZOLE AND RIBOCICLIB SUCCINATE",
        "trade_name": "KISQALI FEMARA CO-PACK (COPACKAGED)",
        "forms": [
            {
                "orange_id": "209935-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2369,
        "type": "RX",
        "ingredient": "LEUCOVORIN CALCIUM",
        "trade_name": "LEUCOVORIN CALCIUM",
        "forms": [
            {
                "orange_id": "207226-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML",
                    "EQ 50MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL",
                    "EQ 350MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "71198-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 25MG BASE",
                    "EQ 10MG BASE",
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2370,
        "type": "RX",
        "ingredient": "LEUCOVORIN CALCIUM",
        "trade_name": "LEUCOVORIN CALCIUM PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "40258-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 200MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 10MG BASE/ML",
                    "EQ 350MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL",
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2371,
        "type": "RX",
        "ingredient": "LEUPROLIDE ACETATE",
        "trade_name": "ELIGARD KIT",
        "forms": [
            {
                "orange_id": "21343-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "7.5MG",
                    "22.5MG",
                    "30MG",
                    "45MG"
                ]
            }
        ]
    },
    {
        "id": 2372,
        "type": "RX",
        "ingredient": "LEUPROLIDE ACETATE",
        "trade_name": "FENSOLVI KIT",
        "forms": [
            {
                "orange_id": "213150-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "45MG"
                ]
            }
        ]
    },
    {
        "id": 2373,
        "type": "RX",
        "ingredient": "LEUPROLIDE ACETATE",
        "trade_name": "LEUPROLIDE ACETATE",
        "forms": [
            {
                "orange_id": "74728-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/0.2ML"
                ]
            }
        ]
    },
    {
        "id": 2374,
        "type": "RX",
        "ingredient": "LEUPROLIDE ACETATE",
        "trade_name": "LUPRON DEPOT",
        "forms": [
            {
                "orange_id": "20011-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3.75MG",
                    "7.5MG/VIAL",
                    "11.25MG/VIAL",
                    "22.5MG/VIAL",
                    "30MG/VIAL",
                    "45MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2375,
        "type": "RX",
        "ingredient": "LEUPROLIDE ACETATE",
        "trade_name": "LUPRON DEPOT-PED KIT",
        "forms": [
            {
                "orange_id": "20263-2",
                "form": "POWDER",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "7.5MG",
                    "11.25MG",
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2376,
        "type": "RX",
        "ingredient": "LEUPROLIDE MESYLATE",
        "trade_name": "CAMCEVI KIT",
        "forms": [
            {
                "orange_id": "211488-1",
                "form": "EMULSION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 42MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2377,
        "type": "RX",
        "ingredient": "LEVALBUTEROL HYDROCHLORIDE",
        "trade_name": "LEVALBUTEROL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78171-2",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.021% BASE",
                    "EQ 0.042% BASE",
                    "EQ 0.0103% BASE",
                    "EQ 0.25% BASE"
                ]
            }
        ]
    },
    {
        "id": 2378,
        "type": "RX",
        "ingredient": "LEVALBUTEROL HYDROCHLORIDE",
        "trade_name": "XOPENEX",
        "forms": [
            {
                "orange_id": "20837-3",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.0103% BASE",
                    "EQ 0.021% BASE",
                    "EQ 0.042% BASE",
                    "EQ 0.25% BASE"
                ]
            }
        ]
    },
    {
        "id": 2379,
        "type": "RX",
        "ingredient": "LEVALBUTEROL TARTRATE",
        "trade_name": "XOPENEX HFA",
        "forms": [
            {
                "orange_id": "21730-1",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.045MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 2380,
        "type": "RX",
        "ingredient": "LEVAMLODIPINE MALEATE",
        "trade_name": "CONJUPRI",
        "forms": [
            {
                "orange_id": "212895-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2381,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "ELEPSIA XR",
        "forms": [
            {
                "orange_id": "204417-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "1.5GM"
                ]
            }
        ]
    },
    {
        "id": 2382,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "KEPPRA",
        "forms": [
            {
                "orange_id": "21872-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/5ML (100MG/ML)"
                ]
            },
            {
                "orange_id": "21505-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "21035-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "250MG",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2383,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "KEPPRA XR",
        "forms": [
            {
                "orange_id": "22285-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2384,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "LEVETIRACETAM",
        "forms": [
            {
                "orange_id": "204312-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/5ML (100MG/ML)"
                ]
            },
            {
                "orange_id": "78582-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "91093-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "750MG",
                    "1GM"
                ]
            },
            {
                "orange_id": "90843-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "250MG",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2385,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "LEVETIRACETAM IN SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "207160-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/100ML (10MG/ML)",
                    "1.5GM/100ML (15MG/ML)",
                    "500MG/100ML (5MG/ML)",
                    "250MG/50ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2386,
        "type": "RX",
        "ingredient": "LEVETIRACETAM",
        "trade_name": "SPRITAM",
        "forms": [
            {
                "orange_id": "207958-4",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "250MG",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2387,
        "type": "RX",
        "ingredient": "LEVOBUNOLOL HYDROCHLORIDE",
        "trade_name": "BETAGAN",
        "forms": [
            {
                "orange_id": "19219-2",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2388,
        "type": "RX",
        "ingredient": "LEVOBUNOLOL HYDROCHLORIDE",
        "trade_name": "LEVOBUNOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74326-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2389,
        "type": "RX",
        "ingredient": "LEVOCARNITINE",
        "trade_name": "CARNITOR",
        "forms": [
            {
                "orange_id": "20182-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/ML"
                ]
            },
            {
                "orange_id": "19257-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            },
            {
                "orange_id": "18948-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "330MG"
                ]
            }
        ]
    },
    {
        "id": 2390,
        "type": "RX",
        "ingredient": "LEVOCARNITINE",
        "trade_name": "CARNITOR SF",
        "forms": [
            {
                "orange_id": "19257-2",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            }
        ]
    },
    {
        "id": 2391,
        "type": "RX",
        "ingredient": "LEVOCARNITINE",
        "trade_name": "LEVOCARNITINE",
        "forms": [
            {
                "orange_id": "75861-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/ML"
                ]
            },
            {
                "orange_id": "77399-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            },
            {
                "orange_id": "76858-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "330MG"
                ]
            }
        ]
    },
    {
        "id": 2392,
        "type": "RX",
        "ingredient": "LEVOCARNITINE",
        "trade_name": "LEVOCARNITINE SF",
        "forms": [
            {
                "orange_id": "211676-2",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            }
        ]
    },
    {
        "id": 2393,
        "type": "RX",
        "ingredient": "LEVOCETIRIZINE DIHYDROCHLORIDE",
        "trade_name": "LEVOCETIRIZINE DIHYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204599-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/5ML"
                ]
            },
            {
                "orange_id": "211443-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2394,
        "type": "RX",
        "ingredient": "LEVOCETIRIZINE DIHYDROCHLORIDE",
        "trade_name": "LEVOCETIRIZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210914-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2395,
        "type": "OTC",
        "ingredient": "LEVOCETIRIZINE DIHYDROCHLORIDE",
        "trade_name": "XYZAL ALLERGY 24HR",
        "forms": [
            {
                "orange_id": "209090-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2.5MG/5ML"
                ]
            },
            {
                "orange_id": "209089-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2396,
        "type": "RX",
        "ingredient": "LEVODOPA",
        "trade_name": "INBRIJA",
        "forms": [
            {
                "orange_id": "209184-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "42MG"
                ]
            }
        ]
    },
    {
        "id": 2397,
        "type": "RX",
        "ingredient": "LEVOFLOXACIN",
        "trade_name": "LEVOFLOXACIN",
        "forms": [
            {
                "orange_id": "91644-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500MG/20ML (EQ 25MG/ML)",
                    "EQ 750MG/30ML (EQ 25MG/ML)"
                ]
            },
            {
                "orange_id": "90268-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%",
                    "1.5%"
                ]
            },
            {
                "orange_id": "91678-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "250MG/10ML"
                ]
            },
            {
                "orange_id": "90787-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2398,
        "type": "RX",
        "ingredient": "LEVOFLOXACIN",
        "trade_name": "LEVOFLOXACIN IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "91397-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 250MG/50ML (EQ 5MG/ML)",
                    "EQ 500MG/100ML (EQ 5MG/ML)",
                    "EQ 750MG/150ML (EQ 5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2399,
        "type": "RX",
        "ingredient": "LEVOKETOCONAZOLE",
        "trade_name": "RECORLEV",
        "forms": [
            {
                "orange_id": "214133-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2400,
        "type": "RX",
        "ingredient": "LEVOLEUCOVORIN",
        "trade_name": "KHAPZORY",
        "forms": [
            {
                "orange_id": "211226-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "175MG/VIAL",
                    "300MG/VIAL "
                ]
            }
        ]
    },
    {
        "id": 2401,
        "type": "RX",
        "ingredient": "LEVOLEUCOVORIN CALCIUM",
        "trade_name": "FUSILEV",
        "forms": [
            {
                "orange_id": "20140-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2402,
        "type": "RX",
        "ingredient": "LEVOLEUCOVORIN CALCIUM",
        "trade_name": "LEVOLEUCOVORIN CALCIUM",
        "forms": [
            {
                "orange_id": "206263-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "207548-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 175MG BASE/17.5ML (EQ 10MG BASE/ML) ",
                    "EQ 175MG BASE/17.5ML (EQ 10MG BASE/ML)",
                    "EQ 250MG BASE/25ML (EQ 10MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2403,
        "type": "RX",
        "ingredient": "LEVOMILNACIPRAN HYDROCHLORIDE",
        "trade_name": "FETZIMA",
        "forms": [
            {
                "orange_id": "204168-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 80MG BASE",
                    "EQ 120MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2404,
        "type": "RX",
        "ingredient": "LEVONORDEFRIN AND MEPIVACAINE HYDROCHLORIDE",
        "trade_name": "SCANDONEST L",
        "forms": [
            {
                "orange_id": "88388-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.05MG/ML-2%"
                ]
            }
        ]
    },
    {
        "id": 2405,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "ATHENTIA NEXT",
        "forms": [
            {
                "orange_id": "206867-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2406,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "FALLBACK SOLO",
        "forms": [
            {
                "orange_id": "201446-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2407,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "HER STYLE",
        "forms": [
            {
                "orange_id": "207976-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2408,
        "type": "RX",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "KYLEENA",
        "forms": [
            {
                "orange_id": "208224-1",
                "form": "INTRAUTERINE DEVICE",
                "route": "INTRAUTERINE",
                "dosage": [
                    "19.5MG"
                ]
            }
        ]
    },
    {
        "id": 2409,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "LEVONORGESTREL",
        "forms": [
            {
                "orange_id": "207044-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG",
                    "0.75MG"
                ]
            }
        ]
    },
    {
        "id": 2410,
        "type": "RX",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "LILETTA",
        "forms": [
            {
                "orange_id": "206229-1",
                "form": "INTRAUTERINE DEVICE",
                "route": "INTRAUTERINE",
                "dosage": [
                    "52MG"
                ]
            }
        ]
    },
    {
        "id": 2411,
        "type": "RX",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "MIRENA",
        "forms": [
            {
                "orange_id": "21225-1",
                "form": "INTRAUTERINE DEVICE",
                "route": "INTRAUTERINE",
                "dosage": [
                    "52MG"
                ]
            }
        ]
    },
    {
        "id": 2412,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "OPCICON ONE-STEP",
        "forms": [
            {
                "orange_id": "202635-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2413,
        "type": "OTC",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "PLAN B ONE-STEP",
        "forms": [
            {
                "orange_id": "21998-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 2414,
        "type": "RX",
        "ingredient": "LEVONORGESTREL",
        "trade_name": "SKYLA",
        "forms": [
            {
                "orange_id": "203159-1",
                "form": "INTRAUTERINE DEVICE",
                "route": "INTRAUTERINE",
                "dosage": [
                    "13.5MG"
                ]
            }
        ]
    },
    {
        "id": 2415,
        "type": "RX",
        "ingredient": "LEVORPHANOL TARTRATE",
        "trade_name": "LEVORPHANOL TARTRATE",
        "forms": [
            {
                "orange_id": "213479-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2416,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "EUTHYROX",
        "forms": [
            {
                "orange_id": "21292-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 2417,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "LEVOLET",
        "forms": [
            {
                "orange_id": "21137-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2418,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "LEVO-T",
        "forms": [
            {
                "orange_id": "21342-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2419,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "LEVOTHYROXINE SODIUM",
        "forms": [
            {
                "orange_id": "202231-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MCG/VIAL",
                    "200MCG/VIAL",
                    "500MCG/VIAL"
                ]
            },
            {
                "orange_id": "214253-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MCG/ML",
                    "100MCG/5ML (20MCG/ML)",
                    "200MCG/5ML (40MCG/ML)",
                    "500MCG/5ML (100MCG/ML)"
                ]
            },
            {
                "orange_id": "212399-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2420,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "LEVOXYL",
        "forms": [
            {
                "orange_id": "21301-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 2421,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "SYNTHROID",
        "forms": [
            {
                "orange_id": "21402-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2422,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "THYQUIDITY",
        "forms": [
            {
                "orange_id": "214047-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MCG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2423,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "THYRO-TABS",
        "forms": [
            {
                "orange_id": "21116-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2424,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "TIROSINT",
        "forms": [
            {
                "orange_id": "21924-13",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.013MG",
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.200MG"
                ]
            }
        ]
    },
    {
        "id": 2425,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "TIROSINT-SOL",
        "forms": [
            {
                "orange_id": "206977-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "13MCG/ML",
                    "25MCG/ML",
                    "37.5MCG/ML",
                    "44MCG/ML",
                    "50MCG/ML",
                    "62.5MCG/ML",
                    "75MCG/ML",
                    "88MCG/ML",
                    "100MCG/ML",
                    "112MCG/ML",
                    "125MCG/ML",
                    "137MCG/ML",
                    "150MCG/ML",
                    "175MCG/ML",
                    "200MCG/ML"
                ]
            }
        ]
    },
    {
        "id": 2426,
        "type": "RX",
        "ingredient": "LEVOTHYROXINE SODIUM",
        "trade_name": "UNITHROID",
        "forms": [
            {
                "orange_id": "21210-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.025MG",
                    "0.05MG",
                    "0.075MG",
                    "0.088MG",
                    "0.1MG",
                    "0.112MG",
                    "0.125MG",
                    "0.137MG",
                    "0.15MG",
                    "0.175MG",
                    "0.2MG",
                    "0.3MG"
                ]
            }
        ]
    },
    {
        "id": 2427,
        "type": "RX",
        "ingredient": "L-GLUTAMINE",
        "trade_name": "ENDARI",
        "forms": [
            {
                "orange_id": "208587-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 2428,
        "type": "RX",
        "ingredient": "LIDOCAINE",
        "trade_name": "LIDOCAINE",
        "forms": [
            {
                "orange_id": "211469-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "200675-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2429,
        "type": "RX",
        "ingredient": "LIDOCAINE",
        "trade_name": "LIDODERM",
        "forms": [
            {
                "orange_id": "20612-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2430,
        "type": "RX",
        "ingredient": "LIDOCAINE",
        "trade_name": "ZTLIDO",
        "forms": [
            {
                "orange_id": "207962-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "1.8%"
                ]
            }
        ]
    },
    {
        "id": 2431,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "AKTEN",
        "forms": [
            {
                "orange_id": "22221-1",
                "form": "GEL",
                "route": "OPHTHALMIC",
                "dosage": [
                    "3.5%"
                ]
            }
        ]
    },
    {
        "id": 2432,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "GLYDO",
        "forms": [
            {
                "orange_id": "201094-1",
                "form": "JELLY",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2433,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LARYNG-O-JET KIT",
        "forms": [
            {
                "orange_id": "86364-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 2434,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "214336-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "2%",
                    "0.5%"
                ]
            },
            {
                "orange_id": "40433-1",
                "form": "JELLY",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "40014-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "88803-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 2435,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE 0. 2% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19830-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2436,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE 0. 4% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19830-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "400MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2437,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE 0. 8% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19830-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "800MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2438,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE 5% AND DEXTROSE 7. 5%",
        "forms": [
            {
                "orange_id": "83914-1",
                "form": "INJECTABLE",
                "route": "SPINAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2439,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "88586-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "0.5%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2440,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "203040-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "2%",
                    "4%",
                    "1.5%"
                ]
            }
        ]
    },
    {
        "id": 2441,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE PRESERVATIVE FREE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "40302-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2442,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE HYDROCHLORIDE VISCOUS",
        "forms": [
            {
                "orange_id": "40708-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2443,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "LIDOCAINE VISCOUS",
        "forms": [
            {
                "orange_id": "88802-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2444,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "XYLOCAINE",
        "forms": [
            {
                "orange_id": "6488-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5%",
                    "1%",
                    "1.5%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2445,
        "type": "RX",
        "ingredient": "LIDOCAINE HYDROCHLORIDE",
        "trade_name": "ZINGO",
        "forms": [
            {
                "orange_id": "22114-1",
                "form": "SYSTEM",
                "route": "INTRADERMAL",
                "dosage": [
                    "0.5MG"
                ]
            }
        ]
    },
    {
        "id": 2446,
        "type": "RX",
        "ingredient": "LIDOCAINE AND PRILOCAINE",
        "trade_name": "EMLA",
        "forms": [
            {
                "orange_id": "19941-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 2447,
        "type": "RX",
        "ingredient": "LIDOCAINE AND PRILOCAINE",
        "trade_name": "LIDOCAINE AND PRILOCAINE",
        "forms": [
            {
                "orange_id": "76290-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 2448,
        "type": "RX",
        "ingredient": "LIDOCAINE AND PRILOCAINE",
        "trade_name": "ORAQIX",
        "forms": [
            {
                "orange_id": "21451-1",
                "form": "GEL",
                "route": "PERIODONTAL",
                "dosage": [
                    "2.5%-2.5%"
                ]
            }
        ]
    },
    {
        "id": 2449,
        "type": "RX",
        "ingredient": "LIDOCAINE AND TETRACAINE",
        "trade_name": "PLIAGLIS",
        "forms": [
            {
                "orange_id": "21717-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "7%-7%"
                ]
            }
        ]
    },
    {
        "id": 2450,
        "type": "RX",
        "ingredient": "LIDOCAINE AND TETRACAINE",
        "trade_name": "SYNERA",
        "forms": [
            {
                "orange_id": "21623-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "70MG-70MG"
                ]
            }
        ]
    },
    {
        "id": 2451,
        "type": "RX",
        "ingredient": "LIFITEGRAST",
        "trade_name": "XIIDRA",
        "forms": [
            {
                "orange_id": "208073-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2452,
        "type": "RX",
        "ingredient": "LINACLOTIDE",
        "trade_name": "LINZESS",
        "forms": [
            {
                "orange_id": "202811-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "72MCG",
                    "145MCG",
                    "290MCG"
                ]
            }
        ]
    },
    {
        "id": 2453,
        "type": "RX",
        "ingredient": "LINAGLIPTIN",
        "trade_name": "LINAGLIPTIN",
        "forms": [
            {
                "orange_id": "208335-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2454,
        "type": "RX",
        "ingredient": "LINAGLIPTIN",
        "trade_name": "TRADJENTA",
        "forms": [
            {
                "orange_id": "201280-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2455,
        "type": "RX",
        "ingredient": "LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "JENTADUETO",
        "forms": [
            {
                "orange_id": "201281-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-1GM",
                    "2.5MG-500MG",
                    "2.5MG-850MG"
                ]
            }
        ]
    },
    {
        "id": 2456,
        "type": "RX",
        "ingredient": "LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "JENTADUETO XR",
        "forms": [
            {
                "orange_id": "208026-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-1GM",
                    "5MG-1GM"
                ]
            }
        ]
    },
    {
        "id": 2457,
        "type": "RX",
        "ingredient": "LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
        "trade_name": "LINAGLIPTIN AND METFORMIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208336-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG-1GM",
                    "2.5MG-500MG",
                    "2.5MG-850MG"
                ]
            }
        ]
    },
    {
        "id": 2458,
        "type": "RX",
        "ingredient": "LINCOMYCIN",
        "trade_name": "LINCOMYCIN",
        "forms": [
            {
                "orange_id": "215082-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 300MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2459,
        "type": "RX",
        "ingredient": "LINCOMYCIN HYDROCHLORIDE",
        "trade_name": "LINCOCIN",
        "forms": [
            {
                "orange_id": "50317-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 300MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2460,
        "type": "RX",
        "ingredient": "LINCOMYCIN HYDROCHLORIDE",
        "trade_name": "LINCOMYCIN",
        "forms": [
            {
                "orange_id": "201746-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 300MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2461,
        "type": "RX",
        "ingredient": "LINDANE",
        "trade_name": "LINDANE",
        "forms": [
            {
                "orange_id": "88191-1",
                "form": "SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2462,
        "type": "RX",
        "ingredient": "LINEZOLID",
        "trade_name": "LINEZOLID",
        "forms": [
            {
                "orange_id": "200068-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "206917-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "600MG/300ML (2MG/ML)",
                    "200MG/100ML (2MG/ML)"
                ]
            },
            {
                "orange_id": "205233-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 2463,
        "type": "RX",
        "ingredient": "LINEZOLID",
        "trade_name": "LINEZOLID IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "206473-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "600MG/300ML (2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2464,
        "type": "RX",
        "ingredient": "LINEZOLID",
        "trade_name": "ZYVOX",
        "forms": [
            {
                "orange_id": "21132-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "21131-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/100ML (2MG/ML)",
                    "600MG/300ML (2MG/ML)"
                ]
            },
            {
                "orange_id": "21130-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 2465,
        "type": "RX",
        "ingredient": "LIOTHYRONINE SODIUM",
        "trade_name": "CYTOMEL",
        "forms": [
            {
                "orange_id": "10379-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.005MG BASE",
                    "EQ 0.025MG BASE",
                    "EQ 0.05MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2466,
        "type": "RX",
        "ingredient": "LIOTHYRONINE SODIUM",
        "trade_name": "LIOTHYRONINE SODIUM",
        "forms": [
            {
                "orange_id": "76923-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.01MG BASE/ML"
                ]
            },
            {
                "orange_id": "90097-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.005MG BASE",
                    "EQ 0.025MG BASE",
                    "EQ 0.05MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2467,
        "type": "RX",
        "ingredient": "LIOTHYRONINE SODIUM",
        "trade_name": "TRIOSTAT",
        "forms": [
            {
                "orange_id": "20105-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.01MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2468,
        "type": "RX",
        "ingredient": "LIRAGLUTIDE RECOMBINANT",
        "trade_name": "SAXENDA",
        "forms": [
            {
                "orange_id": "206321-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "18MG/3ML (6MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2469,
        "type": "RX",
        "ingredient": "LIRAGLUTIDE RECOMBINANT",
        "trade_name": "VICTOZA",
        "forms": [
            {
                "orange_id": "22341-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "18MG/3ML (6MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2470,
        "type": "RX",
        "ingredient": "LISDEXAMFETAMINE DIMESYLATE",
        "trade_name": "VYVANSE",
        "forms": [
            {
                "orange_id": "21977-7",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG",
                    "60MG",
                    "70MG"
                ]
            },
            {
                "orange_id": "208510-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 2471,
        "type": "RX",
        "ingredient": "LISINOPRIL",
        "trade_name": "LISINOPRIL",
        "forms": [
            {
                "orange_id": "202554-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2472,
        "type": "RX",
        "ingredient": "LISINOPRIL",
        "trade_name": "PRINIVIL",
        "forms": [
            {
                "orange_id": "19558-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2473,
        "type": "RX",
        "ingredient": "LISINOPRIL",
        "trade_name": "QBRELIS",
        "forms": [
            {
                "orange_id": "208401-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2474,
        "type": "RX",
        "ingredient": "LISINOPRIL",
        "trade_name": "ZESTRIL",
        "forms": [
            {
                "orange_id": "19777-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2475,
        "type": "RX",
        "ingredient": "LITHIUM CARBONATE",
        "trade_name": "LITHIUM CARBONATE",
        "forms": [
            {
                "orange_id": "79159-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG",
                    "600MG"
                ]
            },
            {
                "orange_id": "91616-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "450MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "18558-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2476,
        "type": "RX",
        "ingredient": "LITHIUM CARBONATE",
        "trade_name": "LITHOBID",
        "forms": [
            {
                "orange_id": "18027-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2477,
        "type": "RX",
        "ingredient": "LITHIUM CITRATE",
        "trade_name": "LITHIUM CITRATE",
        "forms": [
            {
                "orange_id": "18421-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "EQ 300MG CARBONATE/5ML"
                ]
            }
        ]
    },
    {
        "id": 2478,
        "type": "RX",
        "ingredient": "LODOXAMIDE TROMETHAMINE",
        "trade_name": "ALOMIDE",
        "forms": [
            {
                "orange_id": "20191-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 2479,
        "type": "RX",
        "ingredient": "LOFEXIDINE HYDROCHLORIDE",
        "trade_name": "LUCEMYRA",
        "forms": [
            {
                "orange_id": "209229-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.18MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2480,
        "type": "RX",
        "ingredient": "LOMITAPIDE MESYLATE",
        "trade_name": "JUXTAPID",
        "forms": [
            {
                "orange_id": "203858-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 30MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2481,
        "type": "RX",
        "ingredient": "LOMUSTINE",
        "trade_name": "GLEOSTINE",
        "forms": [
            {
                "orange_id": "17588-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "40MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2482,
        "type": "RX",
        "ingredient": "LONAFARNIB",
        "trade_name": "ZOKINVY",
        "forms": [
            {
                "orange_id": "213969-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 2483,
        "type": "OTC",
        "ingredient": "LOPERAMIDE HYDROCHLORIDE",
        "trade_name": "IMODIUM A-D",
        "forms": [
            {
                "orange_id": "19487-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/5ML"
                ]
            },
            {
                "orange_id": "19487-2",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/7.5ML"
                ]
            },
            {
                "orange_id": "19860-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2484,
        "type": "OTC",
        "ingredient": "LOPERAMIDE HYDROCHLORIDE",
        "trade_name": "LOPERAMIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "21855-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            },
            {
                "orange_id": "74352-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/5ML"
                ]
            },
            {
                "orange_id": "91292-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/7.5ML"
                ]
            },
            {
                "orange_id": "206548-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2485,
        "type": "OTC",
        "ingredient": "LOPERAMIDE HYDROCHLORIDE AND SIMETHICONE",
        "trade_name": "IMODIUM MULTI-SYMPTOM RELIEF",
        "forms": [
            {
                "orange_id": "21140-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG-125MG"
                ]
            }
        ]
    },
    {
        "id": 2486,
        "type": "OTC",
        "ingredient": "LOPERAMIDE HYDROCHLORIDE AND SIMETHICONE",
        "trade_name": "LOPERAMIDE HYDROCHLORIDE AND SIMETHICONE",
        "forms": [
            {
                "orange_id": "76029-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "2MG-125MG"
                ]
            },
            {
                "orange_id": "211059-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG-125MG"
                ]
            }
        ]
    },
    {
        "id": 2487,
        "type": "RX",
        "ingredient": "LOPINAVIR AND RITONAVIR",
        "trade_name": "KALETRA",
        "forms": [
            {
                "orange_id": "21251-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "80MG/ML-20MG/ML"
                ]
            },
            {
                "orange_id": "21906-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-25MG",
                    "200MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 2488,
        "type": "RX",
        "ingredient": "LOPINAVIR AND RITONAVIR",
        "trade_name": "LOPINAVIR AND RITONAVIR",
        "forms": [
            {
                "orange_id": "207407-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "80MG/ML-20MG/ML"
                ]
            },
            {
                "orange_id": "91677-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG-25MG",
                    "200MG-50MG"
                ]
            }
        ]
    },
    {
        "id": 2489,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "ALAVERT",
        "forms": [
            {
                "orange_id": "21375-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2490,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "CHILDREN'S CLARITIN",
        "forms": [
            {
                "orange_id": "21891-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2491,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "CLARITIN",
        "forms": [
            {
                "orange_id": "21952-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "20641-2",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "21891-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "19658-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2492,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "CLARITIN HIVES RELIEF",
        "forms": [
            {
                "orange_id": "19658-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2493,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "CLARITIN HIVES RELIEF REDITAB",
        "forms": [
            {
                "orange_id": "20704-3",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2494,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "CLARITIN REDITABS",
        "forms": [
            {
                "orange_id": "21993-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2495,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "LORATADINE",
        "forms": [
            {
                "orange_id": "202538-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "21734-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "208931-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "210033-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            },
            {
                "orange_id": "208477-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "76471-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2496,
        "type": "OTC",
        "ingredient": "LORATADINE",
        "trade_name": "LORATADINE REDIDOSE",
        "forms": [
            {
                "orange_id": "77153-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2497,
        "type": "OTC",
        "ingredient": "LORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "trade_name": "CLARITIN-D",
        "forms": [
            {
                "orange_id": "19670-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 2498,
        "type": "OTC",
        "ingredient": "LORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "trade_name": "CLARITIN-D 24 HOUR",
        "forms": [
            {
                "orange_id": "20470-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG-240MG"
                ]
            }
        ]
    },
    {
        "id": 2499,
        "type": "OTC",
        "ingredient": "LORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "trade_name": "LORATADINE AND PSEUDOEPHEDRINE SULFATE",
        "forms": [
            {
                "orange_id": "75706-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG-240MG",
                    "5MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 2500,
        "type": "RX",
        "ingredient": "LORAZEPAM",
        "trade_name": "ATIVAN",
        "forms": [
            {
                "orange_id": "18140-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML",
                    "4MG/ML"
                ]
            },
            {
                "orange_id": "17794-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2501,
        "type": "RX",
        "ingredient": "LORAZEPAM",
        "trade_name": "LORAZEPAM",
        "forms": [
            {
                "orange_id": "200169-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "2MG/ML"
                ]
            },
            {
                "orange_id": "75025-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MG/ML",
                    "4MG/ML"
                ]
            },
            {
                "orange_id": "78826-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2502,
        "type": "RX",
        "ingredient": "LORAZEPAM",
        "trade_name": "LORAZEPAM INTENSOL",
        "forms": [
            {
                "orange_id": "72755-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2503,
        "type": "RX",
        "ingredient": "LORAZEPAM",
        "trade_name": "LOREEV XR",
        "forms": [
            {
                "orange_id": "214826-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2504,
        "type": "RX",
        "ingredient": "LORLATINIB",
        "trade_name": "LORBRENA",
        "forms": [
            {
                "orange_id": "210868-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2505,
        "type": "RX",
        "ingredient": "LOSARTAN POTASSIUM",
        "trade_name": "COZAAR",
        "forms": [
            {
                "orange_id": "20386-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2506,
        "type": "RX",
        "ingredient": "LOSARTAN POTASSIUM",
        "trade_name": "LOSARTAN POTASSIUM",
        "forms": [
            {
                "orange_id": "90428-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2507,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "ALREX",
        "forms": [
            {
                "orange_id": "20803-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%"
                ]
            }
        ]
    },
    {
        "id": 2508,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "EYSUVIS",
        "forms": [
            {
                "orange_id": "210933-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.25%"
                ]
            }
        ]
    },
    {
        "id": 2509,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "INVELTYS",
        "forms": [
            {
                "orange_id": "210565-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2510,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "LOTEMAX",
        "forms": [
            {
                "orange_id": "202872-1",
                "form": "GEL",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "200738-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "20583-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2511,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "LOTEMAX SM",
        "forms": [
            {
                "orange_id": "208219-1",
                "form": "GEL",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.38%"
                ]
            }
        ]
    },
    {
        "id": 2512,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE",
        "trade_name": "LOTEPREDNOL ETABONATE",
        "forms": [
            {
                "orange_id": "212080-1",
                "form": "GEL",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "207609-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2513,
        "type": "RX",
        "ingredient": "LOTEPREDNOL ETABONATE AND TOBRAMYCIN",
        "trade_name": "ZYLET",
        "forms": [
            {
                "orange_id": "50804-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 2514,
        "type": "RX",
        "ingredient": "LOVASTATIN",
        "trade_name": "ALTOPREV",
        "forms": [
            {
                "orange_id": "21316-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 2515,
        "type": "RX",
        "ingredient": "LOVASTATIN",
        "trade_name": "LOVASTATIN",
        "forms": [
            {
                "orange_id": "75828-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2516,
        "type": "RX",
        "ingredient": "LOXAPINE",
        "trade_name": "ADASUVE",
        "forms": [
            {
                "orange_id": "22549-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2517,
        "type": "RX",
        "ingredient": "LOXAPINE SUCCINATE",
        "trade_name": "LOXAPINE SUCCINATE",
        "forms": [
            {
                "orange_id": "76868-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2518,
        "type": "RX",
        "ingredient": "LUBIPROSTONE",
        "trade_name": "AMITIZA",
        "forms": [
            {
                "orange_id": "21908-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "8MCG",
                    "24MCG"
                ]
            }
        ]
    },
    {
        "id": 2519,
        "type": "RX",
        "ingredient": "LUBIPROSTONE",
        "trade_name": "LUBIPROSTONE",
        "forms": [
            {
                "orange_id": "209450-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "8MCG",
                    "24MCG"
                ]
            }
        ]
    },
    {
        "id": 2520,
        "type": "RX",
        "ingredient": "LULICONAZOLE",
        "trade_name": "LUZU",
        "forms": [
            {
                "orange_id": "204153-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2521,
        "type": "RX",
        "ingredient": "LUMASIRAN SODIUM",
        "trade_name": "OXLUMO",
        "forms": [
            {
                "orange_id": "214103-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 94.5MG/0.5ML BASE (EQ 94.5MG/0.5ML BASE)"
                ]
            }
        ]
    },
    {
        "id": 2522,
        "type": "RX",
        "ingredient": "LUMATEPERONE TOSYLATE",
        "trade_name": "CAPLYTA",
        "forms": [
            {
                "orange_id": "209500-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 42MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2523,
        "type": "RX",
        "ingredient": "LURASIDONE HYDROCHLORIDE",
        "trade_name": "LATUDA",
        "forms": [
            {
                "orange_id": "200603-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2524,
        "type": "RX",
        "ingredient": "LURASIDONE HYDROCHLORIDE",
        "trade_name": "LURASIDONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208049-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2525,
        "type": "RX",
        "ingredient": "LURBINECTEDIN",
        "trade_name": "ZEPZELCA",
        "forms": [
            {
                "orange_id": "213702-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "4MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2526,
        "type": "RX",
        "ingredient": "LUSUTROMBOPAG",
        "trade_name": "MULPLETA",
        "forms": [
            {
                "orange_id": "210923-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 2527,
        "type": "RX",
        "ingredient": "LUTETIUM DOTATATE LU-177",
        "trade_name": "LUTATHERA",
        "forms": [
            {
                "orange_id": "208700-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 2528,
        "type": "RX",
        "ingredient": "MACIMORELIN ACETATE",
        "trade_name": "MACRILEN",
        "forms": [
            {
                "orange_id": "205598-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 60MG BASE/POUCH"
                ]
            }
        ]
    },
    {
        "id": 2529,
        "type": "RX",
        "ingredient": "MACITENTAN",
        "trade_name": "OPSUMIT",
        "forms": [
            {
                "orange_id": "204410-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2530,
        "type": "RX",
        "ingredient": "MAFENIDE ACETATE",
        "trade_name": "MAFENIDE ACETATE",
        "forms": [
            {
                "orange_id": "206716-1",
                "form": "FOR SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2531,
        "type": "RX",
        "ingredient": "MAFENIDE ACETATE",
        "trade_name": "SULFAMYLON",
        "forms": [
            {
                "orange_id": "16763-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 85MG BASE/GM"
                ]
            },
            {
                "orange_id": "19832-3",
                "form": "FOR SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2532,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, MONOBASIC, SODIUM ACETATE, SODIUM CHLORIDE, SODIUM GLUCONATE AND SODIUM PHOSPHATE, DIBASIC, HEPTAHYDRATE",
        "trade_name": "ISOLYTE S PH 7. 4 IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19696-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-0.82MG/100ML-370MG/100ML-530MG/100ML-500MG/100ML-12MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2533,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "ISOLYTE S IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19711-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-370MG/100ML-530MG/100ML-500MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2534,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "NORMOSOL-R IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17586-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-222MG/100ML-526MG/100ML-502MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2535,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "PHYSIOLYTE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19024-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-370MG/100ML-530MG/100ML-500MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2536,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "PHYSIOSOL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17637-2",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-222MG/100ML-526MG/100ML-502MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2537,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "PLASMA-LYTE 148 IN WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17378-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-368MG/100ML-526MG/100ML-502MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2538,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, POTASSIUM CHLORIDE, SODIUM ACETATE, SODIUM CHLORIDE AND SODIUM GLUCONATE",
        "trade_name": "PLASMA-LYTE A IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17378-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/100ML-37MG/100ML-368MG/100ML-526MG/100ML-502MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2539,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "NORMOCARB HF 25",
        "forms": [
            {
                "orange_id": "21910-1",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "0.21GM/100ML-2.8GM/100ML-9.07GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2540,
        "type": "RX",
        "ingredient": "MAGNESIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "NORMOCARB HF 35",
        "forms": [
            {
                "orange_id": "21910-2",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "0.21GM/100ML-3.97GM/100ML-8.3GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2541,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE",
        "trade_name": "MAGNESIUM SULFATE",
        "forms": [
            {
                "orange_id": "207967-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2GM/50ML (40MG/ML)",
                    "4GM/100ML (40MG/ML)",
                    "4GM/50ML (80MG/ML)"
                ]
            },
            {
                "orange_id": "206039-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "5GM/10ML (500MG/ML)",
                    "1GM/2ML (500MG/ML)",
                    "10GM/20ML (500MG/ML)",
                    "25GM/50ML (500MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2542,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE",
        "trade_name": "MAGNESIUM SULFATE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "207966-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/100ML",
                    "2GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2543,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE",
        "trade_name": "MAGNESIUM SULFATE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "211966-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2GM/50ML (40MG/ML)",
                    "4GM/50ML (80MG/ML)",
                    "4GM/100ML (40MG/ML)",
                    "20GM/500ML (40MG/ML)",
                    "40GM/1000ML (40MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2544,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, MONOBASIC, SODIUM CHLORIDE AND SODIUM PHOSPHATE",
        "trade_name": "TIS-U-SOL",
        "forms": [
            {
                "orange_id": "18508-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "20MG/100ML-40MG/100ML-6.25MG/100ML-800MG/100ML-8.75MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2545,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE, POTASSIUM CHLORIDE, POTASSIUM PHOSPHATE, MONOBASIC, SODIUM CHLORIDE AND SODIUM PHOSPHATE",
        "trade_name": "TIS-U-SOL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18336-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "20MG/100ML-40MG/100ML-6.25MG/100ML-800MG/100ML-8.75MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2546,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE, POTASSIUM CHLORIDE AND SODIUM SULFATE",
        "trade_name": "SUTAB",
        "forms": [
            {
                "orange_id": "213135-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.225GM-0.188GM-1.479GM"
                ]
            }
        ]
    },
    {
        "id": 2547,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE, POTASSIUM SULFATE AND SODIUM SULFATE",
        "trade_name": "SODIUM SULFATE, POTASSIUM SULFATE AND MAGNESIUM SULFATE",
        "forms": [
            {
                "orange_id": "202511-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1.6GM/BOT-3.13GM/BOT-17.5GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 2548,
        "type": "RX",
        "ingredient": "MAGNESIUM SULFATE, POTASSIUM SULFATE AND SODIUM SULFATE",
        "trade_name": "SUPREP BOWEL PREP KIT",
        "forms": [
            {
                "orange_id": "22372-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1.6GM/BOT-3.13GM/BOT-17.5GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 2549,
        "type": "RX",
        "ingredient": "MALATHION",
        "trade_name": "MALATHION",
        "forms": [
            {
                "orange_id": "91559-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 2550,
        "type": "RX",
        "ingredient": "MANGANESE CHLORIDE",
        "trade_name": "MANGANESE CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18962-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.1MG MANGANESE/ML"
                ]
            }
        ]
    },
    {
        "id": 2551,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "ARIDOL KIT",
        "forms": [
            {
                "orange_id": "22368-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "N/A,5MG,10MG,20MG,40MG"
                ]
            }
        ]
    },
    {
        "id": 2552,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "BRONCHITOL",
        "forms": [
            {
                "orange_id": "202049-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2553,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "MANNITOL 10% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20006-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2554,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "MANNITOL 15% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20006-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2555,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "MANNITOL 20% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20006-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2556,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "MANNITOL 25%",
        "forms": [
            {
                "orange_id": "80677-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "12.5GM/50ML"
                ]
            }
        ]
    },
    {
        "id": 2557,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "MANNITOL 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "20006-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2558,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 10% IN WATER",
        "forms": [
            {
                "orange_id": "13684-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2559,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 10% IN WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "13684-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2560,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 15% IN WATER",
        "forms": [
            {
                "orange_id": "13684-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2561,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 15% IN WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "13684-8",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2562,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 20% IN WATER",
        "forms": [
            {
                "orange_id": "13684-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2563,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 20% IN WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "13684-7",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2564,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 5% IN WATER",
        "forms": [
            {
                "orange_id": "13684-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2565,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "OSMITROL 5% IN WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "13684-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2566,
        "type": "RX",
        "ingredient": "MANNITOL",
        "trade_name": "RESECTISOL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16772-2",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2567,
        "type": "RX",
        "ingredient": "MANNITOL AND SORBITOL",
        "trade_name": "SORBITOL-MANNITOL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18316-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "540MG/100ML-2.7GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 2568,
        "type": "RX",
        "ingredient": "MARALIXIBAT CHLORIDE",
        "trade_name": "LIVMARLI",
        "forms": [
            {
                "orange_id": "214662-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 9.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2569,
        "type": "RX",
        "ingredient": "MARAVIROC",
        "trade_name": "MARAVIROC",
        "forms": [
            {
                "orange_id": "203347-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2570,
        "type": "RX",
        "ingredient": "MARAVIROC",
        "trade_name": "SELZENTRY",
        "forms": [
            {
                "orange_id": "208984-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MG/ML"
                ]
            },
            {
                "orange_id": "22128-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "75MG",
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2571,
        "type": "RX",
        "ingredient": "MARIBAVIR",
        "trade_name": "LIVTENCITY",
        "forms": [
            {
                "orange_id": "215596-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2572,
        "type": "RX",
        "ingredient": "MEBENDAZOLE",
        "trade_name": "EMVERM",
        "forms": [
            {
                "orange_id": "73580-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2573,
        "type": "RX",
        "ingredient": "MECAMYLAMINE HYDROCHLORIDE",
        "trade_name": "MECAMYLAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204054-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 2574,
        "type": "RX",
        "ingredient": "MECHLORETHAMINE HYDROCHLORIDE",
        "trade_name": "VALCHLOR",
        "forms": [
            {
                "orange_id": "202317-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 0.016% BASE"
                ]
            }
        ]
    },
    {
        "id": 2575,
        "type": "RX",
        "ingredient": "MECLIZINE HYDROCHLORIDE",
        "trade_name": "ANTIVERT",
        "forms": [
            {
                "orange_id": "10721-5",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            },
            {
                "orange_id": "10721-6",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2576,
        "type": "RX",
        "ingredient": "MECLIZINE HYDROCHLORIDE",
        "trade_name": "MECLIZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "201451-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2577,
        "type": "RX",
        "ingredient": "MECLOFENAMATE SODIUM",
        "trade_name": "MECLOFENAMATE SODIUM",
        "forms": [
            {
                "orange_id": "71081-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2578,
        "type": "RX",
        "ingredient": "MEDROXYPROGESTERONE ACETATE",
        "trade_name": "DEPO-PROVERA",
        "forms": [
            {
                "orange_id": "20246-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2579,
        "type": "RX",
        "ingredient": "MEDROXYPROGESTERONE ACETATE",
        "trade_name": "DEPO-SUBQ PROVERA 104",
        "forms": [
            {
                "orange_id": "21583-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "104MG/0.65ML"
                ]
            }
        ]
    },
    {
        "id": 2580,
        "type": "RX",
        "ingredient": "MEDROXYPROGESTERONE ACETATE",
        "trade_name": "MEDROXYPROGESTERONE ACETATE",
        "forms": [
            {
                "orange_id": "77235-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/ML"
                ]
            },
            {
                "orange_id": "40159-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2581,
        "type": "RX",
        "ingredient": "MEDROXYPROGESTERONE ACETATE",
        "trade_name": "PROVERA",
        "forms": [
            {
                "orange_id": "11839-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2582,
        "type": "RX",
        "ingredient": "MEFENAMIC ACID",
        "trade_name": "MEFENAMIC ACID",
        "forms": [
            {
                "orange_id": "91608-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2583,
        "type": "RX",
        "ingredient": "MEFENAMIC ACID",
        "trade_name": "PONSTEL",
        "forms": [
            {
                "orange_id": "15034-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2584,
        "type": "RX",
        "ingredient": "MEFLOQUINE HYDROCHLORIDE",
        "trade_name": "MEFLOQUINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76392-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2585,
        "type": "RX",
        "ingredient": "MEGESTROL ACETATE",
        "trade_name": "MEGACE ES",
        "forms": [
            {
                "orange_id": "21778-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2586,
        "type": "RX",
        "ingredient": "MEGESTROL ACETATE",
        "trade_name": "MEGESTROL ACETATE",
        "forms": [
            {
                "orange_id": "203960-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML",
                    "125MG/ML"
                ]
            },
            {
                "orange_id": "74621-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2587,
        "type": "RX",
        "ingredient": "MELOXICAM",
        "trade_name": "ANJESO",
        "forms": [
            {
                "orange_id": "210583-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "30MG/ML (30MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2588,
        "type": "RX",
        "ingredient": "MELOXICAM",
        "trade_name": "MELOXICAM",
        "forms": [
            {
                "orange_id": "209487-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "77882-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7.5MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 2589,
        "type": "RX",
        "ingredient": "MELOXICAM",
        "trade_name": "MOBIC",
        "forms": [
            {
                "orange_id": "20938-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7.5MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 2590,
        "type": "RX",
        "ingredient": "MELPHALAN",
        "trade_name": "MELPHALAN",
        "forms": [
            {
                "orange_id": "207809-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2591,
        "type": "RX",
        "ingredient": "MELPHALAN HYDROCHLORIDE",
        "trade_name": "EVOMELA",
        "forms": [
            {
                "orange_id": "207155-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2592,
        "type": "RX",
        "ingredient": "MELPHALAN HYDROCHLORIDE",
        "trade_name": "MELPHALAN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206018-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2593,
        "type": "RX",
        "ingredient": "MEMANTINE HYDROCHLORIDE",
        "trade_name": "MEMANTINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205825-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "7MG",
                    "14MG",
                    "21MG",
                    "28MG"
                ]
            },
            {
                "orange_id": "209955-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "2MG/ML"
                ]
            },
            {
                "orange_id": "206528-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2594,
        "type": "RX",
        "ingredient": "MEMANTINE HYDROCHLORIDE",
        "trade_name": "NAMENDA",
        "forms": [
            {
                "orange_id": "21487-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2595,
        "type": "RX",
        "ingredient": "MEMANTINE HYDROCHLORIDE",
        "trade_name": "NAMENDA XR",
        "forms": [
            {
                "orange_id": "22525-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "7MG",
                    "14MG",
                    "21MG",
                    "28MG"
                ]
            }
        ]
    },
    {
        "id": 2596,
        "type": "OTC",
        "ingredient": "MENTHOL AND METHYL SALICYLATE",
        "trade_name": "SALONPAS",
        "forms": [
            {
                "orange_id": "22029-1",
                "form": "PATCH",
                "route": "TOPICAL",
                "dosage": [
                    "3%-10%"
                ]
            }
        ]
    },
    {
        "id": 2597,
        "type": "RX",
        "ingredient": "MEPERIDINE HYDROCHLORIDE",
        "trade_name": "DEMEROL",
        "forms": [
            {
                "orange_id": "21171-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML",
                    "50MG/ML",
                    "75MG/ML",
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2598,
        "type": "RX",
        "ingredient": "MEPERIDINE HYDROCHLORIDE",
        "trade_name": "MEPERIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "80445-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML",
                    "50MG/ML",
                    "75MG/ML",
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "88744-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "40331-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2599,
        "type": "RX",
        "ingredient": "MEPERIDINE HYDROCHLORIDE",
        "trade_name": "MEPERIDINE HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "81002-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2600,
        "type": "RX",
        "ingredient": "MEPIVACAINE HYDROCHLORIDE",
        "trade_name": "CARBOCAINE",
        "forms": [
            {
                "orange_id": "12250-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "1.5%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2601,
        "type": "RX",
        "ingredient": "MEPIVACAINE HYDROCHLORIDE",
        "trade_name": "POLOCAINE",
        "forms": [
            {
                "orange_id": "89407-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2602,
        "type": "RX",
        "ingredient": "MEPIVACAINE HYDROCHLORIDE",
        "trade_name": "POLOCAINE-MPF",
        "forms": [
            {
                "orange_id": "89406-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1%",
                    "1.5%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2603,
        "type": "RX",
        "ingredient": "MEPIVACAINE HYDROCHLORIDE",
        "trade_name": "SCANDONEST PLAIN",
        "forms": [
            {
                "orange_id": "88387-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3%"
                ]
            }
        ]
    },
    {
        "id": 2604,
        "type": "RX",
        "ingredient": "MEPROBAMATE",
        "trade_name": "MEPROBAMATE",
        "forms": [
            {
                "orange_id": "90122-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2605,
        "type": "RX",
        "ingredient": "MERCAPTOPURINE",
        "trade_name": "MERCAPTOPURINE",
        "forms": [
            {
                "orange_id": "40461-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2606,
        "type": "RX",
        "ingredient": "MERCAPTOPURINE",
        "trade_name": "PURINETHOL",
        "forms": [
            {
                "orange_id": "9053-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2607,
        "type": "RX",
        "ingredient": "MERCAPTOPURINE",
        "trade_name": "PURIXAN",
        "forms": [
            {
                "orange_id": "205919-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2608,
        "type": "RX",
        "ingredient": "MEROPENEM",
        "trade_name": "MEROPENEM",
        "forms": [
            {
                "orange_id": "91404-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2609,
        "type": "RX",
        "ingredient": "MEROPENEM",
        "trade_name": "MEROPENEM AND SODIUM CHLORIDE IN DUPLEX CONTAINER",
        "forms": [
            {
                "orange_id": "202106-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2610,
        "type": "RX",
        "ingredient": "MEROPENEM",
        "trade_name": "MERREM",
        "forms": [
            {
                "orange_id": "50706-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL",
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2611,
        "type": "RX",
        "ingredient": "MEROPENEM AND VABORBACTAM",
        "trade_name": "VABOMERE",
        "forms": [
            {
                "orange_id": "209776-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/VIAL-1GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2612,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "APRISO",
        "forms": [
            {
                "orange_id": "22301-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "375MG"
                ]
            }
        ]
    },
    {
        "id": 2613,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "ASACOL HD",
        "forms": [
            {
                "orange_id": "21830-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 2614,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "CANASA",
        "forms": [
            {
                "orange_id": "21252-2",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2615,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "DELZICOL",
        "forms": [
            {
                "orange_id": "204412-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2616,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "LIALDA",
        "forms": [
            {
                "orange_id": "22000-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.2GM"
                ]
            }
        ]
    },
    {
        "id": 2617,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "MESALAMINE",
        "forms": [
            {
                "orange_id": "207873-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            },
            {
                "orange_id": "214242-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "375MG"
                ]
            },
            {
                "orange_id": "76751-1",
                "form": "ENEMA",
                "route": "RECTAL",
                "dosage": [
                    "4GM/60ML"
                ]
            },
            {
                "orange_id": "205654-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "1GM"
                ]
            },
            {
                "orange_id": "203817-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.2GM",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 2618,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "PENTASA",
        "forms": [
            {
                "orange_id": "20049-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2619,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "ROWASA",
        "forms": [
            {
                "orange_id": "19618-1",
                "form": "ENEMA",
                "route": "RECTAL",
                "dosage": [
                    "4GM/60ML"
                ]
            }
        ]
    },
    {
        "id": 2620,
        "type": "RX",
        "ingredient": "MESALAMINE",
        "trade_name": "SFROWASA",
        "forms": [
            {
                "orange_id": "19618-2",
                "form": "ENEMA",
                "route": "RECTAL",
                "dosage": [
                    "4GM/60ML"
                ]
            }
        ]
    },
    {
        "id": 2621,
        "type": "RX",
        "ingredient": "MESNA",
        "trade_name": "MESNA",
        "forms": [
            {
                "orange_id": "75811-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2622,
        "type": "RX",
        "ingredient": "MESNA",
        "trade_name": "MESNEX",
        "forms": [
            {
                "orange_id": "19884-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "20855-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2623,
        "type": "RX",
        "ingredient": "METAPROTERENOL SULFATE",
        "trade_name": "METAPROTERENOL SULFATE",
        "forms": [
            {
                "orange_id": "73632-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "10MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2624,
        "type": "RX",
        "ingredient": "METARAMINOL BITARTRATE",
        "trade_name": "METARAMINOL BITARTRATE",
        "forms": [
            {
                "orange_id": "211304-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2625,
        "type": "RX",
        "ingredient": "METAXALONE",
        "trade_name": "METAXALONE",
        "forms": [
            {
                "orange_id": "203695-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2626,
        "type": "RX",
        "ingredient": "METAXALONE",
        "trade_name": "SKELAXIN",
        "forms": [
            {
                "orange_id": "13217-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 2627,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE",
        "trade_name": "FORTAMET",
        "forms": [
            {
                "orange_id": "21574-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2628,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE",
        "trade_name": "GLUMETZA",
        "forms": [
            {
                "orange_id": "21748-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2629,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE",
        "trade_name": "METFORMIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "211309-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "500MG/5ML"
                ]
            },
            {
                "orange_id": "203755-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG",
                    "750MG"
                ]
            },
            {
                "orange_id": "91184-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG",
                    "850MG",
                    "625MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2630,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE",
        "trade_name": "RIOMET",
        "forms": [
            {
                "orange_id": "21591-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "500MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2631,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE AND PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "ACTOPLUS MET",
        "forms": [
            {
                "orange_id": "21842-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG-EQ 15MG BASE",
                    "850MG-EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2632,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE AND PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "PIOGLITAZONE HYDROCHLORIDE AND METFORMIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "200823-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG-EQ 15MG BASE",
                    "850MG-EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2633,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE AND SAXAGLIPTIN HYDROCHLORIDE",
        "trade_name": "KOMBIGLYZE XR",
        "forms": [
            {
                "orange_id": "200678-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM-EQ 2.5MG BASE",
                    "1GM-EQ 5MG BASE",
                    "500MG-EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2634,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE AND SITAGLIPTIN PHOSPHATE",
        "trade_name": "JANUMET",
        "forms": [
            {
                "orange_id": "22044-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM-EQ 50MG BASE",
                    "500MG-EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2635,
        "type": "RX",
        "ingredient": "METFORMIN HYDROCHLORIDE AND SITAGLIPTIN PHOSPHATE",
        "trade_name": "JANUMET XR",
        "forms": [
            {
                "orange_id": "202270-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM-EQ 50MG BASE",
                    "1GM-EQ 100MG BASE",
                    "500MG-EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2636,
        "type": "RX",
        "ingredient": "METHACHOLINE CHLORIDE",
        "trade_name": "PROVOCHOLINE",
        "forms": [
            {
                "orange_id": "19193-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2637,
        "type": "RX",
        "ingredient": "METHADONE HYDROCHLORIDE",
        "trade_name": "METHADONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40180-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "208306-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "87393-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML",
                    "10MG/5ML"
                ]
            },
            {
                "orange_id": "17058-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            },
            {
                "orange_id": "211228-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2638,
        "type": "RX",
        "ingredient": "METHADONE HYDROCHLORIDE",
        "trade_name": "METHADONE HYDROCHLORIDE INTENSOL",
        "forms": [
            {
                "orange_id": "89897-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2639,
        "type": "RX",
        "ingredient": "METHADONE HYDROCHLORIDE",
        "trade_name": "METHADOSE",
        "forms": [
            {
                "orange_id": "17116-2",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "74184-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2640,
        "type": "RX",
        "ingredient": "METHAMPHETAMINE HYDROCHLORIDE",
        "trade_name": "DESOXYN",
        "forms": [
            {
                "orange_id": "5378-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2641,
        "type": "RX",
        "ingredient": "METHAMPHETAMINE HYDROCHLORIDE",
        "trade_name": "METHAMPHETAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "203846-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2642,
        "type": "RX",
        "ingredient": "METHAZOLAMIDE",
        "trade_name": "METHAZOLAMIDE",
        "forms": [
            {
                "orange_id": "40001-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2643,
        "type": "RX",
        "ingredient": "METHENAMINE HIPPURATE",
        "trade_name": "METHENAMINE HIPPURATE",
        "forms": [
            {
                "orange_id": "205661-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2644,
        "type": "RX",
        "ingredient": "METHENAMINE HIPPURATE",
        "trade_name": "UREX",
        "forms": [
            {
                "orange_id": "16151-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2645,
        "type": "RX",
        "ingredient": "METHIMAZOLE",
        "trade_name": "METHIMAZOLE",
        "forms": [
            {
                "orange_id": "40547-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2646,
        "type": "RX",
        "ingredient": "METHOCARBAMOL",
        "trade_name": "METHOCARBAMOL",
        "forms": [
            {
                "orange_id": "207496-1",
                "form": "SOLUTION",
                "route": "IM-IV",
                "dosage": [
                    "1GM/10ML (100MG/ML)"
                ]
            },
            {
                "orange_id": "200958-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2647,
        "type": "RX",
        "ingredient": "METHOCARBAMOL",
        "trade_name": "ROBAXIN",
        "forms": [
            {
                "orange_id": "11790-1",
                "form": "SOLUTION",
                "route": "IM-IV",
                "dosage": [
                    "1GM/10ML (100MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2648,
        "type": "RX",
        "ingredient": "METHOHEXITAL SODIUM",
        "trade_name": "BREVITAL SODIUM",
        "forms": [
            {
                "orange_id": "11559-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2649,
        "type": "RX",
        "ingredient": "METHOTREXATE",
        "trade_name": "OTREXUP",
        "forms": [
            {
                "orange_id": "204824-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "10MG/0.4ML (10MG/0.4ML)",
                    "12.5MG/0.4ML (12.5MG/0.4ML)",
                    "15MG/0.4ML (15MG/0.4ML)",
                    "17.5MG/0.4ML (17.5MG/0.4ML)",
                    "20MG/0.4ML (20MG/0.4ML)",
                    "22.5MG/0.4ML (22.5MG/0.4ML)",
                    "25MG/0.4ML (25MG/0.4ML)"
                ]
            }
        ]
    },
    {
        "id": 2650,
        "type": "RX",
        "ingredient": "METHOTREXATE",
        "trade_name": "RASUVO",
        "forms": [
            {
                "orange_id": "205776-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "7.5MG/0.15ML (7.5MG/0.15ML)",
                    "10MG/0.20ML (10MG/0.20ML)",
                    "12.5MG/0.25ML (12.5MG/0.25ML)",
                    "15MG/0.30ML (15MG/0.30ML)",
                    "17.5MG/0.35ML (17.5MG/0.35ML)",
                    "20MG/0.4ML (20MG/0.4ML)",
                    "22.5MG/0.45ML (22.5MG/0.45ML)",
                    "25MG/0.5ML (25MG/0.5ML)",
                    "30MG/0.6ML (30MG/0.6ML)"
                ]
            }
        ]
    },
    {
        "id": 2651,
        "type": "RX",
        "ingredient": "METHOTREXATE",
        "trade_name": "REDITREX",
        "forms": [
            {
                "orange_id": "210737-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "7.5MG/0.3ML (7.5MG/0.3ML)",
                    "10MG/0.4ML (10MG/0.4ML)",
                    "12.5MG/0.5ML (12.5MG/0.5ML)",
                    "15MG/0.6ML (15MG/0.6ML)",
                    "17.5MG/0.7ML (17.5MG/0.7ML)",
                    "20MG/0.8ML (20MG/0.8ML)",
                    "22.5MG/ML (22.5MG/ML)",
                    "25MG/1ML (25MG/1ML)"
                ]
            }
        ]
    },
    {
        "id": 2652,
        "type": "RX",
        "ingredient": "METHOTREXATE SODIUM",
        "trade_name": "METHOTREXATE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "40266-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2653,
        "type": "RX",
        "ingredient": "METHOTREXATE SODIUM",
        "trade_name": "METHOTREXATE SODIUM",
        "forms": [
            {
                "orange_id": "40263-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50MG BASE/2ML (EQ 25MG BASE/ML)",
                    "EQ 100MG BASE/4ML (EQ 25MG BASE/ML)",
                    "EQ 200MG BASE/8ML (EQ 25MG BASE/ML)"
                ]
            },
            {
                "orange_id": "213343-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2654,
        "type": "RX",
        "ingredient": "METHOTREXATE SODIUM",
        "trade_name": "METHOTREXATE SODIUM PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "40716-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/40ML (EQ 25MG BASE/ML)",
                    "EQ 50MG BASE/2ML (EQ 25MG BASE/ML)",
                    "EQ 250MG BASE/10ML (EQ 25MG BASE/ML)",
                    "EQ 1GM BASE/VIAL",
                    "EQ 100MG BASE/4ML (EQ 25MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2655,
        "type": "RX",
        "ingredient": "METHOTREXATE SODIUM",
        "trade_name": "TREXALL",
        "forms": [
            {
                "orange_id": "40385-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 7.5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2656,
        "type": "RX",
        "ingredient": "METHOTREXATE SODIUM",
        "trade_name": "XATMEP",
        "forms": [
            {
                "orange_id": "208400-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2657,
        "type": "RX",
        "ingredient": "METHOXSALEN",
        "trade_name": "METHOXSALEN",
        "forms": [
            {
                "orange_id": "202687-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2658,
        "type": "RX",
        "ingredient": "METHOXSALEN",
        "trade_name": "OXSORALEN-ULTRA",
        "forms": [
            {
                "orange_id": "19600-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2659,
        "type": "RX",
        "ingredient": "METHOXSALEN",
        "trade_name": "UVADEX",
        "forms": [
            {
                "orange_id": "20969-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.02MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2660,
        "type": "RX",
        "ingredient": "METHSCOPOLAMINE BROMIDE",
        "trade_name": "METHSCOPOLAMINE BROMIDE",
        "forms": [
            {
                "orange_id": "200602-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2661,
        "type": "RX",
        "ingredient": "METHSUXIMIDE",
        "trade_name": "CELONTIN",
        "forms": [
            {
                "orange_id": "10596-8",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2662,
        "type": "RX",
        "ingredient": "METHYLDOPA",
        "trade_name": "METHYLDOPA",
        "forms": [
            {
                "orange_id": "70084-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2663,
        "type": "RX",
        "ingredient": "METHYLENE BLUE",
        "trade_name": "PROVAYBLUE",
        "forms": [
            {
                "orange_id": "204630-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/2ML (5MG/ML)",
                    "50MG/10ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2664,
        "type": "RX",
        "ingredient": "METHYLERGONOVINE MALEATE",
        "trade_name": "METHERGINE",
        "forms": [
            {
                "orange_id": "6035-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2665,
        "type": "RX",
        "ingredient": "METHYLERGONOVINE MALEATE",
        "trade_name": "METHYLERGONOVINE MALEATE",
        "forms": [
            {
                "orange_id": "90193-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.2MG/ML"
                ]
            },
            {
                "orange_id": "211483-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 2666,
        "type": "RX",
        "ingredient": "METHYLNALTREXONE BROMIDE",
        "trade_name": "RELISTOR",
        "forms": [
            {
                "orange_id": "21964-2",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "8MG/0.4ML (8MG/0.4ML)",
                    "12MG/0.6ML (12MG/0.6ML)"
                ]
            },
            {
                "orange_id": "208271-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2667,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE",
        "trade_name": "COTEMPLA XR-ODT",
        "forms": [
            {
                "orange_id": "205489-1",
                "form": "TABLET, ORALLY DISINTEGRATING, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8.6MG",
                    "17.3MG",
                    "25.9MG"
                ]
            }
        ]
    },
    {
        "id": 2668,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE",
        "trade_name": "DAYTRANA",
        "forms": [
            {
                "orange_id": "21514-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "10MG/9HR (1.1MG/HR)",
                    "15MG/9HR (1.6MG/HR)",
                    "20MG/9HR (2.2MG/HR)",
                    "30MG/9HR (3.3MG/HR)"
                ]
            }
        ]
    },
    {
        "id": 2669,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "ADHANSIA XR",
        "forms": [
            {
                "orange_id": "212038-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "35MG",
                    "45MG",
                    "55MG",
                    "70MG",
                    "85MG"
                ]
            }
        ]
    },
    {
        "id": 2670,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "APTENSIO XR",
        "forms": [
            {
                "orange_id": "205831-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 2671,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "CONCERTA",
        "forms": [
            {
                "orange_id": "21121-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "18MG",
                    "27MG",
                    "36MG",
                    "54MG"
                ]
            }
        ]
    },
    {
        "id": 2672,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "JORNAY PM",
        "forms": [
            {
                "orange_id": "209311-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "60MG",
                    "80MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2673,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "METADATE CD",
        "forms": [
            {
                "orange_id": "21259-3",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 2674,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "METHYLIN",
        "forms": [
            {
                "orange_id": "21419-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML",
                    "10MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2675,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "METHYLIN ER",
        "forms": [
            {
                "orange_id": "75629-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2676,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "METHYLPHENIDATE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208861-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "50MG",
                    "60MG"
                ]
            },
            {
                "orange_id": "206049-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "207485-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML",
                    "10MG/5ML"
                ]
            },
            {
                "orange_id": "210354-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "207488-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "18MG",
                    "27MG",
                    "36MG",
                    "54MG",
                    "72MG"
                ]
            },
            {
                "orange_id": "206932-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2677,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "QUILLICHEW ER",
        "forms": [
            {
                "orange_id": "207960-1",
                "form": "TABLET, EXTENDED RELEASE, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2678,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "QUILLIVANT XR",
        "forms": [
            {
                "orange_id": "202100-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2679,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "RITALIN",
        "forms": [
            {
                "orange_id": "10187-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2680,
        "type": "RX",
        "ingredient": "METHYLPHENIDATE HYDROCHLORIDE",
        "trade_name": "RITALIN LA",
        "forms": [
            {
                "orange_id": "21284-4",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2681,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE",
        "trade_name": "MEDROL",
        "forms": [
            {
                "orange_id": "11153-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "8MG",
                    "16MG",
                    "32MG"
                ]
            }
        ]
    },
    {
        "id": 2682,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE",
        "trade_name": "METHYLPREDNISOLONE",
        "forms": [
            {
                "orange_id": "207481-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG",
                    "16MG",
                    "32MG"
                ]
            }
        ]
    },
    {
        "id": 2683,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE ACETATE",
        "trade_name": "DEPO-MEDROL",
        "forms": [
            {
                "orange_id": "11757-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML",
                    "40MG/ML",
                    "80MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2684,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE ACETATE",
        "trade_name": "METHYLPREDNISOLONE ACETATE",
        "forms": [
            {
                "orange_id": "210043-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/ML",
                    "80MG/ML",
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2685,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE SODIUM SUCCINATE",
        "trade_name": "METHYLPREDNISOLONE SODIUM SUCCINATE",
        "forms": [
            {
                "orange_id": "207549-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 40MG BASE/VIAL",
                    "EQ 125MG BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2686,
        "type": "RX",
        "ingredient": "METHYLPREDNISOLONE SODIUM SUCCINATE",
        "trade_name": "SOLU-MEDROL",
        "forms": [
            {
                "orange_id": "11856-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 40MG BASE/VIAL",
                    "EQ 125MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2687,
        "type": "RX",
        "ingredient": "METHYLTESTOSTERONE",
        "trade_name": "ANDROID 25",
        "forms": [
            {
                "orange_id": "87147-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 2688,
        "type": "RX",
        "ingredient": "METHYLTESTOSTERONE",
        "trade_name": "METHYLTESTOSTERONE",
        "forms": [
            {
                "orange_id": "204851-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "80767-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2689,
        "type": "RX",
        "ingredient": "METOCLOPRAMIDE HYDROCHLORIDE",
        "trade_name": "GIMOTI",
        "forms": [
            {
                "orange_id": "209388-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "EQ 15MG BASE/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2690,
        "type": "RX",
        "ingredient": "METOCLOPRAMIDE HYDROCHLORIDE",
        "trade_name": "METOCLOPRAMIDE",
        "forms": [
            {
                "orange_id": "204756-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    " EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2691,
        "type": "RX",
        "ingredient": "METOCLOPRAMIDE HYDROCHLORIDE",
        "trade_name": "METOCLOPRAMIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91392-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            },
            {
                "orange_id": "71402-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE/5ML"
                ]
            },
            {
                "orange_id": "202191-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            },
            {
                "orange_id": "71250-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2692,
        "type": "RX",
        "ingredient": "METOCLOPRAMIDE HYDROCHLORIDE",
        "trade_name": "REGLAN",
        "forms": [
            {
                "orange_id": "17854-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2693,
        "type": "RX",
        "ingredient": "METOLAZONE",
        "trade_name": "METOLAZONE",
        "forms": [
            {
                "orange_id": "213251-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2694,
        "type": "RX",
        "ingredient": "METOPROLOL SUCCINATE",
        "trade_name": "KAPSPARGO SPRINKLE",
        "forms": [
            {
                "orange_id": "210428-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG TARTRATE",
                    "EQ 50MG TARTRATE",
                    "EQ 100MG TARTRATE",
                    "EQ 200MG TARTRATE"
                ]
            }
        ]
    },
    {
        "id": 2695,
        "type": "RX",
        "ingredient": "METOPROLOL SUCCINATE",
        "trade_name": "METOPROLOL SUCCINATE",
        "forms": [
            {
                "orange_id": "204161-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG TARTRATE",
                    "EQ 50MG TARTRATE",
                    "EQ 100MG TARTRATE",
                    "EQ 200MG TARTRATE"
                ]
            }
        ]
    },
    {
        "id": 2696,
        "type": "RX",
        "ingredient": "METOPROLOL SUCCINATE",
        "trade_name": "TOPROL-XL",
        "forms": [
            {
                "orange_id": "19962-4",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG TARTRATE",
                    "EQ 50MG TARTRATE",
                    "EQ 100MG TARTRATE",
                    "EQ 200MG TARTRATE"
                ]
            }
        ]
    },
    {
        "id": 2697,
        "type": "RX",
        "ingredient": "METOPROLOL TARTRATE",
        "trade_name": "LOPRESSOR",
        "forms": [
            {
                "orange_id": "17963-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2698,
        "type": "RX",
        "ingredient": "METOPROLOL TARTRATE",
        "trade_name": "METOPROLOL TARTRATE",
        "forms": [
            {
                "orange_id": "78950-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "202871-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "37.5MG",
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 2699,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "FLAGYL",
        "forms": [
            {
                "orange_id": "20334-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "375MG"
                ]
            },
            {
                "orange_id": "12623-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2700,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "FLAGYL I. V. RTU IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18657-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2701,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METRO I. V. IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18900-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2702,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METROCREAM",
        "forms": [
            {
                "orange_id": "20531-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 2703,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METROGEL",
        "forms": [
            {
                "orange_id": "19737-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%",
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2704,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METROGEL-VAGINAL",
        "forms": [
            {
                "orange_id": "20208-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 2705,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METROLOTION",
        "forms": [
            {
                "orange_id": "20901-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 2706,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METRONIDAZOLE",
        "forms": [
            {
                "orange_id": "79065-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "375MG"
                ]
            },
            {
                "orange_id": "77549-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%"
                ]
            },
            {
                "orange_id": "212646-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%",
                    "0.75%"
                ]
            },
            {
                "orange_id": "215794-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "0.75%"
                ]
            },
            {
                "orange_id": "77197-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.75%"
                ]
            },
            {
                "orange_id": "208681-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2707,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "METRONIDAZOLE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "78084-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2708,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "NORITATE",
        "forms": [
            {
                "orange_id": "20743-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2709,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "NUVESSA",
        "forms": [
            {
                "orange_id": "205223-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "1.3%"
                ]
            }
        ]
    },
    {
        "id": 2710,
        "type": "RX",
        "ingredient": "METRONIDAZOLE",
        "trade_name": "VANDAZOLE",
        "forms": [
            {
                "orange_id": "21806-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "0.75%"
                ]
            }
        ]
    },
    {
        "id": 2711,
        "type": "RX",
        "ingredient": "METYRAPONE",
        "trade_name": "METOPIRONE",
        "forms": [
            {
                "orange_id": "12911-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2712,
        "type": "RX",
        "ingredient": "METYROSINE",
        "trade_name": "DEMSER",
        "forms": [
            {
                "orange_id": "17871-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2713,
        "type": "RX",
        "ingredient": "METYROSINE",
        "trade_name": "METYROSINE",
        "forms": [
            {
                "orange_id": "213734-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2714,
        "type": "RX",
        "ingredient": "MEXILETINE HYDROCHLORIDE",
        "trade_name": "MEXILETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74450-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "200MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2715,
        "type": "RX",
        "ingredient": "MICAFUNGIN SODIUM",
        "trade_name": "MICAFUNGIN",
        "forms": [
            {
                "orange_id": "212156-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2716,
        "type": "RX",
        "ingredient": "MICAFUNGIN SODIUM",
        "trade_name": "MICAFUNGIN SODIUM",
        "forms": [
            {
                "orange_id": "208366-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2717,
        "type": "RX",
        "ingredient": "MICAFUNGIN SODIUM",
        "trade_name": "MYCAMINE",
        "forms": [
            {
                "orange_id": "21506-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 50MG BASE/VIAL",
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2718,
        "type": "RX",
        "ingredient": "MICONAZOLE",
        "trade_name": "ORAVIG",
        "forms": [
            {
                "orange_id": "22404-1",
                "form": "TABLET",
                "route": "BUCCAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2719,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MICONAZOLE 3",
        "forms": [
            {
                "orange_id": "76773-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 2720,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MICONAZOLE 3 COMBINATION PACK",
        "forms": [
            {
                "orange_id": "76357-1",
                "form": "CREAM",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,4%"
                ]
            }
        ]
    },
    {
        "id": 2721,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MICONAZOLE 7",
        "forms": [
            {
                "orange_id": "74164-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2722,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MICONAZOLE NITRATE",
        "forms": [
            {
                "orange_id": "79114-1",
                "form": "CREAM, INSERT",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,1.2GM"
                ]
            },
            {
                "orange_id": "74366-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "2%",
                    "4%"
                ]
            },
            {
                "orange_id": "73508-1",
                "form": "SUPPOSITORY",
                "route": "VAGINAL",
                "dosage": [
                    "200MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2723,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MICONAZOLE NITRATE COMBINATION PACK",
        "forms": [
            {
                "orange_id": "75329-1",
                "form": "CREAM, SUPPOSITORY",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,200MG"
                ]
            }
        ]
    },
    {
        "id": 2724,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 1 COMBINATION PACK",
        "forms": [
            {
                "orange_id": "21308-1",
                "form": "CREAM, INSERT",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,1.2GM"
                ]
            }
        ]
    },
    {
        "id": 2725,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 3",
        "forms": [
            {
                "orange_id": "20827-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "4%"
                ]
            },
            {
                "orange_id": "18888-1",
                "form": "SUPPOSITORY",
                "route": "VAGINAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2726,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 3 COMBINATION PACK",
        "forms": [
            {
                "orange_id": "20670-2",
                "form": "CREAM, SUPPOSITORY",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,200MG"
                ]
            },
            {
                "orange_id": "21261-3",
                "form": "CREAM",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,4%"
                ]
            }
        ]
    },
    {
        "id": 2727,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 3 COMBINATION PACK (PREFILLED)",
        "forms": [
            {
                "orange_id": "21261-1",
                "form": "CREAM",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,4%"
                ]
            }
        ]
    },
    {
        "id": 2728,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 7",
        "forms": [
            {
                "orange_id": "17450-2",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "18520-2",
                "form": "SUPPOSITORY",
                "route": "VAGINAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2729,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "MONISTAT 7 COMBINATION PACK",
        "forms": [
            {
                "orange_id": "20288-2",
                "form": "CREAM, SUPPOSITORY",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,100MG"
                ]
            }
        ]
    },
    {
        "id": 2730,
        "type": "OTC",
        "ingredient": "MICONAZOLE NITRATE",
        "trade_name": "M-ZOLE 3 COMBINATION PACK",
        "forms": [
            {
                "orange_id": "74926-1",
                "form": "CREAM, SUPPOSITORY",
                "route": "TOPICAL, VAGINAL",
                "dosage": [
                    "2%,200MG"
                ]
            }
        ]
    },
    {
        "id": 2731,
        "type": "RX",
        "ingredient": "MICONAZOLE NITRATE, PETROLATUM, WHITE AND ZINC OXIDE",
        "trade_name": "VUSION",
        "forms": [
            {
                "orange_id": "21026-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.25%-81.35%-15%"
                ]
            }
        ]
    },
    {
        "id": 2732,
        "type": "RX",
        "ingredient": "MIDAZOLAM",
        "trade_name": "MIDAZOLAM IN 0. 9% SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "211844-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/50ML (1MG/ML)",
                    "100MG/100ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2733,
        "type": "RX",
        "ingredient": "MIDAZOLAM",
        "trade_name": "NAYZILAM",
        "forms": [
            {
                "orange_id": "211321-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2734,
        "type": "RX",
        "ingredient": "MIDAZOLAM HYDROCHLORIDE",
        "trade_name": "MIDAZOLAM HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75494-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML",
                    "EQ 5MG BASE/ML"
                ]
            },
            {
                "orange_id": "75958-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2735,
        "type": "RX",
        "ingredient": "MIDAZOLAM HYDROCHLORIDE",
        "trade_name": "MIDAZOLAM HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "203460-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML",
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2736,
        "type": "RX",
        "ingredient": "MIDAZOLAM HYDROCHLORIDE",
        "trade_name": "SEIZALAM",
        "forms": [
            {
                "orange_id": "209566-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 50MG BASE/10ML (EQ 5MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2737,
        "type": "RX",
        "ingredient": "MIDODRINE HYDROCHLORIDE",
        "trade_name": "MIDODRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "214734-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2738,
        "type": "RX",
        "ingredient": "MIDODRINE HYDROCHLORIDE",
        "trade_name": "ORVATEN",
        "forms": [
            {
                "orange_id": "76725-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2739,
        "type": "RX",
        "ingredient": "MIDOSTAURIN",
        "trade_name": "RYDAPT",
        "forms": [
            {
                "orange_id": "207997-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 2740,
        "type": "RX",
        "ingredient": "MIFEPRISTONE",
        "trade_name": "KORLYM",
        "forms": [
            {
                "orange_id": "202107-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2741,
        "type": "RX",
        "ingredient": "MIFEPRISTONE",
        "trade_name": "MIFEPREX",
        "forms": [
            {
                "orange_id": "20687-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2742,
        "type": "RX",
        "ingredient": "MIFEPRISTONE",
        "trade_name": "MIFEPRISTONE",
        "forms": [
            {
                "orange_id": "91178-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 2743,
        "type": "RX",
        "ingredient": "MIGALASTAT HYDROCHLORIDE",
        "trade_name": "GALAFOLD",
        "forms": [
            {
                "orange_id": "208623-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 123MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2744,
        "type": "RX",
        "ingredient": "MIGLITOL",
        "trade_name": "GLYSET",
        "forms": [
            {
                "orange_id": "20682-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2745,
        "type": "RX",
        "ingredient": "MIGLITOL",
        "trade_name": "MIGLITOL",
        "forms": [
            {
                "orange_id": "203965-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2746,
        "type": "RX",
        "ingredient": "MIGLUSTAT",
        "trade_name": "MIGLUSTAT",
        "forms": [
            {
                "orange_id": "208342-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2747,
        "type": "RX",
        "ingredient": "MIGLUSTAT",
        "trade_name": "ZAVESCA",
        "forms": [
            {
                "orange_id": "21348-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2748,
        "type": "RX",
        "ingredient": "MILNACIPRAN HYDROCHLORIDE",
        "trade_name": "SAVELLA",
        "forms": [
            {
                "orange_id": "22256-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2749,
        "type": "RX",
        "ingredient": "MILRINONE LACTATE",
        "trade_name": "MILRINONE LACTATE",
        "forms": [
            {
                "orange_id": "214380-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2750,
        "type": "RX",
        "ingredient": "MILRINONE LACTATE",
        "trade_name": "MILRINONE LACTATE IN DEXTROSE 5%",
        "forms": [
            {
                "orange_id": "209666-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/100ML (EQ 0.2MG BASE/ML)",
                    "EQ 40MG BASE/200ML (EQ 0.2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2751,
        "type": "RX",
        "ingredient": "MILRINONE LACTATE",
        "trade_name": "MILRINONE LACTATE IN DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "75834-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/100ML (EQ 0.2MG BASE/ML)",
                    "EQ 40MG BASE/200ML (EQ 0.2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2752,
        "type": "RX",
        "ingredient": "MILRINONE LACTATE",
        "trade_name": "MILRINONE LACTATE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "90038-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/100ML (EQ 0.2MG BASE/ML)",
                    "EQ 40MG BASE/200ML (EQ 0.2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2753,
        "type": "RX",
        "ingredient": "MILTEFOSINE",
        "trade_name": "IMPAVIDO",
        "forms": [
            {
                "orange_id": "204684-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2754,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "AMZEEQ",
        "forms": [
            {
                "orange_id": "212379-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 4% BASE"
                ]
            }
        ]
    },
    {
        "id": 2755,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "ARESTIN",
        "forms": [
            {
                "orange_id": "50781-1",
                "form": "POWDER, EXTENDED RELEASE",
                "route": "DENTAL",
                "dosage": [
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2756,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "DYNACIN",
        "forms": [
            {
                "orange_id": "63067-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2757,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "MINOCIN",
        "forms": [
            {
                "orange_id": "50649-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            },
            {
                "orange_id": "50444-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2758,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "MINOCYCLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65470-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            },
            {
                "orange_id": "204453-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 45MG BASE",
                    "EQ 55MG BASE",
                    "EQ 65MG BASE",
                    "EQ 80MG BASE",
                    "EQ 90MG BASE",
                    "EQ 105MG BASE",
                    "EQ 115MG BASE",
                    "EQ 135MG BASE"
                ]
            },
            {
                "orange_id": "213662-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2759,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "MINOLIRA",
        "forms": [
            {
                "orange_id": "209269-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 105MG BASE",
                    "EQ 135MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2760,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "SOLODYN",
        "forms": [
            {
                "orange_id": "50808-8",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 55MG BASE",
                    "EQ 65MG BASE",
                    "EQ 80MG BASE",
                    "EQ 105MG BASE",
                    "EQ 115MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2761,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "XIMINO",
        "forms": [
            {
                "orange_id": "201922-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 45MG BASE",
                    "EQ 90MG BASE",
                    "EQ 135MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2762,
        "type": "RX",
        "ingredient": "MINOCYCLINE HYDROCHLORIDE",
        "trade_name": "ZILXI",
        "forms": [
            {
                "orange_id": "213690-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 2763,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "MEN'S ROGAINE",
        "forms": [
            {
                "orange_id": "21812-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2764,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "MINOXIDIL",
        "forms": [
            {
                "orange_id": "91344-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "71826-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2765,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "MINOXIDIL (FOR MEN)",
        "forms": [
            {
                "orange_id": "208092-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "74731-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2766,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "MINOXIDIL (FOR WOMEN)",
        "forms": [
            {
                "orange_id": "208092-2",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "74731-2",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2767,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "MINOXIDIL EXTRA STRENGTH (FOR MEN)",
        "forms": [
            {
                "orange_id": "75518-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2768,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "ROGAINE (FOR MEN)",
        "forms": [
            {
                "orange_id": "19501-2",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2769,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "ROGAINE (FOR WOMEN)",
        "forms": [
            {
                "orange_id": "19501-3",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2770,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "ROGAINE EXTRA STRENGTH (FOR MEN)",
        "forms": [
            {
                "orange_id": "20834-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2771,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "THEROXIDIL",
        "forms": [
            {
                "orange_id": "78176-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "2%",
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2772,
        "type": "OTC",
        "ingredient": "MINOXIDIL",
        "trade_name": "WOMEN'S ROGAINE",
        "forms": [
            {
                "orange_id": "21812-2",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2773,
        "type": "RX",
        "ingredient": "MIRABEGRON",
        "trade_name": "MYRBETRIQ",
        "forms": [
            {
                "orange_id": "202611-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2774,
        "type": "RX",
        "ingredient": "MIRABEGRON",
        "trade_name": "MYRBETRIQ GRANULES",
        "forms": [
            {
                "orange_id": "213801-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2775,
        "type": "RX",
        "ingredient": "MIRTAZAPINE",
        "trade_name": "MIRTAZAPINE",
        "forms": [
            {
                "orange_id": "77376-2",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "45MG"
                ]
            },
            {
                "orange_id": "77666-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "45MG",
                    "7.5MG"
                ]
            }
        ]
    },
    {
        "id": 2776,
        "type": "RX",
        "ingredient": "MIRTAZAPINE",
        "trade_name": "REMERON",
        "forms": [
            {
                "orange_id": "20415-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2777,
        "type": "RX",
        "ingredient": "MIRTAZAPINE",
        "trade_name": "REMERON SOLTAB",
        "forms": [
            {
                "orange_id": "21208-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "45MG"
                ]
            }
        ]
    },
    {
        "id": 2778,
        "type": "RX",
        "ingredient": "MISOPROSTOL",
        "trade_name": "CYTOTEC",
        "forms": [
            {
                "orange_id": "19268-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 2779,
        "type": "RX",
        "ingredient": "MISOPROSTOL",
        "trade_name": "MISOPROSTOL",
        "forms": [
            {
                "orange_id": "91667-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.1MG",
                    "0.2MG"
                ]
            }
        ]
    },
    {
        "id": 2780,
        "type": "RX",
        "ingredient": "MITOMYCIN",
        "trade_name": "JELMYTO",
        "forms": [
            {
                "orange_id": "211728-1",
                "form": "POWDER",
                "route": "PYELOCALYCEAL",
                "dosage": [
                    "40MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2781,
        "type": "RX",
        "ingredient": "MITOMYCIN",
        "trade_name": "MITOMYCIN",
        "forms": [
            {
                "orange_id": "64144-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/VIAL",
                    "20MG/VIAL",
                    "40MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2782,
        "type": "RX",
        "ingredient": "MITOMYCIN",
        "trade_name": "MITOSOL",
        "forms": [
            {
                "orange_id": "22572-1",
                "form": "FOR SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.2MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2783,
        "type": "RX",
        "ingredient": "MITOTANE",
        "trade_name": "LYSODREN",
        "forms": [
            {
                "orange_id": "16885-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2784,
        "type": "RX",
        "ingredient": "MITOXANTRONE HYDROCHLORIDE",
        "trade_name": "MITOXANTRONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77496-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/10ML (EQ 2MG BASE/ML)",
                    "EQ 25MG BASE/12.5ML (EQ 2MG BASE/ML)",
                    "EQ 30MG BASE/15ML (EQ 2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2785,
        "type": "RX",
        "ingredient": "MIVACURIUM CHLORIDE",
        "trade_name": "MIVACURIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "209708-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 10MG BASE/5ML (EQ 2MG BASE/ML)",
                    "EQ 20MG BASE/10ML (EQ 2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2786,
        "type": "RX",
        "ingredient": "MOBOCERTINIB SUCCINATE",
        "trade_name": "EXKIVITY",
        "forms": [
            {
                "orange_id": "215310-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2787,
        "type": "RX",
        "ingredient": "MODAFINIL",
        "trade_name": "MODAFINIL",
        "forms": [
            {
                "orange_id": "202700-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2788,
        "type": "RX",
        "ingredient": "MODAFINIL",
        "trade_name": "PROVIGIL",
        "forms": [
            {
                "orange_id": "20717-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2789,
        "type": "RX",
        "ingredient": "MOEXIPRIL HYDROCHLORIDE",
        "trade_name": "MOEXIPRIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78454-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7.5MG",
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 2790,
        "type": "RX",
        "ingredient": "MOLINDONE HYDROCHLORIDE",
        "trade_name": "MOLINDONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90453-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 2791,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE",
        "trade_name": "ASMANEX HFA",
        "forms": [
            {
                "orange_id": "205641-3",
                "form": "AEROSOL, METERED",
                "route": "INHALATION",
                "dosage": [
                    "0.05MG/INH",
                    "0.10MG/INH",
                    "0.20MG/INH"
                ]
            }
        ]
    },
    {
        "id": 2792,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE",
        "trade_name": "ASMANEX TWISTHALER",
        "forms": [
            {
                "orange_id": "21067-2",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "0.11MG/INH",
                    "0.22MG/INH"
                ]
            }
        ]
    },
    {
        "id": 2793,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE",
        "trade_name": "ELOCON",
        "forms": [
            {
                "orange_id": "19796-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2794,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE",
        "trade_name": "MOMETASONE FUROATE",
        "forms": [
            {
                "orange_id": "77447-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "77678-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "77401-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "207989-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.05MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2795,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE",
        "trade_name": "SINUVA",
        "forms": [
            {
                "orange_id": "209310-1",
                "form": "IMPLANT",
                "route": "IMPLANTATION",
                "dosage": [
                    "1.35MG"
                ]
            }
        ]
    },
    {
        "id": 2796,
        "type": "RX",
        "ingredient": "MOMETASONE FUROATE AND OLOPATADINE HYDROCHLORIDE",
        "trade_name": "RYALTRIS",
        "forms": [
            {
                "orange_id": "211746-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.025MG/SPRAY-0.665MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2797,
        "type": "RX",
        "ingredient": "MONOMETHYL FUMARATE",
        "trade_name": "BAFIERTAM",
        "forms": [
            {
                "orange_id": "210296-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "95MG"
                ]
            }
        ]
    },
    {
        "id": 2798,
        "type": "RX",
        "ingredient": "MONTELUKAST SODIUM",
        "trade_name": "MONTELUKAST SODIUM",
        "forms": [
            {
                "orange_id": "203438-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE/PACKET"
                ]
            },
            {
                "orange_id": "209011-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "202717-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2799,
        "type": "RX",
        "ingredient": "MONTELUKAST SODIUM",
        "trade_name": "SINGULAIR",
        "forms": [
            {
                "orange_id": "21409-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE/PACKET"
                ]
            },
            {
                "orange_id": "20830-2",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "20829-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2800,
        "type": "RX",
        "ingredient": "MORPHINE SULFATE",
        "trade_name": "DURAMORPH PF",
        "forms": [
            {
                "orange_id": "18565-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MG/ML",
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2801,
        "type": "RX",
        "ingredient": "MORPHINE SULFATE",
        "trade_name": "INFUMORPH",
        "forms": [
            {
                "orange_id": "18565-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2802,
        "type": "RX",
        "ingredient": "MORPHINE SULFATE",
        "trade_name": "MITIGO",
        "forms": [
            {
                "orange_id": "204393-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2803,
        "type": "RX",
        "ingredient": "MORPHINE SULFATE",
        "trade_name": "MORPHINE SULFATE",
        "forms": [
            {
                "orange_id": "79040-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "45MG",
                    "60MG",
                    "75MG",
                    "90MG",
                    "120MG",
                    "20MG",
                    "40MG",
                    "50MG",
                    "80MG",
                    "100MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "205758-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4MG/ML",
                    "8MG/ML",
                    "10MG/ML",
                    "0.5MG/ML",
                    "1MG/ML",
                    "2MG/ML"
                ]
            },
            {
                "orange_id": "204223-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "2MG/ML (2MG/ML)",
                    "4MG/ML (4MG/ML)",
                    "5MG/ML (5MG/ML)",
                    "8MG/ML (8MG/ML)",
                    "10MG/ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "208809-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML",
                    "10MG/5ML",
                    "20MG/5ML"
                ]
            },
            {
                "orange_id": "203849-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "60MG",
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "212451-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2804,
        "type": "RX",
        "ingredient": "MORPHINE SULFATE",
        "trade_name": "MS CONTIN",
        "forms": [
            {
                "orange_id": "19516-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "60MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2805,
        "type": "RX",
        "ingredient": "MOXIDECTIN",
        "trade_name": "MOXIDECTIN",
        "forms": [
            {
                "orange_id": "210867-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 2806,
        "type": "RX",
        "ingredient": "MOXIFLOXACIN HYDROCHLORIDE",
        "trade_name": "MOXEZA",
        "forms": [
            {
                "orange_id": "22428-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 2807,
        "type": "RX",
        "ingredient": "MOXIFLOXACIN HYDROCHLORIDE",
        "trade_name": "MOXIFLOXACIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202916-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            },
            {
                "orange_id": "205572-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 400MG BASE/250ML (EQ 1.6MG BASE/ML)"
                ]
            },
            {
                "orange_id": "202632-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2808,
        "type": "RX",
        "ingredient": "MOXIFLOXACIN HYDROCHLORIDE",
        "trade_name": "MOXIFLOXACIN HYDROCHLORIDE IN SODIUM CHLORIDE 0. 8% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "205833-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "400MG/250ML (1.6MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2809,
        "type": "RX",
        "ingredient": "MOXIFLOXACIN HYDROCHLORIDE",
        "trade_name": "VIGAMOX",
        "forms": [
            {
                "orange_id": "21598-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 2810,
        "type": "RX",
        "ingredient": "MUPIROCIN",
        "trade_name": "CENTANY",
        "forms": [
            {
                "orange_id": "50788-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2811,
        "type": "RX",
        "ingredient": "MUPIROCIN",
        "trade_name": "MUPIROCIN",
        "forms": [
            {
                "orange_id": "65192-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2812,
        "type": "RX",
        "ingredient": "MUPIROCIN CALCIUM",
        "trade_name": "MUPIROCIN",
        "forms": [
            {
                "orange_id": "213053-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 2% BASE"
                ]
            }
        ]
    },
    {
        "id": 2813,
        "type": "RX",
        "ingredient": "MYCOPHENOLATE MOFETIL",
        "trade_name": "CELLCEPT",
        "forms": [
            {
                "orange_id": "50722-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "50759-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/ML"
                ]
            },
            {
                "orange_id": "50723-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2814,
        "type": "RX",
        "ingredient": "MYCOPHENOLATE MOFETIL",
        "trade_name": "MYCOPHENOLATE MOFETIL",
        "forms": [
            {
                "orange_id": "90253-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "203005-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/ML"
                ]
            },
            {
                "orange_id": "65416-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2815,
        "type": "RX",
        "ingredient": "MYCOPHENOLATE MOFETIL HYDROCHLORIDE",
        "trade_name": "CELLCEPT",
        "forms": [
            {
                "orange_id": "50758-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2816,
        "type": "RX",
        "ingredient": "MYCOPHENOLATE MOFETIL HYDROCHLORIDE",
        "trade_name": "MYCOPHENOLATE MOFETIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204043-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "500MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2817,
        "type": "RX",
        "ingredient": "MYCOPHENOLIC ACID",
        "trade_name": "MYCOPHENOLIC ACID",
        "forms": [
            {
                "orange_id": "214630-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 180MG BASE",
                    "EQ 360MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2818,
        "type": "RX",
        "ingredient": "MYCOPHENOLIC SODIUM",
        "trade_name": "MYCOPHENOLIC SODIUM",
        "forms": [
            {
                "orange_id": "202555-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 180MG BASE",
                    "EQ 360MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2819,
        "type": "RX",
        "ingredient": "MYCOPHENOLIC SODIUM",
        "trade_name": "MYFORTIC",
        "forms": [
            {
                "orange_id": "50791-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 180MG BASE",
                    "EQ 360MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2820,
        "type": "RX",
        "ingredient": "NABILONE",
        "trade_name": "CESAMET",
        "forms": [
            {
                "orange_id": "18677-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MG"
                ]
            }
        ]
    },
    {
        "id": 2821,
        "type": "RX",
        "ingredient": "NABUMETONE",
        "trade_name": "NABUMETONE",
        "forms": [
            {
                "orange_id": "90445-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG",
                    "750MG",
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 2822,
        "type": "RX",
        "ingredient": "NADOLOL",
        "trade_name": "CORGARD",
        "forms": [
            {
                "orange_id": "18063-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 2823,
        "type": "RX",
        "ingredient": "NADOLOL",
        "trade_name": "NADOLOL",
        "forms": [
            {
                "orange_id": "208832-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 2824,
        "type": "RX",
        "ingredient": "NAFARELIN ACETATE",
        "trade_name": "SYNAREL",
        "forms": [
            {
                "orange_id": "19886-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "EQ 0.2MG BASE/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2825,
        "type": "RX",
        "ingredient": "NAFCILLIN SODIUM",
        "trade_name": "NAFCILLIN SODIUM",
        "forms": [
            {
                "orange_id": "90560-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2826,
        "type": "RX",
        "ingredient": "NAFCILLIN SODIUM",
        "trade_name": "NALLPEN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50655-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2GM BASE/100ML",
                    "EQ 20MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2827,
        "type": "RX",
        "ingredient": "NAFTIFINE HYDROCHLORIDE",
        "trade_name": "NAFTIFINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205975-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%",
                    "2%",
                    "2.0%"
                ]
            },
            {
                "orange_id": "206165-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 2828,
        "type": "RX",
        "ingredient": "NAFTIFINE HYDROCHLORIDE",
        "trade_name": "NAFTIN",
        "forms": [
            {
                "orange_id": "19599-2",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "19356-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%",
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2829,
        "type": "RX",
        "ingredient": "NALBUPHINE HYDROCHLORIDE",
        "trade_name": "NALBUPHINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "70914-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2830,
        "type": "RX",
        "ingredient": "NALDEMEDINE TOSYLATE",
        "trade_name": "SYMPROIC",
        "forms": [
            {
                "orange_id": "208854-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2831,
        "type": "RX",
        "ingredient": "NALMEFENE HYDROCHLORIDE",
        "trade_name": "NALMEFENE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "212955-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS, SUBCUTANEOUS",
                "dosage": [
                    "EQ 2MG BASE/2ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2832,
        "type": "RX",
        "ingredient": "NALOXEGOL OXALATE",
        "trade_name": "MOVANTIK",
        "forms": [
            {
                "orange_id": "204760-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2833,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE",
        "trade_name": "KLOXXADO",
        "forms": [
            {
                "orange_id": "212045-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "8MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2834,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE",
        "trade_name": "NALOXONE",
        "forms": [
            {
                "orange_id": "70299-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.4MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2835,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE",
        "trade_name": "NALOXONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208871-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.4MG/ML",
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "209522-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "4MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2836,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE",
        "trade_name": "NARCAN",
        "forms": [
            {
                "orange_id": "208411-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "4MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2837,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE",
        "trade_name": "ZIMHI",
        "forms": [
            {
                "orange_id": "212854-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, SUBCUTANEOUS",
                "dosage": [
                    "5MG/0.5ML (5MG/0.5ML)"
                ]
            }
        ]
    },
    {
        "id": 2838,
        "type": "RX",
        "ingredient": "NALOXONE HYDROCHLORIDE AND PENTAZOCINE HYDROCHLORIDE",
        "trade_name": "NALOXONE HYDROCHLORIDE AND PENTAZOCINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75735-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE-EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2839,
        "type": "RX",
        "ingredient": "NALTREXONE",
        "trade_name": "VIVITROL",
        "forms": [
            {
                "orange_id": "21897-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "380MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2840,
        "type": "RX",
        "ingredient": "NALTREXONE HYDROCHLORIDE",
        "trade_name": "NALTREXONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91205-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2841,
        "type": "OTC",
        "ingredient": "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
        "trade_name": "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
        "forms": [
            {
                "orange_id": "202795-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%-0.3%",
                    "0.02675%-0.315%"
                ]
            }
        ]
    },
    {
        "id": 2842,
        "type": "OTC",
        "ingredient": "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
        "trade_name": "NAPHCON-A",
        "forms": [
            {
                "orange_id": "20226-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 2843,
        "type": "OTC",
        "ingredient": "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
        "trade_name": "OPCON-A",
        "forms": [
            {
                "orange_id": "20065-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.02675%-0.315%"
                ]
            }
        ]
    },
    {
        "id": 2844,
        "type": "OTC",
        "ingredient": "NAPHAZOLINE HYDROCHLORIDE AND PHENIRAMINE MALEATE",
        "trade_name": "VISINE",
        "forms": [
            {
                "orange_id": "20485-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%-0.3%"
                ]
            }
        ]
    },
    {
        "id": 2845,
        "type": "RX",
        "ingredient": "NAPROXEN",
        "trade_name": "EC-NAPROSYN",
        "forms": [
            {
                "orange_id": "20067-2",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "375MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2846,
        "type": "RX",
        "ingredient": "NAPROXEN",
        "trade_name": "NAPROSYN",
        "forms": [
            {
                "orange_id": "18965-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/ML"
                ]
            },
            {
                "orange_id": "17581-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2847,
        "type": "RX",
        "ingredient": "NAPROXEN",
        "trade_name": "NAPROXEN",
        "forms": [
            {
                "orange_id": "212705-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/ML"
                ]
            },
            {
                "orange_id": "91432-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "375MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "75927-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "375MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2848,
        "type": "OTC",
        "ingredient": "NAPROXEN SODIUM",
        "trade_name": "ALEVE",
        "forms": [
            {
                "orange_id": "20204-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "220MG"
                ]
            }
        ]
    },
    {
        "id": 2849,
        "type": "RX",
        "ingredient": "NAPROXEN SODIUM",
        "trade_name": "ANAPROX DS",
        "forms": [
            {
                "orange_id": "18164-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2850,
        "type": "RX",
        "ingredient": "NAPROXEN SODIUM",
        "trade_name": "NAPRELAN",
        "forms": [
            {
                "orange_id": "20353-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 375MG BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2851,
        "type": "OTC",
        "ingredient": "NAPROXEN SODIUM",
        "trade_name": "NAPROXEN SODIUM",
        "forms": [
            {
                "orange_id": "21920-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            },
            {
                "orange_id": "75416-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 375MG BASE",
                    "EQ 500MG BASE",
                    "EQ 750MG BASE"
                ]
            },
            {
                "orange_id": "79096-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "220MG",
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2852,
        "type": "OTC",
        "ingredient": "NAPROXEN SODIUM AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "NAPROXEN SODIUM AND PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77381-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "220MG-120MG"
                ]
            }
        ]
    },
    {
        "id": 2853,
        "type": "RX",
        "ingredient": "NAPROXEN SODIUM AND SUMATRIPTAN SUCCINATE",
        "trade_name": "SUMATRIPTAN AND NAPROXEN SODIUM",
        "forms": [
            {
                "orange_id": "207457-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG-EQ 85MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2854,
        "type": "RX",
        "ingredient": "NAPROXEN SODIUM AND SUMATRIPTAN SUCCINATE",
        "trade_name": "TREXIMET",
        "forms": [
            {
                "orange_id": "21926-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG-EQ 85MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2855,
        "type": "RX",
        "ingredient": "NARATRIPTAN HYDROCHLORIDE",
        "trade_name": "AMERGE",
        "forms": [
            {
                "orange_id": "20763-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2856,
        "type": "RX",
        "ingredient": "NARATRIPTAN HYDROCHLORIDE",
        "trade_name": "NARATRIPTAN",
        "forms": [
            {
                "orange_id": "200502-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2857,
        "type": "RX",
        "ingredient": "NATAMYCIN",
        "trade_name": "NATACYN",
        "forms": [
            {
                "orange_id": "50514-1",
                "form": "SUSPENSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 2858,
        "type": "RX",
        "ingredient": "NATEGLINIDE",
        "trade_name": "NATEGLINIDE",
        "forms": [
            {
                "orange_id": "206432-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2859,
        "type": "RX",
        "ingredient": "NEBIVOLOL HYDROCHLORIDE",
        "trade_name": "BYSTOLIC",
        "forms": [
            {
                "orange_id": "21742-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2860,
        "type": "RX",
        "ingredient": "NEBIVOLOL HYDROCHLORIDE",
        "trade_name": "NEBIVOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "203659-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2861,
        "type": "RX",
        "ingredient": "NEDOCROMIL SODIUM",
        "trade_name": "ALOCRIL",
        "forms": [
            {
                "orange_id": "21009-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2862,
        "type": "RX",
        "ingredient": "NEDOCROMIL SODIUM",
        "trade_name": "NEDOCROMIL SODIUM",
        "forms": [
            {
                "orange_id": "90638-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 2863,
        "type": "RX",
        "ingredient": "NEFAZODONE HYDROCHLORIDE",
        "trade_name": "NEFAZODONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76037-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2864,
        "type": "RX",
        "ingredient": "NELARABINE",
        "trade_name": "ARRANON",
        "forms": [
            {
                "orange_id": "21877-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/50ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2865,
        "type": "RX",
        "ingredient": "NELARABINE",
        "trade_name": "NELARABINE",
        "forms": [
            {
                "orange_id": "215037-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/50ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2866,
        "type": "RX",
        "ingredient": "NELFINAVIR MESYLATE",
        "trade_name": "VIRACEPT",
        "forms": [
            {
                "orange_id": "20779-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 625MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2867,
        "type": "RX",
        "ingredient": "NEOMYCIN SULFATE",
        "trade_name": "NEOMYCIN SULFATE",
        "forms": [
            {
                "orange_id": "60304-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2868,
        "type": "RX",
        "ingredient": "NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOMYCIN AND POLYMYXIN B SULFATE",
        "forms": [
            {
                "orange_id": "62664-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "EQ 40MG BASE/ML-200,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2869,
        "type": "RX",
        "ingredient": "NEOMYCIN SULFATE AND POLYMYXIN B SULFATE",
        "trade_name": "NEOSPORIN G. U. IRRIGANT",
        "forms": [
            {
                "orange_id": "60707-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "EQ 40MG BASE/ML-200,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 2870,
        "type": "RX",
        "ingredient": "NEOSTIGMINE METHYLSULFATE",
        "trade_name": "BLOXIVERZ",
        "forms": [
            {
                "orange_id": "204078-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5MG/10ML (0.5MG/ML)",
                    "10MG/10ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2871,
        "type": "RX",
        "ingredient": "NEOSTIGMINE METHYLSULFATE",
        "trade_name": "NEOSTIGMINE METHYLSULFATE",
        "forms": [
            {
                "orange_id": "209182-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5MG/10ML (0.5MG/ML)",
                    "10MG/10ML (1MG/ML)",
                    "3MG/3ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2872,
        "type": "RX",
        "ingredient": "NEPAFENAC",
        "trade_name": "ILEVRO",
        "forms": [
            {
                "orange_id": "203491-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            }
        ]
    },
    {
        "id": 2873,
        "type": "RX",
        "ingredient": "NEPAFENAC",
        "trade_name": "NEVANAC",
        "forms": [
            {
                "orange_id": "21862-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 2874,
        "type": "RX",
        "ingredient": "NERATINIB MALEATE",
        "trade_name": "NERLYNX",
        "forms": [
            {
                "orange_id": "208051-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2875,
        "type": "RX",
        "ingredient": "NETARSUDIL MESYLATE",
        "trade_name": "RHOPRESSA",
        "forms": [
            {
                "orange_id": "208254-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.02% BASE"
                ]
            }
        ]
    },
    {
        "id": 2876,
        "type": "RX",
        "ingredient": "NETUPITANT AND PALONOSETRON HYDROCHLORIDE",
        "trade_name": "AKYNZEO",
        "forms": [
            {
                "orange_id": "205718-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG-EQ 0.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2877,
        "type": "RX",
        "ingredient": "NEVIRAPINE",
        "trade_name": "NEVIRAPINE",
        "forms": [
            {
                "orange_id": "77702-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "204621-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "400MG"
                ]
            },
            {
                "orange_id": "77521-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2878,
        "type": "RX",
        "ingredient": "NEVIRAPINE",
        "trade_name": "VIRAMUNE",
        "forms": [
            {
                "orange_id": "20933-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "20636-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 2879,
        "type": "RX",
        "ingredient": "NEVIRAPINE",
        "trade_name": "VIRAMUNE XR",
        "forms": [
            {
                "orange_id": "201152-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2880,
        "type": "RX",
        "ingredient": "NIACIN",
        "trade_name": "NIACIN",
        "forms": [
            {
                "orange_id": "203578-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG",
                    "750MG"
                ]
            }
        ]
    },
    {
        "id": 2881,
        "type": "RX",
        "ingredient": "NIACIN",
        "trade_name": "NIACOR",
        "forms": [
            {
                "orange_id": "40378-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2882,
        "type": "RX",
        "ingredient": "NICARDIPINE HYDROCHLORIDE",
        "trade_name": "CARDENE IN 0. 83% SODIUM CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19734-4",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "40MG/200ML (0.2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2883,
        "type": "RX",
        "ingredient": "NICARDIPINE HYDROCHLORIDE",
        "trade_name": "CARDENE IN 0. 86% SODIUM CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19734-3",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/200ML (0.1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2884,
        "type": "RX",
        "ingredient": "NICARDIPINE HYDROCHLORIDE",
        "trade_name": "CARDENE IN 4. 8% DEXTROSE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19734-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/200ML (0.1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2885,
        "type": "RX",
        "ingredient": "NICARDIPINE HYDROCHLORIDE",
        "trade_name": "NICARDIPINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74670-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "30MG"
                ]
            },
            {
                "orange_id": "90534-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/10ML (2.5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2886,
        "type": "RX",
        "ingredient": "NICARDIPINE HYDROCHLORIDE",
        "trade_name": "NICARDIPINE HYDROCHLORIDE IN 0. 9% SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "22276-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/200ML (0.1MG/ML)",
                    "40MG/200ML (0.2MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2887,
        "type": "OTC",
        "ingredient": "NICOTINE",
        "trade_name": "HABITROL",
        "forms": [
            {
                "orange_id": "20076-4",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "7MG/24HR",
                    "14MG/24HR",
                    "21MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 2888,
        "type": "OTC",
        "ingredient": "NICOTINE",
        "trade_name": "NICODERM CQ",
        "forms": [
            {
                "orange_id": "20165-6",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "7MG/24HR",
                    "14MG/24HR",
                    "21MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 2889,
        "type": "OTC",
        "ingredient": "NICOTINE",
        "trade_name": "NICOTINE",
        "forms": [
            {
                "orange_id": "74612-2",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "7MG/24HR",
                    "14MG/24HR",
                    "21MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 2890,
        "type": "RX",
        "ingredient": "NICOTINE",
        "trade_name": "NICOTROL",
        "forms": [
            {
                "orange_id": "20714-1",
                "form": "INHALANT",
                "route": "ORAL",
                "dosage": [
                    "4MG/CARTRIDGE"
                ]
            },
            {
                "orange_id": "20385-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2891,
        "type": "OTC",
        "ingredient": "NICOTINE POLACRILEX",
        "trade_name": "NICORETTE",
        "forms": [
            {
                "orange_id": "18612-2",
                "form": "GUM, CHEWING",
                "route": "BUCCAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            },
            {
                "orange_id": "22360-1",
                "form": "TROCHE/LOZENGE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2892,
        "type": "OTC",
        "ingredient": "NICOTINE POLACRILEX",
        "trade_name": "NICORETTE (MINT)",
        "forms": [
            {
                "orange_id": "18612-3",
                "form": "GUM, CHEWING",
                "route": "BUCCAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2893,
        "type": "OTC",
        "ingredient": "NICOTINE POLACRILEX",
        "trade_name": "NICOTINE POLACRILEX",
        "forms": [
            {
                "orange_id": "76775-1",
                "form": "GUM, CHEWING",
                "route": "BUCCAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            },
            {
                "orange_id": "213266-1",
                "form": "TROCHE/LOZENGE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2894,
        "type": "RX",
        "ingredient": "NIFEDIPINE",
        "trade_name": "NIFEDIPINE",
        "forms": [
            {
                "orange_id": "72781-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            },
            {
                "orange_id": "213361-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "90MG"
                ]
            }
        ]
    },
    {
        "id": 2895,
        "type": "RX",
        "ingredient": "NIFEDIPINE",
        "trade_name": "PROCARDIA",
        "forms": [
            {
                "orange_id": "18482-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2896,
        "type": "RX",
        "ingredient": "NIFEDIPINE",
        "trade_name": "PROCARDIA XL",
        "forms": [
            {
                "orange_id": "19684-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG",
                    "90MG"
                ]
            }
        ]
    },
    {
        "id": 2897,
        "type": "RX",
        "ingredient": "NIFURTIMOX",
        "trade_name": "LAMPIT",
        "forms": [
            {
                "orange_id": "213464-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2898,
        "type": "RX",
        "ingredient": "NILOTINIB HYDROCHLORIDE",
        "trade_name": "TASIGNA",
        "forms": [
            {
                "orange_id": "22068-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2899,
        "type": "RX",
        "ingredient": "NILUTAMIDE",
        "trade_name": "NILANDRON",
        "forms": [
            {
                "orange_id": "20169-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2900,
        "type": "RX",
        "ingredient": "NILUTAMIDE",
        "trade_name": "NILUTAMIDE",
        "forms": [
            {
                "orange_id": "207631-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2901,
        "type": "RX",
        "ingredient": "NIMODIPINE",
        "trade_name": "NIMODIPINE",
        "forms": [
            {
                "orange_id": "76740-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 2902,
        "type": "RX",
        "ingredient": "NIMODIPINE",
        "trade_name": "NYMALIZE",
        "forms": [
            {
                "orange_id": "203340-2",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2903,
        "type": "RX",
        "ingredient": "NINTEDANIB ESYLATE",
        "trade_name": "OFEV",
        "forms": [
            {
                "orange_id": "205832-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2904,
        "type": "RX",
        "ingredient": "NIRAPARIB TOSYLATE",
        "trade_name": "ZEJULA",
        "forms": [
            {
                "orange_id": "208447-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2905,
        "type": "RX",
        "ingredient": "NISOLDIPINE",
        "trade_name": "NISOLDIPINE",
        "forms": [
            {
                "orange_id": "91001-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8.5MG",
                    "17MG",
                    "20MG",
                    "25.5MG",
                    "30MG",
                    "34MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2906,
        "type": "RX",
        "ingredient": "NISOLDIPINE",
        "trade_name": "SULAR",
        "forms": [
            {
                "orange_id": "20356-8",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8.5MG",
                    "17MG",
                    "34MG"
                ]
            }
        ]
    },
    {
        "id": 2907,
        "type": "RX",
        "ingredient": "NITAZOXANIDE",
        "trade_name": "ALINIA",
        "forms": [
            {
                "orange_id": "21498-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "21497-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2908,
        "type": "RX",
        "ingredient": "NITAZOXANIDE",
        "trade_name": "NITAZOXANIDE",
        "forms": [
            {
                "orange_id": "213820-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 2909,
        "type": "RX",
        "ingredient": "NITISINONE",
        "trade_name": "NITISINONE",
        "forms": [
            {
                "orange_id": "211041-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2910,
        "type": "RX",
        "ingredient": "NITISINONE",
        "trade_name": "NITYR",
        "forms": [
            {
                "orange_id": "209449-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2911,
        "type": "RX",
        "ingredient": "NITISINONE",
        "trade_name": "ORFADIN",
        "forms": [
            {
                "orange_id": "21232-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            },
            {
                "orange_id": "206356-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "4MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2912,
        "type": "RX",
        "ingredient": "NITRIC OXIDE",
        "trade_name": "GENOSYL",
        "forms": [
            {
                "orange_id": "202860-1",
                "form": "GAS",
                "route": "INHALATION",
                "dosage": [
                    "800PPM"
                ]
            }
        ]
    },
    {
        "id": 2913,
        "type": "RX",
        "ingredient": "NITRIC OXIDE",
        "trade_name": "INOMAX",
        "forms": [
            {
                "orange_id": "20845-3",
                "form": "GAS",
                "route": "INHALATION",
                "dosage": [
                    "800PPM"
                ]
            }
        ]
    },
    {
        "id": 2914,
        "type": "RX",
        "ingredient": "NITRIC OXIDE",
        "trade_name": "NOXIVENT",
        "forms": [
            {
                "orange_id": "207141-1",
                "form": "GAS",
                "route": "INHALATION",
                "dosage": [
                    "100PPM",
                    "800PPM"
                ]
            }
        ]
    },
    {
        "id": 2915,
        "type": "RX",
        "ingredient": "NITROFURANTOIN",
        "trade_name": "FURADANTIN",
        "forms": [
            {
                "orange_id": "9175-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2916,
        "type": "RX",
        "ingredient": "NITROFURANTOIN",
        "trade_name": "NITROFURANTOIN",
        "forms": [
            {
                "orange_id": "205180-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 2917,
        "type": "RX",
        "ingredient": "NITROFURANTOIN, MACROCRYSTALLINE",
        "trade_name": "MACRODANTIN",
        "forms": [
            {
                "orange_id": "16620-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2918,
        "type": "RX",
        "ingredient": "NITROFURANTOIN, MACROCRYSTALLINE",
        "trade_name": "NITROFURANTOIN",
        "forms": [
            {
                "orange_id": "91095-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2919,
        "type": "RX",
        "ingredient": "NITROFURANTOIN AND NITROFURANTOIN, MACROCRYSTALLINE",
        "trade_name": "MACROBID",
        "forms": [
            {
                "orange_id": "20064-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 2920,
        "type": "RX",
        "ingredient": "NITROFURANTOIN AND NITROFURANTOIN, MACROCRYSTALLINE",
        "trade_name": "NITROFURANTOIN (MONOHYDRATE/MACROCRYSTALS)",
        "forms": [
            {
                "orange_id": "207372-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG-25MG"
                ]
            }
        ]
    },
    {
        "id": 2921,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITRO-DUR",
        "forms": [
            {
                "orange_id": "20145-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.1MG/HR",
                    "0.2MG/HR",
                    "0.3MG/HR",
                    "0.4MG/HR",
                    "0.6MG/HR",
                    "0.8MG/HR"
                ]
            }
        ]
    },
    {
        "id": 2922,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITROGLYCERIN",
        "forms": [
            {
                "orange_id": "89885-2",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "0.1MG/HR",
                    "0.2MG/HR",
                    "0.4MG/HR",
                    "0.6MG/HR"
                ]
            },
            {
                "orange_id": "72034-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "87355-1",
                "form": "OINTMENT",
                "route": "TRANSDERMAL",
                "dosage": [
                    "2%"
                ]
            },
            {
                "orange_id": "91496-1",
                "form": "SPRAY, METERED",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.4MG/SPRAY"
                ]
            },
            {
                "orange_id": "211604-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.3MG",
                    "0.4MG",
                    "0.6MG"
                ]
            }
        ]
    },
    {
        "id": 2923,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITROGLYCERIN IN DEXTROSE 5%",
        "forms": [
            {
                "orange_id": "19970-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/100ML",
                    "20MG/100ML",
                    "40MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 2924,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITROLINGUAL PUMPSPRAY",
        "forms": [
            {
                "orange_id": "18705-2",
                "form": "SPRAY, METERED",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.4MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2925,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITROMIST",
        "forms": [
            {
                "orange_id": "21780-1",
                "form": "AEROSOL, METERED",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.4MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2926,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "NITROSTAT",
        "forms": [
            {
                "orange_id": "21134-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "0.3MG",
                    "0.4MG",
                    "0.6MG"
                ]
            }
        ]
    },
    {
        "id": 2927,
        "type": "RX",
        "ingredient": "NITROGLYCERIN",
        "trade_name": "RECTIV",
        "forms": [
            {
                "orange_id": "21359-1",
                "form": "OINTMENT",
                "route": "INTRA-ANAL",
                "dosage": [
                    "0.4%"
                ]
            }
        ]
    },
    {
        "id": 2928,
        "type": "OTC",
        "ingredient": "NIZATIDINE",
        "trade_name": "AXID AR",
        "forms": [
            {
                "orange_id": "20555-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 2929,
        "type": "RX",
        "ingredient": "NIZATIDINE",
        "trade_name": "NIZATIDINE",
        "forms": [
            {
                "orange_id": "77314-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "90576-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "15MG/ML"
                ]
            }
        ]
    },
    {
        "id": 2930,
        "type": "RX",
        "ingredient": "NOREPINEPHRINE BITARTRATE",
        "trade_name": "LEVOPHED",
        "forms": [
            {
                "orange_id": "7513-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2931,
        "type": "RX",
        "ingredient": "NOREPINEPHRINE BITARTRATE",
        "trade_name": "NOREPINEPHRINE BITARTRATE",
        "forms": [
            {
                "orange_id": "210839-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2932,
        "type": "RX",
        "ingredient": "NOREPINEPHRINE BITARTRATE",
        "trade_name": "NOREPINEPHRINE BITARTRATE IN 5% DEXTROSE",
        "forms": [
            {
                "orange_id": "214313-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 4MG BASE/250ML (EQ 16MCG BASE/ML)",
                    "EQ 8MG BASE/250ML (EQ 32MCG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2933,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "CAMILA",
        "forms": [
            {
                "orange_id": "76177-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2934,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "ERRIN",
        "forms": [
            {
                "orange_id": "76225-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2935,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "HEATHER",
        "forms": [
            {
                "orange_id": "90454-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2936,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "INCASSIA",
        "forms": [
            {
                "orange_id": "207304-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2937,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "JENCYCLA",
        "forms": [
            {
                "orange_id": "91323-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2938,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "NORETHINDRONE",
        "forms": [
            {
                "orange_id": "202260-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2939,
        "type": "RX",
        "ingredient": "NORETHINDRONE",
        "trade_name": "NOR-QD",
        "forms": [
            {
                "orange_id": "17060-1",
                "form": "TABLET",
                "route": "ORAL-28",
                "dosage": [
                    "0.35MG"
                ]
            }
        ]
    },
    {
        "id": 2940,
        "type": "RX",
        "ingredient": "NORETHINDRONE ACETATE",
        "trade_name": "NORETHINDRONE ACETATE",
        "forms": [
            {
                "orange_id": "200275-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 2941,
        "type": "RX",
        "ingredient": "NORTRIPTYLINE HYDROCHLORIDE",
        "trade_name": "NORTRIPTYLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "73556-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 75MG BASE"
                ]
            },
            {
                "orange_id": "75606-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 2942,
        "type": "RX",
        "ingredient": "NORTRIPTYLINE HYDROCHLORIDE",
        "trade_name": "PAMELOR",
        "forms": [
            {
                "orange_id": "18013-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 75MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2943,
        "type": "RX",
        "ingredient": "NUSINERSEN SODIUM",
        "trade_name": "SPINRAZA",
        "forms": [
            {
                "orange_id": "209531-1",
                "form": "SOLUTION",
                "route": "INTRATHECAL",
                "dosage": [
                    "EQ 12MG BASE/5ML (EQ 2.4MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 2944,
        "type": "RX",
        "ingredient": "NYSTATIN",
        "trade_name": "NYSTATIN",
        "forms": [
            {
                "orange_id": "62949-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM"
                ]
            },
            {
                "orange_id": "62840-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM"
                ]
            },
            {
                "orange_id": "210532-1",
                "form": "POWDER",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM"
                ]
            },
            {
                "orange_id": "64042-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "100,000 UNITS/ML"
                ]
            },
            {
                "orange_id": "62474-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500,000 UNITS"
                ]
            }
        ]
    },
    {
        "id": 2945,
        "type": "RX",
        "ingredient": "NYSTATIN",
        "trade_name": "NYSTOP",
        "forms": [
            {
                "orange_id": "64118-1",
                "form": "POWDER",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM"
                ]
            }
        ]
    },
    {
        "id": 2946,
        "type": "RX",
        "ingredient": "NYSTATIN AND TRIAMCINOLONE ACETONIDE",
        "trade_name": "MYKACET",
        "forms": [
            {
                "orange_id": "62367-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM-0.1%"
                ]
            },
            {
                "orange_id": "62733-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM-0.1%"
                ]
            }
        ]
    },
    {
        "id": 2947,
        "type": "RX",
        "ingredient": "NYSTATIN AND TRIAMCINOLONE ACETONIDE",
        "trade_name": "NYSTATIN AND TRIAMCINOLONE ACETONIDE",
        "forms": [
            {
                "orange_id": "214090-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM-0.1%"
                ]
            },
            {
                "orange_id": "207217-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "100,000 UNITS/GM-0.1%"
                ]
            }
        ]
    },
    {
        "id": 2948,
        "type": "RX",
        "ingredient": "OBETICHOLIC ACID",
        "trade_name": "OCALIVA",
        "forms": [
            {
                "orange_id": "207999-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 2949,
        "type": "RX",
        "ingredient": "OCTREOTIDE ACETATE",
        "trade_name": "MYCAPSSA",
        "forms": [
            {
                "orange_id": "208232-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2950,
        "type": "RX",
        "ingredient": "OCTREOTIDE ACETATE",
        "trade_name": "OCTREOTIDE ACETATE",
        "forms": [
            {
                "orange_id": "77450-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.2MG BASE/ML",
                    "EQ 1MG BASE/ML",
                    "EQ 0.05MG BASE/ML",
                    "EQ 0.1MG BASE/ML",
                    "EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2951,
        "type": "RX",
        "ingredient": "OCTREOTIDE ACETATE",
        "trade_name": "OCTREOTIDE ACETATE (PRESERVATIVE FREE)",
        "forms": [
            {
                "orange_id": "77457-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML",
                    "EQ 0.1MG BASE/ML",
                    "EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2952,
        "type": "RX",
        "ingredient": "OCTREOTIDE ACETATE",
        "trade_name": "SANDOSTATIN",
        "forms": [
            {
                "orange_id": "19667-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML",
                    "EQ 0.1MG BASE/ML",
                    "EQ 0.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2953,
        "type": "RX",
        "ingredient": "OCTREOTIDE ACETATE",
        "trade_name": "SANDOSTATIN LAR",
        "forms": [
            {
                "orange_id": "21008-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/VIAL",
                    "EQ 20MG BASE/VIAL",
                    "EQ 30MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2954,
        "type": "RX",
        "ingredient": "ODEVIXIBAT",
        "trade_name": "BYLVAY",
        "forms": [
            {
                "orange_id": "215498-1",
                "form": "CAPSULE, PELLETS",
                "route": "ORAL",
                "dosage": [
                    "0.2MG",
                    "0.6MG"
                ]
            },
            {
                "orange_id": "215498-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.4MG",
                    "1.2MG"
                ]
            }
        ]
    },
    {
        "id": 2955,
        "type": "RX",
        "ingredient": "OFLOXACIN",
        "trade_name": "OCUFLOX",
        "forms": [
            {
                "orange_id": "19921-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            }
        ]
    },
    {
        "id": 2956,
        "type": "RX",
        "ingredient": "OFLOXACIN",
        "trade_name": "OFLOXACIN",
        "forms": [
            {
                "orange_id": "76407-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            },
            {
                "orange_id": "76616-1",
                "form": "SOLUTION/DROPS",
                "route": "OTIC",
                "dosage": [
                    "0.3%"
                ]
            },
            {
                "orange_id": "91656-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 2957,
        "type": "RX",
        "ingredient": "OLANZAPINE",
        "trade_name": "OLANZAPINE",
        "forms": [
            {
                "orange_id": "201741-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "10MG/VIAL"
                ]
            },
            {
                "orange_id": "91265-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            },
            {
                "orange_id": "202295-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "7.5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2958,
        "type": "RX",
        "ingredient": "OLANZAPINE",
        "trade_name": "ZYPREXA",
        "forms": [
            {
                "orange_id": "21253-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "10MG/VIAL"
                ]
            },
            {
                "orange_id": "20592-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "7.5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2959,
        "type": "RX",
        "ingredient": "OLANZAPINE",
        "trade_name": "ZYPREXA ZYDIS",
        "forms": [
            {
                "orange_id": "21086-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2960,
        "type": "RX",
        "ingredient": "OLANZAPINE PAMOATE",
        "trade_name": "ZYPREXA RELPREVV",
        "forms": [
            {
                "orange_id": "22173-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 210MG BASE/VIAL",
                    "EQ 300MG BASE/VIAL",
                    "EQ 405MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2961,
        "type": "RX",
        "ingredient": "OLANZAPINE AND SAMIDORPHAN L-MALATE",
        "trade_name": "LYBALVI",
        "forms": [
            {
                "orange_id": "213378-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG-EQ 10MG BASE",
                    "10MG-EQ 10MG BASE",
                    "15MG-EQ 10MG BASE",
                    "20MG-EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2962,
        "type": "RX",
        "ingredient": "OLAPARIB",
        "trade_name": "LYNPARZA",
        "forms": [
            {
                "orange_id": "208558-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 2963,
        "type": "RX",
        "ingredient": "OLICERIDINE",
        "trade_name": "OLINVYK",
        "forms": [
            {
                "orange_id": "210730-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1MG/ML (1MG/ML)",
                    "2MG/2ML (1MG/ML)",
                    "30MG/30ML (1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 2964,
        "type": "RX",
        "ingredient": "OLIVE OIL AND SOYBEAN OIL",
        "trade_name": "CLINOLIPID 20%",
        "forms": [
            {
                "orange_id": "204508-1",
                "form": "EMULSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "16%(160GM/1000ML)-4%  (40GM/1000ML)"
                ]
            }
        ]
    },
    {
        "id": 2965,
        "type": "RX",
        "ingredient": "OLMESARTAN MEDOXOMIL",
        "trade_name": "BENICAR",
        "forms": [
            {
                "orange_id": "21286-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2966,
        "type": "RX",
        "ingredient": "OLMESARTAN MEDOXOMIL",
        "trade_name": "OLMESARTAN MEDOXOMIL",
        "forms": [
            {
                "orange_id": "207662-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 2967,
        "type": "RX",
        "ingredient": "OLODATEROL HYDROCHLORIDE",
        "trade_name": "STRIVERDI RESPIMAT",
        "forms": [
            {
                "orange_id": "203108-1",
                "form": "SPRAY, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.0025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 2968,
        "type": "RX",
        "ingredient": "OLODATEROL HYDROCHLORIDE AND TIOTROPIUM BROMIDE",
        "trade_name": "STIOLTO RESPIMAT",
        "forms": [
            {
                "orange_id": "206756-1",
                "form": "SPRAY, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.0025MG BASE/INH-EQ 0.0025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 2969,
        "type": "OTC",
        "ingredient": "OLOPATADINE HYDROCHLORIDE",
        "trade_name": "OLOPATADINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204532-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.1% BASE",
                    "EQ 0.2% BASE"
                ]
            },
            {
                "orange_id": "213757-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.665MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2970,
        "type": "OTC",
        "ingredient": "OLOPATADINE HYDROCHLORIDE",
        "trade_name": "PATADAY ONCE DAILY RELIEF",
        "forms": [
            {
                "orange_id": "21545-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.2% BASE",
                    "EQ 0.7% BASE"
                ]
            }
        ]
    },
    {
        "id": 2971,
        "type": "OTC",
        "ingredient": "OLOPATADINE HYDROCHLORIDE",
        "trade_name": "PATADAY TWICE DAILY RELIEF",
        "forms": [
            {
                "orange_id": "20688-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.1% BASE"
                ]
            }
        ]
    },
    {
        "id": 2972,
        "type": "RX",
        "ingredient": "OLOPATADINE HYDROCHLORIDE",
        "trade_name": "PATANASE",
        "forms": [
            {
                "orange_id": "21861-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.665MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 2973,
        "type": "RX",
        "ingredient": "OLSALAZINE SODIUM",
        "trade_name": "DIPENTUM",
        "forms": [
            {
                "orange_id": "19715-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 2974,
        "type": "RX",
        "ingredient": "OMACETAXINE MEPESUCCINATE",
        "trade_name": "SYNRIBO",
        "forms": [
            {
                "orange_id": "203585-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "3.5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2975,
        "type": "RX",
        "ingredient": "OMADACYCLINE TOSYLATE",
        "trade_name": "NUZYRA",
        "forms": [
            {
                "orange_id": "209817-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 100MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "209816-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2976,
        "type": "RX",
        "ingredient": "OMEGA-3-ACID ETHYL ESTERS",
        "trade_name": "LOVAZA",
        "forms": [
            {
                "orange_id": "21654-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1GM CONTAINS AT LEAST 900MG OF THE ETHYL ESTERS OF OMEGA-3 FATTY ACIDS"
                ]
            }
        ]
    },
    {
        "id": 2977,
        "type": "RX",
        "ingredient": "OMEGA-3-ACID ETHYL ESTERS",
        "trade_name": "OMEGA-3-ACID ETHYL ESTERS",
        "forms": [
            {
                "orange_id": "204940-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1GM CONTAINS AT LEAST 900MG OF THE ETHYL ESTERS OF OMEGA-3 FATTY ACIDS"
                ]
            }
        ]
    },
    {
        "id": 2978,
        "type": "RX",
        "ingredient": "OMEPRAZOLE",
        "trade_name": "OMEPRAZOLE",
        "forms": [
            {
                "orange_id": "75347-1",
                "form": "CAPSULE, DELAYED REL PELLETS",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            },
            {
                "orange_id": "210070-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            },
            {
                "orange_id": "209400-1",
                "form": "TABLET, ORALLY DISINTEGRATING, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 2979,
        "type": "OTC",
        "ingredient": "OMEPRAZOLE MAGNESIUM",
        "trade_name": "OMEPRAZOLE MAGNESIUM",
        "forms": [
            {
                "orange_id": "78878-1",
                "form": "CAPSULE, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            },
            {
                "orange_id": "206877-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2980,
        "type": "RX",
        "ingredient": "OMEPRAZOLE MAGNESIUM",
        "trade_name": "PRILOSEC",
        "forms": [
            {
                "orange_id": "22056-1",
                "form": "FOR SUSPENSION, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE/PACKET",
                    "EQ 10MG BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 2981,
        "type": "OTC",
        "ingredient": "OMEPRAZOLE MAGNESIUM",
        "trade_name": "PRILOSEC OTC",
        "forms": [
            {
                "orange_id": "21229-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2982,
        "type": "RX",
        "ingredient": "OMEPRAZOLE AND SODIUM BICARBONATE",
        "trade_name": "OMEPRAZOLE AND SODIUM BICARBONATE",
        "forms": [
            {
                "orange_id": "204228-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG-1.1GM",
                    "40MG-1.1GM"
                ]
            },
            {
                "orange_id": "205545-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "20MG/PACKET-1.68GM/PACKET",
                    "40MG/PACKET-1.68GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 2983,
        "type": "RX",
        "ingredient": "OMEPRAZOLE AND SODIUM BICARBONATE",
        "trade_name": "ZEGERID",
        "forms": [
            {
                "orange_id": "21849-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG-1.1GM",
                    "40MG-1.1GM"
                ]
            },
            {
                "orange_id": "21636-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "20MG/PACKET-1.68GM/PACKET",
                    "40MG/PACKET-1.68GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 2984,
        "type": "OTC",
        "ingredient": "OMEPRAZOLE AND SODIUM BICARBONATE",
        "trade_name": "ZEGERID OTC",
        "forms": [
            {
                "orange_id": "22281-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG-1.1GM"
                ]
            },
            {
                "orange_id": "22283-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "20MG/PACKET-1.68GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 2985,
        "type": "RX",
        "ingredient": "ONDANSETRON",
        "trade_name": "ONDANSETRON",
        "forms": [
            {
                "orange_id": "90469-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 2986,
        "type": "RX",
        "ingredient": "ONDANSETRON HYDROCHLORIDE",
        "trade_name": "ONDANSETRON HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206846-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML"
                ]
            },
            {
                "orange_id": "91483-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE/5ML"
                ]
            },
            {
                "orange_id": "77306-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 8MG BASE",
                    "EQ 24MG BASE",
                    "EQ 16MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2987,
        "type": "RX",
        "ingredient": "ONDANSETRON HYDROCHLORIDE",
        "trade_name": "ONDANSETRON HYDROCHLORIDE PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "206845-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2988,
        "type": "RX",
        "ingredient": "ONDANSETRON HYDROCHLORIDE",
        "trade_name": "ZOFRAN",
        "forms": [
            {
                "orange_id": "20605-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE/5ML"
                ]
            },
            {
                "orange_id": "20103-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE",
                    "EQ 8MG BASE",
                    "EQ 24MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2989,
        "type": "RX",
        "ingredient": "OPICAPONE",
        "trade_name": "ONGENTYS",
        "forms": [
            {
                "orange_id": "212489-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 2990,
        "type": "RX",
        "ingredient": "ORITAVANCIN DIPHOSPHATE",
        "trade_name": "KIMYRSA",
        "forms": [
            {
                "orange_id": "214155-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1.2GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2991,
        "type": "RX",
        "ingredient": "ORITAVANCIN DIPHOSPHATE",
        "trade_name": "ORBACTIV",
        "forms": [
            {
                "orange_id": "206334-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 400MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 2992,
        "type": "OTC",
        "ingredient": "ORLISTAT",
        "trade_name": "ALLI",
        "forms": [
            {
                "orange_id": "21887-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 2993,
        "type": "RX",
        "ingredient": "ORLISTAT",
        "trade_name": "XENICAL",
        "forms": [
            {
                "orange_id": "20766-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 2994,
        "type": "RX",
        "ingredient": "ORPHENADRINE CITRATE",
        "trade_name": "ORPHENADRINE CITRATE",
        "forms": [
            {
                "orange_id": "40484-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/ML"
                ]
            },
            {
                "orange_id": "40249-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 2995,
        "type": "RX",
        "ingredient": "OSELTAMIVIR PHOSPHATE",
        "trade_name": "OSELTAMIVIR PHOSPHATE",
        "forms": [
            {
                "orange_id": "211823-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE",
                    "EQ 45MG BASE",
                    "EQ 75MG BASE"
                ]
            },
            {
                "orange_id": "212784-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 6MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2996,
        "type": "RX",
        "ingredient": "OSELTAMIVIR PHOSPHATE",
        "trade_name": "TAMIFLU",
        "forms": [
            {
                "orange_id": "21087-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 30MG BASE",
                    "EQ 45MG BASE",
                    "EQ 75MG BASE"
                ]
            },
            {
                "orange_id": "21246-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 6MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 2997,
        "type": "RX",
        "ingredient": "OSILODROSTAT PHOSPHATE",
        "trade_name": "ISTURISA",
        "forms": [
            {
                "orange_id": "212801-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2998,
        "type": "RX",
        "ingredient": "OSIMERTINIB MESYLATE",
        "trade_name": "TAGRISSO",
        "forms": [
            {
                "orange_id": "208065-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 2999,
        "type": "RX",
        "ingredient": "OSPEMIFENE",
        "trade_name": "OSPHENA",
        "forms": [
            {
                "orange_id": "203505-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3000,
        "type": "RX",
        "ingredient": "OXACILLIN SODIUM",
        "trade_name": "BACTOCILL IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50640-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 20MG BASE/ML",
                    "EQ 40MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3001,
        "type": "RX",
        "ingredient": "OXACILLIN SODIUM",
        "trade_name": "OXACILLIN SODIUM",
        "forms": [
            {
                "orange_id": "201539-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 2GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3002,
        "type": "RX",
        "ingredient": "OXALIPLATIN",
        "trade_name": "ELOXATIN",
        "forms": [
            {
                "orange_id": "21759-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/10ML (5MG/ML)",
                    "100MG/20ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3003,
        "type": "RX",
        "ingredient": "OXALIPLATIN",
        "trade_name": "OXALIPLATIN",
        "forms": [
            {
                "orange_id": "207474-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/10ML (5MG/ML)",
                    "100MG/20ML (5MG/ML)",
                    "50MG/VIAL",
                    "100MG/VIAL",
                    "200MG/40ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3004,
        "type": "RX",
        "ingredient": "OXANDROLONE",
        "trade_name": "OXANDROLONE",
        "forms": [
            {
                "orange_id": "77827-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3005,
        "type": "RX",
        "ingredient": "OXAPROZIN",
        "trade_name": "DAYPRO",
        "forms": [
            {
                "orange_id": "18841-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3006,
        "type": "RX",
        "ingredient": "OXAPROZIN",
        "trade_name": "OXAPROZIN",
        "forms": [
            {
                "orange_id": "208633-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3007,
        "type": "RX",
        "ingredient": "OXAZEPAM",
        "trade_name": "OXAZEPAM",
        "forms": [
            {
                "orange_id": "72253-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3008,
        "type": "RX",
        "ingredient": "OXCARBAZEPINE",
        "trade_name": "OXCARBAZEPINE",
        "forms": [
            {
                "orange_id": "211420-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "300MG/5ML"
                ]
            },
            {
                "orange_id": "215939-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3009,
        "type": "RX",
        "ingredient": "OXCARBAZEPINE",
        "trade_name": "OXTELLAR XR",
        "forms": [
            {
                "orange_id": "202810-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3010,
        "type": "RX",
        "ingredient": "OXCARBAZEPINE",
        "trade_name": "TRILEPTAL",
        "forms": [
            {
                "orange_id": "21285-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "300MG/5ML"
                ]
            },
            {
                "orange_id": "21014-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3011,
        "type": "RX",
        "ingredient": "OXICONAZOLE NITRATE",
        "trade_name": "OXICONAZOLE NITRATE",
        "forms": [
            {
                "orange_id": "205076-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 3012,
        "type": "RX",
        "ingredient": "OXICONAZOLE NITRATE",
        "trade_name": "OXISTAT",
        "forms": [
            {
                "orange_id": "19828-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            },
            {
                "orange_id": "20209-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1% BASE"
                ]
            }
        ]
    },
    {
        "id": 3013,
        "type": "RX",
        "ingredient": "OXYBUTYNIN",
        "trade_name": "OXYTROL",
        "forms": [
            {
                "orange_id": "21351-2",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "3.9MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3014,
        "type": "OTC",
        "ingredient": "OXYBUTYNIN",
        "trade_name": "OXYTROL FOR WOMEN",
        "forms": [
            {
                "orange_id": "202211-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "3.9MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3015,
        "type": "RX",
        "ingredient": "OXYBUTYNIN CHLORIDE",
        "trade_name": "DITROPAN XL",
        "forms": [
            {
                "orange_id": "20897-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3016,
        "type": "RX",
        "ingredient": "OXYBUTYNIN CHLORIDE",
        "trade_name": "GELNIQUE",
        "forms": [
            {
                "orange_id": "22204-1",
                "form": "GEL",
                "route": "TRANSDERMAL",
                "dosage": [
                    "10% (100MG/PACKET)"
                ]
            }
        ]
    },
    {
        "id": 3017,
        "type": "RX",
        "ingredient": "OXYBUTYNIN CHLORIDE",
        "trade_name": "OXYBUTYNIN CHLORIDE",
        "forms": [
            {
                "orange_id": "74520-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "207138-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG"
                ]
            },
            {
                "orange_id": "209335-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3018,
        "type": "RX",
        "ingredient": "OXYCODONE",
        "trade_name": "XTAMPZA ER",
        "forms": [
            {
                "orange_id": "208090-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "9MG",
                    "13.5MG",
                    "18MG",
                    "27MG",
                    "36MG"
                ]
            }
        ]
    },
    {
        "id": 3019,
        "type": "RX",
        "ingredient": "OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXAYDO",
        "forms": [
            {
                "orange_id": "202080-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG"
                ]
            }
        ]
    },
    {
        "id": 3020,
        "type": "RX",
        "ingredient": "OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXYCODONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205177-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            },
            {
                "orange_id": "208593-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML",
                    "100MG/5ML"
                ]
            },
            {
                "orange_id": "202116-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "15MG",
                    "30MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3021,
        "type": "RX",
        "ingredient": "OXYCODONE HYDROCHLORIDE",
        "trade_name": "OXYCONTIN",
        "forms": [
            {
                "orange_id": "22272-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG",
                    "40MG",
                    "60MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3022,
        "type": "RX",
        "ingredient": "OXYCODONE HYDROCHLORIDE",
        "trade_name": "ROXICODONE",
        "forms": [
            {
                "orange_id": "21011-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3023,
        "type": "RX",
        "ingredient": "OXYMETAZOLINE HYDROCHLORIDE",
        "trade_name": "RHOFADE",
        "forms": [
            {
                "orange_id": "208552-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3024,
        "type": "RX",
        "ingredient": "OXYMETAZOLINE HYDROCHLORIDE",
        "trade_name": "UPNEEQ",
        "forms": [
            {
                "orange_id": "212520-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3025,
        "type": "OTC",
        "ingredient": "OXYMETAZOLINE HYDROCHLORIDE",
        "trade_name": "VISINE L. R.",
        "forms": [
            {
                "orange_id": "19407-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 3026,
        "type": "RX",
        "ingredient": "OXYMETAZOLINE HYDROCHLORIDE AND TETRACAINE HYDROCHLORIDE",
        "trade_name": "KOVANAZE",
        "forms": [
            {
                "orange_id": "208032-1",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.1MG/SPRAY-6MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3027,
        "type": "RX",
        "ingredient": "OXYMORPHONE HYDROCHLORIDE",
        "trade_name": "OXYMORPHONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79087-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG",
                    "10MG",
                    "15MG",
                    "20MG",
                    "30MG",
                    "40MG"
                ]
            },
            {
                "orange_id": "210175-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3028,
        "type": "RX",
        "ingredient": "OXYTOCIN",
        "trade_name": "OXYTOCIN",
        "forms": [
            {
                "orange_id": "18248-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10USP UNITS/ML (10USP UNITS/ML)",
                    "100USP UNITS/10ML (10USP UNITS/ML)",
                    "300USP UNITS/30ML (10USP UNITS/ML)"
                ]
            }
        ]
    },
    {
        "id": 3029,
        "type": "RX",
        "ingredient": "OXYTOCIN",
        "trade_name": "PITOCIN",
        "forms": [
            {
                "orange_id": "18261-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10USP UNITS/ML (10USP UNITS/ML)",
                    "100USP UNITS/10ML (10USP UNITS/ML)",
                    "500USP UNITS/50ML (10USP UNITS/ML)"
                ]
            }
        ]
    },
    {
        "id": 3030,
        "type": "RX",
        "ingredient": "OZANIMOD HYDROCHLORIDE",
        "trade_name": "ZEPOSIA",
        "forms": [
            {
                "orange_id": "209899-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.23MG BASE",
                    "EQ 0.46MG BASE",
                    "EQ 0.92MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3031,
        "type": "RX",
        "ingredient": "OZENOXACIN",
        "trade_name": "XEPI",
        "forms": [
            {
                "orange_id": "208945-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3032,
        "type": "RX",
        "ingredient": "PACLITAXEL",
        "trade_name": "ABRAXANE",
        "forms": [
            {
                "orange_id": "21660-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3033,
        "type": "RX",
        "ingredient": "PACLITAXEL",
        "trade_name": "PACITAXEL",
        "forms": [
            {
                "orange_id": "207326-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3034,
        "type": "RX",
        "ingredient": "PACLITAXEL",
        "trade_name": "PACLITAXEL",
        "forms": [
            {
                "orange_id": "205720-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3035,
        "type": "RX",
        "ingredient": "PAFOLACIANINE SODIUM",
        "trade_name": "CYTALUX",
        "forms": [
            {
                "orange_id": "214907-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 3.2MG BASE/1.6ML (EQ 2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3036,
        "type": "RX",
        "ingredient": "PALBOCICLIB",
        "trade_name": "IBRANCE",
        "forms": [
            {
                "orange_id": "207103-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "100MG",
                    "125MG"
                ]
            },
            {
                "orange_id": "212436-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG",
                    "100MG",
                    "125MG"
                ]
            }
        ]
    },
    {
        "id": 3037,
        "type": "RX",
        "ingredient": "PALIPERIDONE",
        "trade_name": "INVEGA",
        "forms": [
            {
                "orange_id": "21999-6",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.5MG",
                    "3MG",
                    "6MG",
                    "9MG"
                ]
            }
        ]
    },
    {
        "id": 3038,
        "type": "RX",
        "ingredient": "PALIPERIDONE",
        "trade_name": "PALIPERIDONE",
        "forms": [
            {
                "orange_id": "202645-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1.5MG",
                    "3MG",
                    "6MG",
                    "9MG",
                    "1.5mg"
                ]
            }
        ]
    },
    {
        "id": 3039,
        "type": "RX",
        "ingredient": "PALIPERIDONE PALMITATE",
        "trade_name": "INVEGA HAFYERA",
        "forms": [
            {
                "orange_id": "207946-5",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "1.092GM/3.5ML (312MG/ML)",
                    "1.560GM/5ML (312MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3040,
        "type": "RX",
        "ingredient": "PALIPERIDONE PALMITATE",
        "trade_name": "INVEGA SUSTENNA",
        "forms": [
            {
                "orange_id": "22264-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "39MG/0.25ML (39MG/0.25ML)",
                    "78MG/0.5ML (78MG/0.5ML)",
                    "117MG/0.75ML (117MG/0.75ML)",
                    "156MG/ML (156MG/ML)",
                    "234MG/1.5ML (156MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3041,
        "type": "RX",
        "ingredient": "PALIPERIDONE PALMITATE",
        "trade_name": "INVEGA TRINZA",
        "forms": [
            {
                "orange_id": "207946-1",
                "form": "SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "273MG/0.875ML (273MG/0.875ML)",
                    "410MG/1.315ML (311.79MG/ML)",
                    "546MG/1.75ML (312MG/ML)",
                    "819MG/2.625ML (312MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3042,
        "type": "RX",
        "ingredient": "PALONOSETRON HYDROCHLORIDE",
        "trade_name": "PALONOSETRON HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206916-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.25MG BASE/5ML (EQ 0.05MG BASE/ML)"
                ]
            },
            {
                "orange_id": "207963-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 0.25MG BASE/2ML (EQ 0.125MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3043,
        "type": "RX",
        "ingredient": "PAMIDRONATE DISODIUM",
        "trade_name": "PAMIDRONATE DISODIUM",
        "forms": [
            {
                "orange_id": "77433-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30MG/VIAL",
                    "60MG/VIAL",
                    "90MG/VIAL",
                    "30MG/10ML (3MG/ML)",
                    "60MG/10ML (6MG/ML)",
                    "90MG/10ML (9MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3044,
        "type": "RX",
        "ingredient": "PANCURONIUM BROMIDE",
        "trade_name": "PANCURONIUM BROMIDE",
        "forms": [
            {
                "orange_id": "72759-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML",
                    "2MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3045,
        "type": "RX",
        "ingredient": "PANTOPRAZOLE SODIUM",
        "trade_name": "PANTOPRAZOLE SODIUM",
        "forms": [
            {
                "orange_id": "213725-1",
                "form": "FOR SUSPENSION, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "209524-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 40MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "209463-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 40MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "90797-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3046,
        "type": "RX",
        "ingredient": "PANTOPRAZOLE SODIUM",
        "trade_name": "PROTONIX",
        "forms": [
            {
                "orange_id": "22020-1",
                "form": "FOR SUSPENSION, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE"
                ]
            },
            {
                "orange_id": "20987-2",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3047,
        "type": "RX",
        "ingredient": "PANTOPRAZOLE SODIUM",
        "trade_name": "PROTONIX IV",
        "forms": [
            {
                "orange_id": "20988-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 40MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3048,
        "type": "RX",
        "ingredient": "PARICALCITOL",
        "trade_name": "PARICALCITOL",
        "forms": [
            {
                "orange_id": "204327-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MCG",
                    "2MCG",
                    "4MCG"
                ]
            },
            {
                "orange_id": "207174-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.002MG/ML (0.002MG/ML)",
                    "0.005MG/ML (0.005MG/ML)",
                    "0.01MG/2ML (0.005MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3049,
        "type": "RX",
        "ingredient": "PARICALCITOL",
        "trade_name": "ZEMPLAR",
        "forms": [
            {
                "orange_id": "21606-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MCG",
                    "2MCG"
                ]
            },
            {
                "orange_id": "20819-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.002MG/ML (0.002MG/ML)",
                    "0.005MG/ML (0.005MG/ML)",
                    "0.01MG/2ML (0.005MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3050,
        "type": "RX",
        "ingredient": "PAROMOMYCIN SULFATE",
        "trade_name": "PAROMOMYCIN SULFATE",
        "forms": [
            {
                "orange_id": "65173-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3051,
        "type": "RX",
        "ingredient": "PAROXETINE HYDROCHLORIDE",
        "trade_name": "PAROXETINE",
        "forms": [
            {
                "orange_id": "203854-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3052,
        "type": "RX",
        "ingredient": "PAROXETINE HYDROCHLORIDE",
        "trade_name": "PAROXETINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "215003-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/5ML"
                ]
            },
            {
                "orange_id": "77873-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE",
                    "EQ 37.5MG BASE",
                    "EQ 37.5MG BASE "
                ]
            },
            {
                "orange_id": "75356-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3053,
        "type": "RX",
        "ingredient": "PAROXETINE HYDROCHLORIDE",
        "trade_name": "PAXIL",
        "forms": [
            {
                "orange_id": "20710-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/5ML"
                ]
            },
            {
                "orange_id": "20031-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3054,
        "type": "RX",
        "ingredient": "PAROXETINE HYDROCHLORIDE",
        "trade_name": "PAXIL CR",
        "forms": [
            {
                "orange_id": "20936-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE",
                    "EQ 37.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3055,
        "type": "RX",
        "ingredient": "PAROXETINE MESYLATE",
        "trade_name": "BRISDELLE",
        "forms": [
            {
                "orange_id": "204516-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 7.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3056,
        "type": "RX",
        "ingredient": "PAROXETINE MESYLATE",
        "trade_name": "PAROXETINE MESYLATE",
        "forms": [
            {
                "orange_id": "207139-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 7.5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3057,
        "type": "RX",
        "ingredient": "PAROXETINE MESYLATE",
        "trade_name": "PEXEVA",
        "forms": [
            {
                "orange_id": "21299-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 30MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3058,
        "type": "RX",
        "ingredient": "PASIREOTIDE DIASPARTATE",
        "trade_name": "SIGNIFOR",
        "forms": [
            {
                "orange_id": "200677-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 0.3MG BASE/ML (EQ 0.3MG BASE/ML)",
                    "EQ 0.6MG BASE/ML (EQ 0.6MG BASE/ML)",
                    "EQ 0.9MG BASE/ML (EQ 0.9MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3059,
        "type": "RX",
        "ingredient": "PASIREOTIDE PAMOATE",
        "trade_name": "SIGNIFOR LAR KIT",
        "forms": [
            {
                "orange_id": "203255-4",
                "form": "FOR SUSPENSION",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 10MG BASE/VIAL",
                    "EQ 20MG BASE/VIAL",
                    "EQ 30MG BASE/VIAL",
                    "EQ 40MG BASE/VIAL",
                    "EQ 60MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3060,
        "type": "RX",
        "ingredient": "PATIROMER SORBITEX CALCIUM",
        "trade_name": "VELTASSA",
        "forms": [
            {
                "orange_id": "205739-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 8.4GM BASE/PACKET",
                    "EQ 16.8GM BASE/PACKET",
                    "EQ 25.2GM BASE/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3061,
        "type": "RX",
        "ingredient": "PATISIRAN SODIUM",
        "trade_name": "ONPATTRO",
        "forms": [
            {
                "orange_id": "210922-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 10MG BASE/5ML (EQ 2MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3062,
        "type": "RX",
        "ingredient": "PAZOPANIB HYDROCHLORIDE",
        "trade_name": "VOTRIENT",
        "forms": [
            {
                "orange_id": "22465-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3063,
        "type": "RX",
        "ingredient": "PEGCETACOPLAN",
        "trade_name": "EMPAVELI",
        "forms": [
            {
                "orange_id": "215014-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "1080MG/20ML (54MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3064,
        "type": "RX",
        "ingredient": "PEMETREXED",
        "trade_name": "PEMFEXY",
        "forms": [
            {
                "orange_id": "209472-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "500MG/20ML (25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3065,
        "type": "RX",
        "ingredient": "PEMETREXED DISODIUM",
        "trade_name": "ALIMTA",
        "forms": [
            {
                "orange_id": "21462-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 100MG BASE/VIAL",
                    "EQ 500MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3066,
        "type": "RX",
        "ingredient": "PEMIGATINIB",
        "trade_name": "PEMAZYRE",
        "forms": [
            {
                "orange_id": "213736-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "4.5MG",
                    "9MG",
                    "13.5MG"
                ]
            }
        ]
    },
    {
        "id": 3067,
        "type": "RX",
        "ingredient": "PENCICLOVIR",
        "trade_name": "DENAVIR",
        "forms": [
            {
                "orange_id": "20629-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3068,
        "type": "RX",
        "ingredient": "PENICILLAMINE",
        "trade_name": "CUPRIMINE",
        "forms": [
            {
                "orange_id": "19853-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3069,
        "type": "RX",
        "ingredient": "PENICILLAMINE",
        "trade_name": "DEPEN",
        "forms": [
            {
                "orange_id": "19854-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3070,
        "type": "RX",
        "ingredient": "PENICILLAMINE",
        "trade_name": "PENICILLAMINE",
        "forms": [
            {
                "orange_id": "209921-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "212933-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3071,
        "type": "RX",
        "ingredient": "PENICILLIN G BENZATHINE",
        "trade_name": "BICILLIN L-A",
        "forms": [
            {
                "orange_id": "50141-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "600,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 3072,
        "type": "RX",
        "ingredient": "PENICILLIN G BENZATHINE AND PENICILLIN G PROCAINE",
        "trade_name": "BICILLIN C-R",
        "forms": [
            {
                "orange_id": "50138-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "300,000 UNITS/ML-300,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 3073,
        "type": "RX",
        "ingredient": "PENICILLIN G BENZATHINE AND PENICILLIN G PROCAINE",
        "trade_name": "BICILLIN C-R 900/300",
        "forms": [
            {
                "orange_id": "50138-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "900,000 UNITS/2ML-300,000 UNITS/2ML"
                ]
            }
        ]
    },
    {
        "id": 3074,
        "type": "RX",
        "ingredient": "PENICILLIN G POTASSIUM",
        "trade_name": "PENICILLIN G POTASSIUM",
        "forms": [
            {
                "orange_id": "205043-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20,000,000 UNITS/VIAL",
                    "5,000,000 UNITS/VIAL",
                    "1,000,000 UNITS/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3075,
        "type": "RX",
        "ingredient": "PENICILLIN G POTASSIUM",
        "trade_name": "PENICILLIN G POTASSIUM IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50638-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20,000 UNITS/ML",
                    "40,000 UNITS/ML",
                    "60,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 3076,
        "type": "RX",
        "ingredient": "PENICILLIN G POTASSIUM",
        "trade_name": "PFIZERPEN",
        "forms": [
            {
                "orange_id": "60657-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5,000,000 UNITS/VIAL",
                    "20,000,000 UNITS/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3077,
        "type": "RX",
        "ingredient": "PENICILLIN G PROCAINE",
        "trade_name": "PENICILLIN G PROCAINE",
        "forms": [
            {
                "orange_id": "60101-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "300,000 UNITS/ML",
                    "600,000 UNITS/ML"
                ]
            }
        ]
    },
    {
        "id": 3078,
        "type": "RX",
        "ingredient": "PENICILLIN G SODIUM",
        "trade_name": "PENICILLIN G SODIUM",
        "forms": [
            {
                "orange_id": "65068-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "5,000,000 UNITS/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3079,
        "type": "RX",
        "ingredient": "PENICILLIN V POTASSIUM",
        "trade_name": "PENICILLIN V POTASSIUM",
        "forms": [
            {
                "orange_id": "65435-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3080,
        "type": "RX",
        "ingredient": "PENICILLIN V POTASSIUM",
        "trade_name": "PENICILLIN-VK",
        "forms": [
            {
                "orange_id": "60456-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG BASE/5ML",
                    "EQ 250MG BASE/5ML"
                ]
            },
            {
                "orange_id": "60711-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3081,
        "type": "RX",
        "ingredient": "PENTAMIDINE ISETHIONATE",
        "trade_name": "NEBUPENT",
        "forms": [
            {
                "orange_id": "19887-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3082,
        "type": "RX",
        "ingredient": "PENTAMIDINE ISETHIONATE",
        "trade_name": "PENTAM",
        "forms": [
            {
                "orange_id": "19264-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "300MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3083,
        "type": "RX",
        "ingredient": "PENTAMIDINE ISETHIONATE",
        "trade_name": "PENTAMIDINE ISETHIONATE",
        "forms": [
            {
                "orange_id": "206667-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/VIAL"
                ]
            },
            {
                "orange_id": "213806-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "300MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3084,
        "type": "RX",
        "ingredient": "PENTOBARBITAL SODIUM",
        "trade_name": "NEMBUTAL SODIUM",
        "forms": [
            {
                "orange_id": "83246-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3085,
        "type": "RX",
        "ingredient": "PENTOBARBITAL SODIUM",
        "trade_name": "PENTOBARBITAL SODIUM",
        "forms": [
            {
                "orange_id": "206677-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3086,
        "type": "RX",
        "ingredient": "PENTOSAN POLYSULFATE SODIUM",
        "trade_name": "ELMIRON",
        "forms": [
            {
                "orange_id": "20193-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3087,
        "type": "RX",
        "ingredient": "PENTOSTATIN",
        "trade_name": "NIPENT",
        "forms": [
            {
                "orange_id": "20122-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3088,
        "type": "RX",
        "ingredient": "PENTOSTATIN",
        "trade_name": "PENTOSTATIN",
        "forms": [
            {
                "orange_id": "77841-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3089,
        "type": "RX",
        "ingredient": "PENTOXIFYLLINE",
        "trade_name": "PENTOXIFYLLINE",
        "forms": [
            {
                "orange_id": "75191-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 3090,
        "type": "RX",
        "ingredient": "PERAMIVIR",
        "trade_name": "RAPIVAB",
        "forms": [
            {
                "orange_id": "206426-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/20ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3091,
        "type": "RX",
        "ingredient": "PERAMPANEL",
        "trade_name": "FYCOMPA",
        "forms": [
            {
                "orange_id": "208277-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "0.5MG/ML"
                ]
            },
            {
                "orange_id": "202834-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "6MG",
                    "8MG",
                    "10MG",
                    "12MG"
                ]
            }
        ]
    },
    {
        "id": 3092,
        "type": "RX",
        "ingredient": "PERFLUTREN",
        "trade_name": "DEFINITY",
        "forms": [
            {
                "orange_id": "21064-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6.52MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3093,
        "type": "RX",
        "ingredient": "PERFLUTREN",
        "trade_name": "DEFINITY RT",
        "forms": [
            {
                "orange_id": "21064-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "6.52MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3094,
        "type": "RX",
        "ingredient": "PERINDOPRIL ERBUMINE",
        "trade_name": "PERINDOPRIL ERBUMINE",
        "forms": [
            {
                "orange_id": "79070-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3095,
        "type": "OTC",
        "ingredient": "PERMETHRIN",
        "trade_name": "NIX",
        "forms": [
            {
                "orange_id": "19918-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3096,
        "type": "RX",
        "ingredient": "PERMETHRIN",
        "trade_name": "PERMETHRIN",
        "forms": [
            {
                "orange_id": "74806-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            },
            {
                "orange_id": "75014-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3097,
        "type": "RX",
        "ingredient": "PERPHENAZINE",
        "trade_name": "PERPHENAZINE",
        "forms": [
            {
                "orange_id": "206691-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "8MG",
                    "16MG"
                ]
            }
        ]
    },
    {
        "id": 3098,
        "type": "RX",
        "ingredient": "PEXIDARTINIB HYDROCHLORIDE",
        "trade_name": "TURALIO",
        "forms": [
            {
                "orange_id": "211810-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3099,
        "type": "RX",
        "ingredient": "PHENDIMETRAZINE TARTRATE",
        "trade_name": "BONTRIL PDM",
        "forms": [
            {
                "orange_id": "85272-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "35MG"
                ]
            }
        ]
    },
    {
        "id": 3100,
        "type": "RX",
        "ingredient": "PHENDIMETRAZINE TARTRATE",
        "trade_name": "PHENDIMETRAZINE TARTRATE",
        "forms": [
            {
                "orange_id": "18074-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "105MG"
                ]
            },
            {
                "orange_id": "40762-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "35MG"
                ]
            }
        ]
    },
    {
        "id": 3101,
        "type": "RX",
        "ingredient": "PHENELZINE SULFATE",
        "trade_name": "NARDIL",
        "forms": [
            {
                "orange_id": "11909-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3102,
        "type": "RX",
        "ingredient": "PHENELZINE SULFATE",
        "trade_name": "PHENELZINE SULFATE",
        "forms": [
            {
                "orange_id": "200181-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3103,
        "type": "RX",
        "ingredient": "PHENOXYBENZAMINE HYDROCHLORIDE",
        "trade_name": "DIBENZYLINE",
        "forms": [
            {
                "orange_id": "8708-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3104,
        "type": "RX",
        "ingredient": "PHENOXYBENZAMINE HYDROCHLORIDE",
        "trade_name": "PHENOXYBENZAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "212568-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3105,
        "type": "RX",
        "ingredient": "PHENTERMINE HYDROCHLORIDE",
        "trade_name": "ADIPEX-P",
        "forms": [
            {
                "orange_id": "88023-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "37.5MG"
                ]
            },
            {
                "orange_id": "85128-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "37.5MG"
                ]
            }
        ]
    },
    {
        "id": 3106,
        "type": "RX",
        "ingredient": "PHENTERMINE HYDROCHLORIDE",
        "trade_name": "LOMAIRA",
        "forms": [
            {
                "orange_id": "203495-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3107,
        "type": "RX",
        "ingredient": "PHENTERMINE HYDROCHLORIDE",
        "trade_name": "PHENTERMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204318-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "37.5MG"
                ]
            },
            {
                "orange_id": "204663-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "37.5MG"
                ]
            },
            {
                "orange_id": "203068-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "37.5MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3108,
        "type": "RX",
        "ingredient": "PHENTERMINE HYDROCHLORIDE AND TOPIRAMATE",
        "trade_name": "QSYMIA",
        "forms": [
            {
                "orange_id": "22580-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 3.75MG BASE-23MG",
                    "EQ 7.5MG BASE-46MG",
                    "EQ 11.25MG BASE-69MG",
                    "EQ 15MG BASE-92MG"
                ]
            }
        ]
    },
    {
        "id": 3109,
        "type": "RX",
        "ingredient": "PHENTOLAMINE MESYLATE",
        "trade_name": "ORAVERSE",
        "forms": [
            {
                "orange_id": "22159-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.4MG/1.7ML"
                ]
            }
        ]
    },
    {
        "id": 3110,
        "type": "RX",
        "ingredient": "PHENTOLAMINE MESYLATE",
        "trade_name": "PHENTOLAMINE MESYLATE",
        "forms": [
            {
                "orange_id": "40235-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3111,
        "type": "RX",
        "ingredient": "PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "BIORPHEN",
        "forms": [
            {
                "orange_id": "212909-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.5MG/5ML (0.1MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3112,
        "type": "RX",
        "ingredient": "PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "PHENYLEPHRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207926-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "2.5%",
                    "10%"
                ]
            },
            {
                "orange_id": "211079-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/ML (10MG/ML)",
                    "50MG/5ML (10MG/ML)",
                    "100MG/10ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3113,
        "type": "RX",
        "ingredient": "PHENYLEPHRINE HYDROCHLORIDE",
        "trade_name": "VAZCULEP",
        "forms": [
            {
                "orange_id": "204300-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/ML (10MG/ML)",
                    "50MG/5ML (10MG/ML)",
                    "100MG/10ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3114,
        "type": "RX",
        "ingredient": "PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40675-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3115,
        "type": "RX",
        "ingredient": "PHENYLEPHRINE HYDROCHLORIDE AND PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE HYDROCHLORIDE AND PHENYLEPHRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40902-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML-6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3116,
        "type": "RX",
        "ingredient": "PHENYTOIN",
        "trade_name": "DILANTIN",
        "forms": [
            {
                "orange_id": "84427-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3117,
        "type": "RX",
        "ingredient": "PHENYTOIN",
        "trade_name": "DILANTIN-125",
        "forms": [
            {
                "orange_id": "8762-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3118,
        "type": "RX",
        "ingredient": "PHENYTOIN",
        "trade_name": "PHENYTOIN",
        "forms": [
            {
                "orange_id": "40521-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "125MG/5ML"
                ]
            },
            {
                "orange_id": "40884-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3119,
        "type": "RX",
        "ingredient": "PHENYTOIN SODIUM",
        "trade_name": "DILANTIN",
        "forms": [
            {
                "orange_id": "84349-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "30MG EXTENDED",
                    "100MG EXTENDED"
                ]
            }
        ]
    },
    {
        "id": 3120,
        "type": "RX",
        "ingredient": "PHENYTOIN SODIUM",
        "trade_name": "EXTENDED PHENYTOIN SODIUM",
        "forms": [
            {
                "orange_id": "40765-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG EXTENDED",
                    "200MG EXTENDED",
                    "300MG EXTENDED"
                ]
            }
        ]
    },
    {
        "id": 3121,
        "type": "RX",
        "ingredient": "PHENYTOIN SODIUM",
        "trade_name": "PHENYTEK",
        "forms": [
            {
                "orange_id": "40298-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG EXTENDED",
                    "300MG EXTENDED"
                ]
            }
        ]
    },
    {
        "id": 3122,
        "type": "RX",
        "ingredient": "PHENYTOIN SODIUM",
        "trade_name": "PHENYTOIN SODIUM",
        "forms": [
            {
                "orange_id": "204309-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG EXTENDED"
                ]
            },
            {
                "orange_id": "40573-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3123,
        "type": "RX",
        "ingredient": "PHYTONADIONE",
        "trade_name": "MEPHYTON",
        "forms": [
            {
                "orange_id": "10104-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3124,
        "type": "RX",
        "ingredient": "PHYTONADIONE",
        "trade_name": "PHYTONADIONE",
        "forms": [
            {
                "orange_id": "207719-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML",
                    "1MG/0.5ML"
                ]
            },
            {
                "orange_id": "209373-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3125,
        "type": "RX",
        "ingredient": "PHYTONADIONE",
        "trade_name": "VITAMIN K1",
        "forms": [
            {
                "orange_id": "87954-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/0.5ML",
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3126,
        "type": "RX",
        "ingredient": "PIFLUFOLASTAT F-18",
        "trade_name": "PYLARIFY",
        "forms": [
            {
                "orange_id": "214793-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50ML (1-80mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 3127,
        "type": "RX",
        "ingredient": "PILOCARPINE HYDROCHLORIDE",
        "trade_name": "ISOPTO CARPINE",
        "forms": [
            {
                "orange_id": "200890-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%",
                    "2%",
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 3128,
        "type": "RX",
        "ingredient": "PILOCARPINE HYDROCHLORIDE",
        "trade_name": "PILOCARPINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204398-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%",
                    "2%",
                    "4%"
                ]
            },
            {
                "orange_id": "76963-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG"
                ]
            }
        ]
    },
    {
        "id": 3129,
        "type": "RX",
        "ingredient": "PILOCARPINE HYDROCHLORIDE",
        "trade_name": "SALAGEN",
        "forms": [
            {
                "orange_id": "20237-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "7.5MG"
                ]
            }
        ]
    },
    {
        "id": 3130,
        "type": "RX",
        "ingredient": "PILOCARPINE HYDROCHLORIDE",
        "trade_name": "VUITY",
        "forms": [
            {
                "orange_id": "214028-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1.25%"
                ]
            }
        ]
    },
    {
        "id": 3131,
        "type": "RX",
        "ingredient": "PIMAVANSERIN TARTRATE",
        "trade_name": "NUPLAZID",
        "forms": [
            {
                "orange_id": "210793-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 34MG BASE"
                ]
            },
            {
                "orange_id": "207318-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3132,
        "type": "RX",
        "ingredient": "PIMECROLIMUS",
        "trade_name": "ELIDEL",
        "forms": [
            {
                "orange_id": "21302-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3133,
        "type": "RX",
        "ingredient": "PIMECROLIMUS",
        "trade_name": "PIMECROLIMUS",
        "forms": [
            {
                "orange_id": "209345-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3134,
        "type": "RX",
        "ingredient": "PIMOZIDE",
        "trade_name": "PIMOZIDE",
        "forms": [
            {
                "orange_id": "204521-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3135,
        "type": "RX",
        "ingredient": "PINDOLOL",
        "trade_name": "PINDOLOL",
        "forms": [
            {
                "orange_id": "73609-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3136,
        "type": "RX",
        "ingredient": "PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "ACTOS",
        "forms": [
            {
                "orange_id": "21073-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE",
                    "EQ 30MG BASE",
                    "EQ 45MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3137,
        "type": "RX",
        "ingredient": "PIOGLITAZONE HYDROCHLORIDE",
        "trade_name": "PIOGLITAZONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "200044-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE",
                    "EQ 30MG BASE",
                    "EQ 45MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3138,
        "type": "RX",
        "ingredient": "PIPERACILLIN SODIUM",
        "trade_name": "PIPERACILLIN",
        "forms": [
            {
                "orange_id": "65114-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2GM BASE/VIAL",
                    "EQ 3GM BASE/VIAL",
                    "EQ 4GM BASE/VIAL",
                    "EQ 40GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3139,
        "type": "RX",
        "ingredient": "PIPERACILLIN SODIUM AND TAZOBACTAM SODIUM",
        "trade_name": "PIPERACILLIN AND TAZOBACTAM",
        "forms": [
            {
                "orange_id": "212287-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 2GM BASE/VIAL-EQ 250MG BASE/VIAL",
                    "EQ 3GM BASE/VIAL-EQ 375MG BASE/VIAL",
                    "EQ 4GM BASE/VIAL-EQ 500MG BASE/VIAL",
                    "EQ 36GM BASE/VIAL-EQ 4.5GM BASE/VIAL",
                    "EQ 12GM BASE/VIAL-EQ 1.5GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3140,
        "type": "RX",
        "ingredient": "PIPERACILLIN SODIUM AND TAZOBACTAM SODIUM",
        "trade_name": "ZOSYN IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50750-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 4GM BASE/100ML-EQ 500MG BASE/100ML",
                    "EQ 40MG BASE/ML-EQ 5MG BASE/ML",
                    "EQ 60MG BASE/ML-EQ 7.5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3141,
        "type": "RX",
        "ingredient": "PIRFENIDONE",
        "trade_name": "ESBRIET",
        "forms": [
            {
                "orange_id": "22535-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "267MG"
                ]
            },
            {
                "orange_id": "208780-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "267MG",
                    "801MG"
                ]
            }
        ]
    },
    {
        "id": 3142,
        "type": "RX",
        "ingredient": "PIRFENIDONE",
        "trade_name": "PIRFENIDONE",
        "forms": [
            {
                "orange_id": "212731-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "267MG"
                ]
            },
            {
                "orange_id": "212730-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "267MG",
                    "801MG"
                ]
            }
        ]
    },
    {
        "id": 3143,
        "type": "RX",
        "ingredient": "PIROXICAM",
        "trade_name": "FELDENE",
        "forms": [
            {
                "orange_id": "18147-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3144,
        "type": "RX",
        "ingredient": "PIROXICAM",
        "trade_name": "PIROXICAM",
        "forms": [
            {
                "orange_id": "205585-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3145,
        "type": "RX",
        "ingredient": "PITAVASTATIN CALCIUM",
        "trade_name": "LIVALO",
        "forms": [
            {
                "orange_id": "22363-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3146,
        "type": "RX",
        "ingredient": "PITAVASTATIN CALCIUM",
        "trade_name": "PITAVASTATIN CALCIUM",
        "forms": [
            {
                "orange_id": "206015-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3147,
        "type": "RX",
        "ingredient": "PITAVASTATIN MAGNESIUM",
        "trade_name": "ZYPITAMAG",
        "forms": [
            {
                "orange_id": "208379-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3148,
        "type": "RX",
        "ingredient": "PITOLISANT HYDROCHLORIDE",
        "trade_name": "WAKIX",
        "forms": [
            {
                "orange_id": "211150-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 4.45MG BASE",
                    "EQ 17.8MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3149,
        "type": "RX",
        "ingredient": "PLAZOMICIN SULFATE",
        "trade_name": "ZEMDRI",
        "forms": [
            {
                "orange_id": "210303-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 500MG BASE/10ML (EQ 50MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3150,
        "type": "RX",
        "ingredient": "PLECANATIDE",
        "trade_name": "TRULANCE",
        "forms": [
            {
                "orange_id": "208745-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG"
                ]
            }
        ]
    },
    {
        "id": 3151,
        "type": "RX",
        "ingredient": "PLERIXAFOR",
        "trade_name": "MOZOBIL",
        "forms": [
            {
                "orange_id": "22311-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "24MG/1.2ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3152,
        "type": "RX",
        "ingredient": "PODOFILOX",
        "trade_name": "CONDYLOX",
        "forms": [
            {
                "orange_id": "20529-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            },
            {
                "orange_id": "19795-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3153,
        "type": "RX",
        "ingredient": "PODOFILOX",
        "trade_name": "PODOFILOX",
        "forms": [
            {
                "orange_id": "75600-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3154,
        "type": "RX",
        "ingredient": "POLIDOCANOL",
        "trade_name": "ASCLERA",
        "forms": [
            {
                "orange_id": "21201-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/2ML (5MG/ML)",
                    "20MG/2ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3155,
        "type": "RX",
        "ingredient": "POLIDOCANOL",
        "trade_name": "VARITHENA",
        "forms": [
            {
                "orange_id": "205098-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "77.5MG/7.75ML (10MG/ML)",
                    "180MG/18ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3156,
        "type": "OTC",
        "ingredient": "POLYETHYLENE GLYCOL 3350",
        "trade_name": "MIRALAX",
        "forms": [
            {
                "orange_id": "22015-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "17GM/SCOOPFUL"
                ]
            }
        ]
    },
    {
        "id": 3157,
        "type": "OTC",
        "ingredient": "POLYETHYLENE GLYCOL 3350",
        "trade_name": "POLYETHYLENE GLYCOL 3350",
        "forms": [
            {
                "orange_id": "202850-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "17GM/SCOOPFUL",
                    "17GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3158,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "LAX-LYTE WITH FLAVOR PACKS",
        "forms": [
            {
                "orange_id": "79232-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "420GM/BOT-1.48GM/BOT-5.72GM/BOT-11.2GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3159,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "NULYTELY",
        "forms": [
            {
                "orange_id": "19797-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "420GM/BOT-1.48GM/BOT-5.72GM/BOT-11.2GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3160,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "NULYTELY-FLAVORED",
        "forms": [
            {
                "orange_id": "19797-2",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "420GM/BOT-1.48GM/BOT-5.72GM/BOT-11.2GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3161,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE AND SODIUM CHLORIDE",
        "trade_name": "PEG-3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "90019-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "420GM/BOT-1.48GM/BOT-5.72GM/BOT-11.2GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3162,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM SULFATE ANHYDROUS",
        "trade_name": "COLYTE WITH FLAVOR PACKS",
        "forms": [
            {
                "orange_id": "18983-12",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "240GM/BOT-2.98GM/BOT-6.72GM/BOT-5.84GM/BOT-22.72GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3163,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM SULFATE ANHYDROUS",
        "trade_name": "GOLYTELY",
        "forms": [
            {
                "orange_id": "19011-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "236GM/BOT-2.97GM/BOT-6.74GM/BOT-5.86GM/BOT-22.74GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3164,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM SULFATE ANHYDROUS",
        "trade_name": "PEG 3350 AND ELECTROLYTES",
        "forms": [
            {
                "orange_id": "90231-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "236GM/BOT-2.97GM/BOT-6.74GM/BOT-5.86GM/BOT-22.74GM/BOT",
                    "240GM/BOT-2.98GM/BOT-6.72GM/BOT-5.84GM/BOT-22.72GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3165,
        "type": "RX",
        "ingredient": "POLYETHYLENE GLYCOL 3350, POTASSIUM CHLORIDE, SODIUM BICARBONATE, SODIUM CHLORIDE AND SODIUM SULFATE ANHYDROUS",
        "trade_name": "POLYETHYLENE GLYCOL 3350 AND ELECTROLYTES",
        "forms": [
            {
                "orange_id": "204558-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "236GM/BOT-2.97GM/BOT-6.74GM/BOT-5.86GM/BOT-22.74GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3166,
        "type": "RX",
        "ingredient": "POLYMYXIN B SULFATE",
        "trade_name": "POLYMYXIN B SULFATE",
        "forms": [
            {
                "orange_id": "206589-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 500,000 UNITS BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3167,
        "type": "RX",
        "ingredient": "POLYMYXIN B SULFATE AND TRIMETHOPRIM SULFATE",
        "trade_name": "POLYTRIM",
        "forms": [
            {
                "orange_id": "50567-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10,000 UNITS/ML-EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3168,
        "type": "RX",
        "ingredient": "POLYMYXIN B SULFATE AND TRIMETHOPRIM SULFATE",
        "trade_name": "TRIMETHOPRIM SULFATE AND POLYMYXIN B SULFATE",
        "forms": [
            {
                "orange_id": "65006-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10,000 UNITS/ML-EQ 1MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3169,
        "type": "RX",
        "ingredient": "POMALIDOMIDE",
        "trade_name": "POMALIDOMIDE",
        "forms": [
            {
                "orange_id": "210275-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3170,
        "type": "RX",
        "ingredient": "POMALIDOMIDE",
        "trade_name": "POMALYST",
        "forms": [
            {
                "orange_id": "204026-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3171,
        "type": "RX",
        "ingredient": "PONATINIB HYDROCHLORIDE",
        "trade_name": "ICLUSIG",
        "forms": [
            {
                "orange_id": "203469-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 15MG BASE",
                    "EQ 30MG BASE",
                    "EQ 45MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3172,
        "type": "RX",
        "ingredient": "PONESIMOD",
        "trade_name": "PONVORY",
        "forms": [
            {
                "orange_id": "213498-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "3MG",
                    "4MG",
                    "5MG",
                    "6MG",
                    "7MG",
                    "8MG",
                    "9MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3173,
        "type": "RX",
        "ingredient": "PORFIMER SODIUM",
        "trade_name": "PHOTOFRIN",
        "forms": [
            {
                "orange_id": "20451-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "75MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3174,
        "type": "RX",
        "ingredient": "POSACONAZOLE",
        "trade_name": "NOXAFIL",
        "forms": [
            {
                "orange_id": "205596-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "300MG/16.7ML (18MG/ML)"
                ]
            },
            {
                "orange_id": "22003-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "205053-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3175,
        "type": "RX",
        "ingredient": "POSACONAZOLE",
        "trade_name": "POSACONAZOLE",
        "forms": [
            {
                "orange_id": "213454-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3176,
        "type": "RX",
        "ingredient": "POTASSIUM ACETATE",
        "trade_name": "POTASSIUM ACETATE",
        "forms": [
            {
                "orange_id": "206203-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MEQ/ML"
                ]
            }
        ]
    },
    {
        "id": 3177,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "KLOR-CON",
        "forms": [
            {
                "orange_id": "203106-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MEQ",
                    "10MEQ"
                ]
            },
            {
                "orange_id": "209662-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MEQ"
                ]
            },
            {
                "orange_id": "19123-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MEQ",
                    "10MEQ"
                ]
            }
        ]
    },
    {
        "id": 3178,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "KLOR-CON M10",
        "forms": [
            {
                "orange_id": "74726-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MEQ"
                ]
            }
        ]
    },
    {
        "id": 3179,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "KLOR-CON M15",
        "forms": [
            {
                "orange_id": "74726-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MEQ"
                ]
            }
        ]
    },
    {
        "id": 3180,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "KLOR-CON M20",
        "forms": [
            {
                "orange_id": "74726-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MEQ"
                ]
            }
        ]
    },
    {
        "id": 3181,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "K-TAB",
        "forms": [
            {
                "orange_id": "18279-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MEQ",
                    "10MEQ",
                    "20MEQ"
                ]
            }
        ]
    },
    {
        "id": 3182,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "77419-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "8MEQ",
                    "10MEQ"
                ]
            },
            {
                "orange_id": "210902-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MEQ"
                ]
            },
            {
                "orange_id": "85870-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MEQ/ML",
                    "3MEQ/ML"
                ]
            },
            {
                "orange_id": "210041-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MEQ/15ML",
                    "40MEQ/15ML"
                ]
            },
            {
                "orange_id": "75604-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MEQ",
                    "20MEQ",
                    "15MEQ",
                    "8MEQ"
                ]
            }
        ]
    },
    {
        "id": 3183,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 10MEQ",
        "forms": [
            {
                "orange_id": "214727-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "14.9MG/ML",
                    "745MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3184,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 10MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19904-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "14.9MG/ML",
                    "746MG/100ML",
                    "745MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3185,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ",
        "forms": [
            {
                "orange_id": "214727-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1.49GM/100ML",
                    "29.8MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3186,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19904-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1.49GM/100ML",
                    "29.8MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3187,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 30MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19904-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.24GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3188,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ",
        "forms": [
            {
                "orange_id": "214727-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.98GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3189,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19904-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.98GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3190,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "88901-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2MEQ/ML"
                ]
            }
        ]
    },
    {
        "id": 3191,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 149% IN SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "78446-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "149MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3192,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN SODIUM CHLORIDE 0. 45%",
        "forms": [
            {
                "orange_id": "17648-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/100ML-450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3193,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "17648-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3194,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 15% IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19708-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "150MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3195,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 0. 3% AND SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "17648-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "300MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3196,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 20MEQ IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19686-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "149MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3197,
        "type": "RX",
        "ingredient": "POTASSIUM CHLORIDE AND SODIUM CHLORIDE",
        "trade_name": "POTASSIUM CHLORIDE 40MEQ IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19686-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "298MG/100ML-900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3198,
        "type": "RX",
        "ingredient": "POTASSIUM CITRATE",
        "trade_name": "POTASSIUM CITRATE",
        "forms": [
            {
                "orange_id": "212779-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "10MEQ",
                    "15MEQ",
                    "5MEQ"
                ]
            }
        ]
    },
    {
        "id": 3199,
        "type": "RX",
        "ingredient": "POTASSIUM CITRATE",
        "trade_name": "UROCIT-K",
        "forms": [
            {
                "orange_id": "19071-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "5MEQ",
                    "10MEQ",
                    "15MEQ"
                ]
            }
        ]
    },
    {
        "id": 3200,
        "type": "OTC",
        "ingredient": "POTASSIUM IODIDE",
        "trade_name": "IOSAT",
        "forms": [
            {
                "orange_id": "18664-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "65MG",
                    "130MG"
                ]
            }
        ]
    },
    {
        "id": 3201,
        "type": "OTC",
        "ingredient": "POTASSIUM IODIDE",
        "trade_name": "POTASSIUM IODIDE",
        "forms": [
            {
                "orange_id": "206211-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "65MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3202,
        "type": "OTC",
        "ingredient": "POTASSIUM IODIDE",
        "trade_name": "THYROSAFE",
        "forms": [
            {
                "orange_id": "76350-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "65MG"
                ]
            }
        ]
    },
    {
        "id": 3203,
        "type": "RX",
        "ingredient": "POTASSIUM PHOSPHATE, DIBASIC AND POTASSIUM PHOSPHATE, MONOBASIC",
        "trade_name": "POTASSIUM PHOSPHATES",
        "forms": [
            {
                "orange_id": "212121-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "4.5GM/15ML (300MG/ML)-2.65GM/15ML (175MG/ML)",
                    "1.18GM/5ML (236MG/ML)-1.12GM/5ML (224MG/ML)",
                    "3.54GM/15ML (236MG/ML)-3.36GM/15ML (224MG/ML)",
                    "11.8GM/50ML (236MG/ML)-11.2GM/50ML (224MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3204,
        "type": "RX",
        "ingredient": "POVIDONE-IODINE",
        "trade_name": "BETADINE",
        "forms": [
            {
                "orange_id": "18634-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 3205,
        "type": "OTC",
        "ingredient": "POVIDONE-IODINE",
        "trade_name": "E-Z SCRUB 201",
        "forms": [
            {
                "orange_id": "19240-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 3206,
        "type": "OTC",
        "ingredient": "POVIDONE-IODINE",
        "trade_name": "E-Z SCRUB 241",
        "forms": [
            {
                "orange_id": "19476-1",
                "form": "SPONGE",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3207,
        "type": "OTC",
        "ingredient": "POVIDONE-IODINE",
        "trade_name": "POVIDONE IODINE",
        "forms": [
            {
                "orange_id": "19522-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3208,
        "type": "RX",
        "ingredient": "PRALATREXATE",
        "trade_name": "FOLOTYN",
        "forms": [
            {
                "orange_id": "22468-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/ML (20MG/ML)",
                    "40MG/2ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3209,
        "type": "RX",
        "ingredient": "PRALIDOXIME CHLORIDE",
        "trade_name": "PROTOPAM CHLORIDE",
        "forms": [
            {
                "orange_id": "14134-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3210,
        "type": "RX",
        "ingredient": "PRALSETINIB",
        "trade_name": "GAVRETO",
        "forms": [
            {
                "orange_id": "213721-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3211,
        "type": "RX",
        "ingredient": "PRAMIPEXOLE DIHYDROCHLORIDE",
        "trade_name": "MIRAPEX",
        "forms": [
            {
                "orange_id": "20667-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG",
                    "0.75MG",
                    "1MG",
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 3212,
        "type": "RX",
        "ingredient": "PRAMIPEXOLE DIHYDROCHLORIDE",
        "trade_name": "MIRAPEX ER",
        "forms": [
            {
                "orange_id": "22421-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.375MG",
                    "0.75MG",
                    "1.5MG",
                    "2.25MG",
                    "3MG",
                    "3.75MG",
                    "4.5MG"
                ]
            }
        ]
    },
    {
        "id": 3213,
        "type": "RX",
        "ingredient": "PRAMIPEXOLE DIHYDROCHLORIDE",
        "trade_name": "PRAMIPEXOLE DIHYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "201963-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "0.375MG",
                    "0.75MG",
                    "1.5MG",
                    "2.25MG",
                    "3MG",
                    "3.75MG",
                    "4.5MG"
                ]
            },
            {
                "orange_id": "202633-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG",
                    "0.5MG",
                    "0.75MG",
                    "1MG",
                    "1.5MG"
                ]
            }
        ]
    },
    {
        "id": 3214,
        "type": "RX",
        "ingredient": "PRAMLINTIDE ACETATE",
        "trade_name": "SYMLIN",
        "forms": [
            {
                "orange_id": "21332-2",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 1.5MG BASE/1.5ML (EQ 1MG BASE/ML)",
                    "EQ 2.7MG BASE/2.7ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3215,
        "type": "RX",
        "ingredient": "PRASTERONE",
        "trade_name": "INTRAROSA",
        "forms": [
            {
                "orange_id": "208470-1",
                "form": "INSERT",
                "route": "VAGINAL",
                "dosage": [
                    "6.5MG"
                ]
            }
        ]
    },
    {
        "id": 3216,
        "type": "RX",
        "ingredient": "PRASUGREL HYDROCHLORIDE",
        "trade_name": "EFFIENT",
        "forms": [
            {
                "orange_id": "22307-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3217,
        "type": "RX",
        "ingredient": "PRASUGREL HYDROCHLORIDE",
        "trade_name": "PRASUGREL",
        "forms": [
            {
                "orange_id": "205987-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3218,
        "type": "RX",
        "ingredient": "PRAVASTATIN SODIUM",
        "trade_name": "PRAVASTATIN SODIUM",
        "forms": [
            {
                "orange_id": "207068-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3219,
        "type": "RX",
        "ingredient": "PRAZIQUANTEL",
        "trade_name": "BILTRICIDE",
        "forms": [
            {
                "orange_id": "18714-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3220,
        "type": "RX",
        "ingredient": "PRAZIQUANTEL",
        "trade_name": "PRAZIQUANTEL",
        "forms": [
            {
                "orange_id": "208820-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3221,
        "type": "RX",
        "ingredient": "PRAZOSIN HYDROCHLORIDE",
        "trade_name": "MINIPRESS",
        "forms": [
            {
                "orange_id": "17442-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3222,
        "type": "RX",
        "ingredient": "PRAZOSIN HYDROCHLORIDE",
        "trade_name": "PRAZOSIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "72577-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3223,
        "type": "RX",
        "ingredient": "PREDNICARBATE",
        "trade_name": "PREDNICARBATE",
        "forms": [
            {
                "orange_id": "77236-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3224,
        "type": "RX",
        "ingredient": "PREDNISOLONE",
        "trade_name": "PREDNISOLONE",
        "forms": [
            {
                "orange_id": "40401-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "15MG/5ML"
                ]
            },
            {
                "orange_id": "80354-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3225,
        "type": "RX",
        "ingredient": "PREDNISOLONE",
        "trade_name": "PRELONE",
        "forms": [
            {
                "orange_id": "89081-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "15MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3226,
        "type": "RX",
        "ingredient": "PREDNISOLONE ACETATE",
        "trade_name": "OMNIPRED",
        "forms": [
            {
                "orange_id": "17469-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3227,
        "type": "RX",
        "ingredient": "PREDNISOLONE ACETATE",
        "trade_name": "PRED FORTE",
        "forms": [
            {
                "orange_id": "17011-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3228,
        "type": "RX",
        "ingredient": "PREDNISOLONE ACETATE",
        "trade_name": "PRED MILD",
        "forms": [
            {
                "orange_id": "17100-1",
                "form": "SUSPENSION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.12%"
                ]
            }
        ]
    },
    {
        "id": 3229,
        "type": "RX",
        "ingredient": "PREDNISOLONE ACETATE AND SULFACETAMIDE SODIUM",
        "trade_name": "BLEPHAMIDE",
        "forms": [
            {
                "orange_id": "12813-2",
                "form": "SUSPENSION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%-10%"
                ]
            }
        ]
    },
    {
        "id": 3230,
        "type": "RX",
        "ingredient": "PREDNISOLONE ACETATE AND SULFACETAMIDE SODIUM",
        "trade_name": "BLEPHAMIDE S. O. P.",
        "forms": [
            {
                "orange_id": "87748-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.2%-10%"
                ]
            }
        ]
    },
    {
        "id": 3231,
        "type": "RX",
        "ingredient": "PREDNISOLONE SODIUM PHOSPHATE",
        "trade_name": "ORAPRED ODT",
        "forms": [
            {
                "orange_id": "21959-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 15MG BASE",
                    "EQ 30MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3232,
        "type": "RX",
        "ingredient": "PREDNISOLONE SODIUM PHOSPHATE",
        "trade_name": "PEDIAPRED",
        "forms": [
            {
                "orange_id": "19157-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 3233,
        "type": "RX",
        "ingredient": "PREDNISOLONE SODIUM PHOSPHATE",
        "trade_name": "PREDNISOLONE SODIUM PHOSPHATE",
        "forms": [
            {
                "orange_id": "40070-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.9% PHOSPHATE"
                ]
            },
            {
                "orange_id": "75183-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE/5ML",
                    "EQ 10MG BASE/5ML",
                    "EQ 20MG BASE/5ML",
                    "EQ 25MG BASE/5ML",
                    "EQ 15MG BASE/5ML",
                    "EQ 30MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 3234,
        "type": "RX",
        "ingredient": "PREDNISOLONE SODIUM PHOSPHATE AND SULFACETAMIDE SODIUM",
        "trade_name": "SULFACETAMIDE SODIUM AND PREDNISOLONE SODIUM PHOSPHATE",
        "forms": [
            {
                "orange_id": "74449-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.23% PHOSPHATE-10%"
                ]
            }
        ]
    },
    {
        "id": 3235,
        "type": "RX",
        "ingredient": "PREDNISONE",
        "trade_name": "PREDNISONE",
        "forms": [
            {
                "orange_id": "88703-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/5ML"
                ]
            },
            {
                "orange_id": "213385-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "5MG",
                    "10MG",
                    "20MG",
                    "2.5MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3236,
        "type": "RX",
        "ingredient": "PREDNISONE",
        "trade_name": "PREDNISONE INTENSOL",
        "forms": [
            {
                "orange_id": "88810-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3237,
        "type": "RX",
        "ingredient": "PREDNISONE",
        "trade_name": "RAYOS",
        "forms": [
            {
                "orange_id": "202020-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3238,
        "type": "RX",
        "ingredient": "PREGABALIN",
        "trade_name": "LYRICA",
        "forms": [
            {
                "orange_id": "21446-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG",
                    "150MG",
                    "200MG",
                    "225MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "22488-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3239,
        "type": "RX",
        "ingredient": "PREGABALIN",
        "trade_name": "LYRICA CR",
        "forms": [
            {
                "orange_id": "209501-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "82.5MG",
                    "165MG",
                    "330MG"
                ]
            }
        ]
    },
    {
        "id": 3240,
        "type": "RX",
        "ingredient": "PREGABALIN",
        "trade_name": "PREGABALIN",
        "forms": [
            {
                "orange_id": "91025-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "75MG",
                    "100MG",
                    "150MG",
                    "200MG",
                    "225MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "207623-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MG/ML"
                ]
            },
            {
                "orange_id": "211593-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "82.5MG",
                    "165MG",
                    "330MG"
                ]
            }
        ]
    },
    {
        "id": 3241,
        "type": "RX",
        "ingredient": "PRETOMANID",
        "trade_name": "PRETOMANID",
        "forms": [
            {
                "orange_id": "212862-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3242,
        "type": "RX",
        "ingredient": "PRILOCAINE HYDROCHLORIDE",
        "trade_name": "PRILOCAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79235-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4%"
                ]
            }
        ]
    },
    {
        "id": 3243,
        "type": "RX",
        "ingredient": "PRIMAQUINE PHOSPHATE",
        "trade_name": "PRIMAQUINE",
        "forms": [
            {
                "orange_id": "8316-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3244,
        "type": "RX",
        "ingredient": "PRIMAQUINE PHOSPHATE",
        "trade_name": "PRIMAQUINE PHOSPHATE",
        "forms": [
            {
                "orange_id": "204476-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3245,
        "type": "RX",
        "ingredient": "PRIMIDONE",
        "trade_name": "MYSOLINE",
        "forms": [
            {
                "orange_id": "9170-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3246,
        "type": "RX",
        "ingredient": "PRIMIDONE",
        "trade_name": "PRIMIDONE",
        "forms": [
            {
                "orange_id": "40866-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3247,
        "type": "RX",
        "ingredient": "PROBENECID",
        "trade_name": "PROBALAN",
        "forms": [
            {
                "orange_id": "80966-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3248,
        "type": "RX",
        "ingredient": "PROBENECID",
        "trade_name": "PROBENECID",
        "forms": [
            {
                "orange_id": "84442-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3249,
        "type": "RX",
        "ingredient": "PROCAINAMIDE HYDROCHLORIDE",
        "trade_name": "PROCAINAMIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "89069-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML",
                    "500MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3250,
        "type": "RX",
        "ingredient": "PROCARBAZINE HYDROCHLORIDE",
        "trade_name": "MATULANE",
        "forms": [
            {
                "orange_id": "16785-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3251,
        "type": "RX",
        "ingredient": "PROCHLORPERAZINE",
        "trade_name": "COMPRO",
        "forms": [
            {
                "orange_id": "40246-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 3252,
        "type": "RX",
        "ingredient": "PROCHLORPERAZINE",
        "trade_name": "PROCHLORPERAZINE",
        "forms": [
            {
                "orange_id": "40058-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 3253,
        "type": "RX",
        "ingredient": "PROCHLORPERAZINE EDISYLATE",
        "trade_name": "PROCHLORPERAZINE EDISYLATE",
        "forms": [
            {
                "orange_id": "40540-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3254,
        "type": "RX",
        "ingredient": "PROCHLORPERAZINE MALEATE",
        "trade_name": "PROCHLORPERAZINE MALEATE",
        "forms": [
            {
                "orange_id": "40185-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3255,
        "type": "RX",
        "ingredient": "PROCHLORPERAZINE MALEATE",
        "trade_name": "PROCOMP",
        "forms": [
            {
                "orange_id": "40268-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3256,
        "type": "RX",
        "ingredient": "PROGESTERONE",
        "trade_name": "CRINONE",
        "forms": [
            {
                "orange_id": "20701-1",
                "form": "GEL",
                "route": "VAGINAL",
                "dosage": [
                    "4%",
                    "8%"
                ]
            }
        ]
    },
    {
        "id": 3257,
        "type": "RX",
        "ingredient": "PROGESTERONE",
        "trade_name": "ENDOMETRIN",
        "forms": [
            {
                "orange_id": "22057-1",
                "form": "INSERT",
                "route": "VAGINAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3258,
        "type": "RX",
        "ingredient": "PROGESTERONE",
        "trade_name": "PROGESTERONE",
        "forms": [
            {
                "orange_id": "207724-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "17362-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3259,
        "type": "RX",
        "ingredient": "PROGESTERONE",
        "trade_name": "PROMETRIUM",
        "forms": [
            {
                "orange_id": "19781-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3260,
        "type": "RX",
        "ingredient": "PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "83312-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML",
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "40428-2",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "12.5MG",
                    "25MG"
                ]
            },
            {
                "orange_id": "40026-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "6.25MG/5ML"
                ]
            },
            {
                "orange_id": "91179-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG",
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3261,
        "type": "RX",
        "ingredient": "PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHAZINE PLAIN",
        "forms": [
            {
                "orange_id": "87953-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "6.25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3262,
        "type": "RX",
        "ingredient": "PROMETHAZINE HYDROCHLORIDE",
        "trade_name": "PROMETHEGAN",
        "forms": [
            {
                "orange_id": "87165-1",
                "form": "SUPPOSITORY",
                "route": "RECTAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3263,
        "type": "RX",
        "ingredient": "PROPAFENONE HYDROCHLORIDE",
        "trade_name": "PROPAFENONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205268-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "225MG",
                    "325MG",
                    "425MG"
                ]
            },
            {
                "orange_id": "76550-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "225MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3264,
        "type": "RX",
        "ingredient": "PROPAFENONE HYDROCHLORIDE",
        "trade_name": "RYTHMOL SR",
        "forms": [
            {
                "orange_id": "21416-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "225MG",
                    "325MG",
                    "425MG"
                ]
            }
        ]
    },
    {
        "id": 3265,
        "type": "RX",
        "ingredient": "PROPARACAINE HYDROCHLORIDE",
        "trade_name": "ALCAINE",
        "forms": [
            {
                "orange_id": "80027-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3266,
        "type": "RX",
        "ingredient": "PROPARACAINE HYDROCHLORIDE",
        "trade_name": "PROPARACAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40277-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3267,
        "type": "RX",
        "ingredient": "PROPOFOL",
        "trade_name": "DIPRIVAN",
        "forms": [
            {
                "orange_id": "19627-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3268,
        "type": "RX",
        "ingredient": "PROPOFOL",
        "trade_name": "PROPOFOL",
        "forms": [
            {
                "orange_id": "205067-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3269,
        "type": "RX",
        "ingredient": "PROPRANOLOL HYDROCHLORIDE",
        "trade_name": "HEMANGEOL",
        "forms": [
            {
                "orange_id": "205410-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "4.28MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3270,
        "type": "RX",
        "ingredient": "PROPRANOLOL HYDROCHLORIDE",
        "trade_name": "INDERAL LA",
        "forms": [
            {
                "orange_id": "18553-4",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "80MG",
                    "120MG",
                    "160MG"
                ]
            }
        ]
    },
    {
        "id": 3271,
        "type": "RX",
        "ingredient": "PROPRANOLOL HYDROCHLORIDE",
        "trade_name": "INNOPRAN XL",
        "forms": [
            {
                "orange_id": "21438-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3272,
        "type": "RX",
        "ingredient": "PROPRANOLOL HYDROCHLORIDE",
        "trade_name": "PROPRANOLOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "78494-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "80MG",
                    "120MG",
                    "160MG"
                ]
            },
            {
                "orange_id": "75792-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "70979-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MG/5ML",
                    "40MG/5ML"
                ]
            },
            {
                "orange_id": "71972-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG",
                    "60MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3273,
        "type": "RX",
        "ingredient": "PROPYLTHIOURACIL",
        "trade_name": "PROPYLTHIOURACIL",
        "forms": [
            {
                "orange_id": "80172-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3274,
        "type": "RX",
        "ingredient": "PROTAMINE SULFATE",
        "trade_name": "PROTAMINE SULFATE",
        "forms": [
            {
                "orange_id": "89454-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3275,
        "type": "RX",
        "ingredient": "PROTRIPTYLINE HYDROCHLORIDE",
        "trade_name": "PROTRIPTYLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202220-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3276,
        "type": "RX",
        "ingredient": "PRUCALOPRIDE SUCCINATE",
        "trade_name": "MOTEGRITY",
        "forms": [
            {
                "orange_id": "210166-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3277,
        "type": "OTC",
        "ingredient": "PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "PSEUDOEPHEDRINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "209008-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3278,
        "type": "OTC",
        "ingredient": "PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "SUDAFED 12 HOUR",
        "forms": [
            {
                "orange_id": "73585-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3279,
        "type": "OTC",
        "ingredient": "PSEUDOEPHEDRINE HYDROCHLORIDE",
        "trade_name": "SUDAFED 24 HOUR",
        "forms": [
            {
                "orange_id": "20021-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3280,
        "type": "OTC",
        "ingredient": "PURIFIED WATER",
        "trade_name": "PUR-WASH",
        "forms": [
            {
                "orange_id": "22305-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "98.3%"
                ]
            }
        ]
    },
    {
        "id": 3281,
        "type": "RX",
        "ingredient": "PYRAZINAMIDE",
        "trade_name": "PYRAZINAMIDE",
        "forms": [
            {
                "orange_id": "81319-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3282,
        "type": "RX",
        "ingredient": "PYRIDOSTIGMINE BROMIDE",
        "trade_name": "MESTINON",
        "forms": [
            {
                "orange_id": "9830-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            },
            {
                "orange_id": "15193-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "60MG/5ML"
                ]
            },
            {
                "orange_id": "11665-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "180MG"
                ]
            },
            {
                "orange_id": "9829-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3283,
        "type": "RX",
        "ingredient": "PYRIDOSTIGMINE BROMIDE",
        "trade_name": "PYRIDOSTIGMINE BROMIDE",
        "forms": [
            {
                "orange_id": "212702-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "60MG/5ML"
                ]
            },
            {
                "orange_id": "204737-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "180MG"
                ]
            },
            {
                "orange_id": "211181-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3284,
        "type": "RX",
        "ingredient": "PYRIDOSTIGMINE BROMIDE",
        "trade_name": "REGONOL",
        "forms": [
            {
                "orange_id": "17398-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3285,
        "type": "RX",
        "ingredient": "PYRIDOXINE HYDROCHLORIDE",
        "trade_name": "PYRIDOXINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "80618-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3286,
        "type": "RX",
        "ingredient": "PYRIMETHAMINE",
        "trade_name": "DARAPRIM",
        "forms": [
            {
                "orange_id": "8578-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 3287,
        "type": "RX",
        "ingredient": "PYRIMETHAMINE",
        "trade_name": "PYRIMETHAMINE",
        "forms": [
            {
                "orange_id": "211271-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 3288,
        "type": "RX",
        "ingredient": "QUAZEPAM",
        "trade_name": "DORAL",
        "forms": [
            {
                "orange_id": "18708-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG"
                ]
            }
        ]
    },
    {
        "id": 3289,
        "type": "RX",
        "ingredient": "QUETIAPINE FUMARATE",
        "trade_name": "QUETIAPINE FUMARATE",
        "forms": [
            {
                "orange_id": "206252-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE",
                    "EQ 400MG BASE"
                ]
            },
            {
                "orange_id": "202152-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE",
                    "EQ 400MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3290,
        "type": "RX",
        "ingredient": "QUETIAPINE FUMARATE",
        "trade_name": "SEROQUEL",
        "forms": [
            {
                "orange_id": "20639-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3291,
        "type": "RX",
        "ingredient": "QUETIAPINE FUMARATE",
        "trade_name": "SEROQUEL XR",
        "forms": [
            {
                "orange_id": "22047-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE",
                    "EQ 300MG BASE",
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3292,
        "type": "RX",
        "ingredient": "QUINAPRIL HYDROCHLORIDE",
        "trade_name": "ACCUPRIL",
        "forms": [
            {
                "orange_id": "19885-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3293,
        "type": "RX",
        "ingredient": "QUINAPRIL HYDROCHLORIDE",
        "trade_name": "QUINAPRIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202725-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3294,
        "type": "RX",
        "ingredient": "QUINIDINE GLUCONATE",
        "trade_name": "QUINIDINE GLUCONATE",
        "forms": [
            {
                "orange_id": "212589-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "324MG"
                ]
            }
        ]
    },
    {
        "id": 3295,
        "type": "RX",
        "ingredient": "QUINIDINE SULFATE",
        "trade_name": "QUINIDINE SULFATE",
        "forms": [
            {
                "orange_id": "88072-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3296,
        "type": "RX",
        "ingredient": "QUININE SULFATE",
        "trade_name": "QUALAQUIN",
        "forms": [
            {
                "orange_id": "21799-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "324MG"
                ]
            }
        ]
    },
    {
        "id": 3297,
        "type": "RX",
        "ingredient": "QUININE SULFATE",
        "trade_name": "QUININE SULFATE",
        "forms": [
            {
                "orange_id": "203729-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "324MG"
                ]
            }
        ]
    },
    {
        "id": 3298,
        "type": "RX",
        "ingredient": "RABEPRAZOLE SODIUM",
        "trade_name": "ACIPHEX",
        "forms": [
            {
                "orange_id": "20973-2",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3299,
        "type": "RX",
        "ingredient": "RABEPRAZOLE SODIUM",
        "trade_name": "RABEPRAZOLE SODIUM",
        "forms": [
            {
                "orange_id": "208644-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3300,
        "type": "RX",
        "ingredient": "RADIUM RA-223 DICHLORIDE",
        "trade_name": "XOFIGO",
        "forms": [
            {
                "orange_id": "203971-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "162mCi/6ML (27mCi/ML)"
                ]
            }
        ]
    },
    {
        "id": 3301,
        "type": "RX",
        "ingredient": "RALOXIFENE HYDROCHLORIDE",
        "trade_name": "EVISTA",
        "forms": [
            {
                "orange_id": "20815-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3302,
        "type": "RX",
        "ingredient": "RALOXIFENE HYDROCHLORIDE",
        "trade_name": "RALOXIFENE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208206-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3303,
        "type": "RX",
        "ingredient": "RALTEGRAVIR POTASSIUM",
        "trade_name": "ISENTRESS",
        "forms": [
            {
                "orange_id": "205786-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE/PACKET"
                ]
            },
            {
                "orange_id": "203045-1",
                "form": "TABLET, CHEWABLE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 100MG BASE"
                ]
            },
            {
                "orange_id": "22145-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 400MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3304,
        "type": "RX",
        "ingredient": "RALTEGRAVIR POTASSIUM",
        "trade_name": "ISENTRESS HD",
        "forms": [
            {
                "orange_id": "22145-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 600MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3305,
        "type": "RX",
        "ingredient": "RAMELTEON",
        "trade_name": "RAMELTEON",
        "forms": [
            {
                "orange_id": "91610-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3306,
        "type": "RX",
        "ingredient": "RAMELTEON",
        "trade_name": "ROZEREM",
        "forms": [
            {
                "orange_id": "21782-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3307,
        "type": "RX",
        "ingredient": "RAMIPRIL",
        "trade_name": "ALTACE",
        "forms": [
            {
                "orange_id": "19901-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1.25MG",
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3308,
        "type": "RX",
        "ingredient": "RAMIPRIL",
        "trade_name": "RAMIPRIL",
        "forms": [
            {
                "orange_id": "202392-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1.25MG",
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3309,
        "type": "RX",
        "ingredient": "RANITIDINE HYDROCHLORIDE",
        "trade_name": "RANITIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75742-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 300MG BASE"
                ]
            },
            {
                "orange_id": "74777-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 25MG BASE/ML"
                ]
            },
            {
                "orange_id": "78890-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "EQ 15MG BASE/ML"
                ]
            },
            {
                "orange_id": "74680-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 300MG BASE",
                    "EQ 75MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3310,
        "type": "RX",
        "ingredient": "RANITIDINE HYDROCHLORIDE",
        "trade_name": "ZANTAC",
        "forms": [
            {
                "orange_id": "19090-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 25MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3311,
        "type": "RX",
        "ingredient": "RANOLAZINE",
        "trade_name": "RANEXA",
        "forms": [
            {
                "orange_id": "21526-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3312,
        "type": "RX",
        "ingredient": "RANOLAZINE",
        "trade_name": "RANOLAZINE",
        "forms": [
            {
                "orange_id": "208862-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1GM",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3313,
        "type": "RX",
        "ingredient": "RASAGILINE MESYLATE",
        "trade_name": "AZILECT",
        "forms": [
            {
                "orange_id": "21641-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3314,
        "type": "RX",
        "ingredient": "RASAGILINE MESYLATE",
        "trade_name": "RASAGILINE MESYLATE",
        "forms": [
            {
                "orange_id": "201889-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3315,
        "type": "RX",
        "ingredient": "REGADENOSON",
        "trade_name": "LEXISCAN",
        "forms": [
            {
                "orange_id": "22161-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "0.4MG/5ML (0.08MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3316,
        "type": "RX",
        "ingredient": "REGORAFENIB",
        "trade_name": "STIVARGA",
        "forms": [
            {
                "orange_id": "203085-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 3317,
        "type": "RX",
        "ingredient": "RELUGOLIX",
        "trade_name": "ORGOVYX",
        "forms": [
            {
                "orange_id": "214621-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3318,
        "type": "RX",
        "ingredient": "REMDESIVIR",
        "trade_name": "VEKLURY",
        "forms": [
            {
                "orange_id": "214787-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            },
            {
                "orange_id": "214787-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/20ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3319,
        "type": "RX",
        "ingredient": "REMIFENTANIL HYDROCHLORIDE",
        "trade_name": "REMIFENTANIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206223-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/VIAL",
                    "EQ 2MG BASE/VIAL",
                    "EQ 5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3320,
        "type": "RX",
        "ingredient": "REMIFENTANIL HYDROCHLORIDE",
        "trade_name": "ULTIVA",
        "forms": [
            {
                "orange_id": "20630-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG BASE/VIAL",
                    "EQ 2MG BASE/VIAL",
                    "EQ 5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3321,
        "type": "RX",
        "ingredient": "REMIMAZOLAM BESYLATE",
        "trade_name": "BYFAVO",
        "forms": [
            {
                "orange_id": "212295-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 20MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3322,
        "type": "RX",
        "ingredient": "REPAGLINIDE",
        "trade_name": "REPAGLINIDE",
        "forms": [
            {
                "orange_id": "203820-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3323,
        "type": "RX",
        "ingredient": "RETAPAMULIN",
        "trade_name": "ALTABAX",
        "forms": [
            {
                "orange_id": "22055-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3324,
        "type": "RX",
        "ingredient": "REVEFENACIN",
        "trade_name": "YUPELRI",
        "forms": [
            {
                "orange_id": "210598-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "175MCG/3ML"
                ]
            }
        ]
    },
    {
        "id": 3325,
        "type": "RX",
        "ingredient": "RIBAVIRIN",
        "trade_name": "REBETOL",
        "forms": [
            {
                "orange_id": "20903-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3326,
        "type": "RX",
        "ingredient": "RIBAVIRIN",
        "trade_name": "RIBAVIRIN",
        "forms": [
            {
                "orange_id": "79117-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            },
            {
                "orange_id": "207366-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "6GM/VIAL"
                ]
            },
            {
                "orange_id": "79111-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3327,
        "type": "RX",
        "ingredient": "RIBAVIRIN",
        "trade_name": "VIRAZOLE",
        "forms": [
            {
                "orange_id": "18859-1",
                "form": "FOR SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "6GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3328,
        "type": "RX",
        "ingredient": "RIBOCICLIB SUCCINATE",
        "trade_name": "KISQALI",
        "forms": [
            {
                "orange_id": "209092-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3329,
        "type": "RX",
        "ingredient": "RIBOFLAVIN 5'-PHOSPHATE SODIUM",
        "trade_name": "PHOTREXA",
        "forms": [
            {
                "orange_id": "203324-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.146%"
                ]
            }
        ]
    },
    {
        "id": 3330,
        "type": "RX",
        "ingredient": "RIBOFLAVIN 5'-PHOSPHATE SODIUM",
        "trade_name": "PHOTREXA VISCOUS IN DEXTRAN 20%",
        "forms": [
            {
                "orange_id": "203324-2",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.146%"
                ]
            }
        ]
    },
    {
        "id": 3331,
        "type": "RX",
        "ingredient": "RIFABUTIN",
        "trade_name": "MYCOBUTIN",
        "forms": [
            {
                "orange_id": "50689-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3332,
        "type": "RX",
        "ingredient": "RIFABUTIN",
        "trade_name": "RIFABUTIN",
        "forms": [
            {
                "orange_id": "90033-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3333,
        "type": "RX",
        "ingredient": "RIFAMPIN",
        "trade_name": "RIFADIN",
        "forms": [
            {
                "orange_id": "50627-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "600MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3334,
        "type": "RX",
        "ingredient": "RIFAMPIN",
        "trade_name": "RIFAMPIN",
        "forms": [
            {
                "orange_id": "65028-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "65502-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "600MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3335,
        "type": "RX",
        "ingredient": "RIFAMPIN",
        "trade_name": "RIMACTANE",
        "forms": [
            {
                "orange_id": "50429-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3336,
        "type": "RX",
        "ingredient": "RIFAMYCIN SODIUM",
        "trade_name": "AEMCOLO",
        "forms": [
            {
                "orange_id": "210910-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 194MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3337,
        "type": "RX",
        "ingredient": "RIFAPENTINE",
        "trade_name": "PRIFTIN",
        "forms": [
            {
                "orange_id": "21024-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3338,
        "type": "RX",
        "ingredient": "RIFAXIMIN",
        "trade_name": "XIFAXAN",
        "forms": [
            {
                "orange_id": "21361-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "550MG"
                ]
            }
        ]
    },
    {
        "id": 3339,
        "type": "RX",
        "ingredient": "RILPIVIRINE HYDROCHLORIDE",
        "trade_name": "EDURANT",
        "forms": [
            {
                "orange_id": "202022-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3340,
        "type": "RX",
        "ingredient": "RILUZOLE",
        "trade_name": "EXSERVAN",
        "forms": [
            {
                "orange_id": "212640-1",
                "form": "FILM",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3341,
        "type": "RX",
        "ingredient": "RILUZOLE",
        "trade_name": "RILUTEK",
        "forms": [
            {
                "orange_id": "20599-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3342,
        "type": "RX",
        "ingredient": "RILUZOLE",
        "trade_name": "RILUZOLE",
        "forms": [
            {
                "orange_id": "204048-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3343,
        "type": "RX",
        "ingredient": "RILUZOLE",
        "trade_name": "TIGLUTIK KIT",
        "forms": [
            {
                "orange_id": "209080-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "50MG/10ML"
                ]
            }
        ]
    },
    {
        "id": 3344,
        "type": "RX",
        "ingredient": "RIMANTADINE HYDROCHLORIDE",
        "trade_name": "FLUMADINE",
        "forms": [
            {
                "orange_id": "19649-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3345,
        "type": "RX",
        "ingredient": "RIMANTADINE HYDROCHLORIDE",
        "trade_name": "RIMANTADINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76132-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3346,
        "type": "RX",
        "ingredient": "RIMEGEPANT SULFATE",
        "trade_name": "NURTEC ODT",
        "forms": [
            {
                "orange_id": "212728-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3347,
        "type": "RX",
        "ingredient": "RIOCIGUAT",
        "trade_name": "ADEMPAS",
        "forms": [
            {
                "orange_id": "204819-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "1.5MG",
                    "2MG",
                    "2.5MG"
                ]
            }
        ]
    },
    {
        "id": 3348,
        "type": "RX",
        "ingredient": "RIPRETINIB",
        "trade_name": "QINLOCK",
        "forms": [
            {
                "orange_id": "213973-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3349,
        "type": "RX",
        "ingredient": "RISDIPLAM",
        "trade_name": "EVRYSDI",
        "forms": [
            {
                "orange_id": "213535-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.75MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3350,
        "type": "RX",
        "ingredient": "RISEDRONATE SODIUM",
        "trade_name": "ACTONEL",
        "forms": [
            {
                "orange_id": "20835-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "30MG",
                    "35MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3351,
        "type": "RX",
        "ingredient": "RISEDRONATE SODIUM",
        "trade_name": "ATELVIA",
        "forms": [
            {
                "orange_id": "22560-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "35MG"
                ]
            }
        ]
    },
    {
        "id": 3352,
        "type": "RX",
        "ingredient": "RISEDRONATE SODIUM",
        "trade_name": "RISEDRONATE SODIUM",
        "forms": [
            {
                "orange_id": "203925-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "35MG"
                ]
            },
            {
                "orange_id": "90877-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "35MG",
                    "75MG",
                    "150MG",
                    "5MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3353,
        "type": "RX",
        "ingredient": "RISPERIDONE",
        "trade_name": "PERSERIS KIT",
        "forms": [
            {
                "orange_id": "210655-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "90MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3354,
        "type": "RX",
        "ingredient": "RISPERIDONE",
        "trade_name": "RISPERDAL",
        "forms": [
            {
                "orange_id": "20588-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "20272-8",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3355,
        "type": "RX",
        "ingredient": "RISPERIDONE",
        "trade_name": "RISPERDAL CONSTA",
        "forms": [
            {
                "orange_id": "21346-4",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "12.5MG/VIAL",
                    "25MG/VIAL",
                    "37.5MG/VIAL",
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3356,
        "type": "RX",
        "ingredient": "RISPERIDONE",
        "trade_name": "RISPERIDONE",
        "forms": [
            {
                "orange_id": "91384-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "77328-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG",
                    "0.25MG"
                ]
            },
            {
                "orange_id": "201003-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.25MG",
                    "0.5MG",
                    "1MG",
                    "2MG",
                    "3MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3357,
        "type": "RX",
        "ingredient": "RITONAVIR",
        "trade_name": "NORVIR",
        "forms": [
            {
                "orange_id": "209512-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "100MG/PACKET"
                ]
            },
            {
                "orange_id": "20659-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "80MG/ML"
                ]
            },
            {
                "orange_id": "22417-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3358,
        "type": "RX",
        "ingredient": "RITONAVIR",
        "trade_name": "RITONAVIR",
        "forms": [
            {
                "orange_id": "208890-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3359,
        "type": "RX",
        "ingredient": "RIVAROXABAN",
        "trade_name": "XARELTO",
        "forms": [
            {
                "orange_id": "215859-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "22406-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3360,
        "type": "RX",
        "ingredient": "RIVASTIGMINE",
        "trade_name": "EXELON",
        "forms": [
            {
                "orange_id": "22083-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "4.6MG/24HR",
                    "9.5MG/24HR",
                    "13.3MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3361,
        "type": "RX",
        "ingredient": "RIVASTIGMINE",
        "trade_name": "RIVASTIGMINE",
        "forms": [
            {
                "orange_id": "204403-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "4.6MG/24HR",
                    "9.5MG/24HR",
                    "13.3MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3362,
        "type": "RX",
        "ingredient": "RIVASTIGMINE TARTRATE",
        "trade_name": "RIVASTIGMINE TARTRATE",
        "forms": [
            {
                "orange_id": "91689-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1.5MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4.5MG BASE",
                    "EQ 6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3363,
        "type": "RX",
        "ingredient": "RIZATRIPTAN BENZOATE",
        "trade_name": "MAXALT",
        "forms": [
            {
                "orange_id": "20864-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3364,
        "type": "RX",
        "ingredient": "RIZATRIPTAN BENZOATE",
        "trade_name": "MAXALT-MLT",
        "forms": [
            {
                "orange_id": "20865-2",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3365,
        "type": "RX",
        "ingredient": "RIZATRIPTAN BENZOATE",
        "trade_name": "RIZATRIPTAN BENZOATE",
        "forms": [
            {
                "orange_id": "203062-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            },
            {
                "orange_id": "203269-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3366,
        "type": "RX",
        "ingredient": "ROCURONIUM BROMIDE",
        "trade_name": "ROCURONIUM BROMIDE",
        "forms": [
            {
                "orange_id": "206206-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "50MG/5ML (10MG/ML)",
                    "100MG/10ML (10MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3367,
        "type": "RX",
        "ingredient": "ROFLUMILAST",
        "trade_name": "DALIRESP",
        "forms": [
            {
                "orange_id": "22522-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MCG",
                    "500MCG"
                ]
            }
        ]
    },
    {
        "id": 3368,
        "type": "RX",
        "ingredient": "ROFLUMILAST",
        "trade_name": "ROFLUMILAST",
        "forms": [
            {
                "orange_id": "208213-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MCG"
                ]
            }
        ]
    },
    {
        "id": 3369,
        "type": "RX",
        "ingredient": "ROLAPITANT HYDROCHLORIDE",
        "trade_name": "VARUBI",
        "forms": [
            {
                "orange_id": "206500-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 90MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3370,
        "type": "RX",
        "ingredient": "ROMIDEPSIN",
        "trade_name": "ISTODAX",
        "forms": [
            {
                "orange_id": "22393-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3371,
        "type": "RX",
        "ingredient": "ROMIDEPSIN",
        "trade_name": "ROMIDEPSIN",
        "forms": [
            {
                "orange_id": "206254-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10MG/VIAL"
                ]
            },
            {
                "orange_id": "208574-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "27.5MG/5.5ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3372,
        "type": "RX",
        "ingredient": "ROPINIROLE HYDROCHLORIDE",
        "trade_name": "ROPINIROLE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90869-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE",
                    "EQ 6MG BASE",
                    "EQ 8MG BASE",
                    "EQ 12MG BASE"
                ]
            },
            {
                "orange_id": "204022-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE",
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 3MG BASE",
                    "EQ 4MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3373,
        "type": "RX",
        "ingredient": "ROPIVACAINE HYDROCHLORIDE",
        "trade_name": "NAROPIN",
        "forms": [
            {
                "orange_id": "20533-10",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "1GM/200ML (5MG/ML)",
                    "20MG/10ML (2MG/ML)",
                    "40MG/20ML (2MG/ML)",
                    "100MG/20ML (5MG/ML)",
                    "100MG/10ML (10MG/ML)",
                    "150MG/20ML (7.5MG/ML)",
                    "150MG/30ML (5MG/ML)",
                    "200MG/100ML (2MG/ML)",
                    "200MG/20ML (10MG/ML)",
                    "400MG/200ML (2MG/ML)",
                    "500MG/100ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3374,
        "type": "RX",
        "ingredient": "ROPIVACAINE HYDROCHLORIDE",
        "trade_name": "ROPIVACAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204636-1",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "200MG/100ML (2MG/ML)",
                    "400MG/200ML (2MG/ML)",
                    "150MG/30ML (5MG/ML)",
                    "40MG/20ML (2MG/ML)",
                    "100MG/20ML (5MG/ML)",
                    "200MG/20ML (10MG/ML)",
                    "100MG/10ML (10MG/ML)",
                    "150MG/20ML (7.5MG/ML)",
                    "20MG/10ML (2MG/ML)",
                    "1GM/200ML (5MG/ML)",
                    "500MG/100ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3375,
        "type": "RX",
        "ingredient": "ROSIGLITAZONE MALEATE",
        "trade_name": "AVANDIA",
        "forms": [
            {
                "orange_id": "21071-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3376,
        "type": "RX",
        "ingredient": "ROSUVASTATIN CALCIUM",
        "trade_name": "CRESTOR",
        "forms": [
            {
                "orange_id": "21366-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3377,
        "type": "RX",
        "ingredient": "ROSUVASTATIN CALCIUM",
        "trade_name": "EZALLOR SPRINKLE",
        "forms": [
            {
                "orange_id": "208647-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3378,
        "type": "RX",
        "ingredient": "ROSUVASTATIN CALCIUM",
        "trade_name": "ROSUVASTATIN CALCIUM",
        "forms": [
            {
                "orange_id": "206434-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE",
                    "EQ 40MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3379,
        "type": "RX",
        "ingredient": "ROTIGOTINE",
        "trade_name": "NEUPRO",
        "forms": [
            {
                "orange_id": "21829-4",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1MG/24HR",
                    "2MG/24HR",
                    "3MG/24HR",
                    "4MG/24HR",
                    "6MG/24HR",
                    "8MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3380,
        "type": "RX",
        "ingredient": "RUBIDIUM CHLORIDE RB-82",
        "trade_name": "CARDIOGEN-82",
        "forms": [
            {
                "orange_id": "19414-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3381,
        "type": "RX",
        "ingredient": "RUBIDIUM CHLORIDE RB-82",
        "trade_name": "RUBY-FILL",
        "forms": [
            {
                "orange_id": "202153-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3382,
        "type": "RX",
        "ingredient": "RUCAPARIB CAMSYLATE",
        "trade_name": "RUBRACA",
        "forms": [
            {
                "orange_id": "209115-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE",
                    "EQ 250MG BASE",
                    "EQ 300MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3383,
        "type": "RX",
        "ingredient": "RUFINAMIDE",
        "trade_name": "BANZEL",
        "forms": [
            {
                "orange_id": "201367-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "21911-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 3384,
        "type": "RX",
        "ingredient": "RUFINAMIDE",
        "trade_name": "RUFINAMIDE",
        "forms": [
            {
                "orange_id": "213410-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "205075-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 3385,
        "type": "RX",
        "ingredient": "RUXOLITINIB PHOSPHATE",
        "trade_name": "JAKAFI",
        "forms": [
            {
                "orange_id": "202192-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 15MG BASE",
                    "EQ 20MG BASE",
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3386,
        "type": "RX",
        "ingredient": "RUXOLITINIB PHOSPHATE",
        "trade_name": "OPZELURA",
        "forms": [
            {
                "orange_id": "215309-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "EQ 1.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3387,
        "type": "RX",
        "ingredient": "SACUBITRIL AND VALSARTAN",
        "trade_name": "ENTRESTO",
        "forms": [
            {
                "orange_id": "207620-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "24MG-26MG",
                    "49MG-51MG",
                    "97MG-103MG"
                ]
            }
        ]
    },
    {
        "id": 3388,
        "type": "RX",
        "ingredient": "SAFINAMIDE MESYLATE",
        "trade_name": "XADAGO",
        "forms": [
            {
                "orange_id": "207145-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3389,
        "type": "RX",
        "ingredient": "SALMETEROL XINAFOATE",
        "trade_name": "SEREVENT",
        "forms": [
            {
                "orange_id": "20692-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.05MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 3390,
        "type": "RX",
        "ingredient": "SAPROPTERIN DIHYDROCHLORIDE",
        "trade_name": "KUVAN",
        "forms": [
            {
                "orange_id": "205065-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "100MG/PACKET",
                    "500MG/PACKET"
                ]
            },
            {
                "orange_id": "22181-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3391,
        "type": "RX",
        "ingredient": "SAPROPTERIN DIHYDROCHLORIDE",
        "trade_name": "SAPROPTERIN DIHYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "209452-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "100MG/PACKET",
                    "500MG/PACKET"
                ]
            },
            {
                "orange_id": "207685-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3392,
        "type": "RX",
        "ingredient": "SARECYCLINE HYDROCHLORIDE",
        "trade_name": "SEYSARA",
        "forms": [
            {
                "orange_id": "209521-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 60MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3393,
        "type": "RX",
        "ingredient": "SAXAGLIPTIN HYDROCHLORIDE",
        "trade_name": "ONGLYZA",
        "forms": [
            {
                "orange_id": "22350-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3394,
        "type": "RX",
        "ingredient": "SCOPOLAMINE",
        "trade_name": "SCOPOLAMINE",
        "forms": [
            {
                "orange_id": "208769-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1MG/72HR"
                ]
            }
        ]
    },
    {
        "id": 3395,
        "type": "RX",
        "ingredient": "SCOPOLAMINE",
        "trade_name": "TRANSDERM SCOP",
        "forms": [
            {
                "orange_id": "17874-1",
                "form": "SYSTEM",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1MG/72HR"
                ]
            }
        ]
    },
    {
        "id": 3396,
        "type": "RX",
        "ingredient": "SECNIDAZOLE",
        "trade_name": "SOLOSEC",
        "forms": [
            {
                "orange_id": "209363-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "2GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3397,
        "type": "RX",
        "ingredient": "SECRETIN SYNTHETIC HUMAN",
        "trade_name": "CHIRHOSTIM",
        "forms": [
            {
                "orange_id": "21256-1",
                "form": "FOR SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "16MCG/VIAL",
                    "40MCG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3398,
        "type": "RX",
        "ingredient": "SELEGILINE",
        "trade_name": "EMSAM",
        "forms": [
            {
                "orange_id": "21336-1",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "6MG/24HR",
                    "9MG/24HR",
                    "12MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3399,
        "type": "RX",
        "ingredient": "SELEGILINE HYDROCHLORIDE",
        "trade_name": "SELEGILINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75321-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            },
            {
                "orange_id": "74871-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3400,
        "type": "RX",
        "ingredient": "SELEGILINE HYDROCHLORIDE",
        "trade_name": "ZELAPAR",
        "forms": [
            {
                "orange_id": "21479-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "1.25MG"
                ]
            }
        ]
    },
    {
        "id": 3401,
        "type": "RX",
        "ingredient": "SELENIOUS ACID",
        "trade_name": "SELENIOUS ACID",
        "forms": [
            {
                "orange_id": "209379-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 12MCG SELENIUM/2ML (EQ 6MCG SELENIUM/ML)",
                    "EQ 60MCG SELENIUM/ML (EQ 60MCG SELENIUM/ML)",
                    "EQ 600MCG SELENIUM/10ML (EQ 60MCG SELENIUM/ML)"
                ]
            }
        ]
    },
    {
        "id": 3402,
        "type": "RX",
        "ingredient": "SELENIUM SULFIDE",
        "trade_name": "SELENIUM SULFIDE",
        "forms": [
            {
                "orange_id": "89996-1",
                "form": "LOTION/SHAMPOO",
                "route": "TOPICAL",
                "dosage": [
                    "2.5%"
                ]
            }
        ]
    },
    {
        "id": 3403,
        "type": "RX",
        "ingredient": "SELEXIPAG",
        "trade_name": "UPTRAVI",
        "forms": [
            {
                "orange_id": "214275-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1.8MG/VIAL"
                ]
            },
            {
                "orange_id": "207947-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.2MG",
                    "0.4MG",
                    "0.6MG",
                    "0.8MG",
                    "1MG",
                    "1.2MG",
                    "1.4MG",
                    "1.6MG"
                ]
            }
        ]
    },
    {
        "id": 3404,
        "type": "RX",
        "ingredient": "SELINEXOR",
        "trade_name": "XPOVIO",
        "forms": [
            {
                "orange_id": "212306-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "50MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3405,
        "type": "RX",
        "ingredient": "SELPERCATINIB",
        "trade_name": "RETEVMO",
        "forms": [
            {
                "orange_id": "213246-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3406,
        "type": "RX",
        "ingredient": "SELUMETINIB SULFATE",
        "trade_name": "KOSELUGO",
        "forms": [
            {
                "orange_id": "213756-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3407,
        "type": "RX",
        "ingredient": "SEMAGLUTIDE",
        "trade_name": "OZEMPIC",
        "forms": [
            {
                "orange_id": "209637-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "2MG/1.5ML (1.34MG/ML)",
                    "4MG/3ML (1.34MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3408,
        "type": "RX",
        "ingredient": "SEMAGLUTIDE",
        "trade_name": "RYBELSUS",
        "forms": [
            {
                "orange_id": "213051-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "3MG",
                    "7MG",
                    "14MG"
                ]
            }
        ]
    },
    {
        "id": 3409,
        "type": "RX",
        "ingredient": "SEMAGLUTIDE",
        "trade_name": "WEGOVY",
        "forms": [
            {
                "orange_id": "215256-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.25MG/0.5ML (0.25MG/0.5ML)",
                    "0.5MG/0.5ML (0.5MG/0.5ML)",
                    "1MG/0.5ML (1MG/0.5ML)",
                    "1.7MG/0.75ML (1.7MG/0.75ML)",
                    "2.4MG/0.75ML (2.4MG/0.75ML)"
                ]
            }
        ]
    },
    {
        "id": 3410,
        "type": "RX",
        "ingredient": "SERTACONAZOLE NITRATE",
        "trade_name": "ERTACZO",
        "forms": [
            {
                "orange_id": "21385-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "2%"
                ]
            }
        ]
    },
    {
        "id": 3411,
        "type": "RX",
        "ingredient": "SERTRALINE HYDROCHLORIDE",
        "trade_name": "SERTRALINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "215133-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            },
            {
                "orange_id": "76934-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            },
            {
                "orange_id": "202825-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3412,
        "type": "RX",
        "ingredient": "SERTRALINE HYDROCHLORIDE",
        "trade_name": "ZOLOFT",
        "forms": [
            {
                "orange_id": "20990-1",
                "form": "CONCENTRATE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            },
            {
                "orange_id": "19839-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3413,
        "type": "RX",
        "ingredient": "SETMELANOTIDE ACETATE",
        "trade_name": "IMCIVREE",
        "forms": [
            {
                "orange_id": "213793-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 10MG/ML BASE (EQ 10MG/ML BASE)"
                ]
            }
        ]
    },
    {
        "id": 3414,
        "type": "RX",
        "ingredient": "SEVELAMER CARBONATE",
        "trade_name": "RENVELA",
        "forms": [
            {
                "orange_id": "22318-2",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "2.4GM/PACKET",
                    "800MG/PACKET"
                ]
            },
            {
                "orange_id": "22127-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 3415,
        "type": "RX",
        "ingredient": "SEVELAMER CARBONATE",
        "trade_name": "SEVELAMER CARBONATE",
        "forms": [
            {
                "orange_id": "207624-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "800MG/PACKET",
                    "2.4GM/PACKET"
                ]
            },
            {
                "orange_id": "207288-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 3416,
        "type": "RX",
        "ingredient": "SEVELAMER HYDROCHLORIDE",
        "trade_name": "RENAGEL",
        "forms": [
            {
                "orange_id": "21179-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 3417,
        "type": "RX",
        "ingredient": "SEVELAMER HYDROCHLORIDE",
        "trade_name": "SEVELAMER HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "204724-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG",
                    "800MG"
                ]
            }
        ]
    },
    {
        "id": 3418,
        "type": "RX",
        "ingredient": "SEVOFLURANE",
        "trade_name": "SEVOFLURANE",
        "forms": [
            {
                "orange_id": "75895-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3419,
        "type": "RX",
        "ingredient": "SEVOFLURANE",
        "trade_name": "SOJOURN",
        "forms": [
            {
                "orange_id": "77867-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3420,
        "type": "RX",
        "ingredient": "SEVOFLURANE",
        "trade_name": "ULTANE",
        "forms": [
            {
                "orange_id": "20478-1",
                "form": "LIQUID",
                "route": "INHALATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3421,
        "type": "RX",
        "ingredient": "SILDENAFIL CITRATE",
        "trade_name": "REVATIO",
        "forms": [
            {
                "orange_id": "203109-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            },
            {
                "orange_id": "22473-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 10MG BASE/12.5ML (EQ 0.8MG BASE/ML)"
                ]
            },
            {
                "orange_id": "21845-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3422,
        "type": "RX",
        "ingredient": "SILDENAFIL CITRATE",
        "trade_name": "SILDENAFIL CITRATE",
        "forms": [
            {
                "orange_id": "212883-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            },
            {
                "orange_id": "203988-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 10MG BASE/12.5ML (EQ 0.8MG BASE/ML)"
                ]
            },
            {
                "orange_id": "210394-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3423,
        "type": "RX",
        "ingredient": "SILDENAFIL CITRATE",
        "trade_name": "VIAGRA",
        "forms": [
            {
                "orange_id": "20895-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3424,
        "type": "RX",
        "ingredient": "SILODOSIN",
        "trade_name": "RAPAFLO",
        "forms": [
            {
                "orange_id": "22206-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3425,
        "type": "RX",
        "ingredient": "SILODOSIN",
        "trade_name": "SILODOSIN",
        "forms": [
            {
                "orange_id": "211060-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "4MG",
                    "8MG"
                ]
            }
        ]
    },
    {
        "id": 3426,
        "type": "RX",
        "ingredient": "SILVER SULFADIAZINE",
        "trade_name": "SILVADENE",
        "forms": [
            {
                "orange_id": "17381-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3427,
        "type": "RX",
        "ingredient": "SILVER SULFADIAZINE",
        "trade_name": "SSD",
        "forms": [
            {
                "orange_id": "18578-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3428,
        "type": "RX",
        "ingredient": "SILVER SULFADIAZINE",
        "trade_name": "THERMAZENE",
        "forms": [
            {
                "orange_id": "18810-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3429,
        "type": "RX",
        "ingredient": "SIMVASTATIN",
        "trade_name": "FLOLIPID",
        "forms": [
            {
                "orange_id": "206679-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "20MG/5ML",
                    "40MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3430,
        "type": "RX",
        "ingredient": "SIMVASTATIN",
        "trade_name": "SIMVASTATIN",
        "forms": [
            {
                "orange_id": "78155-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3431,
        "type": "RX",
        "ingredient": "SIMVASTATIN",
        "trade_name": "ZOCOR",
        "forms": [
            {
                "orange_id": "19766-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 3432,
        "type": "RX",
        "ingredient": "SINCALIDE",
        "trade_name": "KINEVAC",
        "forms": [
            {
                "orange_id": "17697-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.005MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3433,
        "type": "RX",
        "ingredient": "SINECATECHINS",
        "trade_name": "VEREGEN",
        "forms": [
            {
                "orange_id": "21902-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "15%"
                ]
            }
        ]
    },
    {
        "id": 3434,
        "type": "RX",
        "ingredient": "SIPONIMOD FUMARIC ACID",
        "trade_name": "MAYZENT",
        "forms": [
            {
                "orange_id": "209884-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE",
                    "EQ 1MG BASE",
                    "EQ 2MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3435,
        "type": "RX",
        "ingredient": "SIROLIMUS",
        "trade_name": "FYARRO",
        "forms": [
            {
                "orange_id": "213312-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3436,
        "type": "RX",
        "ingredient": "SIROLIMUS",
        "trade_name": "RAPAMUNE",
        "forms": [
            {
                "orange_id": "21083-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "21110-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3437,
        "type": "RX",
        "ingredient": "SIROLIMUS",
        "trade_name": "SIROLIMUS",
        "forms": [
            {
                "orange_id": "211212-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "214753-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.5MG",
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3438,
        "type": "RX",
        "ingredient": "SITAGLIPTIN PHOSPHATE",
        "trade_name": "JANUVIA",
        "forms": [
            {
                "orange_id": "21995-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3439,
        "type": "RX",
        "ingredient": "SODIUM ACETATE",
        "trade_name": "SODIUM ACETATE",
        "forms": [
            {
                "orange_id": "206687-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "4MEQ/ML",
                    "2MEQ/ML"
                ]
            }
        ]
    },
    {
        "id": 3440,
        "type": "RX",
        "ingredient": "SODIUM BENZOATE AND SODIUM PHENYLACETATE",
        "trade_name": "AMMONUL",
        "forms": [
            {
                "orange_id": "20645-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10%-10% (5GM/50ML-5GM/50ML)"
                ]
            }
        ]
    },
    {
        "id": 3441,
        "type": "RX",
        "ingredient": "SODIUM BENZOATE AND SODIUM PHENYLACETATE",
        "trade_name": "SODIUM PHENYLACETATE AND SODIUM BENZOATE",
        "forms": [
            {
                "orange_id": "207096-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10%-10% (5GM/50ML-5GM/50ML)",
                    "10%-10% (2GM/20ML-2GM/20ML)"
                ]
            }
        ]
    },
    {
        "id": 3442,
        "type": "RX",
        "ingredient": "SODIUM BICARBONATE",
        "trade_name": "SODIUM BICARBONATE",
        "forms": [
            {
                "orange_id": "211091-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "0.5MEQ/ML",
                    "0.9MEQ/ML",
                    "1MEQ/ML"
                ]
            }
        ]
    },
    {
        "id": 3443,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "BACTERIOSTATIC SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "88911-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "9MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3444,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 0. 45% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19635-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "450MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3445,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "19635-5",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "9MG/10ML",
                    "9MG/ML",
                    "90MG/10ML (9MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3446,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17464-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "900MG/100ML",
                    "9MG/ML",
                    "1012.5MG/125ML (9MG/ML)"
                ]
            },
            {
                "orange_id": "16733-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3447,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 0. 9% IN STERILE PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19319-2",
                "form": "SOLUTION FOR SLUSH",
                "route": "IRRIGATION",
                "dosage": [
                    "900MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3448,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 14. 6%",
        "forms": [
            {
                "orange_id": "212070-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MEQ/20ML (2.5MEQ/ML)",
                    "100MEQ/40ML (2.5MEQ/ML)"
                ]
            }
        ]
    },
    {
        "id": 3449,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 23. 4%",
        "forms": [
            {
                "orange_id": "212248-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "234MG/ML"
                ]
            },
            {
                "orange_id": "18897-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "400MEQ/100ML (4MEQ/ML)"
                ]
            }
        ]
    },
    {
        "id": 3450,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19635-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "3GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3451,
        "type": "RX",
        "ingredient": "SODIUM CHLORIDE",
        "trade_name": "SODIUM CHLORIDE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19635-4",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3452,
        "type": "RX",
        "ingredient": "SODIUM FLUORIDE F-18",
        "trade_name": "SODIUM FLUORIDE F-18",
        "forms": [
            {
                "orange_id": "203777-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "10-200mCi/ML",
                    "10-91.5mCi/ML",
                    "20-600mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 3453,
        "type": "RX",
        "ingredient": "SODIUM IODIDE I-123",
        "trade_name": "SODIUM IODIDE I 123",
        "forms": [
            {
                "orange_id": "18671-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100uCi",
                    "200uCi"
                ]
            }
        ]
    },
    {
        "id": 3454,
        "type": "RX",
        "ingredient": "SODIUM IODIDE I-131",
        "trade_name": "HICON",
        "forms": [
            {
                "orange_id": "21305-7",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "250-1000mCi"
                ]
            }
        ]
    },
    {
        "id": 3455,
        "type": "RX",
        "ingredient": "SODIUM IODIDE I-131",
        "trade_name": "SODIUM IODIDE I 131",
        "forms": [
            {
                "orange_id": "21305-6",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.009-0.1mCi"
                ]
            },
            {
                "orange_id": "209166-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "250-1000mCi"
                ]
            }
        ]
    },
    {
        "id": 3456,
        "type": "RX",
        "ingredient": "SODIUM NITRITE",
        "trade_name": "SODIUM NITRITE",
        "forms": [
            {
                "orange_id": "203922-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "300MG/10ML (30MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3457,
        "type": "RX",
        "ingredient": "SODIUM NITRITE AND SODIUM THIOSULFATE",
        "trade_name": "NITHIODOTE",
        "forms": [
            {
                "orange_id": "201444-1",
                "form": "SOLUTION, SOLUTION",
                "route": "INTRAVENOUS, INTRAVENOUS",
                "dosage": [
                    "300MG/10ML(30MG/ML),N/A-N/A,12.5GM/50ML(250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3458,
        "type": "RX",
        "ingredient": "SODIUM NITROPRUSSIDE",
        "trade_name": "NIPRIDE RTU IN SODIUM CHLORIDE 0. 9%",
        "forms": [
            {
                "orange_id": "209387-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20MG/100ML (0.2MG/ML)",
                    "50MG/100ML (0.5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3459,
        "type": "RX",
        "ingredient": "SODIUM NITROPRUSSIDE",
        "trade_name": "NITROPRESS",
        "forms": [
            {
                "orange_id": "71961-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3460,
        "type": "RX",
        "ingredient": "SODIUM NITROPRUSSIDE",
        "trade_name": "SODIUM NITROPRUSSIDE",
        "forms": [
            {
                "orange_id": "208635-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3461,
        "type": "RX",
        "ingredient": "SODIUM OXYBATE",
        "trade_name": "XYREM",
        "forms": [
            {
                "orange_id": "21196-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "0.5GM/ML"
                ]
            }
        ]
    },
    {
        "id": 3462,
        "type": "RX",
        "ingredient": "SODIUM PHENYLBUTYRATE",
        "trade_name": "BUPHENYL",
        "forms": [
            {
                "orange_id": "20573-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "3GM/TEASPOONFUL"
                ]
            },
            {
                "orange_id": "20572-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3463,
        "type": "RX",
        "ingredient": "SODIUM PHENYLBUTYRATE",
        "trade_name": "SODIUM PHENYLBUTYRATE",
        "forms": [
            {
                "orange_id": "203918-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "3GM/TEASPOONFUL"
                ]
            },
            {
                "orange_id": "204395-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3464,
        "type": "RX",
        "ingredient": "SODIUM PHOSPHATE, DIBASIC, ANHYDROUS AND SODIUM PHOSPHATE, MONOBASIC, MONOHYDRATE",
        "trade_name": "MONOBASIC SODIUM PHOSPHATE AND DIBASIC SODIUM PHOSPHATE",
        "forms": [
            {
                "orange_id": "79247-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.398GM-1.102GM"
                ]
            }
        ]
    },
    {
        "id": 3465,
        "type": "RX",
        "ingredient": "SODIUM PHOSPHATE, DIBASIC, ANHYDROUS AND SODIUM PHOSPHATE, MONOBASIC, MONOHYDRATE",
        "trade_name": "OSMOPREP",
        "forms": [
            {
                "orange_id": "21892-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.398GM-1.102GM"
                ]
            }
        ]
    },
    {
        "id": 3466,
        "type": "RX",
        "ingredient": "SODIUM PHOSPHATE, DIBASIC, HEPTAHYDRATE AND SODIUM PHOSPHATE, MONOBASIC, ANHYDROUS",
        "trade_name": "SODIUM PHOSPHATES IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18892-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "142MG/ML-276MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3467,
        "type": "RX",
        "ingredient": "SODIUM POLYSTYRENE SULFONATE",
        "trade_name": "KALEXATE",
        "forms": [
            {
                "orange_id": "40905-2",
                "form": "POWDER",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "15GM/BOT",
                    "454GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3468,
        "type": "RX",
        "ingredient": "SODIUM POLYSTYRENE SULFONATE",
        "trade_name": "KIONEX",
        "forms": [
            {
                "orange_id": "40029-1",
                "form": "POWDER",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "454GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3469,
        "type": "RX",
        "ingredient": "SODIUM POLYSTYRENE SULFONATE",
        "trade_name": "SODIUM POLYSTYRENE SULFONATE",
        "forms": [
            {
                "orange_id": "205727-1",
                "form": "POWDER",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "454GM/BOT",
                    "453.6GM/BOT",
                    "15GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3470,
        "type": "RX",
        "ingredient": "SODIUM POLYSTYRENE SULFONATE",
        "trade_name": "SPS",
        "forms": [
            {
                "orange_id": "87859-1",
                "form": "SUSPENSION",
                "route": "ORAL, RECTAL",
                "dosage": [
                    "15GM/60ML"
                ]
            }
        ]
    },
    {
        "id": 3471,
        "type": "RX",
        "ingredient": "SODIUM TETRADECYL SULFATE",
        "trade_name": "SODIUM TETRADECYL SULFATE",
        "forms": [
            {
                "orange_id": "209937-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "60MG/2ML (30MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3472,
        "type": "RX",
        "ingredient": "SODIUM TETRADECYL SULFATE",
        "trade_name": "SOTRADECOL",
        "forms": [
            {
                "orange_id": "40541-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/2ML (10MG/ML)",
                    "60MG/2ML (30MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3473,
        "type": "RX",
        "ingredient": "SODIUM THIOSULFATE",
        "trade_name": "SODIUM THIOSULFATE",
        "forms": [
            {
                "orange_id": "203923-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "12.5GM/50ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3474,
        "type": "RX",
        "ingredient": "SODIUM ZIRCONIUM CYCLOSILICATE",
        "trade_name": "LOKELMA",
        "forms": [
            {
                "orange_id": "207078-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "5GM/PACKET",
                    "10GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3475,
        "type": "RX",
        "ingredient": "SOFOSBUVIR",
        "trade_name": "SOFOSBUVIR",
        "forms": [
            {
                "orange_id": "211353-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 3476,
        "type": "RX",
        "ingredient": "SOFOSBUVIR",
        "trade_name": "SOVALDI",
        "forms": [
            {
                "orange_id": "212480-1",
                "form": "PELLETS",
                "route": "ORAL",
                "dosage": [
                    "150MG/PACKET",
                    "200MG/PACKET"
                ]
            },
            {
                "orange_id": "204671-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG",
                    "400MG"
                ]
            }
        ]
    },
    {
        "id": 3477,
        "type": "RX",
        "ingredient": "SOFOSBUVIR AND VELPATASVIR",
        "trade_name": "EPCLUSA",
        "forms": [
            {
                "orange_id": "214187-1",
                "form": "PELLETS",
                "route": "ORAL",
                "dosage": [
                    "150MG-37.5MG/PACKET",
                    "200MG-50MG/PACKET"
                ]
            },
            {
                "orange_id": "208341-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG-50MG",
                    "400MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 3478,
        "type": "RX",
        "ingredient": "SOFOSBUVIR, VELPATASVIR AND VOXILAPREVIR",
        "trade_name": "VOSEVI",
        "forms": [
            {
                "orange_id": "209195-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-100MG-100MG"
                ]
            }
        ]
    },
    {
        "id": 3479,
        "type": "RX",
        "ingredient": "SOLIFENACIN SUCCINATE",
        "trade_name": "SOLIFENACIN SUCCINATE",
        "forms": [
            {
                "orange_id": "207477-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3480,
        "type": "RX",
        "ingredient": "SOLIFENACIN SUCCINATE",
        "trade_name": "VESICARE",
        "forms": [
            {
                "orange_id": "21518-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3481,
        "type": "RX",
        "ingredient": "SOLIFENACIN SUCCINATE",
        "trade_name": "VESICARE LS",
        "forms": [
            {
                "orange_id": "209529-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3482,
        "type": "RX",
        "ingredient": "SOLRIAMFETOL HYDROCHLORIDE",
        "trade_name": "SUNOSI",
        "forms": [
            {
                "orange_id": "211230-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 75MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3483,
        "type": "RX",
        "ingredient": "SONIDEGIB PHOSPHATE",
        "trade_name": "ODOMZO",
        "forms": [
            {
                "orange_id": "205266-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3484,
        "type": "RX",
        "ingredient": "SORAFENIB TOSYLATE",
        "trade_name": "NEXAVAR",
        "forms": [
            {
                "orange_id": "21923-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3485,
        "type": "RX",
        "ingredient": "SORBITOL",
        "trade_name": "SORBITOL 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "17863-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "3GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3486,
        "type": "RX",
        "ingredient": "SORBITOL",
        "trade_name": "SORBITOL 3. 3% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16741-1",
                "form": "SOLUTION",
                "route": "IRRIGATION",
                "dosage": [
                    "3.3GM/100ML"
                ]
            }
        ]
    },
    {
        "id": 3487,
        "type": "RX",
        "ingredient": "SOTALOL HYDROCHLORIDE",
        "trade_name": "BETAPACE",
        "forms": [
            {
                "orange_id": "19865-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "120MG",
                    "160MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3488,
        "type": "RX",
        "ingredient": "SOTALOL HYDROCHLORIDE",
        "trade_name": "BETAPACE AF",
        "forms": [
            {
                "orange_id": "21151-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "120MG",
                    "160MG"
                ]
            }
        ]
    },
    {
        "id": 3489,
        "type": "RX",
        "ingredient": "SOTALOL HYDROCHLORIDE",
        "trade_name": "SORINE",
        "forms": [
            {
                "orange_id": "75500-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "120MG",
                    "160MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3490,
        "type": "RX",
        "ingredient": "SOTALOL HYDROCHLORIDE",
        "trade_name": "SOTALOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "22306-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "150MG/10ML (15MG/ML)"
                ]
            },
            {
                "orange_id": "76140-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "80MG",
                    "120MG",
                    "160MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3491,
        "type": "RX",
        "ingredient": "SOTALOL HYDROCHLORIDE",
        "trade_name": "SOTYLIZE",
        "forms": [
            {
                "orange_id": "205108-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML (5MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3492,
        "type": "RX",
        "ingredient": "SOTORASIB",
        "trade_name": "LUMAKRAS",
        "forms": [
            {
                "orange_id": "214665-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3493,
        "type": "RX",
        "ingredient": "SOYBEAN OIL",
        "trade_name": "INTRALIPID 10%",
        "forms": [
            {
                "orange_id": "17643-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3494,
        "type": "RX",
        "ingredient": "SOYBEAN OIL",
        "trade_name": "INTRALIPID 20%",
        "forms": [
            {
                "orange_id": "18449-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 3495,
        "type": "RX",
        "ingredient": "SOYBEAN OIL",
        "trade_name": "INTRALIPID 30%",
        "forms": [
            {
                "orange_id": "19942-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "30%"
                ]
            }
        ]
    },
    {
        "id": 3496,
        "type": "RX",
        "ingredient": "SOYBEAN OIL",
        "trade_name": "NUTRILIPID 10%",
        "forms": [
            {
                "orange_id": "19531-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3497,
        "type": "RX",
        "ingredient": "SOYBEAN OIL",
        "trade_name": "NUTRILIPID 20%",
        "forms": [
            {
                "orange_id": "19531-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20%"
                ]
            }
        ]
    },
    {
        "id": 3498,
        "type": "RX",
        "ingredient": "SPINOSAD",
        "trade_name": "NATROBA",
        "forms": [
            {
                "orange_id": "22408-1",
                "form": "SUSPENSION",
                "route": "TOPICAL",
                "dosage": [
                    "0.9%"
                ]
            }
        ]
    },
    {
        "id": 3499,
        "type": "RX",
        "ingredient": "SPIRONOLACTONE",
        "trade_name": "ALDACTONE",
        "forms": [
            {
                "orange_id": "12151-9",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3500,
        "type": "RX",
        "ingredient": "SPIRONOLACTONE",
        "trade_name": "CAROSPIR",
        "forms": [
            {
                "orange_id": "209478-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "25MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3501,
        "type": "RX",
        "ingredient": "SPIRONOLACTONE",
        "trade_name": "SPIRONOLACTONE",
        "forms": [
            {
                "orange_id": "203512-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3502,
        "type": "RX",
        "ingredient": "STERILE WATER FOR INJECTION",
        "trade_name": "BACTERIOSTATIC WATER FOR INJECTION IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18802-1",
                "form": "LIQUID",
                "route": "N/A",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3503,
        "type": "RX",
        "ingredient": "STERILE WATER FOR INJECTION",
        "trade_name": "STERILE WATER FOR INJECTION",
        "forms": [
            {
                "orange_id": "209689-1",
                "form": "LIQUID",
                "route": "N/A",
                "dosage": [
                    "100%",
                    "100% (10ML)",
                    "100% (20ML)",
                    "100% (50ML)",
                    "100% (100ML)",
                    "100% (1ML)",
                    "100% (2.5ML)",
                    "100% (3ML)",
                    "100% (5ML)"
                ]
            }
        ]
    },
    {
        "id": 3504,
        "type": "RX",
        "ingredient": "STERILE WATER FOR INJECTION",
        "trade_name": "STERILE WATER FOR INJECTION IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19633-1",
                "form": "LIQUID",
                "route": "N/A",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3505,
        "type": "RX",
        "ingredient": "STERILE WATER FOR IRRIGATION",
        "trade_name": "STERILE WATER",
        "forms": [
            {
                "orange_id": "17428-1",
                "form": "LIQUID",
                "route": "IRRIGATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3506,
        "type": "RX",
        "ingredient": "STERILE WATER FOR IRRIGATION",
        "trade_name": "STERILE WATER IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "16734-1",
                "form": "LIQUID",
                "route": "IRRIGATION",
                "dosage": [
                    "100%"
                ]
            }
        ]
    },
    {
        "id": 3507,
        "type": "RX",
        "ingredient": "STIRIPENTOL",
        "trade_name": "DIACOMIT",
        "forms": [
            {
                "orange_id": "206709-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            },
            {
                "orange_id": "207223-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "250MG/PACKET",
                    "500MG/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3508,
        "type": "RX",
        "ingredient": "STREPTOMYCIN SULFATE",
        "trade_name": "STREPTOMYCIN SULFATE",
        "forms": [
            {
                "orange_id": "64210-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3509,
        "type": "RX",
        "ingredient": "STREPTOZOCIN",
        "trade_name": "ZANOSAR",
        "forms": [
            {
                "orange_id": "50577-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3510,
        "type": "RX",
        "ingredient": "STRONTIUM CHLORIDE SR-89",
        "trade_name": "METASTRON",
        "forms": [
            {
                "orange_id": "20134-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 3511,
        "type": "RX",
        "ingredient": "STRONTIUM CHLORIDE SR-89",
        "trade_name": "STRONTIUM CHLORIDE SR-89",
        "forms": [
            {
                "orange_id": "75941-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 3512,
        "type": "RX",
        "ingredient": "SUCCIMER",
        "trade_name": "CHEMET",
        "forms": [
            {
                "orange_id": "19998-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3513,
        "type": "RX",
        "ingredient": "SUCCINYLCHOLINE CHLORIDE",
        "trade_name": "ANECTINE",
        "forms": [
            {
                "orange_id": "8453-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3514,
        "type": "RX",
        "ingredient": "SUCCINYLCHOLINE CHLORIDE",
        "trade_name": "QUELICIN",
        "forms": [
            {
                "orange_id": "8845-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3515,
        "type": "RX",
        "ingredient": "SUCCINYLCHOLINE CHLORIDE",
        "trade_name": "SUCCINYLCHOLINE CHLORIDE",
        "forms": [
            {
                "orange_id": "213705-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "20MG/ML"
                ]
            },
            {
                "orange_id": "215143-1",
                "form": "SOLUTION",
                "route": "INTRAMUSCULAR, INTRAVENOUS",
                "dosage": [
                    "100MG/5ML (20MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3516,
        "type": "RX",
        "ingredient": "SUCRALFATE",
        "trade_name": "CARAFATE",
        "forms": [
            {
                "orange_id": "19183-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            },
            {
                "orange_id": "18333-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 3517,
        "type": "RX",
        "ingredient": "SUCRALFATE",
        "trade_name": "SUCRALFATE",
        "forms": [
            {
                "orange_id": "209356-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "1GM/10ML"
                ]
            },
            {
                "orange_id": "74415-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1GM"
                ]
            }
        ]
    },
    {
        "id": 3518,
        "type": "RX",
        "ingredient": "SUFENTANIL CITRATE",
        "trade_name": "DSUVIA",
        "forms": [
            {
                "orange_id": "209128-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "EQ 0.03MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3519,
        "type": "RX",
        "ingredient": "SUFENTANIL CITRATE",
        "trade_name": "SUFENTA PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "19050-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3520,
        "type": "RX",
        "ingredient": "SUFENTANIL CITRATE",
        "trade_name": "SUFENTANIL CITRATE",
        "forms": [
            {
                "orange_id": "74413-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 0.05MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3521,
        "type": "RX",
        "ingredient": "SUGAMMADEX SODIUM",
        "trade_name": "BRIDION",
        "forms": [
            {
                "orange_id": "22225-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 200MG BASE/2ML (EQ 100MG BASE/ML)",
                    "EQ 500MG BASE/5ML (EQ 100MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3522,
        "type": "RX",
        "ingredient": "SULCONAZOLE NITRATE",
        "trade_name": "EXELDERM",
        "forms": [
            {
                "orange_id": "18737-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "18738-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3523,
        "type": "RX",
        "ingredient": "SULFACETAMIDE SODIUM",
        "trade_name": "BLEPH-10",
        "forms": [
            {
                "orange_id": "80028-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3524,
        "type": "RX",
        "ingredient": "SULFACETAMIDE SODIUM",
        "trade_name": "KLARON",
        "forms": [
            {
                "orange_id": "19931-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3525,
        "type": "RX",
        "ingredient": "SULFACETAMIDE SODIUM",
        "trade_name": "SULFACETAMIDE SODIUM",
        "forms": [
            {
                "orange_id": "77015-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "10%"
                ]
            },
            {
                "orange_id": "80029-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10%"
                ]
            },
            {
                "orange_id": "40215-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "10%"
                ]
            }
        ]
    },
    {
        "id": 3526,
        "type": "RX",
        "ingredient": "SULFADIAZINE",
        "trade_name": "SULFADIAZINE",
        "forms": [
            {
                "orange_id": "40091-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3527,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "BACTRIM",
        "forms": [
            {
                "orange_id": "17377-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 3528,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "BACTRIM DS",
        "forms": [
            {
                "orange_id": "17377-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG-160MG"
                ]
            }
        ]
    },
    {
        "id": 3529,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "SEPTRA",
        "forms": [
            {
                "orange_id": "17376-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-80MG"
                ]
            }
        ]
    },
    {
        "id": 3530,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "SEPTRA DS",
        "forms": [
            {
                "orange_id": "17376-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "800MG-160MG"
                ]
            }
        ]
    },
    {
        "id": 3531,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "forms": [
            {
                "orange_id": "206607-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80MG/ML-16MG/ML"
                ]
            },
            {
                "orange_id": "74650-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML-40MG/5ML"
                ]
            },
            {
                "orange_id": "76899-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "400MG-80MG",
                    "800MG-160MG"
                ]
            }
        ]
    },
    {
        "id": 3532,
        "type": "RX",
        "ingredient": "SULFAMETHOXAZOLE AND TRIMETHOPRIM",
        "trade_name": "SULFATRIM PEDIATRIC",
        "forms": [
            {
                "orange_id": "18615-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML-40MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3533,
        "type": "RX",
        "ingredient": "SULFASALAZINE",
        "trade_name": "AZULFIDINE",
        "forms": [
            {
                "orange_id": "7073-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3534,
        "type": "RX",
        "ingredient": "SULFASALAZINE",
        "trade_name": "AZULFIDINE EN-TABS",
        "forms": [
            {
                "orange_id": "7073-2",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3535,
        "type": "RX",
        "ingredient": "SULFASALAZINE",
        "trade_name": "SULFASALAZINE",
        "forms": [
            {
                "orange_id": "75339-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            },
            {
                "orange_id": "80197-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3536,
        "type": "RX",
        "ingredient": "SULFUR HEXAFLUORIDE LIPID-TYPE A MICROSPHERES",
        "trade_name": "LUMASON",
        "forms": [
            {
                "orange_id": "203684-1",
                "form": "FOR SUSPENSION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "60.7MG/25MG"
                ]
            }
        ]
    },
    {
        "id": 3537,
        "type": "RX",
        "ingredient": "SULINDAC",
        "trade_name": "SULINDAC",
        "forms": [
            {
                "orange_id": "72710-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3538,
        "type": "RX",
        "ingredient": "SUMATRIPTAN",
        "trade_name": "IMITREX",
        "forms": [
            {
                "orange_id": "20626-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "5MG/SPRAY",
                    "20MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3539,
        "type": "RX",
        "ingredient": "SUMATRIPTAN",
        "trade_name": "SUMATRIPTAN",
        "forms": [
            {
                "orange_id": "214209-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "20MG/SPRAY ",
                    "20MG/SPRAY",
                    "5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3540,
        "type": "RX",
        "ingredient": "SUMATRIPTAN",
        "trade_name": "TOSYMRA",
        "forms": [
            {
                "orange_id": "210884-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "10MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3541,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "IMITREX",
        "forms": [
            {
                "orange_id": "20080-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 6MG BASE/0.5ML (EQ 12MG BASE/ML)"
                ]
            },
            {
                "orange_id": "20132-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3542,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "IMITREX STATDOSE",
        "forms": [
            {
                "orange_id": "20080-2",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 4MG BASE/0.5ML (EQ 8MG BASE/ML)",
                    "EQ 6MG BASE/0.5ML (EQ 12MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3543,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "ONZETRA XSAIL",
        "forms": [
            {
                "orange_id": "206099-1",
                "form": "POWDER",
                "route": "NASAL",
                "dosage": [
                    "EQ 11MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3544,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "SUMATRIPTAN",
        "forms": [
            {
                "orange_id": "213465-2",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3545,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "SUMATRIPTAN SUCCINATE",
        "forms": [
            {
                "orange_id": "78319-1",
                "form": "INJECTABLE",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 4MG BASE/0.5ML (EQ 8MG BASE/ML)",
                    "EQ 6MG BASE/0.5ML (EQ 12MG BASE/ML)"
                ]
            },
            {
                "orange_id": "78327-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3546,
        "type": "RX",
        "ingredient": "SUMATRIPTAN SUCCINATE",
        "trade_name": "ZEMBRACE SYMTOUCH",
        "forms": [
            {
                "orange_id": "208223-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "EQ 3MG BASE/0.5ML (EQ 3MG BASE/0.5ML)"
                ]
            }
        ]
    },
    {
        "id": 3547,
        "type": "RX",
        "ingredient": "SUNITINIB MALATE",
        "trade_name": "SUNITINIB MALATE",
        "forms": [
            {
                "orange_id": "201275-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE",
                    "EQ 37.5MG BASE",
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3548,
        "type": "RX",
        "ingredient": "SUNITINIB MALATE",
        "trade_name": "SUTENT",
        "forms": [
            {
                "orange_id": "21938-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 12.5MG BASE",
                    "EQ 25MG BASE",
                    "EQ 37.5MG BASE",
                    "EQ 50MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3549,
        "type": "RX",
        "ingredient": "SUVOREXANT",
        "trade_name": "BELSOMRA",
        "forms": [
            {
                "orange_id": "204569-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "15MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3550,
        "type": "RX",
        "ingredient": "TACROLIMUS",
        "trade_name": "ASTAGRAF XL",
        "forms": [
            {
                "orange_id": "204096-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3551,
        "type": "RX",
        "ingredient": "TACROLIMUS",
        "trade_name": "ENVARSUS XR",
        "forms": [
            {
                "orange_id": "206406-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.75MG BASE",
                    "EQ 1MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3552,
        "type": "RX",
        "ingredient": "TACROLIMUS",
        "trade_name": "PROGRAF",
        "forms": [
            {
                "orange_id": "50708-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE",
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "210115-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.2MG BASE/PACKET",
                    "EQ 1MG BASE/PACKET"
                ]
            },
            {
                "orange_id": "50709-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3553,
        "type": "RX",
        "ingredient": "TACROLIMUS",
        "trade_name": "PROTOPIC",
        "forms": [
            {
                "orange_id": "50777-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.03%",
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3554,
        "type": "RX",
        "ingredient": "TACROLIMUS",
        "trade_name": "TACROLIMUS",
        "forms": [
            {
                "orange_id": "91195-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE",
                    "EQ 5MG BASE"
                ]
            },
            {
                "orange_id": "203900-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 5MG BASE/ML"
                ]
            },
            {
                "orange_id": "211688-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.03%",
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3555,
        "type": "RX",
        "ingredient": "TADALAFIL",
        "trade_name": "ADCIRCA",
        "forms": [
            {
                "orange_id": "22332-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3556,
        "type": "RX",
        "ingredient": "TADALAFIL",
        "trade_name": "ALYQ",
        "forms": [
            {
                "orange_id": "209942-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3557,
        "type": "RX",
        "ingredient": "TADALAFIL",
        "trade_name": "CIALIS",
        "forms": [
            {
                "orange_id": "21368-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3558,
        "type": "RX",
        "ingredient": "TADALAFIL",
        "trade_name": "TADALAFIL",
        "forms": [
            {
                "orange_id": "209167-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3559,
        "type": "RX",
        "ingredient": "TAFAMIDIS",
        "trade_name": "VYNDAMAX",
        "forms": [
            {
                "orange_id": "212161-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "61MG"
                ]
            }
        ]
    },
    {
        "id": 3560,
        "type": "RX",
        "ingredient": "TAFAMIDIS MEGLUMINE",
        "trade_name": "VYNDAQEL",
        "forms": [
            {
                "orange_id": "211996-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3561,
        "type": "RX",
        "ingredient": "TAFENOQUINE SUCCINATE",
        "trade_name": "ARAKODA",
        "forms": [
            {
                "orange_id": "210607-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3562,
        "type": "RX",
        "ingredient": "TAFENOQUINE SUCCINATE",
        "trade_name": "KRINTAFEL",
        "forms": [
            {
                "orange_id": "210795-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3563,
        "type": "RX",
        "ingredient": "TAFLUPROST",
        "trade_name": "TAFLUPROST",
        "forms": [
            {
                "orange_id": "209051-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.0015%"
                ]
            }
        ]
    },
    {
        "id": 3564,
        "type": "RX",
        "ingredient": "TAFLUPROST",
        "trade_name": "ZIOPTAN",
        "forms": [
            {
                "orange_id": "202514-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.0015%"
                ]
            }
        ]
    },
    {
        "id": 3565,
        "type": "RX",
        "ingredient": "TALAZOPARIB TOSYLATE",
        "trade_name": "TALZENNA",
        "forms": [
            {
                "orange_id": "211651-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE",
                    "EQ 0.5MG BASE",
                    "EQ 0.75MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3566,
        "type": "RX",
        "ingredient": "TALC",
        "trade_name": "SCLEROSOL",
        "forms": [
            {
                "orange_id": "20587-1",
                "form": "AEROSOL",
                "route": "INTRAPLEURAL",
                "dosage": [
                    "4GM/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3567,
        "type": "RX",
        "ingredient": "TALC",
        "trade_name": "STERITALC",
        "forms": [
            {
                "orange_id": "205555-1",
                "form": "POWDER",
                "route": "INTRAPLEURAL",
                "dosage": [
                    "2GM/VIAL",
                    "3GM/VIAL",
                    "4GM/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3568,
        "type": "RX",
        "ingredient": "TALC",
        "trade_name": "TALC",
        "forms": [
            {
                "orange_id": "21388-1",
                "form": "POWDER",
                "route": "INTRAPLEURAL",
                "dosage": [
                    "5GM/BOT"
                ]
            }
        ]
    },
    {
        "id": 3569,
        "type": "RX",
        "ingredient": "TAMOXIFEN CITRATE",
        "trade_name": "SOLTAMOX",
        "forms": [
            {
                "orange_id": "21807-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE/10ML"
                ]
            }
        ]
    },
    {
        "id": 3570,
        "type": "RX",
        "ingredient": "TAMOXIFEN CITRATE",
        "trade_name": "TAMOXIFEN CITRATE",
        "forms": [
            {
                "orange_id": "70929-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3571,
        "type": "RX",
        "ingredient": "TAMSULOSIN HYDROCHLORIDE",
        "trade_name": "FLOMAX",
        "forms": [
            {
                "orange_id": "20579-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.4MG"
                ]
            }
        ]
    },
    {
        "id": 3572,
        "type": "RX",
        "ingredient": "TAMSULOSIN HYDROCHLORIDE",
        "trade_name": "TAMSULOSIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "207405-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "0.4MG"
                ]
            }
        ]
    },
    {
        "id": 3573,
        "type": "RX",
        "ingredient": "TAPENTADOL HYDROCHLORIDE",
        "trade_name": "NUCYNTA",
        "forms": [
            {
                "orange_id": "22304-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3574,
        "type": "RX",
        "ingredient": "TAPENTADOL HYDROCHLORIDE",
        "trade_name": "NUCYNTA ER",
        "forms": [
            {
                "orange_id": "200533-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 50MG BASE",
                    "EQ 100MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE",
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3575,
        "type": "RX",
        "ingredient": "TASIMELTEON",
        "trade_name": "HETLIOZ",
        "forms": [
            {
                "orange_id": "205677-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3576,
        "type": "RX",
        "ingredient": "TASIMELTEON",
        "trade_name": "HETLIOZ LQ",
        "forms": [
            {
                "orange_id": "214517-1",
                "form": "SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "4MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3577,
        "type": "RX",
        "ingredient": "TAVABOROLE",
        "trade_name": "KERYDIN",
        "forms": [
            {
                "orange_id": "204427-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 3578,
        "type": "RX",
        "ingredient": "TAVABOROLE",
        "trade_name": "TAVABOROLE",
        "forms": [
            {
                "orange_id": "212188-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "5%"
                ]
            }
        ]
    },
    {
        "id": 3579,
        "type": "RX",
        "ingredient": "TAZAROTENE",
        "trade_name": "ARAZLO",
        "forms": [
            {
                "orange_id": "211882-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.045%"
                ]
            }
        ]
    },
    {
        "id": 3580,
        "type": "RX",
        "ingredient": "TAZAROTENE",
        "trade_name": "AVAGE",
        "forms": [
            {
                "orange_id": "21184-3",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3581,
        "type": "RX",
        "ingredient": "TAZAROTENE",
        "trade_name": "FABIOR",
        "forms": [
            {
                "orange_id": "202428-1",
                "form": "AEROSOL, FOAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3582,
        "type": "RX",
        "ingredient": "TAZAROTENE",
        "trade_name": "TAZAROTENE",
        "forms": [
            {
                "orange_id": "208662-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3583,
        "type": "RX",
        "ingredient": "TAZAROTENE",
        "trade_name": "TAZORAC",
        "forms": [
            {
                "orange_id": "21184-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "20600-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3584,
        "type": "RX",
        "ingredient": "TAZEMETOSTAT HYDROBROMIDE",
        "trade_name": "TAZVERIK",
        "forms": [
            {
                "orange_id": "211723-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3585,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M BICISATE KIT",
        "trade_name": "NEUROLITE",
        "forms": [
            {
                "orange_id": "20256-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3586,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M EXAMETAZIME KIT",
        "trade_name": "CERETEC",
        "forms": [
            {
                "orange_id": "19829-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3587,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M EXAMETAZIME KIT",
        "trade_name": "DRAX EXAMETAZIME",
        "forms": [
            {
                "orange_id": "208870-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3588,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MEBROFENIN KIT",
        "trade_name": "CHOLETEC",
        "forms": [
            {
                "orange_id": "18963-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3589,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MEBROFENIN KIT",
        "trade_name": "TECHNETIUM TC-99M MEBROFENIN",
        "forms": [
            {
                "orange_id": "78242-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3590,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MEDRONATE",
        "trade_name": "DRAXIMAGE MDP-25",
        "forms": [
            {
                "orange_id": "18035-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3591,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MEDRONATE KIT",
        "trade_name": "CIS-MDP",
        "forms": [
            {
                "orange_id": "18124-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3592,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MEDRONATE KIT",
        "trade_name": "TECHNETIUM TC-99M MEDRONATE KIT",
        "forms": [
            {
                "orange_id": "18107-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3593,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MERTIATIDE KIT",
        "trade_name": "TECHNESCAN MAG3",
        "forms": [
            {
                "orange_id": "19882-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3594,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M MERTIATIDE KIT",
        "trade_name": "TECHNETIUM TC99M MERTIATIDE KIT",
        "forms": [
            {
                "orange_id": "206489-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3595,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M OXIDRONATE KIT",
        "trade_name": "TECHNESCAN",
        "forms": [
            {
                "orange_id": "18321-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3596,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M PENTETATE KIT",
        "trade_name": "DRAXIMAGE DTPA",
        "forms": [
            {
                "orange_id": "18511-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3597,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M PYROPHOSPHATE KIT",
        "trade_name": "CIS-PYRO",
        "forms": [
            {
                "orange_id": "19039-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3598,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M PYROPHOSPHATE KIT",
        "trade_name": "TECHNESCAN PYP KIT",
        "forms": [
            {
                "orange_id": "17538-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3599,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M RED BLOOD CELL KIT",
        "trade_name": "ULTRATAG",
        "forms": [
            {
                "orange_id": "19981-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3600,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SESTAMIBI KIT",
        "trade_name": "CARDIOLITE",
        "forms": [
            {
                "orange_id": "19785-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3601,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SESTAMIBI KIT",
        "trade_name": "TECHNETIUM TC 99M SESTAMIBI",
        "forms": [
            {
                "orange_id": "78809-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A",
                    "10-30mCi"
                ]
            }
        ]
    },
    {
        "id": 3602,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SODIUM PERTECHNETATE GENERATOR",
        "trade_name": "RADIOGENIX SYSTEM",
        "forms": [
            {
                "orange_id": "202158-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS, INTRAVESICULAR, OPHTHALMIC",
                "dosage": [
                    "30-1153mCi/GENERATOR"
                ]
            }
        ]
    },
    {
        "id": 3603,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SODIUM PERTECHNETATE GENERATOR",
        "trade_name": "TECHNELITE",
        "forms": [
            {
                "orange_id": "17771-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1-20 CI/GENERATOR"
                ]
            }
        ]
    },
    {
        "id": 3604,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SODIUM PERTECHNETATE GENERATOR",
        "trade_name": "ULTRA-TECHNEKOW FM",
        "forms": [
            {
                "orange_id": "17243-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1-19 CI/GENERATOR"
                ]
            }
        ]
    },
    {
        "id": 3605,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M SULFUR COLLOID KIT",
        "trade_name": "AN-SULFUR COLLOID",
        "forms": [
            {
                "orange_id": "17858-1",
                "form": "SOLUTION",
                "route": "INJECTION, ORAL",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3606,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M TETROFOSMIN KIT",
        "trade_name": "MYOVIEW 30ML",
        "forms": [
            {
                "orange_id": "20372-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3607,
        "type": "RX",
        "ingredient": "TECHNETIUM TC-99M TILMANOCEPT",
        "trade_name": "LYMPHOSEEK KIT",
        "forms": [
            {
                "orange_id": "202207-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "N/A"
                ]
            }
        ]
    },
    {
        "id": 3608,
        "type": "RX",
        "ingredient": "TECOVIRIMAT",
        "trade_name": "TPOXX",
        "forms": [
            {
                "orange_id": "208627-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3609,
        "type": "RX",
        "ingredient": "TEDIZOLID PHOSPHATE",
        "trade_name": "SIVEXTRO",
        "forms": [
            {
                "orange_id": "205436-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/VIAL"
                ]
            },
            {
                "orange_id": "205435-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3610,
        "type": "RX",
        "ingredient": "TEDUGLUTIDE RECOMBINANT",
        "trade_name": "GATTEX KIT",
        "forms": [
            {
                "orange_id": "203441-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "5MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3611,
        "type": "RX",
        "ingredient": "TEGASEROD MALEATE",
        "trade_name": "ZELNORM",
        "forms": [
            {
                "orange_id": "21200-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 6MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3612,
        "type": "RX",
        "ingredient": "TELAVANCIN HYDROCHLORIDE",
        "trade_name": "VIBATIV",
        "forms": [
            {
                "orange_id": "22110-2",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 750MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3613,
        "type": "RX",
        "ingredient": "TELMISARTAN",
        "trade_name": "MICARDIS",
        "forms": [
            {
                "orange_id": "20850-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3614,
        "type": "RX",
        "ingredient": "TELMISARTAN",
        "trade_name": "TELMISARTAN",
        "forms": [
            {
                "orange_id": "202130-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3615,
        "type": "RX",
        "ingredient": "TELOTRISTAT ETIPRATE",
        "trade_name": "XERMELO",
        "forms": [
            {
                "orange_id": "208794-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3616,
        "type": "RX",
        "ingredient": "TEMAZEPAM",
        "trade_name": "RESTORIL",
        "forms": [
            {
                "orange_id": "18163-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "7.5MG",
                    "15MG",
                    "22.5MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3617,
        "type": "RX",
        "ingredient": "TEMAZEPAM",
        "trade_name": "TEMAZEPAM",
        "forms": [
            {
                "orange_id": "71620-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "7.5MG",
                    "22.5MG"
                ]
            }
        ]
    },
    {
        "id": 3618,
        "type": "RX",
        "ingredient": "TEMOZOLOMIDE",
        "trade_name": "TEMODAR",
        "forms": [
            {
                "orange_id": "21029-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "20MG",
                    "100MG",
                    "140MG",
                    "180MG",
                    "250MG"
                ]
            },
            {
                "orange_id": "22277-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3619,
        "type": "RX",
        "ingredient": "TEMOZOLOMIDE",
        "trade_name": "TEMOZOLOMIDE",
        "forms": [
            {
                "orange_id": "201528-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "20MG",
                    "100MG",
                    "140MG",
                    "180MG",
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3620,
        "type": "RX",
        "ingredient": "TEMSIROLIMUS",
        "trade_name": "TEMSIROLIMUS",
        "forms": [
            {
                "orange_id": "203153-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "25MG/ML (25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3621,
        "type": "RX",
        "ingredient": "TEMSIROLIMUS",
        "trade_name": "TORISEL",
        "forms": [
            {
                "orange_id": "22088-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "25MG/ML (25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3622,
        "type": "RX",
        "ingredient": "TENOFOVIR ALAFENAMIDE FUMARATE",
        "trade_name": "VEMLIDY",
        "forms": [
            {
                "orange_id": "208464-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3623,
        "type": "RX",
        "ingredient": "TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "TENOFOVIR DISOPROXIL FUMARATE",
        "forms": [
            {
                "orange_id": "90647-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "200MG",
                    "250MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3624,
        "type": "RX",
        "ingredient": "TENOFOVIR DISOPROXIL FUMARATE",
        "trade_name": "VIREAD",
        "forms": [
            {
                "orange_id": "22577-1",
                "form": "POWDER",
                "route": "ORAL",
                "dosage": [
                    "40MG/SCOOPFUL"
                ]
            },
            {
                "orange_id": "21356-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "150MG",
                    "200MG",
                    "250MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3625,
        "type": "RX",
        "ingredient": "TEPOTINIB HYDROCHLORIDE",
        "trade_name": "TEPMETKO",
        "forms": [
            {
                "orange_id": "214096-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 225MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3626,
        "type": "RX",
        "ingredient": "TERAZOSIN HYDROCHLORIDE",
        "trade_name": "TERAZOSIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "74823-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3627,
        "type": "OTC",
        "ingredient": "TERBINAFINE",
        "trade_name": "LAMISIL AT",
        "forms": [
            {
                "orange_id": "21958-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3628,
        "type": "OTC",
        "ingredient": "TERBINAFINE HYDROCHLORIDE",
        "trade_name": "LAMISIL",
        "forms": [
            {
                "orange_id": "20980-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3629,
        "type": "OTC",
        "ingredient": "TERBINAFINE HYDROCHLORIDE",
        "trade_name": "LAMISIL AT",
        "forms": [
            {
                "orange_id": "21124-1",
                "form": "SOLUTION",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "21124-2",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3630,
        "type": "OTC",
        "ingredient": "TERBINAFINE HYDROCHLORIDE",
        "trade_name": "TERBINAFINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77511-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            },
            {
                "orange_id": "78297-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3631,
        "type": "RX",
        "ingredient": "TERBUTALINE SULFATE",
        "trade_name": "BRETHINE",
        "forms": [
            {
                "orange_id": "17849-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3632,
        "type": "RX",
        "ingredient": "TERBUTALINE SULFATE",
        "trade_name": "TERBUTALINE SULFATE",
        "forms": [
            {
                "orange_id": "78151-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            },
            {
                "orange_id": "75877-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3633,
        "type": "RX",
        "ingredient": "TERCONAZOLE",
        "trade_name": "TERCONAZOLE",
        "forms": [
            {
                "orange_id": "76712-1",
                "form": "CREAM",
                "route": "VAGINAL",
                "dosage": [
                    "0.4%",
                    "0.8%"
                ]
            },
            {
                "orange_id": "77149-1",
                "form": "SUPPOSITORY",
                "route": "VAGINAL",
                "dosage": [
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3634,
        "type": "RX",
        "ingredient": "TERIFLUNOMIDE",
        "trade_name": "AUBAGIO",
        "forms": [
            {
                "orange_id": "202992-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7MG",
                    "14MG"
                ]
            }
        ]
    },
    {
        "id": 3635,
        "type": "RX",
        "ingredient": "TERIFLUNOMIDE",
        "trade_name": "TERIFLUNOMIDE",
        "forms": [
            {
                "orange_id": "209690-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "7MG",
                    "14MG"
                ]
            }
        ]
    },
    {
        "id": 3636,
        "type": "RX",
        "ingredient": "TERIPARATIDE",
        "trade_name": "BONSITY",
        "forms": [
            {
                "orange_id": "211939-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.62MG/2.48ML (0.25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3637,
        "type": "RX",
        "ingredient": "TERIPARATIDE",
        "trade_name": "FORTEO",
        "forms": [
            {
                "orange_id": "21318-2",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.6MG/2.4ML (0.25MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3638,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "ANDRODERM",
        "forms": [
            {
                "orange_id": "20489-3",
                "form": "FILM, EXTENDED RELEASE",
                "route": "TRANSDERMAL",
                "dosage": [
                    "2MG/24HR",
                    "4MG/24HR"
                ]
            }
        ]
    },
    {
        "id": 3639,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "ANDROGEL",
        "forms": [
            {
                "orange_id": "22309-1",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1.62% (20.25MG/1.25GM ACTUATION)"
                ]
            }
        ]
    },
    {
        "id": 3640,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "FORTESTA",
        "forms": [
            {
                "orange_id": "21463-1",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "10MG/0.5GM ACTUATION"
                ]
            }
        ]
    },
    {
        "id": 3641,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "NATESTO",
        "forms": [
            {
                "orange_id": "205488-1",
                "form": "GEL, METERED",
                "route": "NASAL",
                "dosage": [
                    "5.5MG/0.122GM ACTUATION"
                ]
            }
        ]
    },
    {
        "id": 3642,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "TESTIM",
        "forms": [
            {
                "orange_id": "21454-1",
                "form": "GEL",
                "route": "TRANSDERMAL",
                "dosage": [
                    "50MG/5GM PACKET"
                ]
            }
        ]
    },
    {
        "id": 3643,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "TESTOPEL",
        "forms": [
            {
                "orange_id": "80911-1",
                "form": "PELLET",
                "route": "IMPLANTATION",
                "dosage": [
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 3644,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "TESTOSTERONE",
        "forms": [
            {
                "orange_id": "204570-1",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1.62% (20.25MG/1.25GM ACTUATION)",
                    "10MG/0.5GM ACTUATION",
                    "12.5MG/1.25GM ACTUATION"
                ]
            },
            {
                "orange_id": "204570-2",
                "form": "GEL",
                "route": "TRANSDERMAL",
                "dosage": [
                    "1.62% (20.25MG/1.25GM PACKET)",
                    "1.62% (40.5MG/2.5GM PACKET)",
                    "25MG/2.5GM PACKET",
                    "50MG/5GM PACKET"
                ]
            },
            {
                "orange_id": "205328-1",
                "form": "SOLUTION, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "30MG/1.5ML ACTUATION"
                ]
            }
        ]
    },
    {
        "id": 3645,
        "type": "RX",
        "ingredient": "TESTOSTERONE",
        "trade_name": "VOGELXO",
        "forms": [
            {
                "orange_id": "204399-3",
                "form": "GEL, METERED",
                "route": "TRANSDERMAL",
                "dosage": [
                    "12.5MG/1.25GM ACTUATION"
                ]
            },
            {
                "orange_id": "204399-2",
                "form": "GEL",
                "route": "TRANSDERMAL",
                "dosage": [
                    "50MG/5GM PACKET"
                ]
            }
        ]
    },
    {
        "id": 3646,
        "type": "RX",
        "ingredient": "TESTOSTERONE CYPIONATE",
        "trade_name": "DEPO-TESTOSTERONE",
        "forms": [
            {
                "orange_id": "85635-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML",
                    "200MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3647,
        "type": "RX",
        "ingredient": "TESTOSTERONE CYPIONATE",
        "trade_name": "TESTOSTERONE CYPIONATE",
        "forms": [
            {
                "orange_id": "207742-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/ML",
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3648,
        "type": "RX",
        "ingredient": "TESTOSTERONE ENANTHATE",
        "trade_name": "TESTOSTERONE ENANTHATE",
        "forms": [
            {
                "orange_id": "91120-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "200MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3649,
        "type": "RX",
        "ingredient": "TESTOSTERONE ENANTHATE",
        "trade_name": "XYOSTED (AUTOINJECTOR)",
        "forms": [
            {
                "orange_id": "209863-1",
                "form": "SOLUTION",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "50MG/0.5ML (50MG/0.5ML)",
                    "75MG/0.5ML (75MG/0.5ML)",
                    "100MG/0.5ML (100MG/0.5ML)"
                ]
            }
        ]
    },
    {
        "id": 3650,
        "type": "RX",
        "ingredient": "TESTOSTERONE UNDECANOATE",
        "trade_name": "AVEED",
        "forms": [
            {
                "orange_id": "22219-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "750MG/3ML (250MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3651,
        "type": "RX",
        "ingredient": "TESTOSTERONE UNDECANOATE",
        "trade_name": "JATENZO",
        "forms": [
            {
                "orange_id": "206089-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "158MG",
                    "198MG",
                    "237MG"
                ]
            }
        ]
    },
    {
        "id": 3652,
        "type": "RX",
        "ingredient": "TETRABENAZINE",
        "trade_name": "TETRABENAZINE",
        "forms": [
            {
                "orange_id": "206686-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "12.5MG"
                ]
            }
        ]
    },
    {
        "id": 3653,
        "type": "RX",
        "ingredient": "TETRABENAZINE",
        "trade_name": "XENAZINE",
        "forms": [
            {
                "orange_id": "21894-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "12.5MG",
                    "25MG"
                ]
            }
        ]
    },
    {
        "id": 3654,
        "type": "RX",
        "ingredient": "TETRACAINE HYDROCHLORIDE",
        "trade_name": "TETRACAINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208135-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3655,
        "type": "RX",
        "ingredient": "TETRACYCLINE HYDROCHLORIDE",
        "trade_name": "ACHROMYCIN V",
        "forms": [
            {
                "orange_id": "50278-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3656,
        "type": "RX",
        "ingredient": "TETRACYCLINE HYDROCHLORIDE",
        "trade_name": "TETRACYCLINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "210674-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3657,
        "type": "RX",
        "ingredient": "TETRAHYDROZOLINE HYDROCHLORIDE",
        "trade_name": "TYZINE",
        "forms": [
            {
                "orange_id": "86576-2",
                "form": "SOLUTION",
                "route": "NASAL",
                "dosage": [
                    "0.05%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "86576-3",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3658,
        "type": "RX",
        "ingredient": "THALIDOMIDE",
        "trade_name": "THALOMID",
        "forms": [
            {
                "orange_id": "20785-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3659,
        "type": "RX",
        "ingredient": "THALLOUS CHLORIDE TL-201",
        "trade_name": "THALLOUS CHLORIDE TL 201",
        "forms": [
            {
                "orange_id": "18150-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1mCi/ML"
                ]
            }
        ]
    },
    {
        "id": 3660,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "ELIXOPHYLLIN",
        "forms": [
            {
                "orange_id": "85186-1",
                "form": "SOLUTION, ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "80MG/15ML"
                ]
            }
        ]
    },
    {
        "id": 3661,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEO-24",
        "forms": [
            {
                "orange_id": "87942-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "400MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3662,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEOPHYLLINE",
        "forms": [
            {
                "orange_id": "206344-1",
                "form": "SOLUTION, ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "80MG/15ML"
                ]
            },
            {
                "orange_id": "91156-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "80MG/15ML"
                ]
            },
            {
                "orange_id": "90430-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "300MG",
                    "450MG",
                    "400MG",
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3663,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEOPHYLLINE 0. 04% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19826-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3664,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEOPHYLLINE 0. 08% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19826-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3665,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEOPHYLLINE 0. 16% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19826-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "160MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3666,
        "type": "RX",
        "ingredient": "THEOPHYLLINE",
        "trade_name": "THEOPHYLLINE 0. 32% AND DEXTROSE 5% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "19826-6",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "320MG/100ML"
                ]
            }
        ]
    },
    {
        "id": 3667,
        "type": "RX",
        "ingredient": "THIAMINE HYDROCHLORIDE",
        "trade_name": "THIAMINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "80556-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3668,
        "type": "RX",
        "ingredient": "THIOGUANINE",
        "trade_name": "THIOGUANINE",
        "forms": [
            {
                "orange_id": "12429-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 3669,
        "type": "RX",
        "ingredient": "THIORIDAZINE HYDROCHLORIDE",
        "trade_name": "THIORIDAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "88004-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3670,
        "type": "RX",
        "ingredient": "THIOTEPA",
        "trade_name": "TEPADINA",
        "forms": [
            {
                "orange_id": "208264-1",
                "form": "POWDER",
                "route": "INTRACAVITARY, INTRAVENOUS, INTRAVESICAL",
                "dosage": [
                    "15MG/VIAL",
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3671,
        "type": "RX",
        "ingredient": "THIOTEPA",
        "trade_name": "THIOTEPA",
        "forms": [
            {
                "orange_id": "211831-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15MG/VIAL"
                ]
            },
            {
                "orange_id": "214222-1",
                "form": "POWDER",
                "route": "INTRACAVITARY, INTRAVENOUS, INTRAVESICAL",
                "dosage": [
                    "15MG/VIAL",
                    "100MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3672,
        "type": "RX",
        "ingredient": "THIOTHIXENE",
        "trade_name": "THIOTHIXENE",
        "forms": [
            {
                "orange_id": "71093-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3673,
        "type": "RX",
        "ingredient": "TIAGABINE HYDROCHLORIDE",
        "trade_name": "GABITRIL",
        "forms": [
            {
                "orange_id": "20646-5",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "12MG",
                    "16MG"
                ]
            }
        ]
    },
    {
        "id": 3674,
        "type": "RX",
        "ingredient": "TIAGABINE HYDROCHLORIDE",
        "trade_name": "TIAGABINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208181-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG",
                    "12MG",
                    "16MG"
                ]
            }
        ]
    },
    {
        "id": 3675,
        "type": "RX",
        "ingredient": "TICAGRELOR",
        "trade_name": "BRILINTA",
        "forms": [
            {
                "orange_id": "22433-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "60MG",
                    "90MG"
                ]
            }
        ]
    },
    {
        "id": 3676,
        "type": "RX",
        "ingredient": "TICAGRELOR",
        "trade_name": "TICAGRELOR",
        "forms": [
            {
                "orange_id": "208575-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "90MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3677,
        "type": "RX",
        "ingredient": "TICLOPIDINE HYDROCHLORIDE",
        "trade_name": "TICLOPIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75089-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3678,
        "type": "RX",
        "ingredient": "TIGECYCLINE",
        "trade_name": "TIGECYCLINE",
        "forms": [
            {
                "orange_id": "208744-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3679,
        "type": "RX",
        "ingredient": "TIGECYCLINE",
        "trade_name": "TYGACIL",
        "forms": [
            {
                "orange_id": "21821-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "50MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3680,
        "type": "RX",
        "ingredient": "TIMOLOL",
        "trade_name": "BETIMOL",
        "forms": [
            {
                "orange_id": "20439-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3681,
        "type": "RX",
        "ingredient": "TIMOLOL",
        "trade_name": "TIMOLOL",
        "forms": [
            {
                "orange_id": "205309-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3682,
        "type": "RX",
        "ingredient": "TIMOLOL MALEATE",
        "trade_name": "ISTALOL",
        "forms": [
            {
                "orange_id": "21516-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3683,
        "type": "RX",
        "ingredient": "TIMOLOL MALEATE",
        "trade_name": "TIMOLOL MALEATE",
        "forms": [
            {
                "orange_id": "212942-1",
                "form": "SOLUTION, GEL FORMING/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            },
            {
                "orange_id": "74466-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.5% BASE",
                    "EQ 0.25% BASE"
                ]
            },
            {
                "orange_id": "207556-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3684,
        "type": "RX",
        "ingredient": "TIMOLOL MALEATE",
        "trade_name": "TIMOPTIC",
        "forms": [
            {
                "orange_id": "18086-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3685,
        "type": "RX",
        "ingredient": "TIMOLOL MALEATE",
        "trade_name": "TIMOPTIC IN OCUDOSE",
        "forms": [
            {
                "orange_id": "19463-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3686,
        "type": "RX",
        "ingredient": "TIMOLOL MALEATE",
        "trade_name": "TIMOPTIC-XE",
        "forms": [
            {
                "orange_id": "20330-1",
                "form": "SOLUTION, GEL FORMING/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "EQ 0.25% BASE",
                    "EQ 0.5% BASE"
                ]
            }
        ]
    },
    {
        "id": 3687,
        "type": "RX",
        "ingredient": "TINIDAZOLE",
        "trade_name": "TINDAMAX",
        "forms": [
            {
                "orange_id": "21618-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3688,
        "type": "RX",
        "ingredient": "TINIDAZOLE",
        "trade_name": "TINIDAZOLE",
        "forms": [
            {
                "orange_id": "203808-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3689,
        "type": "OTC",
        "ingredient": "TIOCONAZOLE",
        "trade_name": "TIOCONAZOLE",
        "forms": [
            {
                "orange_id": "75915-1",
                "form": "OINTMENT",
                "route": "VAGINAL",
                "dosage": [
                    "6.5%"
                ]
            }
        ]
    },
    {
        "id": 3690,
        "type": "OTC",
        "ingredient": "TIOCONAZOLE",
        "trade_name": "VAGISTAT-1",
        "forms": [
            {
                "orange_id": "20676-1",
                "form": "OINTMENT",
                "route": "VAGINAL",
                "dosage": [
                    "6.5%"
                ]
            }
        ]
    },
    {
        "id": 3691,
        "type": "RX",
        "ingredient": "TIOPRONIN",
        "trade_name": "THIOLA",
        "forms": [
            {
                "orange_id": "19569-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3692,
        "type": "RX",
        "ingredient": "TIOPRONIN",
        "trade_name": "THIOLA EC",
        "forms": [
            {
                "orange_id": "211843-1",
                "form": "TABLET, DELAYED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3693,
        "type": "RX",
        "ingredient": "TIOPRONIN",
        "trade_name": "TIOPRONIN",
        "forms": [
            {
                "orange_id": "214326-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3694,
        "type": "RX",
        "ingredient": "TIOTROPIUM BROMIDE",
        "trade_name": "SPIRIVA",
        "forms": [
            {
                "orange_id": "21395-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.018MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 3695,
        "type": "RX",
        "ingredient": "TIOTROPIUM BROMIDE",
        "trade_name": "SPIRIVA RESPIMAT",
        "forms": [
            {
                "orange_id": "21936-2",
                "form": "SPRAY, METERED",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.00125MG BASE/INH",
                    "EQ 0.0025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 3696,
        "type": "RX",
        "ingredient": "TIPIRACIL HYDROCHLORIDE AND TRIFLURIDINE",
        "trade_name": "LONSURF",
        "forms": [
            {
                "orange_id": "207981-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 6.14MG BASE-15MG",
                    "EQ 8.19MG BASE-20MG"
                ]
            }
        ]
    },
    {
        "id": 3697,
        "type": "RX",
        "ingredient": "TIPRANAVIR",
        "trade_name": "APTIVUS",
        "forms": [
            {
                "orange_id": "21814-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "22292-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3698,
        "type": "RX",
        "ingredient": "TIRBANIBULIN",
        "trade_name": "KLISYRI",
        "forms": [
            {
                "orange_id": "213189-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3699,
        "type": "RX",
        "ingredient": "TIROFIBAN HYDROCHLORIDE",
        "trade_name": "AGGRASTAT",
        "forms": [
            {
                "orange_id": "20912-2",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "EQ 3.75MG BASE/15ML (EQ 0.25MG BASE/ML)"
                ]
            },
            {
                "orange_id": "20913-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 5MG BASE/100ML (EQ 0.05MG BASE/ML)",
                    "EQ 12.5MG BASE/250ML (EQ 0.05MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3700,
        "type": "RX",
        "ingredient": "TIROFIBAN HYDROCHLORIDE",
        "trade_name": "TIROFIBAN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206888-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 12.5MG BASE/250ML (EQ 0.05MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3701,
        "type": "RX",
        "ingredient": "TIVOZANIB HYDROCHLORIDE",
        "trade_name": "FOTIVDA",
        "forms": [
            {
                "orange_id": "212904-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.89MG BASE",
                    "EQ 1.34MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3702,
        "type": "RX",
        "ingredient": "TIZANIDINE HYDROCHLORIDE",
        "trade_name": "TIZANIDINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "213223-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE",
                    "EQ 6MG BASE"
                ]
            },
            {
                "orange_id": "211798-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3703,
        "type": "RX",
        "ingredient": "TIZANIDINE HYDROCHLORIDE",
        "trade_name": "ZANAFLEX",
        "forms": [
            {
                "orange_id": "21447-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 2MG BASE",
                    "EQ 4MG BASE",
                    "EQ 6MG BASE"
                ]
            },
            {
                "orange_id": "20397-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 4MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3704,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "AKTOB",
        "forms": [
            {
                "orange_id": "64096-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            }
        ]
    },
    {
        "id": 3705,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "BETHKIS",
        "forms": [
            {
                "orange_id": "201820-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/4ML"
                ]
            }
        ]
    },
    {
        "id": 3706,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "KITABIS PAK",
        "forms": [
            {
                "orange_id": "205433-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3707,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "TOBI",
        "forms": [
            {
                "orange_id": "50753-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3708,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "TOBI PODHALER",
        "forms": [
            {
                "orange_id": "201688-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "28MG"
                ]
            }
        ]
    },
    {
        "id": 3709,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "TOBRAMYCIN",
        "forms": [
            {
                "orange_id": "211847-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            },
            {
                "orange_id": "201422-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "300MG/5ML",
                    "300MG/4ML"
                ]
            }
        ]
    },
    {
        "id": 3710,
        "type": "RX",
        "ingredient": "TOBRAMYCIN",
        "trade_name": "TOBREX",
        "forms": [
            {
                "orange_id": "50555-1",
                "form": "OINTMENT",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            },
            {
                "orange_id": "50541-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.3%"
                ]
            }
        ]
    },
    {
        "id": 3711,
        "type": "RX",
        "ingredient": "TOBRAMYCIN SULFATE",
        "trade_name": "TOBRAMYCIN SULFATE",
        "forms": [
            {
                "orange_id": "205179-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 40MG BASE/ML",
                    "EQ 1.2GM BASE/VIAL",
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3712,
        "type": "RX",
        "ingredient": "TOBRAMYCIN SULFATE",
        "trade_name": "TOBRAMYCIN SULFATE (PHARMACY BULK)",
        "forms": [
            {
                "orange_id": "65120-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 40MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3713,
        "type": "RX",
        "ingredient": "TOBRAMYCIN SULFATE",
        "trade_name": "TOBRAMYCIN SULFATE IN SODIUM CHLORIDE 0. 9% IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "63081-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1.2MG BASE/ML",
                    "EQ 1.6MG BASE/ML",
                    "EQ 80MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 3714,
        "type": "RX",
        "ingredient": "TOFACITINIB CITRATE",
        "trade_name": "XELJANZ",
        "forms": [
            {
                "orange_id": "213082-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG/ML BASE"
                ]
            },
            {
                "orange_id": "203214-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3715,
        "type": "RX",
        "ingredient": "TOFACITINIB CITRATE",
        "trade_name": "XELJANZ XR",
        "forms": [
            {
                "orange_id": "208246-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 11MG BASE",
                    "EQ 22MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3716,
        "type": "RX",
        "ingredient": "TOLCAPONE",
        "trade_name": "TASMAR",
        "forms": [
            {
                "orange_id": "20697-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3717,
        "type": "RX",
        "ingredient": "TOLCAPONE",
        "trade_name": "TOLCAPONE",
        "forms": [
            {
                "orange_id": "208937-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3718,
        "type": "RX",
        "ingredient": "TOLTERODINE TARTRATE",
        "trade_name": "DETROL",
        "forms": [
            {
                "orange_id": "20771-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3719,
        "type": "RX",
        "ingredient": "TOLTERODINE TARTRATE",
        "trade_name": "DETROL LA",
        "forms": [
            {
                "orange_id": "21228-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3720,
        "type": "RX",
        "ingredient": "TOLTERODINE TARTRATE",
        "trade_name": "TOLTERODINE TARTRATE",
        "forms": [
            {
                "orange_id": "213397-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "4MG"
                ]
            },
            {
                "orange_id": "210775-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG"
                ]
            }
        ]
    },
    {
        "id": 3721,
        "type": "RX",
        "ingredient": "TOLVAPTAN",
        "trade_name": "JYNARQUE",
        "forms": [
            {
                "orange_id": "204441-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG",
                    "45MG",
                    "60MG",
                    "90MG"
                ]
            }
        ]
    },
    {
        "id": 3722,
        "type": "RX",
        "ingredient": "TOLVAPTAN",
        "trade_name": "SAMSCA",
        "forms": [
            {
                "orange_id": "22275-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3723,
        "type": "RX",
        "ingredient": "TOLVAPTAN",
        "trade_name": "TOLVAPTAN",
        "forms": [
            {
                "orange_id": "211891-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3724,
        "type": "RX",
        "ingredient": "TOPIRAMATE",
        "trade_name": "EPRONTIA",
        "forms": [
            {
                "orange_id": "214679-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "25MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3725,
        "type": "RX",
        "ingredient": "TOPIRAMATE",
        "trade_name": "QUDEXY XR",
        "forms": [
            {
                "orange_id": "205122-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3726,
        "type": "RX",
        "ingredient": "TOPIRAMATE",
        "trade_name": "TOPAMAX",
        "forms": [
            {
                "orange_id": "20844-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "25MG"
                ]
            },
            {
                "orange_id": "20505-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3727,
        "type": "RX",
        "ingredient": "TOPIRAMATE",
        "trade_name": "TOPIRAMATE",
        "forms": [
            {
                "orange_id": "210278-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "150MG",
                    "200MG"
                ]
            },
            {
                "orange_id": "76575-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "25MG"
                ]
            },
            {
                "orange_id": "76311-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3728,
        "type": "RX",
        "ingredient": "TOPIRAMATE",
        "trade_name": "TROKENDI XR",
        "forms": [
            {
                "orange_id": "201635-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3729,
        "type": "RX",
        "ingredient": "TOPOTECAN HYDROCHLORIDE",
        "trade_name": "HYCAMTIN",
        "forms": [
            {
                "orange_id": "20981-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.25MG BASE",
                    "EQ 1MG BASE"
                ]
            },
            {
                "orange_id": "20671-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 4MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3730,
        "type": "RX",
        "ingredient": "TOPOTECAN HYDROCHLORIDE",
        "trade_name": "TOPOTECAN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "202351-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 4MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "204406-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1MG BASE/ML (EQ 1MG BASE/ML)",
                    "EQ 4MG BASE/4ML (EQ 1MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3731,
        "type": "RX",
        "ingredient": "TOREMIFENE CITRATE",
        "trade_name": "FARESTON",
        "forms": [
            {
                "orange_id": "20497-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3732,
        "type": "RX",
        "ingredient": "TOREMIFENE CITRATE",
        "trade_name": "TOREMIFENE CITRATE",
        "forms": [
            {
                "orange_id": "212818-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 60MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3733,
        "type": "RX",
        "ingredient": "TORSEMIDE",
        "trade_name": "SOAANZ",
        "forms": [
            {
                "orange_id": "213218-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG",
                    "40MG",
                    "60MG"
                ]
            }
        ]
    },
    {
        "id": 3734,
        "type": "RX",
        "ingredient": "TORSEMIDE",
        "trade_name": "TORSEMIDE",
        "forms": [
            {
                "orange_id": "78249-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG",
                    "20MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3735,
        "type": "RX",
        "ingredient": "TRABECTEDIN",
        "trade_name": "YONDELIS",
        "forms": [
            {
                "orange_id": "207953-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3736,
        "type": "RX",
        "ingredient": "TRAMADOL HYDROCHLORIDE",
        "trade_name": "CONZIP",
        "forms": [
            {
                "orange_id": "22370-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3737,
        "type": "RX",
        "ingredient": "TRAMADOL HYDROCHLORIDE",
        "trade_name": "QDOLO",
        "forms": [
            {
                "orange_id": "214044-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "5MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3738,
        "type": "RX",
        "ingredient": "TRAMADOL HYDROCHLORIDE",
        "trade_name": "TRAMADOL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "91609-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            },
            {
                "orange_id": "202075-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3739,
        "type": "RX",
        "ingredient": "TRAMADOL HYDROCHLORIDE",
        "trade_name": "ULTRAM",
        "forms": [
            {
                "orange_id": "20281-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG"
                ]
            }
        ]
    },
    {
        "id": 3740,
        "type": "RX",
        "ingredient": "TRAMETINIB DIMETHYL SULFOXIDE",
        "trade_name": "MEKINIST",
        "forms": [
            {
                "orange_id": "204114-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG",
                    "EQ 2MG"
                ]
            }
        ]
    },
    {
        "id": 3741,
        "type": "RX",
        "ingredient": "TRANDOLAPRIL",
        "trade_name": "TRANDOLAPRIL",
        "forms": [
            {
                "orange_id": "78438-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "4MG"
                ]
            }
        ]
    },
    {
        "id": 3742,
        "type": "RX",
        "ingredient": "TRANDOLAPRIL AND VERAPAMIL HYDROCHLORIDE",
        "trade_name": "TRANDOLAPRIL AND VERAPAMIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "79135-4",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "1MG-240MG",
                    "2MG-180MG",
                    "2MG-240MG",
                    "4MG-240MG"
                ]
            }
        ]
    },
    {
        "id": 3743,
        "type": "RX",
        "ingredient": "TRANEXAMIC ACID",
        "trade_name": "CYKLOKAPRON",
        "forms": [
            {
                "orange_id": "19281-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3744,
        "type": "RX",
        "ingredient": "TRANEXAMIC ACID",
        "trade_name": "LYSTEDA",
        "forms": [
            {
                "orange_id": "22430-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "650MG"
                ]
            }
        ]
    },
    {
        "id": 3745,
        "type": "RX",
        "ingredient": "TRANEXAMIC ACID",
        "trade_name": "TRANEXAMIC ACID",
        "forms": [
            {
                "orange_id": "202436-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            },
            {
                "orange_id": "212020-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "1GM/100ML (10MG/ML)"
                ]
            },
            {
                "orange_id": "202093-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "650MG"
                ]
            }
        ]
    },
    {
        "id": 3746,
        "type": "RX",
        "ingredient": "TRANYLCYPROMINE SULFATE",
        "trade_name": "PARNATE",
        "forms": [
            {
                "orange_id": "12342-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3747,
        "type": "RX",
        "ingredient": "TRANYLCYPROMINE SULFATE",
        "trade_name": "TRANYLCYPROMINE SULFATE",
        "forms": [
            {
                "orange_id": "206856-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3748,
        "type": "RX",
        "ingredient": "TRAVOPROST",
        "trade_name": "TRAVATAN Z",
        "forms": [
            {
                "orange_id": "21994-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.004%"
                ]
            }
        ]
    },
    {
        "id": 3749,
        "type": "RX",
        "ingredient": "TRAVOPROST",
        "trade_name": "TRAVOPROST",
        "forms": [
            {
                "orange_id": "210458-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.004%"
                ]
            }
        ]
    },
    {
        "id": 3750,
        "type": "RX",
        "ingredient": "TRAZODONE HYDROCHLORIDE",
        "trade_name": "TRAZODONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "206923-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG",
                    "150MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3751,
        "type": "RX",
        "ingredient": "TREPROSTINIL",
        "trade_name": "REMODULIN",
        "forms": [
            {
                "orange_id": "21272-1",
                "form": "INJECTABLE",
                "route": "IV (INFUSION), SUBCUTANEOUS",
                "dosage": [
                    "1MG/ML",
                    "2.5MG/ML",
                    "5MG/ML",
                    "10MG/ML",
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3752,
        "type": "RX",
        "ingredient": "TREPROSTINIL",
        "trade_name": "TREPROSTINIL",
        "forms": [
            {
                "orange_id": "211574-1",
                "form": "INJECTABLE",
                "route": "IV (INFUSION), SUBCUTANEOUS",
                "dosage": [
                    "1MG/ML",
                    "2.5MG/ML",
                    "5MG/ML",
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3753,
        "type": "RX",
        "ingredient": "TREPROSTINIL",
        "trade_name": "TYVASO",
        "forms": [
            {
                "orange_id": "22387-1",
                "form": "SOLUTION",
                "route": "INHALATION",
                "dosage": [
                    "0.6MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3754,
        "type": "RX",
        "ingredient": "TREPROSTINIL DIOLAMINE",
        "trade_name": "ORENITRAM",
        "forms": [
            {
                "orange_id": "203496-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.125MG BASE",
                    "EQ 0.25MG BASE",
                    "EQ 1MG BASE",
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3755,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "ALTRENO",
        "forms": [
            {
                "orange_id": "209353-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 3756,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "ATRALIN",
        "forms": [
            {
                "orange_id": "22070-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 3757,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "AVITA",
        "forms": [
            {
                "orange_id": "20404-3",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%"
                ]
            },
            {
                "orange_id": "20400-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 3758,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "RENOVA",
        "forms": [
            {
                "orange_id": "21108-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.02%"
                ]
            }
        ]
    },
    {
        "id": 3759,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "RETIN-A",
        "forms": [
            {
                "orange_id": "19049-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%",
                    "0.05%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "17955-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.01%",
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 3760,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "RETIN-A MICRO",
        "forms": [
            {
                "orange_id": "20475-2",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.04%",
                    "0.1%"
                ]
            }
        ]
    },
    {
        "id": 3761,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "RETIN-A-MICRO",
        "forms": [
            {
                "orange_id": "20475-4",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.06%",
                    "0.08%"
                ]
            }
        ]
    },
    {
        "id": 3762,
        "type": "RX",
        "ingredient": "TRETINOIN",
        "trade_name": "TRETINOIN",
        "forms": [
            {
                "orange_id": "201687-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "75264-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%",
                    "0.05%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "207955-1",
                "form": "GEL",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.01%",
                    "0.025%"
                ]
            }
        ]
    },
    {
        "id": 3763,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "KENALOG",
        "forms": [
            {
                "orange_id": "12104-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.147MG/GM"
                ]
            }
        ]
    },
    {
        "id": 3764,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "KENALOG-10",
        "forms": [
            {
                "orange_id": "12041-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3765,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "KENALOG-40",
        "forms": [
            {
                "orange_id": "14901-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3766,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "KENALOG-80",
        "forms": [
            {
                "orange_id": "14901-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "80MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3767,
        "type": "OTC",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "NASACORT ALLERGY 24 HOUR",
        "forms": [
            {
                "orange_id": "20468-2",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.055MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3768,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "TRIAMCINOLONE ACETONIDE",
        "forms": [
            {
                "orange_id": "207651-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%",
                    "0.1%",
                    "0.5%"
                ]
            },
            {
                "orange_id": "207550-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "40MG/ML"
                ]
            },
            {
                "orange_id": "202374-1",
                "form": "LOTION",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%",
                    "0.1%"
                ]
            },
            {
                "orange_id": "213619-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%",
                    "0.025%",
                    "0.1%",
                    "0.5%"
                ]
            },
            {
                "orange_id": "206312-1",
                "form": "PASTE",
                "route": "DENTAL",
                "dosage": [
                    "0.1%"
                ]
            },
            {
                "orange_id": "78104-2",
                "form": "SPRAY, METERED",
                "route": "NASAL",
                "dosage": [
                    "0.055MG/SPRAY"
                ]
            },
            {
                "orange_id": "207094-1",
                "form": "SPRAY",
                "route": "TOPICAL",
                "dosage": [
                    "0.147MG/GM"
                ]
            }
        ]
    },
    {
        "id": 3769,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "TRIANEX",
        "forms": [
            {
                "orange_id": "89595-1",
                "form": "OINTMENT",
                "route": "TOPICAL",
                "dosage": [
                    "0.05%"
                ]
            }
        ]
    },
    {
        "id": 3770,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "TRIDERM",
        "forms": [
            {
                "orange_id": "88042-2",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.025%",
                    "0.1%",
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3771,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "TRIESENCE",
        "forms": [
            {
                "orange_id": "22048-1",
                "form": "INJECTABLE",
                "route": "INTRAVITREAL",
                "dosage": [
                    "40MG/ML (40MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3772,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "XIPERE",
        "forms": [
            {
                "orange_id": "211950-1",
                "form": "SUSPENSION",
                "route": "INJECTION",
                "dosage": [
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3773,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE ACETONIDE",
        "trade_name": "ZILRETTA",
        "forms": [
            {
                "orange_id": "208845-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "INTRA-ARTICULAR",
                "dosage": [
                    "32MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3774,
        "type": "RX",
        "ingredient": "TRIAMCINOLONE HEXACETONIDE",
        "trade_name": "ARISTOSPAN",
        "forms": [
            {
                "orange_id": "16466-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "5MG/ML",
                    "20MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3775,
        "type": "RX",
        "ingredient": "TRIAMTERENE",
        "trade_name": "DYRENIUM",
        "forms": [
            {
                "orange_id": "13174-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3776,
        "type": "RX",
        "ingredient": "TRIAMTERENE",
        "trade_name": "TRIAMTERENE",
        "forms": [
            {
                "orange_id": "211581-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3777,
        "type": "RX",
        "ingredient": "TRIAZOLAM",
        "trade_name": "HALCION",
        "forms": [
            {
                "orange_id": "17892-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG"
                ]
            }
        ]
    },
    {
        "id": 3778,
        "type": "RX",
        "ingredient": "TRIAZOLAM",
        "trade_name": "TRIAZOLAM",
        "forms": [
            {
                "orange_id": "74224-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "0.125MG",
                    "0.25MG"
                ]
            }
        ]
    },
    {
        "id": 3779,
        "type": "RX",
        "ingredient": "TRICLABENDAZOLE",
        "trade_name": "EGATEN",
        "forms": [
            {
                "orange_id": "208711-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3780,
        "type": "RX",
        "ingredient": "TRIENTINE HYDROCHLORIDE",
        "trade_name": "SYPRINE",
        "forms": [
            {
                "orange_id": "19194-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3781,
        "type": "RX",
        "ingredient": "TRIENTINE HYDROCHLORIDE",
        "trade_name": "TRIENTINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "212929-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3782,
        "type": "RX",
        "ingredient": "TRIFAROTENE",
        "trade_name": "AKLIEF",
        "forms": [
            {
                "orange_id": "211527-1",
                "form": "CREAM",
                "route": "TOPICAL",
                "dosage": [
                    "0.005%"
                ]
            }
        ]
    },
    {
        "id": 3783,
        "type": "RX",
        "ingredient": "TRIFLUOPERAZINE HYDROCHLORIDE",
        "trade_name": "TRIFLUOPERAZINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40209-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1MG BASE",
                    "EQ 2MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3784,
        "type": "RX",
        "ingredient": "TRIFLURIDINE",
        "trade_name": "TRIFLURIDINE",
        "forms": [
            {
                "orange_id": "205438-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3785,
        "type": "RX",
        "ingredient": "TRIFLURIDINE",
        "trade_name": "VIROPTIC",
        "forms": [
            {
                "orange_id": "18299-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3786,
        "type": "RX",
        "ingredient": "TRIHEPTANOIN",
        "trade_name": "DOJOLVI",
        "forms": [
            {
                "orange_id": "213687-1",
                "form": "LIQUID",
                "route": "ORAL",
                "dosage": [
                    "100% w/w"
                ]
            }
        ]
    },
    {
        "id": 3787,
        "type": "RX",
        "ingredient": "TRIHEXYPHENIDYL HYDROCHLORIDE",
        "trade_name": "TRIHEXYPHENIDYL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "40251-1",
                "form": "ELIXIR",
                "route": "ORAL",
                "dosage": [
                    "2MG/5ML"
                ]
            },
            {
                "orange_id": "91630-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3788,
        "type": "RX",
        "ingredient": "TRILACICLIB DIHYDROCHLORIDE",
        "trade_name": "COSELA",
        "forms": [
            {
                "orange_id": "214200-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 300MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3789,
        "type": "RX",
        "ingredient": "TRIMETHOBENZAMIDE HYDROCHLORIDE",
        "trade_name": "TIGAN",
        "forms": [
            {
                "orange_id": "17530-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "100MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3790,
        "type": "RX",
        "ingredient": "TRIMETHOBENZAMIDE HYDROCHLORIDE",
        "trade_name": "TRIMETHOBENZAMIDE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "76546-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3791,
        "type": "RX",
        "ingredient": "TRIMETHOPRIM",
        "trade_name": "TRIMETHOPRIM",
        "forms": [
            {
                "orange_id": "18679-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3792,
        "type": "RX",
        "ingredient": "TRIMIPRAMINE MALEATE",
        "trade_name": "TRIMIPRAMINE MALEATE",
        "forms": [
            {
                "orange_id": "208127-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 50MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3793,
        "type": "RX",
        "ingredient": "TRIPTORELIN PAMOATE",
        "trade_name": "TRELSTAR",
        "forms": [
            {
                "orange_id": "20715-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 3.75MG BASE/VIAL",
                    "EQ 11.25MG BASE/VIAL",
                    "EQ 22.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3794,
        "type": "RX",
        "ingredient": "TRIPTORELIN PAMOATE",
        "trade_name": "TRIPTODUR KIT",
        "forms": [
            {
                "orange_id": "208956-1",
                "form": "FOR SUSPENSION, EXTENDED RELEASE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 22.5MG BASE/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3795,
        "type": "RX",
        "ingredient": "TROMETHAMINE",
        "trade_name": "THAM",
        "forms": [
            {
                "orange_id": "13025-2",
                "form": "SOLUTION",
                "route": "INJECTION",
                "dosage": [
                    "18GM/500ML (3.6GM/100ML)"
                ]
            }
        ]
    },
    {
        "id": 3796,
        "type": "RX",
        "ingredient": "TROPICAMIDE",
        "trade_name": "MYDRIACYL",
        "forms": [
            {
                "orange_id": "84306-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "1%",
                    "0.5%"
                ]
            }
        ]
    },
    {
        "id": 3797,
        "type": "RX",
        "ingredient": "TROPICAMIDE",
        "trade_name": "TROPICACYL",
        "forms": [
            {
                "orange_id": "40314-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%",
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3798,
        "type": "RX",
        "ingredient": "TROPICAMIDE",
        "trade_name": "TROPICAMIDE",
        "forms": [
            {
                "orange_id": "40067-1",
                "form": "SOLUTION/DROPS",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.5%",
                    "1%"
                ]
            }
        ]
    },
    {
        "id": 3799,
        "type": "RX",
        "ingredient": "TROSPIUM CHLORIDE",
        "trade_name": "TROSPIUM CHLORIDE",
        "forms": [
            {
                "orange_id": "91289-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "60MG"
                ]
            },
            {
                "orange_id": "91513-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3800,
        "type": "RX",
        "ingredient": "TRYPAN BLUE",
        "trade_name": "MEMBRANEBLUE",
        "forms": [
            {
                "orange_id": "22278-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.15%"
                ]
            }
        ]
    },
    {
        "id": 3801,
        "type": "RX",
        "ingredient": "TRYPAN BLUE",
        "trade_name": "VISIONBLUE",
        "forms": [
            {
                "orange_id": "21670-1",
                "form": "SOLUTION",
                "route": "OPHTHALMIC",
                "dosage": [
                    "0.06%"
                ]
            }
        ]
    },
    {
        "id": 3802,
        "type": "RX",
        "ingredient": "TUCATINIB",
        "trade_name": "TUKYSA",
        "forms": [
            {
                "orange_id": "213411-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3803,
        "type": "RX",
        "ingredient": "UBROGEPANT",
        "trade_name": "UBRELVY",
        "forms": [
            {
                "orange_id": "211765-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3804,
        "type": "RX",
        "ingredient": "ULIPRISTAL ACETATE",
        "trade_name": "ELLA",
        "forms": [
            {
                "orange_id": "22474-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3805,
        "type": "RX",
        "ingredient": "ULIPRISTAL ACETATE",
        "trade_name": "LOGILIA",
        "forms": [
            {
                "orange_id": "207952-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3806,
        "type": "RX",
        "ingredient": "UMBRALISIB TOSYLATE",
        "trade_name": "UKONIQ",
        "forms": [
            {
                "orange_id": "213176-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3807,
        "type": "RX",
        "ingredient": "UMECLIDINIUM BROMIDE",
        "trade_name": "INCRUSE ELLIPTA",
        "forms": [
            {
                "orange_id": "205382-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "EQ 62.5MCG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 3808,
        "type": "RX",
        "ingredient": "UMECLIDINIUM BROMIDE AND VILANTEROL TRIFENATATE",
        "trade_name": "ANORO ELLIPTA",
        "forms": [
            {
                "orange_id": "203975-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "EQ 0.0625MG BASE/INH-EQ 0.025MG BASE/INH"
                ]
            }
        ]
    },
    {
        "id": 3809,
        "type": "RX",
        "ingredient": "UPADACITINIB",
        "trade_name": "RINVOQ",
        "forms": [
            {
                "orange_id": "211675-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "15MG",
                    "30MG"
                ]
            }
        ]
    },
    {
        "id": 3810,
        "type": "RX",
        "ingredient": "UREA, C-14",
        "trade_name": "PYTEST",
        "forms": [
            {
                "orange_id": "20617-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1uCi"
                ]
            }
        ]
    },
    {
        "id": 3811,
        "type": "RX",
        "ingredient": "UREA, C-14",
        "trade_name": "PYTEST KIT",
        "forms": [
            {
                "orange_id": "20617-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "1uCi"
                ]
            }
        ]
    },
    {
        "id": 3812,
        "type": "RX",
        "ingredient": "URIDINE TRIACETATE",
        "trade_name": "VISTOGARD",
        "forms": [
            {
                "orange_id": "208159-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "10GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3813,
        "type": "RX",
        "ingredient": "URIDINE TRIACETATE",
        "trade_name": "XURIDEN",
        "forms": [
            {
                "orange_id": "208169-1",
                "form": "GRANULE",
                "route": "ORAL",
                "dosage": [
                    "2GM/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3814,
        "type": "RX",
        "ingredient": "URSODIOL",
        "trade_name": "ACTIGALL",
        "forms": [
            {
                "orange_id": "19594-2",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3815,
        "type": "RX",
        "ingredient": "URSODIOL",
        "trade_name": "URSO 250",
        "forms": [
            {
                "orange_id": "20675-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            }
        ]
    },
    {
        "id": 3816,
        "type": "RX",
        "ingredient": "URSODIOL",
        "trade_name": "URSO FORTE",
        "forms": [
            {
                "orange_id": "20675-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3817,
        "type": "RX",
        "ingredient": "URSODIOL",
        "trade_name": "URSODIOL",
        "forms": [
            {
                "orange_id": "210707-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "300MG",
                    "200MG",
                    "400MG"
                ]
            },
            {
                "orange_id": "90801-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "250MG",
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3818,
        "type": "RX",
        "ingredient": "VALACYCLOVIR HYDROCHLORIDE",
        "trade_name": "VALACYCLOVIR HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "90500-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3819,
        "type": "RX",
        "ingredient": "VALACYCLOVIR HYDROCHLORIDE",
        "trade_name": "VALTREX",
        "forms": [
            {
                "orange_id": "20487-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 1GM BASE",
                    "EQ 500MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3820,
        "type": "RX",
        "ingredient": "VALBENAZINE TOSYLATE",
        "trade_name": "INGREZZA",
        "forms": [
            {
                "orange_id": "209241-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 40MG BASE",
                    "EQ 60MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3821,
        "type": "RX",
        "ingredient": "VALGANCICLOVIR HYDROCHLORIDE",
        "trade_name": "VALCYTE",
        "forms": [
            {
                "orange_id": "22257-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "21304-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 450MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3822,
        "type": "RX",
        "ingredient": "VALGANCICLOVIR HYDROCHLORIDE",
        "trade_name": "VALGANCICLOVIR HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "205220-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG/ML"
                ]
            },
            {
                "orange_id": "212234-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 450MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3823,
        "type": "RX",
        "ingredient": "VALPROATE SODIUM",
        "trade_name": "VALPROATE SODIUM",
        "forms": [
            {
                "orange_id": "76295-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 100MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3824,
        "type": "RX",
        "ingredient": "VALPROIC ACID",
        "trade_name": "VALPROIC ACID",
        "forms": [
            {
                "orange_id": "73484-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "250MG"
                ]
            },
            {
                "orange_id": "90517-1",
                "form": "SYRUP",
                "route": "ORAL",
                "dosage": [
                    "250MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3825,
        "type": "RX",
        "ingredient": "VALRUBICIN",
        "trade_name": "VALRUBICIN",
        "forms": [
            {
                "orange_id": "206430-1",
                "form": "SOLUTION",
                "route": "INTRAVESICAL",
                "dosage": [
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3826,
        "type": "RX",
        "ingredient": "VALRUBICIN",
        "trade_name": "VALSTAR PRESERVATIVE FREE",
        "forms": [
            {
                "orange_id": "20892-1",
                "form": "SOLUTION",
                "route": "INTRAVESICAL",
                "dosage": [
                    "40MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3827,
        "type": "RX",
        "ingredient": "VALSARTAN",
        "trade_name": "DIOVAN",
        "forms": [
            {
                "orange_id": "21283-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG",
                    "160MG",
                    "320MG"
                ]
            }
        ]
    },
    {
        "id": 3828,
        "type": "RX",
        "ingredient": "VALSARTAN",
        "trade_name": "VALSARTAN",
        "forms": [
            {
                "orange_id": "214102-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "20MG/5ML"
                ]
            },
            {
                "orange_id": "91367-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG",
                    "160MG",
                    "320MG"
                ]
            }
        ]
    },
    {
        "id": 3829,
        "type": "RX",
        "ingredient": "VANCOMYCIN",
        "trade_name": "VANCOMYCIN",
        "forms": [
            {
                "orange_id": "213895-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS, ORAL",
                "dosage": [
                    "5GM/100ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3830,
        "type": "RX",
        "ingredient": "VANCOMYCIN HYDROCHLORIDE",
        "trade_name": "FIRVANQ KIT",
        "forms": [
            {
                "orange_id": "208910-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE/ML",
                    "EQ 50MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3831,
        "type": "RX",
        "ingredient": "VANCOMYCIN HYDROCHLORIDE",
        "trade_name": "VANCOCIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "50606-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG BASE",
                    "EQ 250MG BASE"
                ]
            },
            {
                "orange_id": "61667-2",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "EQ 250MG BASE/5ML"
                ]
            }
        ]
    },
    {
        "id": 3832,
        "type": "RX",
        "ingredient": "VANCOMYCIN HYDROCHLORIDE",
        "trade_name": "VANCOCIN HYDROCHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "50671-3",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/200ML",
                    "EQ 500MG BASE/100ML",
                    "EQ 750MG BASE/150ML"
                ]
            }
        ]
    },
    {
        "id": 3833,
        "type": "RX",
        "ingredient": "VANCOMYCIN HYDROCHLORIDE",
        "trade_name": "VANCOMYCIN HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "65478-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 125MG BASE",
                    "EQ 250MG BASE"
                ]
            },
            {
                "orange_id": "205780-2",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1GM BASE/VIAL",
                    "EQ 5GM BASE/VIAL",
                    "EQ 10GM BASE/VIAL",
                    "EQ 500MG BASE/VIAL",
                    "EQ 750MG BASE/VIAL",
                    "EQ 1.5GM BASE/VIAL"
                ]
            },
            {
                "orange_id": "209481-3",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1.25GM BASE/VIAL",
                    "EQ 1.5GM BASE/VIAL",
                    "EQ 250MG BASE/VIAL",
                    "EQ 750MG BASE/VIAL"
                ]
            },
            {
                "orange_id": "211962-2",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 1GM BASE/200ML (EQ 5MG BASE/ML)",
                    "EQ 1.25GM BASE/250ML (EQ 5MG BASE/ML)",
                    "EQ 1.5GM BASE/300ML (EQ 5MG BASE/ML)",
                    "EQ 1.75GM BASE/350ML (EQ 5MG BASE/ML)",
                    "EQ 2GM BASE/400ML (EQ 5MG BASE/ML)",
                    "EQ 500MG BASE/100ML (EQ 5MG BASE/ML)",
                    "EQ 750MG BASE/150ML (EQ 5MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3834,
        "type": "RX",
        "ingredient": "VANCOMYCIN HYDROCHLORIDE",
        "trade_name": "VANCOMYCIN HYDROCHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "91532-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 100GM BASE"
                ]
            }
        ]
    },
    {
        "id": 3835,
        "type": "RX",
        "ingredient": "VANDETANIB",
        "trade_name": "CAPRELSA",
        "forms": [
            {
                "orange_id": "22405-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3836,
        "type": "RX",
        "ingredient": "VARDENAFIL HYDROCHLORIDE",
        "trade_name": "LEVITRA",
        "forms": [
            {
                "orange_id": "21400-4",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3837,
        "type": "RX",
        "ingredient": "VARDENAFIL HYDROCHLORIDE",
        "trade_name": "STAXYN",
        "forms": [
            {
                "orange_id": "200179-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3838,
        "type": "RX",
        "ingredient": "VARDENAFIL HYDROCHLORIDE",
        "trade_name": "VARDENAFIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208324-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "10MG"
                ]
            },
            {
                "orange_id": "214031-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.5MG BASE",
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3839,
        "type": "RX",
        "ingredient": "VARENICLINE TARTRATE",
        "trade_name": "CHANTIX",
        "forms": [
            {
                "orange_id": "21928-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3840,
        "type": "RX",
        "ingredient": "VARENICLINE TARTRATE",
        "trade_name": "TYRVAYA",
        "forms": [
            {
                "orange_id": "213978-1",
                "form": "SOLUTION",
                "route": "NASAL",
                "dosage": [
                    "EQ 0.03MG BASE/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3841,
        "type": "RX",
        "ingredient": "VARENICLINE TARTRATE",
        "trade_name": "VARENICLINE TARTRATE",
        "forms": [
            {
                "orange_id": "201785-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 0.5MG BASE",
                    "EQ 1MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3842,
        "type": "RX",
        "ingredient": "VASOPRESSIN",
        "trade_name": "VASOPRESSIN",
        "forms": [
            {
                "orange_id": "212593-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20UNITS/ML (20UNITS/ML)"
                ]
            }
        ]
    },
    {
        "id": 3843,
        "type": "RX",
        "ingredient": "VASOPRESSIN",
        "trade_name": "VASOSTRICT",
        "forms": [
            {
                "orange_id": "204485-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "20UNITS/ML (20UNITS/ML)",
                    "20UNITS/100ML (0.2UNITS/ML)",
                    "40UNITS/100ML (0.4UNITS/ML)",
                    "60UNITS/100ML (0.6UNITS/ML)",
                    "200UNITS/10ML (20UNITS/ML)"
                ]
            }
        ]
    },
    {
        "id": 3844,
        "type": "RX",
        "ingredient": "VECURONIUM BROMIDE",
        "trade_name": "VECURONIUM BROMIDE",
        "forms": [
            {
                "orange_id": "206670-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/VIAL",
                    "20MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3845,
        "type": "RX",
        "ingredient": "VEMURAFENIB",
        "trade_name": "ZELBORAF",
        "forms": [
            {
                "orange_id": "202429-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3846,
        "type": "RX",
        "ingredient": "VENETOCLAX",
        "trade_name": "VENCLEXTA",
        "forms": [
            {
                "orange_id": "208573-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3847,
        "type": "RX",
        "ingredient": "VENLAFAXINE HYDROCHLORIDE",
        "trade_name": "EFFEXOR XR",
        "forms": [
            {
                "orange_id": "20699-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 37.5MG BASE",
                    "EQ 75MG BASE",
                    "EQ 150MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3848,
        "type": "RX",
        "ingredient": "VENLAFAXINE HYDROCHLORIDE",
        "trade_name": "VENLAFAXINE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "212277-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 37.5MG BASE",
                    "EQ 75MG BASE",
                    "EQ 150MG BASE"
                ]
            },
            {
                "orange_id": "214127-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 37.5MG BASE",
                    "EQ 75MG BASE",
                    "EQ 150MG BASE",
                    "EQ 225MG BASE"
                ]
            },
            {
                "orange_id": "78932-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG BASE",
                    "EQ 37.5MG BASE",
                    "EQ 50MG BASE",
                    "EQ 75MG BASE",
                    "EQ 100MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3849,
        "type": "RX",
        "ingredient": "VERAPAMIL HYDROCHLORIDE",
        "trade_name": "CALAN SR",
        "forms": [
            {
                "orange_id": "19152-3",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "240MG"
                ]
            }
        ]
    },
    {
        "id": 3850,
        "type": "RX",
        "ingredient": "VERAPAMIL HYDROCHLORIDE",
        "trade_name": "VERAPAMIL HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "75138-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG"
                ]
            },
            {
                "orange_id": "212965-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "2.5MG/ML"
                ]
            },
            {
                "orange_id": "210994-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "5MG/2ML (2.5MG/ML)",
                    "10MG/4ML (2.5MG/ML)"
                ]
            },
            {
                "orange_id": "206173-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "180MG",
                    "240MG",
                    "120MG"
                ]
            },
            {
                "orange_id": "71881-2",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "40MG",
                    "80MG",
                    "120MG"
                ]
            }
        ]
    },
    {
        "id": 3851,
        "type": "RX",
        "ingredient": "VERAPAMIL HYDROCHLORIDE",
        "trade_name": "VERELAN",
        "forms": [
            {
                "orange_id": "19614-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "120MG",
                    "180MG",
                    "240MG",
                    "360MG"
                ]
            }
        ]
    },
    {
        "id": 3852,
        "type": "RX",
        "ingredient": "VERAPAMIL HYDROCHLORIDE",
        "trade_name": "VERELAN PM",
        "forms": [
            {
                "orange_id": "20943-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "100MG",
                    "200MG",
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3853,
        "type": "RX",
        "ingredient": "VERICIGUAT",
        "trade_name": "VERQUVO",
        "forms": [
            {
                "orange_id": "214377-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3854,
        "type": "RX",
        "ingredient": "VERTEPORFIN",
        "trade_name": "VISUDYNE",
        "forms": [
            {
                "orange_id": "21119-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "15MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3855,
        "type": "RX",
        "ingredient": "VIBEGRON",
        "trade_name": "GEMTESA",
        "forms": [
            {
                "orange_id": "213006-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "75MG"
                ]
            }
        ]
    },
    {
        "id": 3856,
        "type": "RX",
        "ingredient": "VIGABATRIN",
        "trade_name": "SABRIL",
        "forms": [
            {
                "orange_id": "22006-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "500MG/PACKET"
                ]
            },
            {
                "orange_id": "20427-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3857,
        "type": "RX",
        "ingredient": "VIGABATRIN",
        "trade_name": "VIGABATRIN",
        "forms": [
            {
                "orange_id": "214425-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "500MG/PACKET"
                ]
            },
            {
                "orange_id": "215109-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3858,
        "type": "RX",
        "ingredient": "VIGABATRIN",
        "trade_name": "VIGADRONE",
        "forms": [
            {
                "orange_id": "210196-1",
                "form": "FOR SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "500MG/PACKET"
                ]
            }
        ]
    },
    {
        "id": 3859,
        "type": "RX",
        "ingredient": "VILAZODONE HYDROCHLORIDE",
        "trade_name": "VIIBRYD",
        "forms": [
            {
                "orange_id": "22567-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 3860,
        "type": "RX",
        "ingredient": "VILAZODONE HYDROCHLORIDE",
        "trade_name": "VILAZODONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "208209-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG",
                    "40MG"
                ]
            }
        ]
    },
    {
        "id": 3861,
        "type": "RX",
        "ingredient": "VILOXAZINE HYDROCHLORIDE",
        "trade_name": "QELBREE",
        "forms": [
            {
                "orange_id": "211964-1",
                "form": "CAPSULE, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "EQ 100MG BASE",
                    "EQ 150MG BASE",
                    "EQ 200MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3862,
        "type": "RX",
        "ingredient": "VILTOLARSEN",
        "trade_name": "VILTEPSO",
        "forms": [
            {
                "orange_id": "212154-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "250MG/5ML (50MG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3863,
        "type": "RX",
        "ingredient": "VINBLASTINE SULFATE",
        "trade_name": "VINBLASTINE SULFATE",
        "forms": [
            {
                "orange_id": "89515-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML",
                    "10MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3864,
        "type": "RX",
        "ingredient": "VINCRISTINE SULFATE",
        "trade_name": "VINCRISTINE SULFATE PFS",
        "forms": [
            {
                "orange_id": "71484-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "1MG/ML"
                ]
            }
        ]
    },
    {
        "id": 3865,
        "type": "RX",
        "ingredient": "VINORELBINE TARTRATE",
        "trade_name": "VINORELBINE TARTRATE",
        "forms": [
            {
                "orange_id": "78011-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 10MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3866,
        "type": "RX",
        "ingredient": "VISMODEGIB",
        "trade_name": "ERIVEDGE",
        "forms": [
            {
                "orange_id": "203388-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "150MG"
                ]
            }
        ]
    },
    {
        "id": 3867,
        "type": "RX",
        "ingredient": "VITAMIN A PALMITATE",
        "trade_name": "AQUASOL A",
        "forms": [
            {
                "orange_id": "6823-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 50,000 UNITS BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3868,
        "type": "RX",
        "ingredient": "VOCLOSPORIN",
        "trade_name": "LUPKYNIS",
        "forms": [
            {
                "orange_id": "213716-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "7.9MG"
                ]
            }
        ]
    },
    {
        "id": 3869,
        "type": "RX",
        "ingredient": "VORAPAXAR SULFATE",
        "trade_name": "ZONTIVITY",
        "forms": [
            {
                "orange_id": "204886-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 2.08MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3870,
        "type": "RX",
        "ingredient": "VORICONAZOLE",
        "trade_name": "VFEND",
        "forms": [
            {
                "orange_id": "21630-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "21267-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/VIAL"
                ]
            },
            {
                "orange_id": "21266-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3871,
        "type": "RX",
        "ingredient": "VORICONAZOLE",
        "trade_name": "VORICONAZOLE",
        "forms": [
            {
                "orange_id": "205034-1",
                "form": "FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "200MG/5ML"
                ]
            },
            {
                "orange_id": "206398-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/VIAL"
                ]
            },
            {
                "orange_id": "208562-1",
                "form": "POWDER",
                "route": "INTRAVENOUS",
                "dosage": [
                    "200MG/VIAL"
                ]
            },
            {
                "orange_id": "206181-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "50MG",
                    "200MG"
                ]
            }
        ]
    },
    {
        "id": 3872,
        "type": "RX",
        "ingredient": "VORINOSTAT",
        "trade_name": "ZOLINZA",
        "forms": [
            {
                "orange_id": "21991-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3873,
        "type": "RX",
        "ingredient": "VORTIOXETINE HYDROBROMIDE",
        "trade_name": "TRINTELLIX",
        "forms": [
            {
                "orange_id": "204447-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3874,
        "type": "RX",
        "ingredient": "VORTIOXETINE HYDROBROMIDE",
        "trade_name": "VORTIOXETINE HYDROBROMIDE",
        "forms": [
            {
                "orange_id": "211146-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "EQ 5MG BASE",
                    "EQ 10MG BASE",
                    "EQ 20MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3875,
        "type": "RX",
        "ingredient": "VOSORITIDE",
        "trade_name": "VOXZOGO",
        "forms": [
            {
                "orange_id": "214938-1",
                "form": "POWDER",
                "route": "SUBCUTANEOUS",
                "dosage": [
                    "0.4MG/VIAL",
                    "0.56MG/VIAL",
                    "1.2MG/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3876,
        "type": "RX",
        "ingredient": "VOXELOTOR",
        "trade_name": "OXBRYTA",
        "forms": [
            {
                "orange_id": "216157-1",
                "form": "TABLET, FOR SUSPENSION",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            },
            {
                "orange_id": "213137-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "500MG"
                ]
            }
        ]
    },
    {
        "id": 3877,
        "type": "RX",
        "ingredient": "WARFARIN SODIUM",
        "trade_name": "JANTOVEN",
        "forms": [
            {
                "orange_id": "40416-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "2.5MG",
                    "3MG",
                    "4MG",
                    "5MG",
                    "6MG",
                    "7.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3878,
        "type": "RX",
        "ingredient": "WARFARIN SODIUM",
        "trade_name": "WARFARIN SODIUM",
        "forms": [
            {
                "orange_id": "202202-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "1MG",
                    "2MG",
                    "2.5MG",
                    "3MG",
                    "4MG",
                    "5MG",
                    "6MG",
                    "7.5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3879,
        "type": "RX",
        "ingredient": "XENON XE-133",
        "trade_name": "XENON XE 133",
        "forms": [
            {
                "orange_id": "18327-1",
                "form": "GAS",
                "route": "INHALATION",
                "dosage": [
                    "10mCi/VIAL",
                    "20mCi/VIAL"
                ]
            }
        ]
    },
    {
        "id": 3880,
        "type": "RX",
        "ingredient": "ZAFIRLUKAST",
        "trade_name": "ACCOLATE",
        "forms": [
            {
                "orange_id": "20547-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3881,
        "type": "RX",
        "ingredient": "ZAFIRLUKAST",
        "trade_name": "ZAFIRLUKAST",
        "forms": [
            {
                "orange_id": "212475-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "10MG",
                    "20MG"
                ]
            }
        ]
    },
    {
        "id": 3882,
        "type": "RX",
        "ingredient": "ZALEPLON",
        "trade_name": "SONATA",
        "forms": [
            {
                "orange_id": "20859-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3883,
        "type": "RX",
        "ingredient": "ZALEPLON",
        "trade_name": "ZALEPLON",
        "forms": [
            {
                "orange_id": "78829-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3884,
        "type": "RX",
        "ingredient": "ZANAMIVIR",
        "trade_name": "RELENZA",
        "forms": [
            {
                "orange_id": "21036-1",
                "form": "POWDER",
                "route": "INHALATION",
                "dosage": [
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3885,
        "type": "RX",
        "ingredient": "ZANUBRUTINIB",
        "trade_name": "BRUKINSA",
        "forms": [
            {
                "orange_id": "213217-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "80MG"
                ]
            }
        ]
    },
    {
        "id": 3886,
        "type": "RX",
        "ingredient": "ZICONOTIDE ACETATE",
        "trade_name": "PRIALT",
        "forms": [
            {
                "orange_id": "21060-2",
                "form": "INJECTABLE",
                "route": "INTRATHECAL",
                "dosage": [
                    "100MCG/1ML (100MCG/ML)",
                    "500MCG/20ML (25MCG/ML)",
                    "500MCG/5ML (100MCG/ML)"
                ]
            }
        ]
    },
    {
        "id": 3887,
        "type": "RX",
        "ingredient": "ZIDOVUDINE",
        "trade_name": "RETROVIR",
        "forms": [
            {
                "orange_id": "19655-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "19951-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "10MG/ML"
                ]
            },
            {
                "orange_id": "19910-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            }
        ]
    },
    {
        "id": 3888,
        "type": "RX",
        "ingredient": "ZIDOVUDINE",
        "trade_name": "ZIDOVUDINE",
        "forms": [
            {
                "orange_id": "78128-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "100MG"
                ]
            },
            {
                "orange_id": "77268-1",
                "form": "SOLUTION",
                "route": "ORAL",
                "dosage": [
                    "50MG/5ML"
                ]
            },
            {
                "orange_id": "77267-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "300MG"
                ]
            }
        ]
    },
    {
        "id": 3889,
        "type": "RX",
        "ingredient": "ZILEUTON",
        "trade_name": "ZILEUTON",
        "forms": [
            {
                "orange_id": "211390-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3890,
        "type": "RX",
        "ingredient": "ZILEUTON",
        "trade_name": "ZYFLO",
        "forms": [
            {
                "orange_id": "20471-3",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3891,
        "type": "RX",
        "ingredient": "ZILEUTON",
        "trade_name": "ZYFLO CR",
        "forms": [
            {
                "orange_id": "22052-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "600MG"
                ]
            }
        ]
    },
    {
        "id": 3892,
        "type": "RX",
        "ingredient": "ZINC ACETATE",
        "trade_name": "GALZIN",
        "forms": [
            {
                "orange_id": "20458-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 25MG ZINC",
                    "EQ 50MG ZINC"
                ]
            }
        ]
    },
    {
        "id": 3893,
        "type": "RX",
        "ingredient": "ZINC CHLORIDE",
        "trade_name": "ZINC CHLORIDE",
        "forms": [
            {
                "orange_id": "212007-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG ZINC/ML"
                ]
            }
        ]
    },
    {
        "id": 3894,
        "type": "RX",
        "ingredient": "ZINC CHLORIDE",
        "trade_name": "ZINC CHLORIDE IN PLASTIC CONTAINER",
        "forms": [
            {
                "orange_id": "18959-1",
                "form": "INJECTABLE",
                "route": "INJECTION",
                "dosage": [
                    "EQ 1MG ZINC/ML"
                ]
            }
        ]
    },
    {
        "id": 3895,
        "type": "RX",
        "ingredient": "ZINC SULFATE",
        "trade_name": "ZINC SULFATE",
        "forms": [
            {
                "orange_id": "209377-3",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 10MG BASE/10ML (EQ 1MG BASE/ML)",
                    "EQ 25MG BASE/5ML (EQ 5MG BASE/ML)",
                    "EQ 30MG BASE/10ML (EQ 3MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3896,
        "type": "RX",
        "ingredient": "ZIPRASIDONE HYDROCHLORIDE",
        "trade_name": "GEODON",
        "forms": [
            {
                "orange_id": "20825-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 60MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3897,
        "type": "RX",
        "ingredient": "ZIPRASIDONE HYDROCHLORIDE",
        "trade_name": "ZIPRASIDONE HYDROCHLORIDE",
        "forms": [
            {
                "orange_id": "77561-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "EQ 20MG BASE",
                    "EQ 40MG BASE",
                    "EQ 60MG BASE",
                    "EQ 80MG BASE"
                ]
            }
        ]
    },
    {
        "id": 3898,
        "type": "RX",
        "ingredient": "ZIPRASIDONE MESYLATE",
        "trade_name": "GEODON",
        "forms": [
            {
                "orange_id": "20919-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3899,
        "type": "RX",
        "ingredient": "ZIPRASIDONE MESYLATE",
        "trade_name": "ZIPRASIDONE MESYLATE",
        "forms": [
            {
                "orange_id": "211908-1",
                "form": "INJECTABLE",
                "route": "INTRAMUSCULAR",
                "dosage": [
                    "EQ 20MG BASE/ML"
                ]
            }
        ]
    },
    {
        "id": 3900,
        "type": "RX",
        "ingredient": "ZOLEDRONIC ACID",
        "trade_name": "RECLAST",
        "forms": [
            {
                "orange_id": "21817-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 5MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 3901,
        "type": "RX",
        "ingredient": "ZOLEDRONIC ACID",
        "trade_name": "ZOLEDRONIC",
        "forms": [
            {
                "orange_id": "205749-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 4MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 3902,
        "type": "RX",
        "ingredient": "ZOLEDRONIC ACID",
        "trade_name": "ZOLEDRONIC ACID",
        "forms": [
            {
                "orange_id": "205279-1",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 4MG BASE/5ML",
                    "EQ 5MG BASE/100ML",
                    "EQ 4MG BASE/100ML"
                ]
            },
            {
                "orange_id": "204016-1",
                "form": "SOLUTION",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 4MG BASE/100ML (EQ 0.04MG BASE/ML)"
                ]
            }
        ]
    },
    {
        "id": 3903,
        "type": "RX",
        "ingredient": "ZOLEDRONIC ACID",
        "trade_name": "ZOMETA",
        "forms": [
            {
                "orange_id": "21223-2",
                "form": "INJECTABLE",
                "route": "INTRAVENOUS",
                "dosage": [
                    "EQ 4MG BASE/5ML",
                    "EQ 4MG BASE/100ML"
                ]
            }
        ]
    },
    {
        "id": 3904,
        "type": "RX",
        "ingredient": "ZOLMITRIPTAN",
        "trade_name": "ZOLMITRIPTAN",
        "forms": [
            {
                "orange_id": "212469-1",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "2.5MG/SPRAY",
                    "5MG/SPRAY"
                ]
            },
            {
                "orange_id": "205074-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            },
            {
                "orange_id": "204041-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3905,
        "type": "RX",
        "ingredient": "ZOLMITRIPTAN",
        "trade_name": "ZOMIG",
        "forms": [
            {
                "orange_id": "21450-3",
                "form": "SPRAY",
                "route": "NASAL",
                "dosage": [
                    "2.5MG/SPRAY",
                    "5MG/SPRAY"
                ]
            },
            {
                "orange_id": "20768-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3906,
        "type": "RX",
        "ingredient": "ZOLMITRIPTAN",
        "trade_name": "ZOMIG-ZMT",
        "forms": [
            {
                "orange_id": "21231-1",
                "form": "TABLET, ORALLY DISINTEGRATING",
                "route": "ORAL",
                "dosage": [
                    "2.5MG",
                    "5MG"
                ]
            }
        ]
    },
    {
        "id": 3907,
        "type": "RX",
        "ingredient": "ZOLPIDEM TARTRATE",
        "trade_name": "AMBIEN",
        "forms": [
            {
                "orange_id": "19908-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3908,
        "type": "RX",
        "ingredient": "ZOLPIDEM TARTRATE",
        "trade_name": "AMBIEN CR",
        "forms": [
            {
                "orange_id": "21774-2",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "6.25MG",
                    "12.5MG"
                ]
            }
        ]
    },
    {
        "id": 3909,
        "type": "RX",
        "ingredient": "ZOLPIDEM TARTRATE",
        "trade_name": "EDLUAR",
        "forms": [
            {
                "orange_id": "21997-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3910,
        "type": "RX",
        "ingredient": "ZOLPIDEM TARTRATE",
        "trade_name": "ZOLPIDEM TARTRATE",
        "forms": [
            {
                "orange_id": "90153-1",
                "form": "TABLET, EXTENDED RELEASE",
                "route": "ORAL",
                "dosage": [
                    "6.25MG",
                    "12.5MG"
                ]
            },
            {
                "orange_id": "77214-1",
                "form": "TABLET",
                "route": "ORAL",
                "dosage": [
                    "5MG",
                    "10MG"
                ]
            },
            {
                "orange_id": "204503-1",
                "form": "TABLET",
                "route": "SUBLINGUAL",
                "dosage": [
                    "1.75MG",
                    "3.5MG",
                    "5MG",
                    "10MG"
                ]
            }
        ]
    },
    {
        "id": 3911,
        "type": "RX",
        "ingredient": "ZOLPIDEM TARTRATE",
        "trade_name": "ZOLPIMIST",
        "forms": [
            {
                "orange_id": "22196-1",
                "form": "SPRAY, METERED",
                "route": "ORAL",
                "dosage": [
                    "5MG/SPRAY"
                ]
            }
        ]
    },
    {
        "id": 3912,
        "type": "RX",
        "ingredient": "ZONISAMIDE",
        "trade_name": "ZONEGRAN",
        "forms": [
            {
                "orange_id": "20789-3",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "100MG"
                ]
            }
        ]
    },
    {
        "id": 3913,
        "type": "RX",
        "ingredient": "ZONISAMIDE",
        "trade_name": "ZONISAMIDE",
        "forms": [
            {
                "orange_id": "77642-1",
                "form": "CAPSULE",
                "route": "ORAL",
                "dosage": [
                    "25MG",
                    "50MG",
                    "100MG"
                ]
            }
        ]
    }
]